// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("bootstrap/fonts/glyphicons-halflings-regular.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("bootstrap/fonts/glyphicons-halflings-regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("bootstrap/fonts/glyphicons-halflings-regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("bootstrap/fonts/glyphicons-halflings-regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("bootstrap/fonts/glyphicons-halflings-regular.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("font-awesome/fonts/fontawesome-webfont.eot?v=4.7.0", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("font-awesome/fonts/fontawesome-webfont.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("font-awesome/fonts/fontawesome-webfont.woff2?v=4.7.0", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("font-awesome/fonts/fontawesome-webfont.woff?v=4.7.0", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("font-awesome/fonts/fontawesome-webfont.ttf?v=4.7.0", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("font-awesome/fonts/fontawesome-webfont.svg?v=4.7.0", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAMCAYAAAAkuj5RAAAAAXNSR0IArs4c6QAAAGFJREFUSMft1LsRQFAQheHPowAKoACx3IgEKtaEHujDjORSgWTH/ZOdnZOcM/sgk/kFFWY0qV8foQwS4MKBCS3qR6ixBJvElOobYAtivseIE120FaowJPN75GMu8j/LfMwNjh4HUpwg4LUAAAAASUVORK5CYII=", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___, { hash: "#glyphicons_halflingsregular" });
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___, { hash: "?#iefix&v=4.7.0" });
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___, { hash: "#fontawesomeregular" });
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*!
*
* Twitter Bootstrap
*
*/
/*!
 * Bootstrap v3.4.1 (https://getbootstrap.com/)
 * Copyright 2011-2019 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 */
/*! normalize.css v3.0.3 | MIT License | github.com/necolas/normalize.css */
html {
  font-family: sans-serif;
  -ms-text-size-adjust: 100%;
  -webkit-text-size-adjust: 100%;
}
body {
  margin: 0;
}
article,
aside,
details,
figcaption,
figure,
footer,
header,
hgroup,
main,
menu,
nav,
section,
summary {
  display: block;
}
audio,
canvas,
progress,
video {
  display: inline-block;
  vertical-align: baseline;
}
audio:not([controls]) {
  display: none;
  height: 0;
}
[hidden],
template {
  display: none;
}
a {
  background-color: transparent;
}
a:active,
a:hover {
  outline: 0;
}
abbr[title] {
  border-bottom: none;
  text-decoration: underline;
  text-decoration: underline dotted;
}
b,
strong {
  font-weight: bold;
}
dfn {
  font-style: italic;
}
h1 {
  font-size: 2em;
  margin: 0.67em 0;
}
mark {
  background: #ff0;
  color: #000;
}
small {
  font-size: 80%;
}
sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}
sup {
  top: -0.5em;
}
sub {
  bottom: -0.25em;
}
img {
  border: 0;
}
svg:not(:root) {
  overflow: hidden;
}
figure {
  margin: 1em 40px;
}
hr {
  box-sizing: content-box;
  height: 0;
}
pre {
  overflow: auto;
}
code,
kbd,
pre,
samp {
  font-family: monospace, monospace;
  font-size: 1em;
}
button,
input,
optgroup,
select,
textarea {
  color: inherit;
  font: inherit;
  margin: 0;
}
button {
  overflow: visible;
}
button,
select {
  text-transform: none;
}
button,
html input[type="button"],
input[type="reset"],
input[type="submit"] {
  -webkit-appearance: button;
  cursor: pointer;
}
button[disabled],
html input[disabled] {
  cursor: default;
}
button::-moz-focus-inner,
input::-moz-focus-inner {
  border: 0;
  padding: 0;
}
input {
  line-height: normal;
}
input[type="checkbox"],
input[type="radio"] {
  box-sizing: border-box;
  padding: 0;
}
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  height: auto;
}
input[type="search"] {
  -webkit-appearance: textfield;
  box-sizing: content-box;
}
input[type="search"]::-webkit-search-cancel-button,
input[type="search"]::-webkit-search-decoration {
  -webkit-appearance: none;
}
fieldset {
  border: 1px solid #c0c0c0;
  margin: 0 2px;
  padding: 0.35em 0.625em 0.75em;
}
legend {
  border: 0;
  padding: 0;
}
textarea {
  overflow: auto;
}
optgroup {
  font-weight: bold;
}
table {
  border-collapse: collapse;
  border-spacing: 0;
}
td,
th {
  padding: 0;
}
/*! Source: https://github.com/h5bp/html5-boilerplate/blob/master/src/css/main.css */
@media print {
  *,
  *:before,
  *:after {
    color: #000 !important;
    text-shadow: none !important;
    background: transparent !important;
    box-shadow: none !important;
  }
  a,
  a:visited {
    text-decoration: underline;
  }
  a[href]:after {
    content: " (" attr(href) ")";
  }
  abbr[title]:after {
    content: " (" attr(title) ")";
  }
  a[href^="#"]:after,
  a[href^="javascript:"]:after {
    content: "";
  }
  pre,
  blockquote {
    border: 1px solid #999;
    page-break-inside: avoid;
  }
  thead {
    display: table-header-group;
  }
  tr,
  img {
    page-break-inside: avoid;
  }
  img {
    max-width: 100% !important;
  }
  p,
  h2,
  h3 {
    orphans: 3;
    widows: 3;
  }
  h2,
  h3 {
    page-break-after: avoid;
  }
  .navbar {
    display: none;
  }
  .btn > .caret,
  .dropup > .btn > .caret {
    border-top-color: #000 !important;
  }
  .label {
    border: 1px solid #000;
  }
  .table {
    border-collapse: collapse !important;
  }
  .table td,
  .table th {
    background-color: #fff !important;
  }
  .table-bordered th,
  .table-bordered td {
    border: 1px solid #ddd !important;
  }
}
@font-face {
  font-family: "Glyphicons Halflings";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("svg");
}
.glyphicon {
  position: relative;
  top: 1px;
  display: inline-block;
  font-family: "Glyphicons Halflings";
  font-style: normal;
  font-weight: 400;
  line-height: 1;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.glyphicon-asterisk:before {
  content: "\\002a";
}
.glyphicon-plus:before {
  content: "\\002b";
}
.glyphicon-euro:before,
.glyphicon-eur:before {
  content: "\\20ac";
}
.glyphicon-minus:before {
  content: "\\2212";
}
.glyphicon-cloud:before {
  content: "\\2601";
}
.glyphicon-envelope:before {
  content: "\\2709";
}
.glyphicon-pencil:before {
  content: "\\270f";
}
.glyphicon-glass:before {
  content: "\\e001";
}
.glyphicon-music:before {
  content: "\\e002";
}
.glyphicon-search:before {
  content: "\\e003";
}
.glyphicon-heart:before {
  content: "\\e005";
}
.glyphicon-star:before {
  content: "\\e006";
}
.glyphicon-star-empty:before {
  content: "\\e007";
}
.glyphicon-user:before {
  content: "\\e008";
}
.glyphicon-film:before {
  content: "\\e009";
}
.glyphicon-th-large:before {
  content: "\\e010";
}
.glyphicon-th:before {
  content: "\\e011";
}
.glyphicon-th-list:before {
  content: "\\e012";
}
.glyphicon-ok:before {
  content: "\\e013";
}
.glyphicon-remove:before {
  content: "\\e014";
}
.glyphicon-zoom-in:before {
  content: "\\e015";
}
.glyphicon-zoom-out:before {
  content: "\\e016";
}
.glyphicon-off:before {
  content: "\\e017";
}
.glyphicon-signal:before {
  content: "\\e018";
}
.glyphicon-cog:before {
  content: "\\e019";
}
.glyphicon-trash:before {
  content: "\\e020";
}
.glyphicon-home:before {
  content: "\\e021";
}
.glyphicon-file:before {
  content: "\\e022";
}
.glyphicon-time:before {
  content: "\\e023";
}
.glyphicon-road:before {
  content: "\\e024";
}
.glyphicon-download-alt:before {
  content: "\\e025";
}
.glyphicon-download:before {
  content: "\\e026";
}
.glyphicon-upload:before {
  content: "\\e027";
}
.glyphicon-inbox:before {
  content: "\\e028";
}
.glyphicon-play-circle:before {
  content: "\\e029";
}
.glyphicon-repeat:before {
  content: "\\e030";
}
.glyphicon-refresh:before {
  content: "\\e031";
}
.glyphicon-list-alt:before {
  content: "\\e032";
}
.glyphicon-lock:before {
  content: "\\e033";
}
.glyphicon-flag:before {
  content: "\\e034";
}
.glyphicon-headphones:before {
  content: "\\e035";
}
.glyphicon-volume-off:before {
  content: "\\e036";
}
.glyphicon-volume-down:before {
  content: "\\e037";
}
.glyphicon-volume-up:before {
  content: "\\e038";
}
.glyphicon-qrcode:before {
  content: "\\e039";
}
.glyphicon-barcode:before {
  content: "\\e040";
}
.glyphicon-tag:before {
  content: "\\e041";
}
.glyphicon-tags:before {
  content: "\\e042";
}
.glyphicon-book:before {
  content: "\\e043";
}
.glyphicon-bookmark:before {
  content: "\\e044";
}
.glyphicon-print:before {
  content: "\\e045";
}
.glyphicon-camera:before {
  content: "\\e046";
}
.glyphicon-font:before {
  content: "\\e047";
}
.glyphicon-bold:before {
  content: "\\e048";
}
.glyphicon-italic:before {
  content: "\\e049";
}
.glyphicon-text-height:before {
  content: "\\e050";
}
.glyphicon-text-width:before {
  content: "\\e051";
}
.glyphicon-align-left:before {
  content: "\\e052";
}
.glyphicon-align-center:before {
  content: "\\e053";
}
.glyphicon-align-right:before {
  content: "\\e054";
}
.glyphicon-align-justify:before {
  content: "\\e055";
}
.glyphicon-list:before {
  content: "\\e056";
}
.glyphicon-indent-left:before {
  content: "\\e057";
}
.glyphicon-indent-right:before {
  content: "\\e058";
}
.glyphicon-facetime-video:before {
  content: "\\e059";
}
.glyphicon-picture:before {
  content: "\\e060";
}
.glyphicon-map-marker:before {
  content: "\\e062";
}
.glyphicon-adjust:before {
  content: "\\e063";
}
.glyphicon-tint:before {
  content: "\\e064";
}
.glyphicon-edit:before {
  content: "\\e065";
}
.glyphicon-share:before {
  content: "\\e066";
}
.glyphicon-check:before {
  content: "\\e067";
}
.glyphicon-move:before {
  content: "\\e068";
}
.glyphicon-step-backward:before {
  content: "\\e069";
}
.glyphicon-fast-backward:before {
  content: "\\e070";
}
.glyphicon-backward:before {
  content: "\\e071";
}
.glyphicon-play:before {
  content: "\\e072";
}
.glyphicon-pause:before {
  content: "\\e073";
}
.glyphicon-stop:before {
  content: "\\e074";
}
.glyphicon-forward:before {
  content: "\\e075";
}
.glyphicon-fast-forward:before {
  content: "\\e076";
}
.glyphicon-step-forward:before {
  content: "\\e077";
}
.glyphicon-eject:before {
  content: "\\e078";
}
.glyphicon-chevron-left:before {
  content: "\\e079";
}
.glyphicon-chevron-right:before {
  content: "\\e080";
}
.glyphicon-plus-sign:before {
  content: "\\e081";
}
.glyphicon-minus-sign:before {
  content: "\\e082";
}
.glyphicon-remove-sign:before {
  content: "\\e083";
}
.glyphicon-ok-sign:before {
  content: "\\e084";
}
.glyphicon-question-sign:before {
  content: "\\e085";
}
.glyphicon-info-sign:before {
  content: "\\e086";
}
.glyphicon-screenshot:before {
  content: "\\e087";
}
.glyphicon-remove-circle:before {
  content: "\\e088";
}
.glyphicon-ok-circle:before {
  content: "\\e089";
}
.glyphicon-ban-circle:before {
  content: "\\e090";
}
.glyphicon-arrow-left:before {
  content: "\\e091";
}
.glyphicon-arrow-right:before {
  content: "\\e092";
}
.glyphicon-arrow-up:before {
  content: "\\e093";
}
.glyphicon-arrow-down:before {
  content: "\\e094";
}
.glyphicon-share-alt:before {
  content: "\\e095";
}
.glyphicon-resize-full:before {
  content: "\\e096";
}
.glyphicon-resize-small:before {
  content: "\\e097";
}
.glyphicon-exclamation-sign:before {
  content: "\\e101";
}
.glyphicon-gift:before {
  content: "\\e102";
}
.glyphicon-leaf:before {
  content: "\\e103";
}
.glyphicon-fire:before {
  content: "\\e104";
}
.glyphicon-eye-open:before {
  content: "\\e105";
}
.glyphicon-eye-close:before {
  content: "\\e106";
}
.glyphicon-warning-sign:before {
  content: "\\e107";
}
.glyphicon-plane:before {
  content: "\\e108";
}
.glyphicon-calendar:before {
  content: "\\e109";
}
.glyphicon-random:before {
  content: "\\e110";
}
.glyphicon-comment:before {
  content: "\\e111";
}
.glyphicon-magnet:before {
  content: "\\e112";
}
.glyphicon-chevron-up:before {
  content: "\\e113";
}
.glyphicon-chevron-down:before {
  content: "\\e114";
}
.glyphicon-retweet:before {
  content: "\\e115";
}
.glyphicon-shopping-cart:before {
  content: "\\e116";
}
.glyphicon-folder-close:before {
  content: "\\e117";
}
.glyphicon-folder-open:before {
  content: "\\e118";
}
.glyphicon-resize-vertical:before {
  content: "\\e119";
}
.glyphicon-resize-horizontal:before {
  content: "\\e120";
}
.glyphicon-hdd:before {
  content: "\\e121";
}
.glyphicon-bullhorn:before {
  content: "\\e122";
}
.glyphicon-bell:before {
  content: "\\e123";
}
.glyphicon-certificate:before {
  content: "\\e124";
}
.glyphicon-thumbs-up:before {
  content: "\\e125";
}
.glyphicon-thumbs-down:before {
  content: "\\e126";
}
.glyphicon-hand-right:before {
  content: "\\e127";
}
.glyphicon-hand-left:before {
  content: "\\e128";
}
.glyphicon-hand-up:before {
  content: "\\e129";
}
.glyphicon-hand-down:before {
  content: "\\e130";
}
.glyphicon-circle-arrow-right:before {
  content: "\\e131";
}
.glyphicon-circle-arrow-left:before {
  content: "\\e132";
}
.glyphicon-circle-arrow-up:before {
  content: "\\e133";
}
.glyphicon-circle-arrow-down:before {
  content: "\\e134";
}
.glyphicon-globe:before {
  content: "\\e135";
}
.glyphicon-wrench:before {
  content: "\\e136";
}
.glyphicon-tasks:before {
  content: "\\e137";
}
.glyphicon-filter:before {
  content: "\\e138";
}
.glyphicon-briefcase:before {
  content: "\\e139";
}
.glyphicon-fullscreen:before {
  content: "\\e140";
}
.glyphicon-dashboard:before {
  content: "\\e141";
}
.glyphicon-paperclip:before {
  content: "\\e142";
}
.glyphicon-heart-empty:before {
  content: "\\e143";
}
.glyphicon-link:before {
  content: "\\e144";
}
.glyphicon-phone:before {
  content: "\\e145";
}
.glyphicon-pushpin:before {
  content: "\\e146";
}
.glyphicon-usd:before {
  content: "\\e148";
}
.glyphicon-gbp:before {
  content: "\\e149";
}
.glyphicon-sort:before {
  content: "\\e150";
}
.glyphicon-sort-by-alphabet:before {
  content: "\\e151";
}
.glyphicon-sort-by-alphabet-alt:before {
  content: "\\e152";
}
.glyphicon-sort-by-order:before {
  content: "\\e153";
}
.glyphicon-sort-by-order-alt:before {
  content: "\\e154";
}
.glyphicon-sort-by-attributes:before {
  content: "\\e155";
}
.glyphicon-sort-by-attributes-alt:before {
  content: "\\e156";
}
.glyphicon-unchecked:before {
  content: "\\e157";
}
.glyphicon-expand:before {
  content: "\\e158";
}
.glyphicon-collapse-down:before {
  content: "\\e159";
}
.glyphicon-collapse-up:before {
  content: "\\e160";
}
.glyphicon-log-in:before {
  content: "\\e161";
}
.glyphicon-flash:before {
  content: "\\e162";
}
.glyphicon-log-out:before {
  content: "\\e163";
}
.glyphicon-new-window:before {
  content: "\\e164";
}
.glyphicon-record:before {
  content: "\\e165";
}
.glyphicon-save:before {
  content: "\\e166";
}
.glyphicon-open:before {
  content: "\\e167";
}
.glyphicon-saved:before {
  content: "\\e168";
}
.glyphicon-import:before {
  content: "\\e169";
}
.glyphicon-export:before {
  content: "\\e170";
}
.glyphicon-send:before {
  content: "\\e171";
}
.glyphicon-floppy-disk:before {
  content: "\\e172";
}
.glyphicon-floppy-saved:before {
  content: "\\e173";
}
.glyphicon-floppy-remove:before {
  content: "\\e174";
}
.glyphicon-floppy-save:before {
  content: "\\e175";
}
.glyphicon-floppy-open:before {
  content: "\\e176";
}
.glyphicon-credit-card:before {
  content: "\\e177";
}
.glyphicon-transfer:before {
  content: "\\e178";
}
.glyphicon-cutlery:before {
  content: "\\e179";
}
.glyphicon-header:before {
  content: "\\e180";
}
.glyphicon-compressed:before {
  content: "\\e181";
}
.glyphicon-earphone:before {
  content: "\\e182";
}
.glyphicon-phone-alt:before {
  content: "\\e183";
}
.glyphicon-tower:before {
  content: "\\e184";
}
.glyphicon-stats:before {
  content: "\\e185";
}
.glyphicon-sd-video:before {
  content: "\\e186";
}
.glyphicon-hd-video:before {
  content: "\\e187";
}
.glyphicon-subtitles:before {
  content: "\\e188";
}
.glyphicon-sound-stereo:before {
  content: "\\e189";
}
.glyphicon-sound-dolby:before {
  content: "\\e190";
}
.glyphicon-sound-5-1:before {
  content: "\\e191";
}
.glyphicon-sound-6-1:before {
  content: "\\e192";
}
.glyphicon-sound-7-1:before {
  content: "\\e193";
}
.glyphicon-copyright-mark:before {
  content: "\\e194";
}
.glyphicon-registration-mark:before {
  content: "\\e195";
}
.glyphicon-cloud-download:before {
  content: "\\e197";
}
.glyphicon-cloud-upload:before {
  content: "\\e198";
}
.glyphicon-tree-conifer:before {
  content: "\\e199";
}
.glyphicon-tree-deciduous:before {
  content: "\\e200";
}
.glyphicon-cd:before {
  content: "\\e201";
}
.glyphicon-save-file:before {
  content: "\\e202";
}
.glyphicon-open-file:before {
  content: "\\e203";
}
.glyphicon-level-up:before {
  content: "\\e204";
}
.glyphicon-copy:before {
  content: "\\e205";
}
.glyphicon-paste:before {
  content: "\\e206";
}
.glyphicon-alert:before {
  content: "\\e209";
}
.glyphicon-equalizer:before {
  content: "\\e210";
}
.glyphicon-king:before {
  content: "\\e211";
}
.glyphicon-queen:before {
  content: "\\e212";
}
.glyphicon-pawn:before {
  content: "\\e213";
}
.glyphicon-bishop:before {
  content: "\\e214";
}
.glyphicon-knight:before {
  content: "\\e215";
}
.glyphicon-baby-formula:before {
  content: "\\e216";
}
.glyphicon-tent:before {
  content: "\\26fa";
}
.glyphicon-blackboard:before {
  content: "\\e218";
}
.glyphicon-bed:before {
  content: "\\e219";
}
.glyphicon-apple:before {
  content: "\\f8ff";
}
.glyphicon-erase:before {
  content: "\\e221";
}
.glyphicon-hourglass:before {
  content: "\\231b";
}
.glyphicon-lamp:before {
  content: "\\e223";
}
.glyphicon-duplicate:before {
  content: "\\e224";
}
.glyphicon-piggy-bank:before {
  content: "\\e225";
}
.glyphicon-scissors:before {
  content: "\\e226";
}
.glyphicon-bitcoin:before {
  content: "\\e227";
}
.glyphicon-btc:before {
  content: "\\e227";
}
.glyphicon-xbt:before {
  content: "\\e227";
}
.glyphicon-yen:before {
  content: "\\00a5";
}
.glyphicon-jpy:before {
  content: "\\00a5";
}
.glyphicon-ruble:before {
  content: "\\20bd";
}
.glyphicon-rub:before {
  content: "\\20bd";
}
.glyphicon-scale:before {
  content: "\\e230";
}
.glyphicon-ice-lolly:before {
  content: "\\e231";
}
.glyphicon-ice-lolly-tasted:before {
  content: "\\e232";
}
.glyphicon-education:before {
  content: "\\e233";
}
.glyphicon-option-horizontal:before {
  content: "\\e234";
}
.glyphicon-option-vertical:before {
  content: "\\e235";
}
.glyphicon-menu-hamburger:before {
  content: "\\e236";
}
.glyphicon-modal-window:before {
  content: "\\e237";
}
.glyphicon-oil:before {
  content: "\\e238";
}
.glyphicon-grain:before {
  content: "\\e239";
}
.glyphicon-sunglasses:before {
  content: "\\e240";
}
.glyphicon-text-size:before {
  content: "\\e241";
}
.glyphicon-text-color:before {
  content: "\\e242";
}
.glyphicon-text-background:before {
  content: "\\e243";
}
.glyphicon-object-align-top:before {
  content: "\\e244";
}
.glyphicon-object-align-bottom:before {
  content: "\\e245";
}
.glyphicon-object-align-horizontal:before {
  content: "\\e246";
}
.glyphicon-object-align-left:before {
  content: "\\e247";
}
.glyphicon-object-align-vertical:before {
  content: "\\e248";
}
.glyphicon-object-align-right:before {
  content: "\\e249";
}
.glyphicon-triangle-right:before {
  content: "\\e250";
}
.glyphicon-triangle-left:before {
  content: "\\e251";
}
.glyphicon-triangle-bottom:before {
  content: "\\e252";
}
.glyphicon-triangle-top:before {
  content: "\\e253";
}
.glyphicon-console:before {
  content: "\\e254";
}
.glyphicon-superscript:before {
  content: "\\e255";
}
.glyphicon-subscript:before {
  content: "\\e256";
}
.glyphicon-menu-left:before {
  content: "\\e257";
}
.glyphicon-menu-right:before {
  content: "\\e258";
}
.glyphicon-menu-down:before {
  content: "\\e259";
}
.glyphicon-menu-up:before {
  content: "\\e260";
}
* {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}
*:before,
*:after {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}
html {
  font-size: 10px;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
body {
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 13px;
  line-height: 1.42857143;
  color: black;
  background-color: var(--body-bg);
}
input,
button,
select,
textarea {
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
}
a {
  color: #296eaa;
  text-decoration: none;
}
a:hover,
a:focus {
  color: #1a466c;
  text-decoration: underline;
}
a:focus {
  outline: 5px auto -webkit-focus-ring-color;
  outline-offset: -2px;
}
figure {
  margin: 0;
}
img {
  vertical-align: middle;
}
.img-responsive,
.thumbnail > img,
.thumbnail a > img,
.carousel-inner > .item > img,
.carousel-inner > .item > a > img {
  display: block;
  max-width: 100%;
  height: auto;
}
.img-rounded {
  border-radius: 3px;
}
.img-thumbnail {
  padding: 4px;
  line-height: 1.42857143;
  background-color: var(--body-bg);
  border: 1px solid #ddd;
  border-radius: 2px;
  -webkit-transition: all 0.2s ease-in-out;
  -o-transition: all 0.2s ease-in-out;
  transition: all 0.2s ease-in-out;
  display: inline-block;
  max-width: 100%;
  height: auto;
}
.img-circle {
  border-radius: 50%;
}
hr {
  margin-top: 18px;
  margin-bottom: 18px;
  border: 0;
  border-top: 1px solid #eeeeee;
}
.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
}
.sr-only-focusable:active,
.sr-only-focusable:focus {
  position: static;
  width: auto;
  height: auto;
  margin: 0;
  overflow: visible;
  clip: auto;
}
[role="button"] {
  cursor: pointer;
}
h1,
h2,
h3,
h4,
h5,
h6,
.h1,
.h2,
.h3,
.h4,
.h5,
.h6 {
  font-family: inherit;
  font-weight: 500;
  line-height: 1.1;
  color: inherit;
}
h1 small,
h2 small,
h3 small,
h4 small,
h5 small,
h6 small,
.h1 small,
.h2 small,
.h3 small,
.h4 small,
.h5 small,
.h6 small,
h1 .small,
h2 .small,
h3 .small,
h4 .small,
h5 .small,
h6 .small,
.h1 .small,
.h2 .small,
.h3 .small,
.h4 .small,
.h5 .small,
.h6 .small {
  font-weight: 400;
  line-height: 1;
  color: #777777;
}
h1,
.h1,
h2,
.h2,
h3,
.h3 {
  margin-top: 18px;
  margin-bottom: 9px;
}
h1 small,
.h1 small,
h2 small,
.h2 small,
h3 small,
.h3 small,
h1 .small,
.h1 .small,
h2 .small,
.h2 .small,
h3 .small,
.h3 .small {
  font-size: 65%;
}
h4,
.h4,
h5,
.h5,
h6,
.h6 {
  margin-top: 9px;
  margin-bottom: 9px;
}
h4 small,
.h4 small,
h5 small,
.h5 small,
h6 small,
.h6 small,
h4 .small,
.h4 .small,
h5 .small,
.h5 .small,
h6 .small,
.h6 .small {
  font-size: 75%;
}
h1,
.h1 {
  font-size: 33px;
}
h2,
.h2 {
  font-size: 27px;
}
h3,
.h3 {
  font-size: 23px;
}
h4,
.h4 {
  font-size: 17px;
}
h5,
.h5 {
  font-size: 13px;
}
h6,
.h6 {
  font-size: 12px;
}
p {
  margin: 0 0 9px;
}
.lead {
  margin-bottom: 18px;
  font-size: 14px;
  font-weight: 300;
  line-height: 1.4;
}
@media (min-width: 768px) {
  .lead {
    font-size: 19.5px;
  }
}
small,
.small {
  font-size: 92%;
}
mark,
.mark {
  padding: 0.2em;
  background-color: #fcf8e3;
}
.text-left {
  text-align: left;
}
.text-right {
  text-align: right;
}
.text-center {
  text-align: center;
}
.text-justify {
  text-align: justify;
}
.text-nowrap {
  white-space: nowrap;
}
.text-lowercase {
  text-transform: lowercase;
}
.text-uppercase {
  text-transform: uppercase;
}
.text-capitalize {
  text-transform: capitalize;
}
.text-muted {
  color: #777777;
}
.text-primary {
  color: #337ab7;
}
a.text-primary:hover,
a.text-primary:focus {
  color: #286090;
}
.text-success {
  color: #3c763d;
}
a.text-success:hover,
a.text-success:focus {
  color: #2b542c;
}
.text-info {
  color: #31708f;
}
a.text-info:hover,
a.text-info:focus {
  color: #245269;
}
.text-warning {
  color: #8a6d3b;
}
a.text-warning:hover,
a.text-warning:focus {
  color: #66512c;
}
.text-danger {
  color: #a94442;
}
a.text-danger:hover,
a.text-danger:focus {
  color: #843534;
}
.bg-primary {
  color: #fff;
  background-color: #337ab7;
}
a.bg-primary:hover,
a.bg-primary:focus {
  background-color: #286090;
}
.bg-success {
  background-color: #dff0d8;
}
a.bg-success:hover,
a.bg-success:focus {
  background-color: #c1e2b3;
}
.bg-info {
  background-color: #d9edf7;
}
a.bg-info:hover,
a.bg-info:focus {
  background-color: #afd9ee;
}
.bg-warning {
  background-color: #fcf8e3;
}
a.bg-warning:hover,
a.bg-warning:focus {
  background-color: #f7ecb5;
}
.bg-danger {
  background-color: #f2dede;
}
a.bg-danger:hover,
a.bg-danger:focus {
  background-color: #e4b9b9;
}
.page-header {
  padding-bottom: 8px;
  margin: 36px 0 18px;
  border-bottom: 1px solid #eeeeee;
}
ul,
ol {
  margin-top: 0;
  margin-bottom: 9px;
}
ul ul,
ol ul,
ul ol,
ol ol {
  margin-bottom: 0;
}
.list-unstyled {
  padding-left: 0;
  list-style: none;
}
.list-inline {
  padding-left: 0;
  list-style: none;
  margin-left: -5px;
}
.list-inline > li {
  display: inline-block;
  padding-right: 5px;
  padding-left: 5px;
}
dl {
  margin-top: 0;
  margin-bottom: 18px;
}
dt,
dd {
  line-height: 1.42857143;
}
dt {
  font-weight: 700;
}
dd {
  margin-left: 0;
}
@media (min-width: 541px) {
  .dl-horizontal dt {
    float: left;
    width: 160px;
    clear: left;
    text-align: right;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .dl-horizontal dd {
    margin-left: 180px;
  }
}
abbr[title],
abbr[data-original-title] {
  cursor: help;
}
.initialism {
  font-size: 90%;
  text-transform: uppercase;
}
blockquote {
  padding: 9px 18px;
  margin: 0 0 18px;
  font-size: inherit;
  border-left: 5px solid #eeeeee;
}
blockquote p:last-child,
blockquote ul:last-child,
blockquote ol:last-child {
  margin-bottom: 0;
}
blockquote footer,
blockquote small,
blockquote .small {
  display: block;
  font-size: 80%;
  line-height: 1.42857143;
  color: #777777;
}
blockquote footer:before,
blockquote small:before,
blockquote .small:before {
  content: "\\2014 \\00A0";
}
.blockquote-reverse,
blockquote.pull-right {
  padding-right: 15px;
  padding-left: 0;
  text-align: right;
  border-right: 5px solid #eeeeee;
  border-left: 0;
}
.blockquote-reverse footer:before,
blockquote.pull-right footer:before,
.blockquote-reverse small:before,
blockquote.pull-right small:before,
.blockquote-reverse .small:before,
blockquote.pull-right .small:before {
  content: "";
}
.blockquote-reverse footer:after,
blockquote.pull-right footer:after,
.blockquote-reverse small:after,
blockquote.pull-right small:after,
.blockquote-reverse .small:after,
blockquote.pull-right .small:after {
  content: "\\00A0 \\2014";
}
address {
  margin-bottom: 18px;
  font-style: normal;
  line-height: 1.42857143;
}
code,
kbd,
pre,
samp {
  font-family: monospace;
}
code {
  padding: 2px 4px;
  font-size: 90%;
  color: #c7254e;
  background-color: #f9f2f4;
  border-radius: 2px;
}
kbd {
  padding: 2px 4px;
  font-size: 90%;
  color: #888;
  background-color: transparent;
  border-radius: 1px;
  box-shadow: inset 0 -1px 0 rgba(0, 0, 0, 0.25);
}
kbd kbd {
  padding: 0;
  font-size: 100%;
  font-weight: 700;
  box-shadow: none;
}
pre {
  display: block;
  padding: 8.5px;
  margin: 0 0 9px;
  font-size: 12px;
  line-height: 1.42857143;
  color: #333333;
  word-break: break-all;
  word-wrap: break-word;
  background-color: #f5f5f5;
  border: 1px solid #ccc;
  border-radius: 2px;
}
pre code {
  padding: 0;
  font-size: inherit;
  color: inherit;
  white-space: pre-wrap;
  background-color: transparent;
  border-radius: 0;
}
.pre-scrollable {
  max-height: 340px;
  overflow-y: scroll;
}
.container {
  padding-right: 0px;
  padding-left: 0px;
  margin-right: auto;
  margin-left: auto;
}
@media (min-width: 768px) {
  .container {
    width: 768px;
  }
}
@media (min-width: 992px) {
  .container {
    width: 940px;
  }
}
@media (min-width: 1200px) {
  .container {
    width: 1140px;
  }
}
.container-fluid {
  padding-right: 0px;
  padding-left: 0px;
  margin-right: auto;
  margin-left: auto;
}
.row {
  margin-right: 0px;
  margin-left: 0px;
}
.row-no-gutters {
  margin-right: 0;
  margin-left: 0;
}
.row-no-gutters [class*="col-"] {
  padding-right: 0;
  padding-left: 0;
}
.col-xs-1,
.col-sm-1,
.col-md-1,
.col-lg-1,
.col-xs-2,
.col-sm-2,
.col-md-2,
.col-lg-2,
.col-xs-3,
.col-sm-3,
.col-md-3,
.col-lg-3,
.col-xs-4,
.col-sm-4,
.col-md-4,
.col-lg-4,
.col-xs-5,
.col-sm-5,
.col-md-5,
.col-lg-5,
.col-xs-6,
.col-sm-6,
.col-md-6,
.col-lg-6,
.col-xs-7,
.col-sm-7,
.col-md-7,
.col-lg-7,
.col-xs-8,
.col-sm-8,
.col-md-8,
.col-lg-8,
.col-xs-9,
.col-sm-9,
.col-md-9,
.col-lg-9,
.col-xs-10,
.col-sm-10,
.col-md-10,
.col-lg-10,
.col-xs-11,
.col-sm-11,
.col-md-11,
.col-lg-11,
.col-xs-12,
.col-sm-12,
.col-md-12,
.col-lg-12 {
  position: relative;
  min-height: 1px;
  padding-right: 0px;
  padding-left: 0px;
}
.col-xs-1,
.col-xs-2,
.col-xs-3,
.col-xs-4,
.col-xs-5,
.col-xs-6,
.col-xs-7,
.col-xs-8,
.col-xs-9,
.col-xs-10,
.col-xs-11,
.col-xs-12 {
  float: left;
}
.col-xs-12 {
  width: 100%;
}
.col-xs-11 {
  width: 91.66666667%;
}
.col-xs-10 {
  width: 83.33333333%;
}
.col-xs-9 {
  width: 75%;
}
.col-xs-8 {
  width: 66.66666667%;
}
.col-xs-7 {
  width: 58.33333333%;
}
.col-xs-6 {
  width: 50%;
}
.col-xs-5 {
  width: 41.66666667%;
}
.col-xs-4 {
  width: 33.33333333%;
}
.col-xs-3 {
  width: 25%;
}
.col-xs-2 {
  width: 16.66666667%;
}
.col-xs-1 {
  width: 8.33333333%;
}
.col-xs-pull-12 {
  right: 100%;
}
.col-xs-pull-11 {
  right: 91.66666667%;
}
.col-xs-pull-10 {
  right: 83.33333333%;
}
.col-xs-pull-9 {
  right: 75%;
}
.col-xs-pull-8 {
  right: 66.66666667%;
}
.col-xs-pull-7 {
  right: 58.33333333%;
}
.col-xs-pull-6 {
  right: 50%;
}
.col-xs-pull-5 {
  right: 41.66666667%;
}
.col-xs-pull-4 {
  right: 33.33333333%;
}
.col-xs-pull-3 {
  right: 25%;
}
.col-xs-pull-2 {
  right: 16.66666667%;
}
.col-xs-pull-1 {
  right: 8.33333333%;
}
.col-xs-pull-0 {
  right: auto;
}
.col-xs-push-12 {
  left: 100%;
}
.col-xs-push-11 {
  left: 91.66666667%;
}
.col-xs-push-10 {
  left: 83.33333333%;
}
.col-xs-push-9 {
  left: 75%;
}
.col-xs-push-8 {
  left: 66.66666667%;
}
.col-xs-push-7 {
  left: 58.33333333%;
}
.col-xs-push-6 {
  left: 50%;
}
.col-xs-push-5 {
  left: 41.66666667%;
}
.col-xs-push-4 {
  left: 33.33333333%;
}
.col-xs-push-3 {
  left: 25%;
}
.col-xs-push-2 {
  left: 16.66666667%;
}
.col-xs-push-1 {
  left: 8.33333333%;
}
.col-xs-push-0 {
  left: auto;
}
.col-xs-offset-12 {
  margin-left: 100%;
}
.col-xs-offset-11 {
  margin-left: 91.66666667%;
}
.col-xs-offset-10 {
  margin-left: 83.33333333%;
}
.col-xs-offset-9 {
  margin-left: 75%;
}
.col-xs-offset-8 {
  margin-left: 66.66666667%;
}
.col-xs-offset-7 {
  margin-left: 58.33333333%;
}
.col-xs-offset-6 {
  margin-left: 50%;
}
.col-xs-offset-5 {
  margin-left: 41.66666667%;
}
.col-xs-offset-4 {
  margin-left: 33.33333333%;
}
.col-xs-offset-3 {
  margin-left: 25%;
}
.col-xs-offset-2 {
  margin-left: 16.66666667%;
}
.col-xs-offset-1 {
  margin-left: 8.33333333%;
}
.col-xs-offset-0 {
  margin-left: 0%;
}
@media (min-width: 768px) {
  .col-sm-1,
  .col-sm-2,
  .col-sm-3,
  .col-sm-4,
  .col-sm-5,
  .col-sm-6,
  .col-sm-7,
  .col-sm-8,
  .col-sm-9,
  .col-sm-10,
  .col-sm-11,
  .col-sm-12 {
    float: left;
  }
  .col-sm-12 {
    width: 100%;
  }
  .col-sm-11 {
    width: 91.66666667%;
  }
  .col-sm-10 {
    width: 83.33333333%;
  }
  .col-sm-9 {
    width: 75%;
  }
  .col-sm-8 {
    width: 66.66666667%;
  }
  .col-sm-7 {
    width: 58.33333333%;
  }
  .col-sm-6 {
    width: 50%;
  }
  .col-sm-5 {
    width: 41.66666667%;
  }
  .col-sm-4 {
    width: 33.33333333%;
  }
  .col-sm-3 {
    width: 25%;
  }
  .col-sm-2 {
    width: 16.66666667%;
  }
  .col-sm-1 {
    width: 8.33333333%;
  }
  .col-sm-pull-12 {
    right: 100%;
  }
  .col-sm-pull-11 {
    right: 91.66666667%;
  }
  .col-sm-pull-10 {
    right: 83.33333333%;
  }
  .col-sm-pull-9 {
    right: 75%;
  }
  .col-sm-pull-8 {
    right: 66.66666667%;
  }
  .col-sm-pull-7 {
    right: 58.33333333%;
  }
  .col-sm-pull-6 {
    right: 50%;
  }
  .col-sm-pull-5 {
    right: 41.66666667%;
  }
  .col-sm-pull-4 {
    right: 33.33333333%;
  }
  .col-sm-pull-3 {
    right: 25%;
  }
  .col-sm-pull-2 {
    right: 16.66666667%;
  }
  .col-sm-pull-1 {
    right: 8.33333333%;
  }
  .col-sm-pull-0 {
    right: auto;
  }
  .col-sm-push-12 {
    left: 100%;
  }
  .col-sm-push-11 {
    left: 91.66666667%;
  }
  .col-sm-push-10 {
    left: 83.33333333%;
  }
  .col-sm-push-9 {
    left: 75%;
  }
  .col-sm-push-8 {
    left: 66.66666667%;
  }
  .col-sm-push-7 {
    left: 58.33333333%;
  }
  .col-sm-push-6 {
    left: 50%;
  }
  .col-sm-push-5 {
    left: 41.66666667%;
  }
  .col-sm-push-4 {
    left: 33.33333333%;
  }
  .col-sm-push-3 {
    left: 25%;
  }
  .col-sm-push-2 {
    left: 16.66666667%;
  }
  .col-sm-push-1 {
    left: 8.33333333%;
  }
  .col-sm-push-0 {
    left: auto;
  }
  .col-sm-offset-12 {
    margin-left: 100%;
  }
  .col-sm-offset-11 {
    margin-left: 91.66666667%;
  }
  .col-sm-offset-10 {
    margin-left: 83.33333333%;
  }
  .col-sm-offset-9 {
    margin-left: 75%;
  }
  .col-sm-offset-8 {
    margin-left: 66.66666667%;
  }
  .col-sm-offset-7 {
    margin-left: 58.33333333%;
  }
  .col-sm-offset-6 {
    margin-left: 50%;
  }
  .col-sm-offset-5 {
    margin-left: 41.66666667%;
  }
  .col-sm-offset-4 {
    margin-left: 33.33333333%;
  }
  .col-sm-offset-3 {
    margin-left: 25%;
  }
  .col-sm-offset-2 {
    margin-left: 16.66666667%;
  }
  .col-sm-offset-1 {
    margin-left: 8.33333333%;
  }
  .col-sm-offset-0 {
    margin-left: 0%;
  }
}
@media (min-width: 992px) {
  .col-md-1,
  .col-md-2,
  .col-md-3,
  .col-md-4,
  .col-md-5,
  .col-md-6,
  .col-md-7,
  .col-md-8,
  .col-md-9,
  .col-md-10,
  .col-md-11,
  .col-md-12 {
    float: left;
  }
  .col-md-12 {
    width: 100%;
  }
  .col-md-11 {
    width: 91.66666667%;
  }
  .col-md-10 {
    width: 83.33333333%;
  }
  .col-md-9 {
    width: 75%;
  }
  .col-md-8 {
    width: 66.66666667%;
  }
  .col-md-7 {
    width: 58.33333333%;
  }
  .col-md-6 {
    width: 50%;
  }
  .col-md-5 {
    width: 41.66666667%;
  }
  .col-md-4 {
    width: 33.33333333%;
  }
  .col-md-3 {
    width: 25%;
  }
  .col-md-2 {
    width: 16.66666667%;
  }
  .col-md-1 {
    width: 8.33333333%;
  }
  .col-md-pull-12 {
    right: 100%;
  }
  .col-md-pull-11 {
    right: 91.66666667%;
  }
  .col-md-pull-10 {
    right: 83.33333333%;
  }
  .col-md-pull-9 {
    right: 75%;
  }
  .col-md-pull-8 {
    right: 66.66666667%;
  }
  .col-md-pull-7 {
    right: 58.33333333%;
  }
  .col-md-pull-6 {
    right: 50%;
  }
  .col-md-pull-5 {
    right: 41.66666667%;
  }
  .col-md-pull-4 {
    right: 33.33333333%;
  }
  .col-md-pull-3 {
    right: 25%;
  }
  .col-md-pull-2 {
    right: 16.66666667%;
  }
  .col-md-pull-1 {
    right: 8.33333333%;
  }
  .col-md-pull-0 {
    right: auto;
  }
  .col-md-push-12 {
    left: 100%;
  }
  .col-md-push-11 {
    left: 91.66666667%;
  }
  .col-md-push-10 {
    left: 83.33333333%;
  }
  .col-md-push-9 {
    left: 75%;
  }
  .col-md-push-8 {
    left: 66.66666667%;
  }
  .col-md-push-7 {
    left: 58.33333333%;
  }
  .col-md-push-6 {
    left: 50%;
  }
  .col-md-push-5 {
    left: 41.66666667%;
  }
  .col-md-push-4 {
    left: 33.33333333%;
  }
  .col-md-push-3 {
    left: 25%;
  }
  .col-md-push-2 {
    left: 16.66666667%;
  }
  .col-md-push-1 {
    left: 8.33333333%;
  }
  .col-md-push-0 {
    left: auto;
  }
  .col-md-offset-12 {
    margin-left: 100%;
  }
  .col-md-offset-11 {
    margin-left: 91.66666667%;
  }
  .col-md-offset-10 {
    margin-left: 83.33333333%;
  }
  .col-md-offset-9 {
    margin-left: 75%;
  }
  .col-md-offset-8 {
    margin-left: 66.66666667%;
  }
  .col-md-offset-7 {
    margin-left: 58.33333333%;
  }
  .col-md-offset-6 {
    margin-left: 50%;
  }
  .col-md-offset-5 {
    margin-left: 41.66666667%;
  }
  .col-md-offset-4 {
    margin-left: 33.33333333%;
  }
  .col-md-offset-3 {
    margin-left: 25%;
  }
  .col-md-offset-2 {
    margin-left: 16.66666667%;
  }
  .col-md-offset-1 {
    margin-left: 8.33333333%;
  }
  .col-md-offset-0 {
    margin-left: 0%;
  }
}
@media (min-width: 1200px) {
  .col-lg-1,
  .col-lg-2,
  .col-lg-3,
  .col-lg-4,
  .col-lg-5,
  .col-lg-6,
  .col-lg-7,
  .col-lg-8,
  .col-lg-9,
  .col-lg-10,
  .col-lg-11,
  .col-lg-12 {
    float: left;
  }
  .col-lg-12 {
    width: 100%;
  }
  .col-lg-11 {
    width: 91.66666667%;
  }
  .col-lg-10 {
    width: 83.33333333%;
  }
  .col-lg-9 {
    width: 75%;
  }
  .col-lg-8 {
    width: 66.66666667%;
  }
  .col-lg-7 {
    width: 58.33333333%;
  }
  .col-lg-6 {
    width: 50%;
  }
  .col-lg-5 {
    width: 41.66666667%;
  }
  .col-lg-4 {
    width: 33.33333333%;
  }
  .col-lg-3 {
    width: 25%;
  }
  .col-lg-2 {
    width: 16.66666667%;
  }
  .col-lg-1 {
    width: 8.33333333%;
  }
  .col-lg-pull-12 {
    right: 100%;
  }
  .col-lg-pull-11 {
    right: 91.66666667%;
  }
  .col-lg-pull-10 {
    right: 83.33333333%;
  }
  .col-lg-pull-9 {
    right: 75%;
  }
  .col-lg-pull-8 {
    right: 66.66666667%;
  }
  .col-lg-pull-7 {
    right: 58.33333333%;
  }
  .col-lg-pull-6 {
    right: 50%;
  }
  .col-lg-pull-5 {
    right: 41.66666667%;
  }
  .col-lg-pull-4 {
    right: 33.33333333%;
  }
  .col-lg-pull-3 {
    right: 25%;
  }
  .col-lg-pull-2 {
    right: 16.66666667%;
  }
  .col-lg-pull-1 {
    right: 8.33333333%;
  }
  .col-lg-pull-0 {
    right: auto;
  }
  .col-lg-push-12 {
    left: 100%;
  }
  .col-lg-push-11 {
    left: 91.66666667%;
  }
  .col-lg-push-10 {
    left: 83.33333333%;
  }
  .col-lg-push-9 {
    left: 75%;
  }
  .col-lg-push-8 {
    left: 66.66666667%;
  }
  .col-lg-push-7 {
    left: 58.33333333%;
  }
  .col-lg-push-6 {
    left: 50%;
  }
  .col-lg-push-5 {
    left: 41.66666667%;
  }
  .col-lg-push-4 {
    left: 33.33333333%;
  }
  .col-lg-push-3 {
    left: 25%;
  }
  .col-lg-push-2 {
    left: 16.66666667%;
  }
  .col-lg-push-1 {
    left: 8.33333333%;
  }
  .col-lg-push-0 {
    left: auto;
  }
  .col-lg-offset-12 {
    margin-left: 100%;
  }
  .col-lg-offset-11 {
    margin-left: 91.66666667%;
  }
  .col-lg-offset-10 {
    margin-left: 83.33333333%;
  }
  .col-lg-offset-9 {
    margin-left: 75%;
  }
  .col-lg-offset-8 {
    margin-left: 66.66666667%;
  }
  .col-lg-offset-7 {
    margin-left: 58.33333333%;
  }
  .col-lg-offset-6 {
    margin-left: 50%;
  }
  .col-lg-offset-5 {
    margin-left: 41.66666667%;
  }
  .col-lg-offset-4 {
    margin-left: 33.33333333%;
  }
  .col-lg-offset-3 {
    margin-left: 25%;
  }
  .col-lg-offset-2 {
    margin-left: 16.66666667%;
  }
  .col-lg-offset-1 {
    margin-left: 8.33333333%;
  }
  .col-lg-offset-0 {
    margin-left: 0%;
  }
}
table {
  background-color: transparent;
}
table col[class*="col-"] {
  position: static;
  display: table-column;
  float: none;
}
table td[class*="col-"],
table th[class*="col-"] {
  position: static;
  display: table-cell;
  float: none;
}
caption {
  padding-top: 8px;
  padding-bottom: 8px;
  color: #777777;
  text-align: left;
}
th {
  text-align: left;
}
.table {
  width: 100%;
  max-width: 100%;
  margin-bottom: 18px;
}
.table > thead > tr > th,
.table > tbody > tr > th,
.table > tfoot > tr > th,
.table > thead > tr > td,
.table > tbody > tr > td,
.table > tfoot > tr > td {
  padding: 8px;
  line-height: 1.42857143;
  vertical-align: top;
  border-top: 1px solid #ddd;
}
.table > thead > tr > th {
  vertical-align: bottom;
  border-bottom: 2px solid #ddd;
}
.table > caption + thead > tr:first-child > th,
.table > colgroup + thead > tr:first-child > th,
.table > thead:first-child > tr:first-child > th,
.table > caption + thead > tr:first-child > td,
.table > colgroup + thead > tr:first-child > td,
.table > thead:first-child > tr:first-child > td {
  border-top: 0;
}
.table > tbody + tbody {
  border-top: 2px solid #ddd;
}
.table .table {
  background-color: var(--body-bg);
}
.table-condensed > thead > tr > th,
.table-condensed > tbody > tr > th,
.table-condensed > tfoot > tr > th,
.table-condensed > thead > tr > td,
.table-condensed > tbody > tr > td,
.table-condensed > tfoot > tr > td {
  padding: 5px;
}
.table-bordered {
  border: 1px solid #ddd;
}
.table-bordered > thead > tr > th,
.table-bordered > tbody > tr > th,
.table-bordered > tfoot > tr > th,
.table-bordered > thead > tr > td,
.table-bordered > tbody > tr > td,
.table-bordered > tfoot > tr > td {
  border: 1px solid #ddd;
}
.table-bordered > thead > tr > th,
.table-bordered > thead > tr > td {
  border-bottom-width: 2px;
}
.table-striped > tbody > tr:nth-of-type(odd) {
  background-color: #f9f9f9;
}
.table-hover > tbody > tr:hover {
  background-color: #f5f5f5;
}
.table > thead > tr > td.active,
.table > tbody > tr > td.active,
.table > tfoot > tr > td.active,
.table > thead > tr > th.active,
.table > tbody > tr > th.active,
.table > tfoot > tr > th.active,
.table > thead > tr.active > td,
.table > tbody > tr.active > td,
.table > tfoot > tr.active > td,
.table > thead > tr.active > th,
.table > tbody > tr.active > th,
.table > tfoot > tr.active > th {
  background-color: #f5f5f5;
}
.table-hover > tbody > tr > td.active:hover,
.table-hover > tbody > tr > th.active:hover,
.table-hover > tbody > tr.active:hover > td,
.table-hover > tbody > tr:hover > .active,
.table-hover > tbody > tr.active:hover > th {
  background-color: #e8e8e8;
}
.table > thead > tr > td.success,
.table > tbody > tr > td.success,
.table > tfoot > tr > td.success,
.table > thead > tr > th.success,
.table > tbody > tr > th.success,
.table > tfoot > tr > th.success,
.table > thead > tr.success > td,
.table > tbody > tr.success > td,
.table > tfoot > tr.success > td,
.table > thead > tr.success > th,
.table > tbody > tr.success > th,
.table > tfoot > tr.success > th {
  background-color: #dff0d8;
}
.table-hover > tbody > tr > td.success:hover,
.table-hover > tbody > tr > th.success:hover,
.table-hover > tbody > tr.success:hover > td,
.table-hover > tbody > tr:hover > .success,
.table-hover > tbody > tr.success:hover > th {
  background-color: #d0e9c6;
}
.table > thead > tr > td.info,
.table > tbody > tr > td.info,
.table > tfoot > tr > td.info,
.table > thead > tr > th.info,
.table > tbody > tr > th.info,
.table > tfoot > tr > th.info,
.table > thead > tr.info > td,
.table > tbody > tr.info > td,
.table > tfoot > tr.info > td,
.table > thead > tr.info > th,
.table > tbody > tr.info > th,
.table > tfoot > tr.info > th {
  background-color: #d9edf7;
}
.table-hover > tbody > tr > td.info:hover,
.table-hover > tbody > tr > th.info:hover,
.table-hover > tbody > tr.info:hover > td,
.table-hover > tbody > tr:hover > .info,
.table-hover > tbody > tr.info:hover > th {
  background-color: #c4e3f3;
}
.table > thead > tr > td.warning,
.table > tbody > tr > td.warning,
.table > tfoot > tr > td.warning,
.table > thead > tr > th.warning,
.table > tbody > tr > th.warning,
.table > tfoot > tr > th.warning,
.table > thead > tr.warning > td,
.table > tbody > tr.warning > td,
.table > tfoot > tr.warning > td,
.table > thead > tr.warning > th,
.table > tbody > tr.warning > th,
.table > tfoot > tr.warning > th {
  background-color: #fcf8e3;
}
.table-hover > tbody > tr > td.warning:hover,
.table-hover > tbody > tr > th.warning:hover,
.table-hover > tbody > tr.warning:hover > td,
.table-hover > tbody > tr:hover > .warning,
.table-hover > tbody > tr.warning:hover > th {
  background-color: #faf2cc;
}
.table > thead > tr > td.danger,
.table > tbody > tr > td.danger,
.table > tfoot > tr > td.danger,
.table > thead > tr > th.danger,
.table > tbody > tr > th.danger,
.table > tfoot > tr > th.danger,
.table > thead > tr.danger > td,
.table > tbody > tr.danger > td,
.table > tfoot > tr.danger > td,
.table > thead > tr.danger > th,
.table > tbody > tr.danger > th,
.table > tfoot > tr.danger > th {
  background-color: #f2dede;
}
.table-hover > tbody > tr > td.danger:hover,
.table-hover > tbody > tr > th.danger:hover,
.table-hover > tbody > tr.danger:hover > td,
.table-hover > tbody > tr:hover > .danger,
.table-hover > tbody > tr.danger:hover > th {
  background-color: #ebcccc;
}
.table-responsive {
  min-height: 0.01%;
  overflow-x: auto;
}
@media screen and (max-width: 767px) {
  .table-responsive {
    width: 100%;
    margin-bottom: 13.5px;
    overflow-y: hidden;
    -ms-overflow-style: -ms-autohiding-scrollbar;
    border: 1px solid #ddd;
  }
  .table-responsive > .table {
    margin-bottom: 0;
  }
  .table-responsive > .table > thead > tr > th,
  .table-responsive > .table > tbody > tr > th,
  .table-responsive > .table > tfoot > tr > th,
  .table-responsive > .table > thead > tr > td,
  .table-responsive > .table > tbody > tr > td,
  .table-responsive > .table > tfoot > tr > td {
    white-space: nowrap;
  }
  .table-responsive > .table-bordered {
    border: 0;
  }
  .table-responsive > .table-bordered > thead > tr > th:first-child,
  .table-responsive > .table-bordered > tbody > tr > th:first-child,
  .table-responsive > .table-bordered > tfoot > tr > th:first-child,
  .table-responsive > .table-bordered > thead > tr > td:first-child,
  .table-responsive > .table-bordered > tbody > tr > td:first-child,
  .table-responsive > .table-bordered > tfoot > tr > td:first-child {
    border-left: 0;
  }
  .table-responsive > .table-bordered > thead > tr > th:last-child,
  .table-responsive > .table-bordered > tbody > tr > th:last-child,
  .table-responsive > .table-bordered > tfoot > tr > th:last-child,
  .table-responsive > .table-bordered > thead > tr > td:last-child,
  .table-responsive > .table-bordered > tbody > tr > td:last-child,
  .table-responsive > .table-bordered > tfoot > tr > td:last-child {
    border-right: 0;
  }
  .table-responsive > .table-bordered > tbody > tr:last-child > th,
  .table-responsive > .table-bordered > tfoot > tr:last-child > th,
  .table-responsive > .table-bordered > tbody > tr:last-child > td,
  .table-responsive > .table-bordered > tfoot > tr:last-child > td {
    border-bottom: 0;
  }
}
fieldset {
  min-width: 0;
  padding: 0;
  margin: 0;
  border: 0;
}
legend {
  display: block;
  width: 100%;
  padding: 0;
  margin-bottom: 18px;
  font-size: 19.5px;
  line-height: inherit;
  color: #333333;
  border: 0;
  border-bottom: 1px solid #e5e5e5;
}
label {
  display: inline-block;
  max-width: 100%;
  margin-bottom: 5px;
  font-weight: 700;
}
input[type="search"] {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  -webkit-appearance: none;
  appearance: none;
}
input[type="radio"],
input[type="checkbox"] {
  margin: 4px 0 0;
  margin-top: 1px \\9;
  line-height: normal;
}
input[type="radio"][disabled],
input[type="checkbox"][disabled],
input[type="radio"].disabled,
input[type="checkbox"].disabled,
fieldset[disabled] input[type="radio"],
fieldset[disabled] input[type="checkbox"] {
  cursor: not-allowed;
}
input[type="file"] {
  display: block;
}
input[type="range"] {
  display: block;
  width: 100%;
}
select[multiple],
select[size] {
  height: auto;
}
input[type="file"]:focus,
input[type="radio"]:focus,
input[type="checkbox"]:focus {
  outline: 5px auto -webkit-focus-ring-color;
  outline-offset: -2px;
}
output {
  display: block;
  padding-top: 7px;
  font-size: 13px;
  line-height: 1.42857143;
  color: #555555;
}
.form-control {
  display: block;
  width: 100%;
  height: 32px;
  padding: 6px 12px;
  font-size: 13px;
  line-height: 1.42857143;
  color: #555555;
  background-color: #fff;
  background-image: none;
  border: 1px solid #ccc;
  border-radius: 2px;
  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  -webkit-transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;
  -o-transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;
  transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;
}
.form-control:focus {
  border-color: #66afe9;
  outline: 0;
  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075), 0 0 8px rgba(102, 175, 233, 0.6);
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075), 0 0 8px rgba(102, 175, 233, 0.6);
}
.form-control::-moz-placeholder {
  color: #999;
  opacity: 1;
}
.form-control:-ms-input-placeholder {
  color: #999;
}
.form-control::-webkit-input-placeholder {
  color: #999;
}
.form-control::-ms-expand {
  background-color: transparent;
  border: 0;
}
.form-control[disabled],
.form-control[readonly],
fieldset[disabled] .form-control {
  background-color: #eeeeee;
  opacity: 1;
}
.form-control[disabled],
fieldset[disabled] .form-control {
  cursor: not-allowed;
}
textarea.form-control {
  height: auto;
}
@media screen and (-webkit-min-device-pixel-ratio: 0) {
  input[type="date"].form-control,
  input[type="time"].form-control,
  input[type="datetime-local"].form-control,
  input[type="month"].form-control {
    line-height: 32px;
  }
  input[type="date"].input-sm,
  input[type="time"].input-sm,
  input[type="datetime-local"].input-sm,
  input[type="month"].input-sm,
  .input-group-sm input[type="date"],
  .input-group-sm input[type="time"],
  .input-group-sm input[type="datetime-local"],
  .input-group-sm input[type="month"] {
    line-height: 30px;
  }
  input[type="date"].input-lg,
  input[type="time"].input-lg,
  input[type="datetime-local"].input-lg,
  input[type="month"].input-lg,
  .input-group-lg input[type="date"],
  .input-group-lg input[type="time"],
  .input-group-lg input[type="datetime-local"],
  .input-group-lg input[type="month"] {
    line-height: 45px;
  }
}
.form-group {
  margin-bottom: 15px;
}
.radio,
.checkbox {
  position: relative;
  display: block;
  margin-top: 10px;
  margin-bottom: 10px;
}
.radio.disabled label,
.checkbox.disabled label,
fieldset[disabled] .radio label,
fieldset[disabled] .checkbox label {
  cursor: not-allowed;
}
.radio label,
.checkbox label {
  min-height: 18px;
  padding-left: 20px;
  margin-bottom: 0;
  font-weight: 400;
  cursor: pointer;
}
.radio input[type="radio"],
.radio-inline input[type="radio"],
.checkbox input[type="checkbox"],
.checkbox-inline input[type="checkbox"] {
  position: absolute;
  margin-top: 4px \\9;
  margin-left: -20px;
}
.radio + .radio,
.checkbox + .checkbox {
  margin-top: -5px;
}
.radio-inline,
.checkbox-inline {
  position: relative;
  display: inline-block;
  padding-left: 20px;
  margin-bottom: 0;
  font-weight: 400;
  vertical-align: middle;
  cursor: pointer;
}
.radio-inline.disabled,
.checkbox-inline.disabled,
fieldset[disabled] .radio-inline,
fieldset[disabled] .checkbox-inline {
  cursor: not-allowed;
}
.radio-inline + .radio-inline,
.checkbox-inline + .checkbox-inline {
  margin-top: 0;
  margin-left: 10px;
}
.form-control-static {
  min-height: 31px;
  padding-top: 7px;
  padding-bottom: 7px;
  margin-bottom: 0;
}
.form-control-static.input-lg,
.form-control-static.input-sm {
  padding-right: 0;
  padding-left: 0;
}
.input-sm {
  height: 30px;
  padding: 5px 10px;
  font-size: 12px;
  line-height: 1.5;
  border-radius: 1px;
}
select.input-sm {
  height: 30px;
  line-height: 30px;
}
textarea.input-sm,
select[multiple].input-sm {
  height: auto;
}
.form-group-sm .form-control {
  height: 30px;
  padding: 5px 10px;
  font-size: 12px;
  line-height: 1.5;
  border-radius: 1px;
}
.form-group-sm select.form-control {
  height: 30px;
  line-height: 30px;
}
.form-group-sm textarea.form-control,
.form-group-sm select[multiple].form-control {
  height: auto;
}
.form-group-sm .form-control-static {
  height: 30px;
  min-height: 30px;
  padding: 6px 10px;
  font-size: 12px;
  line-height: 1.5;
}
.input-lg {
  height: 45px;
  padding: 10px 16px;
  font-size: 17px;
  line-height: 1.3333333;
  border-radius: 3px;
}
select.input-lg {
  height: 45px;
  line-height: 45px;
}
textarea.input-lg,
select[multiple].input-lg {
  height: auto;
}
.form-group-lg .form-control {
  height: 45px;
  padding: 10px 16px;
  font-size: 17px;
  line-height: 1.3333333;
  border-radius: 3px;
}
.form-group-lg select.form-control {
  height: 45px;
  line-height: 45px;
}
.form-group-lg textarea.form-control,
.form-group-lg select[multiple].form-control {
  height: auto;
}
.form-group-lg .form-control-static {
  height: 45px;
  min-height: 35px;
  padding: 11px 16px;
  font-size: 17px;
  line-height: 1.3333333;
}
.has-feedback {
  position: relative;
}
.has-feedback .form-control {
  padding-right: 40px;
}
.form-control-feedback {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 2;
  display: block;
  width: 32px;
  height: 32px;
  line-height: 32px;
  text-align: center;
  pointer-events: none;
}
.input-lg + .form-control-feedback,
.input-group-lg + .form-control-feedback,
.form-group-lg .form-control + .form-control-feedback {
  width: 45px;
  height: 45px;
  line-height: 45px;
}
.input-sm + .form-control-feedback,
.input-group-sm + .form-control-feedback,
.form-group-sm .form-control + .form-control-feedback {
  width: 30px;
  height: 30px;
  line-height: 30px;
}
.has-success .help-block,
.has-success .control-label,
.has-success .radio,
.has-success .checkbox,
.has-success .radio-inline,
.has-success .checkbox-inline,
.has-success.radio label,
.has-success.checkbox label,
.has-success.radio-inline label,
.has-success.checkbox-inline label {
  color: #3c763d;
}
.has-success .form-control {
  border-color: #3c763d;
  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
}
.has-success .form-control:focus {
  border-color: #2b542c;
  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 6px #67b168;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 6px #67b168;
}
.has-success .input-group-addon {
  color: #3c763d;
  background-color: #dff0d8;
  border-color: #3c763d;
}
.has-success .form-control-feedback {
  color: #3c763d;
}
.has-warning .help-block,
.has-warning .control-label,
.has-warning .radio,
.has-warning .checkbox,
.has-warning .radio-inline,
.has-warning .checkbox-inline,
.has-warning.radio label,
.has-warning.checkbox label,
.has-warning.radio-inline label,
.has-warning.checkbox-inline label {
  color: #8a6d3b;
}
.has-warning .form-control {
  border-color: #8a6d3b;
  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
}
.has-warning .form-control:focus {
  border-color: #66512c;
  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 6px #c0a16b;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 6px #c0a16b;
}
.has-warning .input-group-addon {
  color: #8a6d3b;
  background-color: #fcf8e3;
  border-color: #8a6d3b;
}
.has-warning .form-control-feedback {
  color: #8a6d3b;
}
.has-error .help-block,
.has-error .control-label,
.has-error .radio,
.has-error .checkbox,
.has-error .radio-inline,
.has-error .checkbox-inline,
.has-error.radio label,
.has-error.checkbox label,
.has-error.radio-inline label,
.has-error.checkbox-inline label {
  color: #a94442;
}
.has-error .form-control {
  border-color: #a94442;
  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
}
.has-error .form-control:focus {
  border-color: #843534;
  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 6px #ce8483;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 6px #ce8483;
}
.has-error .input-group-addon {
  color: #a94442;
  background-color: #f2dede;
  border-color: #a94442;
}
.has-error .form-control-feedback {
  color: #a94442;
}
.has-feedback label ~ .form-control-feedback {
  top: 23px;
}
.has-feedback label.sr-only ~ .form-control-feedback {
  top: 0;
}
.help-block {
  display: block;
  margin-top: 5px;
  margin-bottom: 10px;
  color: #404040;
}
@media (min-width: 768px) {
  .form-inline .form-group {
    display: inline-block;
    margin-bottom: 0;
    vertical-align: middle;
  }
  .form-inline .form-control {
    display: inline-block;
    width: auto;
    vertical-align: middle;
  }
  .form-inline .form-control-static {
    display: inline-block;
  }
  .form-inline .input-group {
    display: inline-table;
    vertical-align: middle;
  }
  .form-inline .input-group .input-group-addon,
  .form-inline .input-group .input-group-btn,
  .form-inline .input-group .form-control {
    width: auto;
  }
  .form-inline .input-group > .form-control {
    width: 100%;
  }
  .form-inline .control-label {
    margin-bottom: 0;
    vertical-align: middle;
  }
  .form-inline .radio,
  .form-inline .checkbox {
    display: inline-block;
    margin-top: 0;
    margin-bottom: 0;
    vertical-align: middle;
  }
  .form-inline .radio label,
  .form-inline .checkbox label {
    padding-left: 0;
  }
  .form-inline .radio input[type="radio"],
  .form-inline .checkbox input[type="checkbox"] {
    position: relative;
    margin-left: 0;
  }
  .form-inline .has-feedback .form-control-feedback {
    top: 0;
  }
}
.form-horizontal .radio,
.form-horizontal .checkbox,
.form-horizontal .radio-inline,
.form-horizontal .checkbox-inline {
  padding-top: 7px;
  margin-top: 0;
  margin-bottom: 0;
}
.form-horizontal .radio,
.form-horizontal .checkbox {
  min-height: 25px;
}
.form-horizontal .form-group {
  margin-right: 0px;
  margin-left: 0px;
}
@media (min-width: 768px) {
  .form-horizontal .control-label {
    padding-top: 7px;
    margin-bottom: 0;
    text-align: right;
  }
}
.form-horizontal .has-feedback .form-control-feedback {
  right: 0px;
}
@media (min-width: 768px) {
  .form-horizontal .form-group-lg .control-label {
    padding-top: 11px;
    font-size: 17px;
  }
}
@media (min-width: 768px) {
  .form-horizontal .form-group-sm .control-label {
    padding-top: 6px;
    font-size: 12px;
  }
}
.btn {
  display: inline-block;
  margin-bottom: 0;
  font-weight: normal;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  touch-action: manipulation;
  cursor: pointer;
  background-image: none;
  border: 1px solid transparent;
  padding: 6px 12px;
  font-size: 13px;
  line-height: 1.42857143;
  border-radius: 2px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.btn:focus,
.btn:active:focus,
.btn.active:focus,
.btn.focus,
.btn:active.focus,
.btn.active.focus {
  outline: 5px auto -webkit-focus-ring-color;
  outline-offset: -2px;
}
.btn:hover,
.btn:focus,
.btn.focus {
  color: #333;
  text-decoration: none;
}
.btn:active,
.btn.active {
  background-image: none;
  outline: 0;
  -webkit-box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
}
.btn.disabled,
.btn[disabled],
fieldset[disabled] .btn {
  cursor: not-allowed;
  filter: alpha(opacity=65);
  opacity: 0.65;
  -webkit-box-shadow: none;
  box-shadow: none;
}
a.btn.disabled,
fieldset[disabled] a.btn {
  pointer-events: none;
}
.btn-default {
  color: #333;
  background-color: #fff;
  border-color: #ccc;
}
.btn-default:focus,
.btn-default.focus {
  color: #333;
  background-color: #e6e6e6;
  border-color: #8c8c8c;
}
.btn-default:hover {
  color: #333;
  background-color: #e6e6e6;
  border-color: #adadad;
}
.btn-default:active,
.btn-default.active,
.open > .dropdown-toggle.btn-default {
  color: #333;
  background-color: #e6e6e6;
  background-image: none;
  border-color: #adadad;
}
.btn-default:active:hover,
.btn-default.active:hover,
.open > .dropdown-toggle.btn-default:hover,
.btn-default:active:focus,
.btn-default.active:focus,
.open > .dropdown-toggle.btn-default:focus,
.btn-default:active.focus,
.btn-default.active.focus,
.open > .dropdown-toggle.btn-default.focus {
  color: #333;
  background-color: #d4d4d4;
  border-color: #8c8c8c;
}
.btn-default.disabled:hover,
.btn-default[disabled]:hover,
fieldset[disabled] .btn-default:hover,
.btn-default.disabled:focus,
.btn-default[disabled]:focus,
fieldset[disabled] .btn-default:focus,
.btn-default.disabled.focus,
.btn-default[disabled].focus,
fieldset[disabled] .btn-default.focus {
  background-color: #fff;
  border-color: #ccc;
}
.btn-default .badge {
  color: #fff;
  background-color: #333;
}
.btn-primary {
  color: #fff;
  background-color: #337ab7;
  border-color: #2e6da4;
}
.btn-primary:focus,
.btn-primary.focus {
  color: #fff;
  background-color: #286090;
  border-color: #122b40;
}
.btn-primary:hover {
  color: #fff;
  background-color: #286090;
  border-color: #204d74;
}
.btn-primary:active,
.btn-primary.active,
.open > .dropdown-toggle.btn-primary {
  color: #fff;
  background-color: #286090;
  background-image: none;
  border-color: #204d74;
}
.btn-primary:active:hover,
.btn-primary.active:hover,
.open > .dropdown-toggle.btn-primary:hover,
.btn-primary:active:focus,
.btn-primary.active:focus,
.open > .dropdown-toggle.btn-primary:focus,
.btn-primary:active.focus,
.btn-primary.active.focus,
.open > .dropdown-toggle.btn-primary.focus {
  color: #fff;
  background-color: #204d74;
  border-color: #122b40;
}
.btn-primary.disabled:hover,
.btn-primary[disabled]:hover,
fieldset[disabled] .btn-primary:hover,
.btn-primary.disabled:focus,
.btn-primary[disabled]:focus,
fieldset[disabled] .btn-primary:focus,
.btn-primary.disabled.focus,
.btn-primary[disabled].focus,
fieldset[disabled] .btn-primary.focus {
  background-color: #337ab7;
  border-color: #2e6da4;
}
.btn-primary .badge {
  color: #337ab7;
  background-color: #fff;
}
.btn-success {
  color: #fff;
  background-color: #5cb85c;
  border-color: #4cae4c;
}
.btn-success:focus,
.btn-success.focus {
  color: #fff;
  background-color: #449d44;
  border-color: #255625;
}
.btn-success:hover {
  color: #fff;
  background-color: #449d44;
  border-color: #398439;
}
.btn-success:active,
.btn-success.active,
.open > .dropdown-toggle.btn-success {
  color: #fff;
  background-color: #449d44;
  background-image: none;
  border-color: #398439;
}
.btn-success:active:hover,
.btn-success.active:hover,
.open > .dropdown-toggle.btn-success:hover,
.btn-success:active:focus,
.btn-success.active:focus,
.open > .dropdown-toggle.btn-success:focus,
.btn-success:active.focus,
.btn-success.active.focus,
.open > .dropdown-toggle.btn-success.focus {
  color: #fff;
  background-color: #398439;
  border-color: #255625;
}
.btn-success.disabled:hover,
.btn-success[disabled]:hover,
fieldset[disabled] .btn-success:hover,
.btn-success.disabled:focus,
.btn-success[disabled]:focus,
fieldset[disabled] .btn-success:focus,
.btn-success.disabled.focus,
.btn-success[disabled].focus,
fieldset[disabled] .btn-success.focus {
  background-color: #5cb85c;
  border-color: #4cae4c;
}
.btn-success .badge {
  color: #5cb85c;
  background-color: #fff;
}
.btn-info {
  color: #fff;
  background-color: #5bc0de;
  border-color: #46b8da;
}
.btn-info:focus,
.btn-info.focus {
  color: #fff;
  background-color: #31b0d5;
  border-color: #1b6d85;
}
.btn-info:hover {
  color: #fff;
  background-color: #31b0d5;
  border-color: #269abc;
}
.btn-info:active,
.btn-info.active,
.open > .dropdown-toggle.btn-info {
  color: #fff;
  background-color: #31b0d5;
  background-image: none;
  border-color: #269abc;
}
.btn-info:active:hover,
.btn-info.active:hover,
.open > .dropdown-toggle.btn-info:hover,
.btn-info:active:focus,
.btn-info.active:focus,
.open > .dropdown-toggle.btn-info:focus,
.btn-info:active.focus,
.btn-info.active.focus,
.open > .dropdown-toggle.btn-info.focus {
  color: #fff;
  background-color: #269abc;
  border-color: #1b6d85;
}
.btn-info.disabled:hover,
.btn-info[disabled]:hover,
fieldset[disabled] .btn-info:hover,
.btn-info.disabled:focus,
.btn-info[disabled]:focus,
fieldset[disabled] .btn-info:focus,
.btn-info.disabled.focus,
.btn-info[disabled].focus,
fieldset[disabled] .btn-info.focus {
  background-color: #5bc0de;
  border-color: #46b8da;
}
.btn-info .badge {
  color: #5bc0de;
  background-color: #fff;
}
.btn-warning {
  color: #fff;
  background-color: #f0ad4e;
  border-color: #eea236;
}
.btn-warning:focus,
.btn-warning.focus {
  color: #fff;
  background-color: #ec971f;
  border-color: #985f0d;
}
.btn-warning:hover {
  color: #fff;
  background-color: #ec971f;
  border-color: #d58512;
}
.btn-warning:active,
.btn-warning.active,
.open > .dropdown-toggle.btn-warning {
  color: #fff;
  background-color: #ec971f;
  background-image: none;
  border-color: #d58512;
}
.btn-warning:active:hover,
.btn-warning.active:hover,
.open > .dropdown-toggle.btn-warning:hover,
.btn-warning:active:focus,
.btn-warning.active:focus,
.open > .dropdown-toggle.btn-warning:focus,
.btn-warning:active.focus,
.btn-warning.active.focus,
.open > .dropdown-toggle.btn-warning.focus {
  color: #fff;
  background-color: #d58512;
  border-color: #985f0d;
}
.btn-warning.disabled:hover,
.btn-warning[disabled]:hover,
fieldset[disabled] .btn-warning:hover,
.btn-warning.disabled:focus,
.btn-warning[disabled]:focus,
fieldset[disabled] .btn-warning:focus,
.btn-warning.disabled.focus,
.btn-warning[disabled].focus,
fieldset[disabled] .btn-warning.focus {
  background-color: #f0ad4e;
  border-color: #eea236;
}
.btn-warning .badge {
  color: #f0ad4e;
  background-color: #fff;
}
.btn-danger {
  color: #fff;
  background-color: #d9534f;
  border-color: #d43f3a;
}
.btn-danger:focus,
.btn-danger.focus {
  color: #fff;
  background-color: #c9302c;
  border-color: #761c19;
}
.btn-danger:hover {
  color: #fff;
  background-color: #c9302c;
  border-color: #ac2925;
}
.btn-danger:active,
.btn-danger.active,
.open > .dropdown-toggle.btn-danger {
  color: #fff;
  background-color: #c9302c;
  background-image: none;
  border-color: #ac2925;
}
.btn-danger:active:hover,
.btn-danger.active:hover,
.open > .dropdown-toggle.btn-danger:hover,
.btn-danger:active:focus,
.btn-danger.active:focus,
.open > .dropdown-toggle.btn-danger:focus,
.btn-danger:active.focus,
.btn-danger.active.focus,
.open > .dropdown-toggle.btn-danger.focus {
  color: #fff;
  background-color: #ac2925;
  border-color: #761c19;
}
.btn-danger.disabled:hover,
.btn-danger[disabled]:hover,
fieldset[disabled] .btn-danger:hover,
.btn-danger.disabled:focus,
.btn-danger[disabled]:focus,
fieldset[disabled] .btn-danger:focus,
.btn-danger.disabled.focus,
.btn-danger[disabled].focus,
fieldset[disabled] .btn-danger.focus {
  background-color: #d9534f;
  border-color: #d43f3a;
}
.btn-danger .badge {
  color: #d9534f;
  background-color: #fff;
}
.btn-link {
  font-weight: 400;
  color: #296eaa;
  border-radius: 0;
}
.btn-link,
.btn-link:active,
.btn-link.active,
.btn-link[disabled],
fieldset[disabled] .btn-link {
  background-color: transparent;
  -webkit-box-shadow: none;
  box-shadow: none;
}
.btn-link,
.btn-link:hover,
.btn-link:focus,
.btn-link:active {
  border-color: transparent;
}
.btn-link:hover,
.btn-link:focus {
  color: #1a466c;
  text-decoration: underline;
  background-color: transparent;
}
.btn-link[disabled]:hover,
fieldset[disabled] .btn-link:hover,
.btn-link[disabled]:focus,
fieldset[disabled] .btn-link:focus {
  color: #777777;
  text-decoration: none;
}
.btn-lg,
.btn-group-lg > .btn {
  padding: 10px 16px;
  font-size: 17px;
  line-height: 1.3333333;
  border-radius: 3px;
}
.btn-sm,
.btn-group-sm > .btn {
  padding: 5px 10px;
  font-size: 12px;
  line-height: 1.5;
  border-radius: 1px;
}
.btn-xs,
.btn-group-xs > .btn {
  padding: 1px 5px;
  font-size: 12px;
  line-height: 1.5;
  border-radius: 1px;
}
.btn-block {
  display: block;
  width: 100%;
}
.btn-block + .btn-block {
  margin-top: 5px;
}
input[type="submit"].btn-block,
input[type="reset"].btn-block,
input[type="button"].btn-block {
  width: 100%;
}
.fade {
  opacity: 0;
  -webkit-transition: opacity 0.15s linear;
  -o-transition: opacity 0.15s linear;
  transition: opacity 0.15s linear;
}
.fade.in {
  opacity: 1;
}
.collapse {
  display: none;
}
.collapse.in {
  display: block;
}
tr.collapse.in {
  display: table-row;
}
tbody.collapse.in {
  display: table-row-group;
}
.collapsing {
  position: relative;
  height: 0;
  overflow: hidden;
  -webkit-transition-property: height, visibility;
  transition-property: height, visibility;
  -webkit-transition-duration: 0.35s;
  transition-duration: 0.35s;
  -webkit-transition-timing-function: ease;
  transition-timing-function: ease;
}
.caret {
  display: inline-block;
  width: 0;
  height: 0;
  margin-left: 2px;
  vertical-align: middle;
  border-top: 4px dashed;
  border-top: 4px solid \\9;
  border-right: 4px solid transparent;
  border-left: 4px solid transparent;
}
.dropup,
.dropdown {
  position: relative;
}
.dropdown-toggle:focus {
  outline: 0;
}
.dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 1000;
  display: none;
  float: left;
  min-width: 160px;
  padding: 5px 0;
  margin: 2px 0 0;
  font-size: 13px;
  text-align: left;
  list-style: none;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ccc;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 2px;
  -webkit-box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);
}
.dropdown-menu.pull-right {
  right: 0;
  left: auto;
}
.dropdown-menu .divider {
  height: 1px;
  margin: 8px 0;
  overflow: hidden;
  background-color: #e5e5e5;
}
.dropdown-menu > li > a {
  display: block;
  padding: 3px 20px;
  clear: both;
  font-weight: 400;
  line-height: 1.42857143;
  color: #333333;
  white-space: nowrap;
}
.dropdown-menu > li > a:hover,
.dropdown-menu > li > a:focus {
  color: #262626;
  text-decoration: none;
  background-color: #f5f5f5;
}
.dropdown-menu > .active > a,
.dropdown-menu > .active > a:hover,
.dropdown-menu > .active > a:focus {
  color: #fff;
  text-decoration: none;
  background-color: #337ab7;
  outline: 0;
}
.dropdown-menu > .disabled > a,
.dropdown-menu > .disabled > a:hover,
.dropdown-menu > .disabled > a:focus {
  color: #777777;
}
.dropdown-menu > .disabled > a:hover,
.dropdown-menu > .disabled > a:focus {
  text-decoration: none;
  cursor: not-allowed;
  background-color: transparent;
  background-image: none;
  filter: progid:DXImageTransform.Microsoft.gradient(enabled = false);
}
.open > .dropdown-menu {
  display: block;
}
.open > a {
  outline: 0;
}
.dropdown-menu-right {
  right: 0;
  left: auto;
}
.dropdown-menu-left {
  right: auto;
  left: 0;
}
.dropdown-header {
  display: block;
  padding: 3px 20px;
  font-size: 12px;
  line-height: 1.42857143;
  color: #777777;
  white-space: nowrap;
}
.dropdown-backdrop {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 990;
}
.pull-right > .dropdown-menu {
  right: 0;
  left: auto;
}
.dropup .caret,
.navbar-fixed-bottom .dropdown .caret {
  content: "";
  border-top: 0;
  border-bottom: 4px dashed;
  border-bottom: 4px solid \\9;
}
.dropup .dropdown-menu,
.navbar-fixed-bottom .dropdown .dropdown-menu {
  top: auto;
  bottom: 100%;
  margin-bottom: 2px;
}
@media (min-width: 541px) {
  .navbar-right .dropdown-menu {
    right: 0;
    left: auto;
  }
  .navbar-right .dropdown-menu-left {
    right: auto;
    left: 0;
  }
}
.btn-group,
.btn-group-vertical {
  position: relative;
  display: inline-block;
  vertical-align: middle;
}
.btn-group > .btn,
.btn-group-vertical > .btn {
  position: relative;
  float: left;
}
.btn-group > .btn:hover,
.btn-group-vertical > .btn:hover,
.btn-group > .btn:focus,
.btn-group-vertical > .btn:focus,
.btn-group > .btn:active,
.btn-group-vertical > .btn:active,
.btn-group > .btn.active,
.btn-group-vertical > .btn.active {
  z-index: 2;
}
.btn-group .btn + .btn,
.btn-group .btn + .btn-group,
.btn-group .btn-group + .btn,
.btn-group .btn-group + .btn-group {
  margin-left: -1px;
}
.btn-toolbar {
  margin-left: -5px;
}
.btn-toolbar .btn,
.btn-toolbar .btn-group,
.btn-toolbar .input-group {
  float: left;
}
.btn-toolbar > .btn,
.btn-toolbar > .btn-group,
.btn-toolbar > .input-group {
  margin-left: 5px;
}
.btn-group > .btn:not(:first-child):not(:last-child):not(.dropdown-toggle) {
  border-radius: 0;
}
.btn-group > .btn:first-child {
  margin-left: 0;
}
.btn-group > .btn:first-child:not(:last-child):not(.dropdown-toggle) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.btn-group > .btn:last-child:not(:first-child),
.btn-group > .dropdown-toggle:not(:first-child) {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.btn-group > .btn-group {
  float: left;
}
.btn-group > .btn-group:not(:first-child):not(:last-child) > .btn {
  border-radius: 0;
}
.btn-group > .btn-group:first-child:not(:last-child) > .btn:last-child,
.btn-group > .btn-group:first-child:not(:last-child) > .dropdown-toggle {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.btn-group > .btn-group:last-child:not(:first-child) > .btn:first-child {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.btn-group .dropdown-toggle:active,
.btn-group.open .dropdown-toggle {
  outline: 0;
}
.btn-group > .btn + .dropdown-toggle {
  padding-right: 8px;
  padding-left: 8px;
}
.btn-group > .btn-lg + .dropdown-toggle {
  padding-right: 12px;
  padding-left: 12px;
}
.btn-group.open .dropdown-toggle {
  -webkit-box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
}
.btn-group.open .dropdown-toggle.btn-link {
  -webkit-box-shadow: none;
  box-shadow: none;
}
.btn .caret {
  margin-left: 0;
}
.btn-lg .caret {
  border-width: 5px 5px 0;
  border-bottom-width: 0;
}
.dropup .btn-lg .caret {
  border-width: 0 5px 5px;
}
.btn-group-vertical > .btn,
.btn-group-vertical > .btn-group,
.btn-group-vertical > .btn-group > .btn {
  display: block;
  float: none;
  width: 100%;
  max-width: 100%;
}
.btn-group-vertical > .btn-group > .btn {
  float: none;
}
.btn-group-vertical > .btn + .btn,
.btn-group-vertical > .btn + .btn-group,
.btn-group-vertical > .btn-group + .btn,
.btn-group-vertical > .btn-group + .btn-group {
  margin-top: -1px;
  margin-left: 0;
}
.btn-group-vertical > .btn:not(:first-child):not(:last-child) {
  border-radius: 0;
}
.btn-group-vertical > .btn:first-child:not(:last-child) {
  border-top-left-radius: 2px;
  border-top-right-radius: 2px;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.btn-group-vertical > .btn:last-child:not(:first-child) {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  border-bottom-right-radius: 2px;
  border-bottom-left-radius: 2px;
}
.btn-group-vertical > .btn-group:not(:first-child):not(:last-child) > .btn {
  border-radius: 0;
}
.btn-group-vertical > .btn-group:first-child:not(:last-child) > .btn:last-child,
.btn-group-vertical > .btn-group:first-child:not(:last-child) > .dropdown-toggle {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.btn-group-vertical > .btn-group:last-child:not(:first-child) > .btn:first-child {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
.btn-group-justified {
  display: table;
  width: 100%;
  table-layout: fixed;
  border-collapse: separate;
}
.btn-group-justified > .btn,
.btn-group-justified > .btn-group {
  display: table-cell;
  float: none;
  width: 1%;
}
.btn-group-justified > .btn-group .btn {
  width: 100%;
}
.btn-group-justified > .btn-group .dropdown-menu {
  left: auto;
}
[data-toggle="buttons"] > .btn input[type="radio"],
[data-toggle="buttons"] > .btn-group > .btn input[type="radio"],
[data-toggle="buttons"] > .btn input[type="checkbox"],
[data-toggle="buttons"] > .btn-group > .btn input[type="checkbox"] {
  position: absolute;
  clip: rect(0, 0, 0, 0);
  pointer-events: none;
}
.input-group {
  position: relative;
  display: table;
  border-collapse: separate;
}
.input-group[class*="col-"] {
  float: none;
  padding-right: 0;
  padding-left: 0;
}
.input-group .form-control {
  position: relative;
  z-index: 2;
  float: left;
  width: 100%;
  margin-bottom: 0;
}
.input-group .form-control:focus {
  z-index: 3;
}
.input-group-lg > .form-control,
.input-group-lg > .input-group-addon,
.input-group-lg > .input-group-btn > .btn {
  height: 45px;
  padding: 10px 16px;
  font-size: 17px;
  line-height: 1.3333333;
  border-radius: 3px;
}
select.input-group-lg > .form-control,
select.input-group-lg > .input-group-addon,
select.input-group-lg > .input-group-btn > .btn {
  height: 45px;
  line-height: 45px;
}
textarea.input-group-lg > .form-control,
textarea.input-group-lg > .input-group-addon,
textarea.input-group-lg > .input-group-btn > .btn,
select[multiple].input-group-lg > .form-control,
select[multiple].input-group-lg > .input-group-addon,
select[multiple].input-group-lg > .input-group-btn > .btn {
  height: auto;
}
.input-group-sm > .form-control,
.input-group-sm > .input-group-addon,
.input-group-sm > .input-group-btn > .btn {
  height: 30px;
  padding: 5px 10px;
  font-size: 12px;
  line-height: 1.5;
  border-radius: 1px;
}
select.input-group-sm > .form-control,
select.input-group-sm > .input-group-addon,
select.input-group-sm > .input-group-btn > .btn {
  height: 30px;
  line-height: 30px;
}
textarea.input-group-sm > .form-control,
textarea.input-group-sm > .input-group-addon,
textarea.input-group-sm > .input-group-btn > .btn,
select[multiple].input-group-sm > .form-control,
select[multiple].input-group-sm > .input-group-addon,
select[multiple].input-group-sm > .input-group-btn > .btn {
  height: auto;
}
.input-group-addon,
.input-group-btn,
.input-group .form-control {
  display: table-cell;
}
.input-group-addon:not(:first-child):not(:last-child),
.input-group-btn:not(:first-child):not(:last-child),
.input-group .form-control:not(:first-child):not(:last-child) {
  border-radius: 0;
}
.input-group-addon,
.input-group-btn {
  width: 1%;
  white-space: nowrap;
  vertical-align: middle;
}
.input-group-addon {
  padding: 6px 12px;
  font-size: 13px;
  font-weight: 400;
  line-height: 1;
  color: #555555;
  text-align: center;
  background-color: #eeeeee;
  border: 1px solid #ccc;
  border-radius: 2px;
}
.input-group-addon.input-sm {
  padding: 5px 10px;
  font-size: 12px;
  border-radius: 1px;
}
.input-group-addon.input-lg {
  padding: 10px 16px;
  font-size: 17px;
  border-radius: 3px;
}
.input-group-addon input[type="radio"],
.input-group-addon input[type="checkbox"] {
  margin-top: 0;
}
.input-group .form-control:first-child,
.input-group-addon:first-child,
.input-group-btn:first-child > .btn,
.input-group-btn:first-child > .btn-group > .btn,
.input-group-btn:first-child > .dropdown-toggle,
.input-group-btn:last-child > .btn:not(:last-child):not(.dropdown-toggle),
.input-group-btn:last-child > .btn-group:not(:last-child) > .btn {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.input-group-addon:first-child {
  border-right: 0;
}
.input-group .form-control:last-child,
.input-group-addon:last-child,
.input-group-btn:last-child > .btn,
.input-group-btn:last-child > .btn-group > .btn,
.input-group-btn:last-child > .dropdown-toggle,
.input-group-btn:first-child > .btn:not(:first-child),
.input-group-btn:first-child > .btn-group:not(:first-child) > .btn {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.input-group-addon:last-child {
  border-left: 0;
}
.input-group-btn {
  position: relative;
  font-size: 0;
  white-space: nowrap;
}
.input-group-btn > .btn {
  position: relative;
}
.input-group-btn > .btn + .btn {
  margin-left: -1px;
}
.input-group-btn > .btn:hover,
.input-group-btn > .btn:focus,
.input-group-btn > .btn:active {
  z-index: 2;
}
.input-group-btn:first-child > .btn,
.input-group-btn:first-child > .btn-group {
  margin-right: -1px;
}
.input-group-btn:last-child > .btn,
.input-group-btn:last-child > .btn-group {
  z-index: 2;
  margin-left: -1px;
}
.nav {
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}
.nav > li {
  position: relative;
  display: block;
}
.nav > li > a {
  position: relative;
  display: block;
  padding: 10px 15px;
}
.nav > li > a:hover,
.nav > li > a:focus {
  text-decoration: none;
  background-color: #eeeeee;
}
.nav > li.disabled > a {
  color: #777777;
}
.nav > li.disabled > a:hover,
.nav > li.disabled > a:focus {
  color: #777777;
  text-decoration: none;
  cursor: not-allowed;
  background-color: transparent;
}
.nav .open > a,
.nav .open > a:hover,
.nav .open > a:focus {
  background-color: #eeeeee;
  border-color: #296eaa;
}
.nav .nav-divider {
  height: 1px;
  margin: 8px 0;
  overflow: hidden;
  background-color: #e5e5e5;
}
.nav > li > a > img {
  max-width: none;
}
.nav-tabs {
  border-bottom: 1px solid #ddd;
}
.nav-tabs > li {
  float: left;
  margin-bottom: -1px;
}
.nav-tabs > li > a {
  margin-right: 2px;
  line-height: 1.42857143;
  border: 1px solid transparent;
  border-radius: 2px 2px 0 0;
}
.nav-tabs > li > a:hover {
  border-color: #eeeeee #eeeeee #ddd;
}
.nav-tabs > li.active > a,
.nav-tabs > li.active > a:hover,
.nav-tabs > li.active > a:focus {
  color: #555555;
  cursor: default;
  background-color: var(--body-bg);
  border: 1px solid #ddd;
  border-bottom-color: transparent;
}
.nav-tabs.nav-justified {
  width: 100%;
  border-bottom: 0;
}
.nav-tabs.nav-justified > li {
  float: none;
}
.nav-tabs.nav-justified > li > a {
  margin-bottom: 5px;
  text-align: center;
}
.nav-tabs.nav-justified > .dropdown .dropdown-menu {
  top: auto;
  left: auto;
}
@media (min-width: 768px) {
  .nav-tabs.nav-justified > li {
    display: table-cell;
    width: 1%;
  }
  .nav-tabs.nav-justified > li > a {
    margin-bottom: 0;
  }
}
.nav-tabs.nav-justified > li > a {
  margin-right: 0;
  border-radius: 2px;
}
.nav-tabs.nav-justified > .active > a,
.nav-tabs.nav-justified > .active > a:hover,
.nav-tabs.nav-justified > .active > a:focus {
  border: 1px solid #ddd;
}
@media (min-width: 768px) {
  .nav-tabs.nav-justified > li > a {
    border-bottom: 1px solid #ddd;
    border-radius: 2px 2px 0 0;
  }
  .nav-tabs.nav-justified > .active > a,
  .nav-tabs.nav-justified > .active > a:hover,
  .nav-tabs.nav-justified > .active > a:focus {
    border-bottom-color: var(--body-bg);
  }
}
.nav-pills > li {
  float: left;
}
.nav-pills > li > a {
  border-radius: 2px;
}
.nav-pills > li + li {
  margin-left: 2px;
}
.nav-pills > li.active > a,
.nav-pills > li.active > a:hover,
.nav-pills > li.active > a:focus {
  color: #fff;
  background-color: #337ab7;
}
.nav-stacked > li {
  float: none;
}
.nav-stacked > li + li {
  margin-top: 2px;
  margin-left: 0;
}
.nav-justified {
  width: 100%;
}
.nav-justified > li {
  float: none;
}
.nav-justified > li > a {
  margin-bottom: 5px;
  text-align: center;
}
.nav-justified > .dropdown .dropdown-menu {
  top: auto;
  left: auto;
}
@media (min-width: 768px) {
  .nav-justified > li {
    display: table-cell;
    width: 1%;
  }
  .nav-justified > li > a {
    margin-bottom: 0;
  }
}
.nav-tabs-justified {
  border-bottom: 0;
}
.nav-tabs-justified > li > a {
  margin-right: 0;
  border-radius: 2px;
}
.nav-tabs-justified > .active > a,
.nav-tabs-justified > .active > a:hover,
.nav-tabs-justified > .active > a:focus {
  border: 1px solid #ddd;
}
@media (min-width: 768px) {
  .nav-tabs-justified > li > a {
    border-bottom: 1px solid #ddd;
    border-radius: 2px 2px 0 0;
  }
  .nav-tabs-justified > .active > a,
  .nav-tabs-justified > .active > a:hover,
  .nav-tabs-justified > .active > a:focus {
    border-bottom-color: var(--body-bg);
  }
}
.tab-content > .tab-pane {
  display: none;
}
.tab-content > .active {
  display: block;
}
.nav-tabs .dropdown-menu {
  margin-top: -1px;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
.navbar {
  position: relative;
  min-height: 30px;
  margin-bottom: 18px;
  border: 1px solid transparent;
}
@media (min-width: 541px) {
  .navbar {
    border-radius: 2px;
  }
}
@media (min-width: 541px) {
  .navbar-header {
    float: left;
  }
}
.navbar-collapse {
  padding-right: 0px;
  padding-left: 0px;
  overflow-x: visible;
  border-top: 1px solid transparent;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.1);
  -webkit-overflow-scrolling: touch;
}
.navbar-collapse.in {
  overflow-y: auto;
}
@media (min-width: 541px) {
  .navbar-collapse {
    width: auto;
    border-top: 0;
    box-shadow: none;
  }
  .navbar-collapse.collapse {
    display: block !important;
    height: auto !important;
    padding-bottom: 0;
    overflow: visible !important;
  }
  .navbar-collapse.in {
    overflow-y: visible;
  }
  .navbar-fixed-top .navbar-collapse,
  .navbar-static-top .navbar-collapse,
  .navbar-fixed-bottom .navbar-collapse {
    padding-right: 0;
    padding-left: 0;
  }
}
.navbar-fixed-top,
.navbar-fixed-bottom {
  position: fixed;
  right: 0;
  left: 0;
  z-index: 1030;
}
.navbar-fixed-top .navbar-collapse,
.navbar-fixed-bottom .navbar-collapse {
  max-height: 340px;
}
@media (max-device-width: 540px) and (orientation: landscape) {
  .navbar-fixed-top .navbar-collapse,
  .navbar-fixed-bottom .navbar-collapse {
    max-height: 200px;
  }
}
@media (min-width: 541px) {
  .navbar-fixed-top,
  .navbar-fixed-bottom {
    border-radius: 0;
  }
}
.navbar-fixed-top {
  top: 0;
  border-width: 0 0 1px;
}
.navbar-fixed-bottom {
  bottom: 0;
  margin-bottom: 0;
  border-width: 1px 0 0;
}
.container > .navbar-header,
.container-fluid > .navbar-header,
.container > .navbar-collapse,
.container-fluid > .navbar-collapse {
  margin-right: 0px;
  margin-left: 0px;
}
@media (min-width: 541px) {
  .container > .navbar-header,
  .container-fluid > .navbar-header,
  .container > .navbar-collapse,
  .container-fluid > .navbar-collapse {
    margin-right: 0;
    margin-left: 0;
  }
}
.navbar-static-top {
  z-index: 1000;
  border-width: 0 0 1px;
}
@media (min-width: 541px) {
  .navbar-static-top {
    border-radius: 0;
  }
}
.navbar-brand {
  float: left;
  height: 30px;
  padding: 6px 0px;
  font-size: 17px;
  line-height: 18px;
}
.navbar-brand:hover,
.navbar-brand:focus {
  text-decoration: none;
}
.navbar-brand > img {
  display: block;
}
@media (min-width: 541px) {
  .navbar > .container .navbar-brand,
  .navbar > .container-fluid .navbar-brand {
    margin-left: 0px;
  }
}
.navbar-toggle {
  position: relative;
  float: right;
  padding: 9px 10px;
  margin-right: 0px;
  margin-top: -2px;
  margin-bottom: -2px;
  background-color: transparent;
  background-image: none;
  border: 1px solid transparent;
  border-radius: 2px;
}
.navbar-toggle:focus {
  outline: 0;
}
.navbar-toggle .icon-bar {
  display: block;
  width: 22px;
  height: 2px;
  border-radius: 1px;
}
.navbar-toggle .icon-bar + .icon-bar {
  margin-top: 4px;
}
@media (min-width: 541px) {
  .navbar-toggle {
    display: none;
  }
}
.navbar-nav {
  margin: 3px 0px;
}
.navbar-nav > li > a {
  padding-top: 10px;
  padding-bottom: 10px;
  line-height: 18px;
}
@media (max-width: 540px) {
  .navbar-nav .open .dropdown-menu {
    position: static;
    float: none;
    width: auto;
    margin-top: 0;
    background-color: transparent;
    border: 0;
    box-shadow: none;
  }
  .navbar-nav .open .dropdown-menu > li > a,
  .navbar-nav .open .dropdown-menu .dropdown-header {
    padding: 5px 15px 5px 25px;
  }
  .navbar-nav .open .dropdown-menu > li > a {
    line-height: 18px;
  }
  .navbar-nav .open .dropdown-menu > li > a:hover,
  .navbar-nav .open .dropdown-menu > li > a:focus {
    background-image: none;
  }
}
@media (min-width: 541px) {
  .navbar-nav {
    float: left;
    margin: 0;
  }
  .navbar-nav > li {
    float: left;
  }
  .navbar-nav > li > a {
    padding-top: 6px;
    padding-bottom: 6px;
  }
}
.navbar-form {
  padding: 10px 0px;
  margin-right: 0px;
  margin-left: 0px;
  border-top: 1px solid transparent;
  border-bottom: 1px solid transparent;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.1), 0 1px 0 rgba(255, 255, 255, 0.1);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.1), 0 1px 0 rgba(255, 255, 255, 0.1);
  margin-top: -1px;
  margin-bottom: -1px;
}
@media (min-width: 768px) {
  .navbar-form .form-group {
    display: inline-block;
    margin-bottom: 0;
    vertical-align: middle;
  }
  .navbar-form .form-control {
    display: inline-block;
    width: auto;
    vertical-align: middle;
  }
  .navbar-form .form-control-static {
    display: inline-block;
  }
  .navbar-form .input-group {
    display: inline-table;
    vertical-align: middle;
  }
  .navbar-form .input-group .input-group-addon,
  .navbar-form .input-group .input-group-btn,
  .navbar-form .input-group .form-control {
    width: auto;
  }
  .navbar-form .input-group > .form-control {
    width: 100%;
  }
  .navbar-form .control-label {
    margin-bottom: 0;
    vertical-align: middle;
  }
  .navbar-form .radio,
  .navbar-form .checkbox {
    display: inline-block;
    margin-top: 0;
    margin-bottom: 0;
    vertical-align: middle;
  }
  .navbar-form .radio label,
  .navbar-form .checkbox label {
    padding-left: 0;
  }
  .navbar-form .radio input[type="radio"],
  .navbar-form .checkbox input[type="checkbox"] {
    position: relative;
    margin-left: 0;
  }
  .navbar-form .has-feedback .form-control-feedback {
    top: 0;
  }
}
@media (max-width: 540px) {
  .navbar-form .form-group {
    margin-bottom: 5px;
  }
  .navbar-form .form-group:last-child {
    margin-bottom: 0;
  }
}
@media (min-width: 541px) {
  .navbar-form {
    width: auto;
    padding-top: 0;
    padding-bottom: 0;
    margin-right: 0;
    margin-left: 0;
    border: 0;
    -webkit-box-shadow: none;
    box-shadow: none;
  }
}
.navbar-nav > li > .dropdown-menu {
  margin-top: 0;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
.navbar-fixed-bottom .navbar-nav > li > .dropdown-menu {
  margin-bottom: 0;
  border-top-left-radius: 2px;
  border-top-right-radius: 2px;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.navbar-btn {
  margin-top: -1px;
  margin-bottom: -1px;
}
.navbar-btn.btn-sm {
  margin-top: 0px;
  margin-bottom: 0px;
}
.navbar-btn.btn-xs {
  margin-top: 4px;
  margin-bottom: 4px;
}
.navbar-text {
  margin-top: 6px;
  margin-bottom: 6px;
}
@media (min-width: 541px) {
  .navbar-text {
    float: left;
    margin-right: 0px;
    margin-left: 0px;
  }
}
@media (min-width: 541px) {
  .navbar-left {
    float: left !important;
    float: left;
  }
  .navbar-right {
    float: right !important;
    float: right;
    margin-right: 0px;
  }
  .navbar-right ~ .navbar-right {
    margin-right: 0;
  }
}
.navbar-default {
  background-color: #f8f8f8;
  border-color: var(--navbar-default-border);
}
.navbar-default .navbar-brand {
  color: #565656;
}
.navbar-default .navbar-brand:hover,
.navbar-default .navbar-brand:focus {
  color: #3c3c3c;
  background-color: transparent;
}
.navbar-default .navbar-text {
  color: #777;
}
.navbar-default .navbar-nav > li > a {
  color: #565656;
}
.navbar-default .navbar-nav > li > a:hover,
.navbar-default .navbar-nav > li > a:focus {
  color: #333;
  background-color: transparent;
}
.navbar-default .navbar-nav > .active > a,
.navbar-default .navbar-nav > .active > a:hover,
.navbar-default .navbar-nav > .active > a:focus {
  color: #555;
  background-color: #e7e7e7;
}
.navbar-default .navbar-nav > .disabled > a,
.navbar-default .navbar-nav > .disabled > a:hover,
.navbar-default .navbar-nav > .disabled > a:focus {
  color: #ccc;
  background-color: transparent;
}
.navbar-default .navbar-nav > .open > a,
.navbar-default .navbar-nav > .open > a:hover,
.navbar-default .navbar-nav > .open > a:focus {
  color: #555;
  background-color: #e7e7e7;
}
@media (max-width: 540px) {
  .navbar-default .navbar-nav .open .dropdown-menu > li > a {
    color: #565656;
  }
  .navbar-default .navbar-nav .open .dropdown-menu > li > a:hover,
  .navbar-default .navbar-nav .open .dropdown-menu > li > a:focus {
    color: #333;
    background-color: transparent;
  }
  .navbar-default .navbar-nav .open .dropdown-menu > .active > a,
  .navbar-default .navbar-nav .open .dropdown-menu > .active > a:hover,
  .navbar-default .navbar-nav .open .dropdown-menu > .active > a:focus {
    color: #555;
    background-color: #e7e7e7;
  }
  .navbar-default .navbar-nav .open .dropdown-menu > .disabled > a,
  .navbar-default .navbar-nav .open .dropdown-menu > .disabled > a:hover,
  .navbar-default .navbar-nav .open .dropdown-menu > .disabled > a:focus {
    color: #ccc;
    background-color: transparent;
  }
}
.navbar-default .navbar-toggle {
  border-color: #ddd;
}
.navbar-default .navbar-toggle:hover,
.navbar-default .navbar-toggle:focus {
  background-color: #ddd;
}
.navbar-default .navbar-toggle .icon-bar {
  background-color: #888;
}
.navbar-default .navbar-collapse,
.navbar-default .navbar-form {
  border-color: var(--navbar-default-border);
}
.navbar-default .navbar-link {
  color: #565656;
}
.navbar-default .navbar-link:hover {
  color: #333;
}
.navbar-default .btn-link {
  color: #565656;
}
.navbar-default .btn-link:hover,
.navbar-default .btn-link:focus {
  color: #333;
}
.navbar-default .btn-link[disabled]:hover,
fieldset[disabled] .navbar-default .btn-link:hover,
.navbar-default .btn-link[disabled]:focus,
fieldset[disabled] .navbar-default .btn-link:focus {
  color: #ccc;
}
.navbar-inverse {
  background-color: #222;
  border-color: #080808;
}
.navbar-inverse .navbar-brand {
  color: #9d9d9d;
}
.navbar-inverse .navbar-brand:hover,
.navbar-inverse .navbar-brand:focus {
  color: #fff;
  background-color: transparent;
}
.navbar-inverse .navbar-text {
  color: #9d9d9d;
}
.navbar-inverse .navbar-nav > li > a {
  color: #9d9d9d;
}
.navbar-inverse .navbar-nav > li > a:hover,
.navbar-inverse .navbar-nav > li > a:focus {
  color: #fff;
  background-color: transparent;
}
.navbar-inverse .navbar-nav > .active > a,
.navbar-inverse .navbar-nav > .active > a:hover,
.navbar-inverse .navbar-nav > .active > a:focus {
  color: #fff;
  background-color: #080808;
}
.navbar-inverse .navbar-nav > .disabled > a,
.navbar-inverse .navbar-nav > .disabled > a:hover,
.navbar-inverse .navbar-nav > .disabled > a:focus {
  color: #444;
  background-color: transparent;
}
.navbar-inverse .navbar-nav > .open > a,
.navbar-inverse .navbar-nav > .open > a:hover,
.navbar-inverse .navbar-nav > .open > a:focus {
  color: #fff;
  background-color: #080808;
}
@media (max-width: 540px) {
  .navbar-inverse .navbar-nav .open .dropdown-menu > .dropdown-header {
    border-color: #080808;
  }
  .navbar-inverse .navbar-nav .open .dropdown-menu .divider {
    background-color: #080808;
  }
  .navbar-inverse .navbar-nav .open .dropdown-menu > li > a {
    color: #9d9d9d;
  }
  .navbar-inverse .navbar-nav .open .dropdown-menu > li > a:hover,
  .navbar-inverse .navbar-nav .open .dropdown-menu > li > a:focus {
    color: #fff;
    background-color: transparent;
  }
  .navbar-inverse .navbar-nav .open .dropdown-menu > .active > a,
  .navbar-inverse .navbar-nav .open .dropdown-menu > .active > a:hover,
  .navbar-inverse .navbar-nav .open .dropdown-menu > .active > a:focus {
    color: #fff;
    background-color: #080808;
  }
  .navbar-inverse .navbar-nav .open .dropdown-menu > .disabled > a,
  .navbar-inverse .navbar-nav .open .dropdown-menu > .disabled > a:hover,
  .navbar-inverse .navbar-nav .open .dropdown-menu > .disabled > a:focus {
    color: #444;
    background-color: transparent;
  }
}
.navbar-inverse .navbar-toggle {
  border-color: #333;
}
.navbar-inverse .navbar-toggle:hover,
.navbar-inverse .navbar-toggle:focus {
  background-color: #333;
}
.navbar-inverse .navbar-toggle .icon-bar {
  background-color: #fff;
}
.navbar-inverse .navbar-collapse,
.navbar-inverse .navbar-form {
  border-color: #101010;
}
.navbar-inverse .navbar-link {
  color: #9d9d9d;
}
.navbar-inverse .navbar-link:hover {
  color: #fff;
}
.navbar-inverse .btn-link {
  color: #9d9d9d;
}
.navbar-inverse .btn-link:hover,
.navbar-inverse .btn-link:focus {
  color: #fff;
}
.navbar-inverse .btn-link[disabled]:hover,
fieldset[disabled] .navbar-inverse .btn-link:hover,
.navbar-inverse .btn-link[disabled]:focus,
fieldset[disabled] .navbar-inverse .btn-link:focus {
  color: #444;
}
.breadcrumb {
  padding: 8px 15px;
  margin-bottom: 18px;
  list-style: none;
  background-color: #f5f5f5;
  border-radius: 2px;
}
.breadcrumb > li {
  display: inline-block;
}
.breadcrumb > li + li:before {
  padding: 0 5px;
  color: hsl(var(--body-bg-hue), var(--body-bg-saturation), calc(var(--body-bg-light) - 63%));
  content: "/\\00a0";
}
.breadcrumb > .active {
  color: #777777;
}
.pagination {
  display: inline-block;
  padding-left: 0;
  margin: 18px 0;
  border-radius: 2px;
}
.pagination > li {
  display: inline;
}
.pagination > li > a,
.pagination > li > span {
  position: relative;
  float: left;
  padding: 6px 12px;
  margin-left: -1px;
  line-height: 1.42857143;
  color: #296eaa;
  text-decoration: none;
  background-color: #fff;
  border: 1px solid #ddd;
}
.pagination > li > a:hover,
.pagination > li > span:hover,
.pagination > li > a:focus,
.pagination > li > span:focus {
  z-index: 2;
  color: #1a466c;
  background-color: #eeeeee;
  border-color: #ddd;
}
.pagination > li:first-child > a,
.pagination > li:first-child > span {
  margin-left: 0;
  border-top-left-radius: 2px;
  border-bottom-left-radius: 2px;
}
.pagination > li:last-child > a,
.pagination > li:last-child > span {
  border-top-right-radius: 2px;
  border-bottom-right-radius: 2px;
}
.pagination > .active > a,
.pagination > .active > span,
.pagination > .active > a:hover,
.pagination > .active > span:hover,
.pagination > .active > a:focus,
.pagination > .active > span:focus {
  z-index: 3;
  color: #fff;
  cursor: default;
  background-color: #337ab7;
  border-color: #337ab7;
}
.pagination > .disabled > span,
.pagination > .disabled > span:hover,
.pagination > .disabled > span:focus,
.pagination > .disabled > a,
.pagination > .disabled > a:hover,
.pagination > .disabled > a:focus {
  color: #777777;
  cursor: not-allowed;
  background-color: #fff;
  border-color: #ddd;
}
.pagination-lg > li > a,
.pagination-lg > li > span {
  padding: 10px 16px;
  font-size: 17px;
  line-height: 1.3333333;
}
.pagination-lg > li:first-child > a,
.pagination-lg > li:first-child > span {
  border-top-left-radius: 3px;
  border-bottom-left-radius: 3px;
}
.pagination-lg > li:last-child > a,
.pagination-lg > li:last-child > span {
  border-top-right-radius: 3px;
  border-bottom-right-radius: 3px;
}
.pagination-sm > li > a,
.pagination-sm > li > span {
  padding: 5px 10px;
  font-size: 12px;
  line-height: 1.5;
}
.pagination-sm > li:first-child > a,
.pagination-sm > li:first-child > span {
  border-top-left-radius: 1px;
  border-bottom-left-radius: 1px;
}
.pagination-sm > li:last-child > a,
.pagination-sm > li:last-child > span {
  border-top-right-radius: 1px;
  border-bottom-right-radius: 1px;
}
.pager {
  padding-left: 0;
  margin: 18px 0;
  text-align: center;
  list-style: none;
}
.pager li {
  display: inline;
}
.pager li > a,
.pager li > span {
  display: inline-block;
  padding: 5px 14px;
  background-color: #fff;
  border: 1px solid #ddd;
  border-radius: 15px;
}
.pager li > a:hover,
.pager li > a:focus {
  text-decoration: none;
  background-color: #eeeeee;
}
.pager .next > a,
.pager .next > span {
  float: right;
}
.pager .previous > a,
.pager .previous > span {
  float: left;
}
.pager .disabled > a,
.pager .disabled > a:hover,
.pager .disabled > a:focus,
.pager .disabled > span {
  color: #777777;
  cursor: not-allowed;
  background-color: #fff;
}
.label {
  display: inline;
  padding: 0.2em 0.6em 0.3em;
  font-size: 75%;
  font-weight: 700;
  line-height: 1;
  color: #fff;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: 0.25em;
}
a.label:hover,
a.label:focus {
  color: #fff;
  text-decoration: none;
  cursor: pointer;
}
.label:empty {
  display: none;
}
.btn .label {
  position: relative;
  top: -1px;
}
.label-default {
  background-color: #777777;
}
.label-default[href]:hover,
.label-default[href]:focus {
  background-color: #5e5e5e;
}
.label-primary {
  background-color: #337ab7;
}
.label-primary[href]:hover,
.label-primary[href]:focus {
  background-color: #286090;
}
.label-success {
  background-color: #5cb85c;
}
.label-success[href]:hover,
.label-success[href]:focus {
  background-color: #449d44;
}
.label-info {
  background-color: #5bc0de;
}
.label-info[href]:hover,
.label-info[href]:focus {
  background-color: #31b0d5;
}
.label-warning {
  background-color: #f0ad4e;
}
.label-warning[href]:hover,
.label-warning[href]:focus {
  background-color: #ec971f;
}
.label-danger {
  background-color: #d9534f;
}
.label-danger[href]:hover,
.label-danger[href]:focus {
  background-color: #c9302c;
}
.badge {
  display: inline-block;
  min-width: 10px;
  padding: 3px 7px;
  font-size: 12px;
  font-weight: bold;
  line-height: 1;
  color: #fff;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  background-color: #777777;
  border-radius: 10px;
}
.badge:empty {
  display: none;
}
.btn .badge {
  position: relative;
  top: -1px;
}
.btn-xs .badge,
.btn-group-xs > .btn .badge {
  top: 0;
  padding: 1px 5px;
}
a.badge:hover,
a.badge:focus {
  color: #fff;
  text-decoration: none;
  cursor: pointer;
}
.list-group-item.active > .badge,
.nav-pills > .active > a > .badge {
  color: #296eaa;
  background-color: #fff;
}
.list-group-item > .badge {
  float: right;
}
.list-group-item > .badge + .badge {
  margin-right: 5px;
}
.nav-pills > li > a > .badge {
  margin-left: 3px;
}
.jumbotron {
  padding-top: 30px;
  padding-bottom: 30px;
  margin-bottom: 30px;
  color: inherit;
  background-color: #eeeeee;
}
.jumbotron h1,
.jumbotron .h1 {
  color: inherit;
}
.jumbotron p {
  margin-bottom: 15px;
  font-size: 20px;
  font-weight: 200;
}
.jumbotron > hr {
  border-top-color: #d5d5d5;
}
.container .jumbotron,
.container-fluid .jumbotron {
  padding-right: 0px;
  padding-left: 0px;
  border-radius: 3px;
}
.jumbotron .container {
  max-width: 100%;
}
@media screen and (min-width: 768px) {
  .jumbotron {
    padding-top: 48px;
    padding-bottom: 48px;
  }
  .container .jumbotron,
  .container-fluid .jumbotron {
    padding-right: 60px;
    padding-left: 60px;
  }
  .jumbotron h1,
  .jumbotron .h1 {
    font-size: 59px;
  }
}
.thumbnail {
  display: block;
  padding: 4px;
  margin-bottom: 18px;
  line-height: 1.42857143;
  background-color: var(--body-bg);
  border: 1px solid #ddd;
  border-radius: 2px;
  -webkit-transition: border 0.2s ease-in-out;
  -o-transition: border 0.2s ease-in-out;
  transition: border 0.2s ease-in-out;
}
.thumbnail > img,
.thumbnail a > img {
  margin-right: auto;
  margin-left: auto;
}
a.thumbnail:hover,
a.thumbnail:focus,
a.thumbnail.active {
  border-color: #296eaa;
}
.thumbnail .caption {
  padding: 9px;
  color: black;
}
.alert {
  padding: 15px;
  margin-bottom: 18px;
  border: 1px solid transparent;
  border-radius: 2px;
}
.alert h4 {
  margin-top: 0;
  color: inherit;
}
.alert .alert-link {
  font-weight: bold;
}
.alert > p,
.alert > ul {
  margin-bottom: 0;
}
.alert > p + p {
  margin-top: 5px;
}
.alert-dismissable,
.alert-dismissible {
  padding-right: 35px;
}
.alert-dismissable .close,
.alert-dismissible .close {
  position: relative;
  top: -2px;
  right: -21px;
  color: inherit;
}
.alert-success {
  color: #3c763d;
  background-color: #dff0d8;
  border-color: #d6e9c6;
}
.alert-success hr {
  border-top-color: #c9e2b3;
}
.alert-success .alert-link {
  color: #2b542c;
}
.alert-info {
  color: #31708f;
  background-color: #d9edf7;
  border-color: #bce8f1;
}
.alert-info hr {
  border-top-color: #a6e1ec;
}
.alert-info .alert-link {
  color: #245269;
}
.alert-warning {
  color: #8a6d3b;
  background-color: #fcf8e3;
  border-color: #faebcc;
}
.alert-warning hr {
  border-top-color: #f7e1b5;
}
.alert-warning .alert-link {
  color: #66512c;
}
.alert-danger {
  color: #a94442;
  background-color: #f2dede;
  border-color: #ebccd1;
}
.alert-danger hr {
  border-top-color: #e4b9c0;
}
.alert-danger .alert-link {
  color: #843534;
}
@-webkit-keyframes progress-bar-stripes {
  from {
    background-position: 40px 0;
  }
  to {
    background-position: 0 0;
  }
}
@keyframes progress-bar-stripes {
  from {
    background-position: 40px 0;
  }
  to {
    background-position: 0 0;
  }
}
.progress {
  height: 18px;
  margin-bottom: 18px;
  overflow: hidden;
  background-color: #f5f5f5;
  border-radius: 2px;
  -webkit-box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.1);
  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.1);
}
.progress-bar {
  float: left;
  width: 0%;
  height: 100%;
  font-size: 12px;
  line-height: 18px;
  color: #fff;
  text-align: center;
  background-color: #337ab7;
  -webkit-box-shadow: inset 0 -1px 0 rgba(0, 0, 0, 0.15);
  box-shadow: inset 0 -1px 0 rgba(0, 0, 0, 0.15);
  -webkit-transition: width 0.6s ease;
  -o-transition: width 0.6s ease;
  transition: width 0.6s ease;
}
.progress-striped .progress-bar,
.progress-bar-striped {
  background-image: -webkit-linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
  background-image: -o-linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
  background-size: 40px 40px;
}
.progress.active .progress-bar,
.progress-bar.active {
  -webkit-animation: progress-bar-stripes 2s linear infinite;
  -o-animation: progress-bar-stripes 2s linear infinite;
  animation: progress-bar-stripes 2s linear infinite;
}
.progress-bar-success {
  background-color: #5cb85c;
}
.progress-striped .progress-bar-success {
  background-image: -webkit-linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
  background-image: -o-linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
}
.progress-bar-info {
  background-color: #5bc0de;
}
.progress-striped .progress-bar-info {
  background-image: -webkit-linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
  background-image: -o-linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
}
.progress-bar-warning {
  background-color: #f0ad4e;
}
.progress-striped .progress-bar-warning {
  background-image: -webkit-linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
  background-image: -o-linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
}
.progress-bar-danger {
  background-color: #d9534f;
}
.progress-striped .progress-bar-danger {
  background-image: -webkit-linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
  background-image: -o-linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
}
.media {
  margin-top: 15px;
}
.media:first-child {
  margin-top: 0;
}
.media,
.media-body {
  overflow: hidden;
  zoom: 1;
}
.media-body {
  width: 10000px;
}
.media-object {
  display: block;
}
.media-object.img-thumbnail {
  max-width: none;
}
.media-right,
.media > .pull-right {
  padding-left: 10px;
}
.media-left,
.media > .pull-left {
  padding-right: 10px;
}
.media-left,
.media-right,
.media-body {
  display: table-cell;
  vertical-align: top;
}
.media-middle {
  vertical-align: middle;
}
.media-bottom {
  vertical-align: bottom;
}
.media-heading {
  margin-top: 0;
  margin-bottom: 5px;
}
.media-list {
  padding-left: 0;
  list-style: none;
}
.list-group {
  padding-left: 0;
  margin-bottom: 20px;
}
.list-group-item {
  position: relative;
  display: block;
  padding: 10px 15px;
  margin-bottom: -1px;
  background-color: #fff;
  border: 1px solid #ddd;
}
.list-group-item:first-child {
  border-top-left-radius: 2px;
  border-top-right-radius: 2px;
}
.list-group-item:last-child {
  margin-bottom: 0;
  border-bottom-right-radius: 2px;
  border-bottom-left-radius: 2px;
}
.list-group-item.disabled,
.list-group-item.disabled:hover,
.list-group-item.disabled:focus {
  color: #777777;
  cursor: not-allowed;
  background-color: #eeeeee;
}
.list-group-item.disabled .list-group-item-heading,
.list-group-item.disabled:hover .list-group-item-heading,
.list-group-item.disabled:focus .list-group-item-heading {
  color: inherit;
}
.list-group-item.disabled .list-group-item-text,
.list-group-item.disabled:hover .list-group-item-text,
.list-group-item.disabled:focus .list-group-item-text {
  color: #777777;
}
.list-group-item.active,
.list-group-item.active:hover,
.list-group-item.active:focus {
  z-index: 2;
  color: #fff;
  background-color: #337ab7;
  border-color: #337ab7;
}
.list-group-item.active .list-group-item-heading,
.list-group-item.active:hover .list-group-item-heading,
.list-group-item.active:focus .list-group-item-heading,
.list-group-item.active .list-group-item-heading > small,
.list-group-item.active:hover .list-group-item-heading > small,
.list-group-item.active:focus .list-group-item-heading > small,
.list-group-item.active .list-group-item-heading > .small,
.list-group-item.active:hover .list-group-item-heading > .small,
.list-group-item.active:focus .list-group-item-heading > .small {
  color: inherit;
}
.list-group-item.active .list-group-item-text,
.list-group-item.active:hover .list-group-item-text,
.list-group-item.active:focus .list-group-item-text {
  color: #c7ddef;
}
a.list-group-item,
button.list-group-item {
  color: #555;
}
a.list-group-item .list-group-item-heading,
button.list-group-item .list-group-item-heading {
  color: #333;
}
a.list-group-item:hover,
button.list-group-item:hover,
a.list-group-item:focus,
button.list-group-item:focus {
  color: #555;
  text-decoration: none;
  background-color: #f5f5f5;
}
button.list-group-item {
  width: 100%;
  text-align: left;
}
.list-group-item-success {
  color: #3c763d;
  background-color: #dff0d8;
}
a.list-group-item-success,
button.list-group-item-success {
  color: #3c763d;
}
a.list-group-item-success .list-group-item-heading,
button.list-group-item-success .list-group-item-heading {
  color: inherit;
}
a.list-group-item-success:hover,
button.list-group-item-success:hover,
a.list-group-item-success:focus,
button.list-group-item-success:focus {
  color: #3c763d;
  background-color: #d0e9c6;
}
a.list-group-item-success.active,
button.list-group-item-success.active,
a.list-group-item-success.active:hover,
button.list-group-item-success.active:hover,
a.list-group-item-success.active:focus,
button.list-group-item-success.active:focus {
  color: #fff;
  background-color: #3c763d;
  border-color: #3c763d;
}
.list-group-item-info {
  color: #31708f;
  background-color: #d9edf7;
}
a.list-group-item-info,
button.list-group-item-info {
  color: #31708f;
}
a.list-group-item-info .list-group-item-heading,
button.list-group-item-info .list-group-item-heading {
  color: inherit;
}
a.list-group-item-info:hover,
button.list-group-item-info:hover,
a.list-group-item-info:focus,
button.list-group-item-info:focus {
  color: #31708f;
  background-color: #c4e3f3;
}
a.list-group-item-info.active,
button.list-group-item-info.active,
a.list-group-item-info.active:hover,
button.list-group-item-info.active:hover,
a.list-group-item-info.active:focus,
button.list-group-item-info.active:focus {
  color: #fff;
  background-color: #31708f;
  border-color: #31708f;
}
.list-group-item-warning {
  color: #8a6d3b;
  background-color: #fcf8e3;
}
a.list-group-item-warning,
button.list-group-item-warning {
  color: #8a6d3b;
}
a.list-group-item-warning .list-group-item-heading,
button.list-group-item-warning .list-group-item-heading {
  color: inherit;
}
a.list-group-item-warning:hover,
button.list-group-item-warning:hover,
a.list-group-item-warning:focus,
button.list-group-item-warning:focus {
  color: #8a6d3b;
  background-color: #faf2cc;
}
a.list-group-item-warning.active,
button.list-group-item-warning.active,
a.list-group-item-warning.active:hover,
button.list-group-item-warning.active:hover,
a.list-group-item-warning.active:focus,
button.list-group-item-warning.active:focus {
  color: #fff;
  background-color: #8a6d3b;
  border-color: #8a6d3b;
}
.list-group-item-danger {
  color: #a94442;
  background-color: #f2dede;
}
a.list-group-item-danger,
button.list-group-item-danger {
  color: #a94442;
}
a.list-group-item-danger .list-group-item-heading,
button.list-group-item-danger .list-group-item-heading {
  color: inherit;
}
a.list-group-item-danger:hover,
button.list-group-item-danger:hover,
a.list-group-item-danger:focus,
button.list-group-item-danger:focus {
  color: #a94442;
  background-color: #ebcccc;
}
a.list-group-item-danger.active,
button.list-group-item-danger.active,
a.list-group-item-danger.active:hover,
button.list-group-item-danger.active:hover,
a.list-group-item-danger.active:focus,
button.list-group-item-danger.active:focus {
  color: #fff;
  background-color: #a94442;
  border-color: #a94442;
}
.list-group-item-heading {
  margin-top: 0;
  margin-bottom: 5px;
}
.list-group-item-text {
  margin-bottom: 0;
  line-height: 1.3;
}
.panel {
  margin-bottom: 18px;
  background-color: #fff;
  border: 1px solid transparent;
  border-radius: 2px;
  -webkit-box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);
}
.panel-body {
  padding: 15px;
}
.panel-heading {
  padding: 10px 15px;
  border-bottom: 1px solid transparent;
  border-top-left-radius: 1px;
  border-top-right-radius: 1px;
}
.panel-heading > .dropdown .dropdown-toggle {
  color: inherit;
}
.panel-title {
  margin-top: 0;
  margin-bottom: 0;
  font-size: 15px;
  color: inherit;
}
.panel-title > a,
.panel-title > small,
.panel-title > .small,
.panel-title > small > a,
.panel-title > .small > a {
  color: inherit;
}
.panel-footer {
  padding: 10px 15px;
  background-color: #f5f5f5;
  border-top: 1px solid #ddd;
  border-bottom-right-radius: 1px;
  border-bottom-left-radius: 1px;
}
.panel > .list-group,
.panel > .panel-collapse > .list-group {
  margin-bottom: 0;
}
.panel > .list-group .list-group-item,
.panel > .panel-collapse > .list-group .list-group-item {
  border-width: 1px 0;
  border-radius: 0;
}
.panel > .list-group:first-child .list-group-item:first-child,
.panel > .panel-collapse > .list-group:first-child .list-group-item:first-child {
  border-top: 0;
  border-top-left-radius: 1px;
  border-top-right-radius: 1px;
}
.panel > .list-group:last-child .list-group-item:last-child,
.panel > .panel-collapse > .list-group:last-child .list-group-item:last-child {
  border-bottom: 0;
  border-bottom-right-radius: 1px;
  border-bottom-left-radius: 1px;
}
.panel > .panel-heading + .panel-collapse > .list-group .list-group-item:first-child {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
.panel-heading + .list-group .list-group-item:first-child {
  border-top-width: 0;
}
.list-group + .panel-footer {
  border-top-width: 0;
}
.panel > .table,
.panel > .table-responsive > .table,
.panel > .panel-collapse > .table {
  margin-bottom: 0;
}
.panel > .table caption,
.panel > .table-responsive > .table caption,
.panel > .panel-collapse > .table caption {
  padding-right: 15px;
  padding-left: 15px;
}
.panel > .table:first-child,
.panel > .table-responsive:first-child > .table:first-child {
  border-top-left-radius: 1px;
  border-top-right-radius: 1px;
}
.panel > .table:first-child > thead:first-child > tr:first-child,
.panel > .table-responsive:first-child > .table:first-child > thead:first-child > tr:first-child,
.panel > .table:first-child > tbody:first-child > tr:first-child,
.panel > .table-responsive:first-child > .table:first-child > tbody:first-child > tr:first-child {
  border-top-left-radius: 1px;
  border-top-right-radius: 1px;
}
.panel > .table:first-child > thead:first-child > tr:first-child td:first-child,
.panel > .table-responsive:first-child > .table:first-child > thead:first-child > tr:first-child td:first-child,
.panel > .table:first-child > tbody:first-child > tr:first-child td:first-child,
.panel > .table-responsive:first-child > .table:first-child > tbody:first-child > tr:first-child td:first-child,
.panel > .table:first-child > thead:first-child > tr:first-child th:first-child,
.panel > .table-responsive:first-child > .table:first-child > thead:first-child > tr:first-child th:first-child,
.panel > .table:first-child > tbody:first-child > tr:first-child th:first-child,
.panel > .table-responsive:first-child > .table:first-child > tbody:first-child > tr:first-child th:first-child {
  border-top-left-radius: 1px;
}
.panel > .table:first-child > thead:first-child > tr:first-child td:last-child,
.panel > .table-responsive:first-child > .table:first-child > thead:first-child > tr:first-child td:last-child,
.panel > .table:first-child > tbody:first-child > tr:first-child td:last-child,
.panel > .table-responsive:first-child > .table:first-child > tbody:first-child > tr:first-child td:last-child,
.panel > .table:first-child > thead:first-child > tr:first-child th:last-child,
.panel > .table-responsive:first-child > .table:first-child > thead:first-child > tr:first-child th:last-child,
.panel > .table:first-child > tbody:first-child > tr:first-child th:last-child,
.panel > .table-responsive:first-child > .table:first-child > tbody:first-child > tr:first-child th:last-child {
  border-top-right-radius: 1px;
}
.panel > .table:last-child,
.panel > .table-responsive:last-child > .table:last-child {
  border-bottom-right-radius: 1px;
  border-bottom-left-radius: 1px;
}
.panel > .table:last-child > tbody:last-child > tr:last-child,
.panel > .table-responsive:last-child > .table:last-child > tbody:last-child > tr:last-child,
.panel > .table:last-child > tfoot:last-child > tr:last-child,
.panel > .table-responsive:last-child > .table:last-child > tfoot:last-child > tr:last-child {
  border-bottom-right-radius: 1px;
  border-bottom-left-radius: 1px;
}
.panel > .table:last-child > tbody:last-child > tr:last-child td:first-child,
.panel > .table-responsive:last-child > .table:last-child > tbody:last-child > tr:last-child td:first-child,
.panel > .table:last-child > tfoot:last-child > tr:last-child td:first-child,
.panel > .table-responsive:last-child > .table:last-child > tfoot:last-child > tr:last-child td:first-child,
.panel > .table:last-child > tbody:last-child > tr:last-child th:first-child,
.panel > .table-responsive:last-child > .table:last-child > tbody:last-child > tr:last-child th:first-child,
.panel > .table:last-child > tfoot:last-child > tr:last-child th:first-child,
.panel > .table-responsive:last-child > .table:last-child > tfoot:last-child > tr:last-child th:first-child {
  border-bottom-left-radius: 1px;
}
.panel > .table:last-child > tbody:last-child > tr:last-child td:last-child,
.panel > .table-responsive:last-child > .table:last-child > tbody:last-child > tr:last-child td:last-child,
.panel > .table:last-child > tfoot:last-child > tr:last-child td:last-child,
.panel > .table-responsive:last-child > .table:last-child > tfoot:last-child > tr:last-child td:last-child,
.panel > .table:last-child > tbody:last-child > tr:last-child th:last-child,
.panel > .table-responsive:last-child > .table:last-child > tbody:last-child > tr:last-child th:last-child,
.panel > .table:last-child > tfoot:last-child > tr:last-child th:last-child,
.panel > .table-responsive:last-child > .table:last-child > tfoot:last-child > tr:last-child th:last-child {
  border-bottom-right-radius: 1px;
}
.panel > .panel-body + .table,
.panel > .panel-body + .table-responsive,
.panel > .table + .panel-body,
.panel > .table-responsive + .panel-body {
  border-top: 1px solid #ddd;
}
.panel > .table > tbody:first-child > tr:first-child th,
.panel > .table > tbody:first-child > tr:first-child td {
  border-top: 0;
}
.panel > .table-bordered,
.panel > .table-responsive > .table-bordered {
  border: 0;
}
.panel > .table-bordered > thead > tr > th:first-child,
.panel > .table-responsive > .table-bordered > thead > tr > th:first-child,
.panel > .table-bordered > tbody > tr > th:first-child,
.panel > .table-responsive > .table-bordered > tbody > tr > th:first-child,
.panel > .table-bordered > tfoot > tr > th:first-child,
.panel > .table-responsive > .table-bordered > tfoot > tr > th:first-child,
.panel > .table-bordered > thead > tr > td:first-child,
.panel > .table-responsive > .table-bordered > thead > tr > td:first-child,
.panel > .table-bordered > tbody > tr > td:first-child,
.panel > .table-responsive > .table-bordered > tbody > tr > td:first-child,
.panel > .table-bordered > tfoot > tr > td:first-child,
.panel > .table-responsive > .table-bordered > tfoot > tr > td:first-child {
  border-left: 0;
}
.panel > .table-bordered > thead > tr > th:last-child,
.panel > .table-responsive > .table-bordered > thead > tr > th:last-child,
.panel > .table-bordered > tbody > tr > th:last-child,
.panel > .table-responsive > .table-bordered > tbody > tr > th:last-child,
.panel > .table-bordered > tfoot > tr > th:last-child,
.panel > .table-responsive > .table-bordered > tfoot > tr > th:last-child,
.panel > .table-bordered > thead > tr > td:last-child,
.panel > .table-responsive > .table-bordered > thead > tr > td:last-child,
.panel > .table-bordered > tbody > tr > td:last-child,
.panel > .table-responsive > .table-bordered > tbody > tr > td:last-child,
.panel > .table-bordered > tfoot > tr > td:last-child,
.panel > .table-responsive > .table-bordered > tfoot > tr > td:last-child {
  border-right: 0;
}
.panel > .table-bordered > thead > tr:first-child > td,
.panel > .table-responsive > .table-bordered > thead > tr:first-child > td,
.panel > .table-bordered > tbody > tr:first-child > td,
.panel > .table-responsive > .table-bordered > tbody > tr:first-child > td,
.panel > .table-bordered > thead > tr:first-child > th,
.panel > .table-responsive > .table-bordered > thead > tr:first-child > th,
.panel > .table-bordered > tbody > tr:first-child > th,
.panel > .table-responsive > .table-bordered > tbody > tr:first-child > th {
  border-bottom: 0;
}
.panel > .table-bordered > tbody > tr:last-child > td,
.panel > .table-responsive > .table-bordered > tbody > tr:last-child > td,
.panel > .table-bordered > tfoot > tr:last-child > td,
.panel > .table-responsive > .table-bordered > tfoot > tr:last-child > td,
.panel > .table-bordered > tbody > tr:last-child > th,
.panel > .table-responsive > .table-bordered > tbody > tr:last-child > th,
.panel > .table-bordered > tfoot > tr:last-child > th,
.panel > .table-responsive > .table-bordered > tfoot > tr:last-child > th {
  border-bottom: 0;
}
.panel > .table-responsive {
  margin-bottom: 0;
  border: 0;
}
.panel-group {
  margin-bottom: 18px;
}
.panel-group .panel {
  margin-bottom: 0;
  border-radius: 2px;
}
.panel-group .panel + .panel {
  margin-top: 5px;
}
.panel-group .panel-heading {
  border-bottom: 0;
}
.panel-group .panel-heading + .panel-collapse > .panel-body,
.panel-group .panel-heading + .panel-collapse > .list-group {
  border-top: 1px solid #ddd;
}
.panel-group .panel-footer {
  border-top: 0;
}
.panel-group .panel-footer + .panel-collapse .panel-body {
  border-bottom: 1px solid #ddd;
}
.panel-default {
  border-color: #ddd;
}
.panel-default > .panel-heading {
  color: #333333;
  background-color: #f5f5f5;
  border-color: #ddd;
}
.panel-default > .panel-heading + .panel-collapse > .panel-body {
  border-top-color: #ddd;
}
.panel-default > .panel-heading .badge {
  color: #f5f5f5;
  background-color: #333333;
}
.panel-default > .panel-footer + .panel-collapse > .panel-body {
  border-bottom-color: #ddd;
}
.panel-primary {
  border-color: #337ab7;
}
.panel-primary > .panel-heading {
  color: #fff;
  background-color: #337ab7;
  border-color: #337ab7;
}
.panel-primary > .panel-heading + .panel-collapse > .panel-body {
  border-top-color: #337ab7;
}
.panel-primary > .panel-heading .badge {
  color: #337ab7;
  background-color: #fff;
}
.panel-primary > .panel-footer + .panel-collapse > .panel-body {
  border-bottom-color: #337ab7;
}
.panel-success {
  border-color: #d6e9c6;
}
.panel-success > .panel-heading {
  color: #3c763d;
  background-color: #dff0d8;
  border-color: #d6e9c6;
}
.panel-success > .panel-heading + .panel-collapse > .panel-body {
  border-top-color: #d6e9c6;
}
.panel-success > .panel-heading .badge {
  color: #dff0d8;
  background-color: #3c763d;
}
.panel-success > .panel-footer + .panel-collapse > .panel-body {
  border-bottom-color: #d6e9c6;
}
.panel-info {
  border-color: #bce8f1;
}
.panel-info > .panel-heading {
  color: #31708f;
  background-color: #d9edf7;
  border-color: #bce8f1;
}
.panel-info > .panel-heading + .panel-collapse > .panel-body {
  border-top-color: #bce8f1;
}
.panel-info > .panel-heading .badge {
  color: #d9edf7;
  background-color: #31708f;
}
.panel-info > .panel-footer + .panel-collapse > .panel-body {
  border-bottom-color: #bce8f1;
}
.panel-warning {
  border-color: #faebcc;
}
.panel-warning > .panel-heading {
  color: #8a6d3b;
  background-color: #fcf8e3;
  border-color: #faebcc;
}
.panel-warning > .panel-heading + .panel-collapse > .panel-body {
  border-top-color: #faebcc;
}
.panel-warning > .panel-heading .badge {
  color: #fcf8e3;
  background-color: #8a6d3b;
}
.panel-warning > .panel-footer + .panel-collapse > .panel-body {
  border-bottom-color: #faebcc;
}
.panel-danger {
  border-color: #ebccd1;
}
.panel-danger > .panel-heading {
  color: #a94442;
  background-color: #f2dede;
  border-color: #ebccd1;
}
.panel-danger > .panel-heading + .panel-collapse > .panel-body {
  border-top-color: #ebccd1;
}
.panel-danger > .panel-heading .badge {
  color: #f2dede;
  background-color: #a94442;
}
.panel-danger > .panel-footer + .panel-collapse > .panel-body {
  border-bottom-color: #ebccd1;
}
.embed-responsive {
  position: relative;
  display: block;
  height: 0;
  padding: 0;
  overflow: hidden;
}
.embed-responsive .embed-responsive-item,
.embed-responsive iframe,
.embed-responsive embed,
.embed-responsive object,
.embed-responsive video {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 0;
}
.embed-responsive-16by9 {
  padding-bottom: 56.25%;
}
.embed-responsive-4by3 {
  padding-bottom: 75%;
}
.well {
  min-height: 20px;
  padding: 19px;
  margin-bottom: 20px;
  background-color: #f5f5f5;
  border: 1px solid #e3e3e3;
  border-radius: 2px;
  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.05);
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.05);
}
.well blockquote {
  border-color: #ddd;
  border-color: rgba(0, 0, 0, 0.15);
}
.well-lg {
  padding: 24px;
  border-radius: 3px;
}
.well-sm {
  padding: 9px;
  border-radius: 1px;
}
.close {
  float: right;
  font-size: 19.5px;
  font-weight: bold;
  line-height: 1;
  color: #000;
  text-shadow: 0 1px 0 #fff;
  filter: alpha(opacity=20);
  opacity: 0.2;
}
.close:hover,
.close:focus {
  color: #000;
  text-decoration: none;
  cursor: pointer;
  filter: alpha(opacity=50);
  opacity: 0.5;
}
button.close {
  padding: 0;
  cursor: pointer;
  background: transparent;
  border: 0;
  -webkit-appearance: none;
  appearance: none;
}
.modal-open {
  overflow: hidden;
}
.modal {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1050;
  display: none;
  overflow: hidden;
  -webkit-overflow-scrolling: touch;
  outline: 0;
}
.modal.fade .modal-dialog {
  -webkit-transform: translate(0, -25%);
  -ms-transform: translate(0, -25%);
  -o-transform: translate(0, -25%);
  transform: translate(0, -25%);
  -webkit-transition: -webkit-transform 0.3s ease-out;
  -moz-transition: -moz-transform 0.3s ease-out;
  -o-transition: -o-transform 0.3s ease-out;
  transition: transform 0.3s ease-out;
}
.modal.in .modal-dialog {
  -webkit-transform: translate(0, 0);
  -ms-transform: translate(0, 0);
  -o-transform: translate(0, 0);
  transform: translate(0, 0);
}
.modal-open .modal {
  overflow-x: hidden;
  overflow-y: auto;
}
.modal-dialog {
  position: relative;
  width: auto;
  margin: 10px;
}
.modal-content {
  position: relative;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #999;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 3px;
  -webkit-box-shadow: 0 3px 9px rgba(0, 0, 0, 0.5);
  box-shadow: 0 3px 9px rgba(0, 0, 0, 0.5);
  outline: 0;
}
.modal-backdrop {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1040;
  background-color: #000;
}
.modal-backdrop.fade {
  filter: alpha(opacity=0);
  opacity: 0;
}
.modal-backdrop.in {
  filter: alpha(opacity=50);
  opacity: 0.5;
}
.modal-header {
  padding: 15px;
  border-bottom: 1px solid #e5e5e5;
}
.modal-header .close {
  margin-top: -2px;
}
.modal-title {
  margin: 0;
  line-height: 1.42857143;
}
.modal-body {
  position: relative;
  padding: 15px;
}
.modal-footer {
  padding: 15px;
  text-align: right;
  border-top: 1px solid #e5e5e5;
}
.modal-footer .btn + .btn {
  margin-bottom: 0;
  margin-left: 5px;
}
.modal-footer .btn-group .btn + .btn {
  margin-left: -1px;
}
.modal-footer .btn-block + .btn-block {
  margin-left: 0;
}
.modal-scrollbar-measure {
  position: absolute;
  top: -9999px;
  width: 50px;
  height: 50px;
  overflow: scroll;
}
@media (min-width: 768px) {
  .modal-dialog {
    width: 600px;
    margin: 30px auto;
  }
  .modal-content {
    -webkit-box-shadow: 0 5px 15px rgba(0, 0, 0, 0.5);
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.5);
  }
  .modal-sm {
    width: 300px;
  }
}
@media (min-width: 992px) {
  .modal-lg {
    width: 900px;
  }
}
.tooltip {
  position: absolute;
  z-index: 1070;
  display: block;
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-style: normal;
  font-weight: 400;
  line-height: 1.42857143;
  line-break: auto;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  word-spacing: normal;
  word-wrap: normal;
  white-space: normal;
  font-size: 12px;
  filter: alpha(opacity=0);
  opacity: 0;
}
.tooltip.in {
  filter: alpha(opacity=90);
  opacity: 0.9;
}
.tooltip.top {
  padding: 5px 0;
  margin-top: -3px;
}
.tooltip.right {
  padding: 0 5px;
  margin-left: 3px;
}
.tooltip.bottom {
  padding: 5px 0;
  margin-top: 3px;
}
.tooltip.left {
  padding: 0 5px;
  margin-left: -3px;
}
.tooltip.top .tooltip-arrow {
  bottom: 0;
  left: 50%;
  margin-left: -5px;
  border-width: 5px 5px 0;
  border-top-color: #000;
}
.tooltip.top-left .tooltip-arrow {
  right: 5px;
  bottom: 0;
  margin-bottom: -5px;
  border-width: 5px 5px 0;
  border-top-color: #000;
}
.tooltip.top-right .tooltip-arrow {
  bottom: 0;
  left: 5px;
  margin-bottom: -5px;
  border-width: 5px 5px 0;
  border-top-color: #000;
}
.tooltip.right .tooltip-arrow {
  top: 50%;
  left: 0;
  margin-top: -5px;
  border-width: 5px 5px 5px 0;
  border-right-color: #000;
}
.tooltip.left .tooltip-arrow {
  top: 50%;
  right: 0;
  margin-top: -5px;
  border-width: 5px 0 5px 5px;
  border-left-color: #000;
}
.tooltip.bottom .tooltip-arrow {
  top: 0;
  left: 50%;
  margin-left: -5px;
  border-width: 0 5px 5px;
  border-bottom-color: #000;
}
.tooltip.bottom-left .tooltip-arrow {
  top: 0;
  right: 5px;
  margin-top: -5px;
  border-width: 0 5px 5px;
  border-bottom-color: #000;
}
.tooltip.bottom-right .tooltip-arrow {
  top: 0;
  left: 5px;
  margin-top: -5px;
  border-width: 0 5px 5px;
  border-bottom-color: #000;
}
.tooltip-inner {
  max-width: 200px;
  padding: 3px 8px;
  color: #fff;
  text-align: center;
  background-color: #000;
  border-radius: 2px;
}
.tooltip-arrow {
  position: absolute;
  width: 0;
  height: 0;
  border-color: transparent;
  border-style: solid;
}
.popover {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1060;
  display: none;
  max-width: 276px;
  padding: 1px;
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-style: normal;
  font-weight: 400;
  line-height: 1.42857143;
  line-break: auto;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  word-spacing: normal;
  word-wrap: normal;
  white-space: normal;
  font-size: 13px;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ccc;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 3px;
  -webkit-box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);
  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);
}
.popover.top {
  margin-top: -10px;
}
.popover.right {
  margin-left: 10px;
}
.popover.bottom {
  margin-top: 10px;
}
.popover.left {
  margin-left: -10px;
}
.popover > .arrow {
  border-width: 11px;
}
.popover > .arrow,
.popover > .arrow:after {
  position: absolute;
  display: block;
  width: 0;
  height: 0;
  border-color: transparent;
  border-style: solid;
}
.popover > .arrow:after {
  content: "";
  border-width: 10px;
}
.popover.top > .arrow {
  bottom: -11px;
  left: 50%;
  margin-left: -11px;
  border-top-color: #999999;
  border-top-color: rgba(0, 0, 0, 0.25);
  border-bottom-width: 0;
}
.popover.top > .arrow:after {
  bottom: 1px;
  margin-left: -10px;
  content: " ";
  border-top-color: #fff;
  border-bottom-width: 0;
}
.popover.right > .arrow {
  top: 50%;
  left: -11px;
  margin-top: -11px;
  border-right-color: #999999;
  border-right-color: rgba(0, 0, 0, 0.25);
  border-left-width: 0;
}
.popover.right > .arrow:after {
  bottom: -10px;
  left: 1px;
  content: " ";
  border-right-color: #fff;
  border-left-width: 0;
}
.popover.bottom > .arrow {
  top: -11px;
  left: 50%;
  margin-left: -11px;
  border-top-width: 0;
  border-bottom-color: #999999;
  border-bottom-color: rgba(0, 0, 0, 0.25);
}
.popover.bottom > .arrow:after {
  top: 1px;
  margin-left: -10px;
  content: " ";
  border-top-width: 0;
  border-bottom-color: #fff;
}
.popover.left > .arrow {
  top: 50%;
  right: -11px;
  margin-top: -11px;
  border-right-width: 0;
  border-left-color: #999999;
  border-left-color: rgba(0, 0, 0, 0.25);
}
.popover.left > .arrow:after {
  right: 1px;
  bottom: -10px;
  content: " ";
  border-right-width: 0;
  border-left-color: #fff;
}
.popover-title {
  padding: 8px 14px;
  margin: 0;
  font-size: 13px;
  background-color: #f7f7f7;
  border-bottom: 1px solid #ebebeb;
  border-radius: 2px 2px 0 0;
}
.popover-content {
  padding: 9px 14px;
}
.carousel {
  position: relative;
}
.carousel-inner {
  position: relative;
  width: 100%;
  overflow: hidden;
}
.carousel-inner > .item {
  position: relative;
  display: none;
  -webkit-transition: 0.6s ease-in-out left;
  -o-transition: 0.6s ease-in-out left;
  transition: 0.6s ease-in-out left;
}
.carousel-inner > .item > img,
.carousel-inner > .item > a > img {
  line-height: 1;
}
@media all and (transform-3d), (-webkit-transform-3d) {
  .carousel-inner > .item {
    -webkit-transition: -webkit-transform 0.6s ease-in-out;
    -moz-transition: -moz-transform 0.6s ease-in-out;
    -o-transition: -o-transform 0.6s ease-in-out;
    transition: transform 0.6s ease-in-out;
    -webkit-backface-visibility: hidden;
    -moz-backface-visibility: hidden;
    backface-visibility: hidden;
    -webkit-perspective: 1000px;
    -moz-perspective: 1000px;
    perspective: 1000px;
  }
  .carousel-inner > .item.next,
  .carousel-inner > .item.active.right {
    -webkit-transform: translate3d(100%, 0, 0);
    transform: translate3d(100%, 0, 0);
    left: 0;
  }
  .carousel-inner > .item.prev,
  .carousel-inner > .item.active.left {
    -webkit-transform: translate3d(-100%, 0, 0);
    transform: translate3d(-100%, 0, 0);
    left: 0;
  }
  .carousel-inner > .item.next.left,
  .carousel-inner > .item.prev.right,
  .carousel-inner > .item.active {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
    left: 0;
  }
}
.carousel-inner > .active,
.carousel-inner > .next,
.carousel-inner > .prev {
  display: block;
}
.carousel-inner > .active {
  left: 0;
}
.carousel-inner > .next,
.carousel-inner > .prev {
  position: absolute;
  top: 0;
  width: 100%;
}
.carousel-inner > .next {
  left: 100%;
}
.carousel-inner > .prev {
  left: -100%;
}
.carousel-inner > .next.left,
.carousel-inner > .prev.right {
  left: 0;
}
.carousel-inner > .active.left {
  left: -100%;
}
.carousel-inner > .active.right {
  left: 100%;
}
.carousel-control {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 15%;
  font-size: 20px;
  color: #fff;
  text-align: center;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.6);
  background-color: rgba(0, 0, 0, 0);
  filter: alpha(opacity=50);
  opacity: 0.5;
}
.carousel-control.left {
  background-image: -webkit-linear-gradient(left, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0.0001) 100%);
  background-image: -o-linear-gradient(left, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0.0001) 100%);
  background-image: linear-gradient(to right, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0.0001) 100%);
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#80000000', endColorstr='#00000000', GradientType=1);
  background-repeat: repeat-x;
}
.carousel-control.right {
  right: 0;
  left: auto;
  background-image: -webkit-linear-gradient(left, rgba(0, 0, 0, 0.0001) 0%, rgba(0, 0, 0, 0.5) 100%);
  background-image: -o-linear-gradient(left, rgba(0, 0, 0, 0.0001) 0%, rgba(0, 0, 0, 0.5) 100%);
  background-image: linear-gradient(to right, rgba(0, 0, 0, 0.0001) 0%, rgba(0, 0, 0, 0.5) 100%);
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#00000000', endColorstr='#80000000', GradientType=1);
  background-repeat: repeat-x;
}
.carousel-control:hover,
.carousel-control:focus {
  color: #fff;
  text-decoration: none;
  outline: 0;
  filter: alpha(opacity=90);
  opacity: 0.9;
}
.carousel-control .icon-prev,
.carousel-control .icon-next,
.carousel-control .glyphicon-chevron-left,
.carousel-control .glyphicon-chevron-right {
  position: absolute;
  top: 50%;
  z-index: 5;
  display: inline-block;
  margin-top: -10px;
}
.carousel-control .icon-prev,
.carousel-control .glyphicon-chevron-left {
  left: 50%;
  margin-left: -10px;
}
.carousel-control .icon-next,
.carousel-control .glyphicon-chevron-right {
  right: 50%;
  margin-right: -10px;
}
.carousel-control .icon-prev,
.carousel-control .icon-next {
  width: 20px;
  height: 20px;
  font-family: serif;
  line-height: 1;
}
.carousel-control .icon-prev:before {
  content: "\\2039";
}
.carousel-control .icon-next:before {
  content: "\\203a";
}
.carousel-indicators {
  position: absolute;
  bottom: 10px;
  left: 50%;
  z-index: 15;
  width: 60%;
  padding-left: 0;
  margin-left: -30%;
  text-align: center;
  list-style: none;
}
.carousel-indicators li {
  display: inline-block;
  width: 10px;
  height: 10px;
  margin: 1px;
  text-indent: -999px;
  cursor: pointer;
  background-color: #000 \\9;
  background-color: rgba(0, 0, 0, 0);
  border: 1px solid #fff;
  border-radius: 10px;
}
.carousel-indicators .active {
  width: 12px;
  height: 12px;
  margin: 0;
  background-color: #fff;
}
.carousel-caption {
  position: absolute;
  right: 15%;
  bottom: 20px;
  left: 15%;
  z-index: 10;
  padding-top: 20px;
  padding-bottom: 20px;
  color: #fff;
  text-align: center;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.6);
}
.carousel-caption .btn {
  text-shadow: none;
}
@media screen and (min-width: 768px) {
  .carousel-control .glyphicon-chevron-left,
  .carousel-control .glyphicon-chevron-right,
  .carousel-control .icon-prev,
  .carousel-control .icon-next {
    width: 30px;
    height: 30px;
    margin-top: -10px;
    font-size: 30px;
  }
  .carousel-control .glyphicon-chevron-left,
  .carousel-control .icon-prev {
    margin-left: -10px;
  }
  .carousel-control .glyphicon-chevron-right,
  .carousel-control .icon-next {
    margin-right: -10px;
  }
  .carousel-caption {
    right: 20%;
    left: 20%;
    padding-bottom: 30px;
  }
  .carousel-indicators {
    bottom: 20px;
  }
}
.clearfix:before,
.clearfix:after,
.dl-horizontal dd:before,
.dl-horizontal dd:after,
.container:before,
.container:after,
.container-fluid:before,
.container-fluid:after,
.row:before,
.row:after,
.form-horizontal .form-group:before,
.form-horizontal .form-group:after,
.btn-toolbar:before,
.btn-toolbar:after,
.btn-group-vertical > .btn-group:before,
.btn-group-vertical > .btn-group:after,
.nav:before,
.nav:after,
.navbar:before,
.navbar:after,
.navbar-header:before,
.navbar-header:after,
.navbar-collapse:before,
.navbar-collapse:after,
.pager:before,
.pager:after,
.panel-body:before,
.panel-body:after,
.modal-header:before,
.modal-header:after,
.modal-footer:before,
.modal-footer:after {
  display: table;
  content: " ";
}
.clearfix:after,
.dl-horizontal dd:after,
.container:after,
.container-fluid:after,
.row:after,
.form-horizontal .form-group:after,
.btn-toolbar:after,
.btn-group-vertical > .btn-group:after,
.nav:after,
.navbar:after,
.navbar-header:after,
.navbar-collapse:after,
.pager:after,
.panel-body:after,
.modal-header:after,
.modal-footer:after {
  clear: both;
}
.center-block {
  display: block;
  margin-right: auto;
  margin-left: auto;
}
.pull-right {
  float: right !important;
}
.pull-left {
  float: left !important;
}
.hide {
  display: none !important;
}
.show {
  display: block !important;
}
.invisible {
  visibility: hidden;
}
.text-hide {
  font: 0/0 a;
  color: transparent;
  text-shadow: none;
  background-color: transparent;
  border: 0;
}
.hidden {
  display: none !important;
}
.affix {
  position: fixed;
}
@-ms-viewport {
  width: device-width;
}
.visible-xs,
.visible-sm,
.visible-md,
.visible-lg {
  display: none !important;
}
.visible-xs-block,
.visible-xs-inline,
.visible-xs-inline-block,
.visible-sm-block,
.visible-sm-inline,
.visible-sm-inline-block,
.visible-md-block,
.visible-md-inline,
.visible-md-inline-block,
.visible-lg-block,
.visible-lg-inline,
.visible-lg-inline-block {
  display: none !important;
}
@media (max-width: 767px) {
  .visible-xs {
    display: block !important;
  }
  table.visible-xs {
    display: table !important;
  }
  tr.visible-xs {
    display: table-row !important;
  }
  th.visible-xs,
  td.visible-xs {
    display: table-cell !important;
  }
}
@media (max-width: 767px) {
  .visible-xs-block {
    display: block !important;
  }
}
@media (max-width: 767px) {
  .visible-xs-inline {
    display: inline !important;
  }
}
@media (max-width: 767px) {
  .visible-xs-inline-block {
    display: inline-block !important;
  }
}
@media (min-width: 768px) and (max-width: 991px) {
  .visible-sm {
    display: block !important;
  }
  table.visible-sm {
    display: table !important;
  }
  tr.visible-sm {
    display: table-row !important;
  }
  th.visible-sm,
  td.visible-sm {
    display: table-cell !important;
  }
}
@media (min-width: 768px) and (max-width: 991px) {
  .visible-sm-block {
    display: block !important;
  }
}
@media (min-width: 768px) and (max-width: 991px) {
  .visible-sm-inline {
    display: inline !important;
  }
}
@media (min-width: 768px) and (max-width: 991px) {
  .visible-sm-inline-block {
    display: inline-block !important;
  }
}
@media (min-width: 992px) and (max-width: 1199px) {
  .visible-md {
    display: block !important;
  }
  table.visible-md {
    display: table !important;
  }
  tr.visible-md {
    display: table-row !important;
  }
  th.visible-md,
  td.visible-md {
    display: table-cell !important;
  }
}
@media (min-width: 992px) and (max-width: 1199px) {
  .visible-md-block {
    display: block !important;
  }
}
@media (min-width: 992px) and (max-width: 1199px) {
  .visible-md-inline {
    display: inline !important;
  }
}
@media (min-width: 992px) and (max-width: 1199px) {
  .visible-md-inline-block {
    display: inline-block !important;
  }
}
@media (min-width: 1200px) {
  .visible-lg {
    display: block !important;
  }
  table.visible-lg {
    display: table !important;
  }
  tr.visible-lg {
    display: table-row !important;
  }
  th.visible-lg,
  td.visible-lg {
    display: table-cell !important;
  }
}
@media (min-width: 1200px) {
  .visible-lg-block {
    display: block !important;
  }
}
@media (min-width: 1200px) {
  .visible-lg-inline {
    display: inline !important;
  }
}
@media (min-width: 1200px) {
  .visible-lg-inline-block {
    display: inline-block !important;
  }
}
@media (max-width: 767px) {
  .hidden-xs {
    display: none !important;
  }
}
@media (min-width: 768px) and (max-width: 991px) {
  .hidden-sm {
    display: none !important;
  }
}
@media (min-width: 992px) and (max-width: 1199px) {
  .hidden-md {
    display: none !important;
  }
}
@media (min-width: 1200px) {
  .hidden-lg {
    display: none !important;
  }
}
.visible-print {
  display: none !important;
}
@media print {
  .visible-print {
    display: block !important;
  }
  table.visible-print {
    display: table !important;
  }
  tr.visible-print {
    display: table-row !important;
  }
  th.visible-print,
  td.visible-print {
    display: table-cell !important;
  }
}
.visible-print-block {
  display: none !important;
}
@media print {
  .visible-print-block {
    display: block !important;
  }
}
.visible-print-inline {
  display: none !important;
}
@media print {
  .visible-print-inline {
    display: inline !important;
  }
}
.visible-print-inline-block {
  display: none !important;
}
@media print {
  .visible-print-inline-block {
    display: inline-block !important;
  }
}
@media print {
  .hidden-print {
    display: none !important;
  }
}
/*!
*
* Font Awesome
*
*/
/*!
 *  Font Awesome 4.7.0 by @davegandy - http://fontawesome.io - @fontawesome
 *  License - http://fontawesome.io/license (Font: SIL OFL 1.1, CSS: MIT License)
 */
/* FONT PATH
 * -------------------------- */
@font-face {
  font-family: 'FontAwesome';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format('embedded-opentype'), url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format('woff2'), url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format('woff'), url(${___CSS_LOADER_URL_REPLACEMENT_10___}) format('truetype'), url(${___CSS_LOADER_URL_REPLACEMENT_11___}) format('svg');
  font-weight: normal;
  font-style: normal;
}
.fa {
  display: inline-block;
  font: normal normal normal 14px/1 FontAwesome;
  font-size: inherit;
  text-rendering: auto;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
/* makes the font 33% larger relative to the icon container */
.fa-lg {
  font-size: 1.33333333em;
  line-height: 0.75em;
  vertical-align: -15%;
}
.fa-2x {
  font-size: 2em;
}
.fa-3x {
  font-size: 3em;
}
.fa-4x {
  font-size: 4em;
}
.fa-5x {
  font-size: 5em;
}
.fa-fw {
  width: 1.28571429em;
  text-align: center;
}
.fa-ul {
  padding-left: 0;
  margin-left: 2.14285714em;
  list-style-type: none;
}
.fa-ul > li {
  position: relative;
}
.fa-li {
  position: absolute;
  left: -2.14285714em;
  width: 2.14285714em;
  top: 0.14285714em;
  text-align: center;
}
.fa-li.fa-lg {
  left: -1.85714286em;
}
.fa-border {
  padding: 0.2em 0.25em 0.15em;
  border: solid 0.08em #eee;
  border-radius: 0.1em;
}
.fa-pull-left {
  float: left;
}
.fa-pull-right {
  float: right;
}
.fa.fa-pull-left {
  margin-right: 0.3em;
}
.fa.fa-pull-right {
  margin-left: 0.3em;
}
/* Deprecated as of 4.4.0 */
.pull-right {
  float: right;
}
.pull-left {
  float: left;
}
.fa.pull-left {
  margin-right: 0.3em;
}
.fa.pull-right {
  margin-left: 0.3em;
}
.fa-spin {
  -webkit-animation: fa-spin 2s infinite linear;
  animation: fa-spin 2s infinite linear;
}
.fa-pulse {
  -webkit-animation: fa-spin 1s infinite steps(8);
  animation: fa-spin 1s infinite steps(8);
}
@-webkit-keyframes fa-spin {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(359deg);
    transform: rotate(359deg);
  }
}
@keyframes fa-spin {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(359deg);
    transform: rotate(359deg);
  }
}
.fa-rotate-90 {
  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=1)";
  -webkit-transform: rotate(90deg);
  -ms-transform: rotate(90deg);
  transform: rotate(90deg);
}
.fa-rotate-180 {
  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=2)";
  -webkit-transform: rotate(180deg);
  -ms-transform: rotate(180deg);
  transform: rotate(180deg);
}
.fa-rotate-270 {
  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=3)";
  -webkit-transform: rotate(270deg);
  -ms-transform: rotate(270deg);
  transform: rotate(270deg);
}
.fa-flip-horizontal {
  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=0, mirror=1)";
  -webkit-transform: scale(-1, 1);
  -ms-transform: scale(-1, 1);
  transform: scale(-1, 1);
}
.fa-flip-vertical {
  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)";
  -webkit-transform: scale(1, -1);
  -ms-transform: scale(1, -1);
  transform: scale(1, -1);
}
:root .fa-rotate-90,
:root .fa-rotate-180,
:root .fa-rotate-270,
:root .fa-flip-horizontal,
:root .fa-flip-vertical {
  filter: none;
}
.fa-stack {
  position: relative;
  display: inline-block;
  width: 2em;
  height: 2em;
  line-height: 2em;
  vertical-align: middle;
}
.fa-stack-1x,
.fa-stack-2x {
  position: absolute;
  left: 0;
  width: 100%;
  text-align: center;
}
.fa-stack-1x {
  line-height: inherit;
}
.fa-stack-2x {
  font-size: 2em;
}
.fa-inverse {
  color: #fff;
}
/* Font Awesome uses the Unicode Private Use Area (PUA) to ensure screen
   readers do not read off random characters that represent icons */
.fa-glass:before {
  content: "\\f000";
}
.fa-music:before {
  content: "\\f001";
}
.fa-search:before {
  content: "\\f002";
}
.fa-envelope-o:before {
  content: "\\f003";
}
.fa-heart:before {
  content: "\\f004";
}
.fa-star:before {
  content: "\\f005";
}
.fa-star-o:before {
  content: "\\f006";
}
.fa-user:before {
  content: "\\f007";
}
.fa-film:before {
  content: "\\f008";
}
.fa-th-large:before {
  content: "\\f009";
}
.fa-th:before {
  content: "\\f00a";
}
.fa-th-list:before {
  content: "\\f00b";
}
.fa-check:before {
  content: "\\f00c";
}
.fa-remove:before,
.fa-close:before,
.fa-times:before {
  content: "\\f00d";
}
.fa-search-plus:before {
  content: "\\f00e";
}
.fa-search-minus:before {
  content: "\\f010";
}
.fa-power-off:before {
  content: "\\f011";
}
.fa-signal:before {
  content: "\\f012";
}
.fa-gear:before,
.fa-cog:before {
  content: "\\f013";
}
.fa-trash-o:before {
  content: "\\f014";
}
.fa-home:before {
  content: "\\f015";
}
.fa-file-o:before {
  content: "\\f016";
}
.fa-clock-o:before {
  content: "\\f017";
}
.fa-road:before {
  content: "\\f018";
}
.fa-download:before {
  content: "\\f019";
}
.fa-arrow-circle-o-down:before {
  content: "\\f01a";
}
.fa-arrow-circle-o-up:before {
  content: "\\f01b";
}
.fa-inbox:before {
  content: "\\f01c";
}
.fa-play-circle-o:before {
  content: "\\f01d";
}
.fa-rotate-right:before,
.fa-repeat:before {
  content: "\\f01e";
}
.fa-refresh:before {
  content: "\\f021";
}
.fa-list-alt:before {
  content: "\\f022";
}
.fa-lock:before {
  content: "\\f023";
}
.fa-flag:before {
  content: "\\f024";
}
.fa-headphones:before {
  content: "\\f025";
}
.fa-volume-off:before {
  content: "\\f026";
}
.fa-volume-down:before {
  content: "\\f027";
}
.fa-volume-up:before {
  content: "\\f028";
}
.fa-qrcode:before {
  content: "\\f029";
}
.fa-barcode:before {
  content: "\\f02a";
}
.fa-tag:before {
  content: "\\f02b";
}
.fa-tags:before {
  content: "\\f02c";
}
.fa-book:before {
  content: "\\f02d";
}
.fa-bookmark:before {
  content: "\\f02e";
}
.fa-print:before {
  content: "\\f02f";
}
.fa-camera:before {
  content: "\\f030";
}
.fa-font:before {
  content: "\\f031";
}
.fa-bold:before {
  content: "\\f032";
}
.fa-italic:before {
  content: "\\f033";
}
.fa-text-height:before {
  content: "\\f034";
}
.fa-text-width:before {
  content: "\\f035";
}
.fa-align-left:before {
  content: "\\f036";
}
.fa-align-center:before {
  content: "\\f037";
}
.fa-align-right:before {
  content: "\\f038";
}
.fa-align-justify:before {
  content: "\\f039";
}
.fa-list:before {
  content: "\\f03a";
}
.fa-dedent:before,
.fa-outdent:before {
  content: "\\f03b";
}
.fa-indent:before {
  content: "\\f03c";
}
.fa-video-camera:before {
  content: "\\f03d";
}
.fa-photo:before,
.fa-image:before,
.fa-picture-o:before {
  content: "\\f03e";
}
.fa-pencil:before {
  content: "\\f040";
}
.fa-map-marker:before {
  content: "\\f041";
}
.fa-adjust:before {
  content: "\\f042";
}
.fa-tint:before {
  content: "\\f043";
}
.fa-edit:before,
.fa-pencil-square-o:before {
  content: "\\f044";
}
.fa-share-square-o:before {
  content: "\\f045";
}
.fa-check-square-o:before {
  content: "\\f046";
}
.fa-arrows:before {
  content: "\\f047";
}
.fa-step-backward:before {
  content: "\\f048";
}
.fa-fast-backward:before {
  content: "\\f049";
}
.fa-backward:before {
  content: "\\f04a";
}
.fa-play:before {
  content: "\\f04b";
}
.fa-pause:before {
  content: "\\f04c";
}
.fa-stop:before {
  content: "\\f04d";
}
.fa-forward:before {
  content: "\\f04e";
}
.fa-fast-forward:before {
  content: "\\f050";
}
.fa-step-forward:before {
  content: "\\f051";
}
.fa-eject:before {
  content: "\\f052";
}
.fa-chevron-left:before {
  content: "\\f053";
}
.fa-chevron-right:before {
  content: "\\f054";
}
.fa-plus-circle:before {
  content: "\\f055";
}
.fa-minus-circle:before {
  content: "\\f056";
}
.fa-times-circle:before {
  content: "\\f057";
}
.fa-check-circle:before {
  content: "\\f058";
}
.fa-question-circle:before {
  content: "\\f059";
}
.fa-info-circle:before {
  content: "\\f05a";
}
.fa-crosshairs:before {
  content: "\\f05b";
}
.fa-times-circle-o:before {
  content: "\\f05c";
}
.fa-check-circle-o:before {
  content: "\\f05d";
}
.fa-ban:before {
  content: "\\f05e";
}
.fa-arrow-left:before {
  content: "\\f060";
}
.fa-arrow-right:before {
  content: "\\f061";
}
.fa-arrow-up:before {
  content: "\\f062";
}
.fa-arrow-down:before {
  content: "\\f063";
}
.fa-mail-forward:before,
.fa-share:before {
  content: "\\f064";
}
.fa-expand:before {
  content: "\\f065";
}
.fa-compress:before {
  content: "\\f066";
}
.fa-plus:before {
  content: "\\f067";
}
.fa-minus:before {
  content: "\\f068";
}
.fa-asterisk:before {
  content: "\\f069";
}
.fa-exclamation-circle:before {
  content: "\\f06a";
}
.fa-gift:before {
  content: "\\f06b";
}
.fa-leaf:before {
  content: "\\f06c";
}
.fa-fire:before {
  content: "\\f06d";
}
.fa-eye:before {
  content: "\\f06e";
}
.fa-eye-slash:before {
  content: "\\f070";
}
.fa-warning:before,
.fa-exclamation-triangle:before {
  content: "\\f071";
}
.fa-plane:before {
  content: "\\f072";
}
.fa-calendar:before {
  content: "\\f073";
}
.fa-random:before {
  content: "\\f074";
}
.fa-comment:before {
  content: "\\f075";
}
.fa-magnet:before {
  content: "\\f076";
}
.fa-chevron-up:before {
  content: "\\f077";
}
.fa-chevron-down:before {
  content: "\\f078";
}
.fa-retweet:before {
  content: "\\f079";
}
.fa-shopping-cart:before {
  content: "\\f07a";
}
.fa-folder:before {
  content: "\\f07b";
}
.fa-folder-open:before {
  content: "\\f07c";
}
.fa-arrows-v:before {
  content: "\\f07d";
}
.fa-arrows-h:before {
  content: "\\f07e";
}
.fa-bar-chart-o:before,
.fa-bar-chart:before {
  content: "\\f080";
}
.fa-twitter-square:before {
  content: "\\f081";
}
.fa-facebook-square:before {
  content: "\\f082";
}
.fa-camera-retro:before {
  content: "\\f083";
}
.fa-key:before {
  content: "\\f084";
}
.fa-gears:before,
.fa-cogs:before {
  content: "\\f085";
}
.fa-comments:before {
  content: "\\f086";
}
.fa-thumbs-o-up:before {
  content: "\\f087";
}
.fa-thumbs-o-down:before {
  content: "\\f088";
}
.fa-star-half:before {
  content: "\\f089";
}
.fa-heart-o:before {
  content: "\\f08a";
}
.fa-sign-out:before {
  content: "\\f08b";
}
.fa-linkedin-square:before {
  content: "\\f08c";
}
.fa-thumb-tack:before {
  content: "\\f08d";
}
.fa-external-link:before {
  content: "\\f08e";
}
.fa-sign-in:before {
  content: "\\f090";
}
.fa-trophy:before {
  content: "\\f091";
}
.fa-github-square:before {
  content: "\\f092";
}
.fa-upload:before {
  content: "\\f093";
}
.fa-lemon-o:before {
  content: "\\f094";
}
.fa-phone:before {
  content: "\\f095";
}
.fa-square-o:before {
  content: "\\f096";
}
.fa-bookmark-o:before {
  content: "\\f097";
}
.fa-phone-square:before {
  content: "\\f098";
}
.fa-twitter:before {
  content: "\\f099";
}
.fa-facebook-f:before,
.fa-facebook:before {
  content: "\\f09a";
}
.fa-github:before {
  content: "\\f09b";
}
.fa-unlock:before {
  content: "\\f09c";
}
.fa-credit-card:before {
  content: "\\f09d";
}
.fa-feed:before,
.fa-rss:before {
  content: "\\f09e";
}
.fa-hdd-o:before {
  content: "\\f0a0";
}
.fa-bullhorn:before {
  content: "\\f0a1";
}
.fa-bell:before {
  content: "\\f0f3";
}
.fa-certificate:before {
  content: "\\f0a3";
}
.fa-hand-o-right:before {
  content: "\\f0a4";
}
.fa-hand-o-left:before {
  content: "\\f0a5";
}
.fa-hand-o-up:before {
  content: "\\f0a6";
}
.fa-hand-o-down:before {
  content: "\\f0a7";
}
.fa-arrow-circle-left:before {
  content: "\\f0a8";
}
.fa-arrow-circle-right:before {
  content: "\\f0a9";
}
.fa-arrow-circle-up:before {
  content: "\\f0aa";
}
.fa-arrow-circle-down:before {
  content: "\\f0ab";
}
.fa-globe:before {
  content: "\\f0ac";
}
.fa-wrench:before {
  content: "\\f0ad";
}
.fa-tasks:before {
  content: "\\f0ae";
}
.fa-filter:before {
  content: "\\f0b0";
}
.fa-briefcase:before {
  content: "\\f0b1";
}
.fa-arrows-alt:before {
  content: "\\f0b2";
}
.fa-group:before,
.fa-users:before {
  content: "\\f0c0";
}
.fa-chain:before,
.fa-link:before {
  content: "\\f0c1";
}
.fa-cloud:before {
  content: "\\f0c2";
}
.fa-flask:before {
  content: "\\f0c3";
}
.fa-cut:before,
.fa-scissors:before {
  content: "\\f0c4";
}
.fa-copy:before,
.fa-files-o:before {
  content: "\\f0c5";
}
.fa-paperclip:before {
  content: "\\f0c6";
}
.fa-save:before,
.fa-floppy-o:before {
  content: "\\f0c7";
}
.fa-square:before {
  content: "\\f0c8";
}
.fa-navicon:before,
.fa-reorder:before,
.fa-bars:before {
  content: "\\f0c9";
}
.fa-list-ul:before {
  content: "\\f0ca";
}
.fa-list-ol:before {
  content: "\\f0cb";
}
.fa-strikethrough:before {
  content: "\\f0cc";
}
.fa-underline:before {
  content: "\\f0cd";
}
.fa-table:before {
  content: "\\f0ce";
}
.fa-magic:before {
  content: "\\f0d0";
}
.fa-truck:before {
  content: "\\f0d1";
}
.fa-pinterest:before {
  content: "\\f0d2";
}
.fa-pinterest-square:before {
  content: "\\f0d3";
}
.fa-google-plus-square:before {
  content: "\\f0d4";
}
.fa-google-plus:before {
  content: "\\f0d5";
}
.fa-money:before {
  content: "\\f0d6";
}
.fa-caret-down:before {
  content: "\\f0d7";
}
.fa-caret-up:before {
  content: "\\f0d8";
}
.fa-caret-left:before {
  content: "\\f0d9";
}
.fa-caret-right:before {
  content: "\\f0da";
}
.fa-columns:before {
  content: "\\f0db";
}
.fa-unsorted:before,
.fa-sort:before {
  content: "\\f0dc";
}
.fa-sort-down:before,
.fa-sort-desc:before {
  content: "\\f0dd";
}
.fa-sort-up:before,
.fa-sort-asc:before {
  content: "\\f0de";
}
.fa-envelope:before {
  content: "\\f0e0";
}
.fa-linkedin:before {
  content: "\\f0e1";
}
.fa-rotate-left:before,
.fa-undo:before {
  content: "\\f0e2";
}
.fa-legal:before,
.fa-gavel:before {
  content: "\\f0e3";
}
.fa-dashboard:before,
.fa-tachometer:before {
  content: "\\f0e4";
}
.fa-comment-o:before {
  content: "\\f0e5";
}
.fa-comments-o:before {
  content: "\\f0e6";
}
.fa-flash:before,
.fa-bolt:before {
  content: "\\f0e7";
}
.fa-sitemap:before {
  content: "\\f0e8";
}
.fa-umbrella:before {
  content: "\\f0e9";
}
.fa-paste:before,
.fa-clipboard:before {
  content: "\\f0ea";
}
.fa-lightbulb-o:before {
  content: "\\f0eb";
}
.fa-exchange:before {
  content: "\\f0ec";
}
.fa-cloud-download:before {
  content: "\\f0ed";
}
.fa-cloud-upload:before {
  content: "\\f0ee";
}
.fa-user-md:before {
  content: "\\f0f0";
}
.fa-stethoscope:before {
  content: "\\f0f1";
}
.fa-suitcase:before {
  content: "\\f0f2";
}
.fa-bell-o:before {
  content: "\\f0a2";
}
.fa-coffee:before {
  content: "\\f0f4";
}
.fa-cutlery:before {
  content: "\\f0f5";
}
.fa-file-text-o:before {
  content: "\\f0f6";
}
.fa-building-o:before {
  content: "\\f0f7";
}
.fa-hospital-o:before {
  content: "\\f0f8";
}
.fa-ambulance:before {
  content: "\\f0f9";
}
.fa-medkit:before {
  content: "\\f0fa";
}
.fa-fighter-jet:before {
  content: "\\f0fb";
}
.fa-beer:before {
  content: "\\f0fc";
}
.fa-h-square:before {
  content: "\\f0fd";
}
.fa-plus-square:before {
  content: "\\f0fe";
}
.fa-angle-double-left:before {
  content: "\\f100";
}
.fa-angle-double-right:before {
  content: "\\f101";
}
.fa-angle-double-up:before {
  content: "\\f102";
}
.fa-angle-double-down:before {
  content: "\\f103";
}
.fa-angle-left:before {
  content: "\\f104";
}
.fa-angle-right:before {
  content: "\\f105";
}
.fa-angle-up:before {
  content: "\\f106";
}
.fa-angle-down:before {
  content: "\\f107";
}
.fa-desktop:before {
  content: "\\f108";
}
.fa-laptop:before {
  content: "\\f109";
}
.fa-tablet:before {
  content: "\\f10a";
}
.fa-mobile-phone:before,
.fa-mobile:before {
  content: "\\f10b";
}
.fa-circle-o:before {
  content: "\\f10c";
}
.fa-quote-left:before {
  content: "\\f10d";
}
.fa-quote-right:before {
  content: "\\f10e";
}
.fa-spinner:before {
  content: "\\f110";
}
.fa-circle:before {
  content: "\\f111";
}
.fa-mail-reply:before,
.fa-reply:before {
  content: "\\f112";
}
.fa-github-alt:before {
  content: "\\f113";
}
.fa-folder-o:before {
  content: "\\f114";
}
.fa-folder-open-o:before {
  content: "\\f115";
}
.fa-smile-o:before {
  content: "\\f118";
}
.fa-frown-o:before {
  content: "\\f119";
}
.fa-meh-o:before {
  content: "\\f11a";
}
.fa-gamepad:before {
  content: "\\f11b";
}
.fa-keyboard-o:before {
  content: "\\f11c";
}
.fa-flag-o:before {
  content: "\\f11d";
}
.fa-flag-checkered:before {
  content: "\\f11e";
}
.fa-terminal:before {
  content: "\\f120";
}
.fa-code:before {
  content: "\\f121";
}
.fa-mail-reply-all:before,
.fa-reply-all:before {
  content: "\\f122";
}
.fa-star-half-empty:before,
.fa-star-half-full:before,
.fa-star-half-o:before {
  content: "\\f123";
}
.fa-location-arrow:before {
  content: "\\f124";
}
.fa-crop:before {
  content: "\\f125";
}
.fa-code-fork:before {
  content: "\\f126";
}
.fa-unlink:before,
.fa-chain-broken:before {
  content: "\\f127";
}
.fa-question:before {
  content: "\\f128";
}
.fa-info:before {
  content: "\\f129";
}
.fa-exclamation:before {
  content: "\\f12a";
}
.fa-superscript:before {
  content: "\\f12b";
}
.fa-subscript:before {
  content: "\\f12c";
}
.fa-eraser:before {
  content: "\\f12d";
}
.fa-puzzle-piece:before {
  content: "\\f12e";
}
.fa-microphone:before {
  content: "\\f130";
}
.fa-microphone-slash:before {
  content: "\\f131";
}
.fa-shield:before {
  content: "\\f132";
}
.fa-calendar-o:before {
  content: "\\f133";
}
.fa-fire-extinguisher:before {
  content: "\\f134";
}
.fa-rocket:before {
  content: "\\f135";
}
.fa-maxcdn:before {
  content: "\\f136";
}
.fa-chevron-circle-left:before {
  content: "\\f137";
}
.fa-chevron-circle-right:before {
  content: "\\f138";
}
.fa-chevron-circle-up:before {
  content: "\\f139";
}
.fa-chevron-circle-down:before {
  content: "\\f13a";
}
.fa-html5:before {
  content: "\\f13b";
}
.fa-css3:before {
  content: "\\f13c";
}
.fa-anchor:before {
  content: "\\f13d";
}
.fa-unlock-alt:before {
  content: "\\f13e";
}
.fa-bullseye:before {
  content: "\\f140";
}
.fa-ellipsis-h:before {
  content: "\\f141";
}
.fa-ellipsis-v:before {
  content: "\\f142";
}
.fa-rss-square:before {
  content: "\\f143";
}
.fa-play-circle:before {
  content: "\\f144";
}
.fa-ticket:before {
  content: "\\f145";
}
.fa-minus-square:before {
  content: "\\f146";
}
.fa-minus-square-o:before {
  content: "\\f147";
}
.fa-level-up:before {
  content: "\\f148";
}
.fa-level-down:before {
  content: "\\f149";
}
.fa-check-square:before {
  content: "\\f14a";
}
.fa-pencil-square:before {
  content: "\\f14b";
}
.fa-external-link-square:before {
  content: "\\f14c";
}
.fa-share-square:before {
  content: "\\f14d";
}
.fa-compass:before {
  content: "\\f14e";
}
.fa-toggle-down:before,
.fa-caret-square-o-down:before {
  content: "\\f150";
}
.fa-toggle-up:before,
.fa-caret-square-o-up:before {
  content: "\\f151";
}
.fa-toggle-right:before,
.fa-caret-square-o-right:before {
  content: "\\f152";
}
.fa-euro:before,
.fa-eur:before {
  content: "\\f153";
}
.fa-gbp:before {
  content: "\\f154";
}
.fa-dollar:before,
.fa-usd:before {
  content: "\\f155";
}
.fa-rupee:before,
.fa-inr:before {
  content: "\\f156";
}
.fa-cny:before,
.fa-rmb:before,
.fa-yen:before,
.fa-jpy:before {
  content: "\\f157";
}
.fa-ruble:before,
.fa-rouble:before,
.fa-rub:before {
  content: "\\f158";
}
.fa-won:before,
.fa-krw:before {
  content: "\\f159";
}
.fa-bitcoin:before,
.fa-btc:before {
  content: "\\f15a";
}
.fa-file:before {
  content: "\\f15b";
}
.fa-file-text:before {
  content: "\\f15c";
}
.fa-sort-alpha-asc:before {
  content: "\\f15d";
}
.fa-sort-alpha-desc:before {
  content: "\\f15e";
}
.fa-sort-amount-asc:before {
  content: "\\f160";
}
.fa-sort-amount-desc:before {
  content: "\\f161";
}
.fa-sort-numeric-asc:before {
  content: "\\f162";
}
.fa-sort-numeric-desc:before {
  content: "\\f163";
}
.fa-thumbs-up:before {
  content: "\\f164";
}
.fa-thumbs-down:before {
  content: "\\f165";
}
.fa-youtube-square:before {
  content: "\\f166";
}
.fa-youtube:before {
  content: "\\f167";
}
.fa-xing:before {
  content: "\\f168";
}
.fa-xing-square:before {
  content: "\\f169";
}
.fa-youtube-play:before {
  content: "\\f16a";
}
.fa-dropbox:before {
  content: "\\f16b";
}
.fa-stack-overflow:before {
  content: "\\f16c";
}
.fa-instagram:before {
  content: "\\f16d";
}
.fa-flickr:before {
  content: "\\f16e";
}
.fa-adn:before {
  content: "\\f170";
}
.fa-bitbucket:before {
  content: "\\f171";
}
.fa-bitbucket-square:before {
  content: "\\f172";
}
.fa-tumblr:before {
  content: "\\f173";
}
.fa-tumblr-square:before {
  content: "\\f174";
}
.fa-long-arrow-down:before {
  content: "\\f175";
}
.fa-long-arrow-up:before {
  content: "\\f176";
}
.fa-long-arrow-left:before {
  content: "\\f177";
}
.fa-long-arrow-right:before {
  content: "\\f178";
}
.fa-apple:before {
  content: "\\f179";
}
.fa-windows:before {
  content: "\\f17a";
}
.fa-android:before {
  content: "\\f17b";
}
.fa-linux:before {
  content: "\\f17c";
}
.fa-dribbble:before {
  content: "\\f17d";
}
.fa-skype:before {
  content: "\\f17e";
}
.fa-foursquare:before {
  content: "\\f180";
}
.fa-trello:before {
  content: "\\f181";
}
.fa-female:before {
  content: "\\f182";
}
.fa-male:before {
  content: "\\f183";
}
.fa-gittip:before,
.fa-gratipay:before {
  content: "\\f184";
}
.fa-sun-o:before {
  content: "\\f185";
}
.fa-moon-o:before {
  content: "\\f186";
}
.fa-archive:before {
  content: "\\f187";
}
.fa-bug:before {
  content: "\\f188";
}
.fa-vk:before {
  content: "\\f189";
}
.fa-weibo:before {
  content: "\\f18a";
}
.fa-renren:before {
  content: "\\f18b";
}
.fa-pagelines:before {
  content: "\\f18c";
}
.fa-stack-exchange:before {
  content: "\\f18d";
}
.fa-arrow-circle-o-right:before {
  content: "\\f18e";
}
.fa-arrow-circle-o-left:before {
  content: "\\f190";
}
.fa-toggle-left:before,
.fa-caret-square-o-left:before {
  content: "\\f191";
}
.fa-dot-circle-o:before {
  content: "\\f192";
}
.fa-wheelchair:before {
  content: "\\f193";
}
.fa-vimeo-square:before {
  content: "\\f194";
}
.fa-turkish-lira:before,
.fa-try:before {
  content: "\\f195";
}
.fa-plus-square-o:before {
  content: "\\f196";
}
.fa-space-shuttle:before {
  content: "\\f197";
}
.fa-slack:before {
  content: "\\f198";
}
.fa-envelope-square:before {
  content: "\\f199";
}
.fa-wordpress:before {
  content: "\\f19a";
}
.fa-openid:before {
  content: "\\f19b";
}
.fa-institution:before,
.fa-bank:before,
.fa-university:before {
  content: "\\f19c";
}
.fa-mortar-board:before,
.fa-graduation-cap:before {
  content: "\\f19d";
}
.fa-yahoo:before {
  content: "\\f19e";
}
.fa-google:before {
  content: "\\f1a0";
}
.fa-reddit:before {
  content: "\\f1a1";
}
.fa-reddit-square:before {
  content: "\\f1a2";
}
.fa-stumbleupon-circle:before {
  content: "\\f1a3";
}
.fa-stumbleupon:before {
  content: "\\f1a4";
}
.fa-delicious:before {
  content: "\\f1a5";
}
.fa-digg:before {
  content: "\\f1a6";
}
.fa-pied-piper-pp:before {
  content: "\\f1a7";
}
.fa-pied-piper-alt:before {
  content: "\\f1a8";
}
.fa-drupal:before {
  content: "\\f1a9";
}
.fa-joomla:before {
  content: "\\f1aa";
}
.fa-language:before {
  content: "\\f1ab";
}
.fa-fax:before {
  content: "\\f1ac";
}
.fa-building:before {
  content: "\\f1ad";
}
.fa-child:before {
  content: "\\f1ae";
}
.fa-paw:before {
  content: "\\f1b0";
}
.fa-spoon:before {
  content: "\\f1b1";
}
.fa-cube:before {
  content: "\\f1b2";
}
.fa-cubes:before {
  content: "\\f1b3";
}
.fa-behance:before {
  content: "\\f1b4";
}
.fa-behance-square:before {
  content: "\\f1b5";
}
.fa-steam:before {
  content: "\\f1b6";
}
.fa-steam-square:before {
  content: "\\f1b7";
}
.fa-recycle:before {
  content: "\\f1b8";
}
.fa-automobile:before,
.fa-car:before {
  content: "\\f1b9";
}
.fa-cab:before,
.fa-taxi:before {
  content: "\\f1ba";
}
.fa-tree:before {
  content: "\\f1bb";
}
.fa-spotify:before {
  content: "\\f1bc";
}
.fa-deviantart:before {
  content: "\\f1bd";
}
.fa-soundcloud:before {
  content: "\\f1be";
}
.fa-database:before {
  content: "\\f1c0";
}
.fa-file-pdf-o:before {
  content: "\\f1c1";
}
.fa-file-word-o:before {
  content: "\\f1c2";
}
.fa-file-excel-o:before {
  content: "\\f1c3";
}
.fa-file-powerpoint-o:before {
  content: "\\f1c4";
}
.fa-file-photo-o:before,
.fa-file-picture-o:before,
.fa-file-image-o:before {
  content: "\\f1c5";
}
.fa-file-zip-o:before,
.fa-file-archive-o:before {
  content: "\\f1c6";
}
.fa-file-sound-o:before,
.fa-file-audio-o:before {
  content: "\\f1c7";
}
.fa-file-movie-o:before,
.fa-file-video-o:before {
  content: "\\f1c8";
}
.fa-file-code-o:before {
  content: "\\f1c9";
}
.fa-vine:before {
  content: "\\f1ca";
}
.fa-codepen:before {
  content: "\\f1cb";
}
.fa-jsfiddle:before {
  content: "\\f1cc";
}
.fa-life-bouy:before,
.fa-life-buoy:before,
.fa-life-saver:before,
.fa-support:before,
.fa-life-ring:before {
  content: "\\f1cd";
}
.fa-circle-o-notch:before {
  content: "\\f1ce";
}
.fa-ra:before,
.fa-resistance:before,
.fa-rebel:before {
  content: "\\f1d0";
}
.fa-ge:before,
.fa-empire:before {
  content: "\\f1d1";
}
.fa-git-square:before {
  content: "\\f1d2";
}
.fa-git:before {
  content: "\\f1d3";
}
.fa-y-combinator-square:before,
.fa-yc-square:before,
.fa-hacker-news:before {
  content: "\\f1d4";
}
.fa-tencent-weibo:before {
  content: "\\f1d5";
}
.fa-qq:before {
  content: "\\f1d6";
}
.fa-wechat:before,
.fa-weixin:before {
  content: "\\f1d7";
}
.fa-send:before,
.fa-paper-plane:before {
  content: "\\f1d8";
}
.fa-send-o:before,
.fa-paper-plane-o:before {
  content: "\\f1d9";
}
.fa-history:before {
  content: "\\f1da";
}
.fa-circle-thin:before {
  content: "\\f1db";
}
.fa-header:before {
  content: "\\f1dc";
}
.fa-paragraph:before {
  content: "\\f1dd";
}
.fa-sliders:before {
  content: "\\f1de";
}
.fa-share-alt:before {
  content: "\\f1e0";
}
.fa-share-alt-square:before {
  content: "\\f1e1";
}
.fa-bomb:before {
  content: "\\f1e2";
}
.fa-soccer-ball-o:before,
.fa-futbol-o:before {
  content: "\\f1e3";
}
.fa-tty:before {
  content: "\\f1e4";
}
.fa-binoculars:before {
  content: "\\f1e5";
}
.fa-plug:before {
  content: "\\f1e6";
}
.fa-slideshare:before {
  content: "\\f1e7";
}
.fa-twitch:before {
  content: "\\f1e8";
}
.fa-yelp:before {
  content: "\\f1e9";
}
.fa-newspaper-o:before {
  content: "\\f1ea";
}
.fa-wifi:before {
  content: "\\f1eb";
}
.fa-calculator:before {
  content: "\\f1ec";
}
.fa-paypal:before {
  content: "\\f1ed";
}
.fa-google-wallet:before {
  content: "\\f1ee";
}
.fa-cc-visa:before {
  content: "\\f1f0";
}
.fa-cc-mastercard:before {
  content: "\\f1f1";
}
.fa-cc-discover:before {
  content: "\\f1f2";
}
.fa-cc-amex:before {
  content: "\\f1f3";
}
.fa-cc-paypal:before {
  content: "\\f1f4";
}
.fa-cc-stripe:before {
  content: "\\f1f5";
}
.fa-bell-slash:before {
  content: "\\f1f6";
}
.fa-bell-slash-o:before {
  content: "\\f1f7";
}
.fa-trash:before {
  content: "\\f1f8";
}
.fa-copyright:before {
  content: "\\f1f9";
}
.fa-at:before {
  content: "\\f1fa";
}
.fa-eyedropper:before {
  content: "\\f1fb";
}
.fa-paint-brush:before {
  content: "\\f1fc";
}
.fa-birthday-cake:before {
  content: "\\f1fd";
}
.fa-area-chart:before {
  content: "\\f1fe";
}
.fa-pie-chart:before {
  content: "\\f200";
}
.fa-line-chart:before {
  content: "\\f201";
}
.fa-lastfm:before {
  content: "\\f202";
}
.fa-lastfm-square:before {
  content: "\\f203";
}
.fa-toggle-off:before {
  content: "\\f204";
}
.fa-toggle-on:before {
  content: "\\f205";
}
.fa-bicycle:before {
  content: "\\f206";
}
.fa-bus:before {
  content: "\\f207";
}
.fa-ioxhost:before {
  content: "\\f208";
}
.fa-angellist:before {
  content: "\\f209";
}
.fa-cc:before {
  content: "\\f20a";
}
.fa-shekel:before,
.fa-sheqel:before,
.fa-ils:before {
  content: "\\f20b";
}
.fa-meanpath:before {
  content: "\\f20c";
}
.fa-buysellads:before {
  content: "\\f20d";
}
.fa-connectdevelop:before {
  content: "\\f20e";
}
.fa-dashcube:before {
  content: "\\f210";
}
.fa-forumbee:before {
  content: "\\f211";
}
.fa-leanpub:before {
  content: "\\f212";
}
.fa-sellsy:before {
  content: "\\f213";
}
.fa-shirtsinbulk:before {
  content: "\\f214";
}
.fa-simplybuilt:before {
  content: "\\f215";
}
.fa-skyatlas:before {
  content: "\\f216";
}
.fa-cart-plus:before {
  content: "\\f217";
}
.fa-cart-arrow-down:before {
  content: "\\f218";
}
.fa-diamond:before {
  content: "\\f219";
}
.fa-ship:before {
  content: "\\f21a";
}
.fa-user-secret:before {
  content: "\\f21b";
}
.fa-motorcycle:before {
  content: "\\f21c";
}
.fa-street-view:before {
  content: "\\f21d";
}
.fa-heartbeat:before {
  content: "\\f21e";
}
.fa-venus:before {
  content: "\\f221";
}
.fa-mars:before {
  content: "\\f222";
}
.fa-mercury:before {
  content: "\\f223";
}
.fa-intersex:before,
.fa-transgender:before {
  content: "\\f224";
}
.fa-transgender-alt:before {
  content: "\\f225";
}
.fa-venus-double:before {
  content: "\\f226";
}
.fa-mars-double:before {
  content: "\\f227";
}
.fa-venus-mars:before {
  content: "\\f228";
}
.fa-mars-stroke:before {
  content: "\\f229";
}
.fa-mars-stroke-v:before {
  content: "\\f22a";
}
.fa-mars-stroke-h:before {
  content: "\\f22b";
}
.fa-neuter:before {
  content: "\\f22c";
}
.fa-genderless:before {
  content: "\\f22d";
}
.fa-facebook-official:before {
  content: "\\f230";
}
.fa-pinterest-p:before {
  content: "\\f231";
}
.fa-whatsapp:before {
  content: "\\f232";
}
.fa-server:before {
  content: "\\f233";
}
.fa-user-plus:before {
  content: "\\f234";
}
.fa-user-times:before {
  content: "\\f235";
}
.fa-hotel:before,
.fa-bed:before {
  content: "\\f236";
}
.fa-viacoin:before {
  content: "\\f237";
}
.fa-train:before {
  content: "\\f238";
}
.fa-subway:before {
  content: "\\f239";
}
.fa-medium:before {
  content: "\\f23a";
}
.fa-yc:before,
.fa-y-combinator:before {
  content: "\\f23b";
}
.fa-optin-monster:before {
  content: "\\f23c";
}
.fa-opencart:before {
  content: "\\f23d";
}
.fa-expeditedssl:before {
  content: "\\f23e";
}
.fa-battery-4:before,
.fa-battery:before,
.fa-battery-full:before {
  content: "\\f240";
}
.fa-battery-3:before,
.fa-battery-three-quarters:before {
  content: "\\f241";
}
.fa-battery-2:before,
.fa-battery-half:before {
  content: "\\f242";
}
.fa-battery-1:before,
.fa-battery-quarter:before {
  content: "\\f243";
}
.fa-battery-0:before,
.fa-battery-empty:before {
  content: "\\f244";
}
.fa-mouse-pointer:before {
  content: "\\f245";
}
.fa-i-cursor:before {
  content: "\\f246";
}
.fa-object-group:before {
  content: "\\f247";
}
.fa-object-ungroup:before {
  content: "\\f248";
}
.fa-sticky-note:before {
  content: "\\f249";
}
.fa-sticky-note-o:before {
  content: "\\f24a";
}
.fa-cc-jcb:before {
  content: "\\f24b";
}
.fa-cc-diners-club:before {
  content: "\\f24c";
}
.fa-clone:before {
  content: "\\f24d";
}
.fa-balance-scale:before {
  content: "\\f24e";
}
.fa-hourglass-o:before {
  content: "\\f250";
}
.fa-hourglass-1:before,
.fa-hourglass-start:before {
  content: "\\f251";
}
.fa-hourglass-2:before,
.fa-hourglass-half:before {
  content: "\\f252";
}
.fa-hourglass-3:before,
.fa-hourglass-end:before {
  content: "\\f253";
}
.fa-hourglass:before {
  content: "\\f254";
}
.fa-hand-grab-o:before,
.fa-hand-rock-o:before {
  content: "\\f255";
}
.fa-hand-stop-o:before,
.fa-hand-paper-o:before {
  content: "\\f256";
}
.fa-hand-scissors-o:before {
  content: "\\f257";
}
.fa-hand-lizard-o:before {
  content: "\\f258";
}
.fa-hand-spock-o:before {
  content: "\\f259";
}
.fa-hand-pointer-o:before {
  content: "\\f25a";
}
.fa-hand-peace-o:before {
  content: "\\f25b";
}
.fa-trademark:before {
  content: "\\f25c";
}
.fa-registered:before {
  content: "\\f25d";
}
.fa-creative-commons:before {
  content: "\\f25e";
}
.fa-gg:before {
  content: "\\f260";
}
.fa-gg-circle:before {
  content: "\\f261";
}
.fa-tripadvisor:before {
  content: "\\f262";
}
.fa-odnoklassniki:before {
  content: "\\f263";
}
.fa-odnoklassniki-square:before {
  content: "\\f264";
}
.fa-get-pocket:before {
  content: "\\f265";
}
.fa-wikipedia-w:before {
  content: "\\f266";
}
.fa-safari:before {
  content: "\\f267";
}
.fa-chrome:before {
  content: "\\f268";
}
.fa-firefox:before {
  content: "\\f269";
}
.fa-opera:before {
  content: "\\f26a";
}
.fa-internet-explorer:before {
  content: "\\f26b";
}
.fa-tv:before,
.fa-television:before {
  content: "\\f26c";
}
.fa-contao:before {
  content: "\\f26d";
}
.fa-500px:before {
  content: "\\f26e";
}
.fa-amazon:before {
  content: "\\f270";
}
.fa-calendar-plus-o:before {
  content: "\\f271";
}
.fa-calendar-minus-o:before {
  content: "\\f272";
}
.fa-calendar-times-o:before {
  content: "\\f273";
}
.fa-calendar-check-o:before {
  content: "\\f274";
}
.fa-industry:before {
  content: "\\f275";
}
.fa-map-pin:before {
  content: "\\f276";
}
.fa-map-signs:before {
  content: "\\f277";
}
.fa-map-o:before {
  content: "\\f278";
}
.fa-map:before {
  content: "\\f279";
}
.fa-commenting:before {
  content: "\\f27a";
}
.fa-commenting-o:before {
  content: "\\f27b";
}
.fa-houzz:before {
  content: "\\f27c";
}
.fa-vimeo:before {
  content: "\\f27d";
}
.fa-black-tie:before {
  content: "\\f27e";
}
.fa-fonticons:before {
  content: "\\f280";
}
.fa-reddit-alien:before {
  content: "\\f281";
}
.fa-edge:before {
  content: "\\f282";
}
.fa-credit-card-alt:before {
  content: "\\f283";
}
.fa-codiepie:before {
  content: "\\f284";
}
.fa-modx:before {
  content: "\\f285";
}
.fa-fort-awesome:before {
  content: "\\f286";
}
.fa-usb:before {
  content: "\\f287";
}
.fa-product-hunt:before {
  content: "\\f288";
}
.fa-mixcloud:before {
  content: "\\f289";
}
.fa-scribd:before {
  content: "\\f28a";
}
.fa-pause-circle:before {
  content: "\\f28b";
}
.fa-pause-circle-o:before {
  content: "\\f28c";
}
.fa-stop-circle:before {
  content: "\\f28d";
}
.fa-stop-circle-o:before {
  content: "\\f28e";
}
.fa-shopping-bag:before {
  content: "\\f290";
}
.fa-shopping-basket:before {
  content: "\\f291";
}
.fa-hashtag:before {
  content: "\\f292";
}
.fa-bluetooth:before {
  content: "\\f293";
}
.fa-bluetooth-b:before {
  content: "\\f294";
}
.fa-percent:before {
  content: "\\f295";
}
.fa-gitlab:before {
  content: "\\f296";
}
.fa-wpbeginner:before {
  content: "\\f297";
}
.fa-wpforms:before {
  content: "\\f298";
}
.fa-envira:before {
  content: "\\f299";
}
.fa-universal-access:before {
  content: "\\f29a";
}
.fa-wheelchair-alt:before {
  content: "\\f29b";
}
.fa-question-circle-o:before {
  content: "\\f29c";
}
.fa-blind:before {
  content: "\\f29d";
}
.fa-audio-description:before {
  content: "\\f29e";
}
.fa-volume-control-phone:before {
  content: "\\f2a0";
}
.fa-braille:before {
  content: "\\f2a1";
}
.fa-assistive-listening-systems:before {
  content: "\\f2a2";
}
.fa-asl-interpreting:before,
.fa-american-sign-language-interpreting:before {
  content: "\\f2a3";
}
.fa-deafness:before,
.fa-hard-of-hearing:before,
.fa-deaf:before {
  content: "\\f2a4";
}
.fa-glide:before {
  content: "\\f2a5";
}
.fa-glide-g:before {
  content: "\\f2a6";
}
.fa-signing:before,
.fa-sign-language:before {
  content: "\\f2a7";
}
.fa-low-vision:before {
  content: "\\f2a8";
}
.fa-viadeo:before {
  content: "\\f2a9";
}
.fa-viadeo-square:before {
  content: "\\f2aa";
}
.fa-snapchat:before {
  content: "\\f2ab";
}
.fa-snapchat-ghost:before {
  content: "\\f2ac";
}
.fa-snapchat-square:before {
  content: "\\f2ad";
}
.fa-pied-piper:before {
  content: "\\f2ae";
}
.fa-first-order:before {
  content: "\\f2b0";
}
.fa-yoast:before {
  content: "\\f2b1";
}
.fa-themeisle:before {
  content: "\\f2b2";
}
.fa-google-plus-circle:before,
.fa-google-plus-official:before {
  content: "\\f2b3";
}
.fa-fa:before,
.fa-font-awesome:before {
  content: "\\f2b4";
}
.fa-handshake-o:before {
  content: "\\f2b5";
}
.fa-envelope-open:before {
  content: "\\f2b6";
}
.fa-envelope-open-o:before {
  content: "\\f2b7";
}
.fa-linode:before {
  content: "\\f2b8";
}
.fa-address-book:before {
  content: "\\f2b9";
}
.fa-address-book-o:before {
  content: "\\f2ba";
}
.fa-vcard:before,
.fa-address-card:before {
  content: "\\f2bb";
}
.fa-vcard-o:before,
.fa-address-card-o:before {
  content: "\\f2bc";
}
.fa-user-circle:before {
  content: "\\f2bd";
}
.fa-user-circle-o:before {
  content: "\\f2be";
}
.fa-user-o:before {
  content: "\\f2c0";
}
.fa-id-badge:before {
  content: "\\f2c1";
}
.fa-drivers-license:before,
.fa-id-card:before {
  content: "\\f2c2";
}
.fa-drivers-license-o:before,
.fa-id-card-o:before {
  content: "\\f2c3";
}
.fa-quora:before {
  content: "\\f2c4";
}
.fa-free-code-camp:before {
  content: "\\f2c5";
}
.fa-telegram:before {
  content: "\\f2c6";
}
.fa-thermometer-4:before,
.fa-thermometer:before,
.fa-thermometer-full:before {
  content: "\\f2c7";
}
.fa-thermometer-3:before,
.fa-thermometer-three-quarters:before {
  content: "\\f2c8";
}
.fa-thermometer-2:before,
.fa-thermometer-half:before {
  content: "\\f2c9";
}
.fa-thermometer-1:before,
.fa-thermometer-quarter:before {
  content: "\\f2ca";
}
.fa-thermometer-0:before,
.fa-thermometer-empty:before {
  content: "\\f2cb";
}
.fa-shower:before {
  content: "\\f2cc";
}
.fa-bathtub:before,
.fa-s15:before,
.fa-bath:before {
  content: "\\f2cd";
}
.fa-podcast:before {
  content: "\\f2ce";
}
.fa-window-maximize:before {
  content: "\\f2d0";
}
.fa-window-minimize:before {
  content: "\\f2d1";
}
.fa-window-restore:before {
  content: "\\f2d2";
}
.fa-times-rectangle:before,
.fa-window-close:before {
  content: "\\f2d3";
}
.fa-times-rectangle-o:before,
.fa-window-close-o:before {
  content: "\\f2d4";
}
.fa-bandcamp:before {
  content: "\\f2d5";
}
.fa-grav:before {
  content: "\\f2d6";
}
.fa-etsy:before {
  content: "\\f2d7";
}
.fa-imdb:before {
  content: "\\f2d8";
}
.fa-ravelry:before {
  content: "\\f2d9";
}
.fa-eercast:before {
  content: "\\f2da";
}
.fa-microchip:before {
  content: "\\f2db";
}
.fa-snowflake-o:before {
  content: "\\f2dc";
}
.fa-superpowers:before {
  content: "\\f2dd";
}
.fa-wpexplorer:before {
  content: "\\f2de";
}
.fa-meetup:before {
  content: "\\f2e0";
}
.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
}
.sr-only-focusable:active,
.sr-only-focusable:focus {
  position: static;
  width: auto;
  height: auto;
  margin: 0;
  overflow: visible;
  clip: auto;
}
.sr-only-focusable:active,
.sr-only-focusable:focus {
  position: static;
  width: auto;
  height: auto;
  margin: 0;
  overflow: visible;
  clip: auto;
}
/*!
*
* IPython base
*
*/
:root {
  --page-backdrop-color: #eee;
  --body-bg-hue: 0;
  --body-bg-saturation: 0%;
  --body-bg-light: 100%;
  --body-bg: hsl(var(--body-bg-hue), var(--body-bg-saturation), var(--body-bg-light));
  --body-bg-darken2pc: hsl(var(--body-bg-hue), var(--body-bg-saturation), calc(var(--body-bg-light) - 2%));
  --body-bg-darken3pc: hsl(var(--body-bg-hue), var(--body-bg-saturation), calc(var(--body-bg-light) - 3.2%));
  --body-bg-darken5pc: hsl(var(--body-bg-hue), var(--body-bg-saturation), calc(var(--body-bg-light) - 5%));
  --body-bg-darken10pc: hsl(var(--body-bg-hue), var(--body-bg-saturation), calc(var(--body-bg-light) - 10%));
  --body-bg-darken20pc: hsl(var(--body-bg-hue), var(--body-bg-saturation), calc(var(--body-bg-light) - 20%));
  --body-bg-darken30pc: hsl(var(--body-bg-hue), var(--body-bg-saturation), calc(var(--body-bg-light) - 30%));
  --header-bg: var(--body-bg);
  --rendered-html-border-color: black;
  --input-prompt-color: #303f9f;
  --output-prompt-color: #d84315;
  --output-stderr-bg-color: #fdd;
  --output-pre-color: black;
  --black: #000;
  --text-color: var(--black);
  --border-color: var(--body-bg-darken30pc);
  --light-border-color: var(--body-bg-darken20pc);
  --navbar-default-border: #e7e7e7;
  --navbar-default-bg: #f5f5f5;
  --navbar-default-link-color: #565656;
  --navbar-default-link-hover-color: #333;
  --btn-default-color: var(--navbar-default-link-hover-color);
  --btn-default-hover-color: var(--btn-default-color);
  --btn-default-bg-color: var(--header-bg);
  --btn-default-bg-hover-color: #e6e6e6;
  --btn-default-border-color: #ccc;
  --btn-default-border-hover-color: #adadad;
  --btn-default-active-hover-bg-color: #d4d4d4;
  --btn-default-active-hover-border-color: #8c8c8c;
  --menu-bg: var(--body-bg);
  --menu-bg-hover: #e7e7e7;
  --menu-fg: var(--btn-default-color);
  --menu-fg-hover: var(--navbar-default-link-hover-color);
  --code-bg-color: var(--menu-bg-hover);
  --edit-hover-color: var(--body-bg-darken10pc);
  --self-color: #05a;
  --table-bg-good: rgba(0, 255, 0, 0.23);
  --table-bg-bad: rgba(255, 0, 0, 0.23);
}
[data-theme="darcula"] {
  --page-backdrop-color: #3c3f41;
  --body-bg-light: 17%;
  --header-bg: #313335;
  --input-prompt-color: #307fc1;
  --output-prompt-color: #bf5b3d;
  --output-stderr-bg-color: rgba(244, 67, 54, 0.28);
  --output-pre-color: #bbbbbb;
  --black: #bbbbbb;
  --border-color: #616161;
  --light-border-color: #505050;
  --navbar-default-border: var(--border-color);
  --navbar-default-bg: var(--header-bg);
  --navbar-default-link-color: #a5a5a5;
  --navbar-default-link-hover-color: #cbcbcb;
  --btn-default-color: var(--navbar-default-link-color);
  --btn-default-border-color: var(--navbar-default-border);
  --menu-bg-hover: var(--page-backdrop-color);
  --btn-default-bg-hover-color: var(--page-backdrop-color);
  --btn-default-border-hover-color: var(--btn-default-border-color);
  --btn-default-active-hover-bg-color: var(--btn-default-bg-hover-color);
  --btn-default-active-hover-border-color: var(--btn-default-border-hover-color);
  --edit-hover-color: #555758;
  --rendered-html-border-color: var(--text-color);
  --self-color: #307fc1;
}
.modal.fade .modal-dialog {
  -webkit-transform: translate(0, 0);
  -ms-transform: translate(0, 0);
  -o-transform: translate(0, 0);
  transform: translate(0, 0);
}
code {
  color: var(--black);
}
pre {
  font-size: inherit;
  line-height: inherit;
}
label {
  font-weight: normal;
}
/* Make the page background atleast 100% the height of the view port */
/* Make the page itself atleast 70% the height of the view port */
.border-box-sizing {
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
}
.corner-all {
  border-radius: 2px;
}
.no-padding {
  padding: 0px;
}
/* Flexible box model classes */
/* Taken from Alex Russell http://infrequently.org/2009/08/css-3-progress/ */
/* This file is a compatibility layer.  It allows the usage of flexible box 
model layouts accross multiple browsers, including older browsers.  The newest,
universal implementation of the flexible box model is used when available (see
\`Modern browsers\` comments below).  Browsers that are known to implement this 
new spec completely include:

    Firefox 28.0+
    Chrome 29.0+
    Internet Explorer 11+ 
    Opera 17.0+

Browsers not listed, including Safari, are supported via the styling under the
\`Old browsers\` comments below.
*/
.hbox {
  /* Old browsers */
  display: -webkit-box;
  -webkit-box-orient: horizontal;
  -webkit-box-align: stretch;
  display: -moz-box;
  -moz-box-orient: horizontal;
  -moz-box-align: stretch;
  display: box;
  box-orient: horizontal;
  box-align: stretch;
  /* Modern browsers */
  display: flex;
  flex-direction: row;
  align-items: stretch;
}
.hbox > * {
  /* Old browsers */
  -webkit-box-flex: 0;
  -moz-box-flex: 0;
  box-flex: 0;
  /* Modern browsers */
  flex: none;
}
.vbox {
  /* Old browsers */
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-box-align: stretch;
  display: -moz-box;
  -moz-box-orient: vertical;
  -moz-box-align: stretch;
  display: box;
  box-orient: vertical;
  box-align: stretch;
  /* Modern browsers */
  display: flex;
  flex-direction: column;
  align-items: stretch;
}
.vbox > * {
  /* Old browsers */
  -webkit-box-flex: 0;
  -moz-box-flex: 0;
  box-flex: 0;
  /* Modern browsers */
  flex: none;
}
.hbox.reverse,
.vbox.reverse,
.reverse {
  /* Old browsers */
  -webkit-box-direction: reverse;
  -moz-box-direction: reverse;
  box-direction: reverse;
  /* Modern browsers */
  flex-direction: row-reverse;
}
.hbox.box-flex0,
.vbox.box-flex0,
.box-flex0 {
  /* Old browsers */
  -webkit-box-flex: 0;
  -moz-box-flex: 0;
  box-flex: 0;
  /* Modern browsers */
  flex: none;
  width: auto;
}
.hbox.box-flex1,
.vbox.box-flex1,
.box-flex1 {
  /* Old browsers */
  -webkit-box-flex: 1;
  -moz-box-flex: 1;
  box-flex: 1;
  /* Modern browsers */
  flex: 1;
}
.hbox.box-flex,
.vbox.box-flex,
.box-flex {
  /* Old browsers */
  /* Old browsers */
  -webkit-box-flex: 1;
  -moz-box-flex: 1;
  box-flex: 1;
  /* Modern browsers */
  flex: 1;
}
.hbox.box-flex2,
.vbox.box-flex2,
.box-flex2 {
  /* Old browsers */
  -webkit-box-flex: 2;
  -moz-box-flex: 2;
  box-flex: 2;
  /* Modern browsers */
  flex: 2;
}
.box-group1 {
  /*  Deprecated */
  -webkit-box-flex-group: 1;
  -moz-box-flex-group: 1;
  box-flex-group: 1;
}
.box-group2 {
  /* Deprecated */
  -webkit-box-flex-group: 2;
  -moz-box-flex-group: 2;
  box-flex-group: 2;
}
.hbox.start,
.vbox.start,
.start {
  /* Old browsers */
  -webkit-box-pack: start;
  -moz-box-pack: start;
  box-pack: start;
  /* Modern browsers */
  justify-content: flex-start;
}
.hbox.end,
.vbox.end,
.end {
  /* Old browsers */
  -webkit-box-pack: end;
  -moz-box-pack: end;
  box-pack: end;
  /* Modern browsers */
  justify-content: flex-end;
}
.hbox.center,
.vbox.center,
.center {
  /* Old browsers */
  -webkit-box-pack: center;
  -moz-box-pack: center;
  box-pack: center;
  /* Modern browsers */
  justify-content: center;
}
.hbox.baseline,
.vbox.baseline,
.baseline {
  /* Old browsers */
  -webkit-box-pack: baseline;
  -moz-box-pack: baseline;
  box-pack: baseline;
  /* Modern browsers */
  justify-content: baseline;
}
.hbox.stretch,
.vbox.stretch,
.stretch {
  /* Old browsers */
  -webkit-box-pack: stretch;
  -moz-box-pack: stretch;
  box-pack: stretch;
  /* Modern browsers */
  justify-content: stretch;
}
.hbox.align-start,
.vbox.align-start,
.align-start {
  /* Old browsers */
  -webkit-box-align: start;
  -moz-box-align: start;
  box-align: start;
  /* Modern browsers */
  align-items: flex-start;
}
.hbox.align-end,
.vbox.align-end,
.align-end {
  /* Old browsers */
  -webkit-box-align: end;
  -moz-box-align: end;
  box-align: end;
  /* Modern browsers */
  align-items: flex-end;
}
.hbox.align-center,
.vbox.align-center,
.align-center {
  /* Old browsers */
  -webkit-box-align: center;
  -moz-box-align: center;
  box-align: center;
  /* Modern browsers */
  align-items: center;
}
.hbox.align-baseline,
.vbox.align-baseline,
.align-baseline {
  /* Old browsers */
  -webkit-box-align: baseline;
  -moz-box-align: baseline;
  box-align: baseline;
  /* Modern browsers */
  align-items: baseline;
}
.hbox.align-stretch,
.vbox.align-stretch,
.align-stretch {
  /* Old browsers */
  -webkit-box-align: stretch;
  -moz-box-align: stretch;
  box-align: stretch;
  /* Modern browsers */
  align-items: stretch;
}
div.error {
  margin: 2em;
  text-align: center;
}
div.error > h1 {
  font-size: 500%;
  line-height: normal;
}
div.error > p {
  font-size: 200%;
  line-height: normal;
}
div.traceback-wrapper {
  text-align: left;
  max-width: 800px;
  margin: auto;
}
div.traceback-wrapper pre.traceback {
  max-height: 600px;
  overflow: auto;
}
/**
 * Primary styles
 *
 * Author: Jupyter Development Team
 */
.body {
  background-color: var(--body-bg);
  /* This makes sure that the body covers the entire window and needs to
       be in a different element than the display: box in wrapper below */
  position: absolute;
  left: 0px;
  right: 0px;
  top: 0px;
  bottom: 0px;
  overflow: visible;
  color: var(--text-color);
}
.body > #header {
  /* Initially hidden to prevent FLOUC */
  display: none;
  background-color: var(--header-bg);
  /* Display over codemirror */
  position: relative;
  z-index: 100;
}
.body > #header #header-container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 5px;
  padding-bottom: 5px;
  padding-top: 5px;
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
}
.body > #header .header-bar {
  width: 100%;
  height: 1px;
  background: var(--navbar-default-border);
  margin-bottom: -1px;
}
@media print {
  .body > #header {
    display: none !important;
  }
}
#header-spacer {
  width: 100%;
  visibility: hidden;
}
@media print {
  #header-spacer {
    display: none;
  }
}
#ipython_notebook {
  padding-left: 0px;
  padding-top: 2px / 2;
  padding-bottom: 2px / 2;
  margin-right: auto;
}
[dir="rtl"] #ipython_notebook {
  margin-right: 10px;
  margin-left: 0;
}
[dir="rtl"] #ipython_notebook.pull-left {
  float: right !important;
  float: right;
}
.flex-spacer {
  flex: 1;
}
#ipython_notebook img {
  height: 28px;
}
#site {
  width: 100%;
  display: none;
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  overflow: auto;
}
@media print {
  #site {
    height: auto !important;
  }
}
/* Smaller buttons */
.ui-button .ui-button-text {
  padding: 0.2em 0.8em;
  font-size: 77%;
}
input.ui-button {
  padding: 0.3em 0.9em;
}
span#kernel_logo_widget {
  margin: 0 10px;
  margin-left: auto;
}
span#login_widget {
  float: right;
}
[dir="rtl"] span#login_widget {
  float: left;
}
span#login_widget > .button,
#logout,
#shutdown {
  color: #333;
  background-color: #fff;
  border-color: #ccc;
  margin-left: 10px;
}
span#login_widget > .button:focus,
#logout:focus,
#shutdown:focus,
span#login_widget > .button.focus,
#logout.focus,
#shutdown.focus {
  color: #333;
  background-color: #e6e6e6;
  border-color: #8c8c8c;
}
span#login_widget > .button:hover,
#logout:hover,
#shutdown:hover {
  color: #333;
  background-color: #e6e6e6;
  border-color: #adadad;
}
span#login_widget > .button:active,
#logout:active,
#shutdown:active,
span#login_widget > .button.active,
#logout.active,
#shutdown.active,
.open > .dropdown-togglespan#login_widget > .button,
.open > .dropdown-toggle#logout,
.open > .dropdown-toggle#shutdown {
  color: #333;
  background-color: #e6e6e6;
  background-image: none;
  border-color: #adadad;
}
span#login_widget > .button:active:hover,
#logout:active:hover,
#shutdown:active:hover,
span#login_widget > .button.active:hover,
#logout.active:hover,
#shutdown.active:hover,
.open > .dropdown-togglespan#login_widget > .button:hover,
.open > .dropdown-toggle#logout:hover,
.open > .dropdown-toggle#shutdown:hover,
span#login_widget > .button:active:focus,
#logout:active:focus,
#shutdown:active:focus,
span#login_widget > .button.active:focus,
#logout.active:focus,
#shutdown.active:focus,
.open > .dropdown-togglespan#login_widget > .button:focus,
.open > .dropdown-toggle#logout:focus,
.open > .dropdown-toggle#shutdown:focus,
span#login_widget > .button:active.focus,
#logout:active.focus,
#shutdown:active.focus,
span#login_widget > .button.active.focus,
#logout.active.focus,
#shutdown.active.focus,
.open > .dropdown-togglespan#login_widget > .button.focus,
.open > .dropdown-toggle#logout.focus,
.open > .dropdown-toggle#shutdown.focus {
  color: #333;
  background-color: #d4d4d4;
  border-color: #8c8c8c;
}
span#login_widget > .button.disabled:hover,
#logout.disabled:hover,
#shutdown.disabled:hover,
span#login_widget > .button[disabled]:hover,
#logout[disabled]:hover,
#shutdown[disabled]:hover,
fieldset[disabled] span#login_widget > .button:hover,
fieldset[disabled] #logout:hover,
fieldset[disabled] #shutdown:hover,
span#login_widget > .button.disabled:focus,
#logout.disabled:focus,
#shutdown.disabled:focus,
span#login_widget > .button[disabled]:focus,
#logout[disabled]:focus,
#shutdown[disabled]:focus,
fieldset[disabled] span#login_widget > .button:focus,
fieldset[disabled] #logout:focus,
fieldset[disabled] #shutdown:focus,
span#login_widget > .button.disabled.focus,
#logout.disabled.focus,
#shutdown.disabled.focus,
span#login_widget > .button[disabled].focus,
#logout[disabled].focus,
#shutdown[disabled].focus,
fieldset[disabled] span#login_widget > .button.focus,
fieldset[disabled] #logout.focus,
fieldset[disabled] #shutdown.focus {
  background-color: #fff;
  border-color: #ccc;
}
span#login_widget > .button .badge,
#logout .badge,
#shutdown .badge {
  color: #fff;
  background-color: #333;
}
.nav-header {
  text-transform: none;
}
#header > span {
  margin-top: 10px;
}
.modal_stretch .modal-dialog {
  /* Old browsers */
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-box-align: stretch;
  display: -moz-box;
  -moz-box-orient: vertical;
  -moz-box-align: stretch;
  display: box;
  box-orient: vertical;
  box-align: stretch;
  /* Modern browsers */
  display: flex;
  flex-direction: column;
  align-items: stretch;
  min-height: 80vh;
}
.modal_stretch .modal-dialog .modal-body {
  max-height: calc(100vh - 200px);
  overflow: auto;
  flex: 1;
}
.modal-header {
  cursor: move;
}
@media (min-width: 768px) {
  .modal .modal-dialog {
    width: 700px;
  }
}
@media (min-width: 768px) {
  select.form-control {
    margin-left: 12px;
    margin-right: 12px;
  }
}
/* rtl fixes for the error, connecting, and renaming window */
[dir="rtl"] .modal-footer {
  text-align: left !important;
}
[dir="rtl"] .close {
  float: left;
}
[dir="rtl"] .fa-step-forward::before {
  content: "\\f048";
}
/*!
*
* IPython notebook
*
*/
/* CSS font colors for translated ANSI escape sequences */
/* The color values are a mix of
   http://www.xcolors.net/dl/baskerville-ivorylight and
   http://www.xcolors.net/dl/euphrasia */
.ansi-black-fg {
  color: #3E424D;
}
.ansi-black-bg {
  background-color: #3E424D;
}
.ansi-black-intense-fg {
  color: #282C36;
}
.ansi-black-intense-bg {
  background-color: #282C36;
}
.ansi-red-fg {
  color: #E75C58;
}
.ansi-red-bg {
  background-color: #E75C58;
}
.ansi-red-intense-fg {
  color: #B22B31;
}
.ansi-red-intense-bg {
  background-color: #B22B31;
}
.ansi-green-fg {
  color: #00A250;
}
.ansi-green-bg {
  background-color: #00A250;
}
.ansi-green-intense-fg {
  color: #007427;
}
.ansi-green-intense-bg {
  background-color: #007427;
}
.ansi-yellow-fg {
  color: #DDB62B;
}
.ansi-yellow-bg {
  background-color: #DDB62B;
}
.ansi-yellow-intense-fg {
  color: #B27D12;
}
.ansi-yellow-intense-bg {
  background-color: #B27D12;
}
.ansi-blue-fg {
  color: #208FFB;
}
.ansi-blue-bg {
  background-color: #208FFB;
}
.ansi-blue-intense-fg {
  color: #0065CA;
}
.ansi-blue-intense-bg {
  background-color: #0065CA;
}
.ansi-magenta-fg {
  color: #D160C4;
}
.ansi-magenta-bg {
  background-color: #D160C4;
}
.ansi-magenta-intense-fg {
  color: #A03196;
}
.ansi-magenta-intense-bg {
  background-color: #A03196;
}
.ansi-cyan-fg {
  color: #60C6C8;
}
.ansi-cyan-bg {
  background-color: #60C6C8;
}
.ansi-cyan-intense-fg {
  color: #258F8F;
}
.ansi-cyan-intense-bg {
  background-color: #258F8F;
}
.ansi-white-fg {
  color: #C5C1B4;
}
.ansi-white-bg {
  background-color: #C5C1B4;
}
.ansi-white-intense-fg {
  color: #A1A6B2;
}
.ansi-white-intense-bg {
  background-color: #A1A6B2;
}
.ansi-default-inverse-fg {
  color: #FFFFFF;
}
.ansi-default-inverse-bg {
  background-color: #000000;
}
.ansi-bold {
  font-weight: bold;
}
.ansi-underline {
  text-decoration: underline;
}
div.cell {
  /* Old browsers */
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-box-align: stretch;
  display: -moz-box;
  -moz-box-orient: vertical;
  -moz-box-align: stretch;
  display: box;
  box-orient: vertical;
  box-align: stretch;
  /* Modern browsers */
  display: flex;
  flex-direction: column;
  align-items: stretch;
  border-radius: 2px;
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  border-width: 1px;
  border-style: solid;
  border-color: transparent;
  width: 100%;
  padding: 5px;
  /* This acts as a spacer between cells, that is outside the border */
  margin: 0px;
  outline: none;
  position: relative;
  overflow: visible;
}
div.cell:before {
  position: absolute;
  display: block;
  top: -1px;
  left: -1px;
  width: 5px;
  height: calc(100% +  2 * 1px);
  content: '';
  background: transparent;
}
div.cell.jupyter-soft-selected {
  border-left-color: #E3F2FD;
  border-left-width: 1px;
  padding-left: 5px;
  border-right-color: #E3F2FD;
  border-right-width: 1px;
  background: #E3F2FD;
}
@media print {
  div.cell.jupyter-soft-selected {
    border-color: transparent;
  }
}
div.cell.selected,
div.cell.selected.jupyter-soft-selected {
  border-color: var(--border-color);
}
div.cell.selected:before,
div.cell.selected.jupyter-soft-selected:before {
  position: absolute;
  display: block;
  top: -1px;
  left: -1px;
  width: 5px;
  height: calc(100% +  2 * 1px);
  content: '';
  background: #42A5F5;
}
@media print {
  div.cell.selected,
  div.cell.selected.jupyter-soft-selected {
    border-color: transparent;
  }
}
.edit_mode div.cell.selected {
  border-color: #66BB6A;
}
.edit_mode div.cell.selected:before {
  position: absolute;
  display: block;
  top: -1px;
  left: -1px;
  width: 5px;
  height: calc(100% +  2 * 1px);
  content: '';
  background: #66BB6A;
}
@media print {
  .edit_mode div.cell.selected {
    border-color: transparent;
  }
}
.prompt {
  /* This needs to be wide enough for 3 digit prompt numbers: In[100]: */
  min-width: 14ex;
  /* This padding is tuned to match the padding on the CodeMirror editor. */
  padding: 0.4em;
  margin: 0px;
  font-family: monospace;
  text-align: right;
  /* This has to match that of the the CodeMirror class line-height below */
  line-height: 1.21429em;
  /* Don't highlight prompt number selection */
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  /* Use default cursor */
  cursor: default;
}
@media (max-width: 540px) {
  .prompt {
    text-align: left;
  }
}
div.inner_cell {
  min-width: 0;
  /* Old browsers */
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-box-align: stretch;
  display: -moz-box;
  -moz-box-orient: vertical;
  -moz-box-align: stretch;
  display: box;
  box-orient: vertical;
  box-align: stretch;
  /* Modern browsers */
  display: flex;
  flex-direction: column;
  align-items: stretch;
  /* Old browsers */
  -webkit-box-flex: 1;
  -moz-box-flex: 1;
  box-flex: 1;
  /* Modern browsers */
  flex: 1;
}
/* input_area and input_prompt must match in top border and margin for alignment */
div.input_area {
  border: 1px solid var(--light-border-color);
  border-radius: 2px;
  background: var(--body-bg-darken3pc);
  line-height: 1.21429em;
}
/* This is needed so that empty prompt areas can collapse to zero height when there
   is no content in the output_subarea and the prompt. The main purpose of this is
   to make sure that empty JavaScript output_subareas have no height. */
div.prompt:empty {
  padding-top: 0;
  padding-bottom: 0;
}
div.unrecognized_cell {
  padding: 5px 5px 5px 0px;
  /* Old browsers */
  display: -webkit-box;
  -webkit-box-orient: horizontal;
  -webkit-box-align: stretch;
  display: -moz-box;
  -moz-box-orient: horizontal;
  -moz-box-align: stretch;
  display: box;
  box-orient: horizontal;
  box-align: stretch;
  /* Modern browsers */
  display: flex;
  flex-direction: row;
  align-items: stretch;
}
div.unrecognized_cell .inner_cell {
  border-radius: 2px;
  padding: 5px;
  font-weight: bold;
  color: red;
  border: 1px solid var(--light-border-color);
  background: hsl(var(--body-bg-hue), var(--body-bg-saturation), calc(var(--body-bg-light) - 8.2%));
}
div.unrecognized_cell .inner_cell a {
  color: inherit;
  text-decoration: none;
}
div.unrecognized_cell .inner_cell a:hover {
  color: inherit;
  text-decoration: none;
}
@media (max-width: 540px) {
  div.unrecognized_cell > div.prompt {
    display: none;
  }
}
div.code_cell {
  /* avoid page breaking on code cells when printing */
}
@media print {
  div.code_cell {
    page-break-inside: avoid;
  }
}
/* any special styling for code cells that are currently running goes here */
div.input {
  page-break-inside: avoid;
  /* Old browsers */
  display: -webkit-box;
  -webkit-box-orient: horizontal;
  -webkit-box-align: stretch;
  display: -moz-box;
  -moz-box-orient: horizontal;
  -moz-box-align: stretch;
  display: box;
  box-orient: horizontal;
  box-align: stretch;
  /* Modern browsers */
  display: flex;
  flex-direction: row;
  align-items: stretch;
}
@media (max-width: 540px) {
  div.input {
    /* Old browsers */
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-box-align: stretch;
    display: -moz-box;
    -moz-box-orient: vertical;
    -moz-box-align: stretch;
    display: box;
    box-orient: vertical;
    box-align: stretch;
    /* Modern browsers */
    display: flex;
    flex-direction: column;
    align-items: stretch;
  }
}
div.prompt_container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  text-align: right;
}
/* input_area and input_prompt must match in top border and margin for alignment */
div.input_prompt {
  color: var(--input-prompt-color);
  border-top: 1px solid transparent;
}
div.run_this_cell {
  display: none;
  cursor: pointer;
  color: #333;
  padding-top: 5px;
  padding-bottom: 5px;
  padding-left: 2ex;
  padding-right: 2ex;
  width: 1ex;
}
div.prompt {
  min-width: 15ex;
}
@media (-moz-touch-enabled: 1), (any-pointer: coarse) {
  div.run_this_cell {
    display: block;
  }
}
div.input_area > div.highlight {
  margin: 0.4em;
  border: none;
  padding: 0px;
  background-color: transparent;
}
div.input_area > div.highlight > pre {
  margin: 0px;
  border: none;
  padding: 0px;
  background-color: transparent;
}
/* The following gets added to the <head> if it is detected that the user has a
 * monospace font with inconsistent normal/bold/italic height.  See
 * notebookmain.js.  Such fonts will have keywords vertically offset with
 * respect to the rest of the text.  The user should select a better font.
 * See: https://github.com/ipython/ipython/issues/1503
 *
 * .CodeMirror span {
 *      vertical-align: bottom;
 * }
 */
.CodeMirror {
  line-height: 1.21429em;
  /* Changed from 1em to our global default */
  font-size: 14px;
  height: auto;
  /* Changed to auto to autogrow */
  background: none;
  /* Changed from white to allow our bg to show through */
}
.CodeMirror-scroll {
  /*  The CodeMirror docs are a bit fuzzy on if overflow-y should be hidden or visible.*/
  /*  We have found that if it is visible, vertical scrollbars appear with font size changes.*/
  overflow-y: hidden;
  overflow-x: auto;
}
.CodeMirror-lines {
  /* In CM2, this used to be 0.4em, but in CM3 it went to 4px. We need the em value because */
  /* we have set a different line-height and want this to scale with that. */
  /* Note that this should set vertical padding only, since CodeMirror assumes
       that horizontal padding will be set on CodeMirror pre */
  padding: 0.4em 0;
}
.CodeMirror-linenumber {
  padding: 0 8px 0 4px;
}
.CodeMirror-gutters {
  border-bottom-left-radius: 2px;
  border-top-left-radius: 2px;
}
.CodeMirror pre {
  /* In CM3 this went to 4px from 0 in CM2. This sets horizontal padding only,
    use .CodeMirror-lines for vertical */
  padding: 0 0.4em;
  border: 0;
  border-radius: 0;
}
.CodeMirror-cursor {
  border-left: 1.4px solid black;
}
@media screen and (min-width: 2138px) and (max-width: 4319px) {
  .CodeMirror-cursor {
    border-left: 2px solid black;
  }
}
@media screen and (min-width: 4320px) {
  .CodeMirror-cursor {
    border-left: 4px solid black;
  }
}
/*

Original style from softwaremaniacs.org (c) Ivan Sagalaev <Maniac@SoftwareManiacs.Org>
Adapted from GitHub theme

*/
.highlight-base {
  color: #000;
}
.highlight-variable {
  color: #000;
}
.highlight-variable-2 {
  color: var(--self-color);
}
.highlight-variable-3 {
  color: #333333;
}
.highlight-string {
  color: #ba2121;
}
.highlight-comment {
  color: #007979;
  font-style: italic;
}
.highlight-number {
  color: #080;
}
.highlight-atom {
  color: #88f;
}
.highlight-keyword {
  color: #008000;
  font-weight: bold;
}
.highlight-builtin {
  color: #008000;
}
.highlight-error {
  color: #f00;
}
.highlight-operator {
  color: #aa22ff;
  font-weight: bold;
}
.highlight-meta {
  color: #aa22ff;
}
/* previously not defined, copying from default codemirror */
.highlight-def {
  color: #00f;
}
.highlight-string-2 {
  color: #f50;
}
.highlight-qualifier {
  color: #555;
}
.highlight-bracket {
  color: #997;
}
.highlight-tag {
  color: #170;
}
.highlight-attribute {
  color: #00c;
}
.highlight-header {
  color: blue;
}
.highlight-quote {
  color: #090;
}
.highlight-link {
  color: #00c;
}
/* apply the same style to codemirror */
.cm-s-ipython span.cm-keyword {
  color: #008000;
  font-weight: bold;
}
.cm-s-ipython span.cm-atom {
  color: #88f;
}
.cm-s-ipython span.cm-number {
  color: #080;
}
.cm-s-ipython span.cm-def {
  color: #00f;
}
.cm-s-ipython span.cm-variable {
  color: #000;
}
.cm-s-ipython span.cm-operator {
  color: #aa22ff;
  font-weight: bold;
}
.cm-s-ipython span.cm-variable-2 {
  color: var(--self-color);
}
.cm-s-ipython span.cm-variable-3 {
  color: #333333;
}
.cm-s-ipython span.cm-comment {
  color: #007979;
  font-style: italic;
}
.cm-s-ipython span.cm-string {
  color: #ba2121;
}
.cm-s-ipython span.cm-string-2 {
  color: #f50;
}
.cm-s-ipython span.cm-meta {
  color: #aa22ff;
}
.cm-s-ipython span.cm-qualifier {
  color: #555;
}
.cm-s-ipython span.cm-builtin {
  color: #008000;
}
.cm-s-ipython span.cm-bracket {
  color: #997;
}
.cm-s-ipython span.cm-tag {
  color: #170;
}
.cm-s-ipython span.cm-attribute {
  color: #00c;
}
.cm-s-ipython span.cm-header {
  color: blue;
}
.cm-s-ipython span.cm-quote {
  color: #090;
}
.cm-s-ipython span.cm-link {
  color: #00c;
}
.cm-s-ipython span.cm-error {
  color: #f00;
}
.cm-s-ipython span.cm-tab {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
  background-position: right;
  background-repeat: no-repeat;
}
div.output_wrapper {
  /* this position must be relative to enable descendents to be absolute within it */
  position: relative;
  /* Old browsers */
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-box-align: stretch;
  display: -moz-box;
  -moz-box-orient: vertical;
  -moz-box-align: stretch;
  display: box;
  box-orient: vertical;
  box-align: stretch;
  /* Modern browsers */
  display: flex;
  flex-direction: column;
  align-items: stretch;
  z-index: 1;
}
/* class for the output area when it should be height-limited */
div.output_scroll {
  /* ideally, this would be max-height, but FF barfs all over that */
  height: 24em;
  /* FF needs this *and the wrapper* to specify full width, or it will shrinkwrap */
  width: 100%;
  overflow: auto;
  border-radius: 2px;
  -webkit-box-shadow: inset 0 2px 8px rgba(0, 0, 0, 0.8);
  box-shadow: inset 0 2px 8px rgba(0, 0, 0, 0.8);
  display: block;
}
/* output div while it is collapsed */
div.output_collapsed {
  margin: 0px;
  padding: 0px;
  /* Old browsers */
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-box-align: stretch;
  display: -moz-box;
  -moz-box-orient: vertical;
  -moz-box-align: stretch;
  display: box;
  box-orient: vertical;
  box-align: stretch;
  /* Modern browsers */
  display: flex;
  flex-direction: column;
  align-items: stretch;
}
div.out_prompt_overlay {
  height: 100%;
  padding: 0px 0.4em;
  position: absolute;
  border-radius: 2px;
}
div.out_prompt_overlay:hover {
  /* use inner shadow to get border that is computed the same on WebKit/FF */
  -webkit-box-shadow: inset 0 0 1px #000;
  box-shadow: inset 0 0 1px #000;
  background: rgba(240, 240, 240, 0.5);
}
div.output_prompt {
  color: var(--output-prompt-color);
}
/* This class is the outer container of all output sections. */
div.output_area {
  padding: 0px;
  page-break-inside: avoid;
  /* Old browsers */
  display: -webkit-box;
  -webkit-box-orient: horizontal;
  -webkit-box-align: stretch;
  display: -moz-box;
  -moz-box-orient: horizontal;
  -moz-box-align: stretch;
  display: box;
  box-orient: horizontal;
  box-align: stretch;
  /* Modern browsers */
  display: flex;
  flex-direction: row;
  align-items: stretch;
  /* Basthon: better rendering for animation controls in FuncAnimation.to_jshtml */
}
div.output_area .MathJax_Display {
  text-align: center !important;
}
div.output_area .rendered_html table {
  margin-left: 0;
  margin-right: 0;
}
div.output_area .rendered_html img {
  margin-left: 0;
  margin-right: 0;
}
div.output_area img,
div.output_area svg {
  max-width: 100%;
  height: auto;
}
div.output_area img.unconfined,
div.output_area svg.unconfined {
  max-width: none;
}
div.output_area .mglyph > img {
  max-width: none;
}
div.output_area .output_subarea .animation .anim-controls .anim-buttons button {
  padding: 5px 10px;
  width: unset;
}
/* This is needed to protect the pre formating from global settings such
   as that of bootstrap */
.output {
  /* Old browsers */
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-box-align: stretch;
  display: -moz-box;
  -moz-box-orient: vertical;
  -moz-box-align: stretch;
  display: box;
  box-orient: vertical;
  box-align: stretch;
  /* Modern browsers */
  display: flex;
  flex-direction: column;
  align-items: stretch;
}
@media (max-width: 540px) {
  div.output_area {
    /* Old browsers */
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-box-align: stretch;
    display: -moz-box;
    -moz-box-orient: vertical;
    -moz-box-align: stretch;
    display: box;
    box-orient: vertical;
    box-align: stretch;
    /* Modern browsers */
    display: flex;
    flex-direction: column;
    align-items: stretch;
  }
}
div.output_area pre {
  margin: 0;
  padding: 1px 0 1px 0;
  border: 0;
  vertical-align: baseline;
  color: var(--output-pre-color);
  background-color: transparent;
  border-radius: 0;
}
/* This class is for the output subarea inside the output_area and after
   the prompt div. */
div.output_subarea {
  overflow-x: auto;
  padding: 0.4em;
  /* Old browsers */
  -webkit-box-flex: 1;
  -moz-box-flex: 1;
  box-flex: 1;
  /* Modern browsers */
  flex: 1;
  max-width: calc(100% - 14ex);
}
div.output_scroll div.output_subarea {
  overflow-x: visible;
}
/* The rest of the output_* classes are for special styling of the different
   output types */
/* all text output has this class: */
div.output_text {
  text-align: left;
  color: black;
  /* This has to match that of the the CodeMirror class line-height below */
  line-height: 1.21429em;
}
/* stdout/stderr are 'text' as well as 'stream', but execute_result/error are *not* streams */
div.output_stderr {
  background: var(--output-stderr-bg-color);
  /* very light red background for stderr */
}
div.output_latex {
  text-align: left;
}
/* Empty output_javascript divs should have no height */
div.output_javascript:empty {
  padding: 0;
}
.js-error {
  color: darkred;
}
/* raw_input styles */
div.raw_input_container {
  line-height: 1.21429em;
  padding-top: 5px;
}
pre.raw_input_prompt {
  /* nothing needed here. */
}
input.raw_input {
  font-family: monospace;
  font-size: inherit;
  color: inherit;
  width: auto;
  /* make sure input baseline aligns with prompt */
  vertical-align: baseline;
  /* padding + margin = 0.5em between prompt and cursor */
  padding: 0em 0.25em;
  margin: 0em 0.25em;
}
input.raw_input:focus {
  box-shadow: none;
}
p.p-space {
  margin-bottom: 10px;
}
div.output_unrecognized {
  padding: 5px;
  font-weight: bold;
  color: red;
}
div.output_unrecognized a {
  color: inherit;
  text-decoration: none;
}
div.output_unrecognized a:hover {
  color: inherit;
  text-decoration: none;
}
.rendered_html {
  color: black;
  /* any extras will just be numbers: */
}
.rendered_html em {
  font-style: italic;
}
.rendered_html strong {
  font-weight: bold;
}
.rendered_html u {
  text-decoration: underline;
}
.rendered_html :link {
  text-decoration: underline;
}
.rendered_html :visited {
  text-decoration: underline;
}
.rendered_html h1 {
  font-size: 185.7%;
  margin: 1.08em 0 0 0;
  font-weight: bold;
  line-height: 1;
}
.rendered_html h2 {
  font-size: 157.1%;
  margin: 1.27em 0 0 0;
  font-weight: bold;
  line-height: 1;
}
.rendered_html h3 {
  font-size: 128.6%;
  margin: 1.55em 0 0 0;
  font-weight: bold;
  line-height: 1;
}
.rendered_html h4 {
  font-size: 100%;
  margin: 2em 0 0 0;
  font-weight: bold;
  line-height: 1;
}
.rendered_html h5 {
  font-size: 100%;
  margin: 2em 0 0 0;
  font-weight: bold;
  line-height: 1;
  font-style: italic;
}
.rendered_html h6 {
  font-size: 100%;
  margin: 2em 0 0 0;
  font-weight: bold;
  line-height: 1;
  font-style: italic;
}
.rendered_html h1:first-child {
  margin-top: 0.538em;
}
.rendered_html h2:first-child {
  margin-top: 0.636em;
}
.rendered_html h3:first-child {
  margin-top: 0.777em;
}
.rendered_html h4:first-child {
  margin-top: 1em;
}
.rendered_html h5:first-child {
  margin-top: 1em;
}
.rendered_html h6:first-child {
  margin-top: 1em;
}
.rendered_html ul:not(.list-inline),
.rendered_html ol:not(.list-inline) {
  padding-left: 2em;
}
.rendered_html ul {
  list-style: disc;
}
.rendered_html ul ul {
  list-style: square;
  margin-top: 0;
}
.rendered_html ul ul ul {
  list-style: circle;
}
.rendered_html ol {
  list-style: decimal;
}
.rendered_html ol ol {
  list-style: upper-alpha;
  margin-top: 0;
}
.rendered_html ol ol ol {
  list-style: lower-alpha;
}
.rendered_html ol ol ol ol {
  list-style: lower-roman;
}
.rendered_html ol ol ol ol ol {
  list-style: decimal;
}
.rendered_html * + ul {
  margin-top: 1em;
}
.rendered_html * + ol {
  margin-top: 1em;
}
.rendered_html hr {
  color: var(--rendered-html-border-color);
  background-color: var(--rendered-html-border-color);
}
.rendered_html pre {
  margin: 1em 2em;
  padding: 0px;
  background-color: var(--body-bg);
}
.rendered_html code {
  background-color: #eff0f1;
}
.rendered_html p code {
  padding: 1px 5px;
}
.rendered_html pre code {
  background-color: var(--body-bg);
}
.rendered_html pre,
.rendered_html code {
  border: 0;
  color: black;
  font-size: 100%;
}
.rendered_html blockquote {
  margin: 1em 2em;
}
.rendered_html table {
  margin-left: auto;
  margin-right: auto;
  border: none;
  border-collapse: collapse;
  border-spacing: 0;
  color: var(--rendered-html-border-color);
  font-size: 12px;
  table-layout: fixed;
}
.rendered_html thead {
  border-bottom: 1px solid var(--rendered-html-border-color);
  vertical-align: bottom;
}
.rendered_html tr,
.rendered_html th,
.rendered_html td {
  text-align: right;
  vertical-align: middle;
  padding: 0.5em 0.5em;
  line-height: normal;
  white-space: normal;
  max-width: none;
  border: none;
}
.rendered_html td[align="left"] {
  text-align: left;
}
.rendered_html td[align="center"] {
  text-align: center;
}
.rendered_html td[align="right"] {
  text-align: right;
}
.rendered_html th {
  font-weight: bold;
}
.rendered_html tbody tr:nth-child(odd) {
  background: #f5f5f5;
}
.rendered_html tbody tr:hover {
  background: rgba(66, 165, 245, 0.2);
}
.rendered_html * + table {
  margin-top: 1em;
}
.rendered_html p {
  text-align: left;
}
.rendered_html * + p {
  margin-top: 1em;
}
.rendered_html img {
  display: block;
  margin-left: auto;
  margin-right: auto;
}
.rendered_html * + img {
  margin-top: 1em;
}
.rendered_html img,
.rendered_html svg {
  max-width: 100%;
  height: auto;
}
.rendered_html img.unconfined,
.rendered_html svg.unconfined {
  max-width: none;
}
.rendered_html .alert {
  margin-bottom: initial;
}
.rendered_html * + .alert {
  margin-top: 1em;
}
[dir="rtl"] .rendered_html p {
  text-align: right;
}
div.text_cell {
  /* Old browsers */
  display: -webkit-box;
  -webkit-box-orient: horizontal;
  -webkit-box-align: stretch;
  display: -moz-box;
  -moz-box-orient: horizontal;
  -moz-box-align: stretch;
  display: box;
  box-orient: horizontal;
  box-align: stretch;
  /* Modern browsers */
  display: flex;
  flex-direction: row;
  align-items: stretch;
}
@media (max-width: 540px) {
  div.text_cell > div.prompt {
    display: none;
  }
}
div.text_cell_render {
  /*font-family: "Helvetica Neue", Arial, Helvetica, Geneva, sans-serif;*/
  outline: none;
  resize: none;
  width: inherit;
  border-style: none;
  padding: 0.5em 0.5em 0.5em 0.4em;
  color: black;
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
}
a.anchor-link:link {
  text-decoration: none;
  padding: 0px 20px;
  visibility: hidden;
}
h1:hover .anchor-link,
h2:hover .anchor-link,
h3:hover .anchor-link,
h4:hover .anchor-link,
h5:hover .anchor-link,
h6:hover .anchor-link {
  visibility: visible;
}
.text_cell.rendered .input_area {
  display: none;
}
.text_cell.rendered .rendered_html {
  overflow-x: auto;
  overflow-y: hidden;
}
.text_cell.rendered .rendered_html tr,
.text_cell.rendered .rendered_html th,
.text_cell.rendered .rendered_html td {
  max-width: none;
}
.text_cell.unrendered .text_cell_render {
  display: none;
}
.text_cell .dropzone .input_area {
  border: 2px dashed #bababa;
  margin: -1px;
}
.cm-header-1,
.cm-header-2,
.cm-header-3,
.cm-header-4,
.cm-header-5,
.cm-header-6 {
  font-weight: bold;
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
}
.cm-header-1 {
  font-size: 185.7%;
}
.cm-header-2 {
  font-size: 157.1%;
}
.cm-header-3 {
  font-size: 128.6%;
}
.cm-header-4 {
  font-size: 110%;
}
.cm-header-5 {
  font-size: 100%;
  font-style: italic;
}
.cm-header-6 {
  font-size: 100%;
  font-style: italic;
}
/*!
*
* IPython notebook webapp
*
*/
@media (max-width: 767px) {
  .notebook_app {
    padding-left: 0px;
    padding-right: 0px;
  }
}
#ipython-main-app {
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  height: 100%;
}
div#notebook_panel {
  margin: 0px;
  padding: 0px;
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  height: 100%;
}
div#notebook {
  font-size: 14px;
  line-height: 20px;
  overflow-y: hidden;
  overflow-x: auto;
  width: 100%;
  /* This spaces the page away from the edge of the notebook area */
  padding-top: 20px;
  padding-bottom: 20px;
  margin: 0px;
  outline: none;
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  min-height: 100%;
}
@media not print {
  #notebook-container {
    padding: 15px;
    background-color: var(--body-bg);
    min-height: 0;
    -webkit-box-shadow: 0px 0px 12px 1px rgba(87, 87, 87, 0.2);
    box-shadow: 0px 0px 12px 1px rgba(87, 87, 87, 0.2);
  }
}
@media print {
  #notebook-container {
    width: 100%;
  }
}
div.ui-widget-content {
  border: 1px solid var(--border-color);
  outline: none;
}
pre.dialog {
  background-color: var(--body-bg-darken3pc);
  border: 1px solid #ddd;
  border-radius: 2px;
  padding: 0.4em;
  padding-left: 2em;
}
p.dialog {
  padding: 0.2em;
}
/* Word-wrap output correctly.  This is the CSS3 spelling, though Firefox seems
   to not honor it correctly.  Webkit browsers (Chrome, rekonq, Safari) do.
 */
pre,
code,
kbd,
samp {
  white-space: pre-wrap;
}
#fonttest {
  font-family: monospace;
}
p {
  margin-bottom: 0;
}
.end_space {
  min-height: 100px;
}
.notebook_app > #header {
  -webkit-box-shadow: 0px 0px 12px 1px rgba(87, 87, 87, 0.2);
  box-shadow: 0px 0px 12px 1px rgba(87, 87, 87, 0.2);
}
@media not print {
  .notebook_app {
    background-color: var(--page-backdrop-color);
  }
}
kbd {
  border-style: solid;
  border-width: 1px;
  box-shadow: none;
  margin: 2px;
  padding-left: 2px;
  padding-right: 2px;
  padding-top: 1px;
  padding-bottom: 1px;
}
.jupyter-keybindings {
  padding: 1px;
  line-height: 24px;
  border-bottom: 1px solid gray;
}
.jupyter-keybindings input {
  margin: 0;
  padding: 0;
  border: none;
}
.jupyter-keybindings i {
  padding: 6px;
}
.well code {
  background-color: hsl(var(--body-bg-hue), var(--body-bg-saturation), calc(var(--body-bg-light) + 1.8%));
  border-color: var(--border-color);
  border-width: 1px;
  border-style: solid;
  padding: 2px;
  padding-top: 1px;
  padding-bottom: 1px;
}
/* CSS for the cell toolbar */
.celltoolbar {
  border: thin solid var(--btn-default-border-color);
  border-bottom: none;
  background: var(--page-backdrop-color);
  border-radius: 2px 2px 0px 0px;
  width: 100%;
  height: 29px;
  padding-right: 4px;
  /* Old browsers */
  display: -webkit-box;
  -webkit-box-orient: horizontal;
  -webkit-box-align: stretch;
  display: -moz-box;
  -moz-box-orient: horizontal;
  -moz-box-align: stretch;
  display: box;
  box-orient: horizontal;
  box-align: stretch;
  /* Modern browsers */
  display: flex;
  flex-direction: row;
  align-items: stretch;
  /* Old browsers */
  -webkit-box-pack: end;
  -moz-box-pack: end;
  box-pack: end;
  /* Modern browsers */
  justify-content: flex-end;
  display: -webkit-flex;
}
@media print {
  .celltoolbar {
    display: none;
  }
}
.ctb_hideshow {
  display: none;
  vertical-align: bottom;
}
/* ctb_show is added to the ctb_hideshow div to show the cell toolbar.
   Cell toolbars are only shown when the ctb_global_show class is also set.
*/
.ctb_global_show .ctb_show.ctb_hideshow {
  display: block;
}
.ctb_global_show .ctb_show + .input_area,
.ctb_global_show .ctb_show + div.text_cell_input,
.ctb_global_show .ctb_show ~ div.text_cell_render {
  border-top-right-radius: 0px;
  border-top-left-radius: 0px;
}
.ctb_global_show .ctb_show ~ div.text_cell_render {
  border: 1px solid var(--light-border-color);
}
.celltoolbar {
  font-size: 87%;
  padding-top: 3px;
}
.celltoolbar select {
  display: block;
  width: 100%;
  height: 32px;
  padding: 6px 12px;
  font-size: 13px;
  line-height: 1.42857143;
  color: #555555;
  background-color: #fff;
  background-image: none;
  border: 1px solid #ccc;
  border-radius: 2px;
  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  -webkit-transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;
  -o-transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;
  transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;
  height: 30px;
  padding: 5px 10px;
  font-size: 12px;
  line-height: 1.5;
  border-radius: 1px;
  width: inherit;
  font-size: inherit;
  height: 22px;
  padding: 0px;
  display: inline-block;
}
.celltoolbar select:focus {
  border-color: #66afe9;
  outline: 0;
  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075), 0 0 8px rgba(102, 175, 233, 0.6);
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075), 0 0 8px rgba(102, 175, 233, 0.6);
}
.celltoolbar select::-moz-placeholder {
  color: #999;
  opacity: 1;
}
.celltoolbar select:-ms-input-placeholder {
  color: #999;
}
.celltoolbar select::-webkit-input-placeholder {
  color: #999;
}
.celltoolbar select::-ms-expand {
  background-color: transparent;
  border: 0;
}
.celltoolbar select[disabled],
.celltoolbar select[readonly],
fieldset[disabled] .celltoolbar select {
  background-color: #eeeeee;
  opacity: 1;
}
.celltoolbar select[disabled],
fieldset[disabled] .celltoolbar select {
  cursor: not-allowed;
}
textarea.celltoolbar select {
  height: auto;
}
select.celltoolbar select {
  height: 30px;
  line-height: 30px;
}
textarea.celltoolbar select,
select[multiple].celltoolbar select {
  height: auto;
}
.celltoolbar label {
  margin-left: 5px;
  margin-right: 5px;
}
.tags_button_container {
  width: 100%;
  display: flex;
}
.tag-container {
  display: flex;
  flex-direction: row;
  flex-grow: 1;
  overflow: hidden;
  position: relative;
}
.tag-container > * {
  margin: 0 4px;
}
.remove-tag-btn {
  margin-left: 4px;
}
.tags-input {
  display: flex;
}
.cell-tag:last-child:after {
  content: "";
  position: absolute;
  right: 0;
  width: 40px;
  height: 100%;
  /* Fade to background color of cell toolbar */
  background: linear-gradient(to right, rgba(0, 0, 0, 0), #EEE);
}
.tags-input > * {
  margin-left: 4px;
}
.cell-tag,
.tags-input input,
.tags-input button {
  display: block;
  width: 100%;
  height: 32px;
  padding: 6px 12px;
  font-size: 13px;
  line-height: 1.42857143;
  color: #555555;
  background-color: #fff;
  background-image: none;
  border: 1px solid #ccc;
  border-radius: 2px;
  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  -webkit-transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;
  -o-transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;
  transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;
  height: 30px;
  padding: 5px 10px;
  font-size: 12px;
  line-height: 1.5;
  border-radius: 1px;
  box-shadow: none;
  width: inherit;
  font-size: inherit;
  height: 22px;
  line-height: 22px;
  padding: 0px 4px;
  display: inline-block;
}
.cell-tag:focus,
.tags-input input:focus,
.tags-input button:focus {
  border-color: #66afe9;
  outline: 0;
  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075), 0 0 8px rgba(102, 175, 233, 0.6);
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075), 0 0 8px rgba(102, 175, 233, 0.6);
}
.cell-tag::-moz-placeholder,
.tags-input input::-moz-placeholder,
.tags-input button::-moz-placeholder {
  color: #999;
  opacity: 1;
}
.cell-tag:-ms-input-placeholder,
.tags-input input:-ms-input-placeholder,
.tags-input button:-ms-input-placeholder {
  color: #999;
}
.cell-tag::-webkit-input-placeholder,
.tags-input input::-webkit-input-placeholder,
.tags-input button::-webkit-input-placeholder {
  color: #999;
}
.cell-tag::-ms-expand,
.tags-input input::-ms-expand,
.tags-input button::-ms-expand {
  background-color: transparent;
  border: 0;
}
.cell-tag[disabled],
.tags-input input[disabled],
.tags-input button[disabled],
.cell-tag[readonly],
.tags-input input[readonly],
.tags-input button[readonly],
fieldset[disabled] .cell-tag,
fieldset[disabled] .tags-input input,
fieldset[disabled] .tags-input button {
  background-color: #eeeeee;
  opacity: 1;
}
.cell-tag[disabled],
.tags-input input[disabled],
.tags-input button[disabled],
fieldset[disabled] .cell-tag,
fieldset[disabled] .tags-input input,
fieldset[disabled] .tags-input button {
  cursor: not-allowed;
}
textarea.cell-tag,
textarea.tags-input input,
textarea.tags-input button {
  height: auto;
}
select.cell-tag,
select.tags-input input,
select.tags-input button {
  height: 30px;
  line-height: 30px;
}
textarea.cell-tag,
textarea.tags-input input,
textarea.tags-input button,
select[multiple].cell-tag,
select[multiple].tags-input input,
select[multiple].tags-input button {
  height: auto;
}
.cell-tag,
.tags-input button {
  padding: 0px 4px;
}
.cell-tag {
  background-color: #fff;
  white-space: nowrap;
}
.tags-input input[type=text]:focus {
  outline: none;
  box-shadow: none;
  border-color: #ccc;
}
.completions {
  position: absolute;
  z-index: 110;
  overflow: hidden;
  border: 1px solid var(--border-color);
  border-radius: 2px;
  -webkit-box-shadow: 0px 6px 10px -1px #adadad;
  box-shadow: 0px 6px 10px -1px #adadad;
  line-height: 1;
}
.completions select {
  background: white;
  outline: none;
  border: none;
  padding: 0px;
  margin: 0px;
  overflow: auto;
  font-family: monospace;
  font-size: 110%;
  color: black;
  width: auto;
}
.completions select option.context {
  color: #286090;
}
#kernel_logo_widget .current_kernel_logo {
  display: none;
  margin-top: -1px;
  margin-bottom: -1px;
  width: 32px;
  height: 32px;
}
[dir="rtl"] #kernel_logo_widget {
  float: left !important;
  float: left;
}
.modal .modal-body .move-path {
  display: flex;
  flex-direction: row;
  justify-content: space;
  align-items: center;
}
.modal .modal-body .move-path .server-root {
  padding-right: 20px;
}
.modal .modal-body .move-path .path-input {
  flex: 1;
}
#menubar {
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  margin-top: 1px;
}
#menubar .navbar {
  border-top: 1px;
  border-radius: 0px 0px 2px 2px;
  margin-bottom: 0px;
}
#menubar .navbar-toggle {
  float: left;
  padding-top: 7px;
  padding-bottom: 7px;
  border: none;
}
#menubar .navbar-collapse {
  clear: left;
}
[dir="rtl"] #menubar .navbar-toggle {
  float: right;
}
[dir="rtl"] #menubar .navbar-collapse {
  clear: right;
}
[dir="rtl"] #menubar .navbar-nav {
  float: right;
}
[dir="rtl"] #menubar .nav {
  padding-right: 0px;
}
[dir="rtl"] #menubar .navbar-nav > li {
  float: right;
}
[dir="rtl"] #menubar .navbar-right {
  float: left !important;
}
[dir="rtl"] ul.dropdown-menu {
  text-align: right;
  left: auto;
}
[dir="rtl"] ul#new-menu.dropdown-menu {
  right: auto;
  left: 0;
}
.nav-wrapper {
  border-bottom: 1px solid var(--navbar-default-border);
}
i.menu-icon {
  padding-top: 4px;
}
[dir="rtl"] i.menu-icon.pull-right {
  float: left !important;
  float: left;
}
ul#help_menu li a {
  overflow: hidden;
  padding-right: 2.2em;
}
ul#help_menu li a i {
  margin-right: -1.2em;
}
[dir="rtl"] ul#help_menu li a {
  padding-left: 2.2em;
}
[dir="rtl"] ul#help_menu li a i {
  margin-right: 0;
  margin-left: -1.2em;
}
[dir="rtl"] ul#help_menu li a i.pull-right {
  float: left !important;
  float: left;
}
.dropdown-submenu {
  position: relative;
}
.dropdown-submenu > .dropdown-menu {
  top: 0;
  left: 100%;
  margin-top: -6px;
  margin-left: -1px;
}
[dir="rtl"] .dropdown-submenu > .dropdown-menu {
  right: 100%;
  margin-right: -1px;
}
.dropdown-submenu:hover > .dropdown-menu {
  display: block;
}
.dropdown-submenu > a:after {
  display: inline-block;
  font: normal normal normal 14px/1 FontAwesome;
  font-size: inherit;
  text-rendering: auto;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  display: block;
  content: "\\f0da";
  float: right;
  color: #333333;
  margin-top: 2px;
  margin-right: -10px;
}
.dropdown-submenu > a:after.fa-pull-left {
  margin-right: 0.3em;
}
.dropdown-submenu > a:after.fa-pull-right {
  margin-left: 0.3em;
}
.dropdown-submenu > a:after.pull-left {
  margin-right: 0.3em;
}
.dropdown-submenu > a:after.pull-right {
  margin-left: 0.3em;
}
[dir="rtl"] .dropdown-submenu > a:after {
  float: left;
  content: "\\f0d9";
  margin-right: 0;
  margin-left: -10px;
}
.dropdown-submenu:hover > a:after {
  color: #262626;
}
.dropdown-submenu.pull-left {
  float: none;
}
.dropdown-submenu.pull-left > .dropdown-menu {
  left: -100%;
  margin-left: 10px;
}
#notification_area {
  float: right !important;
  float: right;
  z-index: 10;
}
[dir="rtl"] #notification_area {
  float: left !important;
  float: left;
}
.indicator_area {
  float: right !important;
  float: right;
  color: var(--navbar-default-link-color);
  margin-left: 5px;
  margin-right: 5px;
  width: 11px;
  z-index: 10;
  text-align: center;
  width: auto;
}
[dir="rtl"] .indicator_area {
  float: left !important;
  float: left;
}
#kernel_indicator {
  float: right !important;
  float: right;
  color: var(--navbar-default-link-color);
  margin-left: 5px;
  margin-right: 5px;
  width: 11px;
  z-index: 10;
  text-align: center;
  width: auto;
  border-left: 1px solid;
}
#kernel_indicator .kernel_indicator_name {
  padding-left: 5px;
  padding-right: 5px;
}
[dir="rtl"] #kernel_indicator {
  float: left !important;
  float: left;
  border-left: 0;
  border-right: 1px solid;
}
#modal_indicator {
  float: right !important;
  float: right;
  color: var(--navbar-default-link-color);
  margin-left: 5px;
  margin-right: 5px;
  width: 11px;
  z-index: 10;
  text-align: center;
  width: auto;
}
[dir="rtl"] #modal_indicator {
  float: left !important;
  float: left;
}
#readonly-indicator {
  float: right !important;
  float: right;
  color: var(--navbar-default-link-color);
  margin-left: 5px;
  margin-right: 5px;
  width: 11px;
  z-index: 10;
  text-align: center;
  width: auto;
  margin-top: 2px;
  margin-bottom: 0px;
  margin-left: 0px;
  margin-right: 0px;
  display: none;
}
.modal_indicator:before {
  width: 1.28571429em;
  text-align: center;
}
.edit_mode .modal_indicator:before {
  display: inline-block;
  font: normal normal normal 14px/1 FontAwesome;
  font-size: inherit;
  text-rendering: auto;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  content: "\\f040";
}
.edit_mode .modal_indicator:before.fa-pull-left {
  margin-right: 0.3em;
}
.edit_mode .modal_indicator:before.fa-pull-right {
  margin-left: 0.3em;
}
.edit_mode .modal_indicator:before.pull-left {
  margin-right: 0.3em;
}
.edit_mode .modal_indicator:before.pull-right {
  margin-left: 0.3em;
}
.command_mode .modal_indicator:before {
  display: inline-block;
  font: normal normal normal 14px/1 FontAwesome;
  font-size: inherit;
  text-rendering: auto;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  content: ' ';
}
.command_mode .modal_indicator:before.fa-pull-left {
  margin-right: 0.3em;
}
.command_mode .modal_indicator:before.fa-pull-right {
  margin-left: 0.3em;
}
.command_mode .modal_indicator:before.pull-left {
  margin-right: 0.3em;
}
.command_mode .modal_indicator:before.pull-right {
  margin-left: 0.3em;
}
.kernel_idle_icon:before {
  display: inline-block;
  font: normal normal normal 14px/1 FontAwesome;
  font-size: inherit;
  text-rendering: auto;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  content: "\\f10c";
}
.kernel_idle_icon:before.fa-pull-left {
  margin-right: 0.3em;
}
.kernel_idle_icon:before.fa-pull-right {
  margin-left: 0.3em;
}
.kernel_idle_icon:before.pull-left {
  margin-right: 0.3em;
}
.kernel_idle_icon:before.pull-right {
  margin-left: 0.3em;
}
.kernel_busy_icon:before {
  display: inline-block;
  font: normal normal normal 14px/1 FontAwesome;
  font-size: inherit;
  text-rendering: auto;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  content: "\\f111";
}
.kernel_busy_icon:before.fa-pull-left {
  margin-right: 0.3em;
}
.kernel_busy_icon:before.fa-pull-right {
  margin-left: 0.3em;
}
.kernel_busy_icon:before.pull-left {
  margin-right: 0.3em;
}
.kernel_busy_icon:before.pull-right {
  margin-left: 0.3em;
}
.kernel_dead_icon:before {
  display: inline-block;
  font: normal normal normal 14px/1 FontAwesome;
  font-size: inherit;
  text-rendering: auto;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  content: "\\f1e2";
}
.kernel_dead_icon:before.fa-pull-left {
  margin-right: 0.3em;
}
.kernel_dead_icon:before.fa-pull-right {
  margin-left: 0.3em;
}
.kernel_dead_icon:before.pull-left {
  margin-right: 0.3em;
}
.kernel_dead_icon:before.pull-right {
  margin-left: 0.3em;
}
.kernel_disconnected_icon:before {
  display: inline-block;
  font: normal normal normal 14px/1 FontAwesome;
  font-size: inherit;
  text-rendering: auto;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  content: "\\f127";
}
.kernel_disconnected_icon:before.fa-pull-left {
  margin-right: 0.3em;
}
.kernel_disconnected_icon:before.fa-pull-right {
  margin-left: 0.3em;
}
.kernel_disconnected_icon:before.pull-left {
  margin-right: 0.3em;
}
.kernel_disconnected_icon:before.pull-right {
  margin-left: 0.3em;
}
.notification_widget {
  color: #565656;
  z-index: 10;
  background: rgba(240, 240, 240, 0.5);
  margin-right: 4px;
  color: #333;
  background-color: #fff;
  border-color: #ccc;
}
.notification_widget:focus,
.notification_widget.focus {
  color: #333;
  background-color: #e6e6e6;
  border-color: #8c8c8c;
}
.notification_widget:hover {
  color: #333;
  background-color: #e6e6e6;
  border-color: #adadad;
}
.notification_widget:active,
.notification_widget.active,
.open > .dropdown-toggle.notification_widget {
  color: #333;
  background-color: #e6e6e6;
  background-image: none;
  border-color: #adadad;
}
.notification_widget:active:hover,
.notification_widget.active:hover,
.open > .dropdown-toggle.notification_widget:hover,
.notification_widget:active:focus,
.notification_widget.active:focus,
.open > .dropdown-toggle.notification_widget:focus,
.notification_widget:active.focus,
.notification_widget.active.focus,
.open > .dropdown-toggle.notification_widget.focus {
  color: #333;
  background-color: #d4d4d4;
  border-color: #8c8c8c;
}
.notification_widget.disabled:hover,
.notification_widget[disabled]:hover,
fieldset[disabled] .notification_widget:hover,
.notification_widget.disabled:focus,
.notification_widget[disabled]:focus,
fieldset[disabled] .notification_widget:focus,
.notification_widget.disabled.focus,
.notification_widget[disabled].focus,
fieldset[disabled] .notification_widget.focus {
  background-color: #fff;
  border-color: #ccc;
}
.notification_widget .badge {
  color: #fff;
  background-color: #333;
}
.notification_widget.warning {
  color: #fff;
  background-color: #f0ad4e;
  border-color: #eea236;
  color: #ffffff;
  background-color: #b46102;
  border-color: #b46102;
}
.notification_widget.warning:focus,
.notification_widget.warning.focus {
  color: #fff;
  background-color: #ec971f;
  border-color: #985f0d;
}
.notification_widget.warning:hover {
  color: #fff;
  background-color: #ec971f;
  border-color: #d58512;
}
.notification_widget.warning:active,
.notification_widget.warning.active,
.open > .dropdown-toggle.notification_widget.warning {
  color: #fff;
  background-color: #ec971f;
  background-image: none;
  border-color: #d58512;
}
.notification_widget.warning:active:hover,
.notification_widget.warning.active:hover,
.open > .dropdown-toggle.notification_widget.warning:hover,
.notification_widget.warning:active:focus,
.notification_widget.warning.active:focus,
.open > .dropdown-toggle.notification_widget.warning:focus,
.notification_widget.warning:active.focus,
.notification_widget.warning.active.focus,
.open > .dropdown-toggle.notification_widget.warning.focus {
  color: #fff;
  background-color: #d58512;
  border-color: #985f0d;
}
.notification_widget.warning.disabled:hover,
.notification_widget.warning[disabled]:hover,
fieldset[disabled] .notification_widget.warning:hover,
.notification_widget.warning.disabled:focus,
.notification_widget.warning[disabled]:focus,
fieldset[disabled] .notification_widget.warning:focus,
.notification_widget.warning.disabled.focus,
.notification_widget.warning[disabled].focus,
fieldset[disabled] .notification_widget.warning.focus {
  background-color: #f0ad4e;
  border-color: #eea236;
}
.notification_widget.warning .badge {
  color: #f0ad4e;
  background-color: #fff;
}
.notification_widget.success {
  color: #fff;
  background-color: #5cb85c;
  border-color: #4cae4c;
}
.notification_widget.success:focus,
.notification_widget.success.focus {
  color: #fff;
  background-color: #449d44;
  border-color: #255625;
}
.notification_widget.success:hover {
  color: #fff;
  background-color: #449d44;
  border-color: #398439;
}
.notification_widget.success:active,
.notification_widget.success.active,
.open > .dropdown-toggle.notification_widget.success {
  color: #fff;
  background-color: #449d44;
  background-image: none;
  border-color: #398439;
}
.notification_widget.success:active:hover,
.notification_widget.success.active:hover,
.open > .dropdown-toggle.notification_widget.success:hover,
.notification_widget.success:active:focus,
.notification_widget.success.active:focus,
.open > .dropdown-toggle.notification_widget.success:focus,
.notification_widget.success:active.focus,
.notification_widget.success.active.focus,
.open > .dropdown-toggle.notification_widget.success.focus {
  color: #fff;
  background-color: #398439;
  border-color: #255625;
}
.notification_widget.success.disabled:hover,
.notification_widget.success[disabled]:hover,
fieldset[disabled] .notification_widget.success:hover,
.notification_widget.success.disabled:focus,
.notification_widget.success[disabled]:focus,
fieldset[disabled] .notification_widget.success:focus,
.notification_widget.success.disabled.focus,
.notification_widget.success[disabled].focus,
fieldset[disabled] .notification_widget.success.focus {
  background-color: #5cb85c;
  border-color: #4cae4c;
}
.notification_widget.success .badge {
  color: #5cb85c;
  background-color: #fff;
}
.notification_widget.info {
  color: #fff;
  background-color: #5bc0de;
  border-color: #46b8da;
}
.notification_widget.info:focus,
.notification_widget.info.focus {
  color: #fff;
  background-color: #31b0d5;
  border-color: #1b6d85;
}
.notification_widget.info:hover {
  color: #fff;
  background-color: #31b0d5;
  border-color: #269abc;
}
.notification_widget.info:active,
.notification_widget.info.active,
.open > .dropdown-toggle.notification_widget.info {
  color: #fff;
  background-color: #31b0d5;
  background-image: none;
  border-color: #269abc;
}
.notification_widget.info:active:hover,
.notification_widget.info.active:hover,
.open > .dropdown-toggle.notification_widget.info:hover,
.notification_widget.info:active:focus,
.notification_widget.info.active:focus,
.open > .dropdown-toggle.notification_widget.info:focus,
.notification_widget.info:active.focus,
.notification_widget.info.active.focus,
.open > .dropdown-toggle.notification_widget.info.focus {
  color: #fff;
  background-color: #269abc;
  border-color: #1b6d85;
}
.notification_widget.info.disabled:hover,
.notification_widget.info[disabled]:hover,
fieldset[disabled] .notification_widget.info:hover,
.notification_widget.info.disabled:focus,
.notification_widget.info[disabled]:focus,
fieldset[disabled] .notification_widget.info:focus,
.notification_widget.info.disabled.focus,
.notification_widget.info[disabled].focus,
fieldset[disabled] .notification_widget.info.focus {
  background-color: #5bc0de;
  border-color: #46b8da;
}
.notification_widget.info .badge {
  color: #5bc0de;
  background-color: #fff;
}
.notification_widget.danger {
  color: #fff;
  background-color: #d9534f;
  border-color: #d43f3a;
  color: #ffffff;
  background-color: #df0404;
  border-color: #df0404;
}
.notification_widget.danger:focus,
.notification_widget.danger.focus {
  color: #fff;
  background-color: #c9302c;
  border-color: #761c19;
}
.notification_widget.danger:hover {
  color: #fff;
  background-color: #c9302c;
  border-color: #ac2925;
}
.notification_widget.danger:active,
.notification_widget.danger.active,
.open > .dropdown-toggle.notification_widget.danger {
  color: #fff;
  background-color: #c9302c;
  background-image: none;
  border-color: #ac2925;
}
.notification_widget.danger:active:hover,
.notification_widget.danger.active:hover,
.open > .dropdown-toggle.notification_widget.danger:hover,
.notification_widget.danger:active:focus,
.notification_widget.danger.active:focus,
.open > .dropdown-toggle.notification_widget.danger:focus,
.notification_widget.danger:active.focus,
.notification_widget.danger.active.focus,
.open > .dropdown-toggle.notification_widget.danger.focus {
  color: #fff;
  background-color: #ac2925;
  border-color: #761c19;
}
.notification_widget.danger.disabled:hover,
.notification_widget.danger[disabled]:hover,
fieldset[disabled] .notification_widget.danger:hover,
.notification_widget.danger.disabled:focus,
.notification_widget.danger[disabled]:focus,
fieldset[disabled] .notification_widget.danger:focus,
.notification_widget.danger.disabled.focus,
.notification_widget.danger[disabled].focus,
fieldset[disabled] .notification_widget.danger.focus {
  background-color: #d9534f;
  border-color: #d43f3a;
}
.notification_widget.danger .badge {
  color: #d9534f;
  background-color: #fff;
}
div#pager {
  background-color: var(--body-bg);
  font-size: 14px;
  line-height: 20px;
  overflow: hidden;
  display: none;
  position: fixed;
  bottom: 0px;
  width: 100%;
  max-height: 50%;
  padding-top: 8px;
  -webkit-box-shadow: 0px 0px 12px 1px rgba(87, 87, 87, 0.2);
  box-shadow: 0px 0px 12px 1px rgba(87, 87, 87, 0.2);
  /* Display over codemirror */
  z-index: 100;
  /* Hack which prevents jquery ui resizable from changing top. */
  top: auto !important;
}
div#pager pre {
  line-height: 1.21429em;
  color: black;
  background-color: var(--body-bg-darken3pc);
  padding: 0.4em;
}
div#pager #pager-button-area {
  position: absolute;
  top: 8px;
  right: 20px;
}
div#pager #pager-button-area .ui-button {
  padding-top: 0px;
  padding-bottom: 0px;
  padding-right: 10px;
  padding-left: 10px;
}
div#pager #pager-contents {
  position: relative;
  overflow: auto;
  width: 100%;
  height: 100%;
}
div#pager #pager-contents #pager-container {
  position: relative;
  padding: 15px 0px;
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
}
div#pager .ui-resizable-handle {
  top: 0px;
  height: 8px;
  background: var(--body-bg-darken3pc);
  border-top: 1px solid var(--light-border-color);
  border-bottom: 1px solid var(--light-border-color);
  /* This injects handle bars (a short, wide = symbol) for 
        the resize handle. */
}
div#pager .ui-resizable-handle::after {
  content: '';
  top: 2px;
  left: 50%;
  height: 3px;
  width: 30px;
  margin-left: -15px;
  position: absolute;
  border-top: 1px solid var(--light-border-color);
}
.quickhelp {
  /* Old browsers */
  display: -webkit-box;
  -webkit-box-orient: horizontal;
  -webkit-box-align: stretch;
  display: -moz-box;
  -moz-box-orient: horizontal;
  -moz-box-align: stretch;
  display: box;
  box-orient: horizontal;
  box-align: stretch;
  /* Modern browsers */
  display: flex;
  flex-direction: row;
  align-items: stretch;
  line-height: 1.8em;
}
.shortcut_key {
  display: inline-block;
  width: 21ex;
  text-align: right;
  font-family: monospace;
}
.shortcut_descr {
  display: inline-block;
  /* Old browsers */
  -webkit-box-flex: 1;
  -moz-box-flex: 1;
  box-flex: 1;
  /* Modern browsers */
  flex: 1;
}
span.save_widget {
  height: 30px;
  margin-top: 4px;
  display: flex;
  justify-content: center;
  align-items: baseline;
  width: 50%;
  flex: 1;
  max-width: 50%;
}
span.save_widget span.filename {
  height: 100%;
  line-height: 1em;
  margin-left: 16px;
  border: none;
  font-size: 146.5%;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  border-radius: 2px;
}
span.save_widget span.filename:hover {
  background-color: var(--edit-hover-color);
}
[dir="rtl"] span.save_widget.pull-left {
  float: right !important;
  float: right;
}
[dir="rtl"] span.save_widget span.filename {
  margin-left: 0;
  margin-right: 16px;
}
span.checkpoint_status,
span.autosave_status {
  font-size: small;
  white-space: nowrap;
  padding: 0 5px;
}
@media (max-width: 767px) {
  span.save_widget {
    font-size: small;
    padding: 0 0 0 5px;
  }
  span.checkpoint_status,
  span.autosave_status {
    display: none;
  }
}
@media (min-width: 768px) and (max-width: 991px) {
  span.checkpoint_status {
    display: none;
  }
  span.autosave_status {
    font-size: x-small;
  }
}
.toolbar {
  padding: 0px;
  margin-left: -5px;
  margin-top: 2px;
  margin-bottom: 5px;
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
}
.toolbar select,
.toolbar label {
  width: auto;
  vertical-align: middle;
  margin-right: 2px;
  margin-bottom: 0px;
  display: inline;
  font-size: 92%;
  margin-left: 0.3em;
  margin-right: 0.3em;
  padding: 0px;
  padding-top: 3px;
}
.toolbar .btn {
  padding: 2px 8px;
}
.toolbar .btn-group {
  margin-top: 0px;
  margin-left: 5px;
}
.toolbar-btn-label {
  margin-left: 6px;
}
#maintoolbar {
  margin-bottom: -3px;
  margin-top: -8px;
  border: 0px;
  min-height: 27px;
  margin-left: 0px;
  padding-top: 11px;
  padding-bottom: 3px;
}
#maintoolbar .navbar-text {
  float: none;
  vertical-align: middle;
  text-align: right;
  margin-left: 5px;
  margin-right: 0px;
  margin-top: 0px;
}
.select-xs {
  height: 24px;
}
[dir="rtl"] .btn-group > .btn,
.btn-group-vertical > .btn {
  float: right;
}
.pulse,
.dropdown-menu > li > a.pulse,
li.pulse > a.dropdown-toggle,
li.pulse.open > a.dropdown-toggle {
  background-color: #F37626;
  color: white;
}
/**
 * Primary styles
 *
 * Author: Jupyter Development Team
 */
/** WARNING IF YOU ARE EDITTING THIS FILE, if this is a .css file, It has a lot
 * of chance of beeing generated from the ../less/[samename].less file, you can
 * try to get back the less file by reverting somme commit in history
 **/
/*
 * We'll try to get something pretty, so we
 * have some strange css to have the scroll bar on
 * the left with fix button on the top right of the tooltip
 */
@-moz-keyframes fadeOut {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}
@-webkit-keyframes fadeOut {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}
@-moz-keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@-webkit-keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
/*properties of tooltip after "expand"*/
.bigtooltip {
  overflow: auto;
  height: 200px;
}
/*properties of tooltip before "expand"*/
.smalltooltip {
  text-overflow: ellipsis;
  overflow: hidden;
  height: 85px;
}
.tooltipbuttons {
  position: absolute;
  padding-right: 15px;
  top: 0px;
  right: 0px;
}
.tooltipbuttons .ui-button {
  padding-top: 0px;
  padding-bottom: 0px;
  padding-right: 10px;
  padding-left: 10px;
}
.tooltiptext {
  /*avoid the button to overlap on some docstring*/
  padding-right: 30px;
  /*avoid the ui-icon(s) from overlapping the tooltip*/
  padding-top: 5px;
}
.ipython_tooltip {
  max-width: 700px;
  /*fade-in animation when inserted*/
  -webkit-animation: fadeOut 400ms;
  -moz-animation: fadeOut 400ms;
  animation: fadeOut 400ms;
  -webkit-animation: fadeIn 400ms;
  -moz-animation: fadeIn 400ms;
  animation: fadeIn 400ms;
  vertical-align: middle;
  background-color: var(--body-bg-darken3pc);
  overflow: visible;
  border: var(--border-color) 1px solid;
  outline: none;
  padding: 3px;
  margin: 0px;
  padding-left: 7px;
  font-family: monospace;
  min-height: 50px;
  -moz-box-shadow: 0px 6px 10px -1px #adadad;
  -webkit-box-shadow: 0px 6px 10px -1px #adadad;
  box-shadow: 0px 6px 10px -1px #adadad;
  border-radius: 2px;
  position: absolute;
  z-index: 1000;
}
.ipython_tooltip a {
  float: right;
}
.ipython_tooltip .tooltiptext pre {
  border: 0;
  border-radius: 0;
  font-size: 100%;
  background-color: var(--body-bg-darken3pc);
}
.pretooltiparrow {
  left: 0px;
  margin: 0px;
  top: -16px;
  width: 40px;
  height: 16px;
  overflow: hidden;
  position: absolute;
}
.pretooltiparrow:before {
  background-color: var(--body-bg-darken3pc);
  border: 1px var(--border-color) solid;
  z-index: 11;
  content: "";
  position: absolute;
  left: 15px;
  top: 10px;
  width: 25px;
  height: 25px;
  -webkit-transform: rotate(45deg);
  -moz-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  -o-transform: rotate(45deg);
}
div.typeahead__container {
  font: revert;
}
ul.typeahead__list i {
  width: 18px;
}
ul.typeahead__list {
  max-height: 80vh;
  overflow: auto;
}
ul.typeahead__list > li > a {
  /** Firefox bug **/
  /* see https://github.com/jupyter/notebook/issues/559 */
  white-space: normal;
}
ul.typeahead__list  > li > a.pull-right {
  float: left !important;
  float: left;
}
[dir="rtl"] .typeahead__list {
  text-align: right;
}
.cmd-palette .modal-body {
  padding: 7px;
}
.cmd-palette form {
  background: white;
}
.cmd-palette input {
  outline: none;
}
.no-shortcut {
  min-width: 20px;
  color: transparent;
}
[dir="rtl"] .no-shortcut.pull-right {
  float: left !important;
  float: left;
}
[dir="rtl"] .command-shortcut.pull-right {
  float: left !important;
  float: left;
}
.command-shortcut:before {
  content: "(command mode)";
  padding-right: 3px;
  color: #777777;
}
.edit-shortcut:before {
  content: "(edit)";
  padding-right: 3px;
  color: #777777;
}
[dir="rtl"] .edit-shortcut.pull-right {
  float: left !important;
  float: left;
}
#find-and-replace #replace-preview .match,
#find-and-replace #replace-preview .insert {
  background-color: #BBDEFB;
  border-color: #90CAF9;
  border-style: solid;
  border-width: 1px;
  border-radius: 0px;
}
[dir="ltr"] #find-and-replace .input-group-btn + .form-control {
  border-left: none;
}
[dir="rtl"] #find-and-replace .input-group-btn + .form-control {
  border-right: none;
}
#find-and-replace #replace-preview .replace .match {
  background-color: #FFCDD2;
  border-color: #EF9A9A;
  border-radius: 0px;
}
#find-and-replace #replace-preview .replace .insert {
  background-color: #C8E6C9;
  border-color: #A5D6A7;
  border-radius: 0px;
}
#find-and-replace #replace-preview {
  max-height: 60vh;
  overflow: auto;
}
#find-and-replace #replace-preview pre {
  padding: 5px 10px;
}
.btn-danger {
  color: #ffffff;
  background-color: #df0404;
  border-color: #df0404;
}
.btn-warning {
  color: #ffffff;
  background-color: #b46102;
  border-color: #b46102;
}
.close {
  float: right;
  font-size: 19.5px;
  font-weight: bold;
  line-height: 1;
  color: #000;
  text-shadow: 0 1px 0 #fff;
  filter: alpha(opacity=60);
  opacity: 0.6;
}
.close:hover,
.close:focus {
  color: #000;
  text-decoration: none;
  cursor: pointer;
  filter: alpha(opacity=100);
  opacity: 1;
}
button.close {
  padding: 0;
  cursor: pointer;
  background: transparent;
  border: 0;
  -webkit-appearance: none;
  appearance: none;
}
.navbar-nav > li > a {
  color: #565656;
}
.navbar-nav > li > a:focus {
  /* -webkit-focus-ring-color = '#5B9DD9' */
  outline: -webkit-focus-ring-color auto 5px;
}
.basthon-loader-root {
  background-color: var(--header-bg);
  box-shadow: 0px 0px 12px 1px rgba(87, 87, 87, 0.2);
}
.basthon-loader-spinner.basthon-loader-foot {
  box-sizing: unset;
}
.basthon-loader-text.basthon-loader-foot {
  font-size: 14px;
  color: var(--text-color);
}
.basthon-dynamic-iframe {
  max-width: 100%;
  display: block;
}
`, "",{"version":3,"sources":["webpack://./src/css/style.less","webpack://./node_modules/bootstrap/less/normalize.less","webpack://./node_modules/bootstrap/less/print.less","webpack://./node_modules/bootstrap/less/glyphicons.less","webpack://./node_modules/bootstrap/less/scaffolding.less","webpack://./node_modules/bootstrap/less/mixins/vendor-prefixes.less","webpack://./node_modules/bootstrap/less/mixins/tab-focus.less","webpack://./node_modules/bootstrap/less/mixins/image.less","webpack://./node_modules/bootstrap/less/type.less","webpack://./node_modules/bootstrap/less/mixins/text-emphasis.less","webpack://./node_modules/bootstrap/less/mixins/background-variant.less","webpack://./node_modules/bootstrap/less/mixins/text-overflow.less","webpack://./node_modules/bootstrap/less/code.less","webpack://./node_modules/bootstrap/less/grid.less","webpack://./node_modules/bootstrap/less/mixins/grid.less","webpack://./node_modules/bootstrap/less/mixins/grid-framework.less","webpack://./node_modules/bootstrap/less/tables.less","webpack://./node_modules/bootstrap/less/mixins/table-row.less","webpack://./node_modules/bootstrap/less/forms.less","webpack://./node_modules/bootstrap/less/mixins/forms.less","webpack://./node_modules/bootstrap/less/buttons.less","webpack://./node_modules/bootstrap/less/mixins/buttons.less","webpack://./node_modules/bootstrap/less/mixins/opacity.less","webpack://./node_modules/bootstrap/less/component-animations.less","webpack://./node_modules/bootstrap/less/dropdowns.less","webpack://./node_modules/bootstrap/less/mixins/nav-divider.less","webpack://./node_modules/bootstrap/less/mixins/reset-filter.less","webpack://./node_modules/bootstrap/less/button-groups.less","webpack://./node_modules/bootstrap/less/mixins/border-radius.less","webpack://./node_modules/bootstrap/less/input-groups.less","webpack://./node_modules/bootstrap/less/navs.less","webpack://./node_modules/bootstrap/less/navbar.less","webpack://./node_modules/bootstrap/less/mixins/nav-vertical-align.less","webpack://./node_modules/bootstrap/less/utilities.less","webpack://./node_modules/font-awesome/less/bordered-pulled.less","webpack://./node_modules/bootstrap/less/breadcrumbs.less","webpack://./node_modules/bootstrap/less/pagination.less","webpack://./node_modules/bootstrap/less/mixins/pagination.less","webpack://./node_modules/bootstrap/less/pager.less","webpack://./node_modules/bootstrap/less/labels.less","webpack://./node_modules/bootstrap/less/mixins/labels.less","webpack://./node_modules/bootstrap/less/badges.less","webpack://./node_modules/bootstrap/less/jumbotron.less","webpack://./node_modules/bootstrap/less/thumbnails.less","webpack://./node_modules/bootstrap/less/alerts.less","webpack://./node_modules/bootstrap/less/mixins/alerts.less","webpack://./node_modules/bootstrap/less/progress-bars.less","webpack://./node_modules/bootstrap/less/mixins/gradients.less","webpack://./node_modules/bootstrap/less/mixins/progress-bar.less","webpack://./node_modules/bootstrap/less/media.less","webpack://./node_modules/bootstrap/less/list-group.less","webpack://./node_modules/bootstrap/less/mixins/list-group.less","webpack://./node_modules/bootstrap/less/panels.less","webpack://./node_modules/bootstrap/less/mixins/panels.less","webpack://./node_modules/bootstrap/less/responsive-embed.less","webpack://./node_modules/bootstrap/less/wells.less","webpack://./node_modules/bootstrap/less/close.less","webpack://./node_modules/bootstrap/less/modals.less","webpack://./node_modules/bootstrap/less/tooltip.less","webpack://./node_modules/bootstrap/less/mixins/reset-text.less","webpack://./node_modules/bootstrap/less/popovers.less","webpack://./node_modules/bootstrap/less/carousel.less","webpack://./node_modules/bootstrap/less/mixins/clearfix.less","webpack://./node_modules/bootstrap/less/mixins/center-block.less","webpack://./node_modules/bootstrap/less/mixins/hide-text.less","webpack://./node_modules/bootstrap/less/responsive-utilities.less","webpack://./node_modules/bootstrap/less/mixins/responsive-visibility.less","webpack://./node_modules/font-awesome/less/path.less","webpack://./node_modules/font-awesome/less/core.less","webpack://./node_modules/font-awesome/less/larger.less","webpack://./node_modules/font-awesome/less/fixed-width.less","webpack://./node_modules/font-awesome/less/list.less","webpack://./node_modules/font-awesome/less/animated.less","webpack://./node_modules/font-awesome/less/rotated-flipped.less","webpack://./node_modules/font-awesome/less/mixins.less","webpack://./node_modules/font-awesome/less/stacked.less","webpack://./node_modules/font-awesome/less/icons.less","webpack://./node_modules/font-awesome/less/screen-reader.less","webpack://./src/css/base/less/variables.less","webpack://./src/css/base/less/mixins.less","webpack://./src/css/base/less/flexbox.less","webpack://./src/css/base/less/error.less","webpack://./src/css/base/less/page.less","webpack://./src/css/notebook/less/ansicolors.less","webpack://./src/css/notebook/less/cell.less","webpack://./src/css/notebook/less/codecell.less","webpack://./src/css/notebook/less/codemirror.less","webpack://./src/css/notebook/less/highlight.less","webpack://./node_modules/codemirror/lib/codemirror.css","webpack://./src/css/notebook/less/outputarea.less","webpack://./src/css/notebook/less/renderedhtml.less","webpack://./src/css/notebook/less/textcell.less","webpack://./src/css/notebook/less/notebook.less","webpack://./src/css/notebook/less/celltoolbar.less","webpack://./src/css/notebook/less/tagbar.less","webpack://./src/css/notebook/less/completer.less","webpack://./src/css/notebook/less/kernelselector.less","webpack://./src/css/notebook/less/modal.less","webpack://./src/css/notebook/less/menubar.less","webpack://./src/css/notebook/less/notificationarea.less","webpack://./src/css/notebook/less/notificationwidget.less","webpack://./src/css/acc_overwrite.less","webpack://./src/css/notebook/less/pager.less","webpack://./src/css/notebook/less/quickhelp.less","webpack://./src/css/notebook/less/savewidget.less","webpack://./src/css/notebook/less/toolbar.less","webpack://./src/css/notebook/less/tooltip.less","webpack://./src/css/notebook/less/commandpalette.less","webpack://./src/css/notebook/less/searchandreplace.less","webpack://./src/css/basthon.less"],"names":[],"mappings":"AAAA;;;;CAIC;AACD;;;;EAIE;AACF,2EAA2E;ACA3E;EACE,uBAAA;EACA,0BAAA;EACA,8BAAA;ADEF;ACKA;EACE,SAAA;ADHF;ACgBA;;;;;;;;;;;;;EAaE,cAAA;ADdF;ACsBA;;;;EAIE,qBAAA;EACA,wBAAA;ADpBF;AC4BA;EACE,aAAA;EACA,SAAA;AD1BF;ACkCA;;EAEE,aAAA;ADhCF;AC0CA;EACE,6BAAA;ADxCF;ACgDA;;EAEE,UAAA;AD9CF;ACyDA;EACE,mBAAA;EACA,0BAAA;EACA,iCAAA;ADvDF;AC8DA;;EAEE,iBAAA;AD5DF;ACmEA;EACE,kBAAA;ADjEF;ACyEA;EACE,cAAA;EACA,gBAAA;ADvEF;AC8EA;EACE,gBAAA;EACA,WAAA;AD5EF;ACmFA;EACE,cAAA;ADjFF;ACwFA;;EAEE,cAAA;EACA,cAAA;EACA,kBAAA;EACA,wBAAA;ADtFF;ACyFA;EACE,WAAA;ADvFF;AC0FA;EACE,eAAA;ADxFF;ACkGA;EACE,SAAA;ADhGF;ACuGA;EACE,gBAAA;ADrGF;AC+GA;EACE,gBAAA;AD7GF;ACoHA;EACE,uBAAA;EACA,SAAA;ADlHF;ACyHA;EACE,cAAA;ADvHF;AC8HA;;;;EAIE,iCAAA;EACA,cAAA;AD5HF;AC8IA;;;;;EAKE,cAAA;EACA,aAAA;EACA,SAAA;AD5IF;ACmJA;EACE,iBAAA;ADjJF;AC2JA;;EAEE,oBAAA;ADzJF;ACoKA;;;;EAIE,0BAAA;EACA,eAAA;ADlKF;ACyKA;;EAEE,eAAA;ADvKF;AC8KA;;EAEE,SAAA;EACA,UAAA;AD5KF;ACoLA;EACE,mBAAA;ADlLF;AC6LA;;EAEE,sBAAA;EACA,UAAA;AD3LF;ACoMA;;EAEE,YAAA;ADlMF;AC0MA;EACE,6BAAA;EACA,uBAAA;ADxMF;ACiNA;;EAEE,wBAAA;AD/MF;ACsNA;EACE,yBAAA;EACA,aAAA;EACA,8BAAA;ADpNF;AC4NA;EACE,SAAA;EACA,UAAA;AD1NF;ACiOA;EACE,cAAA;AD/NF;ACuOA;EACE,iBAAA;ADrOF;AC+OA;EACE,yBAAA;EACA,iBAAA;AD7OF;ACgPA;;EAEE,UAAA;AD9OF;AACA,oFAAoF;AErLpF;EACE;;;IAGE,sBAAA;IACA,4BAAA;IACA,kCAAA;IACA,2BAAA;EFuLF;EEpLA;;IAEE,0BAAA;EFsLF;EEnLA;IACE,4BAAA;EFqLF;EElLA;IACE,6BAAA;EFoLF;EE/KA;;IAEE,WAAA;EFiLF;EE9KA;;IAEE,sBAAA;IACA,wBAAA;EFgLF;EE7KA;IACE,2BAAA;EF+KF;EE5KA;;IAEE,wBAAA;EF8KF;EE3KA;IACE,0BAAA;EF6KF;EE1KA;;;IAGE,UAAA;IACA,SAAA;EF4KF;EEzKA;;IAEE,uBAAA;EF2KF;EErKA;IACE,aAAA;EFuKF;EErKA;;IAGI,iCAAA;EFsKJ;EEnKA;IACE,sBAAA;EFqKF;EElKA;IACE,oCAAA;EFoKF;EErKA;;IAKI,iCAAA;EFoKJ;EEjKA;;IAGI,iCAAA;EFkKJ;AACF;AGxPA;EACE,mCAAA;EACA,4CAAA;EACA,4SAAA;AH0PF;AGlPA;EACE,kBAAA;EACA,QAAA;EACA,qBAAA;EACA,mCAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,mCAAA;EACA,kCAAA;AHoPF;AGhPoC;EAAW,gBAAA;AHmP/C;AGlPoC;EAAW,gBAAA;AHqP/C;AGnPoC;;EAAW,gBAAA;AHuP/C;AGtPoC;EAAW,gBAAA;AHyP/C;AGxPoC;EAAW,gBAAA;AH2P/C;AG1PoC;EAAW,gBAAA;AH6P/C;AG5PoC;EAAW,gBAAA;AH+P/C;AG9PoC;EAAW,gBAAA;AHiQ/C;AGhQoC;EAAW,gBAAA;AHmQ/C;AGlQoC;EAAW,gBAAA;AHqQ/C;AGpQoC;EAAW,gBAAA;AHuQ/C;AGtQoC;EAAW,gBAAA;AHyQ/C;AGxQoC;EAAW,gBAAA;AH2Q/C;AG1QoC;EAAW,gBAAA;AH6Q/C;AG5QoC;EAAW,gBAAA;AH+Q/C;AG9QoC;EAAW,gBAAA;AHiR/C;AGhRoC;EAAW,gBAAA;AHmR/C;AGlRoC;EAAW,gBAAA;AHqR/C;AGpRoC;EAAW,gBAAA;AHuR/C;AGtRoC;EAAW,gBAAA;AHyR/C;AGxRoC;EAAW,gBAAA;AH2R/C;AG1RoC;EAAW,gBAAA;AH6R/C;AG5RoC;EAAW,gBAAA;AH+R/C;AG9RoC;EAAW,gBAAA;AHiS/C;AGhSoC;EAAW,gBAAA;AHmS/C;AGlSoC;EAAW,gBAAA;AHqS/C;AGpSoC;EAAW,gBAAA;AHuS/C;AGtSoC;EAAW,gBAAA;AHyS/C;AGxSoC;EAAW,gBAAA;AH2S/C;AG1SoC;EAAW,gBAAA;AH6S/C;AG5SoC;EAAW,gBAAA;AH+S/C;AG9SoC;EAAW,gBAAA;AHiT/C;AGhToC;EAAW,gBAAA;AHmT/C;AGlToC;EAAW,gBAAA;AHqT/C;AGpToC;EAAW,gBAAA;AHuT/C;AGtToC;EAAW,gBAAA;AHyT/C;AGxToC;EAAW,gBAAA;AH2T/C;AG1ToC;EAAW,gBAAA;AH6T/C;AG5ToC;EAAW,gBAAA;AH+T/C;AG9ToC;EAAW,gBAAA;AHiU/C;AGhUoC;EAAW,gBAAA;AHmU/C;AGlUoC;EAAW,gBAAA;AHqU/C;AGpUoC;EAAW,gBAAA;AHuU/C;AGtUoC;EAAW,gBAAA;AHyU/C;AGxUoC;EAAW,gBAAA;AH2U/C;AG1UoC;EAAW,gBAAA;AH6U/C;AG5UoC;EAAW,gBAAA;AH+U/C;AG9UoC;EAAW,gBAAA;AHiV/C;AGhVoC;EAAW,gBAAA;AHmV/C;AGlVoC;EAAW,gBAAA;AHqV/C;AGpVoC;EAAW,gBAAA;AHuV/C;AGtVoC;EAAW,gBAAA;AHyV/C;AGxVoC;EAAW,gBAAA;AH2V/C;AG1VoC;EAAW,gBAAA;AH6V/C;AG5VoC;EAAW,gBAAA;AH+V/C;AG9VoC;EAAW,gBAAA;AHiW/C;AGhWoC;EAAW,gBAAA;AHmW/C;AGlWoC;EAAW,gBAAA;AHqW/C;AGpWoC;EAAW,gBAAA;AHuW/C;AGtWoC;EAAW,gBAAA;AHyW/C;AGxWoC;EAAW,gBAAA;AH2W/C;AG1WoC;EAAW,gBAAA;AH6W/C;AG5WoC;EAAW,gBAAA;AH+W/C;AG9WoC;EAAW,gBAAA;AHiX/C;AGhXoC;EAAW,gBAAA;AHmX/C;AGlXoC;EAAW,gBAAA;AHqX/C;AGpXoC;EAAW,gBAAA;AHuX/C;AGtXoC;EAAW,gBAAA;AHyX/C;AGxXoC;EAAW,gBAAA;AH2X/C;AG1XoC;EAAW,gBAAA;AH6X/C;AG5XoC;EAAW,gBAAA;AH+X/C;AG9XoC;EAAW,gBAAA;AHiY/C;AGhYoC;EAAW,gBAAA;AHmY/C;AGlYoC;EAAW,gBAAA;AHqY/C;AGpYoC;EAAW,gBAAA;AHuY/C;AGtYoC;EAAW,gBAAA;AHyY/C;AGxYoC;EAAW,gBAAA;AH2Y/C;AG1YoC;EAAW,gBAAA;AH6Y/C;AG5YoC;EAAW,gBAAA;AH+Y/C;AG9YoC;EAAW,gBAAA;AHiZ/C;AGhZoC;EAAW,gBAAA;AHmZ/C;AGlZoC;EAAW,gBAAA;AHqZ/C;AGpZoC;EAAW,gBAAA;AHuZ/C;AGtZoC;EAAW,gBAAA;AHyZ/C;AGxZoC;EAAW,gBAAA;AH2Z/C;AG1ZoC;EAAW,gBAAA;AH6Z/C;AG5ZoC;EAAW,gBAAA;AH+Z/C;AG9ZoC;EAAW,gBAAA;AHia/C;AGhaoC;EAAW,gBAAA;AHma/C;AGlaoC;EAAW,gBAAA;AHqa/C;AGpaoC;EAAW,gBAAA;AHua/C;AGtaoC;EAAW,gBAAA;AHya/C;AGxaoC;EAAW,gBAAA;AH2a/C;AG1aoC;EAAW,gBAAA;AH6a/C;AG5aoC;EAAW,gBAAA;AH+a/C;AG9aoC;EAAW,gBAAA;AHib/C;AGhboC;EAAW,gBAAA;AHmb/C;AGlboC;EAAW,gBAAA;AHqb/C;AGpboC;EAAW,gBAAA;AHub/C;AGtboC;EAAW,gBAAA;AHyb/C;AGxboC;EAAW,gBAAA;AH2b/C;AG1boC;EAAW,gBAAA;AH6b/C;AG5boC;EAAW,gBAAA;AH+b/C;AG9boC;EAAW,gBAAA;AHic/C;AGhcoC;EAAW,gBAAA;AHmc/C;AGlcoC;EAAW,gBAAA;AHqc/C;AGpcoC;EAAW,gBAAA;AHuc/C;AGtcoC;EAAW,gBAAA;AHyc/C;AGxcoC;EAAW,gBAAA;AH2c/C;AG1coC;EAAW,gBAAA;AH6c/C;AG5coC;EAAW,gBAAA;AH+c/C;AG9coC;EAAW,gBAAA;AHid/C;AGhdoC;EAAW,gBAAA;AHmd/C;AGldoC;EAAW,gBAAA;AHqd/C;AGpdoC;EAAW,gBAAA;AHud/C;AGtdoC;EAAW,gBAAA;AHyd/C;AGxdoC;EAAW,gBAAA;AH2d/C;AG1doC;EAAW,gBAAA;AH6d/C;AG5doC;EAAW,gBAAA;AH+d/C;AG9doC;EAAW,gBAAA;AHie/C;AGheoC;EAAW,gBAAA;AHme/C;AGleoC;EAAW,gBAAA;AHqe/C;AGpeoC;EAAW,gBAAA;AHue/C;AGteoC;EAAW,gBAAA;AHye/C;AGxeoC;EAAW,gBAAA;AH2e/C;AG1eoC;EAAW,gBAAA;AH6e/C;AG5eoC;EAAW,gBAAA;AH+e/C;AG9eoC;EAAW,gBAAA;AHif/C;AGhfoC;EAAW,gBAAA;AHmf/C;AGlfoC;EAAW,gBAAA;AHqf/C;AGpfoC;EAAW,gBAAA;AHuf/C;AGtfoC;EAAW,gBAAA;AHyf/C;AGxfoC;EAAW,gBAAA;AH2f/C;AG1foC;EAAW,gBAAA;AH6f/C;AG5foC;EAAW,gBAAA;AH+f/C;AG9foC;EAAW,gBAAA;AHigB/C;AGhgBoC;EAAW,gBAAA;AHmgB/C;AGlgBoC;EAAW,gBAAA;AHqgB/C;AGpgBoC;EAAW,gBAAA;AHugB/C;AGtgBoC;EAAW,gBAAA;AHygB/C;AGxgBoC;EAAW,gBAAA;AH2gB/C;AG1gBoC;EAAW,gBAAA;AH6gB/C;AG5gBoC;EAAW,gBAAA;AH+gB/C;AG9gBoC;EAAW,gBAAA;AHihB/C;AGhhBoC;EAAW,gBAAA;AHmhB/C;AGlhBoC;EAAW,gBAAA;AHqhB/C;AGphBoC;EAAW,gBAAA;AHuhB/C;AGthBoC;EAAW,gBAAA;AHyhB/C;AGxhBoC;EAAW,gBAAA;AH2hB/C;AG1hBoC;EAAW,gBAAA;AH6hB/C;AG5hBoC;EAAW,gBAAA;AH+hB/C;AG9hBoC;EAAW,gBAAA;AHiiB/C;AGhiBoC;EAAW,gBAAA;AHmiB/C;AGliBoC;EAAW,gBAAA;AHqiB/C;AGpiBoC;EAAW,gBAAA;AHuiB/C;AGtiBoC;EAAW,gBAAA;AHyiB/C;AGxiBoC;EAAW,gBAAA;AH2iB/C;AG1iBoC;EAAW,gBAAA;AH6iB/C;AG5iBoC;EAAW,gBAAA;AH+iB/C;AG9iBoC;EAAW,gBAAA;AHijB/C;AGhjBoC;EAAW,gBAAA;AHmjB/C;AGljBoC;EAAW,gBAAA;AHqjB/C;AGpjBoC;EAAW,gBAAA;AHujB/C;AGtjBoC;EAAW,gBAAA;AHyjB/C;AGxjBoC;EAAW,gBAAA;AH2jB/C;AG1jBoC;EAAW,gBAAA;AH6jB/C;AG5jBoC;EAAW,gBAAA;AH+jB/C;AG9jBoC;EAAW,gBAAA;AHikB/C;AGhkBoC;EAAW,gBAAA;AHmkB/C;AGlkBoC;EAAW,gBAAA;AHqkB/C;AGpkBoC;EAAW,gBAAA;AHukB/C;AGtkBoC;EAAW,gBAAA;AHykB/C;AGxkBoC;EAAW,gBAAA;AH2kB/C;AG1kBoC;EAAW,gBAAA;AH6kB/C;AG5kBoC;EAAW,gBAAA;AH+kB/C;AG9kBoC;EAAW,gBAAA;AHilB/C;AGhlBoC;EAAW,gBAAA;AHmlB/C;AGllBoC;EAAW,gBAAA;AHqlB/C;AGplBoC;EAAW,gBAAA;AHulB/C;AGtlBoC;EAAW,gBAAA;AHylB/C;AGxlBoC;EAAW,gBAAA;AH2lB/C;AG1lBoC;EAAW,gBAAA;AH6lB/C;AG5lBoC;EAAW,gBAAA;AH+lB/C;AG9lBoC;EAAW,gBAAA;AHimB/C;AGhmBoC;EAAW,gBAAA;AHmmB/C;AGlmBoC;EAAW,gBAAA;AHqmB/C;AGpmBoC;EAAW,gBAAA;AHumB/C;AGtmBoC;EAAW,gBAAA;AHymB/C;AGxmBoC;EAAW,gBAAA;AH2mB/C;AG1mBoC;EAAW,gBAAA;AH6mB/C;AG5mBoC;EAAW,gBAAA;AH+mB/C;AG9mBoC;EAAW,gBAAA;AHinB/C;AGhnBoC;EAAW,gBAAA;AHmnB/C;AGlnBoC;EAAW,gBAAA;AHqnB/C;AGpnBoC;EAAW,gBAAA;AHunB/C;AGtnBoC;EAAW,gBAAA;AHynB/C;AGxnBoC;EAAW,gBAAA;AH2nB/C;AG1nBoC;EAAW,gBAAA;AH6nB/C;AG5nBoC;EAAW,gBAAA;AH+nB/C;AG9nBoC;EAAW,gBAAA;AHioB/C;AGhoBoC;EAAW,gBAAA;AHmoB/C;AGloBoC;EAAW,gBAAA;AHqoB/C;AGpoBoC;EAAW,gBAAA;AHuoB/C;AGtoBoC;EAAW,gBAAA;AHyoB/C;AGxoBoC;EAAW,gBAAA;AH2oB/C;AG1oBoC;EAAW,gBAAA;AH6oB/C;AGpoBoC;EAAW,gBAAA;AHuoB/C;AGtoBoC;EAAW,gBAAA;AHyoB/C;AGxoBoC;EAAW,gBAAA;AH2oB/C;AG1oBoC;EAAW,gBAAA;AH6oB/C;AG5oBoC;EAAW,gBAAA;AH+oB/C;AG9oBoC;EAAW,gBAAA;AHipB/C;AGhpBoC;EAAW,gBAAA;AHmpB/C;AGlpBoC;EAAW,gBAAA;AHqpB/C;AGppBoC;EAAW,gBAAA;AHupB/C;AGtpBoC;EAAW,gBAAA;AHypB/C;AGxpBoC;EAAW,gBAAA;AH2pB/C;AG1pBoC;EAAW,gBAAA;AH6pB/C;AG5pBoC;EAAW,gBAAA;AH+pB/C;AG9pBoC;EAAW,gBAAA;AHiqB/C;AGhqBoC;EAAW,gBAAA;AHmqB/C;AGlqBoC;EAAW,gBAAA;AHqqB/C;AGpqBoC;EAAW,gBAAA;AHuqB/C;AGtqBoC;EAAW,gBAAA;AHyqB/C;AGxqBoC;EAAW,gBAAA;AH2qB/C;AG1qBoC;EAAW,gBAAA;AH6qB/C;AG5qBoC;EAAW,gBAAA;AH+qB/C;AG9qBoC;EAAW,gBAAA;AHirB/C;AGhrBoC;EAAW,gBAAA;AHmrB/C;AGlrBoC;EAAW,gBAAA;AHqrB/C;AGprBoC;EAAW,gBAAA;AHurB/C;AGtrBoC;EAAW,gBAAA;AHyrB/C;AGxrBoC;EAAW,gBAAA;AH2rB/C;AG1rBoC;EAAW,gBAAA;AH6rB/C;AG5rBoC;EAAW,gBAAA;AH+rB/C;AG9rBoC;EAAW,gBAAA;AHisB/C;AGhsBoC;EAAW,gBAAA;AHmsB/C;AGlsBoC;EAAW,gBAAA;AHqsB/C;AGpsBoC;EAAW,gBAAA;AHusB/C;AGtsBoC;EAAW,gBAAA;AHysB/C;AGxsBoC;EAAW,gBAAA;AH2sB/C;AG1sBoC;EAAW,gBAAA;AH6sB/C;AG5sBoC;EAAW,gBAAA;AH+sB/C;AG9sBoC;EAAW,gBAAA;AHitB/C;AGhtBoC;EAAW,gBAAA;AHmtB/C;AGltBoC;EAAW,gBAAA;AHqtB/C;AGptBoC;EAAW,gBAAA;AHutB/C;AGttBoC;EAAW,gBAAA;AHytB/C;AGxtBoC;EAAW,gBAAA;AH2tB/C;AG1tBoC;EAAW,gBAAA;AH6tB/C;AG5tBoC;EAAW,gBAAA;AH+tB/C;AG9tBoC;EAAW,gBAAA;AHiuB/C;AGhuBoC;EAAW,gBAAA;AHmuB/C;AGluBoC;EAAW,gBAAA;AHquB/C;AGpuBoC;EAAW,gBAAA;AHuuB/C;AGtuBoC;EAAW,gBAAA;AHyuB/C;AGxuBoC;EAAW,gBAAA;AH2uB/C;AG1uBoC;EAAW,gBAAA;AH6uB/C;AG5uBoC;EAAW,gBAAA;AH+uB/C;AG9uBoC;EAAW,gBAAA;AHivB/C;AGhvBoC;EAAW,gBAAA;AHmvB/C;AGlvBoC;EAAW,gBAAA;AHqvB/C;AI7hCA;ECkEE,8BAAA;EACG,2BAAA;EACK,sBAAA;AL89BV;AI/hCA;;EC+DE,8BAAA;EACG,2BAAA;EACK,sBAAA;ALo+BV;AI7hCA;EACE,eAAA;EACA,6CAAA;AJ+hCF;AI5hCA;EACE,2DAAA;EACA,eAAA;EACA,uBAAA;EACA,YAAA;EACA,gCAAA;AJ8hCF;AI1hCA;;;;EAIE,oBAAA;EACA,kBAAA;EACA,oBAAA;AJ4hCF;AIthCA;EACE,cAAA;EACA,qBAAA;AJwhCF;AIthCE;;EAEE,cAAA;EACA,0BAAA;AJwhCJ;AIrhCE;EEnDA,0CAAA;EACA,oBAAA;AN2kCF;AI9gCA;EACE,SAAA;AJghCF;AI1gCA;EACE,sBAAA;AJ4gCF;AIxgCA;;;;;EG1EE,cAAA;EACA,eAAA;EACA,YAAA;APylCF;AI5gCA;EACE,kBAAA;AJ8gCF;AIxgCA;EACE,YAAA;EACA,uBAAA;EACA,gCAAA;EACA,sBAAA;EACA,kBAAA;EC+FA,wCAAA;EACK,mCAAA;EACG,gCAAA;EE5LR,qBAAA;EACA,eAAA;EACA,YAAA;APymCF;AIxgCA;EACE,kBAAA;AJ0gCF;AIpgCA;EACE,gBAAA;EACA,mBAAA;EACA,SAAA;EACA,6BAAA;AJsgCF;AI9/BA;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,gBAAA;EACA,sBAAA;EACA,SAAA;AJggCF;AIx/BE;;EAEE,gBAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,iBAAA;EACA,UAAA;AJ0/BJ;AI/+BA;EACE,eAAA;AJi/BF;AQtoCA;;;;;;;;;;;;EAEE,oBAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;ARkpCF;AQvpCA;;;;;;;;;;;;;;;;;;;;;;;;EASI,gBAAA;EACA,cAAA;EACA,cAAA;ARwqCJ;AQpqCA;;;;;;EAGE,gBAAA;EACA,kBAAA;ARyqCF;AQ7qCA;;;;;;;;;;;;EAQI,cAAA;ARmrCJ;AQhrCA;;;;;;EAGE,eAAA;EACA,kBAAA;ARqrCF;AQzrCA;;;;;;;;;;;;EAQI,cAAA;AR+rCJ;AQ3rCA;;EAAU,eAAA;AR+rCV;AQ9rCA;;EAAU,eAAA;ARksCV;AQjsCA;;EAAU,eAAA;ARqsCV;AQpsCA;;EAAU,eAAA;ARwsCV;AQvsCA;;EAAU,eAAA;AR2sCV;AQ1sCA;;EAAU,eAAA;AR8sCV;AQxsCA;EACE,eAAA;AR0sCF;AQvsCA;EACE,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;ARysCF;AQvsCE;EAAA;IACE,iBAAA;ER0sCF;AACF;AQlsCA;;EAEE,cAAA;ARosCF;AQjsCA;;EAEE,cAAA;EACA,yBAAA;ARmsCF;AQ/rCA;EAAuB,gBAAA;ARksCvB;AQjsCA;EAAuB,iBAAA;ARosCvB;AQnsCA;EAAuB,kBAAA;ARssCvB;AQrsCA;EAAuB,mBAAA;ARwsCvB;AQvsCA;EAAuB,mBAAA;AR0sCvB;AQvsCA;EAAuB,yBAAA;AR0sCvB;AQzsCA;EAAuB,yBAAA;AR4sCvB;AQ3sCA;EAAuB,0BAAA;AR8sCvB;AQ3sCA;EACE,cAAA;AR6sCF;AQ3sCA;ECvGE,cAAA;ATqzCF;ASpzCE;;EAEE,cAAA;ATszCJ;AQ/sCA;EC1GE,cAAA;AT4zCF;AS3zCE;;EAEE,cAAA;AT6zCJ;AQntCA;EC7GE,cAAA;ATm0CF;ASl0CE;;EAEE,cAAA;ATo0CJ;AQvtCA;EChHE,cAAA;AT00CF;ASz0CE;;EAEE,cAAA;AT20CJ;AQ3tCA;ECnHE,cAAA;ATi1CF;ASh1CE;;EAEE,cAAA;ATk1CJ;AQ3tCA;EAGE,WAAA;EE7HA,yBAAA;AVy1CF;AUx1CE;;EAEE,yBAAA;AV01CJ;AQ7tCA;EEhIE,yBAAA;AVg2CF;AU/1CE;;EAEE,yBAAA;AVi2CJ;AQjuCA;EEnIE,yBAAA;AVu2CF;AUt2CE;;EAEE,yBAAA;AVw2CJ;AQruCA;EEtIE,yBAAA;AV82CF;AU72CE;;EAEE,yBAAA;AV+2CJ;AQzuCA;EEzIE,yBAAA;AVq3CF;AUp3CE;;EAEE,yBAAA;AVs3CJ;AQxuCA;EACE,mBAAA;EACA,mBAAA;EACA,gCAAA;AR0uCF;AQluCA;;EAEE,aAAA;EACA,kBAAA;ARouCF;AQvuCA;;;;EAMI,gBAAA;ARuuCJ;AQhuCA;EACE,eAAA;EACA,gBAAA;ARkuCF;AQ9tCA;EALE,eAAA;EACA,gBAAA;EAMA,iBAAA;ARiuCF;AQnuCA;EAKI,qBAAA;EACA,kBAAA;EACA,iBAAA;ARiuCJ;AQ5tCA;EACE,aAAA;EACA,mBAAA;AR8tCF;AQ5tCA;;EAEE,uBAAA;AR8tCF;AQ5tCA;EACE,gBAAA;AR8tCF;AQ5tCA;EACE,cAAA;AR8tCF;AQjtCE;EAAA;IAEI,WAAA;IACA,YAAA;IACA,WAAA;IACA,iBAAA;IGxNJ,gBAAA;IACA,uBAAA;IACA,mBAAA;EX46CA;EQ3tCA;IASI,kBAAA;ERqtCJ;AACF;AQ3sCA;;EAEE,YAAA;AR6sCF;AQ1sCA;EACE,cAAA;EA9IqB,yBAAA;AR21CvB;AQxsCA;EACE,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,8BAAA;AR0sCF;AQrsCI;;;EACE,gBAAA;ARysCN;AQntCA;;;EAmBI,cAAA;EACA,cAAA;EACA,uBAAA;EACA,cAAA;ARqsCJ;AQnsCI;;;EACE,sBAAA;ARusCN;AQ/rCA;;EAEE,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,+BAAA;EACA,cAAA;ARisCF;AQ3rCI;;;;;;EAAW,WAAA;ARmsCf;AQlsCI;;;;;;EACE,sBAAA;ARysCN;AQnsCA;EACE,mBAAA;EACA,kBAAA;EACA,uBAAA;ARqsCF;AY7+CA;;;;EAIE,sBAAA;AZ++CF;AY3+CA;EACE,gBAAA;EACA,cAAA;EACA,cAAA;EACA,yBAAA;EACA,kBAAA;AZ6+CF;AYz+CA;EACE,gBAAA;EACA,cAAA;EACA,WAAA;EACA,6BAAA;EACA,kBAAA;EACA,8CAAA;AZ2+CF;AYj/CA;EASI,UAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AZ2+CJ;AYt+CA;EACE,cAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;EACA,uBAAA;EACA,cAAA;EACA,qBAAA;EACA,qBAAA;EACA,yBAAA;EACA,sBAAA;EACA,kBAAA;AZw+CF;AYn/CA;EAeI,UAAA;EACA,kBAAA;EACA,cAAA;EACA,qBAAA;EACA,6BAAA;EACA,gBAAA;AZu+CJ;AYl+CA;EACE,iBAAA;EACA,kBAAA;AZo+CF;Aa9hDA;ECHE,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;AdoiDF;AajiDE;EAAA;IACE,YAAA;EboiDF;AACF;AaniDE;EAAA;IACE,YAAA;EbsiDF;AACF;AariDE;EAAA;IACE,aAAA;EbwiDF;AACF;Aa/hDA;ECvBE,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;AdyjDF;Aa5hDA;ECvBE,iBAAA;EACA,gBAAA;AdsjDF;Aa5hDA;EACE,eAAA;EACA,cAAA;Ab8hDF;AahiDA;EAKI,gBAAA;EACA,eAAA;Ab8hDJ;Ae9jDK;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EACC,kBAAA;EAEA,eAAA;EAEA,kBAAA;EACA,iBAAA;Af6mDN;Ae7lDK;;;;;;;;;;;;EACC,WAAA;Af0mDN;AenmDG;EACC,WAAA;AfqmDJ;AetmDG;EACC,mBAAA;AfwmDJ;AezmDG;EACC,mBAAA;Af2mDJ;Ae5mDG;EACC,UAAA;Af8mDJ;Ae/mDG;EACC,mBAAA;AfinDJ;AelnDG;EACC,mBAAA;AfonDJ;AernDG;EACC,UAAA;AfunDJ;AexnDG;EACC,mBAAA;Af0nDJ;Ae3nDG;EACC,mBAAA;Af6nDJ;Ae9nDG;EACC,UAAA;AfgoDJ;AejoDG;EACC,mBAAA;AfmoDJ;AepoDG;EACC,kBAAA;AfsoDJ;AexnDG;EACC,WAAA;Af0nDJ;Ae3nDG;EACC,mBAAA;Af6nDJ;Ae9nDG;EACC,mBAAA;AfgoDJ;AejoDG;EACC,UAAA;AfmoDJ;AepoDG;EACC,mBAAA;AfsoDJ;AevoDG;EACC,mBAAA;AfyoDJ;Ae1oDG;EACC,UAAA;Af4oDJ;Ae7oDG;EACC,mBAAA;Af+oDJ;AehpDG;EACC,mBAAA;AfkpDJ;AenpDG;EACC,UAAA;AfqpDJ;AetpDG;EACC,mBAAA;AfwpDJ;AezpDG;EACC,kBAAA;Af2pDJ;AevpDG;EACC,WAAA;AfypDJ;AezqDG;EACC,UAAA;Af2qDJ;Ae5qDG;EACC,kBAAA;Af8qDJ;Ae/qDG;EACC,kBAAA;AfirDJ;AelrDG;EACC,SAAA;AforDJ;AerrDG;EACC,kBAAA;AfurDJ;AexrDG;EACC,kBAAA;Af0rDJ;Ae3rDG;EACC,SAAA;Af6rDJ;Ae9rDG;EACC,kBAAA;AfgsDJ;AejsDG;EACC,kBAAA;AfmsDJ;AepsDG;EACC,SAAA;AfssDJ;AevsDG;EACC,kBAAA;AfysDJ;Ae1sDG;EACC,iBAAA;Af4sDJ;AexsDG;EACC,UAAA;Af0sDJ;Ae5rDG;EACC,iBAAA;Af8rDJ;Ae/rDG;EACC,yBAAA;AfisDJ;AelsDG;EACC,yBAAA;AfosDJ;AersDG;EACC,gBAAA;AfusDJ;AexsDG;EACC,yBAAA;Af0sDJ;Ae3sDG;EACC,yBAAA;Af6sDJ;Ae9sDG;EACC,gBAAA;AfgtDJ;AejtDG;EACC,yBAAA;AfmtDJ;AeptDG;EACC,yBAAA;AfstDJ;AevtDG;EACC,gBAAA;AfytDJ;Ae1tDG;EACC,yBAAA;Af4tDJ;Ae7tDG;EACC,wBAAA;Af+tDJ;AehuDG;EACC,eAAA;AfkuDJ;AajuDA;EEnCK;;;;;;;;;;;;IACC,WAAA;EfkxDJ;Ee3wDC;IACC,WAAA;Ef6wDF;Ee9wDC;IACC,mBAAA;EfgxDF;EejxDC;IACC,mBAAA;EfmxDF;EepxDC;IACC,UAAA;EfsxDF;EevxDC;IACC,mBAAA;EfyxDF;Ee1xDC;IACC,mBAAA;Ef4xDF;Ee7xDC;IACC,UAAA;Ef+xDF;EehyDC;IACC,mBAAA;EfkyDF;EenyDC;IACC,mBAAA;EfqyDF;EetyDC;IACC,UAAA;EfwyDF;EezyDC;IACC,mBAAA;Ef2yDF;Ee5yDC;IACC,kBAAA;Ef8yDF;EehyDC;IACC,WAAA;EfkyDF;EenyDC;IACC,mBAAA;EfqyDF;EetyDC;IACC,mBAAA;EfwyDF;EezyDC;IACC,UAAA;Ef2yDF;Ee5yDC;IACC,mBAAA;Ef8yDF;Ee/yDC;IACC,mBAAA;EfizDF;EelzDC;IACC,UAAA;EfozDF;EerzDC;IACC,mBAAA;EfuzDF;EexzDC;IACC,mBAAA;Ef0zDF;Ee3zDC;IACC,UAAA;Ef6zDF;Ee9zDC;IACC,mBAAA;Efg0DF;Eej0DC;IACC,kBAAA;Efm0DF;Ee/zDC;IACC,WAAA;Efi0DF;Eej1DC;IACC,UAAA;Efm1DF;Eep1DC;IACC,kBAAA;Efs1DF;Eev1DC;IACC,kBAAA;Efy1DF;Ee11DC;IACC,SAAA;Ef41DF;Ee71DC;IACC,kBAAA;Ef+1DF;Eeh2DC;IACC,kBAAA;Efk2DF;Een2DC;IACC,SAAA;Efq2DF;Eet2DC;IACC,kBAAA;Efw2DF;Eez2DC;IACC,kBAAA;Ef22DF;Ee52DC;IACC,SAAA;Ef82DF;Ee/2DC;IACC,kBAAA;Efi3DF;Eel3DC;IACC,iBAAA;Efo3DF;Eeh3DC;IACC,UAAA;Efk3DF;Eep2DC;IACC,iBAAA;Efs2DF;Eev2DC;IACC,yBAAA;Efy2DF;Ee12DC;IACC,yBAAA;Ef42DF;Ee72DC;IACC,gBAAA;Ef+2DF;Eeh3DC;IACC,yBAAA;Efk3DF;Een3DC;IACC,yBAAA;Efq3DF;Eet3DC;IACC,gBAAA;Efw3DF;Eez3DC;IACC,yBAAA;Ef23DF;Ee53DC;IACC,yBAAA;Ef83DF;Ee/3DC;IACC,gBAAA;Efi4DF;Eel4DC;IACC,yBAAA;Efo4DF;Eer4DC;IACC,wBAAA;Efu4DF;Eex4DC;IACC,eAAA;Ef04DF;AACF;Aaj4DA;EE5CK;;;;;;;;;;;;IACC,WAAA;Ef27DJ;Eep7DC;IACC,WAAA;Efs7DF;Eev7DC;IACC,mBAAA;Efy7DF;Ee17DC;IACC,mBAAA;Ef47DF;Ee77DC;IACC,UAAA;Ef+7DF;Eeh8DC;IACC,mBAAA;Efk8DF;Een8DC;IACC,mBAAA;Efq8DF;Eet8DC;IACC,UAAA;Efw8DF;Eez8DC;IACC,mBAAA;Ef28DF;Ee58DC;IACC,mBAAA;Ef88DF;Ee/8DC;IACC,UAAA;Efi9DF;Eel9DC;IACC,mBAAA;Efo9DF;Eer9DC;IACC,kBAAA;Efu9DF;Eez8DC;IACC,WAAA;Ef28DF;Ee58DC;IACC,mBAAA;Ef88DF;Ee/8DC;IACC,mBAAA;Efi9DF;Eel9DC;IACC,UAAA;Efo9DF;Eer9DC;IACC,mBAAA;Efu9DF;Eex9DC;IACC,mBAAA;Ef09DF;Ee39DC;IACC,UAAA;Ef69DF;Ee99DC;IACC,mBAAA;Efg+DF;Eej+DC;IACC,mBAAA;Efm+DF;Eep+DC;IACC,UAAA;Efs+DF;Eev+DC;IACC,mBAAA;Efy+DF;Ee1+DC;IACC,kBAAA;Ef4+DF;Eex+DC;IACC,WAAA;Ef0+DF;Ee1/DC;IACC,UAAA;Ef4/DF;Ee7/DC;IACC,kBAAA;Ef+/DF;EehgEC;IACC,kBAAA;EfkgEF;EengEC;IACC,SAAA;EfqgEF;EetgEC;IACC,kBAAA;EfwgEF;EezgEC;IACC,kBAAA;Ef2gEF;Ee5gEC;IACC,SAAA;Ef8gEF;Ee/gEC;IACC,kBAAA;EfihEF;EelhEC;IACC,kBAAA;EfohEF;EerhEC;IACC,SAAA;EfuhEF;EexhEC;IACC,kBAAA;Ef0hEF;Ee3hEC;IACC,iBAAA;Ef6hEF;EezhEC;IACC,UAAA;Ef2hEF;Ee7gEC;IACC,iBAAA;Ef+gEF;EehhEC;IACC,yBAAA;EfkhEF;EenhEC;IACC,yBAAA;EfqhEF;EethEC;IACC,gBAAA;EfwhEF;EezhEC;IACC,yBAAA;Ef2hEF;Ee5hEC;IACC,yBAAA;Ef8hEF;Ee/hEC;IACC,gBAAA;EfiiEF;EeliEC;IACC,yBAAA;EfoiEF;EeriEC;IACC,yBAAA;EfuiEF;EexiEC;IACC,gBAAA;Ef0iEF;Ee3iEC;IACC,yBAAA;Ef6iEF;Ee9iEC;IACC,wBAAA;EfgjEF;EejjEC;IACC,eAAA;EfmjEF;AACF;AajiEA;EErDK;;;;;;;;;;;;IACC,WAAA;EfomEJ;Ee7lEC;IACC,WAAA;Ef+lEF;EehmEC;IACC,mBAAA;EfkmEF;EenmEC;IACC,mBAAA;EfqmEF;EetmEC;IACC,UAAA;EfwmEF;EezmEC;IACC,mBAAA;Ef2mEF;Ee5mEC;IACC,mBAAA;Ef8mEF;Ee/mEC;IACC,UAAA;EfinEF;EelnEC;IACC,mBAAA;EfonEF;EernEC;IACC,mBAAA;EfunEF;EexnEC;IACC,UAAA;Ef0nEF;Ee3nEC;IACC,mBAAA;Ef6nEF;Ee9nEC;IACC,kBAAA;EfgoEF;EelnEC;IACC,WAAA;EfonEF;EernEC;IACC,mBAAA;EfunEF;EexnEC;IACC,mBAAA;Ef0nEF;Ee3nEC;IACC,UAAA;Ef6nEF;Ee9nEC;IACC,mBAAA;EfgoEF;EejoEC;IACC,mBAAA;EfmoEF;EepoEC;IACC,UAAA;EfsoEF;EevoEC;IACC,mBAAA;EfyoEF;Ee1oEC;IACC,mBAAA;Ef4oEF;Ee7oEC;IACC,UAAA;Ef+oEF;EehpEC;IACC,mBAAA;EfkpEF;EenpEC;IACC,kBAAA;EfqpEF;EejpEC;IACC,WAAA;EfmpEF;EenqEC;IACC,UAAA;EfqqEF;EetqEC;IACC,kBAAA;EfwqEF;EezqEC;IACC,kBAAA;Ef2qEF;Ee5qEC;IACC,SAAA;Ef8qEF;Ee/qEC;IACC,kBAAA;EfirEF;EelrEC;IACC,kBAAA;EforEF;EerrEC;IACC,SAAA;EfurEF;EexrEC;IACC,kBAAA;Ef0rEF;Ee3rEC;IACC,kBAAA;Ef6rEF;Ee9rEC;IACC,SAAA;EfgsEF;EejsEC;IACC,kBAAA;EfmsEF;EepsEC;IACC,iBAAA;EfssEF;EelsEC;IACC,UAAA;EfosEF;EetrEC;IACC,iBAAA;EfwrEF;EezrEC;IACC,yBAAA;Ef2rEF;Ee5rEC;IACC,yBAAA;Ef8rEF;Ee/rEC;IACC,gBAAA;EfisEF;EelsEC;IACC,yBAAA;EfosEF;EersEC;IACC,yBAAA;EfusEF;EexsEC;IACC,gBAAA;Ef0sEF;Ee3sEC;IACC,yBAAA;Ef6sEF;Ee9sEC;IACC,yBAAA;EfgtEF;EejtEC;IACC,gBAAA;EfmtEF;EeptEC;IACC,yBAAA;EfstEF;EevtEC;IACC,wBAAA;EfytEF;Ee1tEC;IACC,eAAA;Ef4tEF;AACF;AgB9xEA;EACE,6BAAA;AhBgyEF;AgBjyEA;EAQI,gBAAA;EACA,qBAAA;EACA,WAAA;AhB4xEJ;AgBvxEI;;EACE,gBAAA;EACA,mBAAA;EACA,WAAA;AhB0xEN;AgBrxEA;EACE,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;AhBuxEF;AgBpxEA;EACE,gBAAA;AhBsxEF;AgBhxEA;EACE,WAAA;EACA,eAAA;EACA,mBAAA;AhBkxEF;AgBrxEA;;;;;;EAWQ,YAAA;EACA,uBAAA;EACA,mBAAA;EACA,0BAAA;AhBkxER;AgBhyEA;EAoBI,sBAAA;EACA,6BAAA;AhB+wEJ;AgBpyEA;;;;;;EA8BQ,aAAA;AhB8wER;AgB5yEA;EAoCI,0BAAA;AhB2wEJ;AgB/yEA;EAyCI,gCAAA;AhBywEJ;AgBlwEA;;;;;;EAOQ,YAAA;AhBmwER;AgBxvEA;EACE,sBAAA;AhB0vEF;AgB3vEA;;;;;;EAQQ,sBAAA;AhB2vER;AgBnwEA;;EAeM,wBAAA;AhBwvEN;AgB9uEA;EAEI,yBAAA;AhB+uEJ;AgBtuEA;EAEI,yBAAA;AhBuuEJ;AiBt3EE;;;;;;;;;;;;EAOI,yBAAA;AjB63EN;AiBv3EE;;;;;EAMI,yBAAA;AjBw3EN;AiB34EE;;;;;;;;;;;;EAOI,yBAAA;AjBk5EN;AiB54EE;;;;;EAMI,yBAAA;AjB64EN;AiBh6EE;;;;;;;;;;;;EAOI,yBAAA;AjBu6EN;AiBj6EE;;;;;EAMI,yBAAA;AjBk6EN;AiBr7EE;;;;;;;;;;;;EAOI,yBAAA;AjB47EN;AiBt7EE;;;;;EAMI,yBAAA;AjBu7EN;AiB18EE;;;;;;;;;;;;EAOI,yBAAA;AjBi9EN;AiB38EE;;;;;EAMI,yBAAA;AjB48EN;AgBxzEA;EACE,iBAAA;EACA,gBAAA;AhB0zEF;AgBxzEE;EAAA;IACE,WAAA;IACA,qBAAA;IACA,kBAAA;IACA,4CAAA;IACA,sBAAA;EhB2zEF;EgBh0EA;IASI,gBAAA;EhB0zEJ;EgBn0EA;;;;;;IAkBU,mBAAA;EhByzEV;EgB30EA;IA0BI,SAAA;EhBozEJ;EgB90EA;;;;;;IAmCU,cAAA;EhBmzEV;EgBt1EA;;;;;;IAuCU,eAAA;EhBuzEV;EgB91EA;;;;IAoDU,gBAAA;EhBgzEV;AACF;AkB1gFA;EAIE,YAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;AlBygFF;AkBtgFA;EACE,cAAA;EACA,WAAA;EACA,UAAA;EACA,mBAAA;EACA,iBAAA;EACA,oBAAA;EACA,cAAA;EACA,SAAA;EACA,gCAAA;AlBwgFF;AkBrgFA;EACE,qBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;AlBugFF;AkB7/EA;Eb6BE,8BAAA;EACG,2BAAA;EACK,sBAAA;EarBR,wBAAA;EACA,gBAAA;AlBy/EF;AkBr/EA;;EAEE,eAAA;EACA,kBAAA;EACA,mBAAA;AlBu/EF;AkBj/EE;;;;;;EAGE,mBAAA;AlBs/EJ;AkBl/EA;EACE,cAAA;AlBo/EF;AkBh/EA;EACE,cAAA;EACA,WAAA;AlBk/EF;AkB9+EA;;EAEE,YAAA;AlBg/EF;AkB5+EA;;;EZ1FE,0CAAA;EACA,oBAAA;AN2kFF;AkB3+EA;EACE,cAAA;EACA,gBAAA;EACA,eAAA;EACA,uBAAA;EACA,cAAA;AlB6+EF;AkBn9EA;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;EACA,uBAAA;EACA,cAAA;EACA,sBAAA;EACA,sBAAA;EACA,sBAAA;EACA,kBAAA;Eb3EA,wDAAA;EACQ,gDAAA;EAyHR,8EAAA;EACK,yEAAA;EACG,sEAAA;ALy6EV;AmBnjFE;EACE,qBAAA;EACA,UAAA;EdYF,yFAAA;EACQ,iFAAA;AL0iFV;AKzgFE;EACE,WAAA;EACA,UAAA;AL2gFJ;AKzgFE;EAA0B,WAAA;AL4gF5B;AK3gFE;EAAgC,WAAA;AL8gFlC;AkB/9EE;EACE,6BAAA;EACA,SAAA;AlBi+EJ;AkBz9EE;;;EAGE,yBAAA;EACA,UAAA;AlB29EJ;AkBx9EE;;EAEE,mBAAA;AlB09EJ;AkBt9EE;EACE,YAAA;AlBw9EJ;AkB18EA;EAKI;;;;IACE,iBAAA;ElB28EJ;EkBx8EE;;;;;;;;IAEE,iBAAA;ElBg9EJ;EkB78EE;;;;;;;;IAEE,iBAAA;ElBq9EJ;AACF;AkB38EA;EACE,mBAAA;AlB68EF;AkBr8EA;;EAEE,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;AlBu8EF;AkBp8EE;;;;EAGI,mBAAA;AlBu8EN;AkBl9EA;;EAgBI,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;AlBs8EJ;AkBn8EA;;;;EAIE,kBAAA;EACA,kBAAA;EACA,kBAAA;AlBq8EF;AkBl8EA;;EAEE,gBAAA;AlBo8EF;AkBh8EA;;EAEE,kBAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,sBAAA;EACA,eAAA;AlBk8EF;AkB/7EE;;;;EAEE,mBAAA;AlBm8EJ;AkBh8EA;;EAEE,aAAA;EACA,iBAAA;AlBk8EF;AkBz7EA;EACE,gBAAA;EAEA,gBAAA;EACA,mBAAA;EAEA,gBAAA;AlBy7EF;AkBv7EE;;EAEE,gBAAA;EACA,eAAA;AlBy7EJ;AkB56EA;EC3PE,YAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AnB0qFF;AmBxqFE;EACE,YAAA;EACA,iBAAA;AnB0qFJ;AmBvqFE;;EAEE,YAAA;AnByqFJ;AkBx7EA;EAEI,YAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AlBy7EJ;AkB/7EA;EASI,YAAA;EACA,iBAAA;AlBy7EJ;AkBn8EA;;EAcI,YAAA;AlBy7EJ;AkBv8EA;EAiBI,YAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;AlBy7EJ;AkBr7EA;ECvRE,YAAA;EACA,kBAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;AnB+sFF;AmB7sFE;EACE,YAAA;EACA,iBAAA;AnB+sFJ;AmB5sFE;;EAEE,YAAA;AnB8sFJ;AkBj8EA;EAEI,YAAA;EACA,kBAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;AlBk8EJ;AkBx8EA;EASI,YAAA;EACA,iBAAA;AlBk8EJ;AkB58EA;;EAcI,YAAA;AlBk8EJ;AkBh9EA;EAiBI,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,sBAAA;AlBk8EJ;AkBz7EA;EAEE,kBAAA;AlB07EF;AkB57EA;EAMI,mBAAA;AlBy7EJ;AkBr7EA;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,UAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,oBAAA;AlBu7EF;AkBr7EA;;;EAGE,WAAA;EACA,YAAA;EACA,iBAAA;AlBu7EF;AkBr7EA;;;EAGE,WAAA;EACA,YAAA;EACA,iBAAA;AlBu7EF;AkBn7EA;;;;;;;;;;EClZI,cAAA;AnBi1FJ;AkB/7EA;EC9YI,qBAAA;EdiDF,wDAAA;EACQ,gDAAA;ALgyFV;AmBh1FI;EACE,qBAAA;Ed8CJ,yEAAA;EACQ,iEAAA;ALqyFV;AkBz8EA;ECpYI,cAAA;EACA,yBAAA;EACA,qBAAA;AnBg1FJ;AkB98EA;EC9XI,cAAA;AnB+0FJ;AkB98EA;;;;;;;;;;ECrZI,cAAA;AnB+2FJ;AkB19EA;ECjZI,qBAAA;EdiDF,wDAAA;EACQ,gDAAA;AL8zFV;AmB92FI;EACE,qBAAA;Ed8CJ,yEAAA;EACQ,iEAAA;ALm0FV;AkBp+EA;ECvYI,cAAA;EACA,yBAAA;EACA,qBAAA;AnB82FJ;AkBz+EA;ECjYI,cAAA;AnB62FJ;AkBz+EA;;;;;;;;;;ECxZI,cAAA;AnB64FJ;AkBr/EA;ECpZI,qBAAA;EdiDF,wDAAA;EACQ,gDAAA;AL41FV;AmB54FI;EACE,qBAAA;Ed8CJ,yEAAA;EACQ,iEAAA;ALi2FV;AkB//EA;EC1YI,cAAA;EACA,yBAAA;EACA,qBAAA;AnB44FJ;AkBpgFA;ECpYI,cAAA;AnB24FJ;AkBhgFE;EACE,SAAA;AlBkgFJ;AkBhgFE;EACE,MAAA;AlBkgFJ;AkBx/EA;EACE,cAAA;EACA,eAAA;EACA,mBAAA;EACA,cAAA;AlB0/EF;AkBx+EE;EAAA;IAGI,qBAAA;IACA,gBAAA;IACA,sBAAA;ElBy+EJ;EkB9+EA;IAUI,qBAAA;IACA,WAAA;IACA,sBAAA;ElBu+EJ;EkBn/EA;IAiBI,qBAAA;ElBq+EJ;EkBt/EA;IAqBI,qBAAA;IACA,sBAAA;ElBo+EJ;EkB1/EA;;;IA2BM,WAAA;ElBo+EN;EkB//EA;IAiCI,WAAA;ElBi+EJ;EkBlgFA;IAqCI,gBAAA;IACA,sBAAA;ElBg+EJ;EkBtgFA;;IA6CI,qBAAA;IACA,aAAA;IACA,gBAAA;IACA,sBAAA;ElB69EJ;EkB7gFA;;IAmDM,eAAA;ElB89EN;EkBjhFA;;IAwDI,kBAAA;IACA,cAAA;ElB69EJ;EkBthFA;IA8DI,MAAA;ElB29EJ;AACF;AkBj9EA;;;;EASI,gBAAA;EACA,aAAA;EACA,gBAAA;AlB88EJ;AkBz9EA;;EAiBI,gBAAA;AlB48EJ;AkB79EA;EJ9gBE,iBAAA;EACA,gBAAA;Ad8+FF;AkBt8EE;EAAA;IAEI,gBAAA;IACA,gBAAA;IACA,iBAAA;ElBw8EJ;AACF;AkBx+EA;EAwCI,UAAA;AlBm8EJ;AkB37EI;EAAA;IAEI,iBAAA;IACA,eAAA;ElB67EN;AACF;AkBz7EI;EAAA;IAEI,gBAAA;IACA,eAAA;ElB27EN;AACF;AoB1gGA;EACE,qBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;EACA,0BAAA;EACA,eAAA;EACA,sBAAA;EACA,6BAAA;ECoCA,iBAAA;EACA,eAAA;EACA,uBAAA;EACA,kBAAA;EhBqKA,yBAAA;EACG,sBAAA;EACC,qBAAA;EACI,iBAAA;ALq0FV;AoB7gGI;;;;;;EdrBF,0CAAA;EACA,oBAAA;AN0iGF;AoBhhGE;;;EAGE,WAAA;EACA,qBAAA;ApBkhGJ;AoB/gGE;;EAEE,sBAAA;EACA,UAAA;Ef2BF,wDAAA;EACQ,gDAAA;ALu/FV;AoB/gGE;;;EAGE,mBAAA;EE9CF,yBAAA;EACA,aAAA;EjBiEA,wBAAA;EACQ,gBAAA;ALggGV;AoB/gGI;;EAEE,oBAAA;ApBihGN;AoBxgGA;EC7DE,WAAA;EACA,sBAAA;EACA,kBAAA;ArBwkGF;AqBtkGE;;EAEE,WAAA;EACA,yBAAA;EACA,qBAAA;ArBwkGJ;AqBtkGE;EACE,WAAA;EACA,yBAAA;EACA,qBAAA;ArBwkGJ;AqBtkGE;;;EAGE,WAAA;EACA,yBAAA;EACA,sBAAA;EACA,qBAAA;ArBwkGJ;AqBtkGI;;;;;;;;;EAGE,WAAA;EACA,yBAAA;EACA,qBAAA;ArB8kGN;AqBxkGI;;;;;;;;;EAGE,sBAAA;EACA,kBAAA;ArBglGN;AoBzjGA;EClBI,WAAA;EACA,sBAAA;ArB8kGJ;AoB1jGA;EChEE,WAAA;EACA,yBAAA;EACA,qBAAA;ArB6nGF;AqB3nGE;;EAEE,WAAA;EACA,yBAAA;EACA,qBAAA;ArB6nGJ;AqB3nGE;EACE,WAAA;EACA,yBAAA;EACA,qBAAA;ArB6nGJ;AqB3nGE;;;EAGE,WAAA;EACA,yBAAA;EACA,sBAAA;EACA,qBAAA;ArB6nGJ;AqB3nGI;;;;;;;;;EAGE,WAAA;EACA,yBAAA;EACA,qBAAA;ArBmoGN;AqB7nGI;;;;;;;;;EAGE,yBAAA;EACA,qBAAA;ArBqoGN;AoB3mGA;ECrBI,cAAA;EACA,sBAAA;ArBmoGJ;AoB3mGA;ECpEE,WAAA;EACA,yBAAA;EACA,qBAAA;ArBkrGF;AqBhrGE;;EAEE,WAAA;EACA,yBAAA;EACA,qBAAA;ArBkrGJ;AqBhrGE;EACE,WAAA;EACA,yBAAA;EACA,qBAAA;ArBkrGJ;AqBhrGE;;;EAGE,WAAA;EACA,yBAAA;EACA,sBAAA;EACA,qBAAA;ArBkrGJ;AqBhrGI;;;;;;;;;EAGE,WAAA;EACA,yBAAA;EACA,qBAAA;ArBwrGN;AqBlrGI;;;;;;;;;EAGE,yBAAA;EACA,qBAAA;ArB0rGN;AoB5pGA;ECzBI,cAAA;EACA,sBAAA;ArBwrGJ;AoB5pGA;ECxEE,WAAA;EACA,yBAAA;EACA,qBAAA;ArBuuGF;AqBruGE;;EAEE,WAAA;EACA,yBAAA;EACA,qBAAA;ArBuuGJ;AqBruGE;EACE,WAAA;EACA,yBAAA;EACA,qBAAA;ArBuuGJ;AqBruGE;;;EAGE,WAAA;EACA,yBAAA;EACA,sBAAA;EACA,qBAAA;ArBuuGJ;AqBruGI;;;;;;;;;EAGE,WAAA;EACA,yBAAA;EACA,qBAAA;ArB6uGN;AqBvuGI;;;;;;;;;EAGE,yBAAA;EACA,qBAAA;ArB+uGN;AoB7sGA;EC7BI,cAAA;EACA,sBAAA;ArB6uGJ;AoB7sGA;EC5EE,WAAA;EACA,yBAAA;EACA,qBAAA;ArB4xGF;AqB1xGE;;EAEE,WAAA;EACA,yBAAA;EACA,qBAAA;ArB4xGJ;AqB1xGE;EACE,WAAA;EACA,yBAAA;EACA,qBAAA;ArB4xGJ;AqB1xGE;;;EAGE,WAAA;EACA,yBAAA;EACA,sBAAA;EACA,qBAAA;ArB4xGJ;AqB1xGI;;;;;;;;;EAGE,WAAA;EACA,yBAAA;EACA,qBAAA;ArBkyGN;AqB5xGI;;;;;;;;;EAGE,yBAAA;EACA,qBAAA;ArBoyGN;AoB9vGA;ECjCI,cAAA;EACA,sBAAA;ArBkyGJ;AoB9vGA;EChFE,WAAA;EACA,yBAAA;EACA,qBAAA;ArBi1GF;AqB/0GE;;EAEE,WAAA;EACA,yBAAA;EACA,qBAAA;ArBi1GJ;AqB/0GE;EACE,WAAA;EACA,yBAAA;EACA,qBAAA;ArBi1GJ;AqB/0GE;;;EAGE,WAAA;EACA,yBAAA;EACA,sBAAA;EACA,qBAAA;ArBi1GJ;AqB/0GI;;;;;;;;;EAGE,WAAA;EACA,yBAAA;EACA,qBAAA;ArBu1GN;AqBj1GI;;;;;;;;;EAGE,yBAAA;EACA,qBAAA;ArBy1GN;AoB/yGA;ECrCI,cAAA;EACA,sBAAA;ArBu1GJ;AoB1yGA;EACE,gBAAA;EACA,cAAA;EACA,gBAAA;ApB4yGF;AoB1yGE;;;;;EAKE,6BAAA;EfnCF,wBAAA;EACQ,gBAAA;ALg1GV;AoB3yGE;;;;EAIE,yBAAA;ApB6yGJ;AoB3yGE;;EAEE,cAAA;EACA,0BAAA;EACA,6BAAA;ApB6yGJ;AoBzyGI;;;;EAEE,cAAA;EACA,qBAAA;ApB6yGN;AoBpyGA;;EC9EE,kBAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;ArBs3GF;AoBvyGA;;EClFE,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;ArB63GF;AoB1yGA;;ECtFE,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;ArBo4GF;AoBzyGA;EACE,cAAA;EACA,WAAA;ApB2yGF;AoBvyGA;EACE,eAAA;ApByyGF;AoBlyGE;;;EACE,WAAA;ApBsyGJ;AuBh8GA;EACE,UAAA;ElBoLA,wCAAA;EACK,mCAAA;EACG,gCAAA;AL+wGV;AuBl8GE;EACE,UAAA;AvBo8GJ;AuBh8GA;EACE,aAAA;AvBk8GF;AuBh8GE;EAAY,cAAA;AvBm8Gd;AuBl8GE;EAAY,kBAAA;AvBq8Gd;AuBp8GE;EAAY,wBAAA;AvBu8Gd;AuBp8GA;EACE,kBAAA;EACA,SAAA;EACA,gBAAA;ElBsKA,+CAAA;EACQ,uCAAA;EAOR,kCAAA;EACQ,0BAAA;EAGR,wCAAA;EACQ,gCAAA;ALyxGV;AwBr+GA;EACE,qBAAA;EACA,QAAA;EACA,SAAA;EACA,gBAAA;EACA,sBAAA;EACA,sBAAA;EACA,wBAAA;EACA,mCAAA;EACA,kCAAA;AxBu+GF;AwBn+GA;;EAEE,kBAAA;AxBq+GF;AwBj+GA;EACE,UAAA;AxBm+GF;AwB/9GA;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,aAAA;EACA,aAAA;EACA,WAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,sBAAA;EACA,4BAAA;EACA,sBAAA;EACA,qCAAA;EACA,kBAAA;EnBuBA,mDAAA;EACQ,2CAAA;AL28GV;AwB79GE;EACE,QAAA;EACA,UAAA;AxB+9GJ;AwBx/GA;ECzBE,WAAA;EACA,aAAA;EACA,gBAAA;EACA,yBAAA;AzBohHF;AwB9/GA;EAmCI,cAAA;EACA,iBAAA;EACA,WAAA;EACA,gBAAA;EACA,uBAAA;EACA,cAAA;EACA,mBAAA;AxB89GJ;AwB59GI;;EAEE,cAAA;EACA,qBAAA;EACA,yBAAA;AxB89GN;AwBv9GE;;;EAGE,WAAA;EACA,qBAAA;EACA,yBAAA;EACA,UAAA;AxBy9GJ;AwBh9GE;;;EAGE,cAAA;AxBk9GJ;AwB98GE;;EAEE,qBAAA;EACA,mBAAA;EACA,6BAAA;EACA,sBAAA;EEzGF,mEAAA;A1B0jHF;AwB38GA;EAGI,cAAA;AxB28GJ;AwB98GA;EAQI,UAAA;AxBy8GJ;AwBj8GA;EACE,QAAA;EACA,UAAA;AxBm8GF;AwB37GA;EACE,WAAA;EACA,OAAA;AxB67GF;AwBz7GA;EACE,cAAA;EACA,iBAAA;EACA,eAAA;EACA,uBAAA;EACA,cAAA;EACA,mBAAA;AxB27GF;AwBv7GA;EACE,eAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,YAAA;AxBy7GF;AwBr7GA;EACE,QAAA;EACA,UAAA;AxBu7GF;AwB/6GA;;EAII,WAAA;EACA,aAAA;EACA,yBAAA;EACA,2BAAA;AxB+6GJ;AwBt7GA;;EAWI,SAAA;EACA,YAAA;EACA,kBAAA;AxB+6GJ;AwBt6GA;EACE;IApEA,QAAA;IACA,UAAA;ExB6+GA;EwB16GA;IA1DA,WAAA;IACA,OAAA;ExBu+GA;AACF;A2BlnHA;;EAEE,kBAAA;EACA,qBAAA;EACA,sBAAA;A3BonHF;A2BxnHA;;EAMI,kBAAA;EACA,WAAA;A3BsnHJ;A2BpnHI;;;;;;;;EAIE,UAAA;A3B0nHN;A2BpnHA;;;;EAKI,iBAAA;A3BqnHJ;A2BhnHA;EACE,iBAAA;A3BknHF;A2BnnHA;;;EAOI,WAAA;A3BinHJ;A2BxnHA;;;EAYI,gBAAA;A3BinHJ;A2B7mHA;EACE,gBAAA;A3B+mHF;A2B3mHA;EACE,cAAA;A3B6mHF;A2B5mHE;ECpDA,0BAAA;EACA,6BAAA;A5BmqHF;A2B3mHA;;ECjDE,yBAAA;EACA,4BAAA;A5BgqHF;A2B1mHA;EACE,WAAA;A3B4mHF;A2B1mHA;EACE,gBAAA;A3B4mHF;A2B1mHA;;ECrEE,0BAAA;EACA,6BAAA;A5BmrHF;A2BzmHA;ECnEE,yBAAA;EACA,4BAAA;A5B+qHF;A2BxmHA;;EAEE,UAAA;A3B0mHF;A2BzlHA;EACE,kBAAA;EACA,iBAAA;A3B2lHF;A2BzlHA;EACE,mBAAA;EACA,kBAAA;A3B2lHF;A2BtlHA;EtB/CE,wDAAA;EACQ,gDAAA;ALwoHV;A2BtlHE;EtBnDA,wBAAA;EACQ,gBAAA;AL4oHV;A2BnlHA;EACE,cAAA;A3BqlHF;A2BllHA;EACE,uBAAA;EACA,sBAAA;A3BolHF;A2BjlHA;EACE,uBAAA;A3BmlHF;A2B5kHA;;;EAII,cAAA;EACA,WAAA;EACA,WAAA;EACA,eAAA;A3B6kHJ;A2BplHA;EAcM,WAAA;A3BykHN;A2BvlHA;;;;EAsBI,gBAAA;EACA,cAAA;A3BukHJ;A2BlkHE;EACE,gBAAA;A3BokHJ;A2BlkHE;EC7KA,2BAAA;EACA,4BAAA;EAOA,6BAAA;EACA,4BAAA;A5B4uHF;A2BpkHE;ECjLA,yBAAA;EACA,0BAAA;EAOA,+BAAA;EACA,8BAAA;A5BkvHF;A2BrkHA;EACE,gBAAA;A3BukHF;A2BrkHA;;ECjLE,6BAAA;EACA,4BAAA;A5B0vHF;A2BpkHA;EC/LE,yBAAA;EACA,0BAAA;A5BswHF;A2BhkHA;EACE,cAAA;EACA,WAAA;EACA,mBAAA;EACA,yBAAA;A3BkkHF;A2BtkHA;;EAOI,mBAAA;EACA,WAAA;EACA,SAAA;A3BmkHJ;A2B5kHA;EAYI,WAAA;A3BmkHJ;A2B/kHA;EAgBI,UAAA;A3BkkHJ;A2BjjHA;;;;EAKM,kBAAA;EACA,sBAAA;EACA,oBAAA;A3BkjHN;A6B5xHA;EACE,kBAAA;EACA,cAAA;EACA,yBAAA;A7B8xHF;A6B3xHE;EACE,WAAA;EACA,gBAAA;EACA,eAAA;A7B6xHJ;A6BtyHA;EAeI,kBAAA;EACA,UAAA;EAKA,WAAA;EAEA,WAAA;EACA,gBAAA;A7BqxHJ;A6BnxHI;EACE,UAAA;A7BqxHN;A6B3wHA;;;EVwBE,YAAA;EACA,kBAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;AnBwvHF;AmBtvHE;;;EACE,YAAA;EACA,iBAAA;AnB0vHJ;AmBvvHE;;;;;;EAEE,YAAA;AnB6vHJ;A6B7xHA;;;EVmBE,YAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AnB+wHF;AmB7wHE;;;EACE,YAAA;EACA,iBAAA;AnBixHJ;AmB9wHE;;;;;;EAEE,YAAA;AnBoxHJ;A6B3yHA;;;EAGE,mBAAA;A7B6yHF;A6B3yHE;;;EACE,gBAAA;A7B+yHJ;A6B3yHA;;EAEE,SAAA;EACA,mBAAA;EACA,sBAAA;A7B6yHF;A6BxyHA;EACE,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,cAAA;EACA,kBAAA;EACA,yBAAA;EACA,sBAAA;EACA,kBAAA;A7B0yHF;A6BvyHE;EACE,iBAAA;EACA,eAAA;EACA,kBAAA;A7ByyHJ;A6BvyHE;EACE,kBAAA;EACA,eAAA;EACA,kBAAA;A7ByyHJ;A6B7zHA;;EA0BI,aAAA;A7BuyHJ;A6BlyHA;;;;;;;EDtGE,0BAAA;EACA,6BAAA;A5Bi5HF;A6BnyHA;EACE,eAAA;A7BqyHF;A6BnyHA;;;;;;;ED1GE,yBAAA;EACA,4BAAA;A5Bs5HF;A6BpyHA;EACE,cAAA;A7BsyHF;A6BjyHA;EACE,kBAAA;EAGA,YAAA;EACA,mBAAA;A7BiyHF;A6BtyHA;EAUI,kBAAA;A7B+xHJ;A6BzyHA;EAYM,iBAAA;A7BgyHN;A6B7xHI;;;EAGE,UAAA;A7B+xHN;A6B1xHE;;EAGI,kBAAA;A7B2xHN;A6BxxHE;;EAGI,UAAA;EACA,iBAAA;A7ByxHN;A8Bx7HA;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;A9B07HF;A8B77HA;EAOI,kBAAA;EACA,cAAA;A9By7HJ;A8Bj8HA;EAWM,kBAAA;EACA,cAAA;EACA,kBAAA;A9By7HN;A8Bx7HM;;EAEE,qBAAA;EACA,yBAAA;A9B07HR;A8Br7HI;EACE,cAAA;A9Bu7HN;A8Br7HM;;EAEE,cAAA;EACA,qBAAA;EACA,mBAAA;EACA,6BAAA;A9Bu7HR;A8Bh7HI;;;EAGE,yBAAA;EACA,qBAAA;A9Bk7HN;A8B39HA;ELLE,WAAA;EACA,aAAA;EACA,gBAAA;EACA,yBAAA;AzBm+HF;A8Bj+HA;EA0DI,eAAA;A9B06HJ;A8Bj6HA;EACE,6BAAA;A9Bm6HF;A8Bp6HA;EAGI,WAAA;EAEA,mBAAA;A9Bm6HJ;A8Bx6HA;EASM,iBAAA;EACA,uBAAA;EACA,6BAAA;EACA,0BAAA;A9Bk6HN;A8Bj6HM;EACE,kCAAA;A9Bm6HR;A8B75HM;;;EAGE,cAAA;EACA,eAAA;EACA,gCAAA;EACA,sBAAA;EACA,gCAAA;A9B+5HR;A8B15HE;EAqDA,WAAA;EA8BA,gBAAA;A9B20HF;A8B95HE;EAwDE,WAAA;A9By2HJ;A8Bj6HE;EA0DI,kBAAA;EACA,kBAAA;A9B02HN;A8Br6HE;EAgEE,SAAA;EACA,UAAA;A9Bw2HJ;A8Br2HE;EAAA;IAEI,mBAAA;IACA,SAAA;E9Bu2HJ;E8B12HA;IAKM,gBAAA;E9Bw2HN;AACF;A8Bl7HE;EAuFE,eAAA;EACA,kBAAA;A9B81HJ;A8Bt7HE;;;EA8FE,sBAAA;A9B61HJ;A8B11HE;EAAA;IAEI,6BAAA;IACA,0BAAA;E9B41HJ;E8B/1HA;;;IAQI,mCAAA;E9B41HJ;AACF;A8B77HA;EAEI,WAAA;A9B87HJ;A8Bh8HA;EAMM,kBAAA;A9B67HN;A8Bn8HA;EASM,gBAAA;A9B67HN;A8Bx7HM;;;EAGE,WAAA;EACA,yBAAA;A9B07HR;A8Bl7HA;EAEI,WAAA;A9Bm7HJ;A8Br7HA;EAIM,eAAA;EACA,cAAA;A9Bo7HN;A8Bx6HA;EACE,WAAA;A9B06HF;A8B36HA;EAII,WAAA;A9B06HJ;A8B96HA;EAMM,kBAAA;EACA,kBAAA;A9B26HN;A8Bl7HA;EAYI,SAAA;EACA,UAAA;A9By6HJ;A8Bt6HE;EAAA;IAEI,mBAAA;IACA,SAAA;E9Bw6HJ;E8B36HA;IAKM,gBAAA;E9By6HN;AACF;A8Bj6HA;EACE,gBAAA;A9Bm6HF;A8Bp6HA;EAKI,eAAA;EACA,kBAAA;A9Bk6HJ;A8Bx6HA;;;EAYI,sBAAA;A9Bi6HJ;A8B95HE;EAAA;IAEI,6BAAA;IACA,0BAAA;E9Bg6HJ;E8Bn6HA;;;IAQI,mCAAA;E9Bg6HJ;AACF;A8Bv5HA;EAEI,aAAA;A9Bw5HJ;A8B15HA;EAKI,cAAA;A9Bw5HJ;A8B/4HA;EAEE,gBAAA;EF7OA,yBAAA;EACA,0BAAA;A5B8nIF;A+BtnIA;EACE,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,6BAAA;A/BwnIF;A+BnnIE;EAAA;IACE,kBAAA;E/BsnIF;AACF;A+B1mIE;EAAA;IACE,WAAA;E/B6mIF;AACF;A+B/lIA;EACE,kBAAA;EACA,iBAAA;EACA,mBAAA;EACA,iCAAA;EACA,kDAAA;EAEA,iCAAA;A/BgmIF;A+B9lIE;EACE,gBAAA;A/BgmIJ;A+B7lIE;EAAA;IACE,WAAA;IACA,aAAA;IACA,gBAAA;E/BgmIF;E+B9lIE;IACE,yBAAA;IACA,uBAAA;IACA,iBAAA;IACA,4BAAA;E/BgmIJ;E+B7lIE;IACE,mBAAA;E/B+lIJ;E+B1lIE;;;IAGE,gBAAA;IACA,eAAA;E/B4lIJ;AACF;A+BxlIA;;EAWE,eAAA;EACA,QAAA;EACA,OAAA;EACA,aAAA;A/BilIF;A+B/lIA;;EAGI,iBAAA;A/BgmIJ;A+B9lII;EAAA;;IACE,iBAAA;E/BkmIJ;AACF;A+BxlIE;EAAA;;IACE,gBAAA;E/B4lIF;AACF;A+BzlIA;EACE,MAAA;EACA,qBAAA;A/B2lIF;A+BzlIA;EACE,SAAA;EACA,gBAAA;EACA,qBAAA;A/B2lIF;A+BnlIA;;;;EAII,iBAAA;EACA,gBAAA;A/BqlIJ;A+BnlII;EAAA;;;;IACE,eAAA;IACA,cAAA;E/BylIJ;AACF;A+B7kIA;EACE,aAAA;EACA,qBAAA;A/B+kIF;A+B7kIE;EAAA;IACE,gBAAA;E/BglIF;AACF;A+B1kIA;EACE,WAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;A/B4kIF;A+B1kIE;;EAEE,qBAAA;A/B4kIJ;A+BrlIA;EAaI,cAAA;A/B2kIJ;A+BxkIE;EACE;;IAEE,gBAAA;E/B0kIJ;AACF;A+BhkIA;EACE,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,iBAAA;EC9LA,gBAAA;EACA,mBAAA;ED+LA,6BAAA;EACA,sBAAA;EACA,6BAAA;EACA,kBAAA;A/BmkIF;A+B/jIE;EACE,UAAA;A/BikIJ;A+B/kIA;EAmBI,cAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;A/B+jIJ;A+BrlIA;EAyBI,eAAA;A/B+jIJ;A+B5jIE;EAAA;IACE,aAAA;E/B+jIF;AACF;A+BtjIA;EACE,eAAA;A/BwjIF;A+BzjIA;EAII,iBAAA;EACA,oBAAA;EACA,iBAAA;A/BwjIJ;A+BrjIE;EAAA;IAGI,gBAAA;IACA,WAAA;IACA,WAAA;IACA,aAAA;IACA,6BAAA;IACA,SAAA;IACA,gBAAA;E/BsjIJ;E+B/jIA;;IAYM,0BAAA;E/BujIN;E+BnkIA;IAeM,iBAAA;E/BujIN;E+BtjIM;;IAEE,sBAAA;E/BwjIR;AACF;A+BljIE;EAAA;IACE,WAAA;IACA,SAAA;E/BqjIF;E+BvjIA;IAKI,WAAA;E/BqjIJ;E+B1jIA;IAOM,gBAAA;IACA,mBAAA;E/BsjIN;AACF;A+B3iIA;EACE,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,iCAAA;EACA,oCAAA;E1B5NA,4FAAA;EACQ,oFAAA;E2BjER,gBAAA;EACA,mBAAA;AhC40IF;AkB/3HE;EAAA;IAGI,qBAAA;IACA,gBAAA;IACA,sBAAA;ElBg4HJ;EkBr4HA;IAUI,qBAAA;IACA,WAAA;IACA,sBAAA;ElB83HJ;EkB14HA;IAiBI,qBAAA;ElB43HJ;EkB74HA;IAqBI,qBAAA;IACA,sBAAA;ElB23HJ;EkBj5HA;;;IA2BM,WAAA;ElB23HN;EkBt5HA;IAiCI,WAAA;ElBw3HJ;EkBz5HA;IAqCI,gBAAA;IACA,sBAAA;ElBu3HJ;EkB75HA;;IA6CI,qBAAA;IACA,aAAA;IACA,gBAAA;IACA,sBAAA;ElBo3HJ;EkBp6HA;;IAmDM,eAAA;ElBq3HN;EkBx6HA;;IAwDI,kBAAA;IACA,cAAA;ElBo3HJ;EkB76HA;IA8DI,MAAA;ElBk3HJ;AACF;A+B3lII;EAAA;IACE,kBAAA;E/B8lIJ;E+B5lII;IACE,gBAAA;E/B8lIN;AACF;A+BtlIE;EAAA;IACE,WAAA;IACA,cAAA;IACA,iBAAA;IACA,eAAA;IACA,cAAA;IACA,SAAA;I1BvPF,wBAAA;IACQ,gBAAA;ELi1IR;AACF;A+BnlIA;EACE,aAAA;EHpUA,yBAAA;EACA,0BAAA;A5B05IF;A+BnlIA;EACE,gBAAA;EHzUA,2BAAA;EACA,4BAAA;EAOA,6BAAA;EACA,4BAAA;A5By5IF;A+B/kIA;EChVE,gBAAA;EACA,mBAAA;AhCk6IF;A+BhlIE;ECnVA,eAAA;EACA,kBAAA;AhCs6IF;A+BjlIE;ECtVA,eAAA;EACA,kBAAA;AhC06IF;A+B3kIA;EChWE,eAAA;EACA,kBAAA;AhC86IF;A+B5kIE;EAAA;IACE,WAAA;IACA,iBAAA;IACA,gBAAA;E/B+kIF;AACF;A+BnkIA;EACE;IEtWA,sBAAA;ICDW,WAAA;ElC86IX;E+BtkIA;IE1WA,uBAAA;ICCY,YAAA;IH2WV,iBAAA;E/BykIF;E+B3kIA;IAKI,eAAA;E/BykIJ;AACF;A+BhkIA;EACE,yBAAA;EACA,0CAAA;A/BkkIF;A+BpkIA;EAKI,cAAA;A/BkkIJ;A+BjkII;;EAEE,cAAA;EACA,6BAAA;A/BmkIN;A+B5kIA;EAcI,WAAA;A/BikIJ;A+B/kIA;EAmBM,cAAA;A/B+jIN;A+B7jIM;;EAEE,WAAA;EACA,6BAAA;A/B+jIR;A+B3jIM;;;EAGE,WAAA;EACA,yBAAA;A/B6jIR;A+BzjIM;;;EAGE,WAAA;EACA,6BAAA;A/B2jIR;A+BpjIM;;;EAGE,WAAA;EACA,yBAAA;A/BsjIR;A+BljII;EAAA;IAIM,cAAA;E/BkjIR;E+BjjIQ;;IAEE,WAAA;IACA,6BAAA;E/BmjIV;E+B/iIQ;;;IAGE,WAAA;IACA,yBAAA;E/BijIV;E+B7iIQ;;;IAGE,WAAA;IACA,6BAAA;E/B+iIV;AACF;A+B/nIA;EAuFI,kBAAA;A/B2iIJ;A+B1iII;;EAEE,sBAAA;A/B4iIN;A+BtoIA;EA6FM,sBAAA;A/B4iIN;A+BzoIA;;EAmGI,0CAAA;A/B0iIJ;A+B7oIA;EA4GI,cAAA;A/BoiIJ;A+BniII;EACE,WAAA;A/BqiIN;A+BnpIA;EAmHI,cAAA;A/BmiIJ;A+BliII;;EAEE,WAAA;A/BoiIN;A+BhiIM;;;;EAEE,WAAA;A/BoiIR;A+B5hIA;EACE,sBAAA;EACA,qBAAA;A/B8hIF;A+BhiIA;EAKI,cAAA;A/B8hIJ;A+B7hII;;EAEE,WAAA;EACA,6BAAA;A/B+hIN;A+BxiIA;EAcI,cAAA;A/B6hIJ;A+B3iIA;EAmBM,cAAA;A/B2hIN;A+BzhIM;;EAEE,WAAA;EACA,6BAAA;A/B2hIR;A+BvhIM;;;EAGE,WAAA;EACA,yBAAA;A/ByhIR;A+BrhIM;;;EAGE,WAAA;EACA,6BAAA;A/BuhIR;A+BjhIM;;;EAGE,WAAA;EACA,yBAAA;A/BmhIR;A+B/gII;EAAA;IAIM,qBAAA;E/B+gIR;E+BnhIE;IAOM,yBAAA;E/B+gIR;E+BthIE;IAUM,cAAA;E/B+gIR;E+B9gIQ;;IAEE,WAAA;IACA,6BAAA;E/BghIV;E+B5gIQ;;;IAGE,WAAA;IACA,yBAAA;E/B8gIV;E+B1gIQ;;;IAGE,WAAA;IACA,6BAAA;E/B4gIV;AACF;A+BjmIA;EA6FI,kBAAA;A/BugIJ;A+BtgII;;EAEE,sBAAA;A/BwgIN;A+BxmIA;EAmGM,sBAAA;A/BwgIN;A+B3mIA;;EAyGI,qBAAA;A/BsgIJ;A+B/mIA;EA6GI,cAAA;A/BqgIJ;A+BpgII;EACE,WAAA;A/BsgIN;A+BrnIA;EAoHI,cAAA;A/BogIJ;A+BngII;;EAEE,WAAA;A/BqgIN;A+BjgIM;;;;EAEE,WAAA;A/BqgIR;AmC3oJA;EACE,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;AnC6oJF;AmClpJA;EAQI,qBAAA;AnC6oJJ;AmCrpJA;EAWM,cAAA;EACA,2FAAA;EACA,iBAAA;AnC6oJN;AmC1pJA;EAkBI,cAAA;AnC2oJJ;AoC/pJA;EACE,qBAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;ApCiqJF;AoCrqJA;EAOI,eAAA;ApCiqJJ;AoCxqJA;;EAUM,kBAAA;EACA,WAAA;EACA,iBAAA;EACA,iBAAA;EACA,uBAAA;EACA,cAAA;EACA,qBAAA;EACA,sBAAA;EACA,sBAAA;ApCkqJN;AoChqJM;;;;EAEE,UAAA;EACA,cAAA;EACA,yBAAA;EACA,kBAAA;ApCoqJR;AoCjqJI;;EAGI,cAAA;ERnBN,2BAAA;EACA,8BAAA;A5BsrJF;AoChqJI;;ER/BF,4BAAA;EACA,+BAAA;A5BmsJF;AoC3pJI;;;;;;EAGE,UAAA;EACA,WAAA;EACA,eAAA;EACA,yBAAA;EACA,qBAAA;ApCgqJN;AoCptJA;;;;;;EA+DM,cAAA;EACA,mBAAA;EACA,sBAAA;EACA,kBAAA;ApC6pJN;AoCppJA;;ECxEM,kBAAA;EACA,eAAA;EACA,sBAAA;ArCguJN;AqC9tJI;;ETKF,2BAAA;EACA,8BAAA;A5B6tJF;AqC7tJI;;ETTF,4BAAA;EACA,+BAAA;A5B0uJF;AoC/pJA;;EC7EM,iBAAA;EACA,eAAA;EACA,gBAAA;ArCgvJN;AqC9uJI;;ETKF,2BAAA;EACA,8BAAA;A5B6uJF;AqC7uJI;;ETTF,4BAAA;EACA,+BAAA;A5B0vJF;AsC7vJA;EACE,eAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;AtC+vJF;AsCnwJA;EAOI,eAAA;AtC+vJJ;AsCtwJA;;EAUM,qBAAA;EACA,iBAAA;EACA,sBAAA;EACA,sBAAA;EACA,mBAAA;AtCgwJN;AsC9wJA;;EAmBM,qBAAA;EACA,yBAAA;AtC+vJN;AsCnxJA;;EA2BM,YAAA;AtC4vJN;AsCvxJA;;EAkCM,WAAA;AtCyvJN;AsC3xJA;;;;EA2CM,cAAA;EACA,mBAAA;EACA,sBAAA;AtCsvJN;AuCpyJA;EACE,eAAA;EACA,0BAAA;EACA,cAAA;EACA,gBAAA;EACA,cAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,wBAAA;EACA,qBAAA;AvCsyJF;AuClyJI;;EAEE,WAAA;EACA,qBAAA;EACA,eAAA;AvCoyJN;AuC/xJE;EACE,aAAA;AvCiyJJ;AuC7xJE;EACE,kBAAA;EACA,SAAA;AvC+xJJ;AuCxxJA;ECtCE,yBAAA;AxCi0JF;AwC9zJI;;EAEE,yBAAA;AxCg0JN;AuC3xJA;EC1CE,yBAAA;AxCw0JF;AwCr0JI;;EAEE,yBAAA;AxCu0JN;AuC9xJA;EC9CE,yBAAA;AxC+0JF;AwC50JI;;EAEE,yBAAA;AxC80JN;AuCjyJA;EClDE,yBAAA;AxCs1JF;AwCn1JI;;EAEE,yBAAA;AxCq1JN;AuCpyJA;ECtDE,yBAAA;AxC61JF;AwC11JI;;EAEE,yBAAA;AxC41JN;AuCvyJA;EC1DE,yBAAA;AxCo2JF;AwCj2JI;;EAEE,yBAAA;AxCm2JN;AyCr2JA;EACE,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;EACA,yBAAA;EACA,mBAAA;AzCu2JF;AyCp2JE;EACE,aAAA;AzCs2JJ;AyCl2JE;EACE,kBAAA;EACA,SAAA;AzCo2JJ;AyCj2JE;;EAEE,MAAA;EACA,gBAAA;AzCm2JJ;AyC91JI;;EAEE,WAAA;EACA,qBAAA;EACA,eAAA;AzCg2JN;AyC31JE;;EAEE,cAAA;EACA,sBAAA;AzC61JJ;AyC11JE;EACE,YAAA;AzC41JJ;AyCz1JE;EACE,iBAAA;AzC21JJ;AyCx1JE;EACE,gBAAA;AzC01JJ;A0Cp5JA;EACE,iBAAA;EACA,oBAAA;EACA,mBAAA;EACA,cAAA;EACA,yBAAA;A1Cs5JF;A0C35JA;;EASI,cAAA;A1Cs5JJ;A0C/5JA;EAaI,mBAAA;EACA,eAAA;EACA,gBAAA;A1Cq5JJ;A0Cp6JA;EAmBI,yBAAA;A1Co5JJ;A0Cj5JE;;EAEE,kBAAA;EACA,iBAAA;EACA,kBAAA;A1Cm5JJ;A0C76JA;EA8BI,eAAA;A1Ck5JJ;A0C/4JE;EAAA;IACE,iBAAA;IACA,oBAAA;E1Ck5JF;E0Ch5JE;;IAEE,mBAAA;IACA,kBAAA;E1Ck5JJ;E0Cz5JA;;IAYI,eAAA;E1Ci5JJ;AACF;A2C57JA;EACE,cAAA;EACA,YAAA;EACA,mBAAA;EACA,uBAAA;EACA,gCAAA;EACA,sBAAA;EACA,kBAAA;EtCiLA,2CAAA;EACK,sCAAA;EACG,mCAAA;AL8wJV;A2Cx8JA;;EAaI,kBAAA;EACA,iBAAA;A3C+7JJ;A2C37JE;;;EAGE,qBAAA;A3C67JJ;A2Cl9JA;EA0BI,YAAA;EACA,YAAA;A3C27JJ;A4Ct9JA;EACE,aAAA;EACA,mBAAA;EACA,6BAAA;EACA,kBAAA;A5Cw9JF;A4C59JA;EAQI,aAAA;EACA,cAAA;A5Cu9JJ;A4Ch+JA;EAcI,iBAAA;A5Cq9JJ;A4Cn+JA;;EAoBI,gBAAA;A5Cm9JJ;A4Cv+JA;EAwBI,eAAA;A5Ck9JJ;A4Cz8JA;;EAEE,mBAAA;A5C28JF;A4C78JA;;EAMI,kBAAA;EACA,SAAA;EACA,YAAA;EACA,cAAA;A5C28JJ;A4Cn8JA;ECvDE,cAAA;EACA,yBAAA;EACA,qBAAA;A7C6/JF;A4Cx8JA;EClDI,yBAAA;A7C6/JJ;A4C38JA;EC9CI,cAAA;A7C4/JJ;A4C18JA;EC3DE,cAAA;EACA,yBAAA;EACA,qBAAA;A7CwgKF;A4C/8JA;ECtDI,yBAAA;A7CwgKJ;A4Cl9JA;EClDI,cAAA;A7CugKJ;A4Cj9JA;EC/DE,cAAA;EACA,yBAAA;EACA,qBAAA;A7CmhKF;A4Ct9JA;EC1DI,yBAAA;A7CmhKJ;A4Cz9JA;ECtDI,cAAA;A7CkhKJ;A4Cx9JA;ECnEE,cAAA;EACA,yBAAA;EACA,qBAAA;A7C8hKF;A4C79JA;EC9DI,yBAAA;A7C8hKJ;A4Ch+JA;EC1DI,cAAA;A7C6hKJ;A8C9hKA;EACE;IAAQ,2BAAA;E9CiiKR;E8ChiKA;IAAQ,wBAAA;E9CmiKR;AACF;A8ChiKA;EACE;IAAQ,2BAAA;E9CmiKR;E8CliKA;IAAQ,wBAAA;E9CqiKR;AACF;A8C9hKA;EACE,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EzCsCA,sDAAA;EACQ,8CAAA;AL2/JV;A8C7hKA;EACE,WAAA;EACA,SAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,WAAA;EACA,kBAAA;EACA,yBAAA;EzCyBA,sDAAA;EACQ,8CAAA;EAyHR,mCAAA;EACK,8BAAA;EACG,2BAAA;AL+4JV;A8C1hKA;;ECDI,6MAAA;EACA,wMAAA;EACA,qMAAA;EDEF,0BAAA;A9C8hKF;A8CvhKA;;EzC5CE,0DAAA;EACK,qDAAA;EACG,kDAAA;ALukKV;A8CphKA;EEvEE,yBAAA;AhD8lKF;AgD3lKE;EDgDE,6MAAA;EACA,wMAAA;EACA,qMAAA;A/C8iKJ;A8CxhKA;EE3EE,yBAAA;AhDsmKF;AgDnmKE;EDgDE,6MAAA;EACA,wMAAA;EACA,qMAAA;A/CsjKJ;A8C5hKA;EE/EE,yBAAA;AhD8mKF;AgD3mKE;EDgDE,6MAAA;EACA,wMAAA;EACA,qMAAA;A/C8jKJ;A8ChiKA;EEnFE,yBAAA;AhDsnKF;AgDnnKE;EDgDE,6MAAA;EACA,wMAAA;EACA,qMAAA;A/CskKJ;AiD9nKA;EAEE,gBAAA;AjD+nKF;AiD7nKE;EACE,aAAA;AjD+nKJ;AiD3nKA;;EAEE,gBAAA;EACA,OAAA;AjD6nKF;AiD1nKA;EACE,cAAA;AjD4nKF;AiDznKA;EACE,cAAA;AjD2nKF;AiDxnKE;EACE,eAAA;AjD0nKJ;AiDtnKA;;EAEE,kBAAA;AjDwnKF;AiDrnKA;;EAEE,mBAAA;AjDunKF;AiDpnKA;;;EAGE,mBAAA;EACA,mBAAA;AjDsnKF;AiDnnKA;EACE,sBAAA;AjDqnKF;AiDlnKA;EACE,sBAAA;AjDonKF;AiDhnKA;EACE,aAAA;EACA,kBAAA;AjDknKF;AiD5mKA;EACE,eAAA;EACA,gBAAA;AjD8mKF;AkDnqKA;EAEE,eAAA;EACA,mBAAA;AlDoqKF;AkD5pKA;EACE,kBAAA;EACA,cAAA;EACA,kBAAA;EAEA,mBAAA;EACA,sBAAA;EACA,sBAAA;AlD6pKF;AkD1pKE;EtB7BA,2BAAA;EACA,4BAAA;A5B0rKF;AkD3pKE;EACE,gBAAA;EtBzBF,+BAAA;EACA,8BAAA;A5BurKF;AkD1pKE;;;EAGE,cAAA;EACA,mBAAA;EACA,yBAAA;AlD4pKJ;AkDjqKE;;;EASI,cAAA;AlD6pKN;AkDtqKE;;;EAYI,cAAA;AlD+pKN;AkD1pKE;;;EAGE,UAAA;EACA,WAAA;EACA,yBAAA;EACA,qBAAA;AlD4pKJ;AkDlqKE;;;;;;;;;EAYI,cAAA;AlDiqKN;AkD7qKE;;;EAeI,cAAA;AlDmqKN;AkDxpKA;;EAEE,WAAA;AlD0pKF;AkD5pKA;;EAKI,WAAA;AlD2pKJ;AkDvpKE;;;;EAEE,WAAA;EACA,qBAAA;EACA,yBAAA;AlD2pKJ;AkDvpKA;EACE,WAAA;EACA,gBAAA;AlDypKF;AmD7vKG;EACC,cAAA;EACA,yBAAA;AnD+vKJ;AmD7vKI;;EAEE,cAAA;AnD+vKN;AmDjwKI;;EAKI,cAAA;AnDgwKR;AmD7vKM;;;;EAEE,cAAA;EACA,yBAAA;AnDiwKR;AmD/vKM;;;;;;EAGE,WAAA;EACA,yBAAA;EACA,qBAAA;AnDowKR;AmD1xKG;EACC,cAAA;EACA,yBAAA;AnD4xKJ;AmD1xKI;;EAEE,cAAA;AnD4xKN;AmD9xKI;;EAKI,cAAA;AnD6xKR;AmD1xKM;;;;EAEE,cAAA;EACA,yBAAA;AnD8xKR;AmD5xKM;;;;;;EAGE,WAAA;EACA,yBAAA;EACA,qBAAA;AnDiyKR;AmDvzKG;EACC,cAAA;EACA,yBAAA;AnDyzKJ;AmDvzKI;;EAEE,cAAA;AnDyzKN;AmD3zKI;;EAKI,cAAA;AnD0zKR;AmDvzKM;;;;EAEE,cAAA;EACA,yBAAA;AnD2zKR;AmDzzKM;;;;;;EAGE,WAAA;EACA,yBAAA;EACA,qBAAA;AnD8zKR;AmDp1KG;EACC,cAAA;EACA,yBAAA;AnDs1KJ;AmDp1KI;;EAEE,cAAA;AnDs1KN;AmDx1KI;;EAKI,cAAA;AnDu1KR;AmDp1KM;;;;EAEE,cAAA;EACA,yBAAA;AnDw1KR;AmDt1KM;;;;;;EAGE,WAAA;EACA,yBAAA;EACA,qBAAA;AnD21KR;AkD1vKA;EACE,aAAA;EACA,kBAAA;AlD4vKF;AkD1vKA;EACE,gBAAA;EACA,gBAAA;AlD4vKF;AoDp3KA;EACE,mBAAA;EACA,sBAAA;EACA,6BAAA;EACA,kBAAA;E/C0DA,iDAAA;EACQ,yCAAA;AL6zKV;AoDn3KA;EACE,aAAA;ApDq3KF;AoDh3KA;EACE,kBAAA;EACA,oCAAA;ExBtBA,2BAAA;EACA,4BAAA;A5By4KF;AoDt3KA;EAMI,cAAA;ApDm3KJ;AoD92KA;EACE,aAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;ApDg3KF;AoDp3KA;;;;;EAWI,cAAA;ApDg3KJ;AoD32KA;EACE,kBAAA;EACA,yBAAA;EACA,0BAAA;ExB1CA,+BAAA;EACA,8BAAA;A5Bw5KF;AoDr2KA;;EAGI,gBAAA;ApDs2KJ;AoDz2KA;;EAMM,mBAAA;EACA,gBAAA;ApDu2KN;AoDn2KI;;EAEI,aAAA;ExBzEN,2BAAA;EACA,4BAAA;A5B+6KF;AoDj2KI;;EAEI,gBAAA;ExBzEN,+BAAA;EACA,8BAAA;A5B66KF;AoD13KA;ExB5DE,yBAAA;EACA,0BAAA;A5By7KF;AoD71KA;EAEI,mBAAA;ApD81KJ;AoD31KA;EACE,mBAAA;ApD61KF;AoDr1KA;;;EAII,gBAAA;ApDs1KJ;AoD11KA;;;EAOM,mBAAA;EACA,kBAAA;ApDw1KN;AoDh2KA;;ExB3GE,2BAAA;EACA,4BAAA;A5B+8KF;AoDr2KA;;;;EAmBQ,2BAAA;EACA,4BAAA;ApDw1KR;AoD52KA;;;;;;;;EAwBU,2BAAA;ApD81KV;AoDt3KA;;;;;;;;EA4BU,4BAAA;ApDo2KV;AoDh4KA;;ExBnGE,+BAAA;EACA,8BAAA;A5Bu+KF;AoDr4KA;;;;EAyCQ,+BAAA;EACA,8BAAA;ApDk2KR;AoD54KA;;;;;;;;EA8CU,8BAAA;ApDw2KV;AoDt5KA;;;;;;;;EAkDU,+BAAA;ApD82KV;AoDh6KA;;;;EA2DI,0BAAA;ApD22KJ;AoDt6KA;;EA+DI,aAAA;ApD22KJ;AoD16KA;;EAmEI,SAAA;ApD22KJ;AoD96KA;;;;;;;;;;;;EA0EU,cAAA;ApDk3KV;AoD57KA;;;;;;;;;;;;EA8EU,eAAA;ApD43KV;AoD18KA;;;;;;;;EAuFU,gBAAA;ApD63KV;AoDp9KA;;;;;;;;EAgGU,gBAAA;ApD83KV;AoD99KA;EAsGI,gBAAA;EACA,SAAA;ApD23KJ;AoDj3KA;EACE,mBAAA;ApDm3KF;AoDp3KA;EAKI,gBAAA;EACA,kBAAA;ApDk3KJ;AoDx3KA;EASM,eAAA;ApDk3KN;AoD33KA;EAcI,gBAAA;ApDg3KJ;AoD93KA;;EAkBM,0BAAA;ApDg3KN;AoDl4KA;EAuBI,aAAA;ApD82KJ;AoDr4KA;EAyBM,6BAAA;ApD+2KN;AoDx2KA;EC5PE,kBAAA;ArDumLF;AqDrmLE;EACE,cAAA;EACA,yBAAA;EACA,kBAAA;ArDumLJ;AqD1mLE;EAMI,sBAAA;ArDumLN;AqD7mLE;EASI,cAAA;EACA,yBAAA;ArDumLN;AqDpmLE;EAEI,yBAAA;ArDqmLN;AoDv3KA;EC/PE,qBAAA;ArDynLF;AqDvnLE;EACE,WAAA;EACA,yBAAA;EACA,qBAAA;ArDynLJ;AqD5nLE;EAMI,yBAAA;ArDynLN;AqD/nLE;EASI,cAAA;EACA,sBAAA;ArDynLN;AqDtnLE;EAEI,4BAAA;ArDunLN;AoDt4KA;EClQE,qBAAA;ArD2oLF;AqDzoLE;EACE,cAAA;EACA,yBAAA;EACA,qBAAA;ArD2oLJ;AqD9oLE;EAMI,yBAAA;ArD2oLN;AqDjpLE;EASI,cAAA;EACA,yBAAA;ArD2oLN;AqDxoLE;EAEI,4BAAA;ArDyoLN;AoDr5KA;ECrQE,qBAAA;ArD6pLF;AqD3pLE;EACE,cAAA;EACA,yBAAA;EACA,qBAAA;ArD6pLJ;AqDhqLE;EAMI,yBAAA;ArD6pLN;AqDnqLE;EASI,cAAA;EACA,yBAAA;ArD6pLN;AqD1pLE;EAEI,4BAAA;ArD2pLN;AoDp6KA;ECxQE,qBAAA;ArD+qLF;AqD7qLE;EACE,cAAA;EACA,yBAAA;EACA,qBAAA;ArD+qLJ;AqDlrLE;EAMI,yBAAA;ArD+qLN;AqDrrLE;EASI,cAAA;EACA,yBAAA;ArD+qLN;AqD5qLE;EAEI,4BAAA;ArD6qLN;AoDn7KA;EC3QE,qBAAA;ArDisLF;AqD/rLE;EACE,cAAA;EACA,yBAAA;EACA,qBAAA;ArDisLJ;AqDpsLE;EAMI,yBAAA;ArDisLN;AqDvsLE;EASI,cAAA;EACA,yBAAA;ArDisLN;AqD9rLE;EAEI,4BAAA;ArD+rLN;AsD/sLA;EACE,kBAAA;EACA,cAAA;EACA,SAAA;EACA,UAAA;EACA,gBAAA;AtDitLF;AsDttLA;;;;;EAYI,kBAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;AtDitLJ;AsD5sLA;EACE,sBAAA;AtD8sLF;AsD1sLA;EACE,mBAAA;AtD4sLF;AuDvuLA;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,yBAAA;EACA,kBAAA;ElD0DA,uDAAA;EACQ,+CAAA;ALgrLV;AuDjvLA;EASI,kBAAA;EACA,iCAAA;AvD2uLJ;AuDtuLA;EACE,aAAA;EACA,kBAAA;AvDwuLF;AuDtuLA;EACE,YAAA;EACA,kBAAA;AvDwuLF;AwD5vLA;EACE,YAAA;EACA,iBAAA;EACA,iBAAA;EACA,cAAA;EACA,WAAA;EACA,yBAAA;ElCTA,yBAAA;EACA,YAAA;AtBwwLF;AwD7vLE;;EAEE,WAAA;EACA,qBAAA;EACA,eAAA;ElChBF,yBAAA;EACA,YAAA;AtBgxLF;AwDzvLE;EACE,UAAA;EACA,eAAA;EACA,uBAAA;EACA,SAAA;EACA,wBAAA;EACA,gBAAA;AxD2vLJ;AyDnxLA;EACE,gBAAA;AzDqxLF;AyDjxLA;EACE,eAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,aAAA;EACA,aAAA;EACA,gBAAA;EACA,iCAAA;EAIA,UAAA;AzDgxLF;AyD7wLE;EpDiHA,qCAAA;EACI,iCAAA;EACC,gCAAA;EACG,6BAAA;EAkER,mDAAA;EACG,6CAAA;EACE,yCAAA;EACG,mCAAA;AL8lLV;AyDnxLE;EpD6GA,kCAAA;EACI,8BAAA;EACC,6BAAA;EACG,0BAAA;ALyqLV;AyDvxLA;EACE,kBAAA;EACA,gBAAA;AzDyxLF;AyDrxLA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;AzDuxLF;AyDnxLA;EACE,kBAAA;EACA,sBAAA;EACA,4BAAA;EACA,sBAAA;EACA,oCAAA;EACA,kBAAA;EpDcA,gDAAA;EACQ,wCAAA;EoDZR,UAAA;AzDqxLF;AyDjxLA;EACE,eAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,aAAA;EACA,sBAAA;AzDmxLF;AyDjxLE;EnCpEA,wBAAA;EACA,UAAA;AtBw1LF;AyDpxLE;EnCrEA,yBAAA;EACA,YAAA;AtB41LF;AyDnxLA;EACE,aAAA;EACA,gCAAA;AzDqxLF;AyDjxLA;EACE,gBAAA;AzDmxLF;AyD/wLA;EACE,SAAA;EACA,uBAAA;AzDixLF;AyD5wLA;EACE,kBAAA;EACA,aAAA;AzD8wLF;AyD1wLA;EACE,aAAA;EACA,iBAAA;EACA,6BAAA;AzD4wLF;AyD/wLA;EAQI,gBAAA;EACA,gBAAA;AzD0wLJ;AyDnxLA;EAaI,iBAAA;AzDywLJ;AyDtxLA;EAiBI,cAAA;AzDwwLJ;AyDnwLA;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;AzDqwLF;AyDjwLA;EAEE;IACE,YAAA;IACA,iBAAA;EzDkwLF;EyDhwLA;IpDrEA,iDAAA;IACQ,yCAAA;ELw0LR;EyD/vLA;IAAY,YAAA;EzDkwLZ;AACF;AyDhwLA;EACE;IAAY,YAAA;EzDmwLZ;AACF;A0Dl5LA;EACE,kBAAA;EACA,aAAA;EACA,cAAA;ECRA,2DAAA;EAEA,kBAAA;EACA,gBAAA;EACA,uBAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,oBAAA;EACA,iBAAA;EACA,mBAAA;EDHA,eAAA;EpCTA,wBAAA;EACA,UAAA;AtB06LF;A0D95LE;EpCbA,yBAAA;EACA,YAAA;AtB86LF;A0Dj6LE;EACE,cAAA;EACA,gBAAA;A1Dm6LJ;A0Dj6LE;EACE,cAAA;EACA,gBAAA;A1Dm6LJ;A0Dj6LE;EACE,cAAA;EACA,eAAA;A1Dm6LJ;A0Dj6LE;EACE,cAAA;EACA,iBAAA;A1Dm6LJ;A0D/5LE;EACE,SAAA;EACA,SAAA;EACA,iBAAA;EACA,uBAAA;EACA,sBAAA;A1Di6LJ;A0D/5LE;EACE,UAAA;EACA,SAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;A1Di6LJ;A0D/5LE;EACE,SAAA;EACA,SAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;A1Di6LJ;A0D/5LE;EACE,QAAA;EACA,OAAA;EACA,gBAAA;EACA,2BAAA;EACA,wBAAA;A1Di6LJ;A0D/5LE;EACE,QAAA;EACA,QAAA;EACA,gBAAA;EACA,2BAAA;EACA,uBAAA;A1Di6LJ;A0D/5LE;EACE,MAAA;EACA,SAAA;EACA,iBAAA;EACA,uBAAA;EACA,yBAAA;A1Di6LJ;A0D/5LE;EACE,MAAA;EACA,UAAA;EACA,gBAAA;EACA,uBAAA;EACA,yBAAA;A1Di6LJ;A0D/5LE;EACE,MAAA;EACA,SAAA;EACA,gBAAA;EACA,uBAAA;EACA,yBAAA;A1Di6LJ;A0D55LA;EACE,gBAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;EACA,sBAAA;EACA,kBAAA;A1D85LF;A0D15LA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,yBAAA;EACA,mBAAA;A1D45LF;A4DrgMA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,aAAA;EACA,aAAA;EACA,gBAAA;EACA,YAAA;EDXA,2DAAA;EAEA,kBAAA;EACA,gBAAA;EACA,uBAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,oBAAA;EACA,iBAAA;EACA,mBAAA;ECAA,eAAA;EACA,sBAAA;EACA,4BAAA;EACA,sBAAA;EACA,oCAAA;EACA,kBAAA;EvDiDA,iDAAA;EACQ,yCAAA;ALm+LV;A4DjhME;EAAQ,iBAAA;A5DohMV;A4DnhME;EAAU,iBAAA;A5DshMZ;A4DrhME;EAAW,gBAAA;A5DwhMb;A4DvhME;EAAS,kBAAA;A5D0hMX;A4DjjMA;EA4BI,kBAAA;A5DwhMJ;A4DthMI;;EAEE,kBAAA;EACA,cAAA;EACA,QAAA;EACA,SAAA;EACA,yBAAA;EACA,mBAAA;A5DwhMN;A4DrhMI;EACE,WAAA;EACA,kBAAA;A5DuhMN;A4DnhME;EACE,aAAA;EACA,SAAA;EACA,kBAAA;EACA,yBAAA;EACA,qCAAA;EACA,sBAAA;A5DqhMJ;A4DphMI;EACE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,sBAAA;EACA,sBAAA;A5DshMN;A4DnhME;EACE,QAAA;EACA,WAAA;EACA,iBAAA;EACA,2BAAA;EACA,uCAAA;EACA,oBAAA;A5DqhMJ;A4DphMI;EACE,aAAA;EACA,SAAA;EACA,YAAA;EACA,wBAAA;EACA,oBAAA;A5DshMN;A4DnhME;EACE,UAAA;EACA,SAAA;EACA,kBAAA;EACA,mBAAA;EACA,4BAAA;EACA,wCAAA;A5DqhMJ;A4DphMI;EACE,QAAA;EACA,kBAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;A5DshMN;A4DlhME;EACE,QAAA;EACA,YAAA;EACA,iBAAA;EACA,qBAAA;EACA,0BAAA;EACA,sCAAA;A5DohMJ;A4DnhMI;EACE,UAAA;EACA,aAAA;EACA,YAAA;EACA,qBAAA;EACA,uBAAA;A5DqhMN;A4DhhMA;EACE,iBAAA;EACA,SAAA;EACA,eAAA;EACA,yBAAA;EACA,gCAAA;EACA,0BAAA;A5DkhMF;A4D/gMA;EACE,iBAAA;A5DihMF;A6DroMA;EACE,kBAAA;A7DuoMF;A6DpoMA;EACE,kBAAA;EACA,WAAA;EACA,gBAAA;A7DsoMF;A6DzoMA;EAMI,kBAAA;EACA,aAAA;ExD6KF,yCAAA;EACK,oCAAA;EACG,iCAAA;AL09LV;A6DhpMA;;EAcM,cAAA;A7DsoMN;A6DloMI;EAAA;IxDuLF,sDAAA;IACG,gDAAA;IACE,4CAAA;IACG,sCAAA;IA7JR,mCAAA;IACG,gCAAA;IACK,2BAAA;IA+GR,2BAAA;IACG,wBAAA;IACK,mBAAA;EL+/LR;E6D1oMI;;IxDmHJ,0CAAA;IACQ,kCAAA;IwDjHF,OAAA;E7D6oMN;E6D3oMI;;IxD8GJ,2CAAA;IACQ,mCAAA;IwD5GF,OAAA;E7D8oMN;E6D5oMI;;;IxDyGJ,uCAAA;IACQ,+BAAA;IwDtGF,OAAA;E7D+oMN;AACF;A6DrrMA;;;EA6CI,cAAA;A7D6oMJ;A6D1rMA;EAiDI,OAAA;A7D4oMJ;A6D7rMA;;EAsDI,kBAAA;EACA,MAAA;EACA,WAAA;A7D2oMJ;A6DnsMA;EA4DI,UAAA;A7D0oMJ;A6DtsMA;EA+DI,WAAA;A7D0oMJ;A6DzsMA;;EAmEI,OAAA;A7D0oMJ;A6D7sMA;EAuEI,WAAA;A7DyoMJ;A6DhtMA;EA0EI,UAAA;A7DyoMJ;A6DjoMA;EACE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,eAAA;EACA,WAAA;EACA,kBAAA;EACA,yCAAA;EACA,kCAAA;EvCpGA,yBAAA;EACA,YAAA;AtBwuMF;A6D/nME;EdrGE,kGAAA;EACA,6FAAA;EACA,8FAAA;EACA,sHAAA;EACA,2BAAA;A/CuuMJ;A6DnoME;EACE,QAAA;EACA,UAAA;Ed1GA,kGAAA;EACA,6FAAA;EACA,8FAAA;EACA,sHAAA;EACA,2BAAA;A/CgvMJ;A6DroME;;EAEE,WAAA;EACA,qBAAA;EACA,UAAA;EvCxHF,yBAAA;EACA,YAAA;AtBgwMF;A6DvqMA;;;;EAuCI,kBAAA;EACA,QAAA;EACA,UAAA;EACA,qBAAA;EACA,iBAAA;A7DsoMJ;A6DjrMA;;EA+CI,SAAA;EACA,kBAAA;A7DsoMJ;A6DtrMA;;EAoDI,UAAA;EACA,mBAAA;A7DsoMJ;A6D3rMA;;EAyDI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;A7DsoMJ;A6DloMI;EACE,gBAAA;A7DooMN;A6DhoMI;EACE,gBAAA;A7DkoMN;A6DxnMA;EACE,kBAAA;EACA,YAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;A7D0nMF;A6DnoMA;EAYI,qBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;EACA,eAAA;EAUA,yBAAA;EACA,kCAAA;EAEA,sBAAA;EACA,mBAAA;A7DgnMJ;A6D/oMA;EAmCI,WAAA;EACA,YAAA;EACA,SAAA;EACA,sBAAA;A7D+mMJ;A6DxmMA;EACE,kBAAA;EACA,UAAA;EACA,YAAA;EACA,SAAA;EACA,WAAA;EACA,iBAAA;EACA,oBAAA;EACA,WAAA;EACA,kBAAA;EACA,yCAAA;A7D0mMF;A6DxmME;EACE,iBAAA;A7D0mMJ;A6DpmMA;EAGE;;;;IAKI,WAAA;IACA,YAAA;IACA,iBAAA;IACA,eAAA;E7DmmMJ;E6D3mMA;;IAYI,kBAAA;E7DmmMJ;E6D/mMA;;IAgBI,mBAAA;E7DmmMJ;E6D9lMA;IACE,UAAA;IACA,SAAA;IACA,oBAAA;E7DgmMF;E6D5lMA;IACE,YAAA;E7D8lMF;AACF;A8Dh2ME;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAEE,cAAA;EACA,YAAA;A9Dg4MJ;A8D93ME;;;;;;;;;;;;;;;;EACE,WAAA;A9D+4MJ;AiCr5MA;E8BVE,cAAA;EACA,kBAAA;EACA,iBAAA;A/Dk6MF;AiCv5MA;EACE,uBAAA;AjCy5MF;AiCv5MA;EACE,sBAAA;AjCy5MF;AiCj5MA;EACE,wBAAA;AjCm5MF;AiCj5MA;EACE,yBAAA;AjCm5MF;AiCj5MA;EACE,kBAAA;AjCm5MF;AiCj5MA;E+BzBE,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,6BAAA;EACA,SAAA;AhE66MF;AiC/4MA;EACE,wBAAA;AjCi5MF;AiC14MA;EACE,eAAA;AjC44MF;AiE76MA;EACE,mBAAA;AjE+6MF;AiEz6MA;;;;EClBE,wBAAA;AlEi8MF;AiEx6MA;;;;;;;;;;;;EAYE,wBAAA;AjE06MF;AiEt6ME;EAAA;ICjDA,yBAAA;ElE29MA;EkE19MA;IAAU,yBAAA;ElE69MV;EkE59MA;IAAU,6BAAA;ElE+9MV;EkE99MA;;IACU,8BAAA;ElEi+MV;AACF;AiEh7ME;EAAA;IACE,yBAAA;EjEm7MF;AACF;AiEh7ME;EAAA;IACE,0BAAA;EjEm7MF;AACF;AiEh7ME;EAAA;IACE,gCAAA;EjEm7MF;AACF;AiE/6ME;EAAA;ICtEA,yBAAA;ElEy/MA;EkEx/MA;IAAU,yBAAA;ElE2/MV;EkE1/MA;IAAU,6BAAA;ElE6/MV;EkE5/MA;;IACU,8BAAA;ElE+/MV;AACF;AiEz7ME;EAAA;IACE,yBAAA;EjE47MF;AACF;AiEz7ME;EAAA;IACE,0BAAA;EjE47MF;AACF;AiEz7ME;EAAA;IACE,gCAAA;EjE47MF;AACF;AiEx7ME;EAAA;IC3FA,yBAAA;ElEuhNA;EkEthNA;IAAU,yBAAA;ElEyhNV;EkExhNA;IAAU,6BAAA;ElE2hNV;EkE1hNA;;IACU,8BAAA;ElE6hNV;AACF;AiEl8ME;EAAA;IACE,yBAAA;EjEq8MF;AACF;AiEl8ME;EAAA;IACE,0BAAA;EjEq8MF;AACF;AiEl8ME;EAAA;IACE,gCAAA;EjEq8MF;AACF;AiEj8ME;EAAA;IChHA,yBAAA;ElEqjNA;EkEpjNA;IAAU,yBAAA;ElEujNV;EkEtjNA;IAAU,6BAAA;ElEyjNV;EkExjNA;;IACU,8BAAA;ElE2jNV;AACF;AiE38ME;EAAA;IACE,yBAAA;EjE88MF;AACF;AiE38ME;EAAA;IACE,0BAAA;EjE88MF;AACF;AiE38ME;EAAA;IACE,gCAAA;EjE88MF;AACF;AiE18ME;EAAA;IC7HA,wBAAA;ElE2kNA;AACF;AiE18ME;EAAA;IClIA,wBAAA;ElEglNA;AACF;AiE18ME;EAAA;ICvIA,wBAAA;ElEqlNA;AACF;AiE18ME;EAAA;IC5IA,wBAAA;ElE0lNA;AACF;AiEp8MA;ECvJE,wBAAA;AlE8lNF;AiEp8ME;EAAA;IClKA,yBAAA;ElE0mNA;EkEzmNA;IAAU,yBAAA;ElE4mNV;EkE3mNA;IAAU,6BAAA;ElE8mNV;EkE7mNA;;IACU,8BAAA;ElEgnNV;AACF;AiE/8MA;EACE,wBAAA;AjEi9MF;AiE/8ME;EAAA;IACE,yBAAA;EjEk9MF;AACF;AiEh9MA;EACE,wBAAA;AjEk9MF;AiEh9ME;EAAA;IACE,0BAAA;EjEm9MF;AACF;AiEj9MA;EACE,wBAAA;AjEm9MF;AiEj9ME;EAAA;IACE,gCAAA;EjEo9MF;AACF;AiEh9ME;EAAA;ICrLA,wBAAA;ElEyoNA;AACF;AACA;;;;CAIC;AACD;;;EAGE;AACF;+BAC+B;AmE7pN/B;EACE,0BAAA;EACA,4CAAA;EACA,8SAAA;EAMA,mBAAA;EACA,kBAAA;AnE0pNF;AoEpqNC;EACC,qBAAA;EACA,6CAAA;EACA,kBAAA;EACA,oBAAA;EACA,mCAAA;EACA,kCAAA;ApEsqNF;AACA,6DAA6D;AqE5qN5D;EACC,uBAAA;EACA,mBAAA;EACA,oBAAA;ArE8qNF;AqE5qNC;EAAsB,cAAA;ArE+qNvB;AqE9qNC;EAAsB,cAAA;ArEirNvB;AqEhrNC;EAAsB,cAAA;ArEmrNvB;AqElrNC;EAAsB,cAAA;ArEqrNvB;AsE/rNC;EACC,mBAAA;EACA,kBAAA;AtEisNF;AuElsNC;EACC,eAAA;EACA,yBAAA;EACA,qBAAA;AvEosNF;AuEvsNC;EAIQ,kBAAA;AvEssNT;AuEpsNC;EACC,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;AvEssNF;AuErsNG;EACC,mBAAA;AvEusNJ;AkCptNC;EACC,4BAAA;EACA,yBAAA;EACA,oBAAA;AlCstNF;AkCntNC;EAA6B,WAAA;AlCstN9B;AkCrtNC;EAA8B,YAAA;AlCwtN/B;AkCrtNG;EAA8B,mBAAA;AlCwtNjC;AkCvtNG;EAA+B,kBAAA;AlC0tNlC;AACA,2BAA2B;AkCvtN3B;EAAc,YAAA;AlC0tNd;AkCztNA;EAAa,WAAA;AlC4tNb;AkCztNE;EAAc,mBAAA;AlC4tNhB;AkC3tNE;EAAe,kBAAA;AlC8tNjB;AwElvNC;EACC,6CAAA;EACQ,qCAAA;AxEovNV;AwEjvNC;EACC,+CAAA;EACQ,uCAAA;AxEmvNV;AwEhvNA;EACE;IACE,+BAAA;IACQ,uBAAA;ExEkvNV;EwEhvNA;IACE,iCAAA;IACQ,yBAAA;ExEkvNV;AACF;AwE/uNA;EACE;IACE,+BAAA;IACQ,uBAAA;ExEivNV;EwE/uNA;IACE,iCAAA;IACQ,yBAAA;ExEivNV;AACF;AyE9wNC;ECWC,sEAAA;EACA,gCAAA;EACI,4BAAA;EACI,wBAAA;A1EswNV;AyEnxNC;ECUC,sEAAA;EACA,iCAAA;EACI,6BAAA;EACI,yBAAA;A1E4wNV;AyExxNC;ECSC,sEAAA;EACA,iCAAA;EACI,6BAAA;EACI,yBAAA;A1EkxNV;AyE5xNC;ECcC,gFAAA;EACA,+BAAA;EACI,2BAAA;EACI,uBAAA;A1EixNV;AyEjyNC;ECaC,gFAAA;EACA,+BAAA;EACI,2BAAA;EACI,uBAAA;A1EuxNV;AyElyNC;;;;;EAKC,YAAA;AzEoyNF;A2EnzNC;EACC,kBAAA;EACA,qBAAA;EACA,UAAA;EACA,WAAA;EACA,gBAAA;EACA,sBAAA;A3EqzNF;A2EnzNC;;EACC,kBAAA;EACA,OAAA;EACA,WAAA;EACA,kBAAA;A3EszNF;A2EpzNC;EAA4B,oBAAA;A3EuzN7B;A2EtzNC;EAA4B,cAAA;A3EyzN7B;A2ExzNC;EAA2B,WAAA;A3E2zN5B;AACA;mEACmE;A4E70NlE;EAAgC,gBAAA;A5Eg1NjC;A4E/0NC;EAAgC,gBAAA;A5Ek1NjC;A4Ej1NC;EAAiC,gBAAA;A5Eo1NlC;A4En1NC;EAAqC,gBAAA;A5Es1NtC;A4Er1NC;EAAgC,gBAAA;A5Ew1NjC;A4Ev1NC;EAA+B,gBAAA;A5E01NhC;A4Ez1NC;EAAiC,gBAAA;A5E41NlC;A4E31NC;EAA+B,gBAAA;A5E81NhC;A4E71NC;EAA+B,gBAAA;A5Eg2NhC;A4E/1NC;EAAmC,gBAAA;A5Ek2NpC;A4Ej2NC;EAA6B,gBAAA;A5Eo2N9B;A4En2NC;EAAkC,gBAAA;A5Es2NnC;A4Er2NC;EAAgC,gBAAA;A5Ew2NjC;A4Ev2NC;;;EAEgC,gBAAA;A5E02NjC;A4Ez2NC;EAAsC,gBAAA;A5E42NvC;A4E32NC;EAAuC,gBAAA;A5E82NxC;A4E72NC;EAAoC,gBAAA;A5Eg3NrC;A4E/2NC;EAAiC,gBAAA;A5Ek3NlC;A4Ej3NC;;EAC8B,gBAAA;A5Eo3N/B;A4En3NC;EAAkC,gBAAA;A5Es3NnC;A4Er3NC;EAA+B,gBAAA;A5Ew3NhC;A4Ev3NC;EAAiC,gBAAA;A5E03NlC;A4Ez3NC;EAAkC,gBAAA;A5E43NnC;A4E33NC;EAA+B,gBAAA;A5E83NhC;A4E73NC;EAAmC,gBAAA;A5Eg4NpC;A4E/3NC;EAA8C,gBAAA;A5Ek4N/C;A4Ej4NC;EAA4C,gBAAA;A5Eo4N7C;A4En4NC;EAAgC,gBAAA;A5Es4NjC;A4Er4NC;EAAwC,gBAAA;A5Ew4NzC;A4Ev4NC;;EACiC,gBAAA;A5E04NlC;A4Ez4NC;EAAkC,gBAAA;A5E44NnC;A4E34NC;EAAmC,gBAAA;A5E84NpC;A4E74NC;EAA+B,gBAAA;A5Eg5NhC;A4E/4NC;EAA+B,gBAAA;A5Ek5NhC;A4Ej5NC;EAAqC,gBAAA;A5Eo5NtC;A4En5NC;EAAqC,gBAAA;A5Es5NtC;A4Er5NC;EAAsC,gBAAA;A5Ew5NvC;A4Ev5NC;EAAoC,gBAAA;A5E05NrC;A4Ez5NC;EAAiC,gBAAA;A5E45NlC;A4E35NC;EAAkC,gBAAA;A5E85NnC;A4E75NC;EAA8B,gBAAA;A5Eg6N/B;A4E/5NC;EAA+B,gBAAA;A5Ek6NhC;A4Ej6NC;EAA+B,gBAAA;A5Eo6NhC;A4En6NC;EAAmC,gBAAA;A5Es6NpC;A4Er6NC;EAAgC,gBAAA;A5Ew6NjC;A4Ev6NC;EAAiC,gBAAA;A5E06NlC;A4Ez6NC;EAA+B,gBAAA;A5E46NhC;A4E36NC;EAA+B,gBAAA;A5E86NhC;A4E76NC;EAAiC,gBAAA;A5Eg7NlC;A4E/6NC;EAAsC,gBAAA;A5Ek7NvC;A4Ej7NC;EAAqC,gBAAA;A5Eo7NtC;A4En7NC;EAAqC,gBAAA;A5Es7NtC;A4Er7NC;EAAuC,gBAAA;A5Ew7NxC;A4Ev7NC;EAAsC,gBAAA;A5E07NvC;A4Ez7NC;EAAwC,gBAAA;A5E47NzC;A4E37NC;EAA+B,gBAAA;A5E87NhC;A4E77NC;;EACkC,gBAAA;A5Eg8NnC;A4E/7NC;EAAiC,gBAAA;A5Ek8NlC;A4Ej8NC;EAAuC,gBAAA;A5Eo8NxC;A4En8NC;;;EAEoC,gBAAA;A5Es8NrC;A4Er8NC;EAAiC,gBAAA;A5Ew8NlC;A4Ev8NC;EAAqC,gBAAA;A5E08NtC;A4Ez8NC;EAAiC,gBAAA;A5E48NlC;A4E38NC;EAA+B,gBAAA;A5E88NhC;A4E78NC;;EAC0C,gBAAA;A5Eg9N3C;A4E/8NC;EAAyC,gBAAA;A5Ek9N1C;A4Ej9NC;EAAyC,gBAAA;A5Eo9N1C;A4En9NC;EAAiC,gBAAA;A5Es9NlC;A4Er9NC;EAAwC,gBAAA;A5Ew9NzC;A4Ev9NC;EAAwC,gBAAA;A5E09NzC;A4Ez9NC;EAAmC,gBAAA;A5E49NpC;A4E39NC;EAA+B,gBAAA;A5E89NhC;A4E79NC;EAAgC,gBAAA;A5Eg+NjC;A4E/9NC;EAA+B,gBAAA;A5Ek+NhC;A4Ej+NC;EAAkC,gBAAA;A5Eo+NnC;A4En+NC;EAAuC,gBAAA;A5Es+NxC;A4Er+NC;EAAuC,gBAAA;A5Ew+NxC;A4Ev+NC;EAAgC,gBAAA;A5E0+NjC;A4Ez+NC;EAAuC,gBAAA;A5E4+NxC;A4E3+NC;EAAwC,gBAAA;A5E8+NzC;A4E7+NC;EAAsC,gBAAA;A5Eg/NvC;A4E/+NC;EAAuC,gBAAA;A5Ek/NxC;A4Ej/NC;EAAuC,gBAAA;A5Eo/NxC;A4En/NC;EAAuC,gBAAA;A5Es/NxC;A4Er/NC;EAA0C,gBAAA;A5Ew/N3C;A4Ev/NC;EAAsC,gBAAA;A5E0/NvC;A4Ez/NC;EAAqC,gBAAA;A5E4/NtC;A4E3/NC;EAAyC,gBAAA;A5E8/N1C;A4E7/NC;EAAyC,gBAAA;A5EggO1C;A4E//NC;EAA8B,gBAAA;A5EkgO/B;A4EjgOC;EAAqC,gBAAA;A5EogOtC;A4EngOC;EAAsC,gBAAA;A5EsgOvC;A4ErgOC;EAAmC,gBAAA;A5EwgOpC;A4EvgOC;EAAqC,gBAAA;A5E0gOtC;A4EzgOC;;EACgC,gBAAA;A5E4gOjC;A4E3gOC;EAAiC,gBAAA;A5E8gOlC;A4E7gOC;EAAmC,gBAAA;A5EghOpC;A4E/gOC;EAA+B,gBAAA;A5EkhOhC;A4EjhOC;EAAgC,gBAAA;A5EohOjC;A4EnhOC;EAAmC,gBAAA;A5EshOpC;A4ErhOC;EAA6C,gBAAA;A5EwhO9C;A4EvhOC;EAA+B,gBAAA;A5E0hOhC;A4EzhOC;EAA+B,gBAAA;A5E4hOhC;A4E3hOC;EAA+B,gBAAA;A5E8hOhC;A4E7hOC;EAA8B,gBAAA;A5EgiO/B;A4E/hOC;EAAoC,gBAAA;A5EkiOrC;A4EjiOC;;EAC+C,gBAAA;A5EoiOhD;A4EniOC;EAAgC,gBAAA;A5EsiOjC;A4EriOC;EAAmC,gBAAA;A5EwiOpC;A4EviOC;EAAiC,gBAAA;A5E0iOlC;A4EziOC;EAAkC,gBAAA;A5E4iOnC;A4E3iOC;EAAiC,gBAAA;A5E8iOlC;A4E7iOC;EAAqC,gBAAA;A5EgjOtC;A4E/iOC;EAAuC,gBAAA;A5EkjOxC;A4EjjOC;EAAkC,gBAAA;A5EojOnC;A4EnjOC;EAAwC,gBAAA;A5EsjOzC;A4ErjOC;EAAiC,gBAAA;A5EwjOlC;A4EvjOC;EAAsC,gBAAA;A5E0jOvC;A4EzjOC;EAAmC,gBAAA;A5E4jOpC;A4E3jOC;EAAmC,gBAAA;A5E8jOpC;A4E7jOC;;EACoC,gBAAA;A5EgkOrC;A4E/jOC;EAAyC,gBAAA;A5EkkO1C;A4EjkOC;EAA0C,gBAAA;A5EokO3C;A4EnkOC;EAAuC,gBAAA;A5EskOxC;A4ErkOC;EAA8B,gBAAA;A5EwkO/B;A4EvkOC;;EAC+B,gBAAA;A5E0kOhC;A4EzkOC;EAAmC,gBAAA;A5E4kOpC;A4E3kOC;EAAsC,gBAAA;A5E8kOvC;A4E7kOC;EAAwC,gBAAA;A5EglOzC;A4E/kOC;EAAoC,gBAAA;A5EklOrC;A4EjlOC;EAAkC,gBAAA;A5EolOnC;A4EnlOC;EAAmC,gBAAA;A5EslOpC;A4ErlOC;EAA0C,gBAAA;A5EwlO3C;A4EvlOC;EAAqC,gBAAA;A5E0lOtC;A4EzlOC;EAAwC,gBAAA;A5E4lOzC;A4E3lOC;EAAkC,gBAAA;A5E8lOnC;A4E7lOC;EAAiC,gBAAA;A5EgmOlC;A4E/lOC;EAAwC,gBAAA;A5EkmOzC;A4EjmOC;EAAiC,gBAAA;A5EomOlC;A4EnmOC;EAAkC,gBAAA;A5EsmOnC;A4ErmOC;EAAgC,gBAAA;A5EwmOjC;A4EvmOC;EAAmC,gBAAA;A5E0mOpC;A4EzmOC;EAAqC,gBAAA;A5E4mOtC;A4E3mOC;EAAuC,gBAAA;A5E8mOxC;A4E7mOC;EAAkC,gBAAA;A5EgnOnC;A4E/mOC;;EACmC,gBAAA;A5EknOpC;A4EjnOC;EAAiC,gBAAA;A5EonOlC;A4EnnOC;EAAiC,gBAAA;A5EsnOlC;A4ErnOC;EAAsC,gBAAA;A5EwnOvC;A4EvnOC;;EAC8B,gBAAA;A5E0nO/B;A4EznOC;EAAgC,gBAAA;A5E4nOjC;A4E3nOC;EAAmC,gBAAA;A5E8nOpC;A4E7nOC;EAA+B,gBAAA;A5EgoOhC;A4E/nOC;EAAsC,gBAAA;A5EkoOvC;A4EjoOC;EAAuC,gBAAA;A5EooOxC;A4EnoOC;EAAsC,gBAAA;A5EsoOvC;A4EroOC;EAAoC,gBAAA;A5EwoOrC;A4EvoOC;EAAsC,gBAAA;A5E0oOvC;A4EzoOC;EAA4C,gBAAA;A5E4oO7C;A4E3oOC;EAA6C,gBAAA;A5E8oO9C;A4E7oOC;EAA0C,gBAAA;A5EgpO3C;A4E/oOC;EAA4C,gBAAA;A5EkpO7C;A4EjpOC;EAAgC,gBAAA;A5EopOjC;A4EnpOC;EAAiC,gBAAA;A5EspOlC;A4ErpOC;EAAgC,gBAAA;A5EwpOjC;A4EvpOC;EAAiC,gBAAA;A5E0pOlC;A4EzpOC;EAAoC,gBAAA;A5E4pOrC;A4E3pOC;EAAqC,gBAAA;A5E8pOtC;A4E7pOC;;EACgC,gBAAA;A5EgqOjC;A4E/pOC;;EAC+B,gBAAA;A5EkqOhC;A4EjqOC;EAAgC,gBAAA;A5EoqOjC;A4EnqOC;EAAgC,gBAAA;A5EsqOjC;A4ErqOC;;EACmC,gBAAA;A5EwqOpC;A4EvqOC;;EACkC,gBAAA;A5E0qOnC;A4EzqOC;EAAoC,gBAAA;A5E4qOrC;A4E3qOC;;EACmC,gBAAA;A5E8qOpC;A4E7qOC;EAAiC,gBAAA;A5EgrOlC;A4E/qOC;;;EAE+B,gBAAA;A5EkrOhC;A4EjrOC;EAAkC,gBAAA;A5EorOnC;A4EnrOC;EAAkC,gBAAA;A5EsrOnC;A4ErrOC;EAAwC,gBAAA;A5EwrOzC;A4EvrOC;EAAoC,gBAAA;A5E0rOrC;A4EzrOC;EAAgC,gBAAA;A5E4rOjC;A4E3rOC;EAAgC,gBAAA;A5E8rOjC;A4E7rOC;EAAgC,gBAAA;A5EgsOjC;A4E/rOC;EAAoC,gBAAA;A5EksOrC;A4EjsOC;EAA2C,gBAAA;A5EosO5C;A4EnsOC;EAA6C,gBAAA;A5EssO9C;A4ErsOC;EAAsC,gBAAA;A5EwsOvC;A4EvsOC;EAAgC,gBAAA;A5E0sOjC;A4EzsOC;EAAqC,gBAAA;A5E4sOtC;A4E3sOC;EAAmC,gBAAA;A5E8sOpC;A4E7sOC;EAAqC,gBAAA;A5EgtOtC;A4E/sOC;EAAsC,gBAAA;A5EktOvC;A4EjtOC;EAAkC,gBAAA;A5EotOnC;A4EntOC;;EAC+B,gBAAA;A5EstOhC;A4ErtOC;;EACoC,gBAAA;A5EwtOrC;A4EvtOC;;EACmC,gBAAA;A5E0tOpC;A4EztOC;EAAmC,gBAAA;A5E4tOpC;A4E3tOC;EAAmC,gBAAA;A5E8tOpC;A4E7tOC;;EAC+B,gBAAA;A5EguOhC;A4E/tOC;;EACgC,gBAAA;A5EkuOjC;A4EjuOC;;EACqC,gBAAA;A5EouOtC;A4EnuOC;EAAoC,gBAAA;A5EsuOrC;A4EruOC;EAAqC,gBAAA;A5EwuOtC;A4EvuOC;;EAC+B,gBAAA;A5E0uOhC;A4EzuOC;EAAkC,gBAAA;A5E4uOnC;A4E3uOC;EAAmC,gBAAA;A5E8uOpC;A4E7uOC;;EACoC,gBAAA;A5EgvOrC;A4E/uOC;EAAsC,gBAAA;A5EkvOvC;A4EjvOC;EAAmC,gBAAA;A5EovOpC;A4EnvOC;EAAyC,gBAAA;A5EsvO1C;A4ErvOC;EAAuC,gBAAA;A5EwvOxC;A4EvvOC;EAAkC,gBAAA;A5E0vOnC;A4EzvOC;EAAsC,gBAAA;A5E4vOvC;A4E3vOC;EAAmC,gBAAA;A5E8vOpC;A4E7vOC;EAAiC,gBAAA;A5EgwOlC;A4E/vOC;EAAiC,gBAAA;A5EkwOlC;A4EjwOC;EAAkC,gBAAA;A5EowOnC;A4EnwOC;EAAsC,gBAAA;A5EswOvC;A4ErwOC;EAAqC,gBAAA;A5EwwOtC;A4EvwOC;EAAqC,gBAAA;A5E0wOtC;A4EzwOC;EAAoC,gBAAA;A5E4wOrC;A4E3wOC;EAAiC,gBAAA;A5E8wOlC;A4E7wOC;EAAsC,gBAAA;A5EgxOvC;A4E/wOC;EAA+B,gBAAA;A5EkxOhC;A4EjxOC;EAAmC,gBAAA;A5EoxOpC;A4EnxOC;EAAsC,gBAAA;A5EsxOvC;A4ErxOC;EAA4C,gBAAA;A5EwxO7C;A4EvxOC;EAA6C,gBAAA;A5E0xO9C;A4EzxOC;EAA0C,gBAAA;A5E4xO3C;A4E3xOC;EAA4C,gBAAA;A5E8xO7C;A4E7xOC;EAAqC,gBAAA;A5EgyOtC;A4E/xOC;EAAsC,gBAAA;A5EkyOvC;A4EjyOC;EAAmC,gBAAA;A5EoyOpC;A4EnyOC;EAAqC,gBAAA;A5EsyOtC;A4EryOC;EAAkC,gBAAA;A5EwyOnC;A4EvyOC;EAAiC,gBAAA;A5E0yOlC;A4EzyOC;EAAiC,gBAAA;A5E4yOlC;A4E3yOC;;EACiC,gBAAA;A5E8yOlC;A4E7yOC;EAAmC,gBAAA;A5EgzOpC;A4E/yOC;EAAqC,gBAAA;A5EkzOtC;A4EjzOC;EAAsC,gBAAA;A5EozOvC;A4EnzOC;EAAkC,gBAAA;A5EszOnC;A4ErzOC;EAAiC,gBAAA;A5EwzOlC;A4EvzOC;;EACgC,gBAAA;A5E0zOjC;A4EzzOC;EAAqC,gBAAA;A5E4zOtC;A4E3zOC;EAAmC,gBAAA;A5E8zOpC;A4E7zOC;EAAwC,gBAAA;A5Eg0OzC;A4E/zOC;EAAkC,gBAAA;A5Ek0OnC;A4Ej0OC;EAAkC,gBAAA;A5Eo0OnC;A4En0OC;EAAgC,gBAAA;A5Es0OjC;A4Er0OC;EAAkC,gBAAA;A5Ew0OnC;A4Ev0OC;EAAqC,gBAAA;A5E00OtC;A4Ez0OC;EAAiC,gBAAA;A5E40OlC;A4E30OC;EAAyC,gBAAA;A5E80O1C;A4E70OC;EAAmC,gBAAA;A5Eg1OpC;A4E/0OC;EAA+B,gBAAA;A5Ek1OhC;A4Ej1OC;;EACoC,gBAAA;A5Eo1OrC;A4En1OC;;;EAEsC,gBAAA;A5Es1OvC;A4Er1OC;EAAyC,gBAAA;A5Ew1O1C;A4Ev1OC;EAA+B,gBAAA;A5E01OhC;A4Ez1OC;EAAoC,gBAAA;A5E41OrC;A4E31OC;;EACuC,gBAAA;A5E81OxC;A4E71OC;EAAmC,gBAAA;A5Eg2OpC;A4E/1OC;EAA+B,gBAAA;A5Ek2OhC;A4Ej2OC;EAAsC,gBAAA;A5Eo2OvC;A4En2OC;EAAsC,gBAAA;A5Es2OvC;A4Er2OC;EAAoC,gBAAA;A5Ew2OrC;A4Ev2OC;EAAiC,gBAAA;A5E02OlC;A4Ez2OC;EAAuC,gBAAA;A5E42OxC;A4E32OC;EAAqC,gBAAA;A5E82OtC;A4E72OC;EAA2C,gBAAA;A5Eg3O5C;A4E/2OC;EAAiC,gBAAA;A5Ek3OlC;A4Ej3OC;EAAqC,gBAAA;A5Eo3OtC;A4En3OC;EAA4C,gBAAA;A5Es3O7C;A4Er3OC;EAAiC,gBAAA;A5Ew3OlC;A4Ev3OC;EAAiC,gBAAA;A5E03OlC;A4Ez3OC;EAA8C,gBAAA;A5E43O/C;A4E33OC;EAA+C,gBAAA;A5E83OhD;A4E73OC;EAA4C,gBAAA;A5Eg4O7C;A4E/3OC;EAA8C,gBAAA;A5Ek4O/C;A4Ej4OC;EAAgC,gBAAA;A5Eo4OjC;A4En4OC;EAA+B,gBAAA;A5Es4OhC;A4Er4OC;EAAiC,gBAAA;A5Ew4OlC;A4Ev4OC;EAAqC,gBAAA;A5E04OtC;A4Ez4OC;EAAmC,gBAAA;A5E44OpC;A4E34OC;EAAqC,gBAAA;A5E84OtC;A4E74OC;EAAqC,gBAAA;A5Eg5OtC;A4E/4OC;EAAqC,gBAAA;A5Ek5OtC;A4Ej5OC;EAAsC,gBAAA;A5Eo5OvC;A4En5OC;EAAiC,gBAAA;A5Es5OlC;A4Er5OC;EAAuC,gBAAA;A5Ew5OxC;A4Ev5OC;EAAyC,gBAAA;A5E05O1C;A4Ez5OC;EAAmC,gBAAA;A5E45OpC;A4E35OC;EAAqC,gBAAA;A5E85OtC;A4E75OC;EAAuC,gBAAA;A5Eg6OxC;A4E/5OC;EAAwC,gBAAA;A5Ek6OzC;A4Ej6OC;EAA+C,gBAAA;A5Eo6OhD;A4En6OC;EAAuC,gBAAA;A5Es6OxC;A4Er6OC;EAAkC,gBAAA;A5Ew6OnC;A4Ev6OC;;EAC8C,gBAAA;A5E06O/C;A4Ez6OC;;EAC4C,gBAAA;A5E46O7C;A4E36OC;;EAC+C,gBAAA;A5E86OhD;A4E76OC;;EAC8B,gBAAA;A5Eg7O/B;A4E/6OC;EAA8B,gBAAA;A5Ek7O/B;A4Ej7OC;;EAC8B,gBAAA;A5Eo7O/B;A4En7OC;;EAC8B,gBAAA;A5Es7O/B;A4Er7OC;;;;EAG8B,gBAAA;A5Ew7O/B;A4Ev7OC;;;EAE8B,gBAAA;A5E07O/B;A4Ez7OC;;EAC8B,gBAAA;A5E47O/B;A4E37OC;;EAC8B,gBAAA;A5E87O/B;A4E77OC;EAA+B,gBAAA;A5Eg8OhC;A4E/7OC;EAAoC,gBAAA;A5Ek8OrC;A4Ej8OC;EAAyC,gBAAA;A5Eo8O1C;A4En8OC;EAA0C,gBAAA;A5Es8O3C;A4Er8OC;EAA0C,gBAAA;A5Ew8O3C;A4Ev8OC;EAA2C,gBAAA;A5E08O5C;A4Ez8OC;EAA2C,gBAAA;A5E48O5C;A4E38OC;EAA4C,gBAAA;A5E88O7C;A4E78OC;EAAoC,gBAAA;A5Eg9OrC;A4E/8OC;EAAsC,gBAAA;A5Ek9OvC;A4Ej9OC;EAAyC,gBAAA;A5Eo9O1C;A4En9OC;EAAkC,gBAAA;A5Es9OnC;A4Er9OC;EAA+B,gBAAA;A5Ew9OhC;A4Ev9OC;EAAsC,gBAAA;A5E09OvC;A4Ez9OC;EAAuC,gBAAA;A5E49OxC;A4E39OC;EAAkC,gBAAA;A5E89OnC;A4E79OC;EAAyC,gBAAA;A5Eg+O1C;A4E/9OC;EAAoC,gBAAA;A5Ek+OrC;A4Ej+OC;EAAiC,gBAAA;A5Eo+OlC;A4En+OC;EAA8B,gBAAA;A5Es+O/B;A4Er+OC;EAAoC,gBAAA;A5Ew+OrC;A4Ev+OC;EAA2C,gBAAA;A5E0+O5C;A4Ez+OC;EAAiC,gBAAA;A5E4+OlC;A4E3+OC;EAAwC,gBAAA;A5E8+OzC;A4E7+OC;EAA0C,gBAAA;A5Eg/O3C;A4E/+OC;EAAwC,gBAAA;A5Ek/OzC;A4Ej/OC;EAA0C,gBAAA;A5Eo/O3C;A4En/OC;EAA2C,gBAAA;A5Es/O5C;A4Er/OC;EAAgC,gBAAA;A5Ew/OjC;A4Ev/OC;EAAkC,gBAAA;A5E0/OnC;A4Ez/OC;EAAkC,gBAAA;A5E4/OnC;A4E3/OC;EAAgC,gBAAA;A5E8/OjC;A4E7/OC;EAAmC,gBAAA;A5EggPpC;A4E//OC;EAAgC,gBAAA;A5EkgPjC;A4EjgPC;EAAqC,gBAAA;A5EogPtC;A4EngPC;EAAiC,gBAAA;A5EsgPlC;A4ErgPC;EAAiC,gBAAA;A5EwgPlC;A4EvgPC;EAA+B,gBAAA;A5E0gPhC;A4EzgPC;;EACmC,gBAAA;A5E4gPpC;A4E3gPC;EAAgC,gBAAA;A5E8gPjC;A4E7gPC;EAAiC,gBAAA;A5EghPlC;A4E/gPC;EAAkC,gBAAA;A5EkhPnC;A4EjhPC;EAA8B,gBAAA;A5EohP/B;A4EnhPC;EAA6B,gBAAA;A5EshP9B;A4ErhPC;EAAgC,gBAAA;A5EwhPjC;A4EvhPC;EAAiC,gBAAA;A5E0hPlC;A4EzhPC;EAAoC,gBAAA;A5E4hPrC;A4E3hPC;EAAyC,gBAAA;A5E8hP1C;A4E7hPC;EAA+C,gBAAA;A5EgiPhD;A4E/hPC;EAA8C,gBAAA;A5EkiP/C;A4EjiPC;;EAC8C,gBAAA;A5EoiP/C;A4EniPC;EAAuC,gBAAA;A5EsiPxC;A4EriPC;EAAqC,gBAAA;A5EwiPtC;A4EviPC;EAAuC,gBAAA;A5E0iPxC;A4EziPC;;EAC8B,gBAAA;A5E4iP/B;A4E3iPC;EAAwC,gBAAA;A5E8iPzC;A4E7iPC;EAAwC,gBAAA;A5EgjPzC;A4E/iPC;EAAgC,gBAAA;A5EkjPjC;A4EjjPC;EAA0C,gBAAA;A5EojP3C;A4EnjPC;EAAoC,gBAAA;A5EsjPrC;A4ErjPC;EAAiC,gBAAA;A5EwjPlC;A4EvjPC;;;EAEqC,gBAAA;A5E0jPtC;A4EzjPC;;EACyC,gBAAA;A5E4jP1C;A4E3jPC;EAAgC,gBAAA;A5E8jPjC;A4E7jPC;EAAiC,gBAAA;A5EgkPlC;A4E/jPC;EAAiC,gBAAA;A5EkkPlC;A4EjkPC;EAAwC,gBAAA;A5EokPzC;A4EnkPC;EAA6C,gBAAA;A5EskP9C;A4ErkPC;EAAsC,gBAAA;A5EwkPvC;A4EvkPC;EAAoC,gBAAA;A5E0kPrC;A4EzkPC;EAA+B,gBAAA;A5E4kPhC;A4E3kPC;EAAwC,gBAAA;A5E8kPzC;A4E7kPC;EAAyC,gBAAA;A5EglP1C;A4E/kPC;EAAiC,gBAAA;A5EklPlC;A4EjlPC;EAAiC,gBAAA;A5EolPlC;A4EnlPC;EAAmC,gBAAA;A5EslPpC;A4ErlPC;EAA8B,gBAAA;A5EwlP/B;A4EvlPC;EAAmC,gBAAA;A5E0lPpC;A4EzlPC;EAAgC,gBAAA;A5E4lPjC;A4E3lPC;EAA8B,gBAAA;A5E8lP/B;A4E7lPC;EAAgC,gBAAA;A5EgmPjC;A4E/lPC;EAA+B,gBAAA;A5EkmPhC;A4EjmPC;EAAgC,gBAAA;A5EomPjC;A4EnmPC;EAAkC,gBAAA;A5EsmPnC;A4ErmPC;EAAyC,gBAAA;A5EwmP1C;A4EvmPC;EAAgC,gBAAA;A5E0mPjC;A4EzmPC;EAAuC,gBAAA;A5E4mPxC;A4E3mPC;EAAkC,gBAAA;A5E8mPnC;A4E7mPC;;EAC8B,gBAAA;A5EgnP/B;A4E/mPC;;EAC+B,gBAAA;A5EknPhC;A4EjnPC;EAA+B,gBAAA;A5EonPhC;A4EnnPC;EAAkC,gBAAA;A5EsnPnC;A4ErnPC;EAAqC,gBAAA;A5EwnPtC;A4EvnPC;EAAqC,gBAAA;A5E0nPtC;A4EznPC;EAAmC,gBAAA;A5E4nPpC;A4E3nPC;EAAqC,gBAAA;A5E8nPtC;A4E7nPC;EAAsC,gBAAA;A5EgoPvC;A4E/nPC;EAAuC,gBAAA;A5EkoPxC;A4EjoPC;EAA4C,gBAAA;A5EooP7C;A4EnoPC;;;EAEuC,gBAAA;A5EsoPxC;A4EroPC;;EACyC,gBAAA;A5EwoP1C;A4EvoPC;;EACuC,gBAAA;A5E0oPxC;A4EzoPC;;EACuC,gBAAA;A5E4oPxC;A4E3oPC;EAAsC,gBAAA;A5E8oPvC;A4E7oPC;EAA+B,gBAAA;A5EgpPhC;A4E/oPC;EAAkC,gBAAA;A5EkpPnC;A4EjpPC;EAAmC,gBAAA;A5EopPpC;A4EnpPC;;;;;EAIoC,gBAAA;A5EspPrC;A4ErpPC;EAAyC,gBAAA;A5EwpP1C;A4EvpPC;;;EAEgC,gBAAA;A5E0pPjC;A4EzpPC;;EACiC,gBAAA;A5E4pPlC;A4E3pPC;EAAqC,gBAAA;A5E8pPtC;A4E7pPC;EAA8B,gBAAA;A5EgqP/B;A4E/pPC;;;EAEsC,gBAAA;A5EkqPvC;A4EjqPC;EAAwC,gBAAA;A5EoqPzC;A4EnqPC;EAA6B,gBAAA;A5EsqP9B;A4ErqPC;;EACiC,gBAAA;A5EwqPlC;A4EvqPC;;EACsC,gBAAA;A5E0qPvC;A4EzqPC;;EACwC,gBAAA;A5E4qPzC;A4E3qPC;EAAkC,gBAAA;A5E8qPnC;A4E7qPC;EAAsC,gBAAA;A5EgrPvC;A4E/qPC;EAAiC,gBAAA;A5EkrPlC;A4EjrPC;EAAoC,gBAAA;A5EorPrC;A4EnrPC;EAAkC,gBAAA;A5EsrPnC;A4ErrPC;EAAoC,gBAAA;A5EwrPrC;A4EvrPC;EAA2C,gBAAA;A5E0rP5C;A4EzrPC;EAA+B,gBAAA;A5E4rPhC;A4E3rPC;;EACmC,gBAAA;A5E8rPpC;A4E7rPC;EAA8B,gBAAA;A5EgsP/B;A4E/rPC;EAAqC,gBAAA;A5EksPtC;A4EjsPC;EAA+B,gBAAA;A5EosPhC;A4EnsPC;EAAqC,gBAAA;A5EssPtC;A4ErsPC;EAAiC,gBAAA;A5EwsPlC;A4EvsPC;EAA+B,gBAAA;A5E0sPhC;A4EzsPC;EAAsC,gBAAA;A5E4sPvC;A4E3sPC;EAA+B,gBAAA;A5E8sPhC;A4E7sPC;EAAqC,gBAAA;A5EgtPtC;A4E/sPC;EAAiC,gBAAA;A5EktPlC;A4EjtPC;EAAwC,gBAAA;A5EotPzC;A4EntPC;EAAkC,gBAAA;A5EstPnC;A4ErtPC;EAAwC,gBAAA;A5EwtPzC;A4EvtPC;EAAsC,gBAAA;A5E0tPvC;A4EztPC;EAAkC,gBAAA;A5E4tPnC;A4E3tPC;EAAoC,gBAAA;A5E8tPrC;A4E7tPC;EAAoC,gBAAA;A5EguPrC;A4E/tPC;EAAqC,gBAAA;A5EkuPtC;A4EjuPC;EAAuC,gBAAA;A5EouPxC;A4EnuPC;EAAgC,gBAAA;A5EsuPjC;A4EruPC;EAAoC,gBAAA;A5EwuPrC;A4EvuPC;EAA6B,gBAAA;A5E0uP9B;A4EzuPC;EAAqC,gBAAA;A5E4uPtC;A4E3uPC;EAAsC,gBAAA;A5E8uPvC;A4E7uPC;EAAwC,gBAAA;A5EgvPzC;A4E/uPC;EAAqC,gBAAA;A5EkvPtC;A4EjvPC;EAAoC,gBAAA;A5EovPrC;A4EnvPC;EAAqC,gBAAA;A5EsvPtC;A4ErvPC;EAAiC,gBAAA;A5EwvPlC;A4EvvPC;EAAwC,gBAAA;A5E0vPzC;A4EzvPC;EAAqC,gBAAA;A5E4vPtC;A4E3vPC;EAAoC,gBAAA;A5E8vPrC;A4E7vPC;EAAkC,gBAAA;A5EgwPnC;A4E/vPC;EAA8B,gBAAA;A5EkwP/B;A4EjwPC;EAAkC,gBAAA;A5EowPnC;A4EnwPC;EAAoC,gBAAA;A5EswPrC;A4ErwPC;EAA6B,gBAAA;A5EwwP9B;A4EvwPC;;;EAE8B,gBAAA;A5E0wP/B;A4EzwPC;EAAmC,gBAAA;A5E4wPpC;A4E3wPC;EAAqC,gBAAA;A5E8wPtC;A4E7wPC;EAAyC,gBAAA;A5EgxP1C;A4E/wPC;EAAmC,gBAAA;A5EkxPpC;A4EjxPC;EAAmC,gBAAA;A5EoxPpC;A4EnxPC;EAAkC,gBAAA;A5EsxPnC;A4ErxPC;EAAiC,gBAAA;A5EwxPlC;A4EvxPC;EAAuC,gBAAA;A5E0xPxC;A4EzxPC;EAAsC,gBAAA;A5E4xPvC;A4E3xPC;EAAmC,gBAAA;A5E8xPpC;A4E7xPC;EAAoC,gBAAA;A5EgyPrC;A4E/xPC;EAA0C,gBAAA;A5EkyP3C;A4EjyPC;EAAkC,gBAAA;A5EoyPnC;A4EnyPC;EAA+B,gBAAA;A5EsyPhC;A4EryPC;EAAsC,gBAAA;A5EwyPvC;A4EvyPC;EAAqC,gBAAA;A5E0yPtC;A4EzyPC;EAAsC,gBAAA;A5E4yPvC;A4E3yPC;EAAoC,gBAAA;A5E8yPrC;A4E7yPC;EAAgC,gBAAA;A5EgzPjC;A4E/yPC;EAA+B,gBAAA;A5EkzPhC;A4EjzPC;EAAkC,gBAAA;A5EozPnC;A4EnzPC;;EACsC,gBAAA;A5EszPvC;A4ErzPC;EAA0C,gBAAA;A5EwzP3C;A4EvzPC;EAAuC,gBAAA;A5E0zPxC;A4EzzPC;EAAsC,gBAAA;A5E4zPvC;A4E3zPC;EAAqC,gBAAA;A5E8zPtC;A4E7zPC;EAAsC,gBAAA;A5Eg0PvC;A4E/zPC;EAAwC,gBAAA;A5Ek0PzC;A4Ej0PC;EAAwC,gBAAA;A5Eo0PzC;A4En0PC;EAAiC,gBAAA;A5Es0PlC;A4Er0PC;EAAqC,gBAAA;A5Ew0PtC;A4Ev0PC;EAA4C,gBAAA;A5E00P7C;A4Ez0PC;EAAsC,gBAAA;A5E40PvC;A4E30PC;EAAmC,gBAAA;A5E80PpC;A4E70PC;EAAiC,gBAAA;A5Eg1PlC;A4E/0PC;EAAoC,gBAAA;A5Ek1PrC;A4Ej1PC;EAAqC,gBAAA;A5Eo1PtC;A4En1PC;;EAC8B,gBAAA;A5Es1P/B;A4Er1PC;EAAkC,gBAAA;A5Ew1PnC;A4Ev1PC;EAAgC,gBAAA;A5E01PjC;A4Ez1PC;EAAiC,gBAAA;A5E41PlC;A4E31PC;EAAiC,gBAAA;A5E81PlC;A4E71PC;;EACuC,gBAAA;A5Eg2PxC;A4E/1PC;EAAwC,gBAAA;A5Ek2PzC;A4Ej2PC;EAAmC,gBAAA;A5Eo2PpC;A4En2PC;EAAuC,gBAAA;A5Es2PxC;A4Er2PC;;;EAEuC,gBAAA;A5Ew2PxC;A4Ev2PC;;EACiD,gBAAA;A5E02PlD;A4Ez2PC;;EACuC,gBAAA;A5E42PxC;A4E32PC;;EAC0C,gBAAA;A5E82P3C;A4E72PC;;EACwC,gBAAA;A5Eg3PzC;A4E/2PC;EAAwC,gBAAA;A5Ek3PzC;A4Ej3PC;EAAmC,gBAAA;A5Eo3PpC;A4En3PC;EAAuC,gBAAA;A5Es3PxC;A4Er3PC;EAAyC,gBAAA;A5Ew3P1C;A4Ev3PC;EAAsC,gBAAA;A5E03PvC;A4Ez3PC;EAAwC,gBAAA;A5E43PzC;A4E33PC;EAAiC,gBAAA;A5E83PlC;A4E73PC;EAAyC,gBAAA;A5Eg4P1C;A4E/3PC;EAAgC,gBAAA;A5Ek4PjC;A4Ej4PC;EAAwC,gBAAA;A5Eo4PzC;A4En4PC;EAAsC,gBAAA;A5Es4PvC;A4Er4PC;;EAC0C,gBAAA;A5Ew4P3C;A4Ev4PC;;EACyC,gBAAA;A5E04P1C;A4Ez4PC;;EACwC,gBAAA;A5E44PzC;A4E34PC;EAAoC,gBAAA;A5E84PrC;A4E74PC;;EACsC,gBAAA;A5Eg5PvC;A4E/4PC;;EACuC,gBAAA;A5Ek5PxC;A4Ej5PC;EAA0C,gBAAA;A5Eo5P3C;A4En5PC;EAAwC,gBAAA;A5Es5PzC;A4Er5PC;EAAuC,gBAAA;A5Ew5PxC;A4Ev5PC;EAAyC,gBAAA;A5E05P1C;A4Ez5PC;EAAuC,gBAAA;A5E45PxC;A4E35PC;EAAoC,gBAAA;A5E85PrC;A4E75PC;EAAqC,gBAAA;A5Eg6PtC;A4E/5PC;EAA2C,gBAAA;A5Ek6P5C;A4Ej6PC;EAA6B,gBAAA;A5Eo6P9B;A4En6PC;EAAoC,gBAAA;A5Es6PrC;A4Er6PC;EAAsC,gBAAA;A5Ew6PvC;A4Ev6PC;EAAwC,gBAAA;A5E06PzC;A4Ez6PC;EAA+C,gBAAA;A5E46PhD;A4E36PC;EAAqC,gBAAA;A5E86PtC;A4E76PC;EAAsC,gBAAA;A5Eg7PvC;A4E/6PC;EAAiC,gBAAA;A5Ek7PlC;A4Ej7PC;EAAiC,gBAAA;A5Eo7PlC;A4En7PC;EAAkC,gBAAA;A5Es7PnC;A4Er7PC;EAAgC,gBAAA;A5Ew7PjC;A4Ev7PC;EAA4C,gBAAA;A5E07P7C;A4Ez7PC;;EACqC,gBAAA;A5E47PtC;A4E37PC;EAAiC,gBAAA;A5E87PlC;A4E77PC;EAAgC,gBAAA;A5Eg8PjC;A4E/7PC;EAAiC,gBAAA;A5Ek8PlC;A4Ej8PC;EAA0C,gBAAA;A5Eo8P3C;A4En8PC;EAA2C,gBAAA;A5Es8P5C;A4Er8PC;EAA2C,gBAAA;A5Ew8P5C;A4Ev8PC;EAA2C,gBAAA;A5E08P5C;A4Ez8PC;EAAmC,gBAAA;A5E48PpC;A4E38PC;EAAkC,gBAAA;A5E88PnC;A4E78PC;EAAoC,gBAAA;A5Eg9PrC;A4E/8PC;EAAgC,gBAAA;A5Ek9PjC;A4Ej9PC;EAA8B,gBAAA;A5Eo9P/B;A4En9PC;EAAqC,gBAAA;A5Es9PtC;A4Er9PC;EAAuC,gBAAA;A5Ew9PxC;A4Ev9PC;EAAgC,gBAAA;A5E09PjC;A4Ez9PC;EAAgC,gBAAA;A5E49PjC;A4E39PC;EAAoC,gBAAA;A5E89PrC;A4E79PC;EAAoC,gBAAA;A5Eg+PrC;A4E/9PC;EAAuC,gBAAA;A5Ek+PxC;A4Ej+PC;EAA+B,gBAAA;A5Eo+PhC;A4En+PC;EAA0C,gBAAA;A5Es+P3C;A4Er+PC;EAAmC,gBAAA;A5Ew+PpC;A4Ev+PC;EAA+B,gBAAA;A5E0+PhC;A4Ez+PC;EAAuC,gBAAA;A5E4+PxC;A4E3+PC;EAA8B,gBAAA;A5E8+P/B;A4E7+PC;EAAuC,gBAAA;A5Eg/PxC;A4E/+PC;EAAmC,gBAAA;A5Ek/PpC;A4Ej/PC;EAAiC,gBAAA;A5Eo/PlC;A4En/PC;EAAuC,gBAAA;A5Es/PxC;A4Er/PC;EAAyC,gBAAA;A5Ew/P1C;A4Ev/PC;EAAsC,gBAAA;A5E0/PvC;A4Ez/PC;EAAwC,gBAAA;A5E4/PzC;A4E3/PC;EAAuC,gBAAA;A5E8/PxC;A4E7/PC;EAA0C,gBAAA;A5EggQ3C;A4E//PC;EAAkC,gBAAA;A5EkgQnC;A4EjgQC;EAAoC,gBAAA;A5EogQrC;A4EngQC;EAAsC,gBAAA;A5EsgQvC;A4ErgQC;EAAkC,gBAAA;A5EwgQnC;A4EvgQC;EAAiC,gBAAA;A5E0gQlC;A4EzgQC;EAAqC,gBAAA;A5E4gQtC;A4E3gQC;EAAkC,gBAAA;A5E8gQnC;A4E7gQC;EAAiC,gBAAA;A5EghQlC;A4E/gQC;EAA2C,gBAAA;A5EkhQ5C;A4EjhQC;EAAyC,gBAAA;A5EohQ1C;A4EnhQC;EAA4C,gBAAA;A5EshQ7C;A4ErhQC;EAAgC,gBAAA;A5EwhQjC;A4EvhQC;EAA4C,gBAAA;A5E0hQ7C;A4EzhQC;EAA+C,gBAAA;A5E4hQhD;A4E3hQC;EAAkC,gBAAA;A5E8hQnC;A4E7hQC;EAAsD,gBAAA;A5EgiQvD;A4E/hQC;;EAC8D,gBAAA;A5EkiQ/D;A4EjiQC;;;EAE+B,gBAAA;A5EoiQhC;A4EniQC;EAAgC,gBAAA;A5EsiQjC;A4EriQC;EAAkC,gBAAA;A5EwiQnC;A4EviQC;;EACwC,gBAAA;A5E0iQzC;A4EziQC;EAAqC,gBAAA;A5E4iQtC;A4E3iQC;EAAiC,gBAAA;A5E8iQlC;A4E7iQC;EAAwC,gBAAA;A5EgjQzC;A4E/iQC;EAAmC,gBAAA;A5EkjQpC;A4EjjQC;EAAyC,gBAAA;A5EojQ1C;A4EnjQC;EAA0C,gBAAA;A5EsjQ3C;A4ErjQC;EAAqC,gBAAA;A5EwjQtC;A4EvjQC;EAAsC,gBAAA;A5E0jQvC;A4EzjQC;EAAgC,gBAAA;A5E4jQjC;A4E3jQC;EAAoC,gBAAA;A5E8jQrC;A4E7jQC;;EAC+C,gBAAA;A5EgkQhD;A4E/jQC;;EACuC,gBAAA;A5EkkQxC;A4EjkQC;EAAsC,gBAAA;A5EokQvC;A4EnkQC;EAAwC,gBAAA;A5EskQzC;A4ErkQC;EAA0C,gBAAA;A5EwkQ3C;A4EvkQC;EAAiC,gBAAA;A5E0kQlC;A4EzkQC;EAAuC,gBAAA;A5E4kQxC;A4E3kQC;EAAyC,gBAAA;A5E8kQ1C;A4E7kQC;;EACuC,gBAAA;A5EglQxC;A4E/kQC;;EACyC,gBAAA;A5EklQ1C;A4EjlQC;EAAsC,gBAAA;A5EolQvC;A4EnlQC;EAAwC,gBAAA;A5EslQzC;A4ErlQC;EAAiC,gBAAA;A5EwlQlC;A4EvlQC;EAAmC,gBAAA;A5E0lQpC;A4EzlQC;;EACkC,gBAAA;A5E4lQnC;A4E3lQC;;EACoC,gBAAA;A5E8lQrC;A4E7lQC;EAAgC,gBAAA;A5EgmQjC;A4E/lQC;EAAyC,gBAAA;A5EkmQ1C;A4EjmQC;EAAmC,gBAAA;A5EomQpC;A4EnmQC;;;EAE2C,gBAAA;A5EsmQ5C;A4ErmQC;;EACqD,gBAAA;A5EwmQtD;A4EvmQC;;EAC2C,gBAAA;A5E0mQ5C;A4EzmQC;;EAC8C,gBAAA;A5E4mQ/C;A4E3mQC;;EAC4C,gBAAA;A5E8mQ7C;A4E7mQC;EAAiC,gBAAA;A5EgnQlC;A4E/mQC;;;EAE+B,gBAAA;A5EknQhC;A4EjnQC;EAAkC,gBAAA;A5EonQnC;A4EnnQC;EAA0C,gBAAA;A5EsnQ3C;A4ErnQC;EAA0C,gBAAA;A5EwnQ3C;A4EvnQC;EAAyC,gBAAA;A5E0nQ1C;A4EznQC;;EACuC,gBAAA;A5E4nQxC;A4E3nQC;;EACyC,gBAAA;A5E8nQ1C;A4E7nQC;EAAmC,gBAAA;A5EgoQpC;A4E/nQC;EAA+B,gBAAA;A5EkoQhC;A4EjoQC;EAA+B,gBAAA;A5EooQhC;A4EnoQC;EAA+B,gBAAA;A5EsoQhC;A4EroQC;EAAkC,gBAAA;A5EwoQnC;A4EvoQC;EAAkC,gBAAA;A5E0oQnC;A4EzoQC;EAAoC,gBAAA;A5E4oQrC;A4E3oQC;EAAsC,gBAAA;A5E8oQvC;A4E7oQC;EAAsC,gBAAA;A5EgpQvC;A4E/oQC;EAAqC,gBAAA;A5EkpQtC;A4EjpQC;EAAiC,gBAAA;A5EopQlC;A6Er6RA;EH8BE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,gBAAA;EACA,sBAAA;EACA,SAAA;A1E04RF;AItyRE;;EAEE,gBAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,iBAAA;EACA,UAAA;AJwyRJ;A0Ez4RE;;EAEE,gBAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,iBAAA;EACA,UAAA;A1E24RJ;AACA;;;;CAIC;A8Ev8RD;EACE,2BAAA;EACA,gBAAA;EACA,wBAAA;EACA,qBAAA;EACA,mFAAA;EAKA,wGAAA;EAKA,0GAAA;EAKA,wGAAA;EAKA,0GAAA;EAKA,0GAAA;EAKA,0GAAA;EAKA,2BAAA;EACA,mCAAA;EACA,6BAAA;EACA,8BAAA;EACA,8BAAA;EACA,yBAAA;EACA,aAAA;EACA,0BAAA;EACA,yCAAA;EACA,+CAAA;EACA,gCAAA;EACA,4BAAA;EACA,oCAAA;EACA,uCAAA;EACA,2DAAA;EACA,mDAAA;EACA,wCAAA;EACA,qCAAA;EACA,gCAAA;EACA,yCAAA;EACA,4CAAA;EACA,gDAAA;EACA,yBAAA;EACA,wBAAA;EACA,mCAAA;EACA,uDAAA;EACA,qCAAA;EACA,6CAAA;EACA,kBAAA;EACA,sCAAA;EACA,qCAAA;A9E66RF;A8E16RA;EACE,8BAAA;EACA,oBAAA;EACA,oBAAA;EACA,6BAAA;EACA,8BAAA;EACA,iDAAA;EACA,2BAAA;EACA,gBAAA;EACA,uBAAA;EACA,6BAAA;EACA,4CAAA;EACA,qCAAA;EACA,oCAAA;EACA,0CAAA;EACA,qDAAA;EACA,wDAAA;EACA,2CAAA;EACA,wDAAA;EACA,iEAAA;EACA,sEAAA;EACA,8EAAA;EAGA,2BAAA;EACA,+CAAA;EACA,qBAAA;A9E06RF;A8E74RE;EzEcA,kCAAA;EACI,8BAAA;EACC,6BAAA;EACG,0BAAA;ALk4RV;A8E74RA;EACE,mBAAA;A9E+4RF;A8E34RA;EAGE,kBAAA;EACA,oBAAA;A9E24RF;A8Ev4RA;EACE,mBAAA;A9Ey4RF;AACA,sEAAsE;AACtE,iEAAiE;A+E/hSjE;EACI,sBAAA;EACA,2BAAA;EACA,8BAAA;A/EiiSJ;A+E9hSA;EACI,kBAAA;A/EgiSJ;A+EzhSA;EACI,YAAA;A/E2hSJ;AACA,+BAA+B;AAC/B,4EAA4E;AAC5E;;;;;;;;;;;;;CAaC;AgFxiSD;EhF0iSE,iBAAiB;EgFxiSf,oBAAA;EACA,8BAAA;EACA,0BAAA;EAEA,iBAAA;EACA,2BAAA;EACA,uBAAA;EAEA,YAAA;EACA,sBAAA;EACA,kBAAA;EhFwiSF,oBAAoB;EgFriSlB,aAAA;EACA,mBAAA;EACA,oBAAA;AhFuiSJ;AgFpiSA;EhFsiSE,iBAAiB;EgFpiSf,mBAAA;EACA,gBAAA;EACA,WAAA;EhFsiSF,oBAAoB;EgFniSlB,UAAA;AhFqiSJ;AgFliSA;EhFoiSE,iBAAiB;EgFliSf,oBAAA;EACA,4BAAA;EACA,0BAAA;EAEA,iBAAA;EACA,yBAAA;EACA,uBAAA;EAEA,YAAA;EACA,oBAAA;EACA,kBAAA;EhFkiSF,oBAAoB;EgF/hSlB,aAAA;EACA,sBAAA;EACA,oBAAA;AhFiiSJ;AgF9hSA;EhFgiSE,iBAAiB;EgF9hSf,mBAAA;EACA,gBAAA;EACA,WAAA;EhFgiSF,oBAAoB;EgF7hSlB,UAAA;AhF+hSJ;AgF5hSA;;;EhFgiSE,iBAAiB;EgF5hSf,8BAAA;EACA,2BAAA;EACA,sBAAA;EhF8hSF,oBAAoB;EgF3hSlB,2BAAA;AhF6hSJ;AgF1hSA;;;EhF8hSE,iBAAiB;EgF1hSf,mBAAA;EACA,gBAAA;EACA,WAAA;EhF4hSF,oBAAoB;EgFzhSlB,UAAA;EACA,WAAA;AhF2hSJ;AgFxhSA;;;EhF4hSE,iBAAiB;EgFxhSf,mBAAA;EACA,gBAAA;EACA,WAAA;EhF0hSF,oBAAoB;EgFvhSlB,OAAA;AhFyhSJ;AgFthSA;;;EhF0hSE,iBAAiB;EACjB,iBAAiB;EgFniSf,mBAAA;EACA,gBAAA;EACA,WAAA;EhFqiSF,oBAAoB;EgFliSlB,OAAA;AhFoiSJ;AgF1hSA;;;EhF8hSE,iBAAiB;EgF1hSf,mBAAA;EACA,gBAAA;EACA,WAAA;EhF4hSF,oBAAoB;EgFzhSlB,OAAA;AhF2hSJ;AgFxhSA;EhF0hSE,gBAAgB;EgFxhSd,yBAAA;EACA,sBAAA;EACA,iBAAA;AhF0hSJ;AgFvhSA;EhFyhSE,eAAe;EgFvhSb,yBAAA;EACA,sBAAA;EACA,iBAAA;AhFyhSJ;AgFthSA;;;EhF0hSE,iBAAiB;EgFthSf,uBAAA;EACA,oBAAA;EACA,eAAA;EhFwhSF,oBAAoB;EgFrhSlB,2BAAA;AhFuhSJ;AgFphSA;;;EhFwhSE,iBAAiB;EgFphSf,qBAAA;EACA,kBAAA;EACA,aAAA;EhFshSF,oBAAoB;EgFnhSlB,yBAAA;AhFqhSJ;AgFlhSA;;;EhFshSE,iBAAiB;EgFlhSf,wBAAA;EACA,qBAAA;EACA,gBAAA;EhFohSF,oBAAoB;EgFjhSlB,uBAAA;AhFmhSJ;AgFhhSA;;;EhFohSE,iBAAiB;EgFhhSf,0BAAA;EACA,uBAAA;EACA,kBAAA;EhFkhSF,oBAAoB;EgF/gSlB,yBAAA;AhFihSJ;AgF9gSA;;;EhFkhSE,iBAAiB;EgF9gSf,yBAAA;EACA,sBAAA;EACA,iBAAA;EhFghSF,oBAAoB;EgF7gSlB,wBAAA;AhF+gSJ;AgF5gSA;;;EhFghSE,iBAAiB;EgF5gSf,wBAAA;EACA,qBAAA;EACA,gBAAA;EhF8gSF,oBAAoB;EgF3gSlB,uBAAA;AhF6gSJ;AgF1gSA;;;EhF8gSE,iBAAiB;EgF1gSf,sBAAA;EACA,mBAAA;EACA,cAAA;EhF4gSF,oBAAoB;EgFzgSlB,qBAAA;AhF2gSJ;AgFxgSA;;;EhF4gSE,iBAAiB;EgFxgSf,yBAAA;EACA,sBAAA;EACA,iBAAA;EhF0gSF,oBAAoB;EgFvgSlB,mBAAA;AhFygSJ;AgFtgSA;;;EhF0gSE,iBAAiB;EgFtgSf,2BAAA;EACA,wBAAA;EACA,mBAAA;EhFwgSF,oBAAoB;EgFrgSlB,qBAAA;AhFugSJ;AgFpgSA;;;EhFwgSE,iBAAiB;EgFpgSf,0BAAA;EACA,uBAAA;EACA,kBAAA;EhFsgSF,oBAAoB;EgFngSlB,oBAAA;AhFqgSJ;AiFhxSA;EACE,WAAA;EACA,kBAAA;AjFkxSF;AiF/wSA;EACI,eAAA;EACA,mBAAA;AjFixSJ;AiF9wSA;EACI,eAAA;EACA,mBAAA;AjFgxSJ;AiF7wSA;EACI,gBAAA;EACA,gBAAA;EACA,YAAA;AjF+wSJ;AiFlxSA;EAKM,iBAAA;EACA,cAAA;AjFgxSN;AACA;;;;EAIE;AkFpySF;EACE,gCAAA;ElFsySA;yEACuE;EkFpySvE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,QAAA;EACA,WAAA;EACA,iBAAA;EACA,wBAAA;AlFsySF;AkFnySA;ElFqySE,sCAAsC;EkFnyStC,aAAA;EACA,kCAAA;ElFqySA,4BAA4B;EkFlyS5B,kBAAA;EACA,YAAA;AlFoySF;AkF3ySA;EAUI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;EH/BA,sBAAA;EACA,2BAAA;EACA,8BAAA;A/Eo0SJ;AkFtzSA;EAoBI,WAAA;EACA,WAAA;EACA,wCAAA;EACA,mBAAA;AlFqySJ;AkFlySE;EAAA;IACE,wBAAA;ElFqySF;AACF;AkFlySA;EACE,WAAA;EACA,kBAAA;AlFoySF;AkFlySE;EAAA;IACE,aAAA;ElFqySF;AACF;AkFlySA;EACE,iBAAA;EACA,oBAAA;EACA,uBAAA;EACA,kBAAA;AlFoySF;AkFjySA;EACE,kBAAA;EACA,cAAA;AlFmySF;AkFhySA;EjDtDE,uBAAA;ECCY,YAAA;AlCy1Sd;AkFhySA;EACE,OAAA;AlFkySF;AkF/xSA;EACE,YAAA;AlFiySF;AkF9xSA;EACE,WAAA;EACA,aAAA;EHlFE,sBAAA;EACA,2BAAA;EACA,8BAAA;EGkFF,cAAA;AlFkySF;AkFjySE;EAAA;IAEE,uBAAA;ElFmySF;AACF;AACA,oBAAoB;AkFhySpB;EACE,oBAAA;EACA,cAAA;AlFkySF;AkF/xSA;EACE,oBAAA;AlFiySF;AkF9xSA;EACE,cAAA;EACA,iBAAA;AlFgySF;AkF7xSA;EACE,YAAA;AlF+xSF;AkF5xSA;EACE,WAAA;AlF8xSF;AkF3xSA;;;E7D/GE,WAAA;EACA,sBAAA;EACA,kBAAA;E6DiHA,iBAAA;AlF+xSF;AqB94SE;;;;;;EAEE,WAAA;EACA,yBAAA;EACA,qBAAA;ArBo5SJ;AqBl5SE;;;EACE,WAAA;EACA,yBAAA;EACA,qBAAA;ArBs5SJ;AqBp5SE;;;;;;;;;EAGE,WAAA;EACA,yBAAA;EACA,sBAAA;EACA,qBAAA;ArB45SJ;AqB15SI;;;;;;;;;;;;;;;;;;;;;;;;;;;EAGE,WAAA;EACA,yBAAA;EACA,qBAAA;ArBo7SN;AqB96SI;;;;;;;;;;;;;;;;;;;;;;;;;;;EAGE,sBAAA;EACA,kBAAA;ArBw8SN;AkF/3SA;;;E7DpEI,WAAA;EACA,sBAAA;ArBw8SJ;AkF93SA;EACE,oBAAA;AlFg4SF;AkF73SA;EACE,gBAAA;AlF+3SF;AkF33SA;ElF63SE,iBAAiB;EgF98Sf,oBAAA;EACA,4BAAA;EACA,0BAAA;EAEA,iBAAA;EACA,yBAAA;EACA,uBAAA;EAEA,YAAA;EACA,oBAAA;EACA,kBAAA;EhF88SF,oBAAoB;EgF38SlB,aAAA;EACA,sBAAA;EACA,oBAAA;EEoEF,gBAAA;AlF04SF;AkF54SA;EAKI,+BAAA;EACA,cAAA;EACA,OAAA;AlF04SJ;AkFt4SA;EACE,YAAA;AlFw4SF;AkFr4SA;EACE;IACE,YAAA;ElFu4SF;AACF;AkF93SA;EACE;IACE,iBAAA;IACA,kBAAA;ElFg4SF;AACF;AACA,6DAA6D;AkF53S7D;EACE,2BAAA;AlF83SF;AkF33SA;EACE,WAAA;AlF63SF;AkF13SA;EACE,gBAAA;AlF43SF;AACA;;;;CAIC;AACD,yDAAyD;AACzD;;wCAEwC;AmFpjTrC;EAAkB,cAAA;AnFujTrB;AmFtjTG;EAAkB,yBAAA;AnFyjTrB;AmFxjTG;EAA0B,cAAA;AnF2jT7B;AmF1jTG;EAA0B,yBAAA;AnF6jT7B;AmFhkTG;EAAkB,cAAA;AnFmkTrB;AmFlkTG;EAAkB,yBAAA;AnFqkTrB;AmFpkTG;EAA0B,cAAA;AnFukT7B;AmFtkTG;EAA0B,yBAAA;AnFykT7B;AmF5kTG;EAAkB,cAAA;AnF+kTrB;AmF9kTG;EAAkB,yBAAA;AnFilTrB;AmFhlTG;EAA0B,cAAA;AnFmlT7B;AmFllTG;EAA0B,yBAAA;AnFqlT7B;AmFxlTG;EAAkB,cAAA;AnF2lTrB;AmF1lTG;EAAkB,yBAAA;AnF6lTrB;AmF5lTG;EAA0B,cAAA;AnF+lT7B;AmF9lTG;EAA0B,yBAAA;AnFimT7B;AmFpmTG;EAAkB,cAAA;AnFumTrB;AmFtmTG;EAAkB,yBAAA;AnFymTrB;AmFxmTG;EAA0B,cAAA;AnF2mT7B;AmF1mTG;EAA0B,yBAAA;AnF6mT7B;AmFhnTG;EAAkB,cAAA;AnFmnTrB;AmFlnTG;EAAkB,yBAAA;AnFqnTrB;AmFpnTG;EAA0B,cAAA;AnFunT7B;AmFtnTG;EAA0B,yBAAA;AnFynT7B;AmF5nTG;EAAkB,cAAA;AnF+nTrB;AmF9nTG;EAAkB,yBAAA;AnFioTrB;AmFhoTG;EAA0B,cAAA;AnFmoT7B;AmFloTG;EAA0B,yBAAA;AnFqoT7B;AmFxoTG;EAAkB,cAAA;AnF2oTrB;AmF1oTG;EAAkB,yBAAA;AnF6oTrB;AmF5oTG;EAA0B,cAAA;AnF+oT7B;AmF9oTG;EAA0B,yBAAA;AnFipT7B;AmFjoTA;EAA2B,cAAA;AnFooT3B;AmFnoTA;EAA2B,yBAAA;AnFsoT3B;AmFpoTA;EAAa,iBAAA;AnFuoTb;AmFtoTA;EAAkB,0BAAA;AnFyoTlB;AoFppTA;EpFspTE,iBAAiB;EgFjnTf,oBAAA;EACA,4BAAA;EACA,0BAAA;EAEA,iBAAA;EACA,yBAAA;EACA,uBAAA;EAEA,YAAA;EACA,oBAAA;EACA,kBAAA;EhFinTF,oBAAoB;EgF9mTlB,aAAA;EACA,sBAAA;EACA,oBAAA;ED1DA,kBAAA;EANA,sBAAA;EACA,2BAAA;EACA,8BAAA;EKeA,iBAAA;EACA,mBAAA;EACA,yBAAA;EAEA,WAAA;EACA,YAAA;EpFmqTF,oEAAoE;EoFjqTlE,WAAA;EACA,aAAA;EAEA,kBAAA;EACA,iBAAA;ApFkqTJ;AoFhqTI;EA9BA,kBAAA;EACA,cAAA;EACA,SAAA;EACA,UAAA;EACA,UAAA;EAEA,6BAAA;EACA,WAAA;EACA,uBAAA;ApFgsTJ;AoFtqTI;EACI,0BAAA;EACA,sBAAA;EACA,iBAAA;EACA,2BAAA;EACA,uBAAA;EACA,mBAAA;ApFwqTR;AoFtqTQ;EAAA;IACI,yBAAA;EpFyqTV;AACF;AoFtqTI;;EACI,iCAAA;ApFyqTR;AoFvqTQ;;EAlDJ,kBAAA;EACA,cAAA;EACA,SAAA;EACA,UAAA;EACA,UAAA;EAEA,6BAAA;EACA,WAAA;EACA,mBAAA;ApF4tTJ;AoF9qTQ;EAAA;;IACI,yBAAA;EpFkrTV;AACF;AoF/qTI;EACI,qBAAA;ApFirTR;AoF/qTQ;EA9DJ,kBAAA;EACA,cAAA;EACA,SAAA;EACA,UAAA;EACA,UAAA;EAEA,6BAAA;EACA,WAAA;EACA,mBAAA;ApF+uTJ;AoFrrTQ;EAAA;IACI,yBAAA;EpFwrTV;AACF;AoFlrTA;EpForTE,sEAAsE;EoFlrTpE,eAAA;EpForTF,yEAAyE;EoFjrTvE,cAAA;EACA,WAAA;EACA,sBAAA;EACA,iBAAA;EpFmrTF,yEAAyE;EoFhrTvE,sBAAA;EpFkrTF,4CAA4C;EoF/qT1C,2BAAA;EACA,yBAAA;EACA,wBAAA;EACA,sBAAA;EACA,qBAAA;EACA,iBAAA;EpFirTF,uBAAuB;EoF9qTrB,eAAA;ApFgrTJ;AoF7qTA;EAGI;IACI,gBAAA;EpF6qTN;AACF;AoF1qTA;EACI,YAAA;EpF4qTF,iBAAiB;EgFvuTf,oBAAA;EACA,4BAAA;EACA,0BAAA;EAEA,iBAAA;EACA,yBAAA;EACA,uBAAA;EAEA,YAAA;EACA,oBAAA;EACA,kBAAA;EhFuuTF,oBAAoB;EgFpuTlB,aAAA;EACA,sBAAA;EACA,oBAAA;EhFsuTF,iBAAiB;EgF5rTf,mBAAA;EACA,gBAAA;EACA,WAAA;EhF8rTF,oBAAoB;EgF3rTlB,OAAA;AhF6rTJ;AACA,kFAAkF;AoF3rTlF;EACI,2CAAA;EL7GA,kBAAA;EK+GA,oCAAA;EACA,sBAAA;ApF6rTJ;AACA;;uEAEuE;AoF1rTvE;EACI,cAAA;EACA,iBAAA;ApF4rTJ;AoFzrTA;EAEI,wBAAA;EpF0rTF,iBAAiB;EgF1yTf,oBAAA;EACA,8BAAA;EACA,0BAAA;EAEA,iBAAA;EACA,2BAAA;EACA,uBAAA;EAEA,YAAA;EACA,sBAAA;EACA,kBAAA;EhF0yTF,oBAAoB;EgFvyTlB,aAAA;EACA,mBAAA;EACA,oBAAA;AhFyyTJ;AoF1sTA;ELvHE,kBAAA;EK8HM,YAAA;EACA,iBAAA;EACA,UAAA;EACA,2CAAA;EACA,iGAAA;ApFusTR;AoFltTA;EAcY,cAAA;EACA,qBAAA;ApFusTZ;AoFrsTY;EACI,cAAA;EACA,qBAAA;ApFusThB;AoFlsTA;EAEI;IACI,aAAA;EpFmsTN;AACF;AqFn2TA;ErFq2TE,oDAAoD;AACtD;AqFp2TI;EAAA;IACI,wBAAA;ErFu2TN;AACF;AACA,4EAA4E;AqFj2T5E;EACI,wBAAA;ErFm2TF,iBAAiB;EgFz1Tf,oBAAA;EACA,8BAAA;EACA,0BAAA;EAEA,iBAAA;EACA,2BAAA;EACA,uBAAA;EAEA,YAAA;EACA,sBAAA;EACA,kBAAA;EhFy1TF,oBAAoB;EgFt1TlB,aAAA;EACA,mBAAA;EACA,oBAAA;AhFw1TJ;AqF72TA;EAEI;IrF82TA,iBAAiB;IgF50TjB,oBAAA;IACA,4BAAA;IACA,0BAAA;IAEA,iBAAA;IACA,yBAAA;IACA,uBAAA;IAEA,YAAA;IACA,oBAAA;IACA,kBAAA;IhF40TA,oBAAoB;IgFz0TpB,aAAA;IACA,sBAAA;IACA,oBAAA;EhF20TF;AACF;AqFx3TA;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,uBAAA;EACA,iBAAA;ArF03TJ;AACA,kFAAkF;AqFv3TlF;EACI,gCAAA;EACA,iCAAA;ArFy3TJ;AqFt3TA;EACI,aAAA;EACA,eAAA;EACA,WAAA;EACA,gBAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,UAAA;ArFw3TJ;AqFp3TA;EACI,eAAA;ArFs3TJ;AqFn3TA;EACI;IACI,cAAA;ErFq3TN;AACF;AqF72TA;EACI,aAAA;EACA,YAAA;EACA,YAAA;EACA,6BAAA;ArF+2TJ;AqF52TA;EACI,WAAA;EACA,YAAA;EACA,YAAA;EACA,6BAAA;ArF82TJ;AACA;;;;;;;;;EASE;AsFx7TF;EACI,sBAAA;EtF07TF,2CAA2C;EsFz7TzC,eAAA;EACA,YAAA;EtF27TF,gCAAgC;EsF17T9B,gBAAA;EtF47TF,uDAAuD;AACzD;AsF17TA;EtF47TE,sFAAsF;EACtF,4FAA4F;EsF17T1F,kBAAA;EACA,gBAAA;AtF47TJ;AsFz7TA;EtF27TE,2FAA2F;EAC3F,0EAA0E;EAC1E;8DAC4D;EsFz7T1D,gBAAA;AtF27TJ;AsFx7TA;EAGI,oBAAA;AtFw7TJ;AsFr7TA;EAGI,8BAAA;EACA,2BAAA;AtFq7TJ;AsFl7TA;EtFo7TE;wCACsC;EsFl7TpC,gBAAA;EACA,SAAA;EPrCF,gBAAA;A/E09TF;AsFj7TA;EACI,8BAAA;AtFm7TJ;AsF/6TA;EACI;IACI,4BAAA;EtFi7TN;AACF;AsF76TA;EACI;IACI,4BAAA;EtF+6TN;AACF;AACA;;;;;CAKC;AuF/+TD;EACE,WAAA;AvFi/TF;AuF9+TA;EAHE,WAAA;AvFo/TF;AuF7+TA;EAGE,wBAAA;AvF6+TF;AuF1+TA;EACE,cAAA;AvF4+TF;AuFz+TA;EACE,cAAA;AvF2+TF;AuFv+TA;EACE,cAAA;EACA,kBAAA;AvFy+TF;AuFt+TA;EACE,WAAA;AvFw+TF;AuFr+TA;EACE,WAAA;AvFu+TF;AuFp+TA;EACE,cAAA;EACA,iBAAA;AvFs+TF;AuFn+TA;EACE,cAAA;AvFq+TF;AuFl+TA;EACE,WAAA;AvFo+TF;AuFj+TA;EACE,cAAA;EACA,iBAAA;AvFm+TF;AuFh+TA;EACE,cAAA;AvFk+TF;AACA,4DAA4D;AuF/9T5D;EC6CuB,WAAA;AxFq7TvB;AuFz9TA;EC6C4B,WAAA;AxF+6T5B;AuFz9TA;EC4C6B,WAAA;AxFg7T7B;AuFz9TA;EC2C2B,WAAA;AxFi7T3B;AuFz9TA;ECyCuB,WAAA;AxFm7TvB;AuFz9TA;ECuC6B,WAAA;AxFq7T7B;AuFz9TA;ECS0B,WAAA;AxFm9T1B;AuFz9TA;ECOyB,WAAA;AxFq9TzB;AuFz9TA;ECgCwB,WAAA;AxF47TxB;AACA,uCAAuC;AuFv9TrC;EA1DA,cAAA;EACA,iBAAA;AvFohUF;AuFx9TE;EAjEA,WAAA;AvF4hUF;AuFx9TE;EAxEA,WAAA;AvFmiUF;AuFx9TE;ECAqB,WAAA;AxF29TvB;AuFx9TE;EA1GA,WAAA;AvFqkUF;AuFl9TE;EAlEA,cAAA;EACA,iBAAA;AvFuhUF;AuFn9TE;EA5GA,wBAAA;AvFkkUF;AuFn9TE;EA3GA,cAAA;AvFikUF;AuFn9TE;EArGA,cAAA;EACA,kBAAA;AvF2jUF;AuFp9TE;EA7GA,cAAA;AvFokUF;AuFp9TE;EClB0B,WAAA;AxFy+T5B;AuFp9TE;EA/EA,cAAA;AvFsiUF;AuFp9TE;ECtB2B,WAAA;AxF6+T7B;AuFp9TE;EAlGA,cAAA;AvFyjUF;AuFp9TE;EC1ByB,WAAA;AxFi/T3B;AuFp9TE;EC5BqB,WAAA;AxFm/TvB;AuFp9TE;EC9B2B,WAAA;AxFq/T7B;AuFp9TE;EC5DwB,WAAA;AxFmhU1B;AuFp9TE;EC9DuB,WAAA;AxFqhUzB;AuFp9TE;ECrCsB,WAAA;AxF4/TxB;AuFp9TE;EAnHA,WAAA;AvF0kUF;AuFn9TE;EACE,oDAAA;EACA,0BAAA;EACA,4BAAA;AvFq9TJ;AyFxoUA;EzF0oUE,kFAAkF;EyFxoUhF,kBAAA;EzF0oUF,iBAAiB;EgFxlUf,oBAAA;EACA,4BAAA;EACA,0BAAA;EAEA,iBAAA;EACA,yBAAA;EACA,uBAAA;EAEA,YAAA;EACA,oBAAA;EACA,kBAAA;EhFwlUF,oBAAoB;EgFrlUlB,aAAA;EACA,sBAAA;EACA,oBAAA;ES9DA,UAAA;AzFspUJ;AACA,+DAA+D;AyFnpU/D;EzFqpUE,kEAAkE;EyFnpUhE,YAAA;EzFqpUF,iFAAiF;EyFnpU/E,WAAA;EAEA,cAAA;EVNA,kBAAA;E1E6DF,sDAAA;EACQ,8CAAA;EoFrDN,cAAA;AzFqpUJ;AACA,qCAAqC;AyFlpUrC;EACI,WAAA;EACA,YAAA;EzFopUF,iBAAiB;EgFxnUf,oBAAA;EACA,4BAAA;EACA,0BAAA;EAEA,iBAAA;EACA,yBAAA;EACA,uBAAA;EAEA,YAAA;EACA,oBAAA;EACA,kBAAA;EhFwnUF,oBAAoB;EgFrnUlB,aAAA;EACA,sBAAA;EACA,oBAAA;AhFunUJ;AyF9pUA;EACI,YAAA;EACA,kBAAA;EACA,kBAAA;EVtBA,kBAAA;A/EurUJ;AyF7pUA;EzF+pUE,0EAA0E;EK5nU1E,sCAAA;EACQ,8BAAA;EoFjCN,oCAAA;AzFgqUJ;AyF7pUA;EACI,iCAAA;AzF+pUJ;AACA,8DAA8D;AyF5pU9D;EACI,YAAA;EACA,wBAAA;EzF8pUF,iBAAiB;EgFxrUf,oBAAA;EACA,8BAAA;EACA,0BAAA;EAEA,iBAAA;EACA,2BAAA;EACA,uBAAA;EAEA,YAAA;EACA,sBAAA;EACA,kBAAA;EhFwrUF,oBAAoB;EgFrrUlB,aAAA;EACA,mBAAA;EACA,oBAAA;EhFurUF,gFAAgF;AAClF;AyF/qUA;EAOQ,6BAAA;AzF2qUR;AyFlrUA;EAaY,cAAA;EACA,eAAA;AzFwqUZ;AyFtrUA;EAkBY,cAAA;EACA,eAAA;AzFuqUZ;AyF1rUA;;EAwBQ,eAAA;EACA,YAAA;AzFsqUR;AyFrqUQ;;EACI,eAAA;AzFwqUZ;AyFnsUA;EAgCQ,eAAA;AzFsqUR;AyFtsUA;EAyCwB,iBAAA;EACA,YAAA;AzFgqUxB;AACA;yBACyB;AyFxpUzB;EzF0pUE,iBAAiB;EgFxsUf,oBAAA;EACA,4BAAA;EACA,0BAAA;EAEA,iBAAA;EACA,yBAAA;EACA,uBAAA;EAEA,YAAA;EACA,oBAAA;EACA,kBAAA;EhFwsUF,oBAAoB;EgFrsUlB,aAAA;EACA,sBAAA;EACA,oBAAA;AhFusUJ;AyFpqUA;EAEI;IzFqqUA,iBAAiB;IgFztUjB,oBAAA;IACA,4BAAA;IACA,0BAAA;IAEA,iBAAA;IACA,yBAAA;IACA,uBAAA;IAEA,YAAA;IACA,oBAAA;IACA,kBAAA;IhFytUA,oBAAoB;IgFttUpB,aAAA;IACA,sBAAA;IACA,oBAAA;EhFwtUF;AACF;AyF/qUA;EACI,SAAA;EACA,oBAAA;EACA,SAAA;EACA,wBAAA;EACA,8BAAA;EACA,6BAAA;EVtGF,gBAAA;A/EwxUF;AACA;oBACoB;AyF9qUpB;EAEI,gBAAA;EACA,cAAA;EzF+qUF,iBAAiB;EgF9rUf,mBAAA;EACA,gBAAA;EACA,WAAA;EhFgsUF,oBAAoB;EgF7rUlB,OAAA;ESaA,4BAAA;AzFmrUJ;AyFhrUA;EAEI,mBAAA;AzFirUJ;AACA;iBACiB;AACjB,oCAAoC;AyF7qUpC;EACI,gBAAA;EACA,YAAA;EzF+qUF,yEAAyE;EyF7qUvE,sBAAA;AzF+qUJ;AACA,6FAA6F;AyFtqU7F;EACI,yCAAA;EzFwqUF,yCAAyC;AAC3C;AyFtqUA;EACI,gBAAA;AzFwqUJ;AACA,uDAAuD;AyF5pUvD;EACI,UAAA;AzF8pUJ;AyF3pUA;EACI,cAAA;AzF6pUJ;AACA,qBAAqB;AyFzpUrB;EACI,sBAAA;EAGA,gBAAA;AzFypUJ;AyFtpUA;EzFwpUE,yBAAyB;AAC3B;AyFrpUA;EACI,sBAAA;EACA,kBAAA;EACA,cAAA;EACA,WAAA;EzFupUF,gDAAgD;EyFrpU9C,wBAAA;EzFupUF,uDAAuD;EyFrpUrD,mBAAA;EACA,kBAAA;AzFupUJ;AyFppUA;EACI,gBAAA;AzFspUJ;AyFnpUA;EACI,mBAAA;AzFqpUJ;AyFlpUA;EACE,YAAA;EACA,iBAAA;EACA,UAAA;AzFopUF;AyFvpUA;EAMM,cAAA;EACA,qBAAA;AzFopUN;AyFlpUM;EACI,cAAA;EACA,qBAAA;AzFopUV;A0Fn3UA;EAEI,YAAA;E1Fo3UF,qCAAqC;AACvC;A0Fv3UA;EAGQ,kBAAA;A1Fu3UR;A0F13UA;EAIY,iBAAA;A1Fy3UZ;A0F73UA;EAKO,0BAAA;A1F23UP;A0Fh4UA;EAMW,0BAAA;A1F63UX;A0Fn4UA;EAOc,0BAAA;A1F+3Ud;A0Ft4UA;EAYQ,iBAAA;EAAmB,oBAAA;EAAsB,iBAAA;EAAmB,cAAA;A1Fg4UpE;A0F54UA;EAaQ,iBAAA;EAAmB,oBAAA;EAAsB,iBAAA;EAAmB,cAAA;A1Fq4UpE;A0Fl5UA;EAcQ,iBAAA;EAAmB,oBAAA;EAAsB,iBAAA;EAAmB,cAAA;A1F04UpE;A0Fx5UA;EAeQ,eAAA;EAAiB,iBAAA;EAAmB,iBAAA;EAAmB,cAAA;A1F+4U/D;A0F95UA;EAgBQ,eAAA;EAAiB,iBAAA;EAAmB,iBAAA;EAAmB,cAAA;EAAkB,kBAAA;A1Fq5UjF;A0Fr6UA;EAiBQ,eAAA;EAAiB,iBAAA;EAAmB,iBAAA;EAAmB,cAAA;EAAkB,kBAAA;A1F25UjF;A0F56UA;EAoBoB,mBAAA;A1F25UpB;A0F/6UA;EAqBoB,mBAAA;A1F65UpB;A0Fl7UA;EAsBoB,mBAAA;A1F+5UpB;A0Fr7UA;EAuBoB,eAAA;A1Fi6UpB;A0Fx7UA;EAwBoB,eAAA;A1Fm6UpB;A0F37UA;EAyBoB,eAAA;A1Fq6UpB;A0F97UA;;EA4B0B,iBAAA;A1Fs6U1B;A0Fl8UA;EA6BQ,gBAAA;A1Fw6UR;A0Fr8UA;EA+BM,kBAAA;EACA,aAAA;A1Fy6UN;A0Fz8UA;EAkCc,kBAAA;A1F06Ud;A0F58UA;EAmCQ,mBAAA;A1F46UR;A0F/8UA;EAqCM,uBAAA;EACA,aAAA;A1F66UN;A0Fn9UA;EAwCc,uBAAA;A1F86Ud;A0Ft9UA;EAyCiB,uBAAA;A1Fg7UjB;A0Fz9UA;EA2CoB,mBAAA;A1Fi7UpB;A0F59UA;EA4CY,eAAA;A1Fm7UZ;A0F/9UA;EA6CY,eAAA;A1Fq7UZ;A0Fl+UA;EAgDQ,wCAAA;EACA,mDAAA;A1Fq7UR;A0Ft+UA;EAqDQ,eAAA;EACA,YAAA;EACA,gCAAA;A1Fo7UR;A0F3+UA;EA2DQ,yBAAA;A1Fm7UR;A0F9+UA;EA+DQ,gBAAA;A1Fk7UR;A0Fj/UA;EAkEc,gCAAA;A1Fk7Ud;A0Fp/UA;;EAqEQ,SAAA;EACA,YAAA;EACA,eAAA;A1Fm7UR;A0F1/UA;EA0EgB,eAAA;A1Fm7UhB;A0F7/UA;EA6EQ,iBAAA;EACA,kBAAA;EACA,YAAA;EACA,yBAAA;EACA,iBAAA;EACA,wCAAA;EACA,eAAA;EACA,mBAAA;A1Fm7UR;A0FvgVA;EAuFQ,0DAAA;EACA,sBAAA;A1Fm7UR;A0F3gVA;;;EA2FQ,iBAAA;EACA,sBAAA;EACA,oBAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;EACA,YAAA;A1Fq7UR;A0FthVA;EAoGQ,gBAAA;A1Fq7UR;A0FzhVA;EAuGQ,kBAAA;A1Fq7UR;A0F5hVA;EA0GQ,iBAAA;A1Fq7UR;A0F/hVA;EA6GQ,iBAAA;A1Fq7UR;A0FliVA;EAgHQ,mBAAA;A1Fq7UR;A0FriVA;EAmHQ,mCAAA;A1Fq7UR;A0FxiVA;EAqHe,eAAA;A1Fs7Uf;A0F3iVA;EAuHO,gBAAA;A1Fu7UP;A0F9iVA;EAwHW,eAAA;A1Fy7UX;A0FjjVA;EA2HQ,cAAA;EACA,iBAAA;EACA,kBAAA;A1Fy7UR;A0FtjVA;EA+Ha,eAAA;A1F07Ub;A0FzjVA;;EAkIQ,eAAA;EACA,YAAA;A1F27UR;A0F17UQ;;EACI,eAAA;A1F67UZ;A0FlkVA;EA0IY,sBAAA;A1F27UZ;A0FrkVA;EA2IgB,eAAA;A1F67UhB;A0F17UA;EAEQ,iBAAA;A1F27UR;A2F3kVA;E3F6kVE,iBAAiB;EgFvjVf,oBAAA;EACA,8BAAA;EACA,0BAAA;EAEA,iBAAA;EACA,2BAAA;EACA,uBAAA;EAEA,YAAA;EACA,sBAAA;EACA,kBAAA;EhFujVF,oBAAoB;EgFpjVlB,aAAA;EACA,mBAAA;EACA,oBAAA;AhFsjVJ;A2FxlVA;EAEI;IACI,aAAA;E3FylVN;AACF;A2FtlVA;E3FwlVE,uEAAuE;E2FtlVrE,aAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,gCAAA;EACA,YAAA;EZdA,sBAAA;EACA,2BAAA;EACA,8BAAA;A/EumVJ;A2FvlVA;EACE,qBAAA;EACA,iBAAA;EACA,kBAAA;A3FylVF;A2FrlVI;;;;;;EACI,mBAAA;A3F4lVR;A2FxlVA;EACI,aAAA;A3F0lVJ;A2FvlVA;EACI,gBAAA;EAKA,kBAAA;A3FqlVJ;A2FllVA;;;EAEE,eAAA;A3FqlVF;A2FjlVA;EACI,aAAA;A3FmlVJ;A2FhlVA;EACE,0BAAA;EACA,YAAA;A3FklVF;A2F/kVA;;;;;;EAMI,iBAAA;EACA,2DAAA;A3FilVJ;A2F9kVA;EAAe,iBAAA;A3FilVf;A2FhlVA;EAAe,iBAAA;A3FmlVf;A2FllVA;EAAe,iBAAA;A3FqlVf;A2FplVA;EAAe,eAAA;A3FulVf;A2FtlVA;EACI,eAAA;EACA,kBAAA;A3FwlVJ;A2FtlVA;EACI,eAAA;EACA,kBAAA;A3FwlVJ;AACA;;;;CAIC;A4F9qVD;EAEE;IACE,iBAAA;IACA,kBAAA;E5F+qVF;AACF;A4F5qVA;EbLI,sBAAA;EACA,2BAAA;EACA,8BAAA;EaKF,YAAA;A5FgrVF;A4F7qVA;EACE,WAAA;EACA,YAAA;EbZE,sBAAA;EACA,2BAAA;EACA,8BAAA;EaYF,YAAA;A5FirVF;A4F9qVA;EACE,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,WAAA;E5FgrVA,iEAAiE;E4F9qVjE,iBAAA;EACA,oBAAA;EACA,WAAA;EACA,aAAA;Eb3BE,sBAAA;EACA,2BAAA;EACA,8BAAA;Ea2BF,gBAAA;A5FkrVF;A4F9qVE;EAAA;IACE,aAAA;IACA,gCAAA;IACA,aAAA;IvF+BF,0DAAA;IACQ,kDAAA;ELmpVR;AACF;A4FjrVE;EAAA;IACE,WAAA;E5ForVF;AACF;A4FjrVA;EACE,qCAAA;EACA,aAAA;A5FmrVF;A4FhrVA;EACE,0CAAA;EACA,sBAAA;Eb7CE,kBAAA;Ea+CF,cAAA;EACA,iBAAA;A5FkrVF;A4F/qVA;EACE,cAAA;A5FirVF;AACA;;EAEE;A4F9qVF;;;;EAIE,qBAAA;A5FgrVF;A4F7qVA;EACE,sBAAA;A5F+qVF;A4F5qVA;EACE,gBAAA;A5F8qVF;A4F3qVA;EACE,iBAAA;A5F6qVF;A4FtqVA;EvFpBE,0DAAA;EACQ,kDAAA;AL6rVV;A4FrqVE;EAAA;IACE,4CAAA;E5FwqVF;AACF;A4FrqVA;EACE,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;A5FuqVF;A4FpqVA;EACE,YAAA;EACA,iBAAA;EACA,6BAAA;A5FsqVF;A4FnqVA;EACE,SAAA;EACA,UAAA;EACA,YAAA;A5FqqVF;A4FlqVA;EACE,YAAA;A5FoqVF;A4FjqVA;EACE,uGAAA;EAKA,iCAAA;EACA,iBAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;A5F+pVF;AACA,6BAA6B;A6FvyV7B;EACI,kDAAA;EACA,mBAAA;EACA,sCAAA;EACA,8BAAA;EACA,WAAA;EAEA,YAAA;EACA,kBAAA;E7FwyVF,iBAAiB;EgF7xVf,oBAAA;EACA,8BAAA;EACA,0BAAA;EAEA,iBAAA;EACA,2BAAA;EACA,uBAAA;EAEA,YAAA;EACA,sBAAA;EACA,kBAAA;EhF6xVF,oBAAoB;EgF1xVlB,aAAA;EACA,mBAAA;EACA,oBAAA;EhF4xVF,iBAAiB;EgF3pVf,qBAAA;EACA,kBAAA;EACA,aAAA;EhF6pVF,oBAAoB;EgF1pVlB,yBAAA;Ea1JA,qBAAA;A7FuzVJ;A6FtzVI;EAAA;IACI,aAAA;E7FyzVN;AACF;A6FrzVA;EACI,aAAA;EACA,sBAAA;A7FuzVJ;AACA;;CAEC;A6FpzVD;EACI,cAAA;A7FszVJ;A6FnzVA;;;EAGI,4BAAA;EACA,2BAAA;A7FqzVJ;A6FlzVA;EAEI,2CAAA;A7FmzVJ;A6FhzVA;EACI,cAAA;EACA,gBAAA;A7FkzVJ;A6F/yVA;E3EkFE,cAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;EACA,uBAAA;EACA,cAAA;EACA,sBAAA;EACA,sBAAA;EACA,sBAAA;EACA,kBAAA;Eb3EA,wDAAA;EACQ,gDAAA;EAyHR,8EAAA;EACK,yEAAA;EACG,sEAAA;Ec7HR,YAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;E0EhBE,cAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA;EAEA,qBAAA;A7Fk0VJ;AmBx0VE;EACE,qBAAA;EACA,UAAA;EdYF,yFAAA;EACQ,iFAAA;AL+zVV;AK9xVE;EACE,WAAA;EACA,UAAA;ALgyVJ;AK9xVE;EAA0B,WAAA;ALiyV5B;AKhyVE;EAAgC,WAAA;ALmyVlC;AkBpvVE;EACE,6BAAA;EACA,SAAA;AlBsvVJ;AkB9uVE;;;EAGE,yBAAA;EACA,UAAA;AlBgvVJ;AkB7uVE;;EAEE,mBAAA;AlB+uVJ;AkB3uVE;EACE,YAAA;AlB6uVJ;AmBt1VE;EACE,YAAA;EACA,iBAAA;AnBw1VJ;AmBr1VE;;EAEE,YAAA;AnBu1VJ;A6Fv2VA;EACI,gBAAA;EACA,iBAAA;A7Fy2VJ;A8F36VA;EACI,WAAA;EACA,aAAA;A9F66VJ;A8F16VA;EACI,aAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;A9F46VJ;A8Fz6VA;EACI,aAAA;A9F26VJ;A8Fx6VA;EACI,gBAAA;A9F06VJ;A8Fv6VA;EACI,aAAA;A9Fy6VJ;A8Ft6VA;EACI,WAAA;EACA,kBAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;E9Fw6VF,6CAA6C;E8Ft6V3C,6DAAA;A9Fw6VJ;A8Fr6VA;EACI,gBAAA;A9Fu6VJ;A8Fp6VA;;;E5E8FE,cAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;EACA,uBAAA;EACA,cAAA;EACA,sBAAA;EACA,sBAAA;EACA,sBAAA;EACA,kBAAA;Eb3EA,wDAAA;EACQ,gDAAA;EAyHR,8EAAA;EACK,yEAAA;EACG,sEAAA;Ec7HR,YAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;E2E1BE,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;EAEA,qBAAA;A9Fu7VJ;AmBr7VE;;;EACE,qBAAA;EACA,UAAA;EdYF,yFAAA;EACQ,iFAAA;AL86VV;AK74VE;;;EACE,WAAA;EACA,UAAA;ALi5VJ;AK/4VE;;;EAA0B,WAAA;ALo5V5B;AKn5VE;;;EAAgC,WAAA;ALw5VlC;AkBz2VE;;;EACE,6BAAA;EACA,SAAA;AlB62VJ;AkBr2VE;;;;;;;;;EAGE,yBAAA;EACA,UAAA;AlB62VJ;AkB12VE;;;;;;EAEE,mBAAA;AlBg3VJ;AkB52VE;;;EACE,YAAA;AlBg3VJ;AmBz9VE;;;EACE,YAAA;EACA,iBAAA;AnB69VJ;AmB19VE;;;;;;EAEE,YAAA;AnBg+VJ;A8Fz/VA;;EAEI,gBAAA;A9F2/VJ;A8Fx/VA;EACI,sBAAA;EACA,mBAAA;A9F0/VJ;A8Fv/VA;EACI,aAAA;EACA,gBAAA;EACA,kBAAA;A9Fy/VJ;A+F/jWA;EACI,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,qCAAA;EhBKA,kBAAA;E1E6DF,6CAAA;EACQ,qCAAA;E0FhEN,cAAA;A/FkkWJ;A+F/jWA;EACI,iBAAA;EACA,aAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;EACA,cAAA;EACA,sBAAA;EACA,eAAA;EACA,YAAA;EACA,WAAA;A/FikWJ;A+F9jWA;EACI,cAAA;A/FgkWJ;AgGxlWA;EAEQ,aAAA;EhEIN,gBAAA;EACA,mBAAA;EgEHM,WAAA;EACA,YAAA;AhG0lWR;AgGtlWA;E/DWE,sBAAA;ECDW,WAAA;AlCglWb;AiGnmWA;EAMI,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,mBAAA;AjGgmWJ;AiGzmWA;EAYM,mBAAA;AjGgmWN;AiG5mWA;EAeM,OAAA;AjGgmWN;AkG/mWA;EnBGI,sBAAA;EACA,2BAAA;EACA,8BAAA;EmBHF,eAAA;AlGmnWF;AkGrnWA;EAKI,eAAA;EACA,8BAAA;EACA,kBAAA;AlGmnWJ;AkG1nWA;EAWI,WAAA;EACA,gBAAA;EACA,mBAAA;EACA,YAAA;AlGknWJ;AkGhoWA;EAiBI,WAAA;AlGknWJ;AkG7mWA;EAEQ,YAAA;AlG8mWR;AkG1mWA;EAEQ,YAAA;AlG2mWR;AkG7mWA;EAKQ,YAAA;AlG2mWR;AkGhnWA;EAQQ,kBAAA;AlG2mWR;AkGnnWA;EAWQ,YAAA;AlG2mWR;AkGtnWA;EAcQ,sBAAA;AlG2mWR;AkGvmWA;EACI,iBAAA;EACA,UAAA;AlGymWJ;AkGtmWA;EACI,WAAA;EACA,OAAA;AlGwmWJ;AkGtmWA;EACE,qDAAA;AlGwmWF;AkGrmWA;EAEE,gBAAA;AlGsmWF;AkGnmWA;EjE5CE,sBAAA;ECDW,WAAA;AlCopWb;AkGnmWA;EACI,gBAAA;EACA,oBAAA;AlGqmWJ;AkGvmWA;EAIQ,oBAAA;AlGsmWR;AkGlmWA;EACI,mBAAA;AlGomWJ;AkGrmWA;EAGQ,eAAA;EACA,mBAAA;AlGqmWR;AkGzmWA;EjExDE,sBAAA;ECDW,WAAA;AlCsqWb;AkG/lWA;EACI,kBAAA;AlGimWJ;AkG9lWA;EACI,MAAA;EACA,UAAA;EACA,gBAAA;EACA,iBAAA;AlGgmWJ;AkG7lWA;EACI,WAAA;EACA,kBAAA;AlG+lWJ;AkG3lWA;EACI,cAAA;AlG6lWJ;AkG1lWA;E9B3GE,qBAAA;EACA,6CAAA;EACA,kBAAA;EACA,oBAAA;EACA,mCAAA;EACA,kCAAA;E8BwGE,cAAA;EACA,gBAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;AlGimWJ;AkC1sWG;EAA8B,mBAAA;AlC6sWjC;AkC5sWG;EAA+B,kBAAA;AlC+sWlC;AkCvsWE;EAAc,mBAAA;AlC0sWhB;AkCzsWE;EAAe,kBAAA;AlC4sWjB;AkG1mWA;EACI,WAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;AlG4mWJ;AkGzmWA;EACI,cAAA;AlG2mWJ;AkGxmWA;EACI,WAAA;AlG0mWJ;AkGvmWA;EACI,WAAA;EACA,iBAAA;AlGymWJ;AmGnvWA;ElEiBE,uBAAA;ECCY,YAAA;EiEhBV,WAAA;AnGsvWJ;AmGnvWA;ElEeE,sBAAA;ECDW,WAAA;AlCyuWb;AmGnvWA;ElEQE,uBAAA;ECCY,YAAA;EiEPV,uCAAA;EACA,gBAAA;EACA,iBAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;EACA,WAAA;AnGsvWJ;AmGnvWA;ElEAE,sBAAA;ECDW,WAAA;AlCwvWb;AmGnvWA;ElEPE,uBAAA;ECCY,YAAA;EiEPV,uCAAA;EACA,gBAAA;EACA,iBAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;EACA,WAAA;EAUA,sBAAA;AnG4vWJ;AmG/vWA;EAMQ,iBAAA;EACA,kBAAA;AnG4vWR;AmGxvWA;ElEfE,sBAAA;ECDW,WAAA;EiEkBT,cAAA;EACA,uBAAA;AnG2vWJ;AmGxvWA;ElExBE,uBAAA;ECCY,YAAA;EiEPV,uCAAA;EACA,gBAAA;EACA,iBAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;EACA,WAAA;AnG2xWJ;AmG9vWA;ElE1BE,sBAAA;ECDW,WAAA;AlC6xWb;AmG9vWA;ElEjCE,uBAAA;ECCY,YAAA;EiEPV,uCAAA;EACA,gBAAA;EACA,iBAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;EACA,WAAA;EAqCA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EAGA,aAAA;AnGowWJ;AmGjwWA;E7B5DE,mBAAA;EACA,kBAAA;AtEg0WF;AmGjwWA;E/B/DE,qBAAA;EACA,6CAAA;EACA,kBAAA;EACA,oBAAA;EACA,mCAAA;EACA,kCAAA;EcoJA,gBAAA;AlFgrWF;AkCh0WG;EAA8B,mBAAA;AlCm0WjC;AkCl0WG;EAA+B,kBAAA;AlCq0WlC;AkC7zWE;EAAc,mBAAA;AlCg0WhB;AkC/zWE;EAAe,kBAAA;AlCk0WjB;AmGlxWA;E/BnEE,qBAAA;EACA,6CAAA;EACA,kBAAA;EACA,oBAAA;EACA,mCAAA;EACA,kCAAA;EcoJA,YAAA;AlFqsWF;AkCr1WG;EAA8B,mBAAA;AlCw1WjC;AkCv1WG;EAA+B,kBAAA;AlC01WlC;AkCl1WE;EAAc,mBAAA;AlCq1WhB;AkCp1WE;EAAe,kBAAA;AlCu1WjB;AmGnyWA;E/BvEE,qBAAA;EACA,6CAAA;EACA,kBAAA;EACA,oBAAA;EACA,mCAAA;EACA,kCAAA;EcoJA,gBAAA;AlF0tWF;AkC12WG;EAA8B,mBAAA;AlC62WjC;AkC52WG;EAA+B,kBAAA;AlC+2WlC;AkCv2WE;EAAc,mBAAA;AlC02WhB;AkCz2WE;EAAe,kBAAA;AlC42WjB;AmGpzWA;E/B3EE,qBAAA;EACA,6CAAA;EACA,kBAAA;EACA,oBAAA;EACA,mCAAA;EACA,kCAAA;EcoJA,gBAAA;AlF+uWF;AkC/3WG;EAA8B,mBAAA;AlCk4WjC;AkCj4WG;EAA+B,kBAAA;AlCo4WlC;AkC53WE;EAAc,mBAAA;AlC+3WhB;AkC93WE;EAAe,kBAAA;AlCi4WjB;AmGr0WA;E/B/EE,qBAAA;EACA,6CAAA;EACA,kBAAA;EACA,oBAAA;EACA,mCAAA;EACA,kCAAA;EcoJA,gBAAA;AlFowWF;AkCp5WG;EAA8B,mBAAA;AlCu5WjC;AkCt5WG;EAA+B,kBAAA;AlCy5WlC;AkCj5WE;EAAc,mBAAA;AlCo5WhB;AkCn5WE;EAAe,kBAAA;AlCs5WjB;AmGt1WA;E/BnFE,qBAAA;EACA,6CAAA;EACA,kBAAA;EACA,oBAAA;EACA,mCAAA;EACA,kCAAA;EcoJA,gBAAA;AlFyxWF;AkCz6WG;EAA8B,mBAAA;AlC46WjC;AkC36WG;EAA+B,kBAAA;AlC86WlC;AkCt6WE;EAAc,mBAAA;AlCy6WhB;AkCx6WE;EAAe,kBAAA;AlC26WjB;AoGl8WA;EACI,cAAA;EACA,WAAA;EACA,oCAAA;EACA,iBAAA;E/EEF,WAAA;EACA,sBAAA;EACA,kBAAA;ArBm8WF;AqBj8WE;;EAEE,WAAA;EACA,yBAAA;EACA,qBAAA;ArBm8WJ;AqBj8WE;EACE,WAAA;EACA,yBAAA;EACA,qBAAA;ArBm8WJ;AqBj8WE;;;EAGE,WAAA;EACA,yBAAA;EACA,sBAAA;EACA,qBAAA;ArBm8WJ;AqBj8WI;;;;;;;;;EAGE,WAAA;EACA,yBAAA;EACA,qBAAA;ArBy8WN;AqBn8WI;;;;;;;;;EAGE,sBAAA;EACA,kBAAA;ArB28WN;AoGv/WA;E/EiDI,WAAA;EACA,sBAAA;ArBy8WJ;AoGn/WA;E/EFE,WAAA;EACA,yBAAA;EACA,qBAAA;EgFCE,cAAA;EACA,yBAAA;EACA,qBAAA;ArGw/WJ;AqBz/WE;;EAEE,WAAA;EACA,yBAAA;EACA,qBAAA;ArB2/WJ;AqBz/WE;EACE,WAAA;EACA,yBAAA;EACA,qBAAA;ArB2/WJ;AqBz/WE;;;EAGE,WAAA;EACA,yBAAA;EACA,sBAAA;EACA,qBAAA;ArB2/WJ;AqBz/WI;;;;;;;;;EAGE,WAAA;EACA,yBAAA;EACA,qBAAA;ArBigXN;AqB3/WI;;;;;;;;;EAGE,yBAAA;EACA,qBAAA;ArBmgXN;AoGviXA;E/EyCI,cAAA;EACA,sBAAA;ArBigXJ;AoGxiXA;E/ELE,WAAA;EACA,yBAAA;EACA,qBAAA;ArBgjXF;AqB9iXE;;EAEE,WAAA;EACA,yBAAA;EACA,qBAAA;ArBgjXJ;AqB9iXE;EACE,WAAA;EACA,yBAAA;EACA,qBAAA;ArBgjXJ;AqB9iXE;;;EAGE,WAAA;EACA,yBAAA;EACA,sBAAA;EACA,qBAAA;ArBgjXJ;AqB9iXI;;;;;;;;;EAGE,WAAA;EACA,yBAAA;EACA,qBAAA;ArBsjXN;AqBhjXI;;;;;;;;;EAGE,yBAAA;EACA,qBAAA;ArBwjXN;AoGzlXA;E/EsCI,cAAA;EACA,sBAAA;ArBsjXJ;AoG1lXA;E/ERE,WAAA;EACA,yBAAA;EACA,qBAAA;ArBqmXF;AqBnmXE;;EAEE,WAAA;EACA,yBAAA;EACA,qBAAA;ArBqmXJ;AqBnmXE;EACE,WAAA;EACA,yBAAA;EACA,qBAAA;ArBqmXJ;AqBnmXE;;;EAGE,WAAA;EACA,yBAAA;EACA,sBAAA;EACA,qBAAA;ArBqmXJ;AqBnmXI;;;;;;;;;EAGE,WAAA;EACA,yBAAA;EACA,qBAAA;ArB2mXN;AqBrmXI;;;;;;;;;EAGE,yBAAA;EACA,qBAAA;ArB6mXN;AoG3oXA;E/EmCI,cAAA;EACA,sBAAA;ArB2mXJ;AoG5oXA;E/EXE,WAAA;EACA,yBAAA;EACA,qBAAA;EgFLE,cAAA;EACA,yBAAA;EACA,qBAAA;ArGgqXJ;AqB3pXE;;EAEE,WAAA;EACA,yBAAA;EACA,qBAAA;ArB6pXJ;AqB3pXE;EACE,WAAA;EACA,yBAAA;EACA,qBAAA;ArB6pXJ;AqB3pXE;;;EAGE,WAAA;EACA,yBAAA;EACA,sBAAA;EACA,qBAAA;ArB6pXJ;AqB3pXI;;;;;;;;;EAGE,WAAA;EACA,yBAAA;EACA,qBAAA;ArBmqXN;AqB7pXI;;;;;;;;;EAGE,yBAAA;EACA,qBAAA;ArBqqXN;AoGhsXA;E/EgCI,cAAA;EACA,sBAAA;ArBmqXJ;AsGrtXA;EACI,gCAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;EACA,eAAA;EACA,WAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EjG4DF,0DAAA;EACQ,kDAAA;EL4pXR,4BAA4B;EsGptX1B,YAAA;EtGstXF,+DAA+D;EsGntX7D,oBAAA;AtGqtXJ;AsGvuXA;EAqBQ,sBAAA;EACA,YAAA;EACA,0CAAA;EACA,cAAA;AtGqtXR;AsG7uXA;EA4BQ,kBAAA;EACA,QAAA;EACA,WAAA;AtGotXR;AsGlvXA;EAkCQ,gBAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;AtGmtXR;AsGxvXA;EAyCQ,kBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;AtGktXR;AsG9vXA;EA+CY,kBAAA;EACA,iBAAA;EvB7CR,sBAAA;EACA,2BAAA;EACA,8BAAA;A/EgwXJ;AsGrwXA;EAsDQ,QAAA;EACA,WAAA;EACA,oCAAA;EACA,+CAAA;EACA,kDAAA;EtGktXN;4BAC0B;AAC5B;AsGhtXQ;EACI,WAAA;EAEA,QAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EAEA,+CAAA;AtGgtXZ;AuGxxXA;EvG0xXE,iBAAiB;EgFpwXf,oBAAA;EACA,8BAAA;EACA,0BAAA;EAEA,iBAAA;EACA,2BAAA;EACA,uBAAA;EAEA,YAAA;EACA,sBAAA;EACA,kBAAA;EhFowXF,oBAAoB;EgFjwXlB,aAAA;EACA,mBAAA;EACA,oBAAA;EuBnCA,kBAAA;AvGuyXJ;AuGryXA;EACI,qBAAA;EACA,WAAA;EACA,iBAAA;EACA,sBAAA;AvGuyXJ;AuGpyXA;EACI,qBAAA;EvGsyXF,iBAAiB;EgFrsXf,mBAAA;EACA,gBAAA;EACA,WAAA;EhFusXF,oBAAoB;EgFpsXlB,OAAA;AhFssXJ;AwGxzXA;EACI,YAAA;EACA,eAAA;EACA,aAAA;EACA,uBAAA;EACA,qBAAA;EACA,UAAA;EACA,OAAA;EACA,cAAA;AxG0zXJ;AwGl0XA;EAWQ,YAAA;EACA,gBAAA;EACA,iBAAA;EACA,YAAA;EACA,iBAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;EzBTJ,kBAAA;A/Eo0XJ;AwG1zXQ;EAGI,yCAAA;AxG0zXZ;AwGpzXA;EvEXE,uBAAA;ECCY,YAAA;AlCk0Xd;AwGpzXA;EAEQ,cAAA;EACA,kBAAA;AxGqzXR;AwGjzXA;;EACI,gBAAA;EACA,mBAAA;EACA,cAAA;AxGozXJ;AwGjzXA;EACI;IACI,gBAAA;IACA,kBAAA;ExGmzXN;EwGjzXE;;IACI,aAAA;ExGozXN;AACF;AwGjzXA;EACI;IACI,aAAA;ExGmzXN;EwGjzXE;IACI,kBAAA;ExGmzXN;AACF;AyG92XA;EACI,YAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;E1BHA,sBAAA;EACA,2BAAA;EACA,8BAAA;A/Eo3XJ;AyGv3XA;;EAOQ,WAAA;EACA,sBAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;AzGo3XR;AyGp4XA;EAmBQ,gBAAA;AzGo3XR;AyG92XA;EACE,eAAA;EACA,gBAAA;AzGg3XF;AyG72XA;EACE,gBAAA;AzG+2XF;AyG52XA;EACE,mBAAA;EACA,gBAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;AzG82XF;AyGr3XA;EAUI,WAAA;EACA,sBAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;AzG82XJ;AyG12XA;EACE,YAAA;AzG42XF;AyGz2XA;;EACI,YAAA;AzG42XJ;AyGx2XA;;;;EACI,yBAAA;EACA,YAAA;AzG62XJ;AACA;;;;EAIE;AACF;;;GAGG;AACH;;;;EAIE;A0Gj5XF;EACE;IACE,UAAA;E1Gm5XF;E0Gj5XA;IACE,UAAA;E1Gm5XF;AACF;A0Gh5XA;EACE;IACE,UAAA;E1Gk5XF;E0Gh5XA;IACE,UAAA;E1Gk5XF;AACF;A0G/4XA;EACE;IACE,UAAA;E1Gi5XF;E0G/4XA;IACE,UAAA;E1Gi5XF;AACF;A0G94XA;EACE;IACE,UAAA;E1Gg5XF;E0G94XA;IACE,UAAA;E1Gg5XF;AACF;AACA,uCAAuC;A0G74XvC;EACE,cAAA;EACA,aAAA;A1G+4XF;AACA,wCAAwC;A0G34XxC;EAEE,uBAAA;EACA,gBAAA;EACA,YAAA;A1G44XF;A0Gz4XA;EACE,kBAAA;EACA,mBAAA;EACA,QAAA;EACA,UAAA;A1G24XF;A0Gx4XA;EACE,gBAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;A1G04XF;A0Gv4XA;E1Gy4XE,gDAAgD;E0Gv4XhD,mBAAA;E1Gy4XA,oDAAoD;E0Gv4XpD,gBAAA;A1Gy4XF;A0Gt4XA;EACE,gBAAA;E1Gw4XA,kCAAkC;E0Gt4XlC,gCAAA;EACA,6BAAA;EACA,wBAAA;EACA,+BAAA;EACA,4BAAA;EACA,uBAAA;EACA,sBAAA;EACA,0CAAA;EAEA,iBAAA;EACA,qCAAA;EACA,aAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;EACA,sBAAA;EACA,gBAAA;EA7GA,0CAAA;EACA,6CAAA;EACA,qCAAA;E3BnBE,kBAAA;E2BsIF,kBAAA;EAEA,aAAA;A1Gm4XF;A0Gh6XA;EAyBI,YAAA;A1G04XJ;A0Gn6XA;EAiCM,SAAA;E3BxIJ,gBAAA;E2B0II,eAAA;EACA,0CAAA;A1Gq4XN;A0Gh4XA;EACE,SAAA;EACA,WAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;A1Gk4XF;A0G/3XA;EACE,0CAAA;EACA,qCAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EAEA,gCAAA;EACA,6BAAA;EACA,4BAAA;EACA,2BAAA;A1Gg4XF;A2GrjYA;EACE,YAAA;A3GujYF;A2GpjYA;EACI,WAAA;A3GsjYJ;A2GnjYA;EACE,gBAAA;EACA,cAAA;A3GqjYF;A2GnjYI;E3GqjYF,kBAAkB;EAClB,uDAAuD;E2GnjYjD,mBAAA;A3GqjYR;A2GjjYA;E1ECE,sBAAA;ECDW,WAAA;AlCqjYb;A2GjjYA;EACI,iBAAA;A3GmjYJ;A2G/iYE;EACE,YAAA;A3GijYJ;A2G9iYE;EACE,iBAAA;A3GgjYJ;A2G7iYE;EACE,aAAA;A3G+iYJ;A2G3iYA;EACI,eAAA;EACA,kBAAA;A3G6iYJ;A2G1iYA;E1E1BE,sBAAA;ECDW,WAAA;AlCykYb;A2G1iYA;E1E9BE,sBAAA;ECDW,WAAA;AlC6kYb;A2G1iYA;EACI,yBAAA;EACA,kBAAA;EACA,cAAA;A3G4iYJ;A2GziYA;EACI,iBAAA;EACA,kBAAA;EACA,cAAA;A3G2iYJ;A2GxiYA;E1E9CE,sBAAA;ECDW,WAAA;AlC2lYb;A4G7mYA;;EAGI,yBAAA;EACA,qBAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;A5G8mYJ;A4G1mYE;EACE,iBAAA;A5G4mYJ;A4GzmYE;EACG,kBAAA;A5G2mYL;A4GtmYI;EAEE,yBAAA;EACA,qBAAA;EACA,kBAAA;A5GumYN;A4GnmYI;EACE,yBAAA;EACA,qBAAA;EACA,kBAAA;A5GqmYN;A4GroYA;EAsCI,gBAAA;EACA,cAAA;A5GkmYJ;A4GzoYA;EAyCQ,iBAAA;A5GmmYR;AqG3oYA;EACI,cAAA;EACA,yBAAA;EACA,qBAAA;ArG6oYJ;AqG1oYA;EACI,cAAA;EACA,yBAAA;EACA,qBAAA;ArG4oYJ;AqGvoYA;EACI,YAAA;EACA,iBAAA;EACA,iBAAA;EACA,cAAA;EACA,WAAA;EACA,yBAAA;E/ElBF,yBAAA;EACA,YAAA;AtB4pYF;AqGxoYI;;EAEE,WAAA;EACA,qBAAA;EACA,eAAA;E/EzBJ,0BAAA;EACA,UAAA;AtBoqYF;AqG1oYG;EACC,UAAA;EACA,eAAA;EACA,uBAAA;EACA,SAAA;EACA,wBAAA;EACA,gBAAA;ArG4oYJ;AqGxoYA;EAEM,cAAA;ArGyoYN;AqGtoYM;ErGwoYJ,yCAAyC;EqGtoYrC,0CAAA;ArGwoYN;A6GxrYA;EACE,kCAAA;EACA,kDAAA;A7G0rYF;A6GvrYA;EACE,iBAAA;A7GyrYF;A6GtrYA;EACE,eAAA;EACA,wBAAA;A7GwrYF;A6GrrYA;EACE,eAAA;EACA,cAAA;A7GurYF","sourcesContent":["/*!\n*\n* Twitter Bootstrap\n*\n*/\n/*!\n * Bootstrap v3.4.1 (https://getbootstrap.com/)\n * Copyright 2011-2019 Twitter, Inc.\n * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)\n */\n/*! normalize.css v3.0.3 | MIT License | github.com/necolas/normalize.css */\nhtml {\n  font-family: sans-serif;\n  -ms-text-size-adjust: 100%;\n  -webkit-text-size-adjust: 100%;\n}\nbody {\n  margin: 0;\n}\narticle,\naside,\ndetails,\nfigcaption,\nfigure,\nfooter,\nheader,\nhgroup,\nmain,\nmenu,\nnav,\nsection,\nsummary {\n  display: block;\n}\naudio,\ncanvas,\nprogress,\nvideo {\n  display: inline-block;\n  vertical-align: baseline;\n}\naudio:not([controls]) {\n  display: none;\n  height: 0;\n}\n[hidden],\ntemplate {\n  display: none;\n}\na {\n  background-color: transparent;\n}\na:active,\na:hover {\n  outline: 0;\n}\nabbr[title] {\n  border-bottom: none;\n  text-decoration: underline;\n  text-decoration: underline dotted;\n}\nb,\nstrong {\n  font-weight: bold;\n}\ndfn {\n  font-style: italic;\n}\nh1 {\n  font-size: 2em;\n  margin: 0.67em 0;\n}\nmark {\n  background: #ff0;\n  color: #000;\n}\nsmall {\n  font-size: 80%;\n}\nsub,\nsup {\n  font-size: 75%;\n  line-height: 0;\n  position: relative;\n  vertical-align: baseline;\n}\nsup {\n  top: -0.5em;\n}\nsub {\n  bottom: -0.25em;\n}\nimg {\n  border: 0;\n}\nsvg:not(:root) {\n  overflow: hidden;\n}\nfigure {\n  margin: 1em 40px;\n}\nhr {\n  box-sizing: content-box;\n  height: 0;\n}\npre {\n  overflow: auto;\n}\ncode,\nkbd,\npre,\nsamp {\n  font-family: monospace, monospace;\n  font-size: 1em;\n}\nbutton,\ninput,\noptgroup,\nselect,\ntextarea {\n  color: inherit;\n  font: inherit;\n  margin: 0;\n}\nbutton {\n  overflow: visible;\n}\nbutton,\nselect {\n  text-transform: none;\n}\nbutton,\nhtml input[type=\"button\"],\ninput[type=\"reset\"],\ninput[type=\"submit\"] {\n  -webkit-appearance: button;\n  cursor: pointer;\n}\nbutton[disabled],\nhtml input[disabled] {\n  cursor: default;\n}\nbutton::-moz-focus-inner,\ninput::-moz-focus-inner {\n  border: 0;\n  padding: 0;\n}\ninput {\n  line-height: normal;\n}\ninput[type=\"checkbox\"],\ninput[type=\"radio\"] {\n  box-sizing: border-box;\n  padding: 0;\n}\ninput[type=\"number\"]::-webkit-inner-spin-button,\ninput[type=\"number\"]::-webkit-outer-spin-button {\n  height: auto;\n}\ninput[type=\"search\"] {\n  -webkit-appearance: textfield;\n  box-sizing: content-box;\n}\ninput[type=\"search\"]::-webkit-search-cancel-button,\ninput[type=\"search\"]::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\nfieldset {\n  border: 1px solid #c0c0c0;\n  margin: 0 2px;\n  padding: 0.35em 0.625em 0.75em;\n}\nlegend {\n  border: 0;\n  padding: 0;\n}\ntextarea {\n  overflow: auto;\n}\noptgroup {\n  font-weight: bold;\n}\ntable {\n  border-collapse: collapse;\n  border-spacing: 0;\n}\ntd,\nth {\n  padding: 0;\n}\n/*! Source: https://github.com/h5bp/html5-boilerplate/blob/master/src/css/main.css */\n@media print {\n  *,\n  *:before,\n  *:after {\n    color: #000 !important;\n    text-shadow: none !important;\n    background: transparent !important;\n    box-shadow: none !important;\n  }\n  a,\n  a:visited {\n    text-decoration: underline;\n  }\n  a[href]:after {\n    content: \" (\" attr(href) \")\";\n  }\n  abbr[title]:after {\n    content: \" (\" attr(title) \")\";\n  }\n  a[href^=\"#\"]:after,\n  a[href^=\"javascript:\"]:after {\n    content: \"\";\n  }\n  pre,\n  blockquote {\n    border: 1px solid #999;\n    page-break-inside: avoid;\n  }\n  thead {\n    display: table-header-group;\n  }\n  tr,\n  img {\n    page-break-inside: avoid;\n  }\n  img {\n    max-width: 100% !important;\n  }\n  p,\n  h2,\n  h3 {\n    orphans: 3;\n    widows: 3;\n  }\n  h2,\n  h3 {\n    page-break-after: avoid;\n  }\n  .navbar {\n    display: none;\n  }\n  .btn > .caret,\n  .dropup > .btn > .caret {\n    border-top-color: #000 !important;\n  }\n  .label {\n    border: 1px solid #000;\n  }\n  .table {\n    border-collapse: collapse !important;\n  }\n  .table td,\n  .table th {\n    background-color: #fff !important;\n  }\n  .table-bordered th,\n  .table-bordered td {\n    border: 1px solid #ddd !important;\n  }\n}\n@font-face {\n  font-family: \"Glyphicons Halflings\";\n  src: url(\"../../node_modules/bootstrap/less/~bootstrap/fonts/glyphicons-halflings-regular.eot\");\n  src: url(\"../../node_modules/bootstrap/less/~bootstrap/fonts/glyphicons-halflings-regular.eot?#iefix\") format(\"embedded-opentype\"), url(\"../../node_modules/bootstrap/less/~bootstrap/fonts/glyphicons-halflings-regular.woff2\") format(\"woff2\"), url(\"../../node_modules/bootstrap/less/~bootstrap/fonts/glyphicons-halflings-regular.woff\") format(\"woff\"), url(\"../../node_modules/bootstrap/less/~bootstrap/fonts/glyphicons-halflings-regular.ttf\") format(\"truetype\"), url(\"../../node_modules/bootstrap/less/~bootstrap/fonts/glyphicons-halflings-regular.svg#glyphicons_halflingsregular\") format(\"svg\");\n}\n.glyphicon {\n  position: relative;\n  top: 1px;\n  display: inline-block;\n  font-family: \"Glyphicons Halflings\";\n  font-style: normal;\n  font-weight: 400;\n  line-height: 1;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n.glyphicon-asterisk:before {\n  content: \"\\002a\";\n}\n.glyphicon-plus:before {\n  content: \"\\002b\";\n}\n.glyphicon-euro:before,\n.glyphicon-eur:before {\n  content: \"\\20ac\";\n}\n.glyphicon-minus:before {\n  content: \"\\2212\";\n}\n.glyphicon-cloud:before {\n  content: \"\\2601\";\n}\n.glyphicon-envelope:before {\n  content: \"\\2709\";\n}\n.glyphicon-pencil:before {\n  content: \"\\270f\";\n}\n.glyphicon-glass:before {\n  content: \"\\e001\";\n}\n.glyphicon-music:before {\n  content: \"\\e002\";\n}\n.glyphicon-search:before {\n  content: \"\\e003\";\n}\n.glyphicon-heart:before {\n  content: \"\\e005\";\n}\n.glyphicon-star:before {\n  content: \"\\e006\";\n}\n.glyphicon-star-empty:before {\n  content: \"\\e007\";\n}\n.glyphicon-user:before {\n  content: \"\\e008\";\n}\n.glyphicon-film:before {\n  content: \"\\e009\";\n}\n.glyphicon-th-large:before {\n  content: \"\\e010\";\n}\n.glyphicon-th:before {\n  content: \"\\e011\";\n}\n.glyphicon-th-list:before {\n  content: \"\\e012\";\n}\n.glyphicon-ok:before {\n  content: \"\\e013\";\n}\n.glyphicon-remove:before {\n  content: \"\\e014\";\n}\n.glyphicon-zoom-in:before {\n  content: \"\\e015\";\n}\n.glyphicon-zoom-out:before {\n  content: \"\\e016\";\n}\n.glyphicon-off:before {\n  content: \"\\e017\";\n}\n.glyphicon-signal:before {\n  content: \"\\e018\";\n}\n.glyphicon-cog:before {\n  content: \"\\e019\";\n}\n.glyphicon-trash:before {\n  content: \"\\e020\";\n}\n.glyphicon-home:before {\n  content: \"\\e021\";\n}\n.glyphicon-file:before {\n  content: \"\\e022\";\n}\n.glyphicon-time:before {\n  content: \"\\e023\";\n}\n.glyphicon-road:before {\n  content: \"\\e024\";\n}\n.glyphicon-download-alt:before {\n  content: \"\\e025\";\n}\n.glyphicon-download:before {\n  content: \"\\e026\";\n}\n.glyphicon-upload:before {\n  content: \"\\e027\";\n}\n.glyphicon-inbox:before {\n  content: \"\\e028\";\n}\n.glyphicon-play-circle:before {\n  content: \"\\e029\";\n}\n.glyphicon-repeat:before {\n  content: \"\\e030\";\n}\n.glyphicon-refresh:before {\n  content: \"\\e031\";\n}\n.glyphicon-list-alt:before {\n  content: \"\\e032\";\n}\n.glyphicon-lock:before {\n  content: \"\\e033\";\n}\n.glyphicon-flag:before {\n  content: \"\\e034\";\n}\n.glyphicon-headphones:before {\n  content: \"\\e035\";\n}\n.glyphicon-volume-off:before {\n  content: \"\\e036\";\n}\n.glyphicon-volume-down:before {\n  content: \"\\e037\";\n}\n.glyphicon-volume-up:before {\n  content: \"\\e038\";\n}\n.glyphicon-qrcode:before {\n  content: \"\\e039\";\n}\n.glyphicon-barcode:before {\n  content: \"\\e040\";\n}\n.glyphicon-tag:before {\n  content: \"\\e041\";\n}\n.glyphicon-tags:before {\n  content: \"\\e042\";\n}\n.glyphicon-book:before {\n  content: \"\\e043\";\n}\n.glyphicon-bookmark:before {\n  content: \"\\e044\";\n}\n.glyphicon-print:before {\n  content: \"\\e045\";\n}\n.glyphicon-camera:before {\n  content: \"\\e046\";\n}\n.glyphicon-font:before {\n  content: \"\\e047\";\n}\n.glyphicon-bold:before {\n  content: \"\\e048\";\n}\n.glyphicon-italic:before {\n  content: \"\\e049\";\n}\n.glyphicon-text-height:before {\n  content: \"\\e050\";\n}\n.glyphicon-text-width:before {\n  content: \"\\e051\";\n}\n.glyphicon-align-left:before {\n  content: \"\\e052\";\n}\n.glyphicon-align-center:before {\n  content: \"\\e053\";\n}\n.glyphicon-align-right:before {\n  content: \"\\e054\";\n}\n.glyphicon-align-justify:before {\n  content: \"\\e055\";\n}\n.glyphicon-list:before {\n  content: \"\\e056\";\n}\n.glyphicon-indent-left:before {\n  content: \"\\e057\";\n}\n.glyphicon-indent-right:before {\n  content: \"\\e058\";\n}\n.glyphicon-facetime-video:before {\n  content: \"\\e059\";\n}\n.glyphicon-picture:before {\n  content: \"\\e060\";\n}\n.glyphicon-map-marker:before {\n  content: \"\\e062\";\n}\n.glyphicon-adjust:before {\n  content: \"\\e063\";\n}\n.glyphicon-tint:before {\n  content: \"\\e064\";\n}\n.glyphicon-edit:before {\n  content: \"\\e065\";\n}\n.glyphicon-share:before {\n  content: \"\\e066\";\n}\n.glyphicon-check:before {\n  content: \"\\e067\";\n}\n.glyphicon-move:before {\n  content: \"\\e068\";\n}\n.glyphicon-step-backward:before {\n  content: \"\\e069\";\n}\n.glyphicon-fast-backward:before {\n  content: \"\\e070\";\n}\n.glyphicon-backward:before {\n  content: \"\\e071\";\n}\n.glyphicon-play:before {\n  content: \"\\e072\";\n}\n.glyphicon-pause:before {\n  content: \"\\e073\";\n}\n.glyphicon-stop:before {\n  content: \"\\e074\";\n}\n.glyphicon-forward:before {\n  content: \"\\e075\";\n}\n.glyphicon-fast-forward:before {\n  content: \"\\e076\";\n}\n.glyphicon-step-forward:before {\n  content: \"\\e077\";\n}\n.glyphicon-eject:before {\n  content: \"\\e078\";\n}\n.glyphicon-chevron-left:before {\n  content: \"\\e079\";\n}\n.glyphicon-chevron-right:before {\n  content: \"\\e080\";\n}\n.glyphicon-plus-sign:before {\n  content: \"\\e081\";\n}\n.glyphicon-minus-sign:before {\n  content: \"\\e082\";\n}\n.glyphicon-remove-sign:before {\n  content: \"\\e083\";\n}\n.glyphicon-ok-sign:before {\n  content: \"\\e084\";\n}\n.glyphicon-question-sign:before {\n  content: \"\\e085\";\n}\n.glyphicon-info-sign:before {\n  content: \"\\e086\";\n}\n.glyphicon-screenshot:before {\n  content: \"\\e087\";\n}\n.glyphicon-remove-circle:before {\n  content: \"\\e088\";\n}\n.glyphicon-ok-circle:before {\n  content: \"\\e089\";\n}\n.glyphicon-ban-circle:before {\n  content: \"\\e090\";\n}\n.glyphicon-arrow-left:before {\n  content: \"\\e091\";\n}\n.glyphicon-arrow-right:before {\n  content: \"\\e092\";\n}\n.glyphicon-arrow-up:before {\n  content: \"\\e093\";\n}\n.glyphicon-arrow-down:before {\n  content: \"\\e094\";\n}\n.glyphicon-share-alt:before {\n  content: \"\\e095\";\n}\n.glyphicon-resize-full:before {\n  content: \"\\e096\";\n}\n.glyphicon-resize-small:before {\n  content: \"\\e097\";\n}\n.glyphicon-exclamation-sign:before {\n  content: \"\\e101\";\n}\n.glyphicon-gift:before {\n  content: \"\\e102\";\n}\n.glyphicon-leaf:before {\n  content: \"\\e103\";\n}\n.glyphicon-fire:before {\n  content: \"\\e104\";\n}\n.glyphicon-eye-open:before {\n  content: \"\\e105\";\n}\n.glyphicon-eye-close:before {\n  content: \"\\e106\";\n}\n.glyphicon-warning-sign:before {\n  content: \"\\e107\";\n}\n.glyphicon-plane:before {\n  content: \"\\e108\";\n}\n.glyphicon-calendar:before {\n  content: \"\\e109\";\n}\n.glyphicon-random:before {\n  content: \"\\e110\";\n}\n.glyphicon-comment:before {\n  content: \"\\e111\";\n}\n.glyphicon-magnet:before {\n  content: \"\\e112\";\n}\n.glyphicon-chevron-up:before {\n  content: \"\\e113\";\n}\n.glyphicon-chevron-down:before {\n  content: \"\\e114\";\n}\n.glyphicon-retweet:before {\n  content: \"\\e115\";\n}\n.glyphicon-shopping-cart:before {\n  content: \"\\e116\";\n}\n.glyphicon-folder-close:before {\n  content: \"\\e117\";\n}\n.glyphicon-folder-open:before {\n  content: \"\\e118\";\n}\n.glyphicon-resize-vertical:before {\n  content: \"\\e119\";\n}\n.glyphicon-resize-horizontal:before {\n  content: \"\\e120\";\n}\n.glyphicon-hdd:before {\n  content: \"\\e121\";\n}\n.glyphicon-bullhorn:before {\n  content: \"\\e122\";\n}\n.glyphicon-bell:before {\n  content: \"\\e123\";\n}\n.glyphicon-certificate:before {\n  content: \"\\e124\";\n}\n.glyphicon-thumbs-up:before {\n  content: \"\\e125\";\n}\n.glyphicon-thumbs-down:before {\n  content: \"\\e126\";\n}\n.glyphicon-hand-right:before {\n  content: \"\\e127\";\n}\n.glyphicon-hand-left:before {\n  content: \"\\e128\";\n}\n.glyphicon-hand-up:before {\n  content: \"\\e129\";\n}\n.glyphicon-hand-down:before {\n  content: \"\\e130\";\n}\n.glyphicon-circle-arrow-right:before {\n  content: \"\\e131\";\n}\n.glyphicon-circle-arrow-left:before {\n  content: \"\\e132\";\n}\n.glyphicon-circle-arrow-up:before {\n  content: \"\\e133\";\n}\n.glyphicon-circle-arrow-down:before {\n  content: \"\\e134\";\n}\n.glyphicon-globe:before {\n  content: \"\\e135\";\n}\n.glyphicon-wrench:before {\n  content: \"\\e136\";\n}\n.glyphicon-tasks:before {\n  content: \"\\e137\";\n}\n.glyphicon-filter:before {\n  content: \"\\e138\";\n}\n.glyphicon-briefcase:before {\n  content: \"\\e139\";\n}\n.glyphicon-fullscreen:before {\n  content: \"\\e140\";\n}\n.glyphicon-dashboard:before {\n  content: \"\\e141\";\n}\n.glyphicon-paperclip:before {\n  content: \"\\e142\";\n}\n.glyphicon-heart-empty:before {\n  content: \"\\e143\";\n}\n.glyphicon-link:before {\n  content: \"\\e144\";\n}\n.glyphicon-phone:before {\n  content: \"\\e145\";\n}\n.glyphicon-pushpin:before {\n  content: \"\\e146\";\n}\n.glyphicon-usd:before {\n  content: \"\\e148\";\n}\n.glyphicon-gbp:before {\n  content: \"\\e149\";\n}\n.glyphicon-sort:before {\n  content: \"\\e150\";\n}\n.glyphicon-sort-by-alphabet:before {\n  content: \"\\e151\";\n}\n.glyphicon-sort-by-alphabet-alt:before {\n  content: \"\\e152\";\n}\n.glyphicon-sort-by-order:before {\n  content: \"\\e153\";\n}\n.glyphicon-sort-by-order-alt:before {\n  content: \"\\e154\";\n}\n.glyphicon-sort-by-attributes:before {\n  content: \"\\e155\";\n}\n.glyphicon-sort-by-attributes-alt:before {\n  content: \"\\e156\";\n}\n.glyphicon-unchecked:before {\n  content: \"\\e157\";\n}\n.glyphicon-expand:before {\n  content: \"\\e158\";\n}\n.glyphicon-collapse-down:before {\n  content: \"\\e159\";\n}\n.glyphicon-collapse-up:before {\n  content: \"\\e160\";\n}\n.glyphicon-log-in:before {\n  content: \"\\e161\";\n}\n.glyphicon-flash:before {\n  content: \"\\e162\";\n}\n.glyphicon-log-out:before {\n  content: \"\\e163\";\n}\n.glyphicon-new-window:before {\n  content: \"\\e164\";\n}\n.glyphicon-record:before {\n  content: \"\\e165\";\n}\n.glyphicon-save:before {\n  content: \"\\e166\";\n}\n.glyphicon-open:before {\n  content: \"\\e167\";\n}\n.glyphicon-saved:before {\n  content: \"\\e168\";\n}\n.glyphicon-import:before {\n  content: \"\\e169\";\n}\n.glyphicon-export:before {\n  content: \"\\e170\";\n}\n.glyphicon-send:before {\n  content: \"\\e171\";\n}\n.glyphicon-floppy-disk:before {\n  content: \"\\e172\";\n}\n.glyphicon-floppy-saved:before {\n  content: \"\\e173\";\n}\n.glyphicon-floppy-remove:before {\n  content: \"\\e174\";\n}\n.glyphicon-floppy-save:before {\n  content: \"\\e175\";\n}\n.glyphicon-floppy-open:before {\n  content: \"\\e176\";\n}\n.glyphicon-credit-card:before {\n  content: \"\\e177\";\n}\n.glyphicon-transfer:before {\n  content: \"\\e178\";\n}\n.glyphicon-cutlery:before {\n  content: \"\\e179\";\n}\n.glyphicon-header:before {\n  content: \"\\e180\";\n}\n.glyphicon-compressed:before {\n  content: \"\\e181\";\n}\n.glyphicon-earphone:before {\n  content: \"\\e182\";\n}\n.glyphicon-phone-alt:before {\n  content: \"\\e183\";\n}\n.glyphicon-tower:before {\n  content: \"\\e184\";\n}\n.glyphicon-stats:before {\n  content: \"\\e185\";\n}\n.glyphicon-sd-video:before {\n  content: \"\\e186\";\n}\n.glyphicon-hd-video:before {\n  content: \"\\e187\";\n}\n.glyphicon-subtitles:before {\n  content: \"\\e188\";\n}\n.glyphicon-sound-stereo:before {\n  content: \"\\e189\";\n}\n.glyphicon-sound-dolby:before {\n  content: \"\\e190\";\n}\n.glyphicon-sound-5-1:before {\n  content: \"\\e191\";\n}\n.glyphicon-sound-6-1:before {\n  content: \"\\e192\";\n}\n.glyphicon-sound-7-1:before {\n  content: \"\\e193\";\n}\n.glyphicon-copyright-mark:before {\n  content: \"\\e194\";\n}\n.glyphicon-registration-mark:before {\n  content: \"\\e195\";\n}\n.glyphicon-cloud-download:before {\n  content: \"\\e197\";\n}\n.glyphicon-cloud-upload:before {\n  content: \"\\e198\";\n}\n.glyphicon-tree-conifer:before {\n  content: \"\\e199\";\n}\n.glyphicon-tree-deciduous:before {\n  content: \"\\e200\";\n}\n.glyphicon-cd:before {\n  content: \"\\e201\";\n}\n.glyphicon-save-file:before {\n  content: \"\\e202\";\n}\n.glyphicon-open-file:before {\n  content: \"\\e203\";\n}\n.glyphicon-level-up:before {\n  content: \"\\e204\";\n}\n.glyphicon-copy:before {\n  content: \"\\e205\";\n}\n.glyphicon-paste:before {\n  content: \"\\e206\";\n}\n.glyphicon-alert:before {\n  content: \"\\e209\";\n}\n.glyphicon-equalizer:before {\n  content: \"\\e210\";\n}\n.glyphicon-king:before {\n  content: \"\\e211\";\n}\n.glyphicon-queen:before {\n  content: \"\\e212\";\n}\n.glyphicon-pawn:before {\n  content: \"\\e213\";\n}\n.glyphicon-bishop:before {\n  content: \"\\e214\";\n}\n.glyphicon-knight:before {\n  content: \"\\e215\";\n}\n.glyphicon-baby-formula:before {\n  content: \"\\e216\";\n}\n.glyphicon-tent:before {\n  content: \"\\26fa\";\n}\n.glyphicon-blackboard:before {\n  content: \"\\e218\";\n}\n.glyphicon-bed:before {\n  content: \"\\e219\";\n}\n.glyphicon-apple:before {\n  content: \"\\f8ff\";\n}\n.glyphicon-erase:before {\n  content: \"\\e221\";\n}\n.glyphicon-hourglass:before {\n  content: \"\\231b\";\n}\n.glyphicon-lamp:before {\n  content: \"\\e223\";\n}\n.glyphicon-duplicate:before {\n  content: \"\\e224\";\n}\n.glyphicon-piggy-bank:before {\n  content: \"\\e225\";\n}\n.glyphicon-scissors:before {\n  content: \"\\e226\";\n}\n.glyphicon-bitcoin:before {\n  content: \"\\e227\";\n}\n.glyphicon-btc:before {\n  content: \"\\e227\";\n}\n.glyphicon-xbt:before {\n  content: \"\\e227\";\n}\n.glyphicon-yen:before {\n  content: \"\\00a5\";\n}\n.glyphicon-jpy:before {\n  content: \"\\00a5\";\n}\n.glyphicon-ruble:before {\n  content: \"\\20bd\";\n}\n.glyphicon-rub:before {\n  content: \"\\20bd\";\n}\n.glyphicon-scale:before {\n  content: \"\\e230\";\n}\n.glyphicon-ice-lolly:before {\n  content: \"\\e231\";\n}\n.glyphicon-ice-lolly-tasted:before {\n  content: \"\\e232\";\n}\n.glyphicon-education:before {\n  content: \"\\e233\";\n}\n.glyphicon-option-horizontal:before {\n  content: \"\\e234\";\n}\n.glyphicon-option-vertical:before {\n  content: \"\\e235\";\n}\n.glyphicon-menu-hamburger:before {\n  content: \"\\e236\";\n}\n.glyphicon-modal-window:before {\n  content: \"\\e237\";\n}\n.glyphicon-oil:before {\n  content: \"\\e238\";\n}\n.glyphicon-grain:before {\n  content: \"\\e239\";\n}\n.glyphicon-sunglasses:before {\n  content: \"\\e240\";\n}\n.glyphicon-text-size:before {\n  content: \"\\e241\";\n}\n.glyphicon-text-color:before {\n  content: \"\\e242\";\n}\n.glyphicon-text-background:before {\n  content: \"\\e243\";\n}\n.glyphicon-object-align-top:before {\n  content: \"\\e244\";\n}\n.glyphicon-object-align-bottom:before {\n  content: \"\\e245\";\n}\n.glyphicon-object-align-horizontal:before {\n  content: \"\\e246\";\n}\n.glyphicon-object-align-left:before {\n  content: \"\\e247\";\n}\n.glyphicon-object-align-vertical:before {\n  content: \"\\e248\";\n}\n.glyphicon-object-align-right:before {\n  content: \"\\e249\";\n}\n.glyphicon-triangle-right:before {\n  content: \"\\e250\";\n}\n.glyphicon-triangle-left:before {\n  content: \"\\e251\";\n}\n.glyphicon-triangle-bottom:before {\n  content: \"\\e252\";\n}\n.glyphicon-triangle-top:before {\n  content: \"\\e253\";\n}\n.glyphicon-console:before {\n  content: \"\\e254\";\n}\n.glyphicon-superscript:before {\n  content: \"\\e255\";\n}\n.glyphicon-subscript:before {\n  content: \"\\e256\";\n}\n.glyphicon-menu-left:before {\n  content: \"\\e257\";\n}\n.glyphicon-menu-right:before {\n  content: \"\\e258\";\n}\n.glyphicon-menu-down:before {\n  content: \"\\e259\";\n}\n.glyphicon-menu-up:before {\n  content: \"\\e260\";\n}\n* {\n  -webkit-box-sizing: border-box;\n  -moz-box-sizing: border-box;\n  box-sizing: border-box;\n}\n*:before,\n*:after {\n  -webkit-box-sizing: border-box;\n  -moz-box-sizing: border-box;\n  box-sizing: border-box;\n}\nhtml {\n  font-size: 10px;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\nbody {\n  font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  font-size: 13px;\n  line-height: 1.42857143;\n  color: black;\n  background-color: var(--body-bg);\n}\ninput,\nbutton,\nselect,\ntextarea {\n  font-family: inherit;\n  font-size: inherit;\n  line-height: inherit;\n}\na {\n  color: #296eaa;\n  text-decoration: none;\n}\na:hover,\na:focus {\n  color: #1a466c;\n  text-decoration: underline;\n}\na:focus {\n  outline: 5px auto -webkit-focus-ring-color;\n  outline-offset: -2px;\n}\nfigure {\n  margin: 0;\n}\nimg {\n  vertical-align: middle;\n}\n.img-responsive,\n.thumbnail > img,\n.thumbnail a > img,\n.carousel-inner > .item > img,\n.carousel-inner > .item > a > img {\n  display: block;\n  max-width: 100%;\n  height: auto;\n}\n.img-rounded {\n  border-radius: 3px;\n}\n.img-thumbnail {\n  padding: 4px;\n  line-height: 1.42857143;\n  background-color: var(--body-bg);\n  border: 1px solid #ddd;\n  border-radius: 2px;\n  -webkit-transition: all 0.2s ease-in-out;\n  -o-transition: all 0.2s ease-in-out;\n  transition: all 0.2s ease-in-out;\n  display: inline-block;\n  max-width: 100%;\n  height: auto;\n}\n.img-circle {\n  border-radius: 50%;\n}\nhr {\n  margin-top: 18px;\n  margin-bottom: 18px;\n  border: 0;\n  border-top: 1px solid #eeeeee;\n}\n.sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  border: 0;\n}\n.sr-only-focusable:active,\n.sr-only-focusable:focus {\n  position: static;\n  width: auto;\n  height: auto;\n  margin: 0;\n  overflow: visible;\n  clip: auto;\n}\n[role=\"button\"] {\n  cursor: pointer;\n}\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\n.h1,\n.h2,\n.h3,\n.h4,\n.h5,\n.h6 {\n  font-family: inherit;\n  font-weight: 500;\n  line-height: 1.1;\n  color: inherit;\n}\nh1 small,\nh2 small,\nh3 small,\nh4 small,\nh5 small,\nh6 small,\n.h1 small,\n.h2 small,\n.h3 small,\n.h4 small,\n.h5 small,\n.h6 small,\nh1 .small,\nh2 .small,\nh3 .small,\nh4 .small,\nh5 .small,\nh6 .small,\n.h1 .small,\n.h2 .small,\n.h3 .small,\n.h4 .small,\n.h5 .small,\n.h6 .small {\n  font-weight: 400;\n  line-height: 1;\n  color: #777777;\n}\nh1,\n.h1,\nh2,\n.h2,\nh3,\n.h3 {\n  margin-top: 18px;\n  margin-bottom: 9px;\n}\nh1 small,\n.h1 small,\nh2 small,\n.h2 small,\nh3 small,\n.h3 small,\nh1 .small,\n.h1 .small,\nh2 .small,\n.h2 .small,\nh3 .small,\n.h3 .small {\n  font-size: 65%;\n}\nh4,\n.h4,\nh5,\n.h5,\nh6,\n.h6 {\n  margin-top: 9px;\n  margin-bottom: 9px;\n}\nh4 small,\n.h4 small,\nh5 small,\n.h5 small,\nh6 small,\n.h6 small,\nh4 .small,\n.h4 .small,\nh5 .small,\n.h5 .small,\nh6 .small,\n.h6 .small {\n  font-size: 75%;\n}\nh1,\n.h1 {\n  font-size: 33px;\n}\nh2,\n.h2 {\n  font-size: 27px;\n}\nh3,\n.h3 {\n  font-size: 23px;\n}\nh4,\n.h4 {\n  font-size: 17px;\n}\nh5,\n.h5 {\n  font-size: 13px;\n}\nh6,\n.h6 {\n  font-size: 12px;\n}\np {\n  margin: 0 0 9px;\n}\n.lead {\n  margin-bottom: 18px;\n  font-size: 14px;\n  font-weight: 300;\n  line-height: 1.4;\n}\n@media (min-width: 768px) {\n  .lead {\n    font-size: 19.5px;\n  }\n}\nsmall,\n.small {\n  font-size: 92%;\n}\nmark,\n.mark {\n  padding: 0.2em;\n  background-color: #fcf8e3;\n}\n.text-left {\n  text-align: left;\n}\n.text-right {\n  text-align: right;\n}\n.text-center {\n  text-align: center;\n}\n.text-justify {\n  text-align: justify;\n}\n.text-nowrap {\n  white-space: nowrap;\n}\n.text-lowercase {\n  text-transform: lowercase;\n}\n.text-uppercase {\n  text-transform: uppercase;\n}\n.text-capitalize {\n  text-transform: capitalize;\n}\n.text-muted {\n  color: #777777;\n}\n.text-primary {\n  color: #337ab7;\n}\na.text-primary:hover,\na.text-primary:focus {\n  color: #286090;\n}\n.text-success {\n  color: #3c763d;\n}\na.text-success:hover,\na.text-success:focus {\n  color: #2b542c;\n}\n.text-info {\n  color: #31708f;\n}\na.text-info:hover,\na.text-info:focus {\n  color: #245269;\n}\n.text-warning {\n  color: #8a6d3b;\n}\na.text-warning:hover,\na.text-warning:focus {\n  color: #66512c;\n}\n.text-danger {\n  color: #a94442;\n}\na.text-danger:hover,\na.text-danger:focus {\n  color: #843534;\n}\n.bg-primary {\n  color: #fff;\n  background-color: #337ab7;\n}\na.bg-primary:hover,\na.bg-primary:focus {\n  background-color: #286090;\n}\n.bg-success {\n  background-color: #dff0d8;\n}\na.bg-success:hover,\na.bg-success:focus {\n  background-color: #c1e2b3;\n}\n.bg-info {\n  background-color: #d9edf7;\n}\na.bg-info:hover,\na.bg-info:focus {\n  background-color: #afd9ee;\n}\n.bg-warning {\n  background-color: #fcf8e3;\n}\na.bg-warning:hover,\na.bg-warning:focus {\n  background-color: #f7ecb5;\n}\n.bg-danger {\n  background-color: #f2dede;\n}\na.bg-danger:hover,\na.bg-danger:focus {\n  background-color: #e4b9b9;\n}\n.page-header {\n  padding-bottom: 8px;\n  margin: 36px 0 18px;\n  border-bottom: 1px solid #eeeeee;\n}\nul,\nol {\n  margin-top: 0;\n  margin-bottom: 9px;\n}\nul ul,\nol ul,\nul ol,\nol ol {\n  margin-bottom: 0;\n}\n.list-unstyled {\n  padding-left: 0;\n  list-style: none;\n}\n.list-inline {\n  padding-left: 0;\n  list-style: none;\n  margin-left: -5px;\n}\n.list-inline > li {\n  display: inline-block;\n  padding-right: 5px;\n  padding-left: 5px;\n}\ndl {\n  margin-top: 0;\n  margin-bottom: 18px;\n}\ndt,\ndd {\n  line-height: 1.42857143;\n}\ndt {\n  font-weight: 700;\n}\ndd {\n  margin-left: 0;\n}\n@media (min-width: 541px) {\n  .dl-horizontal dt {\n    float: left;\n    width: 160px;\n    clear: left;\n    text-align: right;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n  .dl-horizontal dd {\n    margin-left: 180px;\n  }\n}\nabbr[title],\nabbr[data-original-title] {\n  cursor: help;\n}\n.initialism {\n  font-size: 90%;\n  text-transform: uppercase;\n}\nblockquote {\n  padding: 9px 18px;\n  margin: 0 0 18px;\n  font-size: inherit;\n  border-left: 5px solid #eeeeee;\n}\nblockquote p:last-child,\nblockquote ul:last-child,\nblockquote ol:last-child {\n  margin-bottom: 0;\n}\nblockquote footer,\nblockquote small,\nblockquote .small {\n  display: block;\n  font-size: 80%;\n  line-height: 1.42857143;\n  color: #777777;\n}\nblockquote footer:before,\nblockquote small:before,\nblockquote .small:before {\n  content: \"\\2014 \\00A0\";\n}\n.blockquote-reverse,\nblockquote.pull-right {\n  padding-right: 15px;\n  padding-left: 0;\n  text-align: right;\n  border-right: 5px solid #eeeeee;\n  border-left: 0;\n}\n.blockquote-reverse footer:before,\nblockquote.pull-right footer:before,\n.blockquote-reverse small:before,\nblockquote.pull-right small:before,\n.blockquote-reverse .small:before,\nblockquote.pull-right .small:before {\n  content: \"\";\n}\n.blockquote-reverse footer:after,\nblockquote.pull-right footer:after,\n.blockquote-reverse small:after,\nblockquote.pull-right small:after,\n.blockquote-reverse .small:after,\nblockquote.pull-right .small:after {\n  content: \"\\00A0 \\2014\";\n}\naddress {\n  margin-bottom: 18px;\n  font-style: normal;\n  line-height: 1.42857143;\n}\ncode,\nkbd,\npre,\nsamp {\n  font-family: monospace;\n}\ncode {\n  padding: 2px 4px;\n  font-size: 90%;\n  color: #c7254e;\n  background-color: #f9f2f4;\n  border-radius: 2px;\n}\nkbd {\n  padding: 2px 4px;\n  font-size: 90%;\n  color: #888;\n  background-color: transparent;\n  border-radius: 1px;\n  box-shadow: inset 0 -1px 0 rgba(0, 0, 0, 0.25);\n}\nkbd kbd {\n  padding: 0;\n  font-size: 100%;\n  font-weight: 700;\n  box-shadow: none;\n}\npre {\n  display: block;\n  padding: 8.5px;\n  margin: 0 0 9px;\n  font-size: 12px;\n  line-height: 1.42857143;\n  color: #333333;\n  word-break: break-all;\n  word-wrap: break-word;\n  background-color: #f5f5f5;\n  border: 1px solid #ccc;\n  border-radius: 2px;\n}\npre code {\n  padding: 0;\n  font-size: inherit;\n  color: inherit;\n  white-space: pre-wrap;\n  background-color: transparent;\n  border-radius: 0;\n}\n.pre-scrollable {\n  max-height: 340px;\n  overflow-y: scroll;\n}\n.container {\n  padding-right: 0px;\n  padding-left: 0px;\n  margin-right: auto;\n  margin-left: auto;\n}\n@media (min-width: 768px) {\n  .container {\n    width: 768px;\n  }\n}\n@media (min-width: 992px) {\n  .container {\n    width: 940px;\n  }\n}\n@media (min-width: 1200px) {\n  .container {\n    width: 1140px;\n  }\n}\n.container-fluid {\n  padding-right: 0px;\n  padding-left: 0px;\n  margin-right: auto;\n  margin-left: auto;\n}\n.row {\n  margin-right: 0px;\n  margin-left: 0px;\n}\n.row-no-gutters {\n  margin-right: 0;\n  margin-left: 0;\n}\n.row-no-gutters [class*=\"col-\"] {\n  padding-right: 0;\n  padding-left: 0;\n}\n.col-xs-1,\n.col-sm-1,\n.col-md-1,\n.col-lg-1,\n.col-xs-2,\n.col-sm-2,\n.col-md-2,\n.col-lg-2,\n.col-xs-3,\n.col-sm-3,\n.col-md-3,\n.col-lg-3,\n.col-xs-4,\n.col-sm-4,\n.col-md-4,\n.col-lg-4,\n.col-xs-5,\n.col-sm-5,\n.col-md-5,\n.col-lg-5,\n.col-xs-6,\n.col-sm-6,\n.col-md-6,\n.col-lg-6,\n.col-xs-7,\n.col-sm-7,\n.col-md-7,\n.col-lg-7,\n.col-xs-8,\n.col-sm-8,\n.col-md-8,\n.col-lg-8,\n.col-xs-9,\n.col-sm-9,\n.col-md-9,\n.col-lg-9,\n.col-xs-10,\n.col-sm-10,\n.col-md-10,\n.col-lg-10,\n.col-xs-11,\n.col-sm-11,\n.col-md-11,\n.col-lg-11,\n.col-xs-12,\n.col-sm-12,\n.col-md-12,\n.col-lg-12 {\n  position: relative;\n  min-height: 1px;\n  padding-right: 0px;\n  padding-left: 0px;\n}\n.col-xs-1,\n.col-xs-2,\n.col-xs-3,\n.col-xs-4,\n.col-xs-5,\n.col-xs-6,\n.col-xs-7,\n.col-xs-8,\n.col-xs-9,\n.col-xs-10,\n.col-xs-11,\n.col-xs-12 {\n  float: left;\n}\n.col-xs-12 {\n  width: 100%;\n}\n.col-xs-11 {\n  width: 91.66666667%;\n}\n.col-xs-10 {\n  width: 83.33333333%;\n}\n.col-xs-9 {\n  width: 75%;\n}\n.col-xs-8 {\n  width: 66.66666667%;\n}\n.col-xs-7 {\n  width: 58.33333333%;\n}\n.col-xs-6 {\n  width: 50%;\n}\n.col-xs-5 {\n  width: 41.66666667%;\n}\n.col-xs-4 {\n  width: 33.33333333%;\n}\n.col-xs-3 {\n  width: 25%;\n}\n.col-xs-2 {\n  width: 16.66666667%;\n}\n.col-xs-1 {\n  width: 8.33333333%;\n}\n.col-xs-pull-12 {\n  right: 100%;\n}\n.col-xs-pull-11 {\n  right: 91.66666667%;\n}\n.col-xs-pull-10 {\n  right: 83.33333333%;\n}\n.col-xs-pull-9 {\n  right: 75%;\n}\n.col-xs-pull-8 {\n  right: 66.66666667%;\n}\n.col-xs-pull-7 {\n  right: 58.33333333%;\n}\n.col-xs-pull-6 {\n  right: 50%;\n}\n.col-xs-pull-5 {\n  right: 41.66666667%;\n}\n.col-xs-pull-4 {\n  right: 33.33333333%;\n}\n.col-xs-pull-3 {\n  right: 25%;\n}\n.col-xs-pull-2 {\n  right: 16.66666667%;\n}\n.col-xs-pull-1 {\n  right: 8.33333333%;\n}\n.col-xs-pull-0 {\n  right: auto;\n}\n.col-xs-push-12 {\n  left: 100%;\n}\n.col-xs-push-11 {\n  left: 91.66666667%;\n}\n.col-xs-push-10 {\n  left: 83.33333333%;\n}\n.col-xs-push-9 {\n  left: 75%;\n}\n.col-xs-push-8 {\n  left: 66.66666667%;\n}\n.col-xs-push-7 {\n  left: 58.33333333%;\n}\n.col-xs-push-6 {\n  left: 50%;\n}\n.col-xs-push-5 {\n  left: 41.66666667%;\n}\n.col-xs-push-4 {\n  left: 33.33333333%;\n}\n.col-xs-push-3 {\n  left: 25%;\n}\n.col-xs-push-2 {\n  left: 16.66666667%;\n}\n.col-xs-push-1 {\n  left: 8.33333333%;\n}\n.col-xs-push-0 {\n  left: auto;\n}\n.col-xs-offset-12 {\n  margin-left: 100%;\n}\n.col-xs-offset-11 {\n  margin-left: 91.66666667%;\n}\n.col-xs-offset-10 {\n  margin-left: 83.33333333%;\n}\n.col-xs-offset-9 {\n  margin-left: 75%;\n}\n.col-xs-offset-8 {\n  margin-left: 66.66666667%;\n}\n.col-xs-offset-7 {\n  margin-left: 58.33333333%;\n}\n.col-xs-offset-6 {\n  margin-left: 50%;\n}\n.col-xs-offset-5 {\n  margin-left: 41.66666667%;\n}\n.col-xs-offset-4 {\n  margin-left: 33.33333333%;\n}\n.col-xs-offset-3 {\n  margin-left: 25%;\n}\n.col-xs-offset-2 {\n  margin-left: 16.66666667%;\n}\n.col-xs-offset-1 {\n  margin-left: 8.33333333%;\n}\n.col-xs-offset-0 {\n  margin-left: 0%;\n}\n@media (min-width: 768px) {\n  .col-sm-1,\n  .col-sm-2,\n  .col-sm-3,\n  .col-sm-4,\n  .col-sm-5,\n  .col-sm-6,\n  .col-sm-7,\n  .col-sm-8,\n  .col-sm-9,\n  .col-sm-10,\n  .col-sm-11,\n  .col-sm-12 {\n    float: left;\n  }\n  .col-sm-12 {\n    width: 100%;\n  }\n  .col-sm-11 {\n    width: 91.66666667%;\n  }\n  .col-sm-10 {\n    width: 83.33333333%;\n  }\n  .col-sm-9 {\n    width: 75%;\n  }\n  .col-sm-8 {\n    width: 66.66666667%;\n  }\n  .col-sm-7 {\n    width: 58.33333333%;\n  }\n  .col-sm-6 {\n    width: 50%;\n  }\n  .col-sm-5 {\n    width: 41.66666667%;\n  }\n  .col-sm-4 {\n    width: 33.33333333%;\n  }\n  .col-sm-3 {\n    width: 25%;\n  }\n  .col-sm-2 {\n    width: 16.66666667%;\n  }\n  .col-sm-1 {\n    width: 8.33333333%;\n  }\n  .col-sm-pull-12 {\n    right: 100%;\n  }\n  .col-sm-pull-11 {\n    right: 91.66666667%;\n  }\n  .col-sm-pull-10 {\n    right: 83.33333333%;\n  }\n  .col-sm-pull-9 {\n    right: 75%;\n  }\n  .col-sm-pull-8 {\n    right: 66.66666667%;\n  }\n  .col-sm-pull-7 {\n    right: 58.33333333%;\n  }\n  .col-sm-pull-6 {\n    right: 50%;\n  }\n  .col-sm-pull-5 {\n    right: 41.66666667%;\n  }\n  .col-sm-pull-4 {\n    right: 33.33333333%;\n  }\n  .col-sm-pull-3 {\n    right: 25%;\n  }\n  .col-sm-pull-2 {\n    right: 16.66666667%;\n  }\n  .col-sm-pull-1 {\n    right: 8.33333333%;\n  }\n  .col-sm-pull-0 {\n    right: auto;\n  }\n  .col-sm-push-12 {\n    left: 100%;\n  }\n  .col-sm-push-11 {\n    left: 91.66666667%;\n  }\n  .col-sm-push-10 {\n    left: 83.33333333%;\n  }\n  .col-sm-push-9 {\n    left: 75%;\n  }\n  .col-sm-push-8 {\n    left: 66.66666667%;\n  }\n  .col-sm-push-7 {\n    left: 58.33333333%;\n  }\n  .col-sm-push-6 {\n    left: 50%;\n  }\n  .col-sm-push-5 {\n    left: 41.66666667%;\n  }\n  .col-sm-push-4 {\n    left: 33.33333333%;\n  }\n  .col-sm-push-3 {\n    left: 25%;\n  }\n  .col-sm-push-2 {\n    left: 16.66666667%;\n  }\n  .col-sm-push-1 {\n    left: 8.33333333%;\n  }\n  .col-sm-push-0 {\n    left: auto;\n  }\n  .col-sm-offset-12 {\n    margin-left: 100%;\n  }\n  .col-sm-offset-11 {\n    margin-left: 91.66666667%;\n  }\n  .col-sm-offset-10 {\n    margin-left: 83.33333333%;\n  }\n  .col-sm-offset-9 {\n    margin-left: 75%;\n  }\n  .col-sm-offset-8 {\n    margin-left: 66.66666667%;\n  }\n  .col-sm-offset-7 {\n    margin-left: 58.33333333%;\n  }\n  .col-sm-offset-6 {\n    margin-left: 50%;\n  }\n  .col-sm-offset-5 {\n    margin-left: 41.66666667%;\n  }\n  .col-sm-offset-4 {\n    margin-left: 33.33333333%;\n  }\n  .col-sm-offset-3 {\n    margin-left: 25%;\n  }\n  .col-sm-offset-2 {\n    margin-left: 16.66666667%;\n  }\n  .col-sm-offset-1 {\n    margin-left: 8.33333333%;\n  }\n  .col-sm-offset-0 {\n    margin-left: 0%;\n  }\n}\n@media (min-width: 992px) {\n  .col-md-1,\n  .col-md-2,\n  .col-md-3,\n  .col-md-4,\n  .col-md-5,\n  .col-md-6,\n  .col-md-7,\n  .col-md-8,\n  .col-md-9,\n  .col-md-10,\n  .col-md-11,\n  .col-md-12 {\n    float: left;\n  }\n  .col-md-12 {\n    width: 100%;\n  }\n  .col-md-11 {\n    width: 91.66666667%;\n  }\n  .col-md-10 {\n    width: 83.33333333%;\n  }\n  .col-md-9 {\n    width: 75%;\n  }\n  .col-md-8 {\n    width: 66.66666667%;\n  }\n  .col-md-7 {\n    width: 58.33333333%;\n  }\n  .col-md-6 {\n    width: 50%;\n  }\n  .col-md-5 {\n    width: 41.66666667%;\n  }\n  .col-md-4 {\n    width: 33.33333333%;\n  }\n  .col-md-3 {\n    width: 25%;\n  }\n  .col-md-2 {\n    width: 16.66666667%;\n  }\n  .col-md-1 {\n    width: 8.33333333%;\n  }\n  .col-md-pull-12 {\n    right: 100%;\n  }\n  .col-md-pull-11 {\n    right: 91.66666667%;\n  }\n  .col-md-pull-10 {\n    right: 83.33333333%;\n  }\n  .col-md-pull-9 {\n    right: 75%;\n  }\n  .col-md-pull-8 {\n    right: 66.66666667%;\n  }\n  .col-md-pull-7 {\n    right: 58.33333333%;\n  }\n  .col-md-pull-6 {\n    right: 50%;\n  }\n  .col-md-pull-5 {\n    right: 41.66666667%;\n  }\n  .col-md-pull-4 {\n    right: 33.33333333%;\n  }\n  .col-md-pull-3 {\n    right: 25%;\n  }\n  .col-md-pull-2 {\n    right: 16.66666667%;\n  }\n  .col-md-pull-1 {\n    right: 8.33333333%;\n  }\n  .col-md-pull-0 {\n    right: auto;\n  }\n  .col-md-push-12 {\n    left: 100%;\n  }\n  .col-md-push-11 {\n    left: 91.66666667%;\n  }\n  .col-md-push-10 {\n    left: 83.33333333%;\n  }\n  .col-md-push-9 {\n    left: 75%;\n  }\n  .col-md-push-8 {\n    left: 66.66666667%;\n  }\n  .col-md-push-7 {\n    left: 58.33333333%;\n  }\n  .col-md-push-6 {\n    left: 50%;\n  }\n  .col-md-push-5 {\n    left: 41.66666667%;\n  }\n  .col-md-push-4 {\n    left: 33.33333333%;\n  }\n  .col-md-push-3 {\n    left: 25%;\n  }\n  .col-md-push-2 {\n    left: 16.66666667%;\n  }\n  .col-md-push-1 {\n    left: 8.33333333%;\n  }\n  .col-md-push-0 {\n    left: auto;\n  }\n  .col-md-offset-12 {\n    margin-left: 100%;\n  }\n  .col-md-offset-11 {\n    margin-left: 91.66666667%;\n  }\n  .col-md-offset-10 {\n    margin-left: 83.33333333%;\n  }\n  .col-md-offset-9 {\n    margin-left: 75%;\n  }\n  .col-md-offset-8 {\n    margin-left: 66.66666667%;\n  }\n  .col-md-offset-7 {\n    margin-left: 58.33333333%;\n  }\n  .col-md-offset-6 {\n    margin-left: 50%;\n  }\n  .col-md-offset-5 {\n    margin-left: 41.66666667%;\n  }\n  .col-md-offset-4 {\n    margin-left: 33.33333333%;\n  }\n  .col-md-offset-3 {\n    margin-left: 25%;\n  }\n  .col-md-offset-2 {\n    margin-left: 16.66666667%;\n  }\n  .col-md-offset-1 {\n    margin-left: 8.33333333%;\n  }\n  .col-md-offset-0 {\n    margin-left: 0%;\n  }\n}\n@media (min-width: 1200px) {\n  .col-lg-1,\n  .col-lg-2,\n  .col-lg-3,\n  .col-lg-4,\n  .col-lg-5,\n  .col-lg-6,\n  .col-lg-7,\n  .col-lg-8,\n  .col-lg-9,\n  .col-lg-10,\n  .col-lg-11,\n  .col-lg-12 {\n    float: left;\n  }\n  .col-lg-12 {\n    width: 100%;\n  }\n  .col-lg-11 {\n    width: 91.66666667%;\n  }\n  .col-lg-10 {\n    width: 83.33333333%;\n  }\n  .col-lg-9 {\n    width: 75%;\n  }\n  .col-lg-8 {\n    width: 66.66666667%;\n  }\n  .col-lg-7 {\n    width: 58.33333333%;\n  }\n  .col-lg-6 {\n    width: 50%;\n  }\n  .col-lg-5 {\n    width: 41.66666667%;\n  }\n  .col-lg-4 {\n    width: 33.33333333%;\n  }\n  .col-lg-3 {\n    width: 25%;\n  }\n  .col-lg-2 {\n    width: 16.66666667%;\n  }\n  .col-lg-1 {\n    width: 8.33333333%;\n  }\n  .col-lg-pull-12 {\n    right: 100%;\n  }\n  .col-lg-pull-11 {\n    right: 91.66666667%;\n  }\n  .col-lg-pull-10 {\n    right: 83.33333333%;\n  }\n  .col-lg-pull-9 {\n    right: 75%;\n  }\n  .col-lg-pull-8 {\n    right: 66.66666667%;\n  }\n  .col-lg-pull-7 {\n    right: 58.33333333%;\n  }\n  .col-lg-pull-6 {\n    right: 50%;\n  }\n  .col-lg-pull-5 {\n    right: 41.66666667%;\n  }\n  .col-lg-pull-4 {\n    right: 33.33333333%;\n  }\n  .col-lg-pull-3 {\n    right: 25%;\n  }\n  .col-lg-pull-2 {\n    right: 16.66666667%;\n  }\n  .col-lg-pull-1 {\n    right: 8.33333333%;\n  }\n  .col-lg-pull-0 {\n    right: auto;\n  }\n  .col-lg-push-12 {\n    left: 100%;\n  }\n  .col-lg-push-11 {\n    left: 91.66666667%;\n  }\n  .col-lg-push-10 {\n    left: 83.33333333%;\n  }\n  .col-lg-push-9 {\n    left: 75%;\n  }\n  .col-lg-push-8 {\n    left: 66.66666667%;\n  }\n  .col-lg-push-7 {\n    left: 58.33333333%;\n  }\n  .col-lg-push-6 {\n    left: 50%;\n  }\n  .col-lg-push-5 {\n    left: 41.66666667%;\n  }\n  .col-lg-push-4 {\n    left: 33.33333333%;\n  }\n  .col-lg-push-3 {\n    left: 25%;\n  }\n  .col-lg-push-2 {\n    left: 16.66666667%;\n  }\n  .col-lg-push-1 {\n    left: 8.33333333%;\n  }\n  .col-lg-push-0 {\n    left: auto;\n  }\n  .col-lg-offset-12 {\n    margin-left: 100%;\n  }\n  .col-lg-offset-11 {\n    margin-left: 91.66666667%;\n  }\n  .col-lg-offset-10 {\n    margin-left: 83.33333333%;\n  }\n  .col-lg-offset-9 {\n    margin-left: 75%;\n  }\n  .col-lg-offset-8 {\n    margin-left: 66.66666667%;\n  }\n  .col-lg-offset-7 {\n    margin-left: 58.33333333%;\n  }\n  .col-lg-offset-6 {\n    margin-left: 50%;\n  }\n  .col-lg-offset-5 {\n    margin-left: 41.66666667%;\n  }\n  .col-lg-offset-4 {\n    margin-left: 33.33333333%;\n  }\n  .col-lg-offset-3 {\n    margin-left: 25%;\n  }\n  .col-lg-offset-2 {\n    margin-left: 16.66666667%;\n  }\n  .col-lg-offset-1 {\n    margin-left: 8.33333333%;\n  }\n  .col-lg-offset-0 {\n    margin-left: 0%;\n  }\n}\ntable {\n  background-color: transparent;\n}\ntable col[class*=\"col-\"] {\n  position: static;\n  display: table-column;\n  float: none;\n}\ntable td[class*=\"col-\"],\ntable th[class*=\"col-\"] {\n  position: static;\n  display: table-cell;\n  float: none;\n}\ncaption {\n  padding-top: 8px;\n  padding-bottom: 8px;\n  color: #777777;\n  text-align: left;\n}\nth {\n  text-align: left;\n}\n.table {\n  width: 100%;\n  max-width: 100%;\n  margin-bottom: 18px;\n}\n.table > thead > tr > th,\n.table > tbody > tr > th,\n.table > tfoot > tr > th,\n.table > thead > tr > td,\n.table > tbody > tr > td,\n.table > tfoot > tr > td {\n  padding: 8px;\n  line-height: 1.42857143;\n  vertical-align: top;\n  border-top: 1px solid #ddd;\n}\n.table > thead > tr > th {\n  vertical-align: bottom;\n  border-bottom: 2px solid #ddd;\n}\n.table > caption + thead > tr:first-child > th,\n.table > colgroup + thead > tr:first-child > th,\n.table > thead:first-child > tr:first-child > th,\n.table > caption + thead > tr:first-child > td,\n.table > colgroup + thead > tr:first-child > td,\n.table > thead:first-child > tr:first-child > td {\n  border-top: 0;\n}\n.table > tbody + tbody {\n  border-top: 2px solid #ddd;\n}\n.table .table {\n  background-color: var(--body-bg);\n}\n.table-condensed > thead > tr > th,\n.table-condensed > tbody > tr > th,\n.table-condensed > tfoot > tr > th,\n.table-condensed > thead > tr > td,\n.table-condensed > tbody > tr > td,\n.table-condensed > tfoot > tr > td {\n  padding: 5px;\n}\n.table-bordered {\n  border: 1px solid #ddd;\n}\n.table-bordered > thead > tr > th,\n.table-bordered > tbody > tr > th,\n.table-bordered > tfoot > tr > th,\n.table-bordered > thead > tr > td,\n.table-bordered > tbody > tr > td,\n.table-bordered > tfoot > tr > td {\n  border: 1px solid #ddd;\n}\n.table-bordered > thead > tr > th,\n.table-bordered > thead > tr > td {\n  border-bottom-width: 2px;\n}\n.table-striped > tbody > tr:nth-of-type(odd) {\n  background-color: #f9f9f9;\n}\n.table-hover > tbody > tr:hover {\n  background-color: #f5f5f5;\n}\n.table > thead > tr > td.active,\n.table > tbody > tr > td.active,\n.table > tfoot > tr > td.active,\n.table > thead > tr > th.active,\n.table > tbody > tr > th.active,\n.table > tfoot > tr > th.active,\n.table > thead > tr.active > td,\n.table > tbody > tr.active > td,\n.table > tfoot > tr.active > td,\n.table > thead > tr.active > th,\n.table > tbody > tr.active > th,\n.table > tfoot > tr.active > th {\n  background-color: #f5f5f5;\n}\n.table-hover > tbody > tr > td.active:hover,\n.table-hover > tbody > tr > th.active:hover,\n.table-hover > tbody > tr.active:hover > td,\n.table-hover > tbody > tr:hover > .active,\n.table-hover > tbody > tr.active:hover > th {\n  background-color: #e8e8e8;\n}\n.table > thead > tr > td.success,\n.table > tbody > tr > td.success,\n.table > tfoot > tr > td.success,\n.table > thead > tr > th.success,\n.table > tbody > tr > th.success,\n.table > tfoot > tr > th.success,\n.table > thead > tr.success > td,\n.table > tbody > tr.success > td,\n.table > tfoot > tr.success > td,\n.table > thead > tr.success > th,\n.table > tbody > tr.success > th,\n.table > tfoot > tr.success > th {\n  background-color: #dff0d8;\n}\n.table-hover > tbody > tr > td.success:hover,\n.table-hover > tbody > tr > th.success:hover,\n.table-hover > tbody > tr.success:hover > td,\n.table-hover > tbody > tr:hover > .success,\n.table-hover > tbody > tr.success:hover > th {\n  background-color: #d0e9c6;\n}\n.table > thead > tr > td.info,\n.table > tbody > tr > td.info,\n.table > tfoot > tr > td.info,\n.table > thead > tr > th.info,\n.table > tbody > tr > th.info,\n.table > tfoot > tr > th.info,\n.table > thead > tr.info > td,\n.table > tbody > tr.info > td,\n.table > tfoot > tr.info > td,\n.table > thead > tr.info > th,\n.table > tbody > tr.info > th,\n.table > tfoot > tr.info > th {\n  background-color: #d9edf7;\n}\n.table-hover > tbody > tr > td.info:hover,\n.table-hover > tbody > tr > th.info:hover,\n.table-hover > tbody > tr.info:hover > td,\n.table-hover > tbody > tr:hover > .info,\n.table-hover > tbody > tr.info:hover > th {\n  background-color: #c4e3f3;\n}\n.table > thead > tr > td.warning,\n.table > tbody > tr > td.warning,\n.table > tfoot > tr > td.warning,\n.table > thead > tr > th.warning,\n.table > tbody > tr > th.warning,\n.table > tfoot > tr > th.warning,\n.table > thead > tr.warning > td,\n.table > tbody > tr.warning > td,\n.table > tfoot > tr.warning > td,\n.table > thead > tr.warning > th,\n.table > tbody > tr.warning > th,\n.table > tfoot > tr.warning > th {\n  background-color: #fcf8e3;\n}\n.table-hover > tbody > tr > td.warning:hover,\n.table-hover > tbody > tr > th.warning:hover,\n.table-hover > tbody > tr.warning:hover > td,\n.table-hover > tbody > tr:hover > .warning,\n.table-hover > tbody > tr.warning:hover > th {\n  background-color: #faf2cc;\n}\n.table > thead > tr > td.danger,\n.table > tbody > tr > td.danger,\n.table > tfoot > tr > td.danger,\n.table > thead > tr > th.danger,\n.table > tbody > tr > th.danger,\n.table > tfoot > tr > th.danger,\n.table > thead > tr.danger > td,\n.table > tbody > tr.danger > td,\n.table > tfoot > tr.danger > td,\n.table > thead > tr.danger > th,\n.table > tbody > tr.danger > th,\n.table > tfoot > tr.danger > th {\n  background-color: #f2dede;\n}\n.table-hover > tbody > tr > td.danger:hover,\n.table-hover > tbody > tr > th.danger:hover,\n.table-hover > tbody > tr.danger:hover > td,\n.table-hover > tbody > tr:hover > .danger,\n.table-hover > tbody > tr.danger:hover > th {\n  background-color: #ebcccc;\n}\n.table-responsive {\n  min-height: 0.01%;\n  overflow-x: auto;\n}\n@media screen and (max-width: 767px) {\n  .table-responsive {\n    width: 100%;\n    margin-bottom: 13.5px;\n    overflow-y: hidden;\n    -ms-overflow-style: -ms-autohiding-scrollbar;\n    border: 1px solid #ddd;\n  }\n  .table-responsive > .table {\n    margin-bottom: 0;\n  }\n  .table-responsive > .table > thead > tr > th,\n  .table-responsive > .table > tbody > tr > th,\n  .table-responsive > .table > tfoot > tr > th,\n  .table-responsive > .table > thead > tr > td,\n  .table-responsive > .table > tbody > tr > td,\n  .table-responsive > .table > tfoot > tr > td {\n    white-space: nowrap;\n  }\n  .table-responsive > .table-bordered {\n    border: 0;\n  }\n  .table-responsive > .table-bordered > thead > tr > th:first-child,\n  .table-responsive > .table-bordered > tbody > tr > th:first-child,\n  .table-responsive > .table-bordered > tfoot > tr > th:first-child,\n  .table-responsive > .table-bordered > thead > tr > td:first-child,\n  .table-responsive > .table-bordered > tbody > tr > td:first-child,\n  .table-responsive > .table-bordered > tfoot > tr > td:first-child {\n    border-left: 0;\n  }\n  .table-responsive > .table-bordered > thead > tr > th:last-child,\n  .table-responsive > .table-bordered > tbody > tr > th:last-child,\n  .table-responsive > .table-bordered > tfoot > tr > th:last-child,\n  .table-responsive > .table-bordered > thead > tr > td:last-child,\n  .table-responsive > .table-bordered > tbody > tr > td:last-child,\n  .table-responsive > .table-bordered > tfoot > tr > td:last-child {\n    border-right: 0;\n  }\n  .table-responsive > .table-bordered > tbody > tr:last-child > th,\n  .table-responsive > .table-bordered > tfoot > tr:last-child > th,\n  .table-responsive > .table-bordered > tbody > tr:last-child > td,\n  .table-responsive > .table-bordered > tfoot > tr:last-child > td {\n    border-bottom: 0;\n  }\n}\nfieldset {\n  min-width: 0;\n  padding: 0;\n  margin: 0;\n  border: 0;\n}\nlegend {\n  display: block;\n  width: 100%;\n  padding: 0;\n  margin-bottom: 18px;\n  font-size: 19.5px;\n  line-height: inherit;\n  color: #333333;\n  border: 0;\n  border-bottom: 1px solid #e5e5e5;\n}\nlabel {\n  display: inline-block;\n  max-width: 100%;\n  margin-bottom: 5px;\n  font-weight: 700;\n}\ninput[type=\"search\"] {\n  -webkit-box-sizing: border-box;\n  -moz-box-sizing: border-box;\n  box-sizing: border-box;\n  -webkit-appearance: none;\n  appearance: none;\n}\ninput[type=\"radio\"],\ninput[type=\"checkbox\"] {\n  margin: 4px 0 0;\n  margin-top: 1px \\9;\n  line-height: normal;\n}\ninput[type=\"radio\"][disabled],\ninput[type=\"checkbox\"][disabled],\ninput[type=\"radio\"].disabled,\ninput[type=\"checkbox\"].disabled,\nfieldset[disabled] input[type=\"radio\"],\nfieldset[disabled] input[type=\"checkbox\"] {\n  cursor: not-allowed;\n}\ninput[type=\"file\"] {\n  display: block;\n}\ninput[type=\"range\"] {\n  display: block;\n  width: 100%;\n}\nselect[multiple],\nselect[size] {\n  height: auto;\n}\ninput[type=\"file\"]:focus,\ninput[type=\"radio\"]:focus,\ninput[type=\"checkbox\"]:focus {\n  outline: 5px auto -webkit-focus-ring-color;\n  outline-offset: -2px;\n}\noutput {\n  display: block;\n  padding-top: 7px;\n  font-size: 13px;\n  line-height: 1.42857143;\n  color: #555555;\n}\n.form-control {\n  display: block;\n  width: 100%;\n  height: 32px;\n  padding: 6px 12px;\n  font-size: 13px;\n  line-height: 1.42857143;\n  color: #555555;\n  background-color: #fff;\n  background-image: none;\n  border: 1px solid #ccc;\n  border-radius: 2px;\n  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);\n  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);\n  -webkit-transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;\n  -o-transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;\n  transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;\n}\n.form-control:focus {\n  border-color: #66afe9;\n  outline: 0;\n  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075), 0 0 8px rgba(102, 175, 233, 0.6);\n  box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075), 0 0 8px rgba(102, 175, 233, 0.6);\n}\n.form-control::-moz-placeholder {\n  color: #999;\n  opacity: 1;\n}\n.form-control:-ms-input-placeholder {\n  color: #999;\n}\n.form-control::-webkit-input-placeholder {\n  color: #999;\n}\n.form-control::-ms-expand {\n  background-color: transparent;\n  border: 0;\n}\n.form-control[disabled],\n.form-control[readonly],\nfieldset[disabled] .form-control {\n  background-color: #eeeeee;\n  opacity: 1;\n}\n.form-control[disabled],\nfieldset[disabled] .form-control {\n  cursor: not-allowed;\n}\ntextarea.form-control {\n  height: auto;\n}\n@media screen and (-webkit-min-device-pixel-ratio: 0) {\n  input[type=\"date\"].form-control,\n  input[type=\"time\"].form-control,\n  input[type=\"datetime-local\"].form-control,\n  input[type=\"month\"].form-control {\n    line-height: 32px;\n  }\n  input[type=\"date\"].input-sm,\n  input[type=\"time\"].input-sm,\n  input[type=\"datetime-local\"].input-sm,\n  input[type=\"month\"].input-sm,\n  .input-group-sm input[type=\"date\"],\n  .input-group-sm input[type=\"time\"],\n  .input-group-sm input[type=\"datetime-local\"],\n  .input-group-sm input[type=\"month\"] {\n    line-height: 30px;\n  }\n  input[type=\"date\"].input-lg,\n  input[type=\"time\"].input-lg,\n  input[type=\"datetime-local\"].input-lg,\n  input[type=\"month\"].input-lg,\n  .input-group-lg input[type=\"date\"],\n  .input-group-lg input[type=\"time\"],\n  .input-group-lg input[type=\"datetime-local\"],\n  .input-group-lg input[type=\"month\"] {\n    line-height: 45px;\n  }\n}\n.form-group {\n  margin-bottom: 15px;\n}\n.radio,\n.checkbox {\n  position: relative;\n  display: block;\n  margin-top: 10px;\n  margin-bottom: 10px;\n}\n.radio.disabled label,\n.checkbox.disabled label,\nfieldset[disabled] .radio label,\nfieldset[disabled] .checkbox label {\n  cursor: not-allowed;\n}\n.radio label,\n.checkbox label {\n  min-height: 18px;\n  padding-left: 20px;\n  margin-bottom: 0;\n  font-weight: 400;\n  cursor: pointer;\n}\n.radio input[type=\"radio\"],\n.radio-inline input[type=\"radio\"],\n.checkbox input[type=\"checkbox\"],\n.checkbox-inline input[type=\"checkbox\"] {\n  position: absolute;\n  margin-top: 4px \\9;\n  margin-left: -20px;\n}\n.radio + .radio,\n.checkbox + .checkbox {\n  margin-top: -5px;\n}\n.radio-inline,\n.checkbox-inline {\n  position: relative;\n  display: inline-block;\n  padding-left: 20px;\n  margin-bottom: 0;\n  font-weight: 400;\n  vertical-align: middle;\n  cursor: pointer;\n}\n.radio-inline.disabled,\n.checkbox-inline.disabled,\nfieldset[disabled] .radio-inline,\nfieldset[disabled] .checkbox-inline {\n  cursor: not-allowed;\n}\n.radio-inline + .radio-inline,\n.checkbox-inline + .checkbox-inline {\n  margin-top: 0;\n  margin-left: 10px;\n}\n.form-control-static {\n  min-height: 31px;\n  padding-top: 7px;\n  padding-bottom: 7px;\n  margin-bottom: 0;\n}\n.form-control-static.input-lg,\n.form-control-static.input-sm {\n  padding-right: 0;\n  padding-left: 0;\n}\n.input-sm {\n  height: 30px;\n  padding: 5px 10px;\n  font-size: 12px;\n  line-height: 1.5;\n  border-radius: 1px;\n}\nselect.input-sm {\n  height: 30px;\n  line-height: 30px;\n}\ntextarea.input-sm,\nselect[multiple].input-sm {\n  height: auto;\n}\n.form-group-sm .form-control {\n  height: 30px;\n  padding: 5px 10px;\n  font-size: 12px;\n  line-height: 1.5;\n  border-radius: 1px;\n}\n.form-group-sm select.form-control {\n  height: 30px;\n  line-height: 30px;\n}\n.form-group-sm textarea.form-control,\n.form-group-sm select[multiple].form-control {\n  height: auto;\n}\n.form-group-sm .form-control-static {\n  height: 30px;\n  min-height: 30px;\n  padding: 6px 10px;\n  font-size: 12px;\n  line-height: 1.5;\n}\n.input-lg {\n  height: 45px;\n  padding: 10px 16px;\n  font-size: 17px;\n  line-height: 1.3333333;\n  border-radius: 3px;\n}\nselect.input-lg {\n  height: 45px;\n  line-height: 45px;\n}\ntextarea.input-lg,\nselect[multiple].input-lg {\n  height: auto;\n}\n.form-group-lg .form-control {\n  height: 45px;\n  padding: 10px 16px;\n  font-size: 17px;\n  line-height: 1.3333333;\n  border-radius: 3px;\n}\n.form-group-lg select.form-control {\n  height: 45px;\n  line-height: 45px;\n}\n.form-group-lg textarea.form-control,\n.form-group-lg select[multiple].form-control {\n  height: auto;\n}\n.form-group-lg .form-control-static {\n  height: 45px;\n  min-height: 35px;\n  padding: 11px 16px;\n  font-size: 17px;\n  line-height: 1.3333333;\n}\n.has-feedback {\n  position: relative;\n}\n.has-feedback .form-control {\n  padding-right: 40px;\n}\n.form-control-feedback {\n  position: absolute;\n  top: 0;\n  right: 0;\n  z-index: 2;\n  display: block;\n  width: 32px;\n  height: 32px;\n  line-height: 32px;\n  text-align: center;\n  pointer-events: none;\n}\n.input-lg + .form-control-feedback,\n.input-group-lg + .form-control-feedback,\n.form-group-lg .form-control + .form-control-feedback {\n  width: 45px;\n  height: 45px;\n  line-height: 45px;\n}\n.input-sm + .form-control-feedback,\n.input-group-sm + .form-control-feedback,\n.form-group-sm .form-control + .form-control-feedback {\n  width: 30px;\n  height: 30px;\n  line-height: 30px;\n}\n.has-success .help-block,\n.has-success .control-label,\n.has-success .radio,\n.has-success .checkbox,\n.has-success .radio-inline,\n.has-success .checkbox-inline,\n.has-success.radio label,\n.has-success.checkbox label,\n.has-success.radio-inline label,\n.has-success.checkbox-inline label {\n  color: #3c763d;\n}\n.has-success .form-control {\n  border-color: #3c763d;\n  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);\n  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);\n}\n.has-success .form-control:focus {\n  border-color: #2b542c;\n  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 6px #67b168;\n  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 6px #67b168;\n}\n.has-success .input-group-addon {\n  color: #3c763d;\n  background-color: #dff0d8;\n  border-color: #3c763d;\n}\n.has-success .form-control-feedback {\n  color: #3c763d;\n}\n.has-warning .help-block,\n.has-warning .control-label,\n.has-warning .radio,\n.has-warning .checkbox,\n.has-warning .radio-inline,\n.has-warning .checkbox-inline,\n.has-warning.radio label,\n.has-warning.checkbox label,\n.has-warning.radio-inline label,\n.has-warning.checkbox-inline label {\n  color: #8a6d3b;\n}\n.has-warning .form-control {\n  border-color: #8a6d3b;\n  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);\n  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);\n}\n.has-warning .form-control:focus {\n  border-color: #66512c;\n  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 6px #c0a16b;\n  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 6px #c0a16b;\n}\n.has-warning .input-group-addon {\n  color: #8a6d3b;\n  background-color: #fcf8e3;\n  border-color: #8a6d3b;\n}\n.has-warning .form-control-feedback {\n  color: #8a6d3b;\n}\n.has-error .help-block,\n.has-error .control-label,\n.has-error .radio,\n.has-error .checkbox,\n.has-error .radio-inline,\n.has-error .checkbox-inline,\n.has-error.radio label,\n.has-error.checkbox label,\n.has-error.radio-inline label,\n.has-error.checkbox-inline label {\n  color: #a94442;\n}\n.has-error .form-control {\n  border-color: #a94442;\n  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);\n  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);\n}\n.has-error .form-control:focus {\n  border-color: #843534;\n  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 6px #ce8483;\n  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 6px #ce8483;\n}\n.has-error .input-group-addon {\n  color: #a94442;\n  background-color: #f2dede;\n  border-color: #a94442;\n}\n.has-error .form-control-feedback {\n  color: #a94442;\n}\n.has-feedback label ~ .form-control-feedback {\n  top: 23px;\n}\n.has-feedback label.sr-only ~ .form-control-feedback {\n  top: 0;\n}\n.help-block {\n  display: block;\n  margin-top: 5px;\n  margin-bottom: 10px;\n  color: #404040;\n}\n@media (min-width: 768px) {\n  .form-inline .form-group {\n    display: inline-block;\n    margin-bottom: 0;\n    vertical-align: middle;\n  }\n  .form-inline .form-control {\n    display: inline-block;\n    width: auto;\n    vertical-align: middle;\n  }\n  .form-inline .form-control-static {\n    display: inline-block;\n  }\n  .form-inline .input-group {\n    display: inline-table;\n    vertical-align: middle;\n  }\n  .form-inline .input-group .input-group-addon,\n  .form-inline .input-group .input-group-btn,\n  .form-inline .input-group .form-control {\n    width: auto;\n  }\n  .form-inline .input-group > .form-control {\n    width: 100%;\n  }\n  .form-inline .control-label {\n    margin-bottom: 0;\n    vertical-align: middle;\n  }\n  .form-inline .radio,\n  .form-inline .checkbox {\n    display: inline-block;\n    margin-top: 0;\n    margin-bottom: 0;\n    vertical-align: middle;\n  }\n  .form-inline .radio label,\n  .form-inline .checkbox label {\n    padding-left: 0;\n  }\n  .form-inline .radio input[type=\"radio\"],\n  .form-inline .checkbox input[type=\"checkbox\"] {\n    position: relative;\n    margin-left: 0;\n  }\n  .form-inline .has-feedback .form-control-feedback {\n    top: 0;\n  }\n}\n.form-horizontal .radio,\n.form-horizontal .checkbox,\n.form-horizontal .radio-inline,\n.form-horizontal .checkbox-inline {\n  padding-top: 7px;\n  margin-top: 0;\n  margin-bottom: 0;\n}\n.form-horizontal .radio,\n.form-horizontal .checkbox {\n  min-height: 25px;\n}\n.form-horizontal .form-group {\n  margin-right: 0px;\n  margin-left: 0px;\n}\n@media (min-width: 768px) {\n  .form-horizontal .control-label {\n    padding-top: 7px;\n    margin-bottom: 0;\n    text-align: right;\n  }\n}\n.form-horizontal .has-feedback .form-control-feedback {\n  right: 0px;\n}\n@media (min-width: 768px) {\n  .form-horizontal .form-group-lg .control-label {\n    padding-top: 11px;\n    font-size: 17px;\n  }\n}\n@media (min-width: 768px) {\n  .form-horizontal .form-group-sm .control-label {\n    padding-top: 6px;\n    font-size: 12px;\n  }\n}\n.btn {\n  display: inline-block;\n  margin-bottom: 0;\n  font-weight: normal;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: middle;\n  touch-action: manipulation;\n  cursor: pointer;\n  background-image: none;\n  border: 1px solid transparent;\n  padding: 6px 12px;\n  font-size: 13px;\n  line-height: 1.42857143;\n  border-radius: 2px;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n.btn:focus,\n.btn:active:focus,\n.btn.active:focus,\n.btn.focus,\n.btn:active.focus,\n.btn.active.focus {\n  outline: 5px auto -webkit-focus-ring-color;\n  outline-offset: -2px;\n}\n.btn:hover,\n.btn:focus,\n.btn.focus {\n  color: #333;\n  text-decoration: none;\n}\n.btn:active,\n.btn.active {\n  background-image: none;\n  outline: 0;\n  -webkit-box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n}\n.btn.disabled,\n.btn[disabled],\nfieldset[disabled] .btn {\n  cursor: not-allowed;\n  filter: alpha(opacity=65);\n  opacity: 0.65;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n}\na.btn.disabled,\nfieldset[disabled] a.btn {\n  pointer-events: none;\n}\n.btn-default {\n  color: #333;\n  background-color: #fff;\n  border-color: #ccc;\n}\n.btn-default:focus,\n.btn-default.focus {\n  color: #333;\n  background-color: #e6e6e6;\n  border-color: #8c8c8c;\n}\n.btn-default:hover {\n  color: #333;\n  background-color: #e6e6e6;\n  border-color: #adadad;\n}\n.btn-default:active,\n.btn-default.active,\n.open > .dropdown-toggle.btn-default {\n  color: #333;\n  background-color: #e6e6e6;\n  background-image: none;\n  border-color: #adadad;\n}\n.btn-default:active:hover,\n.btn-default.active:hover,\n.open > .dropdown-toggle.btn-default:hover,\n.btn-default:active:focus,\n.btn-default.active:focus,\n.open > .dropdown-toggle.btn-default:focus,\n.btn-default:active.focus,\n.btn-default.active.focus,\n.open > .dropdown-toggle.btn-default.focus {\n  color: #333;\n  background-color: #d4d4d4;\n  border-color: #8c8c8c;\n}\n.btn-default.disabled:hover,\n.btn-default[disabled]:hover,\nfieldset[disabled] .btn-default:hover,\n.btn-default.disabled:focus,\n.btn-default[disabled]:focus,\nfieldset[disabled] .btn-default:focus,\n.btn-default.disabled.focus,\n.btn-default[disabled].focus,\nfieldset[disabled] .btn-default.focus {\n  background-color: #fff;\n  border-color: #ccc;\n}\n.btn-default .badge {\n  color: #fff;\n  background-color: #333;\n}\n.btn-primary {\n  color: #fff;\n  background-color: #337ab7;\n  border-color: #2e6da4;\n}\n.btn-primary:focus,\n.btn-primary.focus {\n  color: #fff;\n  background-color: #286090;\n  border-color: #122b40;\n}\n.btn-primary:hover {\n  color: #fff;\n  background-color: #286090;\n  border-color: #204d74;\n}\n.btn-primary:active,\n.btn-primary.active,\n.open > .dropdown-toggle.btn-primary {\n  color: #fff;\n  background-color: #286090;\n  background-image: none;\n  border-color: #204d74;\n}\n.btn-primary:active:hover,\n.btn-primary.active:hover,\n.open > .dropdown-toggle.btn-primary:hover,\n.btn-primary:active:focus,\n.btn-primary.active:focus,\n.open > .dropdown-toggle.btn-primary:focus,\n.btn-primary:active.focus,\n.btn-primary.active.focus,\n.open > .dropdown-toggle.btn-primary.focus {\n  color: #fff;\n  background-color: #204d74;\n  border-color: #122b40;\n}\n.btn-primary.disabled:hover,\n.btn-primary[disabled]:hover,\nfieldset[disabled] .btn-primary:hover,\n.btn-primary.disabled:focus,\n.btn-primary[disabled]:focus,\nfieldset[disabled] .btn-primary:focus,\n.btn-primary.disabled.focus,\n.btn-primary[disabled].focus,\nfieldset[disabled] .btn-primary.focus {\n  background-color: #337ab7;\n  border-color: #2e6da4;\n}\n.btn-primary .badge {\n  color: #337ab7;\n  background-color: #fff;\n}\n.btn-success {\n  color: #fff;\n  background-color: #5cb85c;\n  border-color: #4cae4c;\n}\n.btn-success:focus,\n.btn-success.focus {\n  color: #fff;\n  background-color: #449d44;\n  border-color: #255625;\n}\n.btn-success:hover {\n  color: #fff;\n  background-color: #449d44;\n  border-color: #398439;\n}\n.btn-success:active,\n.btn-success.active,\n.open > .dropdown-toggle.btn-success {\n  color: #fff;\n  background-color: #449d44;\n  background-image: none;\n  border-color: #398439;\n}\n.btn-success:active:hover,\n.btn-success.active:hover,\n.open > .dropdown-toggle.btn-success:hover,\n.btn-success:active:focus,\n.btn-success.active:focus,\n.open > .dropdown-toggle.btn-success:focus,\n.btn-success:active.focus,\n.btn-success.active.focus,\n.open > .dropdown-toggle.btn-success.focus {\n  color: #fff;\n  background-color: #398439;\n  border-color: #255625;\n}\n.btn-success.disabled:hover,\n.btn-success[disabled]:hover,\nfieldset[disabled] .btn-success:hover,\n.btn-success.disabled:focus,\n.btn-success[disabled]:focus,\nfieldset[disabled] .btn-success:focus,\n.btn-success.disabled.focus,\n.btn-success[disabled].focus,\nfieldset[disabled] .btn-success.focus {\n  background-color: #5cb85c;\n  border-color: #4cae4c;\n}\n.btn-success .badge {\n  color: #5cb85c;\n  background-color: #fff;\n}\n.btn-info {\n  color: #fff;\n  background-color: #5bc0de;\n  border-color: #46b8da;\n}\n.btn-info:focus,\n.btn-info.focus {\n  color: #fff;\n  background-color: #31b0d5;\n  border-color: #1b6d85;\n}\n.btn-info:hover {\n  color: #fff;\n  background-color: #31b0d5;\n  border-color: #269abc;\n}\n.btn-info:active,\n.btn-info.active,\n.open > .dropdown-toggle.btn-info {\n  color: #fff;\n  background-color: #31b0d5;\n  background-image: none;\n  border-color: #269abc;\n}\n.btn-info:active:hover,\n.btn-info.active:hover,\n.open > .dropdown-toggle.btn-info:hover,\n.btn-info:active:focus,\n.btn-info.active:focus,\n.open > .dropdown-toggle.btn-info:focus,\n.btn-info:active.focus,\n.btn-info.active.focus,\n.open > .dropdown-toggle.btn-info.focus {\n  color: #fff;\n  background-color: #269abc;\n  border-color: #1b6d85;\n}\n.btn-info.disabled:hover,\n.btn-info[disabled]:hover,\nfieldset[disabled] .btn-info:hover,\n.btn-info.disabled:focus,\n.btn-info[disabled]:focus,\nfieldset[disabled] .btn-info:focus,\n.btn-info.disabled.focus,\n.btn-info[disabled].focus,\nfieldset[disabled] .btn-info.focus {\n  background-color: #5bc0de;\n  border-color: #46b8da;\n}\n.btn-info .badge {\n  color: #5bc0de;\n  background-color: #fff;\n}\n.btn-warning {\n  color: #fff;\n  background-color: #f0ad4e;\n  border-color: #eea236;\n}\n.btn-warning:focus,\n.btn-warning.focus {\n  color: #fff;\n  background-color: #ec971f;\n  border-color: #985f0d;\n}\n.btn-warning:hover {\n  color: #fff;\n  background-color: #ec971f;\n  border-color: #d58512;\n}\n.btn-warning:active,\n.btn-warning.active,\n.open > .dropdown-toggle.btn-warning {\n  color: #fff;\n  background-color: #ec971f;\n  background-image: none;\n  border-color: #d58512;\n}\n.btn-warning:active:hover,\n.btn-warning.active:hover,\n.open > .dropdown-toggle.btn-warning:hover,\n.btn-warning:active:focus,\n.btn-warning.active:focus,\n.open > .dropdown-toggle.btn-warning:focus,\n.btn-warning:active.focus,\n.btn-warning.active.focus,\n.open > .dropdown-toggle.btn-warning.focus {\n  color: #fff;\n  background-color: #d58512;\n  border-color: #985f0d;\n}\n.btn-warning.disabled:hover,\n.btn-warning[disabled]:hover,\nfieldset[disabled] .btn-warning:hover,\n.btn-warning.disabled:focus,\n.btn-warning[disabled]:focus,\nfieldset[disabled] .btn-warning:focus,\n.btn-warning.disabled.focus,\n.btn-warning[disabled].focus,\nfieldset[disabled] .btn-warning.focus {\n  background-color: #f0ad4e;\n  border-color: #eea236;\n}\n.btn-warning .badge {\n  color: #f0ad4e;\n  background-color: #fff;\n}\n.btn-danger {\n  color: #fff;\n  background-color: #d9534f;\n  border-color: #d43f3a;\n}\n.btn-danger:focus,\n.btn-danger.focus {\n  color: #fff;\n  background-color: #c9302c;\n  border-color: #761c19;\n}\n.btn-danger:hover {\n  color: #fff;\n  background-color: #c9302c;\n  border-color: #ac2925;\n}\n.btn-danger:active,\n.btn-danger.active,\n.open > .dropdown-toggle.btn-danger {\n  color: #fff;\n  background-color: #c9302c;\n  background-image: none;\n  border-color: #ac2925;\n}\n.btn-danger:active:hover,\n.btn-danger.active:hover,\n.open > .dropdown-toggle.btn-danger:hover,\n.btn-danger:active:focus,\n.btn-danger.active:focus,\n.open > .dropdown-toggle.btn-danger:focus,\n.btn-danger:active.focus,\n.btn-danger.active.focus,\n.open > .dropdown-toggle.btn-danger.focus {\n  color: #fff;\n  background-color: #ac2925;\n  border-color: #761c19;\n}\n.btn-danger.disabled:hover,\n.btn-danger[disabled]:hover,\nfieldset[disabled] .btn-danger:hover,\n.btn-danger.disabled:focus,\n.btn-danger[disabled]:focus,\nfieldset[disabled] .btn-danger:focus,\n.btn-danger.disabled.focus,\n.btn-danger[disabled].focus,\nfieldset[disabled] .btn-danger.focus {\n  background-color: #d9534f;\n  border-color: #d43f3a;\n}\n.btn-danger .badge {\n  color: #d9534f;\n  background-color: #fff;\n}\n.btn-link {\n  font-weight: 400;\n  color: #296eaa;\n  border-radius: 0;\n}\n.btn-link,\n.btn-link:active,\n.btn-link.active,\n.btn-link[disabled],\nfieldset[disabled] .btn-link {\n  background-color: transparent;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n}\n.btn-link,\n.btn-link:hover,\n.btn-link:focus,\n.btn-link:active {\n  border-color: transparent;\n}\n.btn-link:hover,\n.btn-link:focus {\n  color: #1a466c;\n  text-decoration: underline;\n  background-color: transparent;\n}\n.btn-link[disabled]:hover,\nfieldset[disabled] .btn-link:hover,\n.btn-link[disabled]:focus,\nfieldset[disabled] .btn-link:focus {\n  color: #777777;\n  text-decoration: none;\n}\n.btn-lg,\n.btn-group-lg > .btn {\n  padding: 10px 16px;\n  font-size: 17px;\n  line-height: 1.3333333;\n  border-radius: 3px;\n}\n.btn-sm,\n.btn-group-sm > .btn {\n  padding: 5px 10px;\n  font-size: 12px;\n  line-height: 1.5;\n  border-radius: 1px;\n}\n.btn-xs,\n.btn-group-xs > .btn {\n  padding: 1px 5px;\n  font-size: 12px;\n  line-height: 1.5;\n  border-radius: 1px;\n}\n.btn-block {\n  display: block;\n  width: 100%;\n}\n.btn-block + .btn-block {\n  margin-top: 5px;\n}\ninput[type=\"submit\"].btn-block,\ninput[type=\"reset\"].btn-block,\ninput[type=\"button\"].btn-block {\n  width: 100%;\n}\n.fade {\n  opacity: 0;\n  -webkit-transition: opacity 0.15s linear;\n  -o-transition: opacity 0.15s linear;\n  transition: opacity 0.15s linear;\n}\n.fade.in {\n  opacity: 1;\n}\n.collapse {\n  display: none;\n}\n.collapse.in {\n  display: block;\n}\ntr.collapse.in {\n  display: table-row;\n}\ntbody.collapse.in {\n  display: table-row-group;\n}\n.collapsing {\n  position: relative;\n  height: 0;\n  overflow: hidden;\n  -webkit-transition-property: height, visibility;\n  transition-property: height, visibility;\n  -webkit-transition-duration: 0.35s;\n  transition-duration: 0.35s;\n  -webkit-transition-timing-function: ease;\n  transition-timing-function: ease;\n}\n.caret {\n  display: inline-block;\n  width: 0;\n  height: 0;\n  margin-left: 2px;\n  vertical-align: middle;\n  border-top: 4px dashed;\n  border-top: 4px solid \\9;\n  border-right: 4px solid transparent;\n  border-left: 4px solid transparent;\n}\n.dropup,\n.dropdown {\n  position: relative;\n}\n.dropdown-toggle:focus {\n  outline: 0;\n}\n.dropdown-menu {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  z-index: 1000;\n  display: none;\n  float: left;\n  min-width: 160px;\n  padding: 5px 0;\n  margin: 2px 0 0;\n  font-size: 13px;\n  text-align: left;\n  list-style: none;\n  background-color: #fff;\n  background-clip: padding-box;\n  border: 1px solid #ccc;\n  border: 1px solid rgba(0, 0, 0, 0.15);\n  border-radius: 2px;\n  -webkit-box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);\n  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);\n}\n.dropdown-menu.pull-right {\n  right: 0;\n  left: auto;\n}\n.dropdown-menu .divider {\n  height: 1px;\n  margin: 8px 0;\n  overflow: hidden;\n  background-color: #e5e5e5;\n}\n.dropdown-menu > li > a {\n  display: block;\n  padding: 3px 20px;\n  clear: both;\n  font-weight: 400;\n  line-height: 1.42857143;\n  color: #333333;\n  white-space: nowrap;\n}\n.dropdown-menu > li > a:hover,\n.dropdown-menu > li > a:focus {\n  color: #262626;\n  text-decoration: none;\n  background-color: #f5f5f5;\n}\n.dropdown-menu > .active > a,\n.dropdown-menu > .active > a:hover,\n.dropdown-menu > .active > a:focus {\n  color: #fff;\n  text-decoration: none;\n  background-color: #337ab7;\n  outline: 0;\n}\n.dropdown-menu > .disabled > a,\n.dropdown-menu > .disabled > a:hover,\n.dropdown-menu > .disabled > a:focus {\n  color: #777777;\n}\n.dropdown-menu > .disabled > a:hover,\n.dropdown-menu > .disabled > a:focus {\n  text-decoration: none;\n  cursor: not-allowed;\n  background-color: transparent;\n  background-image: none;\n  filter: progid:DXImageTransform.Microsoft.gradient(enabled = false);\n}\n.open > .dropdown-menu {\n  display: block;\n}\n.open > a {\n  outline: 0;\n}\n.dropdown-menu-right {\n  right: 0;\n  left: auto;\n}\n.dropdown-menu-left {\n  right: auto;\n  left: 0;\n}\n.dropdown-header {\n  display: block;\n  padding: 3px 20px;\n  font-size: 12px;\n  line-height: 1.42857143;\n  color: #777777;\n  white-space: nowrap;\n}\n.dropdown-backdrop {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 990;\n}\n.pull-right > .dropdown-menu {\n  right: 0;\n  left: auto;\n}\n.dropup .caret,\n.navbar-fixed-bottom .dropdown .caret {\n  content: \"\";\n  border-top: 0;\n  border-bottom: 4px dashed;\n  border-bottom: 4px solid \\9;\n}\n.dropup .dropdown-menu,\n.navbar-fixed-bottom .dropdown .dropdown-menu {\n  top: auto;\n  bottom: 100%;\n  margin-bottom: 2px;\n}\n@media (min-width: 541px) {\n  .navbar-right .dropdown-menu {\n    right: 0;\n    left: auto;\n  }\n  .navbar-right .dropdown-menu-left {\n    right: auto;\n    left: 0;\n  }\n}\n.btn-group,\n.btn-group-vertical {\n  position: relative;\n  display: inline-block;\n  vertical-align: middle;\n}\n.btn-group > .btn,\n.btn-group-vertical > .btn {\n  position: relative;\n  float: left;\n}\n.btn-group > .btn:hover,\n.btn-group-vertical > .btn:hover,\n.btn-group > .btn:focus,\n.btn-group-vertical > .btn:focus,\n.btn-group > .btn:active,\n.btn-group-vertical > .btn:active,\n.btn-group > .btn.active,\n.btn-group-vertical > .btn.active {\n  z-index: 2;\n}\n.btn-group .btn + .btn,\n.btn-group .btn + .btn-group,\n.btn-group .btn-group + .btn,\n.btn-group .btn-group + .btn-group {\n  margin-left: -1px;\n}\n.btn-toolbar {\n  margin-left: -5px;\n}\n.btn-toolbar .btn,\n.btn-toolbar .btn-group,\n.btn-toolbar .input-group {\n  float: left;\n}\n.btn-toolbar > .btn,\n.btn-toolbar > .btn-group,\n.btn-toolbar > .input-group {\n  margin-left: 5px;\n}\n.btn-group > .btn:not(:first-child):not(:last-child):not(.dropdown-toggle) {\n  border-radius: 0;\n}\n.btn-group > .btn:first-child {\n  margin-left: 0;\n}\n.btn-group > .btn:first-child:not(:last-child):not(.dropdown-toggle) {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.btn-group > .btn:last-child:not(:first-child),\n.btn-group > .dropdown-toggle:not(:first-child) {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.btn-group > .btn-group {\n  float: left;\n}\n.btn-group > .btn-group:not(:first-child):not(:last-child) > .btn {\n  border-radius: 0;\n}\n.btn-group > .btn-group:first-child:not(:last-child) > .btn:last-child,\n.btn-group > .btn-group:first-child:not(:last-child) > .dropdown-toggle {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.btn-group > .btn-group:last-child:not(:first-child) > .btn:first-child {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.btn-group .dropdown-toggle:active,\n.btn-group.open .dropdown-toggle {\n  outline: 0;\n}\n.btn-group > .btn + .dropdown-toggle {\n  padding-right: 8px;\n  padding-left: 8px;\n}\n.btn-group > .btn-lg + .dropdown-toggle {\n  padding-right: 12px;\n  padding-left: 12px;\n}\n.btn-group.open .dropdown-toggle {\n  -webkit-box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n}\n.btn-group.open .dropdown-toggle.btn-link {\n  -webkit-box-shadow: none;\n  box-shadow: none;\n}\n.btn .caret {\n  margin-left: 0;\n}\n.btn-lg .caret {\n  border-width: 5px 5px 0;\n  border-bottom-width: 0;\n}\n.dropup .btn-lg .caret {\n  border-width: 0 5px 5px;\n}\n.btn-group-vertical > .btn,\n.btn-group-vertical > .btn-group,\n.btn-group-vertical > .btn-group > .btn {\n  display: block;\n  float: none;\n  width: 100%;\n  max-width: 100%;\n}\n.btn-group-vertical > .btn-group > .btn {\n  float: none;\n}\n.btn-group-vertical > .btn + .btn,\n.btn-group-vertical > .btn + .btn-group,\n.btn-group-vertical > .btn-group + .btn,\n.btn-group-vertical > .btn-group + .btn-group {\n  margin-top: -1px;\n  margin-left: 0;\n}\n.btn-group-vertical > .btn:not(:first-child):not(:last-child) {\n  border-radius: 0;\n}\n.btn-group-vertical > .btn:first-child:not(:last-child) {\n  border-top-left-radius: 2px;\n  border-top-right-radius: 2px;\n  border-bottom-right-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.btn-group-vertical > .btn:last-child:not(:first-child) {\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 2px;\n  border-bottom-left-radius: 2px;\n}\n.btn-group-vertical > .btn-group:not(:first-child):not(:last-child) > .btn {\n  border-radius: 0;\n}\n.btn-group-vertical > .btn-group:first-child:not(:last-child) > .btn:last-child,\n.btn-group-vertical > .btn-group:first-child:not(:last-child) > .dropdown-toggle {\n  border-bottom-right-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.btn-group-vertical > .btn-group:last-child:not(:first-child) > .btn:first-child {\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n.btn-group-justified {\n  display: table;\n  width: 100%;\n  table-layout: fixed;\n  border-collapse: separate;\n}\n.btn-group-justified > .btn,\n.btn-group-justified > .btn-group {\n  display: table-cell;\n  float: none;\n  width: 1%;\n}\n.btn-group-justified > .btn-group .btn {\n  width: 100%;\n}\n.btn-group-justified > .btn-group .dropdown-menu {\n  left: auto;\n}\n[data-toggle=\"buttons\"] > .btn input[type=\"radio\"],\n[data-toggle=\"buttons\"] > .btn-group > .btn input[type=\"radio\"],\n[data-toggle=\"buttons\"] > .btn input[type=\"checkbox\"],\n[data-toggle=\"buttons\"] > .btn-group > .btn input[type=\"checkbox\"] {\n  position: absolute;\n  clip: rect(0, 0, 0, 0);\n  pointer-events: none;\n}\n.input-group {\n  position: relative;\n  display: table;\n  border-collapse: separate;\n}\n.input-group[class*=\"col-\"] {\n  float: none;\n  padding-right: 0;\n  padding-left: 0;\n}\n.input-group .form-control {\n  position: relative;\n  z-index: 2;\n  float: left;\n  width: 100%;\n  margin-bottom: 0;\n}\n.input-group .form-control:focus {\n  z-index: 3;\n}\n.input-group-lg > .form-control,\n.input-group-lg > .input-group-addon,\n.input-group-lg > .input-group-btn > .btn {\n  height: 45px;\n  padding: 10px 16px;\n  font-size: 17px;\n  line-height: 1.3333333;\n  border-radius: 3px;\n}\nselect.input-group-lg > .form-control,\nselect.input-group-lg > .input-group-addon,\nselect.input-group-lg > .input-group-btn > .btn {\n  height: 45px;\n  line-height: 45px;\n}\ntextarea.input-group-lg > .form-control,\ntextarea.input-group-lg > .input-group-addon,\ntextarea.input-group-lg > .input-group-btn > .btn,\nselect[multiple].input-group-lg > .form-control,\nselect[multiple].input-group-lg > .input-group-addon,\nselect[multiple].input-group-lg > .input-group-btn > .btn {\n  height: auto;\n}\n.input-group-sm > .form-control,\n.input-group-sm > .input-group-addon,\n.input-group-sm > .input-group-btn > .btn {\n  height: 30px;\n  padding: 5px 10px;\n  font-size: 12px;\n  line-height: 1.5;\n  border-radius: 1px;\n}\nselect.input-group-sm > .form-control,\nselect.input-group-sm > .input-group-addon,\nselect.input-group-sm > .input-group-btn > .btn {\n  height: 30px;\n  line-height: 30px;\n}\ntextarea.input-group-sm > .form-control,\ntextarea.input-group-sm > .input-group-addon,\ntextarea.input-group-sm > .input-group-btn > .btn,\nselect[multiple].input-group-sm > .form-control,\nselect[multiple].input-group-sm > .input-group-addon,\nselect[multiple].input-group-sm > .input-group-btn > .btn {\n  height: auto;\n}\n.input-group-addon,\n.input-group-btn,\n.input-group .form-control {\n  display: table-cell;\n}\n.input-group-addon:not(:first-child):not(:last-child),\n.input-group-btn:not(:first-child):not(:last-child),\n.input-group .form-control:not(:first-child):not(:last-child) {\n  border-radius: 0;\n}\n.input-group-addon,\n.input-group-btn {\n  width: 1%;\n  white-space: nowrap;\n  vertical-align: middle;\n}\n.input-group-addon {\n  padding: 6px 12px;\n  font-size: 13px;\n  font-weight: 400;\n  line-height: 1;\n  color: #555555;\n  text-align: center;\n  background-color: #eeeeee;\n  border: 1px solid #ccc;\n  border-radius: 2px;\n}\n.input-group-addon.input-sm {\n  padding: 5px 10px;\n  font-size: 12px;\n  border-radius: 1px;\n}\n.input-group-addon.input-lg {\n  padding: 10px 16px;\n  font-size: 17px;\n  border-radius: 3px;\n}\n.input-group-addon input[type=\"radio\"],\n.input-group-addon input[type=\"checkbox\"] {\n  margin-top: 0;\n}\n.input-group .form-control:first-child,\n.input-group-addon:first-child,\n.input-group-btn:first-child > .btn,\n.input-group-btn:first-child > .btn-group > .btn,\n.input-group-btn:first-child > .dropdown-toggle,\n.input-group-btn:last-child > .btn:not(:last-child):not(.dropdown-toggle),\n.input-group-btn:last-child > .btn-group:not(:last-child) > .btn {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.input-group-addon:first-child {\n  border-right: 0;\n}\n.input-group .form-control:last-child,\n.input-group-addon:last-child,\n.input-group-btn:last-child > .btn,\n.input-group-btn:last-child > .btn-group > .btn,\n.input-group-btn:last-child > .dropdown-toggle,\n.input-group-btn:first-child > .btn:not(:first-child),\n.input-group-btn:first-child > .btn-group:not(:first-child) > .btn {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.input-group-addon:last-child {\n  border-left: 0;\n}\n.input-group-btn {\n  position: relative;\n  font-size: 0;\n  white-space: nowrap;\n}\n.input-group-btn > .btn {\n  position: relative;\n}\n.input-group-btn > .btn + .btn {\n  margin-left: -1px;\n}\n.input-group-btn > .btn:hover,\n.input-group-btn > .btn:focus,\n.input-group-btn > .btn:active {\n  z-index: 2;\n}\n.input-group-btn:first-child > .btn,\n.input-group-btn:first-child > .btn-group {\n  margin-right: -1px;\n}\n.input-group-btn:last-child > .btn,\n.input-group-btn:last-child > .btn-group {\n  z-index: 2;\n  margin-left: -1px;\n}\n.nav {\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n}\n.nav > li {\n  position: relative;\n  display: block;\n}\n.nav > li > a {\n  position: relative;\n  display: block;\n  padding: 10px 15px;\n}\n.nav > li > a:hover,\n.nav > li > a:focus {\n  text-decoration: none;\n  background-color: #eeeeee;\n}\n.nav > li.disabled > a {\n  color: #777777;\n}\n.nav > li.disabled > a:hover,\n.nav > li.disabled > a:focus {\n  color: #777777;\n  text-decoration: none;\n  cursor: not-allowed;\n  background-color: transparent;\n}\n.nav .open > a,\n.nav .open > a:hover,\n.nav .open > a:focus {\n  background-color: #eeeeee;\n  border-color: #296eaa;\n}\n.nav .nav-divider {\n  height: 1px;\n  margin: 8px 0;\n  overflow: hidden;\n  background-color: #e5e5e5;\n}\n.nav > li > a > img {\n  max-width: none;\n}\n.nav-tabs {\n  border-bottom: 1px solid #ddd;\n}\n.nav-tabs > li {\n  float: left;\n  margin-bottom: -1px;\n}\n.nav-tabs > li > a {\n  margin-right: 2px;\n  line-height: 1.42857143;\n  border: 1px solid transparent;\n  border-radius: 2px 2px 0 0;\n}\n.nav-tabs > li > a:hover {\n  border-color: #eeeeee #eeeeee #ddd;\n}\n.nav-tabs > li.active > a,\n.nav-tabs > li.active > a:hover,\n.nav-tabs > li.active > a:focus {\n  color: #555555;\n  cursor: default;\n  background-color: var(--body-bg);\n  border: 1px solid #ddd;\n  border-bottom-color: transparent;\n}\n.nav-tabs.nav-justified {\n  width: 100%;\n  border-bottom: 0;\n}\n.nav-tabs.nav-justified > li {\n  float: none;\n}\n.nav-tabs.nav-justified > li > a {\n  margin-bottom: 5px;\n  text-align: center;\n}\n.nav-tabs.nav-justified > .dropdown .dropdown-menu {\n  top: auto;\n  left: auto;\n}\n@media (min-width: 768px) {\n  .nav-tabs.nav-justified > li {\n    display: table-cell;\n    width: 1%;\n  }\n  .nav-tabs.nav-justified > li > a {\n    margin-bottom: 0;\n  }\n}\n.nav-tabs.nav-justified > li > a {\n  margin-right: 0;\n  border-radius: 2px;\n}\n.nav-tabs.nav-justified > .active > a,\n.nav-tabs.nav-justified > .active > a:hover,\n.nav-tabs.nav-justified > .active > a:focus {\n  border: 1px solid #ddd;\n}\n@media (min-width: 768px) {\n  .nav-tabs.nav-justified > li > a {\n    border-bottom: 1px solid #ddd;\n    border-radius: 2px 2px 0 0;\n  }\n  .nav-tabs.nav-justified > .active > a,\n  .nav-tabs.nav-justified > .active > a:hover,\n  .nav-tabs.nav-justified > .active > a:focus {\n    border-bottom-color: var(--body-bg);\n  }\n}\n.nav-pills > li {\n  float: left;\n}\n.nav-pills > li > a {\n  border-radius: 2px;\n}\n.nav-pills > li + li {\n  margin-left: 2px;\n}\n.nav-pills > li.active > a,\n.nav-pills > li.active > a:hover,\n.nav-pills > li.active > a:focus {\n  color: #fff;\n  background-color: #337ab7;\n}\n.nav-stacked > li {\n  float: none;\n}\n.nav-stacked > li + li {\n  margin-top: 2px;\n  margin-left: 0;\n}\n.nav-justified {\n  width: 100%;\n}\n.nav-justified > li {\n  float: none;\n}\n.nav-justified > li > a {\n  margin-bottom: 5px;\n  text-align: center;\n}\n.nav-justified > .dropdown .dropdown-menu {\n  top: auto;\n  left: auto;\n}\n@media (min-width: 768px) {\n  .nav-justified > li {\n    display: table-cell;\n    width: 1%;\n  }\n  .nav-justified > li > a {\n    margin-bottom: 0;\n  }\n}\n.nav-tabs-justified {\n  border-bottom: 0;\n}\n.nav-tabs-justified > li > a {\n  margin-right: 0;\n  border-radius: 2px;\n}\n.nav-tabs-justified > .active > a,\n.nav-tabs-justified > .active > a:hover,\n.nav-tabs-justified > .active > a:focus {\n  border: 1px solid #ddd;\n}\n@media (min-width: 768px) {\n  .nav-tabs-justified > li > a {\n    border-bottom: 1px solid #ddd;\n    border-radius: 2px 2px 0 0;\n  }\n  .nav-tabs-justified > .active > a,\n  .nav-tabs-justified > .active > a:hover,\n  .nav-tabs-justified > .active > a:focus {\n    border-bottom-color: var(--body-bg);\n  }\n}\n.tab-content > .tab-pane {\n  display: none;\n}\n.tab-content > .active {\n  display: block;\n}\n.nav-tabs .dropdown-menu {\n  margin-top: -1px;\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n.navbar {\n  position: relative;\n  min-height: 30px;\n  margin-bottom: 18px;\n  border: 1px solid transparent;\n}\n@media (min-width: 541px) {\n  .navbar {\n    border-radius: 2px;\n  }\n}\n@media (min-width: 541px) {\n  .navbar-header {\n    float: left;\n  }\n}\n.navbar-collapse {\n  padding-right: 0px;\n  padding-left: 0px;\n  overflow-x: visible;\n  border-top: 1px solid transparent;\n  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.1);\n  -webkit-overflow-scrolling: touch;\n}\n.navbar-collapse.in {\n  overflow-y: auto;\n}\n@media (min-width: 541px) {\n  .navbar-collapse {\n    width: auto;\n    border-top: 0;\n    box-shadow: none;\n  }\n  .navbar-collapse.collapse {\n    display: block !important;\n    height: auto !important;\n    padding-bottom: 0;\n    overflow: visible !important;\n  }\n  .navbar-collapse.in {\n    overflow-y: visible;\n  }\n  .navbar-fixed-top .navbar-collapse,\n  .navbar-static-top .navbar-collapse,\n  .navbar-fixed-bottom .navbar-collapse {\n    padding-right: 0;\n    padding-left: 0;\n  }\n}\n.navbar-fixed-top,\n.navbar-fixed-bottom {\n  position: fixed;\n  right: 0;\n  left: 0;\n  z-index: 1030;\n}\n.navbar-fixed-top .navbar-collapse,\n.navbar-fixed-bottom .navbar-collapse {\n  max-height: 340px;\n}\n@media (max-device-width: 540px) and (orientation: landscape) {\n  .navbar-fixed-top .navbar-collapse,\n  .navbar-fixed-bottom .navbar-collapse {\n    max-height: 200px;\n  }\n}\n@media (min-width: 541px) {\n  .navbar-fixed-top,\n  .navbar-fixed-bottom {\n    border-radius: 0;\n  }\n}\n.navbar-fixed-top {\n  top: 0;\n  border-width: 0 0 1px;\n}\n.navbar-fixed-bottom {\n  bottom: 0;\n  margin-bottom: 0;\n  border-width: 1px 0 0;\n}\n.container > .navbar-header,\n.container-fluid > .navbar-header,\n.container > .navbar-collapse,\n.container-fluid > .navbar-collapse {\n  margin-right: 0px;\n  margin-left: 0px;\n}\n@media (min-width: 541px) {\n  .container > .navbar-header,\n  .container-fluid > .navbar-header,\n  .container > .navbar-collapse,\n  .container-fluid > .navbar-collapse {\n    margin-right: 0;\n    margin-left: 0;\n  }\n}\n.navbar-static-top {\n  z-index: 1000;\n  border-width: 0 0 1px;\n}\n@media (min-width: 541px) {\n  .navbar-static-top {\n    border-radius: 0;\n  }\n}\n.navbar-brand {\n  float: left;\n  height: 30px;\n  padding: 6px 0px;\n  font-size: 17px;\n  line-height: 18px;\n}\n.navbar-brand:hover,\n.navbar-brand:focus {\n  text-decoration: none;\n}\n.navbar-brand > img {\n  display: block;\n}\n@media (min-width: 541px) {\n  .navbar > .container .navbar-brand,\n  .navbar > .container-fluid .navbar-brand {\n    margin-left: 0px;\n  }\n}\n.navbar-toggle {\n  position: relative;\n  float: right;\n  padding: 9px 10px;\n  margin-right: 0px;\n  margin-top: -2px;\n  margin-bottom: -2px;\n  background-color: transparent;\n  background-image: none;\n  border: 1px solid transparent;\n  border-radius: 2px;\n}\n.navbar-toggle:focus {\n  outline: 0;\n}\n.navbar-toggle .icon-bar {\n  display: block;\n  width: 22px;\n  height: 2px;\n  border-radius: 1px;\n}\n.navbar-toggle .icon-bar + .icon-bar {\n  margin-top: 4px;\n}\n@media (min-width: 541px) {\n  .navbar-toggle {\n    display: none;\n  }\n}\n.navbar-nav {\n  margin: 3px 0px;\n}\n.navbar-nav > li > a {\n  padding-top: 10px;\n  padding-bottom: 10px;\n  line-height: 18px;\n}\n@media (max-width: 540px) {\n  .navbar-nav .open .dropdown-menu {\n    position: static;\n    float: none;\n    width: auto;\n    margin-top: 0;\n    background-color: transparent;\n    border: 0;\n    box-shadow: none;\n  }\n  .navbar-nav .open .dropdown-menu > li > a,\n  .navbar-nav .open .dropdown-menu .dropdown-header {\n    padding: 5px 15px 5px 25px;\n  }\n  .navbar-nav .open .dropdown-menu > li > a {\n    line-height: 18px;\n  }\n  .navbar-nav .open .dropdown-menu > li > a:hover,\n  .navbar-nav .open .dropdown-menu > li > a:focus {\n    background-image: none;\n  }\n}\n@media (min-width: 541px) {\n  .navbar-nav {\n    float: left;\n    margin: 0;\n  }\n  .navbar-nav > li {\n    float: left;\n  }\n  .navbar-nav > li > a {\n    padding-top: 6px;\n    padding-bottom: 6px;\n  }\n}\n.navbar-form {\n  padding: 10px 0px;\n  margin-right: 0px;\n  margin-left: 0px;\n  border-top: 1px solid transparent;\n  border-bottom: 1px solid transparent;\n  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.1), 0 1px 0 rgba(255, 255, 255, 0.1);\n  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.1), 0 1px 0 rgba(255, 255, 255, 0.1);\n  margin-top: -1px;\n  margin-bottom: -1px;\n}\n@media (min-width: 768px) {\n  .navbar-form .form-group {\n    display: inline-block;\n    margin-bottom: 0;\n    vertical-align: middle;\n  }\n  .navbar-form .form-control {\n    display: inline-block;\n    width: auto;\n    vertical-align: middle;\n  }\n  .navbar-form .form-control-static {\n    display: inline-block;\n  }\n  .navbar-form .input-group {\n    display: inline-table;\n    vertical-align: middle;\n  }\n  .navbar-form .input-group .input-group-addon,\n  .navbar-form .input-group .input-group-btn,\n  .navbar-form .input-group .form-control {\n    width: auto;\n  }\n  .navbar-form .input-group > .form-control {\n    width: 100%;\n  }\n  .navbar-form .control-label {\n    margin-bottom: 0;\n    vertical-align: middle;\n  }\n  .navbar-form .radio,\n  .navbar-form .checkbox {\n    display: inline-block;\n    margin-top: 0;\n    margin-bottom: 0;\n    vertical-align: middle;\n  }\n  .navbar-form .radio label,\n  .navbar-form .checkbox label {\n    padding-left: 0;\n  }\n  .navbar-form .radio input[type=\"radio\"],\n  .navbar-form .checkbox input[type=\"checkbox\"] {\n    position: relative;\n    margin-left: 0;\n  }\n  .navbar-form .has-feedback .form-control-feedback {\n    top: 0;\n  }\n}\n@media (max-width: 540px) {\n  .navbar-form .form-group {\n    margin-bottom: 5px;\n  }\n  .navbar-form .form-group:last-child {\n    margin-bottom: 0;\n  }\n}\n@media (min-width: 541px) {\n  .navbar-form {\n    width: auto;\n    padding-top: 0;\n    padding-bottom: 0;\n    margin-right: 0;\n    margin-left: 0;\n    border: 0;\n    -webkit-box-shadow: none;\n    box-shadow: none;\n  }\n}\n.navbar-nav > li > .dropdown-menu {\n  margin-top: 0;\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n.navbar-fixed-bottom .navbar-nav > li > .dropdown-menu {\n  margin-bottom: 0;\n  border-top-left-radius: 2px;\n  border-top-right-radius: 2px;\n  border-bottom-right-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.navbar-btn {\n  margin-top: -1px;\n  margin-bottom: -1px;\n}\n.navbar-btn.btn-sm {\n  margin-top: 0px;\n  margin-bottom: 0px;\n}\n.navbar-btn.btn-xs {\n  margin-top: 4px;\n  margin-bottom: 4px;\n}\n.navbar-text {\n  margin-top: 6px;\n  margin-bottom: 6px;\n}\n@media (min-width: 541px) {\n  .navbar-text {\n    float: left;\n    margin-right: 0px;\n    margin-left: 0px;\n  }\n}\n@media (min-width: 541px) {\n  .navbar-left {\n    float: left !important;\n    float: left;\n  }\n  .navbar-right {\n    float: right !important;\n    float: right;\n    margin-right: 0px;\n  }\n  .navbar-right ~ .navbar-right {\n    margin-right: 0;\n  }\n}\n.navbar-default {\n  background-color: #f8f8f8;\n  border-color: var(--navbar-default-border);\n}\n.navbar-default .navbar-brand {\n  color: #565656;\n}\n.navbar-default .navbar-brand:hover,\n.navbar-default .navbar-brand:focus {\n  color: #3c3c3c;\n  background-color: transparent;\n}\n.navbar-default .navbar-text {\n  color: #777;\n}\n.navbar-default .navbar-nav > li > a {\n  color: #565656;\n}\n.navbar-default .navbar-nav > li > a:hover,\n.navbar-default .navbar-nav > li > a:focus {\n  color: #333;\n  background-color: transparent;\n}\n.navbar-default .navbar-nav > .active > a,\n.navbar-default .navbar-nav > .active > a:hover,\n.navbar-default .navbar-nav > .active > a:focus {\n  color: #555;\n  background-color: #e7e7e7;\n}\n.navbar-default .navbar-nav > .disabled > a,\n.navbar-default .navbar-nav > .disabled > a:hover,\n.navbar-default .navbar-nav > .disabled > a:focus {\n  color: #ccc;\n  background-color: transparent;\n}\n.navbar-default .navbar-nav > .open > a,\n.navbar-default .navbar-nav > .open > a:hover,\n.navbar-default .navbar-nav > .open > a:focus {\n  color: #555;\n  background-color: #e7e7e7;\n}\n@media (max-width: 540px) {\n  .navbar-default .navbar-nav .open .dropdown-menu > li > a {\n    color: #565656;\n  }\n  .navbar-default .navbar-nav .open .dropdown-menu > li > a:hover,\n  .navbar-default .navbar-nav .open .dropdown-menu > li > a:focus {\n    color: #333;\n    background-color: transparent;\n  }\n  .navbar-default .navbar-nav .open .dropdown-menu > .active > a,\n  .navbar-default .navbar-nav .open .dropdown-menu > .active > a:hover,\n  .navbar-default .navbar-nav .open .dropdown-menu > .active > a:focus {\n    color: #555;\n    background-color: #e7e7e7;\n  }\n  .navbar-default .navbar-nav .open .dropdown-menu > .disabled > a,\n  .navbar-default .navbar-nav .open .dropdown-menu > .disabled > a:hover,\n  .navbar-default .navbar-nav .open .dropdown-menu > .disabled > a:focus {\n    color: #ccc;\n    background-color: transparent;\n  }\n}\n.navbar-default .navbar-toggle {\n  border-color: #ddd;\n}\n.navbar-default .navbar-toggle:hover,\n.navbar-default .navbar-toggle:focus {\n  background-color: #ddd;\n}\n.navbar-default .navbar-toggle .icon-bar {\n  background-color: #888;\n}\n.navbar-default .navbar-collapse,\n.navbar-default .navbar-form {\n  border-color: var(--navbar-default-border);\n}\n.navbar-default .navbar-link {\n  color: #565656;\n}\n.navbar-default .navbar-link:hover {\n  color: #333;\n}\n.navbar-default .btn-link {\n  color: #565656;\n}\n.navbar-default .btn-link:hover,\n.navbar-default .btn-link:focus {\n  color: #333;\n}\n.navbar-default .btn-link[disabled]:hover,\nfieldset[disabled] .navbar-default .btn-link:hover,\n.navbar-default .btn-link[disabled]:focus,\nfieldset[disabled] .navbar-default .btn-link:focus {\n  color: #ccc;\n}\n.navbar-inverse {\n  background-color: #222;\n  border-color: #080808;\n}\n.navbar-inverse .navbar-brand {\n  color: #9d9d9d;\n}\n.navbar-inverse .navbar-brand:hover,\n.navbar-inverse .navbar-brand:focus {\n  color: #fff;\n  background-color: transparent;\n}\n.navbar-inverse .navbar-text {\n  color: #9d9d9d;\n}\n.navbar-inverse .navbar-nav > li > a {\n  color: #9d9d9d;\n}\n.navbar-inverse .navbar-nav > li > a:hover,\n.navbar-inverse .navbar-nav > li > a:focus {\n  color: #fff;\n  background-color: transparent;\n}\n.navbar-inverse .navbar-nav > .active > a,\n.navbar-inverse .navbar-nav > .active > a:hover,\n.navbar-inverse .navbar-nav > .active > a:focus {\n  color: #fff;\n  background-color: #080808;\n}\n.navbar-inverse .navbar-nav > .disabled > a,\n.navbar-inverse .navbar-nav > .disabled > a:hover,\n.navbar-inverse .navbar-nav > .disabled > a:focus {\n  color: #444;\n  background-color: transparent;\n}\n.navbar-inverse .navbar-nav > .open > a,\n.navbar-inverse .navbar-nav > .open > a:hover,\n.navbar-inverse .navbar-nav > .open > a:focus {\n  color: #fff;\n  background-color: #080808;\n}\n@media (max-width: 540px) {\n  .navbar-inverse .navbar-nav .open .dropdown-menu > .dropdown-header {\n    border-color: #080808;\n  }\n  .navbar-inverse .navbar-nav .open .dropdown-menu .divider {\n    background-color: #080808;\n  }\n  .navbar-inverse .navbar-nav .open .dropdown-menu > li > a {\n    color: #9d9d9d;\n  }\n  .navbar-inverse .navbar-nav .open .dropdown-menu > li > a:hover,\n  .navbar-inverse .navbar-nav .open .dropdown-menu > li > a:focus {\n    color: #fff;\n    background-color: transparent;\n  }\n  .navbar-inverse .navbar-nav .open .dropdown-menu > .active > a,\n  .navbar-inverse .navbar-nav .open .dropdown-menu > .active > a:hover,\n  .navbar-inverse .navbar-nav .open .dropdown-menu > .active > a:focus {\n    color: #fff;\n    background-color: #080808;\n  }\n  .navbar-inverse .navbar-nav .open .dropdown-menu > .disabled > a,\n  .navbar-inverse .navbar-nav .open .dropdown-menu > .disabled > a:hover,\n  .navbar-inverse .navbar-nav .open .dropdown-menu > .disabled > a:focus {\n    color: #444;\n    background-color: transparent;\n  }\n}\n.navbar-inverse .navbar-toggle {\n  border-color: #333;\n}\n.navbar-inverse .navbar-toggle:hover,\n.navbar-inverse .navbar-toggle:focus {\n  background-color: #333;\n}\n.navbar-inverse .navbar-toggle .icon-bar {\n  background-color: #fff;\n}\n.navbar-inverse .navbar-collapse,\n.navbar-inverse .navbar-form {\n  border-color: #101010;\n}\n.navbar-inverse .navbar-link {\n  color: #9d9d9d;\n}\n.navbar-inverse .navbar-link:hover {\n  color: #fff;\n}\n.navbar-inverse .btn-link {\n  color: #9d9d9d;\n}\n.navbar-inverse .btn-link:hover,\n.navbar-inverse .btn-link:focus {\n  color: #fff;\n}\n.navbar-inverse .btn-link[disabled]:hover,\nfieldset[disabled] .navbar-inverse .btn-link:hover,\n.navbar-inverse .btn-link[disabled]:focus,\nfieldset[disabled] .navbar-inverse .btn-link:focus {\n  color: #444;\n}\n.breadcrumb {\n  padding: 8px 15px;\n  margin-bottom: 18px;\n  list-style: none;\n  background-color: #f5f5f5;\n  border-radius: 2px;\n}\n.breadcrumb > li {\n  display: inline-block;\n}\n.breadcrumb > li + li:before {\n  padding: 0 5px;\n  color: hsl(var(--body-bg-hue), var(--body-bg-saturation), calc(var(--body-bg-light) - 63%));\n  content: \"/\\00a0\";\n}\n.breadcrumb > .active {\n  color: #777777;\n}\n.pagination {\n  display: inline-block;\n  padding-left: 0;\n  margin: 18px 0;\n  border-radius: 2px;\n}\n.pagination > li {\n  display: inline;\n}\n.pagination > li > a,\n.pagination > li > span {\n  position: relative;\n  float: left;\n  padding: 6px 12px;\n  margin-left: -1px;\n  line-height: 1.42857143;\n  color: #296eaa;\n  text-decoration: none;\n  background-color: #fff;\n  border: 1px solid #ddd;\n}\n.pagination > li > a:hover,\n.pagination > li > span:hover,\n.pagination > li > a:focus,\n.pagination > li > span:focus {\n  z-index: 2;\n  color: #1a466c;\n  background-color: #eeeeee;\n  border-color: #ddd;\n}\n.pagination > li:first-child > a,\n.pagination > li:first-child > span {\n  margin-left: 0;\n  border-top-left-radius: 2px;\n  border-bottom-left-radius: 2px;\n}\n.pagination > li:last-child > a,\n.pagination > li:last-child > span {\n  border-top-right-radius: 2px;\n  border-bottom-right-radius: 2px;\n}\n.pagination > .active > a,\n.pagination > .active > span,\n.pagination > .active > a:hover,\n.pagination > .active > span:hover,\n.pagination > .active > a:focus,\n.pagination > .active > span:focus {\n  z-index: 3;\n  color: #fff;\n  cursor: default;\n  background-color: #337ab7;\n  border-color: #337ab7;\n}\n.pagination > .disabled > span,\n.pagination > .disabled > span:hover,\n.pagination > .disabled > span:focus,\n.pagination > .disabled > a,\n.pagination > .disabled > a:hover,\n.pagination > .disabled > a:focus {\n  color: #777777;\n  cursor: not-allowed;\n  background-color: #fff;\n  border-color: #ddd;\n}\n.pagination-lg > li > a,\n.pagination-lg > li > span {\n  padding: 10px 16px;\n  font-size: 17px;\n  line-height: 1.3333333;\n}\n.pagination-lg > li:first-child > a,\n.pagination-lg > li:first-child > span {\n  border-top-left-radius: 3px;\n  border-bottom-left-radius: 3px;\n}\n.pagination-lg > li:last-child > a,\n.pagination-lg > li:last-child > span {\n  border-top-right-radius: 3px;\n  border-bottom-right-radius: 3px;\n}\n.pagination-sm > li > a,\n.pagination-sm > li > span {\n  padding: 5px 10px;\n  font-size: 12px;\n  line-height: 1.5;\n}\n.pagination-sm > li:first-child > a,\n.pagination-sm > li:first-child > span {\n  border-top-left-radius: 1px;\n  border-bottom-left-radius: 1px;\n}\n.pagination-sm > li:last-child > a,\n.pagination-sm > li:last-child > span {\n  border-top-right-radius: 1px;\n  border-bottom-right-radius: 1px;\n}\n.pager {\n  padding-left: 0;\n  margin: 18px 0;\n  text-align: center;\n  list-style: none;\n}\n.pager li {\n  display: inline;\n}\n.pager li > a,\n.pager li > span {\n  display: inline-block;\n  padding: 5px 14px;\n  background-color: #fff;\n  border: 1px solid #ddd;\n  border-radius: 15px;\n}\n.pager li > a:hover,\n.pager li > a:focus {\n  text-decoration: none;\n  background-color: #eeeeee;\n}\n.pager .next > a,\n.pager .next > span {\n  float: right;\n}\n.pager .previous > a,\n.pager .previous > span {\n  float: left;\n}\n.pager .disabled > a,\n.pager .disabled > a:hover,\n.pager .disabled > a:focus,\n.pager .disabled > span {\n  color: #777777;\n  cursor: not-allowed;\n  background-color: #fff;\n}\n.label {\n  display: inline;\n  padding: 0.2em 0.6em 0.3em;\n  font-size: 75%;\n  font-weight: 700;\n  line-height: 1;\n  color: #fff;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: baseline;\n  border-radius: 0.25em;\n}\na.label:hover,\na.label:focus {\n  color: #fff;\n  text-decoration: none;\n  cursor: pointer;\n}\n.label:empty {\n  display: none;\n}\n.btn .label {\n  position: relative;\n  top: -1px;\n}\n.label-default {\n  background-color: #777777;\n}\n.label-default[href]:hover,\n.label-default[href]:focus {\n  background-color: #5e5e5e;\n}\n.label-primary {\n  background-color: #337ab7;\n}\n.label-primary[href]:hover,\n.label-primary[href]:focus {\n  background-color: #286090;\n}\n.label-success {\n  background-color: #5cb85c;\n}\n.label-success[href]:hover,\n.label-success[href]:focus {\n  background-color: #449d44;\n}\n.label-info {\n  background-color: #5bc0de;\n}\n.label-info[href]:hover,\n.label-info[href]:focus {\n  background-color: #31b0d5;\n}\n.label-warning {\n  background-color: #f0ad4e;\n}\n.label-warning[href]:hover,\n.label-warning[href]:focus {\n  background-color: #ec971f;\n}\n.label-danger {\n  background-color: #d9534f;\n}\n.label-danger[href]:hover,\n.label-danger[href]:focus {\n  background-color: #c9302c;\n}\n.badge {\n  display: inline-block;\n  min-width: 10px;\n  padding: 3px 7px;\n  font-size: 12px;\n  font-weight: bold;\n  line-height: 1;\n  color: #fff;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: middle;\n  background-color: #777777;\n  border-radius: 10px;\n}\n.badge:empty {\n  display: none;\n}\n.btn .badge {\n  position: relative;\n  top: -1px;\n}\n.btn-xs .badge,\n.btn-group-xs > .btn .badge {\n  top: 0;\n  padding: 1px 5px;\n}\na.badge:hover,\na.badge:focus {\n  color: #fff;\n  text-decoration: none;\n  cursor: pointer;\n}\n.list-group-item.active > .badge,\n.nav-pills > .active > a > .badge {\n  color: #296eaa;\n  background-color: #fff;\n}\n.list-group-item > .badge {\n  float: right;\n}\n.list-group-item > .badge + .badge {\n  margin-right: 5px;\n}\n.nav-pills > li > a > .badge {\n  margin-left: 3px;\n}\n.jumbotron {\n  padding-top: 30px;\n  padding-bottom: 30px;\n  margin-bottom: 30px;\n  color: inherit;\n  background-color: #eeeeee;\n}\n.jumbotron h1,\n.jumbotron .h1 {\n  color: inherit;\n}\n.jumbotron p {\n  margin-bottom: 15px;\n  font-size: 20px;\n  font-weight: 200;\n}\n.jumbotron > hr {\n  border-top-color: #d5d5d5;\n}\n.container .jumbotron,\n.container-fluid .jumbotron {\n  padding-right: 0px;\n  padding-left: 0px;\n  border-radius: 3px;\n}\n.jumbotron .container {\n  max-width: 100%;\n}\n@media screen and (min-width: 768px) {\n  .jumbotron {\n    padding-top: 48px;\n    padding-bottom: 48px;\n  }\n  .container .jumbotron,\n  .container-fluid .jumbotron {\n    padding-right: 60px;\n    padding-left: 60px;\n  }\n  .jumbotron h1,\n  .jumbotron .h1 {\n    font-size: 59px;\n  }\n}\n.thumbnail {\n  display: block;\n  padding: 4px;\n  margin-bottom: 18px;\n  line-height: 1.42857143;\n  background-color: var(--body-bg);\n  border: 1px solid #ddd;\n  border-radius: 2px;\n  -webkit-transition: border 0.2s ease-in-out;\n  -o-transition: border 0.2s ease-in-out;\n  transition: border 0.2s ease-in-out;\n}\n.thumbnail > img,\n.thumbnail a > img {\n  margin-right: auto;\n  margin-left: auto;\n}\na.thumbnail:hover,\na.thumbnail:focus,\na.thumbnail.active {\n  border-color: #296eaa;\n}\n.thumbnail .caption {\n  padding: 9px;\n  color: black;\n}\n.alert {\n  padding: 15px;\n  margin-bottom: 18px;\n  border: 1px solid transparent;\n  border-radius: 2px;\n}\n.alert h4 {\n  margin-top: 0;\n  color: inherit;\n}\n.alert .alert-link {\n  font-weight: bold;\n}\n.alert > p,\n.alert > ul {\n  margin-bottom: 0;\n}\n.alert > p + p {\n  margin-top: 5px;\n}\n.alert-dismissable,\n.alert-dismissible {\n  padding-right: 35px;\n}\n.alert-dismissable .close,\n.alert-dismissible .close {\n  position: relative;\n  top: -2px;\n  right: -21px;\n  color: inherit;\n}\n.alert-success {\n  color: #3c763d;\n  background-color: #dff0d8;\n  border-color: #d6e9c6;\n}\n.alert-success hr {\n  border-top-color: #c9e2b3;\n}\n.alert-success .alert-link {\n  color: #2b542c;\n}\n.alert-info {\n  color: #31708f;\n  background-color: #d9edf7;\n  border-color: #bce8f1;\n}\n.alert-info hr {\n  border-top-color: #a6e1ec;\n}\n.alert-info .alert-link {\n  color: #245269;\n}\n.alert-warning {\n  color: #8a6d3b;\n  background-color: #fcf8e3;\n  border-color: #faebcc;\n}\n.alert-warning hr {\n  border-top-color: #f7e1b5;\n}\n.alert-warning .alert-link {\n  color: #66512c;\n}\n.alert-danger {\n  color: #a94442;\n  background-color: #f2dede;\n  border-color: #ebccd1;\n}\n.alert-danger hr {\n  border-top-color: #e4b9c0;\n}\n.alert-danger .alert-link {\n  color: #843534;\n}\n@-webkit-keyframes progress-bar-stripes {\n  from {\n    background-position: 40px 0;\n  }\n  to {\n    background-position: 0 0;\n  }\n}\n@keyframes progress-bar-stripes {\n  from {\n    background-position: 40px 0;\n  }\n  to {\n    background-position: 0 0;\n  }\n}\n.progress {\n  height: 18px;\n  margin-bottom: 18px;\n  overflow: hidden;\n  background-color: #f5f5f5;\n  border-radius: 2px;\n  -webkit-box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.1);\n  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.1);\n}\n.progress-bar {\n  float: left;\n  width: 0%;\n  height: 100%;\n  font-size: 12px;\n  line-height: 18px;\n  color: #fff;\n  text-align: center;\n  background-color: #337ab7;\n  -webkit-box-shadow: inset 0 -1px 0 rgba(0, 0, 0, 0.15);\n  box-shadow: inset 0 -1px 0 rgba(0, 0, 0, 0.15);\n  -webkit-transition: width 0.6s ease;\n  -o-transition: width 0.6s ease;\n  transition: width 0.6s ease;\n}\n.progress-striped .progress-bar,\n.progress-bar-striped {\n  background-image: -webkit-linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);\n  background-image: -o-linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);\n  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);\n  background-size: 40px 40px;\n}\n.progress.active .progress-bar,\n.progress-bar.active {\n  -webkit-animation: progress-bar-stripes 2s linear infinite;\n  -o-animation: progress-bar-stripes 2s linear infinite;\n  animation: progress-bar-stripes 2s linear infinite;\n}\n.progress-bar-success {\n  background-color: #5cb85c;\n}\n.progress-striped .progress-bar-success {\n  background-image: -webkit-linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);\n  background-image: -o-linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);\n  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);\n}\n.progress-bar-info {\n  background-color: #5bc0de;\n}\n.progress-striped .progress-bar-info {\n  background-image: -webkit-linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);\n  background-image: -o-linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);\n  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);\n}\n.progress-bar-warning {\n  background-color: #f0ad4e;\n}\n.progress-striped .progress-bar-warning {\n  background-image: -webkit-linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);\n  background-image: -o-linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);\n  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);\n}\n.progress-bar-danger {\n  background-color: #d9534f;\n}\n.progress-striped .progress-bar-danger {\n  background-image: -webkit-linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);\n  background-image: -o-linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);\n  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);\n}\n.media {\n  margin-top: 15px;\n}\n.media:first-child {\n  margin-top: 0;\n}\n.media,\n.media-body {\n  overflow: hidden;\n  zoom: 1;\n}\n.media-body {\n  width: 10000px;\n}\n.media-object {\n  display: block;\n}\n.media-object.img-thumbnail {\n  max-width: none;\n}\n.media-right,\n.media > .pull-right {\n  padding-left: 10px;\n}\n.media-left,\n.media > .pull-left {\n  padding-right: 10px;\n}\n.media-left,\n.media-right,\n.media-body {\n  display: table-cell;\n  vertical-align: top;\n}\n.media-middle {\n  vertical-align: middle;\n}\n.media-bottom {\n  vertical-align: bottom;\n}\n.media-heading {\n  margin-top: 0;\n  margin-bottom: 5px;\n}\n.media-list {\n  padding-left: 0;\n  list-style: none;\n}\n.list-group {\n  padding-left: 0;\n  margin-bottom: 20px;\n}\n.list-group-item {\n  position: relative;\n  display: block;\n  padding: 10px 15px;\n  margin-bottom: -1px;\n  background-color: #fff;\n  border: 1px solid #ddd;\n}\n.list-group-item:first-child {\n  border-top-left-radius: 2px;\n  border-top-right-radius: 2px;\n}\n.list-group-item:last-child {\n  margin-bottom: 0;\n  border-bottom-right-radius: 2px;\n  border-bottom-left-radius: 2px;\n}\n.list-group-item.disabled,\n.list-group-item.disabled:hover,\n.list-group-item.disabled:focus {\n  color: #777777;\n  cursor: not-allowed;\n  background-color: #eeeeee;\n}\n.list-group-item.disabled .list-group-item-heading,\n.list-group-item.disabled:hover .list-group-item-heading,\n.list-group-item.disabled:focus .list-group-item-heading {\n  color: inherit;\n}\n.list-group-item.disabled .list-group-item-text,\n.list-group-item.disabled:hover .list-group-item-text,\n.list-group-item.disabled:focus .list-group-item-text {\n  color: #777777;\n}\n.list-group-item.active,\n.list-group-item.active:hover,\n.list-group-item.active:focus {\n  z-index: 2;\n  color: #fff;\n  background-color: #337ab7;\n  border-color: #337ab7;\n}\n.list-group-item.active .list-group-item-heading,\n.list-group-item.active:hover .list-group-item-heading,\n.list-group-item.active:focus .list-group-item-heading,\n.list-group-item.active .list-group-item-heading > small,\n.list-group-item.active:hover .list-group-item-heading > small,\n.list-group-item.active:focus .list-group-item-heading > small,\n.list-group-item.active .list-group-item-heading > .small,\n.list-group-item.active:hover .list-group-item-heading > .small,\n.list-group-item.active:focus .list-group-item-heading > .small {\n  color: inherit;\n}\n.list-group-item.active .list-group-item-text,\n.list-group-item.active:hover .list-group-item-text,\n.list-group-item.active:focus .list-group-item-text {\n  color: #c7ddef;\n}\na.list-group-item,\nbutton.list-group-item {\n  color: #555;\n}\na.list-group-item .list-group-item-heading,\nbutton.list-group-item .list-group-item-heading {\n  color: #333;\n}\na.list-group-item:hover,\nbutton.list-group-item:hover,\na.list-group-item:focus,\nbutton.list-group-item:focus {\n  color: #555;\n  text-decoration: none;\n  background-color: #f5f5f5;\n}\nbutton.list-group-item {\n  width: 100%;\n  text-align: left;\n}\n.list-group-item-success {\n  color: #3c763d;\n  background-color: #dff0d8;\n}\na.list-group-item-success,\nbutton.list-group-item-success {\n  color: #3c763d;\n}\na.list-group-item-success .list-group-item-heading,\nbutton.list-group-item-success .list-group-item-heading {\n  color: inherit;\n}\na.list-group-item-success:hover,\nbutton.list-group-item-success:hover,\na.list-group-item-success:focus,\nbutton.list-group-item-success:focus {\n  color: #3c763d;\n  background-color: #d0e9c6;\n}\na.list-group-item-success.active,\nbutton.list-group-item-success.active,\na.list-group-item-success.active:hover,\nbutton.list-group-item-success.active:hover,\na.list-group-item-success.active:focus,\nbutton.list-group-item-success.active:focus {\n  color: #fff;\n  background-color: #3c763d;\n  border-color: #3c763d;\n}\n.list-group-item-info {\n  color: #31708f;\n  background-color: #d9edf7;\n}\na.list-group-item-info,\nbutton.list-group-item-info {\n  color: #31708f;\n}\na.list-group-item-info .list-group-item-heading,\nbutton.list-group-item-info .list-group-item-heading {\n  color: inherit;\n}\na.list-group-item-info:hover,\nbutton.list-group-item-info:hover,\na.list-group-item-info:focus,\nbutton.list-group-item-info:focus {\n  color: #31708f;\n  background-color: #c4e3f3;\n}\na.list-group-item-info.active,\nbutton.list-group-item-info.active,\na.list-group-item-info.active:hover,\nbutton.list-group-item-info.active:hover,\na.list-group-item-info.active:focus,\nbutton.list-group-item-info.active:focus {\n  color: #fff;\n  background-color: #31708f;\n  border-color: #31708f;\n}\n.list-group-item-warning {\n  color: #8a6d3b;\n  background-color: #fcf8e3;\n}\na.list-group-item-warning,\nbutton.list-group-item-warning {\n  color: #8a6d3b;\n}\na.list-group-item-warning .list-group-item-heading,\nbutton.list-group-item-warning .list-group-item-heading {\n  color: inherit;\n}\na.list-group-item-warning:hover,\nbutton.list-group-item-warning:hover,\na.list-group-item-warning:focus,\nbutton.list-group-item-warning:focus {\n  color: #8a6d3b;\n  background-color: #faf2cc;\n}\na.list-group-item-warning.active,\nbutton.list-group-item-warning.active,\na.list-group-item-warning.active:hover,\nbutton.list-group-item-warning.active:hover,\na.list-group-item-warning.active:focus,\nbutton.list-group-item-warning.active:focus {\n  color: #fff;\n  background-color: #8a6d3b;\n  border-color: #8a6d3b;\n}\n.list-group-item-danger {\n  color: #a94442;\n  background-color: #f2dede;\n}\na.list-group-item-danger,\nbutton.list-group-item-danger {\n  color: #a94442;\n}\na.list-group-item-danger .list-group-item-heading,\nbutton.list-group-item-danger .list-group-item-heading {\n  color: inherit;\n}\na.list-group-item-danger:hover,\nbutton.list-group-item-danger:hover,\na.list-group-item-danger:focus,\nbutton.list-group-item-danger:focus {\n  color: #a94442;\n  background-color: #ebcccc;\n}\na.list-group-item-danger.active,\nbutton.list-group-item-danger.active,\na.list-group-item-danger.active:hover,\nbutton.list-group-item-danger.active:hover,\na.list-group-item-danger.active:focus,\nbutton.list-group-item-danger.active:focus {\n  color: #fff;\n  background-color: #a94442;\n  border-color: #a94442;\n}\n.list-group-item-heading {\n  margin-top: 0;\n  margin-bottom: 5px;\n}\n.list-group-item-text {\n  margin-bottom: 0;\n  line-height: 1.3;\n}\n.panel {\n  margin-bottom: 18px;\n  background-color: #fff;\n  border: 1px solid transparent;\n  border-radius: 2px;\n  -webkit-box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);\n  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);\n}\n.panel-body {\n  padding: 15px;\n}\n.panel-heading {\n  padding: 10px 15px;\n  border-bottom: 1px solid transparent;\n  border-top-left-radius: 1px;\n  border-top-right-radius: 1px;\n}\n.panel-heading > .dropdown .dropdown-toggle {\n  color: inherit;\n}\n.panel-title {\n  margin-top: 0;\n  margin-bottom: 0;\n  font-size: 15px;\n  color: inherit;\n}\n.panel-title > a,\n.panel-title > small,\n.panel-title > .small,\n.panel-title > small > a,\n.panel-title > .small > a {\n  color: inherit;\n}\n.panel-footer {\n  padding: 10px 15px;\n  background-color: #f5f5f5;\n  border-top: 1px solid #ddd;\n  border-bottom-right-radius: 1px;\n  border-bottom-left-radius: 1px;\n}\n.panel > .list-group,\n.panel > .panel-collapse > .list-group {\n  margin-bottom: 0;\n}\n.panel > .list-group .list-group-item,\n.panel > .panel-collapse > .list-group .list-group-item {\n  border-width: 1px 0;\n  border-radius: 0;\n}\n.panel > .list-group:first-child .list-group-item:first-child,\n.panel > .panel-collapse > .list-group:first-child .list-group-item:first-child {\n  border-top: 0;\n  border-top-left-radius: 1px;\n  border-top-right-radius: 1px;\n}\n.panel > .list-group:last-child .list-group-item:last-child,\n.panel > .panel-collapse > .list-group:last-child .list-group-item:last-child {\n  border-bottom: 0;\n  border-bottom-right-radius: 1px;\n  border-bottom-left-radius: 1px;\n}\n.panel > .panel-heading + .panel-collapse > .list-group .list-group-item:first-child {\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n.panel-heading + .list-group .list-group-item:first-child {\n  border-top-width: 0;\n}\n.list-group + .panel-footer {\n  border-top-width: 0;\n}\n.panel > .table,\n.panel > .table-responsive > .table,\n.panel > .panel-collapse > .table {\n  margin-bottom: 0;\n}\n.panel > .table caption,\n.panel > .table-responsive > .table caption,\n.panel > .panel-collapse > .table caption {\n  padding-right: 15px;\n  padding-left: 15px;\n}\n.panel > .table:first-child,\n.panel > .table-responsive:first-child > .table:first-child {\n  border-top-left-radius: 1px;\n  border-top-right-radius: 1px;\n}\n.panel > .table:first-child > thead:first-child > tr:first-child,\n.panel > .table-responsive:first-child > .table:first-child > thead:first-child > tr:first-child,\n.panel > .table:first-child > tbody:first-child > tr:first-child,\n.panel > .table-responsive:first-child > .table:first-child > tbody:first-child > tr:first-child {\n  border-top-left-radius: 1px;\n  border-top-right-radius: 1px;\n}\n.panel > .table:first-child > thead:first-child > tr:first-child td:first-child,\n.panel > .table-responsive:first-child > .table:first-child > thead:first-child > tr:first-child td:first-child,\n.panel > .table:first-child > tbody:first-child > tr:first-child td:first-child,\n.panel > .table-responsive:first-child > .table:first-child > tbody:first-child > tr:first-child td:first-child,\n.panel > .table:first-child > thead:first-child > tr:first-child th:first-child,\n.panel > .table-responsive:first-child > .table:first-child > thead:first-child > tr:first-child th:first-child,\n.panel > .table:first-child > tbody:first-child > tr:first-child th:first-child,\n.panel > .table-responsive:first-child > .table:first-child > tbody:first-child > tr:first-child th:first-child {\n  border-top-left-radius: 1px;\n}\n.panel > .table:first-child > thead:first-child > tr:first-child td:last-child,\n.panel > .table-responsive:first-child > .table:first-child > thead:first-child > tr:first-child td:last-child,\n.panel > .table:first-child > tbody:first-child > tr:first-child td:last-child,\n.panel > .table-responsive:first-child > .table:first-child > tbody:first-child > tr:first-child td:last-child,\n.panel > .table:first-child > thead:first-child > tr:first-child th:last-child,\n.panel > .table-responsive:first-child > .table:first-child > thead:first-child > tr:first-child th:last-child,\n.panel > .table:first-child > tbody:first-child > tr:first-child th:last-child,\n.panel > .table-responsive:first-child > .table:first-child > tbody:first-child > tr:first-child th:last-child {\n  border-top-right-radius: 1px;\n}\n.panel > .table:last-child,\n.panel > .table-responsive:last-child > .table:last-child {\n  border-bottom-right-radius: 1px;\n  border-bottom-left-radius: 1px;\n}\n.panel > .table:last-child > tbody:last-child > tr:last-child,\n.panel > .table-responsive:last-child > .table:last-child > tbody:last-child > tr:last-child,\n.panel > .table:last-child > tfoot:last-child > tr:last-child,\n.panel > .table-responsive:last-child > .table:last-child > tfoot:last-child > tr:last-child {\n  border-bottom-right-radius: 1px;\n  border-bottom-left-radius: 1px;\n}\n.panel > .table:last-child > tbody:last-child > tr:last-child td:first-child,\n.panel > .table-responsive:last-child > .table:last-child > tbody:last-child > tr:last-child td:first-child,\n.panel > .table:last-child > tfoot:last-child > tr:last-child td:first-child,\n.panel > .table-responsive:last-child > .table:last-child > tfoot:last-child > tr:last-child td:first-child,\n.panel > .table:last-child > tbody:last-child > tr:last-child th:first-child,\n.panel > .table-responsive:last-child > .table:last-child > tbody:last-child > tr:last-child th:first-child,\n.panel > .table:last-child > tfoot:last-child > tr:last-child th:first-child,\n.panel > .table-responsive:last-child > .table:last-child > tfoot:last-child > tr:last-child th:first-child {\n  border-bottom-left-radius: 1px;\n}\n.panel > .table:last-child > tbody:last-child > tr:last-child td:last-child,\n.panel > .table-responsive:last-child > .table:last-child > tbody:last-child > tr:last-child td:last-child,\n.panel > .table:last-child > tfoot:last-child > tr:last-child td:last-child,\n.panel > .table-responsive:last-child > .table:last-child > tfoot:last-child > tr:last-child td:last-child,\n.panel > .table:last-child > tbody:last-child > tr:last-child th:last-child,\n.panel > .table-responsive:last-child > .table:last-child > tbody:last-child > tr:last-child th:last-child,\n.panel > .table:last-child > tfoot:last-child > tr:last-child th:last-child,\n.panel > .table-responsive:last-child > .table:last-child > tfoot:last-child > tr:last-child th:last-child {\n  border-bottom-right-radius: 1px;\n}\n.panel > .panel-body + .table,\n.panel > .panel-body + .table-responsive,\n.panel > .table + .panel-body,\n.panel > .table-responsive + .panel-body {\n  border-top: 1px solid #ddd;\n}\n.panel > .table > tbody:first-child > tr:first-child th,\n.panel > .table > tbody:first-child > tr:first-child td {\n  border-top: 0;\n}\n.panel > .table-bordered,\n.panel > .table-responsive > .table-bordered {\n  border: 0;\n}\n.panel > .table-bordered > thead > tr > th:first-child,\n.panel > .table-responsive > .table-bordered > thead > tr > th:first-child,\n.panel > .table-bordered > tbody > tr > th:first-child,\n.panel > .table-responsive > .table-bordered > tbody > tr > th:first-child,\n.panel > .table-bordered > tfoot > tr > th:first-child,\n.panel > .table-responsive > .table-bordered > tfoot > tr > th:first-child,\n.panel > .table-bordered > thead > tr > td:first-child,\n.panel > .table-responsive > .table-bordered > thead > tr > td:first-child,\n.panel > .table-bordered > tbody > tr > td:first-child,\n.panel > .table-responsive > .table-bordered > tbody > tr > td:first-child,\n.panel > .table-bordered > tfoot > tr > td:first-child,\n.panel > .table-responsive > .table-bordered > tfoot > tr > td:first-child {\n  border-left: 0;\n}\n.panel > .table-bordered > thead > tr > th:last-child,\n.panel > .table-responsive > .table-bordered > thead > tr > th:last-child,\n.panel > .table-bordered > tbody > tr > th:last-child,\n.panel > .table-responsive > .table-bordered > tbody > tr > th:last-child,\n.panel > .table-bordered > tfoot > tr > th:last-child,\n.panel > .table-responsive > .table-bordered > tfoot > tr > th:last-child,\n.panel > .table-bordered > thead > tr > td:last-child,\n.panel > .table-responsive > .table-bordered > thead > tr > td:last-child,\n.panel > .table-bordered > tbody > tr > td:last-child,\n.panel > .table-responsive > .table-bordered > tbody > tr > td:last-child,\n.panel > .table-bordered > tfoot > tr > td:last-child,\n.panel > .table-responsive > .table-bordered > tfoot > tr > td:last-child {\n  border-right: 0;\n}\n.panel > .table-bordered > thead > tr:first-child > td,\n.panel > .table-responsive > .table-bordered > thead > tr:first-child > td,\n.panel > .table-bordered > tbody > tr:first-child > td,\n.panel > .table-responsive > .table-bordered > tbody > tr:first-child > td,\n.panel > .table-bordered > thead > tr:first-child > th,\n.panel > .table-responsive > .table-bordered > thead > tr:first-child > th,\n.panel > .table-bordered > tbody > tr:first-child > th,\n.panel > .table-responsive > .table-bordered > tbody > tr:first-child > th {\n  border-bottom: 0;\n}\n.panel > .table-bordered > tbody > tr:last-child > td,\n.panel > .table-responsive > .table-bordered > tbody > tr:last-child > td,\n.panel > .table-bordered > tfoot > tr:last-child > td,\n.panel > .table-responsive > .table-bordered > tfoot > tr:last-child > td,\n.panel > .table-bordered > tbody > tr:last-child > th,\n.panel > .table-responsive > .table-bordered > tbody > tr:last-child > th,\n.panel > .table-bordered > tfoot > tr:last-child > th,\n.panel > .table-responsive > .table-bordered > tfoot > tr:last-child > th {\n  border-bottom: 0;\n}\n.panel > .table-responsive {\n  margin-bottom: 0;\n  border: 0;\n}\n.panel-group {\n  margin-bottom: 18px;\n}\n.panel-group .panel {\n  margin-bottom: 0;\n  border-radius: 2px;\n}\n.panel-group .panel + .panel {\n  margin-top: 5px;\n}\n.panel-group .panel-heading {\n  border-bottom: 0;\n}\n.panel-group .panel-heading + .panel-collapse > .panel-body,\n.panel-group .panel-heading + .panel-collapse > .list-group {\n  border-top: 1px solid #ddd;\n}\n.panel-group .panel-footer {\n  border-top: 0;\n}\n.panel-group .panel-footer + .panel-collapse .panel-body {\n  border-bottom: 1px solid #ddd;\n}\n.panel-default {\n  border-color: #ddd;\n}\n.panel-default > .panel-heading {\n  color: #333333;\n  background-color: #f5f5f5;\n  border-color: #ddd;\n}\n.panel-default > .panel-heading + .panel-collapse > .panel-body {\n  border-top-color: #ddd;\n}\n.panel-default > .panel-heading .badge {\n  color: #f5f5f5;\n  background-color: #333333;\n}\n.panel-default > .panel-footer + .panel-collapse > .panel-body {\n  border-bottom-color: #ddd;\n}\n.panel-primary {\n  border-color: #337ab7;\n}\n.panel-primary > .panel-heading {\n  color: #fff;\n  background-color: #337ab7;\n  border-color: #337ab7;\n}\n.panel-primary > .panel-heading + .panel-collapse > .panel-body {\n  border-top-color: #337ab7;\n}\n.panel-primary > .panel-heading .badge {\n  color: #337ab7;\n  background-color: #fff;\n}\n.panel-primary > .panel-footer + .panel-collapse > .panel-body {\n  border-bottom-color: #337ab7;\n}\n.panel-success {\n  border-color: #d6e9c6;\n}\n.panel-success > .panel-heading {\n  color: #3c763d;\n  background-color: #dff0d8;\n  border-color: #d6e9c6;\n}\n.panel-success > .panel-heading + .panel-collapse > .panel-body {\n  border-top-color: #d6e9c6;\n}\n.panel-success > .panel-heading .badge {\n  color: #dff0d8;\n  background-color: #3c763d;\n}\n.panel-success > .panel-footer + .panel-collapse > .panel-body {\n  border-bottom-color: #d6e9c6;\n}\n.panel-info {\n  border-color: #bce8f1;\n}\n.panel-info > .panel-heading {\n  color: #31708f;\n  background-color: #d9edf7;\n  border-color: #bce8f1;\n}\n.panel-info > .panel-heading + .panel-collapse > .panel-body {\n  border-top-color: #bce8f1;\n}\n.panel-info > .panel-heading .badge {\n  color: #d9edf7;\n  background-color: #31708f;\n}\n.panel-info > .panel-footer + .panel-collapse > .panel-body {\n  border-bottom-color: #bce8f1;\n}\n.panel-warning {\n  border-color: #faebcc;\n}\n.panel-warning > .panel-heading {\n  color: #8a6d3b;\n  background-color: #fcf8e3;\n  border-color: #faebcc;\n}\n.panel-warning > .panel-heading + .panel-collapse > .panel-body {\n  border-top-color: #faebcc;\n}\n.panel-warning > .panel-heading .badge {\n  color: #fcf8e3;\n  background-color: #8a6d3b;\n}\n.panel-warning > .panel-footer + .panel-collapse > .panel-body {\n  border-bottom-color: #faebcc;\n}\n.panel-danger {\n  border-color: #ebccd1;\n}\n.panel-danger > .panel-heading {\n  color: #a94442;\n  background-color: #f2dede;\n  border-color: #ebccd1;\n}\n.panel-danger > .panel-heading + .panel-collapse > .panel-body {\n  border-top-color: #ebccd1;\n}\n.panel-danger > .panel-heading .badge {\n  color: #f2dede;\n  background-color: #a94442;\n}\n.panel-danger > .panel-footer + .panel-collapse > .panel-body {\n  border-bottom-color: #ebccd1;\n}\n.embed-responsive {\n  position: relative;\n  display: block;\n  height: 0;\n  padding: 0;\n  overflow: hidden;\n}\n.embed-responsive .embed-responsive-item,\n.embed-responsive iframe,\n.embed-responsive embed,\n.embed-responsive object,\n.embed-responsive video {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  border: 0;\n}\n.embed-responsive-16by9 {\n  padding-bottom: 56.25%;\n}\n.embed-responsive-4by3 {\n  padding-bottom: 75%;\n}\n.well {\n  min-height: 20px;\n  padding: 19px;\n  margin-bottom: 20px;\n  background-color: #f5f5f5;\n  border: 1px solid #e3e3e3;\n  border-radius: 2px;\n  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.05);\n  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.05);\n}\n.well blockquote {\n  border-color: #ddd;\n  border-color: rgba(0, 0, 0, 0.15);\n}\n.well-lg {\n  padding: 24px;\n  border-radius: 3px;\n}\n.well-sm {\n  padding: 9px;\n  border-radius: 1px;\n}\n.close {\n  float: right;\n  font-size: 19.5px;\n  font-weight: bold;\n  line-height: 1;\n  color: #000;\n  text-shadow: 0 1px 0 #fff;\n  filter: alpha(opacity=20);\n  opacity: 0.2;\n}\n.close:hover,\n.close:focus {\n  color: #000;\n  text-decoration: none;\n  cursor: pointer;\n  filter: alpha(opacity=50);\n  opacity: 0.5;\n}\nbutton.close {\n  padding: 0;\n  cursor: pointer;\n  background: transparent;\n  border: 0;\n  -webkit-appearance: none;\n  appearance: none;\n}\n.modal-open {\n  overflow: hidden;\n}\n.modal {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1050;\n  display: none;\n  overflow: hidden;\n  -webkit-overflow-scrolling: touch;\n  outline: 0;\n}\n.modal.fade .modal-dialog {\n  -webkit-transform: translate(0, -25%);\n  -ms-transform: translate(0, -25%);\n  -o-transform: translate(0, -25%);\n  transform: translate(0, -25%);\n  -webkit-transition: -webkit-transform 0.3s ease-out;\n  -moz-transition: -moz-transform 0.3s ease-out;\n  -o-transition: -o-transform 0.3s ease-out;\n  transition: transform 0.3s ease-out;\n}\n.modal.in .modal-dialog {\n  -webkit-transform: translate(0, 0);\n  -ms-transform: translate(0, 0);\n  -o-transform: translate(0, 0);\n  transform: translate(0, 0);\n}\n.modal-open .modal {\n  overflow-x: hidden;\n  overflow-y: auto;\n}\n.modal-dialog {\n  position: relative;\n  width: auto;\n  margin: 10px;\n}\n.modal-content {\n  position: relative;\n  background-color: #fff;\n  background-clip: padding-box;\n  border: 1px solid #999;\n  border: 1px solid rgba(0, 0, 0, 0.2);\n  border-radius: 3px;\n  -webkit-box-shadow: 0 3px 9px rgba(0, 0, 0, 0.5);\n  box-shadow: 0 3px 9px rgba(0, 0, 0, 0.5);\n  outline: 0;\n}\n.modal-backdrop {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1040;\n  background-color: #000;\n}\n.modal-backdrop.fade {\n  filter: alpha(opacity=0);\n  opacity: 0;\n}\n.modal-backdrop.in {\n  filter: alpha(opacity=50);\n  opacity: 0.5;\n}\n.modal-header {\n  padding: 15px;\n  border-bottom: 1px solid #e5e5e5;\n}\n.modal-header .close {\n  margin-top: -2px;\n}\n.modal-title {\n  margin: 0;\n  line-height: 1.42857143;\n}\n.modal-body {\n  position: relative;\n  padding: 15px;\n}\n.modal-footer {\n  padding: 15px;\n  text-align: right;\n  border-top: 1px solid #e5e5e5;\n}\n.modal-footer .btn + .btn {\n  margin-bottom: 0;\n  margin-left: 5px;\n}\n.modal-footer .btn-group .btn + .btn {\n  margin-left: -1px;\n}\n.modal-footer .btn-block + .btn-block {\n  margin-left: 0;\n}\n.modal-scrollbar-measure {\n  position: absolute;\n  top: -9999px;\n  width: 50px;\n  height: 50px;\n  overflow: scroll;\n}\n@media (min-width: 768px) {\n  .modal-dialog {\n    width: 600px;\n    margin: 30px auto;\n  }\n  .modal-content {\n    -webkit-box-shadow: 0 5px 15px rgba(0, 0, 0, 0.5);\n    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.5);\n  }\n  .modal-sm {\n    width: 300px;\n  }\n}\n@media (min-width: 992px) {\n  .modal-lg {\n    width: 900px;\n  }\n}\n.tooltip {\n  position: absolute;\n  z-index: 1070;\n  display: block;\n  font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 1.42857143;\n  line-break: auto;\n  text-align: left;\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  word-spacing: normal;\n  word-wrap: normal;\n  white-space: normal;\n  font-size: 12px;\n  filter: alpha(opacity=0);\n  opacity: 0;\n}\n.tooltip.in {\n  filter: alpha(opacity=90);\n  opacity: 0.9;\n}\n.tooltip.top {\n  padding: 5px 0;\n  margin-top: -3px;\n}\n.tooltip.right {\n  padding: 0 5px;\n  margin-left: 3px;\n}\n.tooltip.bottom {\n  padding: 5px 0;\n  margin-top: 3px;\n}\n.tooltip.left {\n  padding: 0 5px;\n  margin-left: -3px;\n}\n.tooltip.top .tooltip-arrow {\n  bottom: 0;\n  left: 50%;\n  margin-left: -5px;\n  border-width: 5px 5px 0;\n  border-top-color: #000;\n}\n.tooltip.top-left .tooltip-arrow {\n  right: 5px;\n  bottom: 0;\n  margin-bottom: -5px;\n  border-width: 5px 5px 0;\n  border-top-color: #000;\n}\n.tooltip.top-right .tooltip-arrow {\n  bottom: 0;\n  left: 5px;\n  margin-bottom: -5px;\n  border-width: 5px 5px 0;\n  border-top-color: #000;\n}\n.tooltip.right .tooltip-arrow {\n  top: 50%;\n  left: 0;\n  margin-top: -5px;\n  border-width: 5px 5px 5px 0;\n  border-right-color: #000;\n}\n.tooltip.left .tooltip-arrow {\n  top: 50%;\n  right: 0;\n  margin-top: -5px;\n  border-width: 5px 0 5px 5px;\n  border-left-color: #000;\n}\n.tooltip.bottom .tooltip-arrow {\n  top: 0;\n  left: 50%;\n  margin-left: -5px;\n  border-width: 0 5px 5px;\n  border-bottom-color: #000;\n}\n.tooltip.bottom-left .tooltip-arrow {\n  top: 0;\n  right: 5px;\n  margin-top: -5px;\n  border-width: 0 5px 5px;\n  border-bottom-color: #000;\n}\n.tooltip.bottom-right .tooltip-arrow {\n  top: 0;\n  left: 5px;\n  margin-top: -5px;\n  border-width: 0 5px 5px;\n  border-bottom-color: #000;\n}\n.tooltip-inner {\n  max-width: 200px;\n  padding: 3px 8px;\n  color: #fff;\n  text-align: center;\n  background-color: #000;\n  border-radius: 2px;\n}\n.tooltip-arrow {\n  position: absolute;\n  width: 0;\n  height: 0;\n  border-color: transparent;\n  border-style: solid;\n}\n.popover {\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 1060;\n  display: none;\n  max-width: 276px;\n  padding: 1px;\n  font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 1.42857143;\n  line-break: auto;\n  text-align: left;\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  word-spacing: normal;\n  word-wrap: normal;\n  white-space: normal;\n  font-size: 13px;\n  background-color: #fff;\n  background-clip: padding-box;\n  border: 1px solid #ccc;\n  border: 1px solid rgba(0, 0, 0, 0.2);\n  border-radius: 3px;\n  -webkit-box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);\n  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);\n}\n.popover.top {\n  margin-top: -10px;\n}\n.popover.right {\n  margin-left: 10px;\n}\n.popover.bottom {\n  margin-top: 10px;\n}\n.popover.left {\n  margin-left: -10px;\n}\n.popover > .arrow {\n  border-width: 11px;\n}\n.popover > .arrow,\n.popover > .arrow:after {\n  position: absolute;\n  display: block;\n  width: 0;\n  height: 0;\n  border-color: transparent;\n  border-style: solid;\n}\n.popover > .arrow:after {\n  content: \"\";\n  border-width: 10px;\n}\n.popover.top > .arrow {\n  bottom: -11px;\n  left: 50%;\n  margin-left: -11px;\n  border-top-color: #999999;\n  border-top-color: rgba(0, 0, 0, 0.25);\n  border-bottom-width: 0;\n}\n.popover.top > .arrow:after {\n  bottom: 1px;\n  margin-left: -10px;\n  content: \" \";\n  border-top-color: #fff;\n  border-bottom-width: 0;\n}\n.popover.right > .arrow {\n  top: 50%;\n  left: -11px;\n  margin-top: -11px;\n  border-right-color: #999999;\n  border-right-color: rgba(0, 0, 0, 0.25);\n  border-left-width: 0;\n}\n.popover.right > .arrow:after {\n  bottom: -10px;\n  left: 1px;\n  content: \" \";\n  border-right-color: #fff;\n  border-left-width: 0;\n}\n.popover.bottom > .arrow {\n  top: -11px;\n  left: 50%;\n  margin-left: -11px;\n  border-top-width: 0;\n  border-bottom-color: #999999;\n  border-bottom-color: rgba(0, 0, 0, 0.25);\n}\n.popover.bottom > .arrow:after {\n  top: 1px;\n  margin-left: -10px;\n  content: \" \";\n  border-top-width: 0;\n  border-bottom-color: #fff;\n}\n.popover.left > .arrow {\n  top: 50%;\n  right: -11px;\n  margin-top: -11px;\n  border-right-width: 0;\n  border-left-color: #999999;\n  border-left-color: rgba(0, 0, 0, 0.25);\n}\n.popover.left > .arrow:after {\n  right: 1px;\n  bottom: -10px;\n  content: \" \";\n  border-right-width: 0;\n  border-left-color: #fff;\n}\n.popover-title {\n  padding: 8px 14px;\n  margin: 0;\n  font-size: 13px;\n  background-color: #f7f7f7;\n  border-bottom: 1px solid #ebebeb;\n  border-radius: 2px 2px 0 0;\n}\n.popover-content {\n  padding: 9px 14px;\n}\n.carousel {\n  position: relative;\n}\n.carousel-inner {\n  position: relative;\n  width: 100%;\n  overflow: hidden;\n}\n.carousel-inner > .item {\n  position: relative;\n  display: none;\n  -webkit-transition: 0.6s ease-in-out left;\n  -o-transition: 0.6s ease-in-out left;\n  transition: 0.6s ease-in-out left;\n}\n.carousel-inner > .item > img,\n.carousel-inner > .item > a > img {\n  line-height: 1;\n}\n@media all and (transform-3d), (-webkit-transform-3d) {\n  .carousel-inner > .item {\n    -webkit-transition: -webkit-transform 0.6s ease-in-out;\n    -moz-transition: -moz-transform 0.6s ease-in-out;\n    -o-transition: -o-transform 0.6s ease-in-out;\n    transition: transform 0.6s ease-in-out;\n    -webkit-backface-visibility: hidden;\n    -moz-backface-visibility: hidden;\n    backface-visibility: hidden;\n    -webkit-perspective: 1000px;\n    -moz-perspective: 1000px;\n    perspective: 1000px;\n  }\n  .carousel-inner > .item.next,\n  .carousel-inner > .item.active.right {\n    -webkit-transform: translate3d(100%, 0, 0);\n    transform: translate3d(100%, 0, 0);\n    left: 0;\n  }\n  .carousel-inner > .item.prev,\n  .carousel-inner > .item.active.left {\n    -webkit-transform: translate3d(-100%, 0, 0);\n    transform: translate3d(-100%, 0, 0);\n    left: 0;\n  }\n  .carousel-inner > .item.next.left,\n  .carousel-inner > .item.prev.right,\n  .carousel-inner > .item.active {\n    -webkit-transform: translate3d(0, 0, 0);\n    transform: translate3d(0, 0, 0);\n    left: 0;\n  }\n}\n.carousel-inner > .active,\n.carousel-inner > .next,\n.carousel-inner > .prev {\n  display: block;\n}\n.carousel-inner > .active {\n  left: 0;\n}\n.carousel-inner > .next,\n.carousel-inner > .prev {\n  position: absolute;\n  top: 0;\n  width: 100%;\n}\n.carousel-inner > .next {\n  left: 100%;\n}\n.carousel-inner > .prev {\n  left: -100%;\n}\n.carousel-inner > .next.left,\n.carousel-inner > .prev.right {\n  left: 0;\n}\n.carousel-inner > .active.left {\n  left: -100%;\n}\n.carousel-inner > .active.right {\n  left: 100%;\n}\n.carousel-control {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  width: 15%;\n  font-size: 20px;\n  color: #fff;\n  text-align: center;\n  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.6);\n  background-color: rgba(0, 0, 0, 0);\n  filter: alpha(opacity=50);\n  opacity: 0.5;\n}\n.carousel-control.left {\n  background-image: -webkit-linear-gradient(left, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0.0001) 100%);\n  background-image: -o-linear-gradient(left, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0.0001) 100%);\n  background-image: linear-gradient(to right, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0.0001) 100%);\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#80000000', endColorstr='#00000000', GradientType=1);\n  background-repeat: repeat-x;\n}\n.carousel-control.right {\n  right: 0;\n  left: auto;\n  background-image: -webkit-linear-gradient(left, rgba(0, 0, 0, 0.0001) 0%, rgba(0, 0, 0, 0.5) 100%);\n  background-image: -o-linear-gradient(left, rgba(0, 0, 0, 0.0001) 0%, rgba(0, 0, 0, 0.5) 100%);\n  background-image: linear-gradient(to right, rgba(0, 0, 0, 0.0001) 0%, rgba(0, 0, 0, 0.5) 100%);\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#00000000', endColorstr='#80000000', GradientType=1);\n  background-repeat: repeat-x;\n}\n.carousel-control:hover,\n.carousel-control:focus {\n  color: #fff;\n  text-decoration: none;\n  outline: 0;\n  filter: alpha(opacity=90);\n  opacity: 0.9;\n}\n.carousel-control .icon-prev,\n.carousel-control .icon-next,\n.carousel-control .glyphicon-chevron-left,\n.carousel-control .glyphicon-chevron-right {\n  position: absolute;\n  top: 50%;\n  z-index: 5;\n  display: inline-block;\n  margin-top: -10px;\n}\n.carousel-control .icon-prev,\n.carousel-control .glyphicon-chevron-left {\n  left: 50%;\n  margin-left: -10px;\n}\n.carousel-control .icon-next,\n.carousel-control .glyphicon-chevron-right {\n  right: 50%;\n  margin-right: -10px;\n}\n.carousel-control .icon-prev,\n.carousel-control .icon-next {\n  width: 20px;\n  height: 20px;\n  font-family: serif;\n  line-height: 1;\n}\n.carousel-control .icon-prev:before {\n  content: \"\\2039\";\n}\n.carousel-control .icon-next:before {\n  content: \"\\203a\";\n}\n.carousel-indicators {\n  position: absolute;\n  bottom: 10px;\n  left: 50%;\n  z-index: 15;\n  width: 60%;\n  padding-left: 0;\n  margin-left: -30%;\n  text-align: center;\n  list-style: none;\n}\n.carousel-indicators li {\n  display: inline-block;\n  width: 10px;\n  height: 10px;\n  margin: 1px;\n  text-indent: -999px;\n  cursor: pointer;\n  background-color: #000 \\9;\n  background-color: rgba(0, 0, 0, 0);\n  border: 1px solid #fff;\n  border-radius: 10px;\n}\n.carousel-indicators .active {\n  width: 12px;\n  height: 12px;\n  margin: 0;\n  background-color: #fff;\n}\n.carousel-caption {\n  position: absolute;\n  right: 15%;\n  bottom: 20px;\n  left: 15%;\n  z-index: 10;\n  padding-top: 20px;\n  padding-bottom: 20px;\n  color: #fff;\n  text-align: center;\n  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.6);\n}\n.carousel-caption .btn {\n  text-shadow: none;\n}\n@media screen and (min-width: 768px) {\n  .carousel-control .glyphicon-chevron-left,\n  .carousel-control .glyphicon-chevron-right,\n  .carousel-control .icon-prev,\n  .carousel-control .icon-next {\n    width: 30px;\n    height: 30px;\n    margin-top: -10px;\n    font-size: 30px;\n  }\n  .carousel-control .glyphicon-chevron-left,\n  .carousel-control .icon-prev {\n    margin-left: -10px;\n  }\n  .carousel-control .glyphicon-chevron-right,\n  .carousel-control .icon-next {\n    margin-right: -10px;\n  }\n  .carousel-caption {\n    right: 20%;\n    left: 20%;\n    padding-bottom: 30px;\n  }\n  .carousel-indicators {\n    bottom: 20px;\n  }\n}\n.clearfix:before,\n.clearfix:after,\n.dl-horizontal dd:before,\n.dl-horizontal dd:after,\n.container:before,\n.container:after,\n.container-fluid:before,\n.container-fluid:after,\n.row:before,\n.row:after,\n.form-horizontal .form-group:before,\n.form-horizontal .form-group:after,\n.btn-toolbar:before,\n.btn-toolbar:after,\n.btn-group-vertical > .btn-group:before,\n.btn-group-vertical > .btn-group:after,\n.nav:before,\n.nav:after,\n.navbar:before,\n.navbar:after,\n.navbar-header:before,\n.navbar-header:after,\n.navbar-collapse:before,\n.navbar-collapse:after,\n.pager:before,\n.pager:after,\n.panel-body:before,\n.panel-body:after,\n.modal-header:before,\n.modal-header:after,\n.modal-footer:before,\n.modal-footer:after {\n  display: table;\n  content: \" \";\n}\n.clearfix:after,\n.dl-horizontal dd:after,\n.container:after,\n.container-fluid:after,\n.row:after,\n.form-horizontal .form-group:after,\n.btn-toolbar:after,\n.btn-group-vertical > .btn-group:after,\n.nav:after,\n.navbar:after,\n.navbar-header:after,\n.navbar-collapse:after,\n.pager:after,\n.panel-body:after,\n.modal-header:after,\n.modal-footer:after {\n  clear: both;\n}\n.center-block {\n  display: block;\n  margin-right: auto;\n  margin-left: auto;\n}\n.pull-right {\n  float: right !important;\n}\n.pull-left {\n  float: left !important;\n}\n.hide {\n  display: none !important;\n}\n.show {\n  display: block !important;\n}\n.invisible {\n  visibility: hidden;\n}\n.text-hide {\n  font: 0/0 a;\n  color: transparent;\n  text-shadow: none;\n  background-color: transparent;\n  border: 0;\n}\n.hidden {\n  display: none !important;\n}\n.affix {\n  position: fixed;\n}\n@-ms-viewport {\n  width: device-width;\n}\n.visible-xs,\n.visible-sm,\n.visible-md,\n.visible-lg {\n  display: none !important;\n}\n.visible-xs-block,\n.visible-xs-inline,\n.visible-xs-inline-block,\n.visible-sm-block,\n.visible-sm-inline,\n.visible-sm-inline-block,\n.visible-md-block,\n.visible-md-inline,\n.visible-md-inline-block,\n.visible-lg-block,\n.visible-lg-inline,\n.visible-lg-inline-block {\n  display: none !important;\n}\n@media (max-width: 767px) {\n  .visible-xs {\n    display: block !important;\n  }\n  table.visible-xs {\n    display: table !important;\n  }\n  tr.visible-xs {\n    display: table-row !important;\n  }\n  th.visible-xs,\n  td.visible-xs {\n    display: table-cell !important;\n  }\n}\n@media (max-width: 767px) {\n  .visible-xs-block {\n    display: block !important;\n  }\n}\n@media (max-width: 767px) {\n  .visible-xs-inline {\n    display: inline !important;\n  }\n}\n@media (max-width: 767px) {\n  .visible-xs-inline-block {\n    display: inline-block !important;\n  }\n}\n@media (min-width: 768px) and (max-width: 991px) {\n  .visible-sm {\n    display: block !important;\n  }\n  table.visible-sm {\n    display: table !important;\n  }\n  tr.visible-sm {\n    display: table-row !important;\n  }\n  th.visible-sm,\n  td.visible-sm {\n    display: table-cell !important;\n  }\n}\n@media (min-width: 768px) and (max-width: 991px) {\n  .visible-sm-block {\n    display: block !important;\n  }\n}\n@media (min-width: 768px) and (max-width: 991px) {\n  .visible-sm-inline {\n    display: inline !important;\n  }\n}\n@media (min-width: 768px) and (max-width: 991px) {\n  .visible-sm-inline-block {\n    display: inline-block !important;\n  }\n}\n@media (min-width: 992px) and (max-width: 1199px) {\n  .visible-md {\n    display: block !important;\n  }\n  table.visible-md {\n    display: table !important;\n  }\n  tr.visible-md {\n    display: table-row !important;\n  }\n  th.visible-md,\n  td.visible-md {\n    display: table-cell !important;\n  }\n}\n@media (min-width: 992px) and (max-width: 1199px) {\n  .visible-md-block {\n    display: block !important;\n  }\n}\n@media (min-width: 992px) and (max-width: 1199px) {\n  .visible-md-inline {\n    display: inline !important;\n  }\n}\n@media (min-width: 992px) and (max-width: 1199px) {\n  .visible-md-inline-block {\n    display: inline-block !important;\n  }\n}\n@media (min-width: 1200px) {\n  .visible-lg {\n    display: block !important;\n  }\n  table.visible-lg {\n    display: table !important;\n  }\n  tr.visible-lg {\n    display: table-row !important;\n  }\n  th.visible-lg,\n  td.visible-lg {\n    display: table-cell !important;\n  }\n}\n@media (min-width: 1200px) {\n  .visible-lg-block {\n    display: block !important;\n  }\n}\n@media (min-width: 1200px) {\n  .visible-lg-inline {\n    display: inline !important;\n  }\n}\n@media (min-width: 1200px) {\n  .visible-lg-inline-block {\n    display: inline-block !important;\n  }\n}\n@media (max-width: 767px) {\n  .hidden-xs {\n    display: none !important;\n  }\n}\n@media (min-width: 768px) and (max-width: 991px) {\n  .hidden-sm {\n    display: none !important;\n  }\n}\n@media (min-width: 992px) and (max-width: 1199px) {\n  .hidden-md {\n    display: none !important;\n  }\n}\n@media (min-width: 1200px) {\n  .hidden-lg {\n    display: none !important;\n  }\n}\n.visible-print {\n  display: none !important;\n}\n@media print {\n  .visible-print {\n    display: block !important;\n  }\n  table.visible-print {\n    display: table !important;\n  }\n  tr.visible-print {\n    display: table-row !important;\n  }\n  th.visible-print,\n  td.visible-print {\n    display: table-cell !important;\n  }\n}\n.visible-print-block {\n  display: none !important;\n}\n@media print {\n  .visible-print-block {\n    display: block !important;\n  }\n}\n.visible-print-inline {\n  display: none !important;\n}\n@media print {\n  .visible-print-inline {\n    display: inline !important;\n  }\n}\n.visible-print-inline-block {\n  display: none !important;\n}\n@media print {\n  .visible-print-inline-block {\n    display: inline-block !important;\n  }\n}\n@media print {\n  .hidden-print {\n    display: none !important;\n  }\n}\n/*!\n*\n* Font Awesome\n*\n*/\n/*!\n *  Font Awesome 4.7.0 by @davegandy - http://fontawesome.io - @fontawesome\n *  License - http://fontawesome.io/license (Font: SIL OFL 1.1, CSS: MIT License)\n */\n/* FONT PATH\n * -------------------------- */\n@font-face {\n  font-family: 'FontAwesome';\n  src: url('../../node_modules/font-awesome/less/~font-awesome/fonts/fontawesome-webfont.eot?v=4.7.0');\n  src: url('../../node_modules/font-awesome/less/~font-awesome/fonts/fontawesome-webfont.eot?#iefix&v=4.7.0') format('embedded-opentype'), url('../../node_modules/font-awesome/less/~font-awesome/fonts/fontawesome-webfont.woff2?v=4.7.0') format('woff2'), url('../../node_modules/font-awesome/less/~font-awesome/fonts/fontawesome-webfont.woff?v=4.7.0') format('woff'), url('../../node_modules/font-awesome/less/~font-awesome/fonts/fontawesome-webfont.ttf?v=4.7.0') format('truetype'), url('../../node_modules/font-awesome/less/~font-awesome/fonts/fontawesome-webfont.svg?v=4.7.0#fontawesomeregular') format('svg');\n  font-weight: normal;\n  font-style: normal;\n}\n.fa {\n  display: inline-block;\n  font: normal normal normal 14px/1 FontAwesome;\n  font-size: inherit;\n  text-rendering: auto;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n/* makes the font 33% larger relative to the icon container */\n.fa-lg {\n  font-size: 1.33333333em;\n  line-height: 0.75em;\n  vertical-align: -15%;\n}\n.fa-2x {\n  font-size: 2em;\n}\n.fa-3x {\n  font-size: 3em;\n}\n.fa-4x {\n  font-size: 4em;\n}\n.fa-5x {\n  font-size: 5em;\n}\n.fa-fw {\n  width: 1.28571429em;\n  text-align: center;\n}\n.fa-ul {\n  padding-left: 0;\n  margin-left: 2.14285714em;\n  list-style-type: none;\n}\n.fa-ul > li {\n  position: relative;\n}\n.fa-li {\n  position: absolute;\n  left: -2.14285714em;\n  width: 2.14285714em;\n  top: 0.14285714em;\n  text-align: center;\n}\n.fa-li.fa-lg {\n  left: -1.85714286em;\n}\n.fa-border {\n  padding: 0.2em 0.25em 0.15em;\n  border: solid 0.08em #eee;\n  border-radius: 0.1em;\n}\n.fa-pull-left {\n  float: left;\n}\n.fa-pull-right {\n  float: right;\n}\n.fa.fa-pull-left {\n  margin-right: 0.3em;\n}\n.fa.fa-pull-right {\n  margin-left: 0.3em;\n}\n/* Deprecated as of 4.4.0 */\n.pull-right {\n  float: right;\n}\n.pull-left {\n  float: left;\n}\n.fa.pull-left {\n  margin-right: 0.3em;\n}\n.fa.pull-right {\n  margin-left: 0.3em;\n}\n.fa-spin {\n  -webkit-animation: fa-spin 2s infinite linear;\n  animation: fa-spin 2s infinite linear;\n}\n.fa-pulse {\n  -webkit-animation: fa-spin 1s infinite steps(8);\n  animation: fa-spin 1s infinite steps(8);\n}\n@-webkit-keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(359deg);\n    transform: rotate(359deg);\n  }\n}\n@keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(359deg);\n    transform: rotate(359deg);\n  }\n}\n.fa-rotate-90 {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=1)\";\n  -webkit-transform: rotate(90deg);\n  -ms-transform: rotate(90deg);\n  transform: rotate(90deg);\n}\n.fa-rotate-180 {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=2)\";\n  -webkit-transform: rotate(180deg);\n  -ms-transform: rotate(180deg);\n  transform: rotate(180deg);\n}\n.fa-rotate-270 {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=3)\";\n  -webkit-transform: rotate(270deg);\n  -ms-transform: rotate(270deg);\n  transform: rotate(270deg);\n}\n.fa-flip-horizontal {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=0, mirror=1)\";\n  -webkit-transform: scale(-1, 1);\n  -ms-transform: scale(-1, 1);\n  transform: scale(-1, 1);\n}\n.fa-flip-vertical {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)\";\n  -webkit-transform: scale(1, -1);\n  -ms-transform: scale(1, -1);\n  transform: scale(1, -1);\n}\n:root .fa-rotate-90,\n:root .fa-rotate-180,\n:root .fa-rotate-270,\n:root .fa-flip-horizontal,\n:root .fa-flip-vertical {\n  filter: none;\n}\n.fa-stack {\n  position: relative;\n  display: inline-block;\n  width: 2em;\n  height: 2em;\n  line-height: 2em;\n  vertical-align: middle;\n}\n.fa-stack-1x,\n.fa-stack-2x {\n  position: absolute;\n  left: 0;\n  width: 100%;\n  text-align: center;\n}\n.fa-stack-1x {\n  line-height: inherit;\n}\n.fa-stack-2x {\n  font-size: 2em;\n}\n.fa-inverse {\n  color: #fff;\n}\n/* Font Awesome uses the Unicode Private Use Area (PUA) to ensure screen\n   readers do not read off random characters that represent icons */\n.fa-glass:before {\n  content: \"\\f000\";\n}\n.fa-music:before {\n  content: \"\\f001\";\n}\n.fa-search:before {\n  content: \"\\f002\";\n}\n.fa-envelope-o:before {\n  content: \"\\f003\";\n}\n.fa-heart:before {\n  content: \"\\f004\";\n}\n.fa-star:before {\n  content: \"\\f005\";\n}\n.fa-star-o:before {\n  content: \"\\f006\";\n}\n.fa-user:before {\n  content: \"\\f007\";\n}\n.fa-film:before {\n  content: \"\\f008\";\n}\n.fa-th-large:before {\n  content: \"\\f009\";\n}\n.fa-th:before {\n  content: \"\\f00a\";\n}\n.fa-th-list:before {\n  content: \"\\f00b\";\n}\n.fa-check:before {\n  content: \"\\f00c\";\n}\n.fa-remove:before,\n.fa-close:before,\n.fa-times:before {\n  content: \"\\f00d\";\n}\n.fa-search-plus:before {\n  content: \"\\f00e\";\n}\n.fa-search-minus:before {\n  content: \"\\f010\";\n}\n.fa-power-off:before {\n  content: \"\\f011\";\n}\n.fa-signal:before {\n  content: \"\\f012\";\n}\n.fa-gear:before,\n.fa-cog:before {\n  content: \"\\f013\";\n}\n.fa-trash-o:before {\n  content: \"\\f014\";\n}\n.fa-home:before {\n  content: \"\\f015\";\n}\n.fa-file-o:before {\n  content: \"\\f016\";\n}\n.fa-clock-o:before {\n  content: \"\\f017\";\n}\n.fa-road:before {\n  content: \"\\f018\";\n}\n.fa-download:before {\n  content: \"\\f019\";\n}\n.fa-arrow-circle-o-down:before {\n  content: \"\\f01a\";\n}\n.fa-arrow-circle-o-up:before {\n  content: \"\\f01b\";\n}\n.fa-inbox:before {\n  content: \"\\f01c\";\n}\n.fa-play-circle-o:before {\n  content: \"\\f01d\";\n}\n.fa-rotate-right:before,\n.fa-repeat:before {\n  content: \"\\f01e\";\n}\n.fa-refresh:before {\n  content: \"\\f021\";\n}\n.fa-list-alt:before {\n  content: \"\\f022\";\n}\n.fa-lock:before {\n  content: \"\\f023\";\n}\n.fa-flag:before {\n  content: \"\\f024\";\n}\n.fa-headphones:before {\n  content: \"\\f025\";\n}\n.fa-volume-off:before {\n  content: \"\\f026\";\n}\n.fa-volume-down:before {\n  content: \"\\f027\";\n}\n.fa-volume-up:before {\n  content: \"\\f028\";\n}\n.fa-qrcode:before {\n  content: \"\\f029\";\n}\n.fa-barcode:before {\n  content: \"\\f02a\";\n}\n.fa-tag:before {\n  content: \"\\f02b\";\n}\n.fa-tags:before {\n  content: \"\\f02c\";\n}\n.fa-book:before {\n  content: \"\\f02d\";\n}\n.fa-bookmark:before {\n  content: \"\\f02e\";\n}\n.fa-print:before {\n  content: \"\\f02f\";\n}\n.fa-camera:before {\n  content: \"\\f030\";\n}\n.fa-font:before {\n  content: \"\\f031\";\n}\n.fa-bold:before {\n  content: \"\\f032\";\n}\n.fa-italic:before {\n  content: \"\\f033\";\n}\n.fa-text-height:before {\n  content: \"\\f034\";\n}\n.fa-text-width:before {\n  content: \"\\f035\";\n}\n.fa-align-left:before {\n  content: \"\\f036\";\n}\n.fa-align-center:before {\n  content: \"\\f037\";\n}\n.fa-align-right:before {\n  content: \"\\f038\";\n}\n.fa-align-justify:before {\n  content: \"\\f039\";\n}\n.fa-list:before {\n  content: \"\\f03a\";\n}\n.fa-dedent:before,\n.fa-outdent:before {\n  content: \"\\f03b\";\n}\n.fa-indent:before {\n  content: \"\\f03c\";\n}\n.fa-video-camera:before {\n  content: \"\\f03d\";\n}\n.fa-photo:before,\n.fa-image:before,\n.fa-picture-o:before {\n  content: \"\\f03e\";\n}\n.fa-pencil:before {\n  content: \"\\f040\";\n}\n.fa-map-marker:before {\n  content: \"\\f041\";\n}\n.fa-adjust:before {\n  content: \"\\f042\";\n}\n.fa-tint:before {\n  content: \"\\f043\";\n}\n.fa-edit:before,\n.fa-pencil-square-o:before {\n  content: \"\\f044\";\n}\n.fa-share-square-o:before {\n  content: \"\\f045\";\n}\n.fa-check-square-o:before {\n  content: \"\\f046\";\n}\n.fa-arrows:before {\n  content: \"\\f047\";\n}\n.fa-step-backward:before {\n  content: \"\\f048\";\n}\n.fa-fast-backward:before {\n  content: \"\\f049\";\n}\n.fa-backward:before {\n  content: \"\\f04a\";\n}\n.fa-play:before {\n  content: \"\\f04b\";\n}\n.fa-pause:before {\n  content: \"\\f04c\";\n}\n.fa-stop:before {\n  content: \"\\f04d\";\n}\n.fa-forward:before {\n  content: \"\\f04e\";\n}\n.fa-fast-forward:before {\n  content: \"\\f050\";\n}\n.fa-step-forward:before {\n  content: \"\\f051\";\n}\n.fa-eject:before {\n  content: \"\\f052\";\n}\n.fa-chevron-left:before {\n  content: \"\\f053\";\n}\n.fa-chevron-right:before {\n  content: \"\\f054\";\n}\n.fa-plus-circle:before {\n  content: \"\\f055\";\n}\n.fa-minus-circle:before {\n  content: \"\\f056\";\n}\n.fa-times-circle:before {\n  content: \"\\f057\";\n}\n.fa-check-circle:before {\n  content: \"\\f058\";\n}\n.fa-question-circle:before {\n  content: \"\\f059\";\n}\n.fa-info-circle:before {\n  content: \"\\f05a\";\n}\n.fa-crosshairs:before {\n  content: \"\\f05b\";\n}\n.fa-times-circle-o:before {\n  content: \"\\f05c\";\n}\n.fa-check-circle-o:before {\n  content: \"\\f05d\";\n}\n.fa-ban:before {\n  content: \"\\f05e\";\n}\n.fa-arrow-left:before {\n  content: \"\\f060\";\n}\n.fa-arrow-right:before {\n  content: \"\\f061\";\n}\n.fa-arrow-up:before {\n  content: \"\\f062\";\n}\n.fa-arrow-down:before {\n  content: \"\\f063\";\n}\n.fa-mail-forward:before,\n.fa-share:before {\n  content: \"\\f064\";\n}\n.fa-expand:before {\n  content: \"\\f065\";\n}\n.fa-compress:before {\n  content: \"\\f066\";\n}\n.fa-plus:before {\n  content: \"\\f067\";\n}\n.fa-minus:before {\n  content: \"\\f068\";\n}\n.fa-asterisk:before {\n  content: \"\\f069\";\n}\n.fa-exclamation-circle:before {\n  content: \"\\f06a\";\n}\n.fa-gift:before {\n  content: \"\\f06b\";\n}\n.fa-leaf:before {\n  content: \"\\f06c\";\n}\n.fa-fire:before {\n  content: \"\\f06d\";\n}\n.fa-eye:before {\n  content: \"\\f06e\";\n}\n.fa-eye-slash:before {\n  content: \"\\f070\";\n}\n.fa-warning:before,\n.fa-exclamation-triangle:before {\n  content: \"\\f071\";\n}\n.fa-plane:before {\n  content: \"\\f072\";\n}\n.fa-calendar:before {\n  content: \"\\f073\";\n}\n.fa-random:before {\n  content: \"\\f074\";\n}\n.fa-comment:before {\n  content: \"\\f075\";\n}\n.fa-magnet:before {\n  content: \"\\f076\";\n}\n.fa-chevron-up:before {\n  content: \"\\f077\";\n}\n.fa-chevron-down:before {\n  content: \"\\f078\";\n}\n.fa-retweet:before {\n  content: \"\\f079\";\n}\n.fa-shopping-cart:before {\n  content: \"\\f07a\";\n}\n.fa-folder:before {\n  content: \"\\f07b\";\n}\n.fa-folder-open:before {\n  content: \"\\f07c\";\n}\n.fa-arrows-v:before {\n  content: \"\\f07d\";\n}\n.fa-arrows-h:before {\n  content: \"\\f07e\";\n}\n.fa-bar-chart-o:before,\n.fa-bar-chart:before {\n  content: \"\\f080\";\n}\n.fa-twitter-square:before {\n  content: \"\\f081\";\n}\n.fa-facebook-square:before {\n  content: \"\\f082\";\n}\n.fa-camera-retro:before {\n  content: \"\\f083\";\n}\n.fa-key:before {\n  content: \"\\f084\";\n}\n.fa-gears:before,\n.fa-cogs:before {\n  content: \"\\f085\";\n}\n.fa-comments:before {\n  content: \"\\f086\";\n}\n.fa-thumbs-o-up:before {\n  content: \"\\f087\";\n}\n.fa-thumbs-o-down:before {\n  content: \"\\f088\";\n}\n.fa-star-half:before {\n  content: \"\\f089\";\n}\n.fa-heart-o:before {\n  content: \"\\f08a\";\n}\n.fa-sign-out:before {\n  content: \"\\f08b\";\n}\n.fa-linkedin-square:before {\n  content: \"\\f08c\";\n}\n.fa-thumb-tack:before {\n  content: \"\\f08d\";\n}\n.fa-external-link:before {\n  content: \"\\f08e\";\n}\n.fa-sign-in:before {\n  content: \"\\f090\";\n}\n.fa-trophy:before {\n  content: \"\\f091\";\n}\n.fa-github-square:before {\n  content: \"\\f092\";\n}\n.fa-upload:before {\n  content: \"\\f093\";\n}\n.fa-lemon-o:before {\n  content: \"\\f094\";\n}\n.fa-phone:before {\n  content: \"\\f095\";\n}\n.fa-square-o:before {\n  content: \"\\f096\";\n}\n.fa-bookmark-o:before {\n  content: \"\\f097\";\n}\n.fa-phone-square:before {\n  content: \"\\f098\";\n}\n.fa-twitter:before {\n  content: \"\\f099\";\n}\n.fa-facebook-f:before,\n.fa-facebook:before {\n  content: \"\\f09a\";\n}\n.fa-github:before {\n  content: \"\\f09b\";\n}\n.fa-unlock:before {\n  content: \"\\f09c\";\n}\n.fa-credit-card:before {\n  content: \"\\f09d\";\n}\n.fa-feed:before,\n.fa-rss:before {\n  content: \"\\f09e\";\n}\n.fa-hdd-o:before {\n  content: \"\\f0a0\";\n}\n.fa-bullhorn:before {\n  content: \"\\f0a1\";\n}\n.fa-bell:before {\n  content: \"\\f0f3\";\n}\n.fa-certificate:before {\n  content: \"\\f0a3\";\n}\n.fa-hand-o-right:before {\n  content: \"\\f0a4\";\n}\n.fa-hand-o-left:before {\n  content: \"\\f0a5\";\n}\n.fa-hand-o-up:before {\n  content: \"\\f0a6\";\n}\n.fa-hand-o-down:before {\n  content: \"\\f0a7\";\n}\n.fa-arrow-circle-left:before {\n  content: \"\\f0a8\";\n}\n.fa-arrow-circle-right:before {\n  content: \"\\f0a9\";\n}\n.fa-arrow-circle-up:before {\n  content: \"\\f0aa\";\n}\n.fa-arrow-circle-down:before {\n  content: \"\\f0ab\";\n}\n.fa-globe:before {\n  content: \"\\f0ac\";\n}\n.fa-wrench:before {\n  content: \"\\f0ad\";\n}\n.fa-tasks:before {\n  content: \"\\f0ae\";\n}\n.fa-filter:before {\n  content: \"\\f0b0\";\n}\n.fa-briefcase:before {\n  content: \"\\f0b1\";\n}\n.fa-arrows-alt:before {\n  content: \"\\f0b2\";\n}\n.fa-group:before,\n.fa-users:before {\n  content: \"\\f0c0\";\n}\n.fa-chain:before,\n.fa-link:before {\n  content: \"\\f0c1\";\n}\n.fa-cloud:before {\n  content: \"\\f0c2\";\n}\n.fa-flask:before {\n  content: \"\\f0c3\";\n}\n.fa-cut:before,\n.fa-scissors:before {\n  content: \"\\f0c4\";\n}\n.fa-copy:before,\n.fa-files-o:before {\n  content: \"\\f0c5\";\n}\n.fa-paperclip:before {\n  content: \"\\f0c6\";\n}\n.fa-save:before,\n.fa-floppy-o:before {\n  content: \"\\f0c7\";\n}\n.fa-square:before {\n  content: \"\\f0c8\";\n}\n.fa-navicon:before,\n.fa-reorder:before,\n.fa-bars:before {\n  content: \"\\f0c9\";\n}\n.fa-list-ul:before {\n  content: \"\\f0ca\";\n}\n.fa-list-ol:before {\n  content: \"\\f0cb\";\n}\n.fa-strikethrough:before {\n  content: \"\\f0cc\";\n}\n.fa-underline:before {\n  content: \"\\f0cd\";\n}\n.fa-table:before {\n  content: \"\\f0ce\";\n}\n.fa-magic:before {\n  content: \"\\f0d0\";\n}\n.fa-truck:before {\n  content: \"\\f0d1\";\n}\n.fa-pinterest:before {\n  content: \"\\f0d2\";\n}\n.fa-pinterest-square:before {\n  content: \"\\f0d3\";\n}\n.fa-google-plus-square:before {\n  content: \"\\f0d4\";\n}\n.fa-google-plus:before {\n  content: \"\\f0d5\";\n}\n.fa-money:before {\n  content: \"\\f0d6\";\n}\n.fa-caret-down:before {\n  content: \"\\f0d7\";\n}\n.fa-caret-up:before {\n  content: \"\\f0d8\";\n}\n.fa-caret-left:before {\n  content: \"\\f0d9\";\n}\n.fa-caret-right:before {\n  content: \"\\f0da\";\n}\n.fa-columns:before {\n  content: \"\\f0db\";\n}\n.fa-unsorted:before,\n.fa-sort:before {\n  content: \"\\f0dc\";\n}\n.fa-sort-down:before,\n.fa-sort-desc:before {\n  content: \"\\f0dd\";\n}\n.fa-sort-up:before,\n.fa-sort-asc:before {\n  content: \"\\f0de\";\n}\n.fa-envelope:before {\n  content: \"\\f0e0\";\n}\n.fa-linkedin:before {\n  content: \"\\f0e1\";\n}\n.fa-rotate-left:before,\n.fa-undo:before {\n  content: \"\\f0e2\";\n}\n.fa-legal:before,\n.fa-gavel:before {\n  content: \"\\f0e3\";\n}\n.fa-dashboard:before,\n.fa-tachometer:before {\n  content: \"\\f0e4\";\n}\n.fa-comment-o:before {\n  content: \"\\f0e5\";\n}\n.fa-comments-o:before {\n  content: \"\\f0e6\";\n}\n.fa-flash:before,\n.fa-bolt:before {\n  content: \"\\f0e7\";\n}\n.fa-sitemap:before {\n  content: \"\\f0e8\";\n}\n.fa-umbrella:before {\n  content: \"\\f0e9\";\n}\n.fa-paste:before,\n.fa-clipboard:before {\n  content: \"\\f0ea\";\n}\n.fa-lightbulb-o:before {\n  content: \"\\f0eb\";\n}\n.fa-exchange:before {\n  content: \"\\f0ec\";\n}\n.fa-cloud-download:before {\n  content: \"\\f0ed\";\n}\n.fa-cloud-upload:before {\n  content: \"\\f0ee\";\n}\n.fa-user-md:before {\n  content: \"\\f0f0\";\n}\n.fa-stethoscope:before {\n  content: \"\\f0f1\";\n}\n.fa-suitcase:before {\n  content: \"\\f0f2\";\n}\n.fa-bell-o:before {\n  content: \"\\f0a2\";\n}\n.fa-coffee:before {\n  content: \"\\f0f4\";\n}\n.fa-cutlery:before {\n  content: \"\\f0f5\";\n}\n.fa-file-text-o:before {\n  content: \"\\f0f6\";\n}\n.fa-building-o:before {\n  content: \"\\f0f7\";\n}\n.fa-hospital-o:before {\n  content: \"\\f0f8\";\n}\n.fa-ambulance:before {\n  content: \"\\f0f9\";\n}\n.fa-medkit:before {\n  content: \"\\f0fa\";\n}\n.fa-fighter-jet:before {\n  content: \"\\f0fb\";\n}\n.fa-beer:before {\n  content: \"\\f0fc\";\n}\n.fa-h-square:before {\n  content: \"\\f0fd\";\n}\n.fa-plus-square:before {\n  content: \"\\f0fe\";\n}\n.fa-angle-double-left:before {\n  content: \"\\f100\";\n}\n.fa-angle-double-right:before {\n  content: \"\\f101\";\n}\n.fa-angle-double-up:before {\n  content: \"\\f102\";\n}\n.fa-angle-double-down:before {\n  content: \"\\f103\";\n}\n.fa-angle-left:before {\n  content: \"\\f104\";\n}\n.fa-angle-right:before {\n  content: \"\\f105\";\n}\n.fa-angle-up:before {\n  content: \"\\f106\";\n}\n.fa-angle-down:before {\n  content: \"\\f107\";\n}\n.fa-desktop:before {\n  content: \"\\f108\";\n}\n.fa-laptop:before {\n  content: \"\\f109\";\n}\n.fa-tablet:before {\n  content: \"\\f10a\";\n}\n.fa-mobile-phone:before,\n.fa-mobile:before {\n  content: \"\\f10b\";\n}\n.fa-circle-o:before {\n  content: \"\\f10c\";\n}\n.fa-quote-left:before {\n  content: \"\\f10d\";\n}\n.fa-quote-right:before {\n  content: \"\\f10e\";\n}\n.fa-spinner:before {\n  content: \"\\f110\";\n}\n.fa-circle:before {\n  content: \"\\f111\";\n}\n.fa-mail-reply:before,\n.fa-reply:before {\n  content: \"\\f112\";\n}\n.fa-github-alt:before {\n  content: \"\\f113\";\n}\n.fa-folder-o:before {\n  content: \"\\f114\";\n}\n.fa-folder-open-o:before {\n  content: \"\\f115\";\n}\n.fa-smile-o:before {\n  content: \"\\f118\";\n}\n.fa-frown-o:before {\n  content: \"\\f119\";\n}\n.fa-meh-o:before {\n  content: \"\\f11a\";\n}\n.fa-gamepad:before {\n  content: \"\\f11b\";\n}\n.fa-keyboard-o:before {\n  content: \"\\f11c\";\n}\n.fa-flag-o:before {\n  content: \"\\f11d\";\n}\n.fa-flag-checkered:before {\n  content: \"\\f11e\";\n}\n.fa-terminal:before {\n  content: \"\\f120\";\n}\n.fa-code:before {\n  content: \"\\f121\";\n}\n.fa-mail-reply-all:before,\n.fa-reply-all:before {\n  content: \"\\f122\";\n}\n.fa-star-half-empty:before,\n.fa-star-half-full:before,\n.fa-star-half-o:before {\n  content: \"\\f123\";\n}\n.fa-location-arrow:before {\n  content: \"\\f124\";\n}\n.fa-crop:before {\n  content: \"\\f125\";\n}\n.fa-code-fork:before {\n  content: \"\\f126\";\n}\n.fa-unlink:before,\n.fa-chain-broken:before {\n  content: \"\\f127\";\n}\n.fa-question:before {\n  content: \"\\f128\";\n}\n.fa-info:before {\n  content: \"\\f129\";\n}\n.fa-exclamation:before {\n  content: \"\\f12a\";\n}\n.fa-superscript:before {\n  content: \"\\f12b\";\n}\n.fa-subscript:before {\n  content: \"\\f12c\";\n}\n.fa-eraser:before {\n  content: \"\\f12d\";\n}\n.fa-puzzle-piece:before {\n  content: \"\\f12e\";\n}\n.fa-microphone:before {\n  content: \"\\f130\";\n}\n.fa-microphone-slash:before {\n  content: \"\\f131\";\n}\n.fa-shield:before {\n  content: \"\\f132\";\n}\n.fa-calendar-o:before {\n  content: \"\\f133\";\n}\n.fa-fire-extinguisher:before {\n  content: \"\\f134\";\n}\n.fa-rocket:before {\n  content: \"\\f135\";\n}\n.fa-maxcdn:before {\n  content: \"\\f136\";\n}\n.fa-chevron-circle-left:before {\n  content: \"\\f137\";\n}\n.fa-chevron-circle-right:before {\n  content: \"\\f138\";\n}\n.fa-chevron-circle-up:before {\n  content: \"\\f139\";\n}\n.fa-chevron-circle-down:before {\n  content: \"\\f13a\";\n}\n.fa-html5:before {\n  content: \"\\f13b\";\n}\n.fa-css3:before {\n  content: \"\\f13c\";\n}\n.fa-anchor:before {\n  content: \"\\f13d\";\n}\n.fa-unlock-alt:before {\n  content: \"\\f13e\";\n}\n.fa-bullseye:before {\n  content: \"\\f140\";\n}\n.fa-ellipsis-h:before {\n  content: \"\\f141\";\n}\n.fa-ellipsis-v:before {\n  content: \"\\f142\";\n}\n.fa-rss-square:before {\n  content: \"\\f143\";\n}\n.fa-play-circle:before {\n  content: \"\\f144\";\n}\n.fa-ticket:before {\n  content: \"\\f145\";\n}\n.fa-minus-square:before {\n  content: \"\\f146\";\n}\n.fa-minus-square-o:before {\n  content: \"\\f147\";\n}\n.fa-level-up:before {\n  content: \"\\f148\";\n}\n.fa-level-down:before {\n  content: \"\\f149\";\n}\n.fa-check-square:before {\n  content: \"\\f14a\";\n}\n.fa-pencil-square:before {\n  content: \"\\f14b\";\n}\n.fa-external-link-square:before {\n  content: \"\\f14c\";\n}\n.fa-share-square:before {\n  content: \"\\f14d\";\n}\n.fa-compass:before {\n  content: \"\\f14e\";\n}\n.fa-toggle-down:before,\n.fa-caret-square-o-down:before {\n  content: \"\\f150\";\n}\n.fa-toggle-up:before,\n.fa-caret-square-o-up:before {\n  content: \"\\f151\";\n}\n.fa-toggle-right:before,\n.fa-caret-square-o-right:before {\n  content: \"\\f152\";\n}\n.fa-euro:before,\n.fa-eur:before {\n  content: \"\\f153\";\n}\n.fa-gbp:before {\n  content: \"\\f154\";\n}\n.fa-dollar:before,\n.fa-usd:before {\n  content: \"\\f155\";\n}\n.fa-rupee:before,\n.fa-inr:before {\n  content: \"\\f156\";\n}\n.fa-cny:before,\n.fa-rmb:before,\n.fa-yen:before,\n.fa-jpy:before {\n  content: \"\\f157\";\n}\n.fa-ruble:before,\n.fa-rouble:before,\n.fa-rub:before {\n  content: \"\\f158\";\n}\n.fa-won:before,\n.fa-krw:before {\n  content: \"\\f159\";\n}\n.fa-bitcoin:before,\n.fa-btc:before {\n  content: \"\\f15a\";\n}\n.fa-file:before {\n  content: \"\\f15b\";\n}\n.fa-file-text:before {\n  content: \"\\f15c\";\n}\n.fa-sort-alpha-asc:before {\n  content: \"\\f15d\";\n}\n.fa-sort-alpha-desc:before {\n  content: \"\\f15e\";\n}\n.fa-sort-amount-asc:before {\n  content: \"\\f160\";\n}\n.fa-sort-amount-desc:before {\n  content: \"\\f161\";\n}\n.fa-sort-numeric-asc:before {\n  content: \"\\f162\";\n}\n.fa-sort-numeric-desc:before {\n  content: \"\\f163\";\n}\n.fa-thumbs-up:before {\n  content: \"\\f164\";\n}\n.fa-thumbs-down:before {\n  content: \"\\f165\";\n}\n.fa-youtube-square:before {\n  content: \"\\f166\";\n}\n.fa-youtube:before {\n  content: \"\\f167\";\n}\n.fa-xing:before {\n  content: \"\\f168\";\n}\n.fa-xing-square:before {\n  content: \"\\f169\";\n}\n.fa-youtube-play:before {\n  content: \"\\f16a\";\n}\n.fa-dropbox:before {\n  content: \"\\f16b\";\n}\n.fa-stack-overflow:before {\n  content: \"\\f16c\";\n}\n.fa-instagram:before {\n  content: \"\\f16d\";\n}\n.fa-flickr:before {\n  content: \"\\f16e\";\n}\n.fa-adn:before {\n  content: \"\\f170\";\n}\n.fa-bitbucket:before {\n  content: \"\\f171\";\n}\n.fa-bitbucket-square:before {\n  content: \"\\f172\";\n}\n.fa-tumblr:before {\n  content: \"\\f173\";\n}\n.fa-tumblr-square:before {\n  content: \"\\f174\";\n}\n.fa-long-arrow-down:before {\n  content: \"\\f175\";\n}\n.fa-long-arrow-up:before {\n  content: \"\\f176\";\n}\n.fa-long-arrow-left:before {\n  content: \"\\f177\";\n}\n.fa-long-arrow-right:before {\n  content: \"\\f178\";\n}\n.fa-apple:before {\n  content: \"\\f179\";\n}\n.fa-windows:before {\n  content: \"\\f17a\";\n}\n.fa-android:before {\n  content: \"\\f17b\";\n}\n.fa-linux:before {\n  content: \"\\f17c\";\n}\n.fa-dribbble:before {\n  content: \"\\f17d\";\n}\n.fa-skype:before {\n  content: \"\\f17e\";\n}\n.fa-foursquare:before {\n  content: \"\\f180\";\n}\n.fa-trello:before {\n  content: \"\\f181\";\n}\n.fa-female:before {\n  content: \"\\f182\";\n}\n.fa-male:before {\n  content: \"\\f183\";\n}\n.fa-gittip:before,\n.fa-gratipay:before {\n  content: \"\\f184\";\n}\n.fa-sun-o:before {\n  content: \"\\f185\";\n}\n.fa-moon-o:before {\n  content: \"\\f186\";\n}\n.fa-archive:before {\n  content: \"\\f187\";\n}\n.fa-bug:before {\n  content: \"\\f188\";\n}\n.fa-vk:before {\n  content: \"\\f189\";\n}\n.fa-weibo:before {\n  content: \"\\f18a\";\n}\n.fa-renren:before {\n  content: \"\\f18b\";\n}\n.fa-pagelines:before {\n  content: \"\\f18c\";\n}\n.fa-stack-exchange:before {\n  content: \"\\f18d\";\n}\n.fa-arrow-circle-o-right:before {\n  content: \"\\f18e\";\n}\n.fa-arrow-circle-o-left:before {\n  content: \"\\f190\";\n}\n.fa-toggle-left:before,\n.fa-caret-square-o-left:before {\n  content: \"\\f191\";\n}\n.fa-dot-circle-o:before {\n  content: \"\\f192\";\n}\n.fa-wheelchair:before {\n  content: \"\\f193\";\n}\n.fa-vimeo-square:before {\n  content: \"\\f194\";\n}\n.fa-turkish-lira:before,\n.fa-try:before {\n  content: \"\\f195\";\n}\n.fa-plus-square-o:before {\n  content: \"\\f196\";\n}\n.fa-space-shuttle:before {\n  content: \"\\f197\";\n}\n.fa-slack:before {\n  content: \"\\f198\";\n}\n.fa-envelope-square:before {\n  content: \"\\f199\";\n}\n.fa-wordpress:before {\n  content: \"\\f19a\";\n}\n.fa-openid:before {\n  content: \"\\f19b\";\n}\n.fa-institution:before,\n.fa-bank:before,\n.fa-university:before {\n  content: \"\\f19c\";\n}\n.fa-mortar-board:before,\n.fa-graduation-cap:before {\n  content: \"\\f19d\";\n}\n.fa-yahoo:before {\n  content: \"\\f19e\";\n}\n.fa-google:before {\n  content: \"\\f1a0\";\n}\n.fa-reddit:before {\n  content: \"\\f1a1\";\n}\n.fa-reddit-square:before {\n  content: \"\\f1a2\";\n}\n.fa-stumbleupon-circle:before {\n  content: \"\\f1a3\";\n}\n.fa-stumbleupon:before {\n  content: \"\\f1a4\";\n}\n.fa-delicious:before {\n  content: \"\\f1a5\";\n}\n.fa-digg:before {\n  content: \"\\f1a6\";\n}\n.fa-pied-piper-pp:before {\n  content: \"\\f1a7\";\n}\n.fa-pied-piper-alt:before {\n  content: \"\\f1a8\";\n}\n.fa-drupal:before {\n  content: \"\\f1a9\";\n}\n.fa-joomla:before {\n  content: \"\\f1aa\";\n}\n.fa-language:before {\n  content: \"\\f1ab\";\n}\n.fa-fax:before {\n  content: \"\\f1ac\";\n}\n.fa-building:before {\n  content: \"\\f1ad\";\n}\n.fa-child:before {\n  content: \"\\f1ae\";\n}\n.fa-paw:before {\n  content: \"\\f1b0\";\n}\n.fa-spoon:before {\n  content: \"\\f1b1\";\n}\n.fa-cube:before {\n  content: \"\\f1b2\";\n}\n.fa-cubes:before {\n  content: \"\\f1b3\";\n}\n.fa-behance:before {\n  content: \"\\f1b4\";\n}\n.fa-behance-square:before {\n  content: \"\\f1b5\";\n}\n.fa-steam:before {\n  content: \"\\f1b6\";\n}\n.fa-steam-square:before {\n  content: \"\\f1b7\";\n}\n.fa-recycle:before {\n  content: \"\\f1b8\";\n}\n.fa-automobile:before,\n.fa-car:before {\n  content: \"\\f1b9\";\n}\n.fa-cab:before,\n.fa-taxi:before {\n  content: \"\\f1ba\";\n}\n.fa-tree:before {\n  content: \"\\f1bb\";\n}\n.fa-spotify:before {\n  content: \"\\f1bc\";\n}\n.fa-deviantart:before {\n  content: \"\\f1bd\";\n}\n.fa-soundcloud:before {\n  content: \"\\f1be\";\n}\n.fa-database:before {\n  content: \"\\f1c0\";\n}\n.fa-file-pdf-o:before {\n  content: \"\\f1c1\";\n}\n.fa-file-word-o:before {\n  content: \"\\f1c2\";\n}\n.fa-file-excel-o:before {\n  content: \"\\f1c3\";\n}\n.fa-file-powerpoint-o:before {\n  content: \"\\f1c4\";\n}\n.fa-file-photo-o:before,\n.fa-file-picture-o:before,\n.fa-file-image-o:before {\n  content: \"\\f1c5\";\n}\n.fa-file-zip-o:before,\n.fa-file-archive-o:before {\n  content: \"\\f1c6\";\n}\n.fa-file-sound-o:before,\n.fa-file-audio-o:before {\n  content: \"\\f1c7\";\n}\n.fa-file-movie-o:before,\n.fa-file-video-o:before {\n  content: \"\\f1c8\";\n}\n.fa-file-code-o:before {\n  content: \"\\f1c9\";\n}\n.fa-vine:before {\n  content: \"\\f1ca\";\n}\n.fa-codepen:before {\n  content: \"\\f1cb\";\n}\n.fa-jsfiddle:before {\n  content: \"\\f1cc\";\n}\n.fa-life-bouy:before,\n.fa-life-buoy:before,\n.fa-life-saver:before,\n.fa-support:before,\n.fa-life-ring:before {\n  content: \"\\f1cd\";\n}\n.fa-circle-o-notch:before {\n  content: \"\\f1ce\";\n}\n.fa-ra:before,\n.fa-resistance:before,\n.fa-rebel:before {\n  content: \"\\f1d0\";\n}\n.fa-ge:before,\n.fa-empire:before {\n  content: \"\\f1d1\";\n}\n.fa-git-square:before {\n  content: \"\\f1d2\";\n}\n.fa-git:before {\n  content: \"\\f1d3\";\n}\n.fa-y-combinator-square:before,\n.fa-yc-square:before,\n.fa-hacker-news:before {\n  content: \"\\f1d4\";\n}\n.fa-tencent-weibo:before {\n  content: \"\\f1d5\";\n}\n.fa-qq:before {\n  content: \"\\f1d6\";\n}\n.fa-wechat:before,\n.fa-weixin:before {\n  content: \"\\f1d7\";\n}\n.fa-send:before,\n.fa-paper-plane:before {\n  content: \"\\f1d8\";\n}\n.fa-send-o:before,\n.fa-paper-plane-o:before {\n  content: \"\\f1d9\";\n}\n.fa-history:before {\n  content: \"\\f1da\";\n}\n.fa-circle-thin:before {\n  content: \"\\f1db\";\n}\n.fa-header:before {\n  content: \"\\f1dc\";\n}\n.fa-paragraph:before {\n  content: \"\\f1dd\";\n}\n.fa-sliders:before {\n  content: \"\\f1de\";\n}\n.fa-share-alt:before {\n  content: \"\\f1e0\";\n}\n.fa-share-alt-square:before {\n  content: \"\\f1e1\";\n}\n.fa-bomb:before {\n  content: \"\\f1e2\";\n}\n.fa-soccer-ball-o:before,\n.fa-futbol-o:before {\n  content: \"\\f1e3\";\n}\n.fa-tty:before {\n  content: \"\\f1e4\";\n}\n.fa-binoculars:before {\n  content: \"\\f1e5\";\n}\n.fa-plug:before {\n  content: \"\\f1e6\";\n}\n.fa-slideshare:before {\n  content: \"\\f1e7\";\n}\n.fa-twitch:before {\n  content: \"\\f1e8\";\n}\n.fa-yelp:before {\n  content: \"\\f1e9\";\n}\n.fa-newspaper-o:before {\n  content: \"\\f1ea\";\n}\n.fa-wifi:before {\n  content: \"\\f1eb\";\n}\n.fa-calculator:before {\n  content: \"\\f1ec\";\n}\n.fa-paypal:before {\n  content: \"\\f1ed\";\n}\n.fa-google-wallet:before {\n  content: \"\\f1ee\";\n}\n.fa-cc-visa:before {\n  content: \"\\f1f0\";\n}\n.fa-cc-mastercard:before {\n  content: \"\\f1f1\";\n}\n.fa-cc-discover:before {\n  content: \"\\f1f2\";\n}\n.fa-cc-amex:before {\n  content: \"\\f1f3\";\n}\n.fa-cc-paypal:before {\n  content: \"\\f1f4\";\n}\n.fa-cc-stripe:before {\n  content: \"\\f1f5\";\n}\n.fa-bell-slash:before {\n  content: \"\\f1f6\";\n}\n.fa-bell-slash-o:before {\n  content: \"\\f1f7\";\n}\n.fa-trash:before {\n  content: \"\\f1f8\";\n}\n.fa-copyright:before {\n  content: \"\\f1f9\";\n}\n.fa-at:before {\n  content: \"\\f1fa\";\n}\n.fa-eyedropper:before {\n  content: \"\\f1fb\";\n}\n.fa-paint-brush:before {\n  content: \"\\f1fc\";\n}\n.fa-birthday-cake:before {\n  content: \"\\f1fd\";\n}\n.fa-area-chart:before {\n  content: \"\\f1fe\";\n}\n.fa-pie-chart:before {\n  content: \"\\f200\";\n}\n.fa-line-chart:before {\n  content: \"\\f201\";\n}\n.fa-lastfm:before {\n  content: \"\\f202\";\n}\n.fa-lastfm-square:before {\n  content: \"\\f203\";\n}\n.fa-toggle-off:before {\n  content: \"\\f204\";\n}\n.fa-toggle-on:before {\n  content: \"\\f205\";\n}\n.fa-bicycle:before {\n  content: \"\\f206\";\n}\n.fa-bus:before {\n  content: \"\\f207\";\n}\n.fa-ioxhost:before {\n  content: \"\\f208\";\n}\n.fa-angellist:before {\n  content: \"\\f209\";\n}\n.fa-cc:before {\n  content: \"\\f20a\";\n}\n.fa-shekel:before,\n.fa-sheqel:before,\n.fa-ils:before {\n  content: \"\\f20b\";\n}\n.fa-meanpath:before {\n  content: \"\\f20c\";\n}\n.fa-buysellads:before {\n  content: \"\\f20d\";\n}\n.fa-connectdevelop:before {\n  content: \"\\f20e\";\n}\n.fa-dashcube:before {\n  content: \"\\f210\";\n}\n.fa-forumbee:before {\n  content: \"\\f211\";\n}\n.fa-leanpub:before {\n  content: \"\\f212\";\n}\n.fa-sellsy:before {\n  content: \"\\f213\";\n}\n.fa-shirtsinbulk:before {\n  content: \"\\f214\";\n}\n.fa-simplybuilt:before {\n  content: \"\\f215\";\n}\n.fa-skyatlas:before {\n  content: \"\\f216\";\n}\n.fa-cart-plus:before {\n  content: \"\\f217\";\n}\n.fa-cart-arrow-down:before {\n  content: \"\\f218\";\n}\n.fa-diamond:before {\n  content: \"\\f219\";\n}\n.fa-ship:before {\n  content: \"\\f21a\";\n}\n.fa-user-secret:before {\n  content: \"\\f21b\";\n}\n.fa-motorcycle:before {\n  content: \"\\f21c\";\n}\n.fa-street-view:before {\n  content: \"\\f21d\";\n}\n.fa-heartbeat:before {\n  content: \"\\f21e\";\n}\n.fa-venus:before {\n  content: \"\\f221\";\n}\n.fa-mars:before {\n  content: \"\\f222\";\n}\n.fa-mercury:before {\n  content: \"\\f223\";\n}\n.fa-intersex:before,\n.fa-transgender:before {\n  content: \"\\f224\";\n}\n.fa-transgender-alt:before {\n  content: \"\\f225\";\n}\n.fa-venus-double:before {\n  content: \"\\f226\";\n}\n.fa-mars-double:before {\n  content: \"\\f227\";\n}\n.fa-venus-mars:before {\n  content: \"\\f228\";\n}\n.fa-mars-stroke:before {\n  content: \"\\f229\";\n}\n.fa-mars-stroke-v:before {\n  content: \"\\f22a\";\n}\n.fa-mars-stroke-h:before {\n  content: \"\\f22b\";\n}\n.fa-neuter:before {\n  content: \"\\f22c\";\n}\n.fa-genderless:before {\n  content: \"\\f22d\";\n}\n.fa-facebook-official:before {\n  content: \"\\f230\";\n}\n.fa-pinterest-p:before {\n  content: \"\\f231\";\n}\n.fa-whatsapp:before {\n  content: \"\\f232\";\n}\n.fa-server:before {\n  content: \"\\f233\";\n}\n.fa-user-plus:before {\n  content: \"\\f234\";\n}\n.fa-user-times:before {\n  content: \"\\f235\";\n}\n.fa-hotel:before,\n.fa-bed:before {\n  content: \"\\f236\";\n}\n.fa-viacoin:before {\n  content: \"\\f237\";\n}\n.fa-train:before {\n  content: \"\\f238\";\n}\n.fa-subway:before {\n  content: \"\\f239\";\n}\n.fa-medium:before {\n  content: \"\\f23a\";\n}\n.fa-yc:before,\n.fa-y-combinator:before {\n  content: \"\\f23b\";\n}\n.fa-optin-monster:before {\n  content: \"\\f23c\";\n}\n.fa-opencart:before {\n  content: \"\\f23d\";\n}\n.fa-expeditedssl:before {\n  content: \"\\f23e\";\n}\n.fa-battery-4:before,\n.fa-battery:before,\n.fa-battery-full:before {\n  content: \"\\f240\";\n}\n.fa-battery-3:before,\n.fa-battery-three-quarters:before {\n  content: \"\\f241\";\n}\n.fa-battery-2:before,\n.fa-battery-half:before {\n  content: \"\\f242\";\n}\n.fa-battery-1:before,\n.fa-battery-quarter:before {\n  content: \"\\f243\";\n}\n.fa-battery-0:before,\n.fa-battery-empty:before {\n  content: \"\\f244\";\n}\n.fa-mouse-pointer:before {\n  content: \"\\f245\";\n}\n.fa-i-cursor:before {\n  content: \"\\f246\";\n}\n.fa-object-group:before {\n  content: \"\\f247\";\n}\n.fa-object-ungroup:before {\n  content: \"\\f248\";\n}\n.fa-sticky-note:before {\n  content: \"\\f249\";\n}\n.fa-sticky-note-o:before {\n  content: \"\\f24a\";\n}\n.fa-cc-jcb:before {\n  content: \"\\f24b\";\n}\n.fa-cc-diners-club:before {\n  content: \"\\f24c\";\n}\n.fa-clone:before {\n  content: \"\\f24d\";\n}\n.fa-balance-scale:before {\n  content: \"\\f24e\";\n}\n.fa-hourglass-o:before {\n  content: \"\\f250\";\n}\n.fa-hourglass-1:before,\n.fa-hourglass-start:before {\n  content: \"\\f251\";\n}\n.fa-hourglass-2:before,\n.fa-hourglass-half:before {\n  content: \"\\f252\";\n}\n.fa-hourglass-3:before,\n.fa-hourglass-end:before {\n  content: \"\\f253\";\n}\n.fa-hourglass:before {\n  content: \"\\f254\";\n}\n.fa-hand-grab-o:before,\n.fa-hand-rock-o:before {\n  content: \"\\f255\";\n}\n.fa-hand-stop-o:before,\n.fa-hand-paper-o:before {\n  content: \"\\f256\";\n}\n.fa-hand-scissors-o:before {\n  content: \"\\f257\";\n}\n.fa-hand-lizard-o:before {\n  content: \"\\f258\";\n}\n.fa-hand-spock-o:before {\n  content: \"\\f259\";\n}\n.fa-hand-pointer-o:before {\n  content: \"\\f25a\";\n}\n.fa-hand-peace-o:before {\n  content: \"\\f25b\";\n}\n.fa-trademark:before {\n  content: \"\\f25c\";\n}\n.fa-registered:before {\n  content: \"\\f25d\";\n}\n.fa-creative-commons:before {\n  content: \"\\f25e\";\n}\n.fa-gg:before {\n  content: \"\\f260\";\n}\n.fa-gg-circle:before {\n  content: \"\\f261\";\n}\n.fa-tripadvisor:before {\n  content: \"\\f262\";\n}\n.fa-odnoklassniki:before {\n  content: \"\\f263\";\n}\n.fa-odnoklassniki-square:before {\n  content: \"\\f264\";\n}\n.fa-get-pocket:before {\n  content: \"\\f265\";\n}\n.fa-wikipedia-w:before {\n  content: \"\\f266\";\n}\n.fa-safari:before {\n  content: \"\\f267\";\n}\n.fa-chrome:before {\n  content: \"\\f268\";\n}\n.fa-firefox:before {\n  content: \"\\f269\";\n}\n.fa-opera:before {\n  content: \"\\f26a\";\n}\n.fa-internet-explorer:before {\n  content: \"\\f26b\";\n}\n.fa-tv:before,\n.fa-television:before {\n  content: \"\\f26c\";\n}\n.fa-contao:before {\n  content: \"\\f26d\";\n}\n.fa-500px:before {\n  content: \"\\f26e\";\n}\n.fa-amazon:before {\n  content: \"\\f270\";\n}\n.fa-calendar-plus-o:before {\n  content: \"\\f271\";\n}\n.fa-calendar-minus-o:before {\n  content: \"\\f272\";\n}\n.fa-calendar-times-o:before {\n  content: \"\\f273\";\n}\n.fa-calendar-check-o:before {\n  content: \"\\f274\";\n}\n.fa-industry:before {\n  content: \"\\f275\";\n}\n.fa-map-pin:before {\n  content: \"\\f276\";\n}\n.fa-map-signs:before {\n  content: \"\\f277\";\n}\n.fa-map-o:before {\n  content: \"\\f278\";\n}\n.fa-map:before {\n  content: \"\\f279\";\n}\n.fa-commenting:before {\n  content: \"\\f27a\";\n}\n.fa-commenting-o:before {\n  content: \"\\f27b\";\n}\n.fa-houzz:before {\n  content: \"\\f27c\";\n}\n.fa-vimeo:before {\n  content: \"\\f27d\";\n}\n.fa-black-tie:before {\n  content: \"\\f27e\";\n}\n.fa-fonticons:before {\n  content: \"\\f280\";\n}\n.fa-reddit-alien:before {\n  content: \"\\f281\";\n}\n.fa-edge:before {\n  content: \"\\f282\";\n}\n.fa-credit-card-alt:before {\n  content: \"\\f283\";\n}\n.fa-codiepie:before {\n  content: \"\\f284\";\n}\n.fa-modx:before {\n  content: \"\\f285\";\n}\n.fa-fort-awesome:before {\n  content: \"\\f286\";\n}\n.fa-usb:before {\n  content: \"\\f287\";\n}\n.fa-product-hunt:before {\n  content: \"\\f288\";\n}\n.fa-mixcloud:before {\n  content: \"\\f289\";\n}\n.fa-scribd:before {\n  content: \"\\f28a\";\n}\n.fa-pause-circle:before {\n  content: \"\\f28b\";\n}\n.fa-pause-circle-o:before {\n  content: \"\\f28c\";\n}\n.fa-stop-circle:before {\n  content: \"\\f28d\";\n}\n.fa-stop-circle-o:before {\n  content: \"\\f28e\";\n}\n.fa-shopping-bag:before {\n  content: \"\\f290\";\n}\n.fa-shopping-basket:before {\n  content: \"\\f291\";\n}\n.fa-hashtag:before {\n  content: \"\\f292\";\n}\n.fa-bluetooth:before {\n  content: \"\\f293\";\n}\n.fa-bluetooth-b:before {\n  content: \"\\f294\";\n}\n.fa-percent:before {\n  content: \"\\f295\";\n}\n.fa-gitlab:before {\n  content: \"\\f296\";\n}\n.fa-wpbeginner:before {\n  content: \"\\f297\";\n}\n.fa-wpforms:before {\n  content: \"\\f298\";\n}\n.fa-envira:before {\n  content: \"\\f299\";\n}\n.fa-universal-access:before {\n  content: \"\\f29a\";\n}\n.fa-wheelchair-alt:before {\n  content: \"\\f29b\";\n}\n.fa-question-circle-o:before {\n  content: \"\\f29c\";\n}\n.fa-blind:before {\n  content: \"\\f29d\";\n}\n.fa-audio-description:before {\n  content: \"\\f29e\";\n}\n.fa-volume-control-phone:before {\n  content: \"\\f2a0\";\n}\n.fa-braille:before {\n  content: \"\\f2a1\";\n}\n.fa-assistive-listening-systems:before {\n  content: \"\\f2a2\";\n}\n.fa-asl-interpreting:before,\n.fa-american-sign-language-interpreting:before {\n  content: \"\\f2a3\";\n}\n.fa-deafness:before,\n.fa-hard-of-hearing:before,\n.fa-deaf:before {\n  content: \"\\f2a4\";\n}\n.fa-glide:before {\n  content: \"\\f2a5\";\n}\n.fa-glide-g:before {\n  content: \"\\f2a6\";\n}\n.fa-signing:before,\n.fa-sign-language:before {\n  content: \"\\f2a7\";\n}\n.fa-low-vision:before {\n  content: \"\\f2a8\";\n}\n.fa-viadeo:before {\n  content: \"\\f2a9\";\n}\n.fa-viadeo-square:before {\n  content: \"\\f2aa\";\n}\n.fa-snapchat:before {\n  content: \"\\f2ab\";\n}\n.fa-snapchat-ghost:before {\n  content: \"\\f2ac\";\n}\n.fa-snapchat-square:before {\n  content: \"\\f2ad\";\n}\n.fa-pied-piper:before {\n  content: \"\\f2ae\";\n}\n.fa-first-order:before {\n  content: \"\\f2b0\";\n}\n.fa-yoast:before {\n  content: \"\\f2b1\";\n}\n.fa-themeisle:before {\n  content: \"\\f2b2\";\n}\n.fa-google-plus-circle:before,\n.fa-google-plus-official:before {\n  content: \"\\f2b3\";\n}\n.fa-fa:before,\n.fa-font-awesome:before {\n  content: \"\\f2b4\";\n}\n.fa-handshake-o:before {\n  content: \"\\f2b5\";\n}\n.fa-envelope-open:before {\n  content: \"\\f2b6\";\n}\n.fa-envelope-open-o:before {\n  content: \"\\f2b7\";\n}\n.fa-linode:before {\n  content: \"\\f2b8\";\n}\n.fa-address-book:before {\n  content: \"\\f2b9\";\n}\n.fa-address-book-o:before {\n  content: \"\\f2ba\";\n}\n.fa-vcard:before,\n.fa-address-card:before {\n  content: \"\\f2bb\";\n}\n.fa-vcard-o:before,\n.fa-address-card-o:before {\n  content: \"\\f2bc\";\n}\n.fa-user-circle:before {\n  content: \"\\f2bd\";\n}\n.fa-user-circle-o:before {\n  content: \"\\f2be\";\n}\n.fa-user-o:before {\n  content: \"\\f2c0\";\n}\n.fa-id-badge:before {\n  content: \"\\f2c1\";\n}\n.fa-drivers-license:before,\n.fa-id-card:before {\n  content: \"\\f2c2\";\n}\n.fa-drivers-license-o:before,\n.fa-id-card-o:before {\n  content: \"\\f2c3\";\n}\n.fa-quora:before {\n  content: \"\\f2c4\";\n}\n.fa-free-code-camp:before {\n  content: \"\\f2c5\";\n}\n.fa-telegram:before {\n  content: \"\\f2c6\";\n}\n.fa-thermometer-4:before,\n.fa-thermometer:before,\n.fa-thermometer-full:before {\n  content: \"\\f2c7\";\n}\n.fa-thermometer-3:before,\n.fa-thermometer-three-quarters:before {\n  content: \"\\f2c8\";\n}\n.fa-thermometer-2:before,\n.fa-thermometer-half:before {\n  content: \"\\f2c9\";\n}\n.fa-thermometer-1:before,\n.fa-thermometer-quarter:before {\n  content: \"\\f2ca\";\n}\n.fa-thermometer-0:before,\n.fa-thermometer-empty:before {\n  content: \"\\f2cb\";\n}\n.fa-shower:before {\n  content: \"\\f2cc\";\n}\n.fa-bathtub:before,\n.fa-s15:before,\n.fa-bath:before {\n  content: \"\\f2cd\";\n}\n.fa-podcast:before {\n  content: \"\\f2ce\";\n}\n.fa-window-maximize:before {\n  content: \"\\f2d0\";\n}\n.fa-window-minimize:before {\n  content: \"\\f2d1\";\n}\n.fa-window-restore:before {\n  content: \"\\f2d2\";\n}\n.fa-times-rectangle:before,\n.fa-window-close:before {\n  content: \"\\f2d3\";\n}\n.fa-times-rectangle-o:before,\n.fa-window-close-o:before {\n  content: \"\\f2d4\";\n}\n.fa-bandcamp:before {\n  content: \"\\f2d5\";\n}\n.fa-grav:before {\n  content: \"\\f2d6\";\n}\n.fa-etsy:before {\n  content: \"\\f2d7\";\n}\n.fa-imdb:before {\n  content: \"\\f2d8\";\n}\n.fa-ravelry:before {\n  content: \"\\f2d9\";\n}\n.fa-eercast:before {\n  content: \"\\f2da\";\n}\n.fa-microchip:before {\n  content: \"\\f2db\";\n}\n.fa-snowflake-o:before {\n  content: \"\\f2dc\";\n}\n.fa-superpowers:before {\n  content: \"\\f2dd\";\n}\n.fa-wpexplorer:before {\n  content: \"\\f2de\";\n}\n.fa-meetup:before {\n  content: \"\\f2e0\";\n}\n.sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  border: 0;\n}\n.sr-only-focusable:active,\n.sr-only-focusable:focus {\n  position: static;\n  width: auto;\n  height: auto;\n  margin: 0;\n  overflow: visible;\n  clip: auto;\n}\n.sr-only-focusable:active,\n.sr-only-focusable:focus {\n  position: static;\n  width: auto;\n  height: auto;\n  margin: 0;\n  overflow: visible;\n  clip: auto;\n}\n/*!\n*\n* IPython base\n*\n*/\n:root {\n  --page-backdrop-color: #eee;\n  --body-bg-hue: 0;\n  --body-bg-saturation: 0%;\n  --body-bg-light: 100%;\n  --body-bg: hsl(var(--body-bg-hue), var(--body-bg-saturation), var(--body-bg-light));\n  --body-bg-darken2pc: hsl(var(--body-bg-hue), var(--body-bg-saturation), calc(var(--body-bg-light) - 2%));\n  --body-bg-darken3pc: hsl(var(--body-bg-hue), var(--body-bg-saturation), calc(var(--body-bg-light) - 3.2%));\n  --body-bg-darken5pc: hsl(var(--body-bg-hue), var(--body-bg-saturation), calc(var(--body-bg-light) - 5%));\n  --body-bg-darken10pc: hsl(var(--body-bg-hue), var(--body-bg-saturation), calc(var(--body-bg-light) - 10%));\n  --body-bg-darken20pc: hsl(var(--body-bg-hue), var(--body-bg-saturation), calc(var(--body-bg-light) - 20%));\n  --body-bg-darken30pc: hsl(var(--body-bg-hue), var(--body-bg-saturation), calc(var(--body-bg-light) - 30%));\n  --header-bg: var(--body-bg);\n  --rendered-html-border-color: black;\n  --input-prompt-color: #303f9f;\n  --output-prompt-color: #d84315;\n  --output-stderr-bg-color: #fdd;\n  --output-pre-color: black;\n  --black: #000;\n  --text-color: var(--black);\n  --border-color: var(--body-bg-darken30pc);\n  --light-border-color: var(--body-bg-darken20pc);\n  --navbar-default-border: #e7e7e7;\n  --navbar-default-bg: #f5f5f5;\n  --navbar-default-link-color: #565656;\n  --navbar-default-link-hover-color: #333;\n  --btn-default-color: var(--navbar-default-link-hover-color);\n  --btn-default-hover-color: var(--btn-default-color);\n  --btn-default-bg-color: var(--header-bg);\n  --btn-default-bg-hover-color: #e6e6e6;\n  --btn-default-border-color: #ccc;\n  --btn-default-border-hover-color: #adadad;\n  --btn-default-active-hover-bg-color: #d4d4d4;\n  --btn-default-active-hover-border-color: #8c8c8c;\n  --menu-bg: var(--body-bg);\n  --menu-bg-hover: #e7e7e7;\n  --menu-fg: var(--btn-default-color);\n  --menu-fg-hover: var(--navbar-default-link-hover-color);\n  --code-bg-color: var(--menu-bg-hover);\n  --edit-hover-color: var(--body-bg-darken10pc);\n  --self-color: #05a;\n  --table-bg-good: rgba(0, 255, 0, 0.23);\n  --table-bg-bad: rgba(255, 0, 0, 0.23);\n}\n[data-theme=\"darcula\"] {\n  --page-backdrop-color: #3c3f41;\n  --body-bg-light: 17%;\n  --header-bg: #313335;\n  --input-prompt-color: #307fc1;\n  --output-prompt-color: #bf5b3d;\n  --output-stderr-bg-color: rgba(244, 67, 54, 0.28);\n  --output-pre-color: #bbbbbb;\n  --black: #bbbbbb;\n  --border-color: #616161;\n  --light-border-color: #505050;\n  --navbar-default-border: var(--border-color);\n  --navbar-default-bg: var(--header-bg);\n  --navbar-default-link-color: #a5a5a5;\n  --navbar-default-link-hover-color: #cbcbcb;\n  --btn-default-color: var(--navbar-default-link-color);\n  --btn-default-border-color: var(--navbar-default-border);\n  --menu-bg-hover: var(--page-backdrop-color);\n  --btn-default-bg-hover-color: var(--page-backdrop-color);\n  --btn-default-border-hover-color: var(--btn-default-border-color);\n  --btn-default-active-hover-bg-color: var(--btn-default-bg-hover-color);\n  --btn-default-active-hover-border-color: var(--btn-default-border-hover-color);\n  --edit-hover-color: #555758;\n  --rendered-html-border-color: var(--text-color);\n  --self-color: #307fc1;\n}\n.modal.fade .modal-dialog {\n  -webkit-transform: translate(0, 0);\n  -ms-transform: translate(0, 0);\n  -o-transform: translate(0, 0);\n  transform: translate(0, 0);\n}\ncode {\n  color: var(--black);\n}\npre {\n  font-size: inherit;\n  line-height: inherit;\n}\nlabel {\n  font-weight: normal;\n}\n/* Make the page background atleast 100% the height of the view port */\n/* Make the page itself atleast 70% the height of the view port */\n.border-box-sizing {\n  box-sizing: border-box;\n  -moz-box-sizing: border-box;\n  -webkit-box-sizing: border-box;\n}\n.corner-all {\n  border-radius: 2px;\n}\n.no-padding {\n  padding: 0px;\n}\n/* Flexible box model classes */\n/* Taken from Alex Russell http://infrequently.org/2009/08/css-3-progress/ */\n/* This file is a compatibility layer.  It allows the usage of flexible box \nmodel layouts accross multiple browsers, including older browsers.  The newest,\nuniversal implementation of the flexible box model is used when available (see\n`Modern browsers` comments below).  Browsers that are known to implement this \nnew spec completely include:\n\n    Firefox 28.0+\n    Chrome 29.0+\n    Internet Explorer 11+ \n    Opera 17.0+\n\nBrowsers not listed, including Safari, are supported via the styling under the\n`Old browsers` comments below.\n*/\n.hbox {\n  /* Old browsers */\n  display: -webkit-box;\n  -webkit-box-orient: horizontal;\n  -webkit-box-align: stretch;\n  display: -moz-box;\n  -moz-box-orient: horizontal;\n  -moz-box-align: stretch;\n  display: box;\n  box-orient: horizontal;\n  box-align: stretch;\n  /* Modern browsers */\n  display: flex;\n  flex-direction: row;\n  align-items: stretch;\n}\n.hbox > * {\n  /* Old browsers */\n  -webkit-box-flex: 0;\n  -moz-box-flex: 0;\n  box-flex: 0;\n  /* Modern browsers */\n  flex: none;\n}\n.vbox {\n  /* Old browsers */\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-box-align: stretch;\n  display: -moz-box;\n  -moz-box-orient: vertical;\n  -moz-box-align: stretch;\n  display: box;\n  box-orient: vertical;\n  box-align: stretch;\n  /* Modern browsers */\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n}\n.vbox > * {\n  /* Old browsers */\n  -webkit-box-flex: 0;\n  -moz-box-flex: 0;\n  box-flex: 0;\n  /* Modern browsers */\n  flex: none;\n}\n.hbox.reverse,\n.vbox.reverse,\n.reverse {\n  /* Old browsers */\n  -webkit-box-direction: reverse;\n  -moz-box-direction: reverse;\n  box-direction: reverse;\n  /* Modern browsers */\n  flex-direction: row-reverse;\n}\n.hbox.box-flex0,\n.vbox.box-flex0,\n.box-flex0 {\n  /* Old browsers */\n  -webkit-box-flex: 0;\n  -moz-box-flex: 0;\n  box-flex: 0;\n  /* Modern browsers */\n  flex: none;\n  width: auto;\n}\n.hbox.box-flex1,\n.vbox.box-flex1,\n.box-flex1 {\n  /* Old browsers */\n  -webkit-box-flex: 1;\n  -moz-box-flex: 1;\n  box-flex: 1;\n  /* Modern browsers */\n  flex: 1;\n}\n.hbox.box-flex,\n.vbox.box-flex,\n.box-flex {\n  /* Old browsers */\n  /* Old browsers */\n  -webkit-box-flex: 1;\n  -moz-box-flex: 1;\n  box-flex: 1;\n  /* Modern browsers */\n  flex: 1;\n}\n.hbox.box-flex2,\n.vbox.box-flex2,\n.box-flex2 {\n  /* Old browsers */\n  -webkit-box-flex: 2;\n  -moz-box-flex: 2;\n  box-flex: 2;\n  /* Modern browsers */\n  flex: 2;\n}\n.box-group1 {\n  /*  Deprecated */\n  -webkit-box-flex-group: 1;\n  -moz-box-flex-group: 1;\n  box-flex-group: 1;\n}\n.box-group2 {\n  /* Deprecated */\n  -webkit-box-flex-group: 2;\n  -moz-box-flex-group: 2;\n  box-flex-group: 2;\n}\n.hbox.start,\n.vbox.start,\n.start {\n  /* Old browsers */\n  -webkit-box-pack: start;\n  -moz-box-pack: start;\n  box-pack: start;\n  /* Modern browsers */\n  justify-content: flex-start;\n}\n.hbox.end,\n.vbox.end,\n.end {\n  /* Old browsers */\n  -webkit-box-pack: end;\n  -moz-box-pack: end;\n  box-pack: end;\n  /* Modern browsers */\n  justify-content: flex-end;\n}\n.hbox.center,\n.vbox.center,\n.center {\n  /* Old browsers */\n  -webkit-box-pack: center;\n  -moz-box-pack: center;\n  box-pack: center;\n  /* Modern browsers */\n  justify-content: center;\n}\n.hbox.baseline,\n.vbox.baseline,\n.baseline {\n  /* Old browsers */\n  -webkit-box-pack: baseline;\n  -moz-box-pack: baseline;\n  box-pack: baseline;\n  /* Modern browsers */\n  justify-content: baseline;\n}\n.hbox.stretch,\n.vbox.stretch,\n.stretch {\n  /* Old browsers */\n  -webkit-box-pack: stretch;\n  -moz-box-pack: stretch;\n  box-pack: stretch;\n  /* Modern browsers */\n  justify-content: stretch;\n}\n.hbox.align-start,\n.vbox.align-start,\n.align-start {\n  /* Old browsers */\n  -webkit-box-align: start;\n  -moz-box-align: start;\n  box-align: start;\n  /* Modern browsers */\n  align-items: flex-start;\n}\n.hbox.align-end,\n.vbox.align-end,\n.align-end {\n  /* Old browsers */\n  -webkit-box-align: end;\n  -moz-box-align: end;\n  box-align: end;\n  /* Modern browsers */\n  align-items: flex-end;\n}\n.hbox.align-center,\n.vbox.align-center,\n.align-center {\n  /* Old browsers */\n  -webkit-box-align: center;\n  -moz-box-align: center;\n  box-align: center;\n  /* Modern browsers */\n  align-items: center;\n}\n.hbox.align-baseline,\n.vbox.align-baseline,\n.align-baseline {\n  /* Old browsers */\n  -webkit-box-align: baseline;\n  -moz-box-align: baseline;\n  box-align: baseline;\n  /* Modern browsers */\n  align-items: baseline;\n}\n.hbox.align-stretch,\n.vbox.align-stretch,\n.align-stretch {\n  /* Old browsers */\n  -webkit-box-align: stretch;\n  -moz-box-align: stretch;\n  box-align: stretch;\n  /* Modern browsers */\n  align-items: stretch;\n}\ndiv.error {\n  margin: 2em;\n  text-align: center;\n}\ndiv.error > h1 {\n  font-size: 500%;\n  line-height: normal;\n}\ndiv.error > p {\n  font-size: 200%;\n  line-height: normal;\n}\ndiv.traceback-wrapper {\n  text-align: left;\n  max-width: 800px;\n  margin: auto;\n}\ndiv.traceback-wrapper pre.traceback {\n  max-height: 600px;\n  overflow: auto;\n}\n/**\n * Primary styles\n *\n * Author: Jupyter Development Team\n */\n.body {\n  background-color: var(--body-bg);\n  /* This makes sure that the body covers the entire window and needs to\n       be in a different element than the display: box in wrapper below */\n  position: absolute;\n  left: 0px;\n  right: 0px;\n  top: 0px;\n  bottom: 0px;\n  overflow: visible;\n  color: var(--text-color);\n}\n.body > #header {\n  /* Initially hidden to prevent FLOUC */\n  display: none;\n  background-color: var(--header-bg);\n  /* Display over codemirror */\n  position: relative;\n  z-index: 100;\n}\n.body > #header #header-container {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  padding: 5px;\n  padding-bottom: 5px;\n  padding-top: 5px;\n  box-sizing: border-box;\n  -moz-box-sizing: border-box;\n  -webkit-box-sizing: border-box;\n}\n.body > #header .header-bar {\n  width: 100%;\n  height: 1px;\n  background: var(--navbar-default-border);\n  margin-bottom: -1px;\n}\n@media print {\n  .body > #header {\n    display: none !important;\n  }\n}\n#header-spacer {\n  width: 100%;\n  visibility: hidden;\n}\n@media print {\n  #header-spacer {\n    display: none;\n  }\n}\n#ipython_notebook {\n  padding-left: 0px;\n  padding-top: 2px / 2;\n  padding-bottom: 2px / 2;\n  margin-right: auto;\n}\n[dir=\"rtl\"] #ipython_notebook {\n  margin-right: 10px;\n  margin-left: 0;\n}\n[dir=\"rtl\"] #ipython_notebook.pull-left {\n  float: right !important;\n  float: right;\n}\n.flex-spacer {\n  flex: 1;\n}\n#ipython_notebook img {\n  height: 28px;\n}\n#site {\n  width: 100%;\n  display: none;\n  box-sizing: border-box;\n  -moz-box-sizing: border-box;\n  -webkit-box-sizing: border-box;\n  overflow: auto;\n}\n@media print {\n  #site {\n    height: auto !important;\n  }\n}\n/* Smaller buttons */\n.ui-button .ui-button-text {\n  padding: 0.2em 0.8em;\n  font-size: 77%;\n}\ninput.ui-button {\n  padding: 0.3em 0.9em;\n}\nspan#kernel_logo_widget {\n  margin: 0 10px;\n  margin-left: auto;\n}\nspan#login_widget {\n  float: right;\n}\n[dir=\"rtl\"] span#login_widget {\n  float: left;\n}\nspan#login_widget > .button,\n#logout,\n#shutdown {\n  color: #333;\n  background-color: #fff;\n  border-color: #ccc;\n  margin-left: 10px;\n}\nspan#login_widget > .button:focus,\n#logout:focus,\n#shutdown:focus,\nspan#login_widget > .button.focus,\n#logout.focus,\n#shutdown.focus {\n  color: #333;\n  background-color: #e6e6e6;\n  border-color: #8c8c8c;\n}\nspan#login_widget > .button:hover,\n#logout:hover,\n#shutdown:hover {\n  color: #333;\n  background-color: #e6e6e6;\n  border-color: #adadad;\n}\nspan#login_widget > .button:active,\n#logout:active,\n#shutdown:active,\nspan#login_widget > .button.active,\n#logout.active,\n#shutdown.active,\n.open > .dropdown-togglespan#login_widget > .button,\n.open > .dropdown-toggle#logout,\n.open > .dropdown-toggle#shutdown {\n  color: #333;\n  background-color: #e6e6e6;\n  background-image: none;\n  border-color: #adadad;\n}\nspan#login_widget > .button:active:hover,\n#logout:active:hover,\n#shutdown:active:hover,\nspan#login_widget > .button.active:hover,\n#logout.active:hover,\n#shutdown.active:hover,\n.open > .dropdown-togglespan#login_widget > .button:hover,\n.open > .dropdown-toggle#logout:hover,\n.open > .dropdown-toggle#shutdown:hover,\nspan#login_widget > .button:active:focus,\n#logout:active:focus,\n#shutdown:active:focus,\nspan#login_widget > .button.active:focus,\n#logout.active:focus,\n#shutdown.active:focus,\n.open > .dropdown-togglespan#login_widget > .button:focus,\n.open > .dropdown-toggle#logout:focus,\n.open > .dropdown-toggle#shutdown:focus,\nspan#login_widget > .button:active.focus,\n#logout:active.focus,\n#shutdown:active.focus,\nspan#login_widget > .button.active.focus,\n#logout.active.focus,\n#shutdown.active.focus,\n.open > .dropdown-togglespan#login_widget > .button.focus,\n.open > .dropdown-toggle#logout.focus,\n.open > .dropdown-toggle#shutdown.focus {\n  color: #333;\n  background-color: #d4d4d4;\n  border-color: #8c8c8c;\n}\nspan#login_widget > .button.disabled:hover,\n#logout.disabled:hover,\n#shutdown.disabled:hover,\nspan#login_widget > .button[disabled]:hover,\n#logout[disabled]:hover,\n#shutdown[disabled]:hover,\nfieldset[disabled] span#login_widget > .button:hover,\nfieldset[disabled] #logout:hover,\nfieldset[disabled] #shutdown:hover,\nspan#login_widget > .button.disabled:focus,\n#logout.disabled:focus,\n#shutdown.disabled:focus,\nspan#login_widget > .button[disabled]:focus,\n#logout[disabled]:focus,\n#shutdown[disabled]:focus,\nfieldset[disabled] span#login_widget > .button:focus,\nfieldset[disabled] #logout:focus,\nfieldset[disabled] #shutdown:focus,\nspan#login_widget > .button.disabled.focus,\n#logout.disabled.focus,\n#shutdown.disabled.focus,\nspan#login_widget > .button[disabled].focus,\n#logout[disabled].focus,\n#shutdown[disabled].focus,\nfieldset[disabled] span#login_widget > .button.focus,\nfieldset[disabled] #logout.focus,\nfieldset[disabled] #shutdown.focus {\n  background-color: #fff;\n  border-color: #ccc;\n}\nspan#login_widget > .button .badge,\n#logout .badge,\n#shutdown .badge {\n  color: #fff;\n  background-color: #333;\n}\n.nav-header {\n  text-transform: none;\n}\n#header > span {\n  margin-top: 10px;\n}\n.modal_stretch .modal-dialog {\n  /* Old browsers */\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-box-align: stretch;\n  display: -moz-box;\n  -moz-box-orient: vertical;\n  -moz-box-align: stretch;\n  display: box;\n  box-orient: vertical;\n  box-align: stretch;\n  /* Modern browsers */\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  min-height: 80vh;\n}\n.modal_stretch .modal-dialog .modal-body {\n  max-height: calc(100vh - 200px);\n  overflow: auto;\n  flex: 1;\n}\n.modal-header {\n  cursor: move;\n}\n@media (min-width: 768px) {\n  .modal .modal-dialog {\n    width: 700px;\n  }\n}\n@media (min-width: 768px) {\n  select.form-control {\n    margin-left: 12px;\n    margin-right: 12px;\n  }\n}\n/* rtl fixes for the error, connecting, and renaming window */\n[dir=\"rtl\"] .modal-footer {\n  text-align: left !important;\n}\n[dir=\"rtl\"] .close {\n  float: left;\n}\n[dir=\"rtl\"] .fa-step-forward::before {\n  content: \"\\f048\";\n}\n/*!\n*\n* IPython notebook\n*\n*/\n/* CSS font colors for translated ANSI escape sequences */\n/* The color values are a mix of\n   http://www.xcolors.net/dl/baskerville-ivorylight and\n   http://www.xcolors.net/dl/euphrasia */\n.ansi-black-fg {\n  color: #3E424D;\n}\n.ansi-black-bg {\n  background-color: #3E424D;\n}\n.ansi-black-intense-fg {\n  color: #282C36;\n}\n.ansi-black-intense-bg {\n  background-color: #282C36;\n}\n.ansi-red-fg {\n  color: #E75C58;\n}\n.ansi-red-bg {\n  background-color: #E75C58;\n}\n.ansi-red-intense-fg {\n  color: #B22B31;\n}\n.ansi-red-intense-bg {\n  background-color: #B22B31;\n}\n.ansi-green-fg {\n  color: #00A250;\n}\n.ansi-green-bg {\n  background-color: #00A250;\n}\n.ansi-green-intense-fg {\n  color: #007427;\n}\n.ansi-green-intense-bg {\n  background-color: #007427;\n}\n.ansi-yellow-fg {\n  color: #DDB62B;\n}\n.ansi-yellow-bg {\n  background-color: #DDB62B;\n}\n.ansi-yellow-intense-fg {\n  color: #B27D12;\n}\n.ansi-yellow-intense-bg {\n  background-color: #B27D12;\n}\n.ansi-blue-fg {\n  color: #208FFB;\n}\n.ansi-blue-bg {\n  background-color: #208FFB;\n}\n.ansi-blue-intense-fg {\n  color: #0065CA;\n}\n.ansi-blue-intense-bg {\n  background-color: #0065CA;\n}\n.ansi-magenta-fg {\n  color: #D160C4;\n}\n.ansi-magenta-bg {\n  background-color: #D160C4;\n}\n.ansi-magenta-intense-fg {\n  color: #A03196;\n}\n.ansi-magenta-intense-bg {\n  background-color: #A03196;\n}\n.ansi-cyan-fg {\n  color: #60C6C8;\n}\n.ansi-cyan-bg {\n  background-color: #60C6C8;\n}\n.ansi-cyan-intense-fg {\n  color: #258F8F;\n}\n.ansi-cyan-intense-bg {\n  background-color: #258F8F;\n}\n.ansi-white-fg {\n  color: #C5C1B4;\n}\n.ansi-white-bg {\n  background-color: #C5C1B4;\n}\n.ansi-white-intense-fg {\n  color: #A1A6B2;\n}\n.ansi-white-intense-bg {\n  background-color: #A1A6B2;\n}\n.ansi-default-inverse-fg {\n  color: #FFFFFF;\n}\n.ansi-default-inverse-bg {\n  background-color: #000000;\n}\n.ansi-bold {\n  font-weight: bold;\n}\n.ansi-underline {\n  text-decoration: underline;\n}\ndiv.cell {\n  /* Old browsers */\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-box-align: stretch;\n  display: -moz-box;\n  -moz-box-orient: vertical;\n  -moz-box-align: stretch;\n  display: box;\n  box-orient: vertical;\n  box-align: stretch;\n  /* Modern browsers */\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  border-radius: 2px;\n  box-sizing: border-box;\n  -moz-box-sizing: border-box;\n  -webkit-box-sizing: border-box;\n  border-width: 1px;\n  border-style: solid;\n  border-color: transparent;\n  width: 100%;\n  padding: 5px;\n  /* This acts as a spacer between cells, that is outside the border */\n  margin: 0px;\n  outline: none;\n  position: relative;\n  overflow: visible;\n}\ndiv.cell:before {\n  position: absolute;\n  display: block;\n  top: -1px;\n  left: -1px;\n  width: 5px;\n  height: calc(100% +  2 * 1px);\n  content: '';\n  background: transparent;\n}\ndiv.cell.jupyter-soft-selected {\n  border-left-color: #E3F2FD;\n  border-left-width: 1px;\n  padding-left: 5px;\n  border-right-color: #E3F2FD;\n  border-right-width: 1px;\n  background: #E3F2FD;\n}\n@media print {\n  div.cell.jupyter-soft-selected {\n    border-color: transparent;\n  }\n}\ndiv.cell.selected,\ndiv.cell.selected.jupyter-soft-selected {\n  border-color: var(--border-color);\n}\ndiv.cell.selected:before,\ndiv.cell.selected.jupyter-soft-selected:before {\n  position: absolute;\n  display: block;\n  top: -1px;\n  left: -1px;\n  width: 5px;\n  height: calc(100% +  2 * 1px);\n  content: '';\n  background: #42A5F5;\n}\n@media print {\n  div.cell.selected,\n  div.cell.selected.jupyter-soft-selected {\n    border-color: transparent;\n  }\n}\n.edit_mode div.cell.selected {\n  border-color: #66BB6A;\n}\n.edit_mode div.cell.selected:before {\n  position: absolute;\n  display: block;\n  top: -1px;\n  left: -1px;\n  width: 5px;\n  height: calc(100% +  2 * 1px);\n  content: '';\n  background: #66BB6A;\n}\n@media print {\n  .edit_mode div.cell.selected {\n    border-color: transparent;\n  }\n}\n.prompt {\n  /* This needs to be wide enough for 3 digit prompt numbers: In[100]: */\n  min-width: 14ex;\n  /* This padding is tuned to match the padding on the CodeMirror editor. */\n  padding: 0.4em;\n  margin: 0px;\n  font-family: monospace;\n  text-align: right;\n  /* This has to match that of the the CodeMirror class line-height below */\n  line-height: 1.21429em;\n  /* Don't highlight prompt number selection */\n  -webkit-touch-callout: none;\n  -webkit-user-select: none;\n  -khtml-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  /* Use default cursor */\n  cursor: default;\n}\n@media (max-width: 540px) {\n  .prompt {\n    text-align: left;\n  }\n}\ndiv.inner_cell {\n  min-width: 0;\n  /* Old browsers */\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-box-align: stretch;\n  display: -moz-box;\n  -moz-box-orient: vertical;\n  -moz-box-align: stretch;\n  display: box;\n  box-orient: vertical;\n  box-align: stretch;\n  /* Modern browsers */\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  /* Old browsers */\n  -webkit-box-flex: 1;\n  -moz-box-flex: 1;\n  box-flex: 1;\n  /* Modern browsers */\n  flex: 1;\n}\n/* input_area and input_prompt must match in top border and margin for alignment */\ndiv.input_area {\n  border: 1px solid var(--light-border-color);\n  border-radius: 2px;\n  background: var(--body-bg-darken3pc);\n  line-height: 1.21429em;\n}\n/* This is needed so that empty prompt areas can collapse to zero height when there\n   is no content in the output_subarea and the prompt. The main purpose of this is\n   to make sure that empty JavaScript output_subareas have no height. */\ndiv.prompt:empty {\n  padding-top: 0;\n  padding-bottom: 0;\n}\ndiv.unrecognized_cell {\n  padding: 5px 5px 5px 0px;\n  /* Old browsers */\n  display: -webkit-box;\n  -webkit-box-orient: horizontal;\n  -webkit-box-align: stretch;\n  display: -moz-box;\n  -moz-box-orient: horizontal;\n  -moz-box-align: stretch;\n  display: box;\n  box-orient: horizontal;\n  box-align: stretch;\n  /* Modern browsers */\n  display: flex;\n  flex-direction: row;\n  align-items: stretch;\n}\ndiv.unrecognized_cell .inner_cell {\n  border-radius: 2px;\n  padding: 5px;\n  font-weight: bold;\n  color: red;\n  border: 1px solid var(--light-border-color);\n  background: hsl(var(--body-bg-hue), var(--body-bg-saturation), calc(var(--body-bg-light) - 8.2%));\n}\ndiv.unrecognized_cell .inner_cell a {\n  color: inherit;\n  text-decoration: none;\n}\ndiv.unrecognized_cell .inner_cell a:hover {\n  color: inherit;\n  text-decoration: none;\n}\n@media (max-width: 540px) {\n  div.unrecognized_cell > div.prompt {\n    display: none;\n  }\n}\ndiv.code_cell {\n  /* avoid page breaking on code cells when printing */\n}\n@media print {\n  div.code_cell {\n    page-break-inside: avoid;\n  }\n}\n/* any special styling for code cells that are currently running goes here */\ndiv.input {\n  page-break-inside: avoid;\n  /* Old browsers */\n  display: -webkit-box;\n  -webkit-box-orient: horizontal;\n  -webkit-box-align: stretch;\n  display: -moz-box;\n  -moz-box-orient: horizontal;\n  -moz-box-align: stretch;\n  display: box;\n  box-orient: horizontal;\n  box-align: stretch;\n  /* Modern browsers */\n  display: flex;\n  flex-direction: row;\n  align-items: stretch;\n}\n@media (max-width: 540px) {\n  div.input {\n    /* Old browsers */\n    display: -webkit-box;\n    -webkit-box-orient: vertical;\n    -webkit-box-align: stretch;\n    display: -moz-box;\n    -moz-box-orient: vertical;\n    -moz-box-align: stretch;\n    display: box;\n    box-orient: vertical;\n    box-align: stretch;\n    /* Modern browsers */\n    display: flex;\n    flex-direction: column;\n    align-items: stretch;\n  }\n}\ndiv.prompt_container {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: flex-start;\n  text-align: right;\n}\n/* input_area and input_prompt must match in top border and margin for alignment */\ndiv.input_prompt {\n  color: var(--input-prompt-color);\n  border-top: 1px solid transparent;\n}\ndiv.run_this_cell {\n  display: none;\n  cursor: pointer;\n  color: #333;\n  padding-top: 5px;\n  padding-bottom: 5px;\n  padding-left: 2ex;\n  padding-right: 2ex;\n  width: 1ex;\n}\ndiv.prompt {\n  min-width: 15ex;\n}\n@media (-moz-touch-enabled: 1), (any-pointer: coarse) {\n  div.run_this_cell {\n    display: block;\n  }\n}\ndiv.input_area > div.highlight {\n  margin: 0.4em;\n  border: none;\n  padding: 0px;\n  background-color: transparent;\n}\ndiv.input_area > div.highlight > pre {\n  margin: 0px;\n  border: none;\n  padding: 0px;\n  background-color: transparent;\n}\n/* The following gets added to the <head> if it is detected that the user has a\n * monospace font with inconsistent normal/bold/italic height.  See\n * notebookmain.js.  Such fonts will have keywords vertically offset with\n * respect to the rest of the text.  The user should select a better font.\n * See: https://github.com/ipython/ipython/issues/1503\n *\n * .CodeMirror span {\n *      vertical-align: bottom;\n * }\n */\n.CodeMirror {\n  line-height: 1.21429em;\n  /* Changed from 1em to our global default */\n  font-size: 14px;\n  height: auto;\n  /* Changed to auto to autogrow */\n  background: none;\n  /* Changed from white to allow our bg to show through */\n}\n.CodeMirror-scroll {\n  /*  The CodeMirror docs are a bit fuzzy on if overflow-y should be hidden or visible.*/\n  /*  We have found that if it is visible, vertical scrollbars appear with font size changes.*/\n  overflow-y: hidden;\n  overflow-x: auto;\n}\n.CodeMirror-lines {\n  /* In CM2, this used to be 0.4em, but in CM3 it went to 4px. We need the em value because */\n  /* we have set a different line-height and want this to scale with that. */\n  /* Note that this should set vertical padding only, since CodeMirror assumes\n       that horizontal padding will be set on CodeMirror pre */\n  padding: 0.4em 0;\n}\n.CodeMirror-linenumber {\n  padding: 0 8px 0 4px;\n}\n.CodeMirror-gutters {\n  border-bottom-left-radius: 2px;\n  border-top-left-radius: 2px;\n}\n.CodeMirror pre {\n  /* In CM3 this went to 4px from 0 in CM2. This sets horizontal padding only,\n    use .CodeMirror-lines for vertical */\n  padding: 0 0.4em;\n  border: 0;\n  border-radius: 0;\n}\n.CodeMirror-cursor {\n  border-left: 1.4px solid black;\n}\n@media screen and (min-width: 2138px) and (max-width: 4319px) {\n  .CodeMirror-cursor {\n    border-left: 2px solid black;\n  }\n}\n@media screen and (min-width: 4320px) {\n  .CodeMirror-cursor {\n    border-left: 4px solid black;\n  }\n}\n/*\n\nOriginal style from softwaremaniacs.org (c) Ivan Sagalaev <Maniac@SoftwareManiacs.Org>\nAdapted from GitHub theme\n\n*/\n.highlight-base {\n  color: #000;\n}\n.highlight-variable {\n  color: #000;\n}\n.highlight-variable-2 {\n  color: var(--self-color);\n}\n.highlight-variable-3 {\n  color: #333333;\n}\n.highlight-string {\n  color: #ba2121;\n}\n.highlight-comment {\n  color: #007979;\n  font-style: italic;\n}\n.highlight-number {\n  color: #080;\n}\n.highlight-atom {\n  color: #88f;\n}\n.highlight-keyword {\n  color: #008000;\n  font-weight: bold;\n}\n.highlight-builtin {\n  color: #008000;\n}\n.highlight-error {\n  color: #f00;\n}\n.highlight-operator {\n  color: #aa22ff;\n  font-weight: bold;\n}\n.highlight-meta {\n  color: #aa22ff;\n}\n/* previously not defined, copying from default codemirror */\n.highlight-def {\n  color: #00f;\n}\n.highlight-string-2 {\n  color: #f50;\n}\n.highlight-qualifier {\n  color: #555;\n}\n.highlight-bracket {\n  color: #997;\n}\n.highlight-tag {\n  color: #170;\n}\n.highlight-attribute {\n  color: #00c;\n}\n.highlight-header {\n  color: blue;\n}\n.highlight-quote {\n  color: #090;\n}\n.highlight-link {\n  color: #00c;\n}\n/* apply the same style to codemirror */\n.cm-s-ipython span.cm-keyword {\n  color: #008000;\n  font-weight: bold;\n}\n.cm-s-ipython span.cm-atom {\n  color: #88f;\n}\n.cm-s-ipython span.cm-number {\n  color: #080;\n}\n.cm-s-ipython span.cm-def {\n  color: #00f;\n}\n.cm-s-ipython span.cm-variable {\n  color: #000;\n}\n.cm-s-ipython span.cm-operator {\n  color: #aa22ff;\n  font-weight: bold;\n}\n.cm-s-ipython span.cm-variable-2 {\n  color: var(--self-color);\n}\n.cm-s-ipython span.cm-variable-3 {\n  color: #333333;\n}\n.cm-s-ipython span.cm-comment {\n  color: #007979;\n  font-style: italic;\n}\n.cm-s-ipython span.cm-string {\n  color: #ba2121;\n}\n.cm-s-ipython span.cm-string-2 {\n  color: #f50;\n}\n.cm-s-ipython span.cm-meta {\n  color: #aa22ff;\n}\n.cm-s-ipython span.cm-qualifier {\n  color: #555;\n}\n.cm-s-ipython span.cm-builtin {\n  color: #008000;\n}\n.cm-s-ipython span.cm-bracket {\n  color: #997;\n}\n.cm-s-ipython span.cm-tag {\n  color: #170;\n}\n.cm-s-ipython span.cm-attribute {\n  color: #00c;\n}\n.cm-s-ipython span.cm-header {\n  color: blue;\n}\n.cm-s-ipython span.cm-quote {\n  color: #090;\n}\n.cm-s-ipython span.cm-link {\n  color: #00c;\n}\n.cm-s-ipython span.cm-error {\n  color: #f00;\n}\n.cm-s-ipython span.cm-tab {\n  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAMCAYAAAAkuj5RAAAAAXNSR0IArs4c6QAAAGFJREFUSMft1LsRQFAQheHPowAKoACx3IgEKtaEHujDjORSgWTH/ZOdnZOcM/sgk/kFFWY0qV8foQwS4MKBCS3qR6ixBJvElOobYAtivseIE120FaowJPN75GMu8j/LfMwNjh4HUpwg4LUAAAAASUVORK5CYII=);\n  background-position: right;\n  background-repeat: no-repeat;\n}\ndiv.output_wrapper {\n  /* this position must be relative to enable descendents to be absolute within it */\n  position: relative;\n  /* Old browsers */\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-box-align: stretch;\n  display: -moz-box;\n  -moz-box-orient: vertical;\n  -moz-box-align: stretch;\n  display: box;\n  box-orient: vertical;\n  box-align: stretch;\n  /* Modern browsers */\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  z-index: 1;\n}\n/* class for the output area when it should be height-limited */\ndiv.output_scroll {\n  /* ideally, this would be max-height, but FF barfs all over that */\n  height: 24em;\n  /* FF needs this *and the wrapper* to specify full width, or it will shrinkwrap */\n  width: 100%;\n  overflow: auto;\n  border-radius: 2px;\n  -webkit-box-shadow: inset 0 2px 8px rgba(0, 0, 0, 0.8);\n  box-shadow: inset 0 2px 8px rgba(0, 0, 0, 0.8);\n  display: block;\n}\n/* output div while it is collapsed */\ndiv.output_collapsed {\n  margin: 0px;\n  padding: 0px;\n  /* Old browsers */\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-box-align: stretch;\n  display: -moz-box;\n  -moz-box-orient: vertical;\n  -moz-box-align: stretch;\n  display: box;\n  box-orient: vertical;\n  box-align: stretch;\n  /* Modern browsers */\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n}\ndiv.out_prompt_overlay {\n  height: 100%;\n  padding: 0px 0.4em;\n  position: absolute;\n  border-radius: 2px;\n}\ndiv.out_prompt_overlay:hover {\n  /* use inner shadow to get border that is computed the same on WebKit/FF */\n  -webkit-box-shadow: inset 0 0 1px #000;\n  box-shadow: inset 0 0 1px #000;\n  background: rgba(240, 240, 240, 0.5);\n}\ndiv.output_prompt {\n  color: var(--output-prompt-color);\n}\n/* This class is the outer container of all output sections. */\ndiv.output_area {\n  padding: 0px;\n  page-break-inside: avoid;\n  /* Old browsers */\n  display: -webkit-box;\n  -webkit-box-orient: horizontal;\n  -webkit-box-align: stretch;\n  display: -moz-box;\n  -moz-box-orient: horizontal;\n  -moz-box-align: stretch;\n  display: box;\n  box-orient: horizontal;\n  box-align: stretch;\n  /* Modern browsers */\n  display: flex;\n  flex-direction: row;\n  align-items: stretch;\n  /* Basthon: better rendering for animation controls in FuncAnimation.to_jshtml */\n}\ndiv.output_area .MathJax_Display {\n  text-align: center !important;\n}\ndiv.output_area .rendered_html table {\n  margin-left: 0;\n  margin-right: 0;\n}\ndiv.output_area .rendered_html img {\n  margin-left: 0;\n  margin-right: 0;\n}\ndiv.output_area img,\ndiv.output_area svg {\n  max-width: 100%;\n  height: auto;\n}\ndiv.output_area img.unconfined,\ndiv.output_area svg.unconfined {\n  max-width: none;\n}\ndiv.output_area .mglyph > img {\n  max-width: none;\n}\ndiv.output_area .output_subarea .animation .anim-controls .anim-buttons button {\n  padding: 5px 10px;\n  width: unset;\n}\n/* This is needed to protect the pre formating from global settings such\n   as that of bootstrap */\n.output {\n  /* Old browsers */\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-box-align: stretch;\n  display: -moz-box;\n  -moz-box-orient: vertical;\n  -moz-box-align: stretch;\n  display: box;\n  box-orient: vertical;\n  box-align: stretch;\n  /* Modern browsers */\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n}\n@media (max-width: 540px) {\n  div.output_area {\n    /* Old browsers */\n    display: -webkit-box;\n    -webkit-box-orient: vertical;\n    -webkit-box-align: stretch;\n    display: -moz-box;\n    -moz-box-orient: vertical;\n    -moz-box-align: stretch;\n    display: box;\n    box-orient: vertical;\n    box-align: stretch;\n    /* Modern browsers */\n    display: flex;\n    flex-direction: column;\n    align-items: stretch;\n  }\n}\ndiv.output_area pre {\n  margin: 0;\n  padding: 1px 0 1px 0;\n  border: 0;\n  vertical-align: baseline;\n  color: var(--output-pre-color);\n  background-color: transparent;\n  border-radius: 0;\n}\n/* This class is for the output subarea inside the output_area and after\n   the prompt div. */\ndiv.output_subarea {\n  overflow-x: auto;\n  padding: 0.4em;\n  /* Old browsers */\n  -webkit-box-flex: 1;\n  -moz-box-flex: 1;\n  box-flex: 1;\n  /* Modern browsers */\n  flex: 1;\n  max-width: calc(100% - 14ex);\n}\ndiv.output_scroll div.output_subarea {\n  overflow-x: visible;\n}\n/* The rest of the output_* classes are for special styling of the different\n   output types */\n/* all text output has this class: */\ndiv.output_text {\n  text-align: left;\n  color: black;\n  /* This has to match that of the the CodeMirror class line-height below */\n  line-height: 1.21429em;\n}\n/* stdout/stderr are 'text' as well as 'stream', but execute_result/error are *not* streams */\ndiv.output_stderr {\n  background: var(--output-stderr-bg-color);\n  /* very light red background for stderr */\n}\ndiv.output_latex {\n  text-align: left;\n}\n/* Empty output_javascript divs should have no height */\ndiv.output_javascript:empty {\n  padding: 0;\n}\n.js-error {\n  color: darkred;\n}\n/* raw_input styles */\ndiv.raw_input_container {\n  line-height: 1.21429em;\n  padding-top: 5px;\n}\npre.raw_input_prompt {\n  /* nothing needed here. */\n}\ninput.raw_input {\n  font-family: monospace;\n  font-size: inherit;\n  color: inherit;\n  width: auto;\n  /* make sure input baseline aligns with prompt */\n  vertical-align: baseline;\n  /* padding + margin = 0.5em between prompt and cursor */\n  padding: 0em 0.25em;\n  margin: 0em 0.25em;\n}\ninput.raw_input:focus {\n  box-shadow: none;\n}\np.p-space {\n  margin-bottom: 10px;\n}\ndiv.output_unrecognized {\n  padding: 5px;\n  font-weight: bold;\n  color: red;\n}\ndiv.output_unrecognized a {\n  color: inherit;\n  text-decoration: none;\n}\ndiv.output_unrecognized a:hover {\n  color: inherit;\n  text-decoration: none;\n}\n.rendered_html {\n  color: black;\n  /* any extras will just be numbers: */\n}\n.rendered_html em {\n  font-style: italic;\n}\n.rendered_html strong {\n  font-weight: bold;\n}\n.rendered_html u {\n  text-decoration: underline;\n}\n.rendered_html :link {\n  text-decoration: underline;\n}\n.rendered_html :visited {\n  text-decoration: underline;\n}\n.rendered_html h1 {\n  font-size: 185.7%;\n  margin: 1.08em 0 0 0;\n  font-weight: bold;\n  line-height: 1;\n}\n.rendered_html h2 {\n  font-size: 157.1%;\n  margin: 1.27em 0 0 0;\n  font-weight: bold;\n  line-height: 1;\n}\n.rendered_html h3 {\n  font-size: 128.6%;\n  margin: 1.55em 0 0 0;\n  font-weight: bold;\n  line-height: 1;\n}\n.rendered_html h4 {\n  font-size: 100%;\n  margin: 2em 0 0 0;\n  font-weight: bold;\n  line-height: 1;\n}\n.rendered_html h5 {\n  font-size: 100%;\n  margin: 2em 0 0 0;\n  font-weight: bold;\n  line-height: 1;\n  font-style: italic;\n}\n.rendered_html h6 {\n  font-size: 100%;\n  margin: 2em 0 0 0;\n  font-weight: bold;\n  line-height: 1;\n  font-style: italic;\n}\n.rendered_html h1:first-child {\n  margin-top: 0.538em;\n}\n.rendered_html h2:first-child {\n  margin-top: 0.636em;\n}\n.rendered_html h3:first-child {\n  margin-top: 0.777em;\n}\n.rendered_html h4:first-child {\n  margin-top: 1em;\n}\n.rendered_html h5:first-child {\n  margin-top: 1em;\n}\n.rendered_html h6:first-child {\n  margin-top: 1em;\n}\n.rendered_html ul:not(.list-inline),\n.rendered_html ol:not(.list-inline) {\n  padding-left: 2em;\n}\n.rendered_html ul {\n  list-style: disc;\n}\n.rendered_html ul ul {\n  list-style: square;\n  margin-top: 0;\n}\n.rendered_html ul ul ul {\n  list-style: circle;\n}\n.rendered_html ol {\n  list-style: decimal;\n}\n.rendered_html ol ol {\n  list-style: upper-alpha;\n  margin-top: 0;\n}\n.rendered_html ol ol ol {\n  list-style: lower-alpha;\n}\n.rendered_html ol ol ol ol {\n  list-style: lower-roman;\n}\n.rendered_html ol ol ol ol ol {\n  list-style: decimal;\n}\n.rendered_html * + ul {\n  margin-top: 1em;\n}\n.rendered_html * + ol {\n  margin-top: 1em;\n}\n.rendered_html hr {\n  color: var(--rendered-html-border-color);\n  background-color: var(--rendered-html-border-color);\n}\n.rendered_html pre {\n  margin: 1em 2em;\n  padding: 0px;\n  background-color: var(--body-bg);\n}\n.rendered_html code {\n  background-color: #eff0f1;\n}\n.rendered_html p code {\n  padding: 1px 5px;\n}\n.rendered_html pre code {\n  background-color: var(--body-bg);\n}\n.rendered_html pre,\n.rendered_html code {\n  border: 0;\n  color: black;\n  font-size: 100%;\n}\n.rendered_html blockquote {\n  margin: 1em 2em;\n}\n.rendered_html table {\n  margin-left: auto;\n  margin-right: auto;\n  border: none;\n  border-collapse: collapse;\n  border-spacing: 0;\n  color: var(--rendered-html-border-color);\n  font-size: 12px;\n  table-layout: fixed;\n}\n.rendered_html thead {\n  border-bottom: 1px solid var(--rendered-html-border-color);\n  vertical-align: bottom;\n}\n.rendered_html tr,\n.rendered_html th,\n.rendered_html td {\n  text-align: right;\n  vertical-align: middle;\n  padding: 0.5em 0.5em;\n  line-height: normal;\n  white-space: normal;\n  max-width: none;\n  border: none;\n}\n.rendered_html td[align=\"left\"] {\n  text-align: left;\n}\n.rendered_html td[align=\"center\"] {\n  text-align: center;\n}\n.rendered_html td[align=\"right\"] {\n  text-align: right;\n}\n.rendered_html th {\n  font-weight: bold;\n}\n.rendered_html tbody tr:nth-child(odd) {\n  background: #f5f5f5;\n}\n.rendered_html tbody tr:hover {\n  background: rgba(66, 165, 245, 0.2);\n}\n.rendered_html * + table {\n  margin-top: 1em;\n}\n.rendered_html p {\n  text-align: left;\n}\n.rendered_html * + p {\n  margin-top: 1em;\n}\n.rendered_html img {\n  display: block;\n  margin-left: auto;\n  margin-right: auto;\n}\n.rendered_html * + img {\n  margin-top: 1em;\n}\n.rendered_html img,\n.rendered_html svg {\n  max-width: 100%;\n  height: auto;\n}\n.rendered_html img.unconfined,\n.rendered_html svg.unconfined {\n  max-width: none;\n}\n.rendered_html .alert {\n  margin-bottom: initial;\n}\n.rendered_html * + .alert {\n  margin-top: 1em;\n}\n[dir=\"rtl\"] .rendered_html p {\n  text-align: right;\n}\ndiv.text_cell {\n  /* Old browsers */\n  display: -webkit-box;\n  -webkit-box-orient: horizontal;\n  -webkit-box-align: stretch;\n  display: -moz-box;\n  -moz-box-orient: horizontal;\n  -moz-box-align: stretch;\n  display: box;\n  box-orient: horizontal;\n  box-align: stretch;\n  /* Modern browsers */\n  display: flex;\n  flex-direction: row;\n  align-items: stretch;\n}\n@media (max-width: 540px) {\n  div.text_cell > div.prompt {\n    display: none;\n  }\n}\ndiv.text_cell_render {\n  /*font-family: \"Helvetica Neue\", Arial, Helvetica, Geneva, sans-serif;*/\n  outline: none;\n  resize: none;\n  width: inherit;\n  border-style: none;\n  padding: 0.5em 0.5em 0.5em 0.4em;\n  color: black;\n  box-sizing: border-box;\n  -moz-box-sizing: border-box;\n  -webkit-box-sizing: border-box;\n}\na.anchor-link:link {\n  text-decoration: none;\n  padding: 0px 20px;\n  visibility: hidden;\n}\nh1:hover .anchor-link,\nh2:hover .anchor-link,\nh3:hover .anchor-link,\nh4:hover .anchor-link,\nh5:hover .anchor-link,\nh6:hover .anchor-link {\n  visibility: visible;\n}\n.text_cell.rendered .input_area {\n  display: none;\n}\n.text_cell.rendered .rendered_html {\n  overflow-x: auto;\n  overflow-y: hidden;\n}\n.text_cell.rendered .rendered_html tr,\n.text_cell.rendered .rendered_html th,\n.text_cell.rendered .rendered_html td {\n  max-width: none;\n}\n.text_cell.unrendered .text_cell_render {\n  display: none;\n}\n.text_cell .dropzone .input_area {\n  border: 2px dashed #bababa;\n  margin: -1px;\n}\n.cm-header-1,\n.cm-header-2,\n.cm-header-3,\n.cm-header-4,\n.cm-header-5,\n.cm-header-6 {\n  font-weight: bold;\n  font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n}\n.cm-header-1 {\n  font-size: 185.7%;\n}\n.cm-header-2 {\n  font-size: 157.1%;\n}\n.cm-header-3 {\n  font-size: 128.6%;\n}\n.cm-header-4 {\n  font-size: 110%;\n}\n.cm-header-5 {\n  font-size: 100%;\n  font-style: italic;\n}\n.cm-header-6 {\n  font-size: 100%;\n  font-style: italic;\n}\n/*!\n*\n* IPython notebook webapp\n*\n*/\n@media (max-width: 767px) {\n  .notebook_app {\n    padding-left: 0px;\n    padding-right: 0px;\n  }\n}\n#ipython-main-app {\n  box-sizing: border-box;\n  -moz-box-sizing: border-box;\n  -webkit-box-sizing: border-box;\n  height: 100%;\n}\ndiv#notebook_panel {\n  margin: 0px;\n  padding: 0px;\n  box-sizing: border-box;\n  -moz-box-sizing: border-box;\n  -webkit-box-sizing: border-box;\n  height: 100%;\n}\ndiv#notebook {\n  font-size: 14px;\n  line-height: 20px;\n  overflow-y: hidden;\n  overflow-x: auto;\n  width: 100%;\n  /* This spaces the page away from the edge of the notebook area */\n  padding-top: 20px;\n  padding-bottom: 20px;\n  margin: 0px;\n  outline: none;\n  box-sizing: border-box;\n  -moz-box-sizing: border-box;\n  -webkit-box-sizing: border-box;\n  min-height: 100%;\n}\n@media not print {\n  #notebook-container {\n    padding: 15px;\n    background-color: var(--body-bg);\n    min-height: 0;\n    -webkit-box-shadow: 0px 0px 12px 1px rgba(87, 87, 87, 0.2);\n    box-shadow: 0px 0px 12px 1px rgba(87, 87, 87, 0.2);\n  }\n}\n@media print {\n  #notebook-container {\n    width: 100%;\n  }\n}\ndiv.ui-widget-content {\n  border: 1px solid var(--border-color);\n  outline: none;\n}\npre.dialog {\n  background-color: var(--body-bg-darken3pc);\n  border: 1px solid #ddd;\n  border-radius: 2px;\n  padding: 0.4em;\n  padding-left: 2em;\n}\np.dialog {\n  padding: 0.2em;\n}\n/* Word-wrap output correctly.  This is the CSS3 spelling, though Firefox seems\n   to not honor it correctly.  Webkit browsers (Chrome, rekonq, Safari) do.\n */\npre,\ncode,\nkbd,\nsamp {\n  white-space: pre-wrap;\n}\n#fonttest {\n  font-family: monospace;\n}\np {\n  margin-bottom: 0;\n}\n.end_space {\n  min-height: 100px;\n}\n.notebook_app > #header {\n  -webkit-box-shadow: 0px 0px 12px 1px rgba(87, 87, 87, 0.2);\n  box-shadow: 0px 0px 12px 1px rgba(87, 87, 87, 0.2);\n}\n@media not print {\n  .notebook_app {\n    background-color: var(--page-backdrop-color);\n  }\n}\nkbd {\n  border-style: solid;\n  border-width: 1px;\n  box-shadow: none;\n  margin: 2px;\n  padding-left: 2px;\n  padding-right: 2px;\n  padding-top: 1px;\n  padding-bottom: 1px;\n}\n.jupyter-keybindings {\n  padding: 1px;\n  line-height: 24px;\n  border-bottom: 1px solid gray;\n}\n.jupyter-keybindings input {\n  margin: 0;\n  padding: 0;\n  border: none;\n}\n.jupyter-keybindings i {\n  padding: 6px;\n}\n.well code {\n  background-color: hsl(var(--body-bg-hue), var(--body-bg-saturation), calc(var(--body-bg-light) + 1.8%));\n  border-color: var(--border-color);\n  border-width: 1px;\n  border-style: solid;\n  padding: 2px;\n  padding-top: 1px;\n  padding-bottom: 1px;\n}\n/* CSS for the cell toolbar */\n.celltoolbar {\n  border: thin solid var(--btn-default-border-color);\n  border-bottom: none;\n  background: var(--page-backdrop-color);\n  border-radius: 2px 2px 0px 0px;\n  width: 100%;\n  height: 29px;\n  padding-right: 4px;\n  /* Old browsers */\n  display: -webkit-box;\n  -webkit-box-orient: horizontal;\n  -webkit-box-align: stretch;\n  display: -moz-box;\n  -moz-box-orient: horizontal;\n  -moz-box-align: stretch;\n  display: box;\n  box-orient: horizontal;\n  box-align: stretch;\n  /* Modern browsers */\n  display: flex;\n  flex-direction: row;\n  align-items: stretch;\n  /* Old browsers */\n  -webkit-box-pack: end;\n  -moz-box-pack: end;\n  box-pack: end;\n  /* Modern browsers */\n  justify-content: flex-end;\n  display: -webkit-flex;\n}\n@media print {\n  .celltoolbar {\n    display: none;\n  }\n}\n.ctb_hideshow {\n  display: none;\n  vertical-align: bottom;\n}\n/* ctb_show is added to the ctb_hideshow div to show the cell toolbar.\n   Cell toolbars are only shown when the ctb_global_show class is also set.\n*/\n.ctb_global_show .ctb_show.ctb_hideshow {\n  display: block;\n}\n.ctb_global_show .ctb_show + .input_area,\n.ctb_global_show .ctb_show + div.text_cell_input,\n.ctb_global_show .ctb_show ~ div.text_cell_render {\n  border-top-right-radius: 0px;\n  border-top-left-radius: 0px;\n}\n.ctb_global_show .ctb_show ~ div.text_cell_render {\n  border: 1px solid var(--light-border-color);\n}\n.celltoolbar {\n  font-size: 87%;\n  padding-top: 3px;\n}\n.celltoolbar select {\n  display: block;\n  width: 100%;\n  height: 32px;\n  padding: 6px 12px;\n  font-size: 13px;\n  line-height: 1.42857143;\n  color: #555555;\n  background-color: #fff;\n  background-image: none;\n  border: 1px solid #ccc;\n  border-radius: 2px;\n  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);\n  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);\n  -webkit-transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;\n  -o-transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;\n  transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;\n  height: 30px;\n  padding: 5px 10px;\n  font-size: 12px;\n  line-height: 1.5;\n  border-radius: 1px;\n  width: inherit;\n  font-size: inherit;\n  height: 22px;\n  padding: 0px;\n  display: inline-block;\n}\n.celltoolbar select:focus {\n  border-color: #66afe9;\n  outline: 0;\n  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075), 0 0 8px rgba(102, 175, 233, 0.6);\n  box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075), 0 0 8px rgba(102, 175, 233, 0.6);\n}\n.celltoolbar select::-moz-placeholder {\n  color: #999;\n  opacity: 1;\n}\n.celltoolbar select:-ms-input-placeholder {\n  color: #999;\n}\n.celltoolbar select::-webkit-input-placeholder {\n  color: #999;\n}\n.celltoolbar select::-ms-expand {\n  background-color: transparent;\n  border: 0;\n}\n.celltoolbar select[disabled],\n.celltoolbar select[readonly],\nfieldset[disabled] .celltoolbar select {\n  background-color: #eeeeee;\n  opacity: 1;\n}\n.celltoolbar select[disabled],\nfieldset[disabled] .celltoolbar select {\n  cursor: not-allowed;\n}\ntextarea.celltoolbar select {\n  height: auto;\n}\nselect.celltoolbar select {\n  height: 30px;\n  line-height: 30px;\n}\ntextarea.celltoolbar select,\nselect[multiple].celltoolbar select {\n  height: auto;\n}\n.celltoolbar label {\n  margin-left: 5px;\n  margin-right: 5px;\n}\n.tags_button_container {\n  width: 100%;\n  display: flex;\n}\n.tag-container {\n  display: flex;\n  flex-direction: row;\n  flex-grow: 1;\n  overflow: hidden;\n  position: relative;\n}\n.tag-container > * {\n  margin: 0 4px;\n}\n.remove-tag-btn {\n  margin-left: 4px;\n}\n.tags-input {\n  display: flex;\n}\n.cell-tag:last-child:after {\n  content: \"\";\n  position: absolute;\n  right: 0;\n  width: 40px;\n  height: 100%;\n  /* Fade to background color of cell toolbar */\n  background: linear-gradient(to right, rgba(0, 0, 0, 0), #EEE);\n}\n.tags-input > * {\n  margin-left: 4px;\n}\n.cell-tag,\n.tags-input input,\n.tags-input button {\n  display: block;\n  width: 100%;\n  height: 32px;\n  padding: 6px 12px;\n  font-size: 13px;\n  line-height: 1.42857143;\n  color: #555555;\n  background-color: #fff;\n  background-image: none;\n  border: 1px solid #ccc;\n  border-radius: 2px;\n  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);\n  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);\n  -webkit-transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;\n  -o-transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;\n  transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;\n  height: 30px;\n  padding: 5px 10px;\n  font-size: 12px;\n  line-height: 1.5;\n  border-radius: 1px;\n  box-shadow: none;\n  width: inherit;\n  font-size: inherit;\n  height: 22px;\n  line-height: 22px;\n  padding: 0px 4px;\n  display: inline-block;\n}\n.cell-tag:focus,\n.tags-input input:focus,\n.tags-input button:focus {\n  border-color: #66afe9;\n  outline: 0;\n  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075), 0 0 8px rgba(102, 175, 233, 0.6);\n  box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075), 0 0 8px rgba(102, 175, 233, 0.6);\n}\n.cell-tag::-moz-placeholder,\n.tags-input input::-moz-placeholder,\n.tags-input button::-moz-placeholder {\n  color: #999;\n  opacity: 1;\n}\n.cell-tag:-ms-input-placeholder,\n.tags-input input:-ms-input-placeholder,\n.tags-input button:-ms-input-placeholder {\n  color: #999;\n}\n.cell-tag::-webkit-input-placeholder,\n.tags-input input::-webkit-input-placeholder,\n.tags-input button::-webkit-input-placeholder {\n  color: #999;\n}\n.cell-tag::-ms-expand,\n.tags-input input::-ms-expand,\n.tags-input button::-ms-expand {\n  background-color: transparent;\n  border: 0;\n}\n.cell-tag[disabled],\n.tags-input input[disabled],\n.tags-input button[disabled],\n.cell-tag[readonly],\n.tags-input input[readonly],\n.tags-input button[readonly],\nfieldset[disabled] .cell-tag,\nfieldset[disabled] .tags-input input,\nfieldset[disabled] .tags-input button {\n  background-color: #eeeeee;\n  opacity: 1;\n}\n.cell-tag[disabled],\n.tags-input input[disabled],\n.tags-input button[disabled],\nfieldset[disabled] .cell-tag,\nfieldset[disabled] .tags-input input,\nfieldset[disabled] .tags-input button {\n  cursor: not-allowed;\n}\ntextarea.cell-tag,\ntextarea.tags-input input,\ntextarea.tags-input button {\n  height: auto;\n}\nselect.cell-tag,\nselect.tags-input input,\nselect.tags-input button {\n  height: 30px;\n  line-height: 30px;\n}\ntextarea.cell-tag,\ntextarea.tags-input input,\ntextarea.tags-input button,\nselect[multiple].cell-tag,\nselect[multiple].tags-input input,\nselect[multiple].tags-input button {\n  height: auto;\n}\n.cell-tag,\n.tags-input button {\n  padding: 0px 4px;\n}\n.cell-tag {\n  background-color: #fff;\n  white-space: nowrap;\n}\n.tags-input input[type=text]:focus {\n  outline: none;\n  box-shadow: none;\n  border-color: #ccc;\n}\n.completions {\n  position: absolute;\n  z-index: 110;\n  overflow: hidden;\n  border: 1px solid var(--border-color);\n  border-radius: 2px;\n  -webkit-box-shadow: 0px 6px 10px -1px #adadad;\n  box-shadow: 0px 6px 10px -1px #adadad;\n  line-height: 1;\n}\n.completions select {\n  background: white;\n  outline: none;\n  border: none;\n  padding: 0px;\n  margin: 0px;\n  overflow: auto;\n  font-family: monospace;\n  font-size: 110%;\n  color: black;\n  width: auto;\n}\n.completions select option.context {\n  color: #286090;\n}\n#kernel_logo_widget .current_kernel_logo {\n  display: none;\n  margin-top: -1px;\n  margin-bottom: -1px;\n  width: 32px;\n  height: 32px;\n}\n[dir=\"rtl\"] #kernel_logo_widget {\n  float: left !important;\n  float: left;\n}\n.modal .modal-body .move-path {\n  display: flex;\n  flex-direction: row;\n  justify-content: space;\n  align-items: center;\n}\n.modal .modal-body .move-path .server-root {\n  padding-right: 20px;\n}\n.modal .modal-body .move-path .path-input {\n  flex: 1;\n}\n#menubar {\n  box-sizing: border-box;\n  -moz-box-sizing: border-box;\n  -webkit-box-sizing: border-box;\n  margin-top: 1px;\n}\n#menubar .navbar {\n  border-top: 1px;\n  border-radius: 0px 0px 2px 2px;\n  margin-bottom: 0px;\n}\n#menubar .navbar-toggle {\n  float: left;\n  padding-top: 7px;\n  padding-bottom: 7px;\n  border: none;\n}\n#menubar .navbar-collapse {\n  clear: left;\n}\n[dir=\"rtl\"] #menubar .navbar-toggle {\n  float: right;\n}\n[dir=\"rtl\"] #menubar .navbar-collapse {\n  clear: right;\n}\n[dir=\"rtl\"] #menubar .navbar-nav {\n  float: right;\n}\n[dir=\"rtl\"] #menubar .nav {\n  padding-right: 0px;\n}\n[dir=\"rtl\"] #menubar .navbar-nav > li {\n  float: right;\n}\n[dir=\"rtl\"] #menubar .navbar-right {\n  float: left !important;\n}\n[dir=\"rtl\"] ul.dropdown-menu {\n  text-align: right;\n  left: auto;\n}\n[dir=\"rtl\"] ul#new-menu.dropdown-menu {\n  right: auto;\n  left: 0;\n}\n.nav-wrapper {\n  border-bottom: 1px solid var(--navbar-default-border);\n}\ni.menu-icon {\n  padding-top: 4px;\n}\n[dir=\"rtl\"] i.menu-icon.pull-right {\n  float: left !important;\n  float: left;\n}\nul#help_menu li a {\n  overflow: hidden;\n  padding-right: 2.2em;\n}\nul#help_menu li a i {\n  margin-right: -1.2em;\n}\n[dir=\"rtl\"] ul#help_menu li a {\n  padding-left: 2.2em;\n}\n[dir=\"rtl\"] ul#help_menu li a i {\n  margin-right: 0;\n  margin-left: -1.2em;\n}\n[dir=\"rtl\"] ul#help_menu li a i.pull-right {\n  float: left !important;\n  float: left;\n}\n.dropdown-submenu {\n  position: relative;\n}\n.dropdown-submenu > .dropdown-menu {\n  top: 0;\n  left: 100%;\n  margin-top: -6px;\n  margin-left: -1px;\n}\n[dir=\"rtl\"] .dropdown-submenu > .dropdown-menu {\n  right: 100%;\n  margin-right: -1px;\n}\n.dropdown-submenu:hover > .dropdown-menu {\n  display: block;\n}\n.dropdown-submenu > a:after {\n  display: inline-block;\n  font: normal normal normal 14px/1 FontAwesome;\n  font-size: inherit;\n  text-rendering: auto;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  display: block;\n  content: \"\\f0da\";\n  float: right;\n  color: #333333;\n  margin-top: 2px;\n  margin-right: -10px;\n}\n.dropdown-submenu > a:after.fa-pull-left {\n  margin-right: 0.3em;\n}\n.dropdown-submenu > a:after.fa-pull-right {\n  margin-left: 0.3em;\n}\n.dropdown-submenu > a:after.pull-left {\n  margin-right: 0.3em;\n}\n.dropdown-submenu > a:after.pull-right {\n  margin-left: 0.3em;\n}\n[dir=\"rtl\"] .dropdown-submenu > a:after {\n  float: left;\n  content: \"\\f0d9\";\n  margin-right: 0;\n  margin-left: -10px;\n}\n.dropdown-submenu:hover > a:after {\n  color: #262626;\n}\n.dropdown-submenu.pull-left {\n  float: none;\n}\n.dropdown-submenu.pull-left > .dropdown-menu {\n  left: -100%;\n  margin-left: 10px;\n}\n#notification_area {\n  float: right !important;\n  float: right;\n  z-index: 10;\n}\n[dir=\"rtl\"] #notification_area {\n  float: left !important;\n  float: left;\n}\n.indicator_area {\n  float: right !important;\n  float: right;\n  color: var(--navbar-default-link-color);\n  margin-left: 5px;\n  margin-right: 5px;\n  width: 11px;\n  z-index: 10;\n  text-align: center;\n  width: auto;\n}\n[dir=\"rtl\"] .indicator_area {\n  float: left !important;\n  float: left;\n}\n#kernel_indicator {\n  float: right !important;\n  float: right;\n  color: var(--navbar-default-link-color);\n  margin-left: 5px;\n  margin-right: 5px;\n  width: 11px;\n  z-index: 10;\n  text-align: center;\n  width: auto;\n  border-left: 1px solid;\n}\n#kernel_indicator .kernel_indicator_name {\n  padding-left: 5px;\n  padding-right: 5px;\n}\n[dir=\"rtl\"] #kernel_indicator {\n  float: left !important;\n  float: left;\n  border-left: 0;\n  border-right: 1px solid;\n}\n#modal_indicator {\n  float: right !important;\n  float: right;\n  color: var(--navbar-default-link-color);\n  margin-left: 5px;\n  margin-right: 5px;\n  width: 11px;\n  z-index: 10;\n  text-align: center;\n  width: auto;\n}\n[dir=\"rtl\"] #modal_indicator {\n  float: left !important;\n  float: left;\n}\n#readonly-indicator {\n  float: right !important;\n  float: right;\n  color: var(--navbar-default-link-color);\n  margin-left: 5px;\n  margin-right: 5px;\n  width: 11px;\n  z-index: 10;\n  text-align: center;\n  width: auto;\n  margin-top: 2px;\n  margin-bottom: 0px;\n  margin-left: 0px;\n  margin-right: 0px;\n  display: none;\n}\n.modal_indicator:before {\n  width: 1.28571429em;\n  text-align: center;\n}\n.edit_mode .modal_indicator:before {\n  display: inline-block;\n  font: normal normal normal 14px/1 FontAwesome;\n  font-size: inherit;\n  text-rendering: auto;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  content: \"\\f040\";\n}\n.edit_mode .modal_indicator:before.fa-pull-left {\n  margin-right: 0.3em;\n}\n.edit_mode .modal_indicator:before.fa-pull-right {\n  margin-left: 0.3em;\n}\n.edit_mode .modal_indicator:before.pull-left {\n  margin-right: 0.3em;\n}\n.edit_mode .modal_indicator:before.pull-right {\n  margin-left: 0.3em;\n}\n.command_mode .modal_indicator:before {\n  display: inline-block;\n  font: normal normal normal 14px/1 FontAwesome;\n  font-size: inherit;\n  text-rendering: auto;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  content: ' ';\n}\n.command_mode .modal_indicator:before.fa-pull-left {\n  margin-right: 0.3em;\n}\n.command_mode .modal_indicator:before.fa-pull-right {\n  margin-left: 0.3em;\n}\n.command_mode .modal_indicator:before.pull-left {\n  margin-right: 0.3em;\n}\n.command_mode .modal_indicator:before.pull-right {\n  margin-left: 0.3em;\n}\n.kernel_idle_icon:before {\n  display: inline-block;\n  font: normal normal normal 14px/1 FontAwesome;\n  font-size: inherit;\n  text-rendering: auto;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  content: \"\\f10c\";\n}\n.kernel_idle_icon:before.fa-pull-left {\n  margin-right: 0.3em;\n}\n.kernel_idle_icon:before.fa-pull-right {\n  margin-left: 0.3em;\n}\n.kernel_idle_icon:before.pull-left {\n  margin-right: 0.3em;\n}\n.kernel_idle_icon:before.pull-right {\n  margin-left: 0.3em;\n}\n.kernel_busy_icon:before {\n  display: inline-block;\n  font: normal normal normal 14px/1 FontAwesome;\n  font-size: inherit;\n  text-rendering: auto;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  content: \"\\f111\";\n}\n.kernel_busy_icon:before.fa-pull-left {\n  margin-right: 0.3em;\n}\n.kernel_busy_icon:before.fa-pull-right {\n  margin-left: 0.3em;\n}\n.kernel_busy_icon:before.pull-left {\n  margin-right: 0.3em;\n}\n.kernel_busy_icon:before.pull-right {\n  margin-left: 0.3em;\n}\n.kernel_dead_icon:before {\n  display: inline-block;\n  font: normal normal normal 14px/1 FontAwesome;\n  font-size: inherit;\n  text-rendering: auto;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  content: \"\\f1e2\";\n}\n.kernel_dead_icon:before.fa-pull-left {\n  margin-right: 0.3em;\n}\n.kernel_dead_icon:before.fa-pull-right {\n  margin-left: 0.3em;\n}\n.kernel_dead_icon:before.pull-left {\n  margin-right: 0.3em;\n}\n.kernel_dead_icon:before.pull-right {\n  margin-left: 0.3em;\n}\n.kernel_disconnected_icon:before {\n  display: inline-block;\n  font: normal normal normal 14px/1 FontAwesome;\n  font-size: inherit;\n  text-rendering: auto;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  content: \"\\f127\";\n}\n.kernel_disconnected_icon:before.fa-pull-left {\n  margin-right: 0.3em;\n}\n.kernel_disconnected_icon:before.fa-pull-right {\n  margin-left: 0.3em;\n}\n.kernel_disconnected_icon:before.pull-left {\n  margin-right: 0.3em;\n}\n.kernel_disconnected_icon:before.pull-right {\n  margin-left: 0.3em;\n}\n.notification_widget {\n  color: #565656;\n  z-index: 10;\n  background: rgba(240, 240, 240, 0.5);\n  margin-right: 4px;\n  color: #333;\n  background-color: #fff;\n  border-color: #ccc;\n}\n.notification_widget:focus,\n.notification_widget.focus {\n  color: #333;\n  background-color: #e6e6e6;\n  border-color: #8c8c8c;\n}\n.notification_widget:hover {\n  color: #333;\n  background-color: #e6e6e6;\n  border-color: #adadad;\n}\n.notification_widget:active,\n.notification_widget.active,\n.open > .dropdown-toggle.notification_widget {\n  color: #333;\n  background-color: #e6e6e6;\n  background-image: none;\n  border-color: #adadad;\n}\n.notification_widget:active:hover,\n.notification_widget.active:hover,\n.open > .dropdown-toggle.notification_widget:hover,\n.notification_widget:active:focus,\n.notification_widget.active:focus,\n.open > .dropdown-toggle.notification_widget:focus,\n.notification_widget:active.focus,\n.notification_widget.active.focus,\n.open > .dropdown-toggle.notification_widget.focus {\n  color: #333;\n  background-color: #d4d4d4;\n  border-color: #8c8c8c;\n}\n.notification_widget.disabled:hover,\n.notification_widget[disabled]:hover,\nfieldset[disabled] .notification_widget:hover,\n.notification_widget.disabled:focus,\n.notification_widget[disabled]:focus,\nfieldset[disabled] .notification_widget:focus,\n.notification_widget.disabled.focus,\n.notification_widget[disabled].focus,\nfieldset[disabled] .notification_widget.focus {\n  background-color: #fff;\n  border-color: #ccc;\n}\n.notification_widget .badge {\n  color: #fff;\n  background-color: #333;\n}\n.notification_widget.warning {\n  color: #fff;\n  background-color: #f0ad4e;\n  border-color: #eea236;\n  color: #ffffff;\n  background-color: #b46102;\n  border-color: #b46102;\n}\n.notification_widget.warning:focus,\n.notification_widget.warning.focus {\n  color: #fff;\n  background-color: #ec971f;\n  border-color: #985f0d;\n}\n.notification_widget.warning:hover {\n  color: #fff;\n  background-color: #ec971f;\n  border-color: #d58512;\n}\n.notification_widget.warning:active,\n.notification_widget.warning.active,\n.open > .dropdown-toggle.notification_widget.warning {\n  color: #fff;\n  background-color: #ec971f;\n  background-image: none;\n  border-color: #d58512;\n}\n.notification_widget.warning:active:hover,\n.notification_widget.warning.active:hover,\n.open > .dropdown-toggle.notification_widget.warning:hover,\n.notification_widget.warning:active:focus,\n.notification_widget.warning.active:focus,\n.open > .dropdown-toggle.notification_widget.warning:focus,\n.notification_widget.warning:active.focus,\n.notification_widget.warning.active.focus,\n.open > .dropdown-toggle.notification_widget.warning.focus {\n  color: #fff;\n  background-color: #d58512;\n  border-color: #985f0d;\n}\n.notification_widget.warning.disabled:hover,\n.notification_widget.warning[disabled]:hover,\nfieldset[disabled] .notification_widget.warning:hover,\n.notification_widget.warning.disabled:focus,\n.notification_widget.warning[disabled]:focus,\nfieldset[disabled] .notification_widget.warning:focus,\n.notification_widget.warning.disabled.focus,\n.notification_widget.warning[disabled].focus,\nfieldset[disabled] .notification_widget.warning.focus {\n  background-color: #f0ad4e;\n  border-color: #eea236;\n}\n.notification_widget.warning .badge {\n  color: #f0ad4e;\n  background-color: #fff;\n}\n.notification_widget.success {\n  color: #fff;\n  background-color: #5cb85c;\n  border-color: #4cae4c;\n}\n.notification_widget.success:focus,\n.notification_widget.success.focus {\n  color: #fff;\n  background-color: #449d44;\n  border-color: #255625;\n}\n.notification_widget.success:hover {\n  color: #fff;\n  background-color: #449d44;\n  border-color: #398439;\n}\n.notification_widget.success:active,\n.notification_widget.success.active,\n.open > .dropdown-toggle.notification_widget.success {\n  color: #fff;\n  background-color: #449d44;\n  background-image: none;\n  border-color: #398439;\n}\n.notification_widget.success:active:hover,\n.notification_widget.success.active:hover,\n.open > .dropdown-toggle.notification_widget.success:hover,\n.notification_widget.success:active:focus,\n.notification_widget.success.active:focus,\n.open > .dropdown-toggle.notification_widget.success:focus,\n.notification_widget.success:active.focus,\n.notification_widget.success.active.focus,\n.open > .dropdown-toggle.notification_widget.success.focus {\n  color: #fff;\n  background-color: #398439;\n  border-color: #255625;\n}\n.notification_widget.success.disabled:hover,\n.notification_widget.success[disabled]:hover,\nfieldset[disabled] .notification_widget.success:hover,\n.notification_widget.success.disabled:focus,\n.notification_widget.success[disabled]:focus,\nfieldset[disabled] .notification_widget.success:focus,\n.notification_widget.success.disabled.focus,\n.notification_widget.success[disabled].focus,\nfieldset[disabled] .notification_widget.success.focus {\n  background-color: #5cb85c;\n  border-color: #4cae4c;\n}\n.notification_widget.success .badge {\n  color: #5cb85c;\n  background-color: #fff;\n}\n.notification_widget.info {\n  color: #fff;\n  background-color: #5bc0de;\n  border-color: #46b8da;\n}\n.notification_widget.info:focus,\n.notification_widget.info.focus {\n  color: #fff;\n  background-color: #31b0d5;\n  border-color: #1b6d85;\n}\n.notification_widget.info:hover {\n  color: #fff;\n  background-color: #31b0d5;\n  border-color: #269abc;\n}\n.notification_widget.info:active,\n.notification_widget.info.active,\n.open > .dropdown-toggle.notification_widget.info {\n  color: #fff;\n  background-color: #31b0d5;\n  background-image: none;\n  border-color: #269abc;\n}\n.notification_widget.info:active:hover,\n.notification_widget.info.active:hover,\n.open > .dropdown-toggle.notification_widget.info:hover,\n.notification_widget.info:active:focus,\n.notification_widget.info.active:focus,\n.open > .dropdown-toggle.notification_widget.info:focus,\n.notification_widget.info:active.focus,\n.notification_widget.info.active.focus,\n.open > .dropdown-toggle.notification_widget.info.focus {\n  color: #fff;\n  background-color: #269abc;\n  border-color: #1b6d85;\n}\n.notification_widget.info.disabled:hover,\n.notification_widget.info[disabled]:hover,\nfieldset[disabled] .notification_widget.info:hover,\n.notification_widget.info.disabled:focus,\n.notification_widget.info[disabled]:focus,\nfieldset[disabled] .notification_widget.info:focus,\n.notification_widget.info.disabled.focus,\n.notification_widget.info[disabled].focus,\nfieldset[disabled] .notification_widget.info.focus {\n  background-color: #5bc0de;\n  border-color: #46b8da;\n}\n.notification_widget.info .badge {\n  color: #5bc0de;\n  background-color: #fff;\n}\n.notification_widget.danger {\n  color: #fff;\n  background-color: #d9534f;\n  border-color: #d43f3a;\n  color: #ffffff;\n  background-color: #df0404;\n  border-color: #df0404;\n}\n.notification_widget.danger:focus,\n.notification_widget.danger.focus {\n  color: #fff;\n  background-color: #c9302c;\n  border-color: #761c19;\n}\n.notification_widget.danger:hover {\n  color: #fff;\n  background-color: #c9302c;\n  border-color: #ac2925;\n}\n.notification_widget.danger:active,\n.notification_widget.danger.active,\n.open > .dropdown-toggle.notification_widget.danger {\n  color: #fff;\n  background-color: #c9302c;\n  background-image: none;\n  border-color: #ac2925;\n}\n.notification_widget.danger:active:hover,\n.notification_widget.danger.active:hover,\n.open > .dropdown-toggle.notification_widget.danger:hover,\n.notification_widget.danger:active:focus,\n.notification_widget.danger.active:focus,\n.open > .dropdown-toggle.notification_widget.danger:focus,\n.notification_widget.danger:active.focus,\n.notification_widget.danger.active.focus,\n.open > .dropdown-toggle.notification_widget.danger.focus {\n  color: #fff;\n  background-color: #ac2925;\n  border-color: #761c19;\n}\n.notification_widget.danger.disabled:hover,\n.notification_widget.danger[disabled]:hover,\nfieldset[disabled] .notification_widget.danger:hover,\n.notification_widget.danger.disabled:focus,\n.notification_widget.danger[disabled]:focus,\nfieldset[disabled] .notification_widget.danger:focus,\n.notification_widget.danger.disabled.focus,\n.notification_widget.danger[disabled].focus,\nfieldset[disabled] .notification_widget.danger.focus {\n  background-color: #d9534f;\n  border-color: #d43f3a;\n}\n.notification_widget.danger .badge {\n  color: #d9534f;\n  background-color: #fff;\n}\ndiv#pager {\n  background-color: var(--body-bg);\n  font-size: 14px;\n  line-height: 20px;\n  overflow: hidden;\n  display: none;\n  position: fixed;\n  bottom: 0px;\n  width: 100%;\n  max-height: 50%;\n  padding-top: 8px;\n  -webkit-box-shadow: 0px 0px 12px 1px rgba(87, 87, 87, 0.2);\n  box-shadow: 0px 0px 12px 1px rgba(87, 87, 87, 0.2);\n  /* Display over codemirror */\n  z-index: 100;\n  /* Hack which prevents jquery ui resizable from changing top. */\n  top: auto !important;\n}\ndiv#pager pre {\n  line-height: 1.21429em;\n  color: black;\n  background-color: var(--body-bg-darken3pc);\n  padding: 0.4em;\n}\ndiv#pager #pager-button-area {\n  position: absolute;\n  top: 8px;\n  right: 20px;\n}\ndiv#pager #pager-button-area .ui-button {\n  padding-top: 0px;\n  padding-bottom: 0px;\n  padding-right: 10px;\n  padding-left: 10px;\n}\ndiv#pager #pager-contents {\n  position: relative;\n  overflow: auto;\n  width: 100%;\n  height: 100%;\n}\ndiv#pager #pager-contents #pager-container {\n  position: relative;\n  padding: 15px 0px;\n  box-sizing: border-box;\n  -moz-box-sizing: border-box;\n  -webkit-box-sizing: border-box;\n}\ndiv#pager .ui-resizable-handle {\n  top: 0px;\n  height: 8px;\n  background: var(--body-bg-darken3pc);\n  border-top: 1px solid var(--light-border-color);\n  border-bottom: 1px solid var(--light-border-color);\n  /* This injects handle bars (a short, wide = symbol) for \n        the resize handle. */\n}\ndiv#pager .ui-resizable-handle::after {\n  content: '';\n  top: 2px;\n  left: 50%;\n  height: 3px;\n  width: 30px;\n  margin-left: -15px;\n  position: absolute;\n  border-top: 1px solid var(--light-border-color);\n}\n.quickhelp {\n  /* Old browsers */\n  display: -webkit-box;\n  -webkit-box-orient: horizontal;\n  -webkit-box-align: stretch;\n  display: -moz-box;\n  -moz-box-orient: horizontal;\n  -moz-box-align: stretch;\n  display: box;\n  box-orient: horizontal;\n  box-align: stretch;\n  /* Modern browsers */\n  display: flex;\n  flex-direction: row;\n  align-items: stretch;\n  line-height: 1.8em;\n}\n.shortcut_key {\n  display: inline-block;\n  width: 21ex;\n  text-align: right;\n  font-family: monospace;\n}\n.shortcut_descr {\n  display: inline-block;\n  /* Old browsers */\n  -webkit-box-flex: 1;\n  -moz-box-flex: 1;\n  box-flex: 1;\n  /* Modern browsers */\n  flex: 1;\n}\nspan.save_widget {\n  height: 30px;\n  margin-top: 4px;\n  display: flex;\n  justify-content: center;\n  align-items: baseline;\n  width: 50%;\n  flex: 1;\n  max-width: 50%;\n}\nspan.save_widget span.filename {\n  height: 100%;\n  line-height: 1em;\n  margin-left: 16px;\n  border: none;\n  font-size: 146.5%;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n  border-radius: 2px;\n}\nspan.save_widget span.filename:hover {\n  background-color: var(--edit-hover-color);\n}\n[dir=\"rtl\"] span.save_widget.pull-left {\n  float: right !important;\n  float: right;\n}\n[dir=\"rtl\"] span.save_widget span.filename {\n  margin-left: 0;\n  margin-right: 16px;\n}\nspan.checkpoint_status,\nspan.autosave_status {\n  font-size: small;\n  white-space: nowrap;\n  padding: 0 5px;\n}\n@media (max-width: 767px) {\n  span.save_widget {\n    font-size: small;\n    padding: 0 0 0 5px;\n  }\n  span.checkpoint_status,\n  span.autosave_status {\n    display: none;\n  }\n}\n@media (min-width: 768px) and (max-width: 991px) {\n  span.checkpoint_status {\n    display: none;\n  }\n  span.autosave_status {\n    font-size: x-small;\n  }\n}\n.toolbar {\n  padding: 0px;\n  margin-left: -5px;\n  margin-top: 2px;\n  margin-bottom: 5px;\n  box-sizing: border-box;\n  -moz-box-sizing: border-box;\n  -webkit-box-sizing: border-box;\n}\n.toolbar select,\n.toolbar label {\n  width: auto;\n  vertical-align: middle;\n  margin-right: 2px;\n  margin-bottom: 0px;\n  display: inline;\n  font-size: 92%;\n  margin-left: 0.3em;\n  margin-right: 0.3em;\n  padding: 0px;\n  padding-top: 3px;\n}\n.toolbar .btn {\n  padding: 2px 8px;\n}\n.toolbar .btn-group {\n  margin-top: 0px;\n  margin-left: 5px;\n}\n.toolbar-btn-label {\n  margin-left: 6px;\n}\n#maintoolbar {\n  margin-bottom: -3px;\n  margin-top: -8px;\n  border: 0px;\n  min-height: 27px;\n  margin-left: 0px;\n  padding-top: 11px;\n  padding-bottom: 3px;\n}\n#maintoolbar .navbar-text {\n  float: none;\n  vertical-align: middle;\n  text-align: right;\n  margin-left: 5px;\n  margin-right: 0px;\n  margin-top: 0px;\n}\n.select-xs {\n  height: 24px;\n}\n[dir=\"rtl\"] .btn-group > .btn,\n.btn-group-vertical > .btn {\n  float: right;\n}\n.pulse,\n.dropdown-menu > li > a.pulse,\nli.pulse > a.dropdown-toggle,\nli.pulse.open > a.dropdown-toggle {\n  background-color: #F37626;\n  color: white;\n}\n/**\n * Primary styles\n *\n * Author: Jupyter Development Team\n */\n/** WARNING IF YOU ARE EDITTING THIS FILE, if this is a .css file, It has a lot\n * of chance of beeing generated from the ../less/[samename].less file, you can\n * try to get back the less file by reverting somme commit in history\n **/\n/*\n * We'll try to get something pretty, so we\n * have some strange css to have the scroll bar on\n * the left with fix button on the top right of the tooltip\n */\n@-moz-keyframes fadeOut {\n  from {\n    opacity: 1;\n  }\n  to {\n    opacity: 0;\n  }\n}\n@-webkit-keyframes fadeOut {\n  from {\n    opacity: 1;\n  }\n  to {\n    opacity: 0;\n  }\n}\n@-moz-keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n@-webkit-keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n/*properties of tooltip after \"expand\"*/\n.bigtooltip {\n  overflow: auto;\n  height: 200px;\n}\n/*properties of tooltip before \"expand\"*/\n.smalltooltip {\n  text-overflow: ellipsis;\n  overflow: hidden;\n  height: 85px;\n}\n.tooltipbuttons {\n  position: absolute;\n  padding-right: 15px;\n  top: 0px;\n  right: 0px;\n}\n.tooltipbuttons .ui-button {\n  padding-top: 0px;\n  padding-bottom: 0px;\n  padding-right: 10px;\n  padding-left: 10px;\n}\n.tooltiptext {\n  /*avoid the button to overlap on some docstring*/\n  padding-right: 30px;\n  /*avoid the ui-icon(s) from overlapping the tooltip*/\n  padding-top: 5px;\n}\n.ipython_tooltip {\n  max-width: 700px;\n  /*fade-in animation when inserted*/\n  -webkit-animation: fadeOut 400ms;\n  -moz-animation: fadeOut 400ms;\n  animation: fadeOut 400ms;\n  -webkit-animation: fadeIn 400ms;\n  -moz-animation: fadeIn 400ms;\n  animation: fadeIn 400ms;\n  vertical-align: middle;\n  background-color: var(--body-bg-darken3pc);\n  overflow: visible;\n  border: var(--border-color) 1px solid;\n  outline: none;\n  padding: 3px;\n  margin: 0px;\n  padding-left: 7px;\n  font-family: monospace;\n  min-height: 50px;\n  -moz-box-shadow: 0px 6px 10px -1px #adadad;\n  -webkit-box-shadow: 0px 6px 10px -1px #adadad;\n  box-shadow: 0px 6px 10px -1px #adadad;\n  border-radius: 2px;\n  position: absolute;\n  z-index: 1000;\n}\n.ipython_tooltip a {\n  float: right;\n}\n.ipython_tooltip .tooltiptext pre {\n  border: 0;\n  border-radius: 0;\n  font-size: 100%;\n  background-color: var(--body-bg-darken3pc);\n}\n.pretooltiparrow {\n  left: 0px;\n  margin: 0px;\n  top: -16px;\n  width: 40px;\n  height: 16px;\n  overflow: hidden;\n  position: absolute;\n}\n.pretooltiparrow:before {\n  background-color: var(--body-bg-darken3pc);\n  border: 1px var(--border-color) solid;\n  z-index: 11;\n  content: \"\";\n  position: absolute;\n  left: 15px;\n  top: 10px;\n  width: 25px;\n  height: 25px;\n  -webkit-transform: rotate(45deg);\n  -moz-transform: rotate(45deg);\n  -ms-transform: rotate(45deg);\n  -o-transform: rotate(45deg);\n}\ndiv.typeahead__container {\n  font: revert;\n}\nul.typeahead__list i {\n  width: 18px;\n}\nul.typeahead__list {\n  max-height: 80vh;\n  overflow: auto;\n}\nul.typeahead__list > li > a {\n  /** Firefox bug **/\n  /* see https://github.com/jupyter/notebook/issues/559 */\n  white-space: normal;\n}\nul.typeahead__list  > li > a.pull-right {\n  float: left !important;\n  float: left;\n}\n[dir=\"rtl\"] .typeahead__list {\n  text-align: right;\n}\n.cmd-palette .modal-body {\n  padding: 7px;\n}\n.cmd-palette form {\n  background: white;\n}\n.cmd-palette input {\n  outline: none;\n}\n.no-shortcut {\n  min-width: 20px;\n  color: transparent;\n}\n[dir=\"rtl\"] .no-shortcut.pull-right {\n  float: left !important;\n  float: left;\n}\n[dir=\"rtl\"] .command-shortcut.pull-right {\n  float: left !important;\n  float: left;\n}\n.command-shortcut:before {\n  content: \"(command mode)\";\n  padding-right: 3px;\n  color: #777777;\n}\n.edit-shortcut:before {\n  content: \"(edit)\";\n  padding-right: 3px;\n  color: #777777;\n}\n[dir=\"rtl\"] .edit-shortcut.pull-right {\n  float: left !important;\n  float: left;\n}\n#find-and-replace #replace-preview .match,\n#find-and-replace #replace-preview .insert {\n  background-color: #BBDEFB;\n  border-color: #90CAF9;\n  border-style: solid;\n  border-width: 1px;\n  border-radius: 0px;\n}\n[dir=\"ltr\"] #find-and-replace .input-group-btn + .form-control {\n  border-left: none;\n}\n[dir=\"rtl\"] #find-and-replace .input-group-btn + .form-control {\n  border-right: none;\n}\n#find-and-replace #replace-preview .replace .match {\n  background-color: #FFCDD2;\n  border-color: #EF9A9A;\n  border-radius: 0px;\n}\n#find-and-replace #replace-preview .replace .insert {\n  background-color: #C8E6C9;\n  border-color: #A5D6A7;\n  border-radius: 0px;\n}\n#find-and-replace #replace-preview {\n  max-height: 60vh;\n  overflow: auto;\n}\n#find-and-replace #replace-preview pre {\n  padding: 5px 10px;\n}\n.btn-danger {\n  color: #ffffff;\n  background-color: #df0404;\n  border-color: #df0404;\n}\n.btn-warning {\n  color: #ffffff;\n  background-color: #b46102;\n  border-color: #b46102;\n}\n.close {\n  float: right;\n  font-size: 19.5px;\n  font-weight: bold;\n  line-height: 1;\n  color: #000;\n  text-shadow: 0 1px 0 #fff;\n  filter: alpha(opacity=60);\n  opacity: 0.6;\n}\n.close:hover,\n.close:focus {\n  color: #000;\n  text-decoration: none;\n  cursor: pointer;\n  filter: alpha(opacity=100);\n  opacity: 1;\n}\nbutton.close {\n  padding: 0;\n  cursor: pointer;\n  background: transparent;\n  border: 0;\n  -webkit-appearance: none;\n  appearance: none;\n}\n.navbar-nav > li > a {\n  color: #565656;\n}\n.navbar-nav > li > a:focus {\n  /* -webkit-focus-ring-color = '#5B9DD9' */\n  outline: -webkit-focus-ring-color auto 5px;\n}\n.basthon-loader-root {\n  background-color: var(--header-bg);\n  box-shadow: 0px 0px 12px 1px rgba(87, 87, 87, 0.2);\n}\n.basthon-loader-spinner.basthon-loader-foot {\n  box-sizing: unset;\n}\n.basthon-loader-text.basthon-loader-foot {\n  font-size: 14px;\n  color: var(--text-color);\n}\n.basthon-dynamic-iframe {\n  max-width: 100%;\n  display: block;\n}\n","// stylelint-disable\n\n/*! normalize.css v3.0.3 | MIT License | github.com/necolas/normalize.css */\n\n//\n// 1. Set default font family to sans-serif.\n// 2. Prevent iOS and IE text size adjust after device orientation change,\n//    without disabling user zoom.\n//\n\nhtml {\n  font-family: sans-serif; // 1\n  -ms-text-size-adjust: 100%; // 2\n  -webkit-text-size-adjust: 100%; // 2\n}\n\n//\n// Remove default margin.\n//\n\nbody {\n  margin: 0;\n}\n\n// HTML5 display definitions\n// ==========================================================================\n\n//\n// Correct `block` display not defined for any HTML5 element in IE 8/9.\n// Correct `block` display not defined for `details` or `summary` in IE 10/11\n// and Firefox.\n// Correct `block` display not defined for `main` in IE 11.\n//\n\narticle,\naside,\ndetails,\nfigcaption,\nfigure,\nfooter,\nheader,\nhgroup,\nmain,\nmenu,\nnav,\nsection,\nsummary {\n  display: block;\n}\n\n//\n// 1. Correct `inline-block` display not defined in IE 8/9.\n// 2. Normalize vertical alignment of `progress` in Chrome, Firefox, and Opera.\n//\n\naudio,\ncanvas,\nprogress,\nvideo {\n  display: inline-block; // 1\n  vertical-align: baseline; // 2\n}\n\n//\n// Prevent modern browsers from displaying `audio` without controls.\n// Remove excess height in iOS 5 devices.\n//\n\naudio:not([controls]) {\n  display: none;\n  height: 0;\n}\n\n//\n// Address `[hidden]` styling not present in IE 8/9/10.\n// Hide the `template` element in IE 8/9/10/11, Safari, and Firefox < 22.\n//\n\n[hidden],\ntemplate {\n  display: none;\n}\n\n// Links\n// ==========================================================================\n\n//\n// Remove the gray background color from active links in IE 10.\n//\n\na {\n  background-color: transparent;\n}\n\n//\n// Improve readability of focused elements when they are also in an\n// active/hover state.\n//\n\na:active,\na:hover {\n  outline: 0;\n}\n\n// Text-level semantics\n// ==========================================================================\n\n//\n// 1. Remove the bottom border in Chrome 57- and Firefox 39-.\n// 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.\n//\n\nabbr[title] {\n  border-bottom: none; // 1\n  text-decoration: underline; // 2\n  text-decoration: underline dotted; // 2\n}\n\n//\n// Address style set to `bolder` in Firefox 4+, Safari, and Chrome.\n//\n\nb,\nstrong {\n  font-weight: bold;\n}\n\n//\n// Address styling not present in Safari and Chrome.\n//\n\ndfn {\n  font-style: italic;\n}\n\n//\n// Address variable `h1` font-size and margin within `section` and `article`\n// contexts in Firefox 4+, Safari, and Chrome.\n//\n\nh1 {\n  font-size: 2em;\n  margin: 0.67em 0;\n}\n\n//\n// Address styling not present in IE 8/9.\n//\n\nmark {\n  background: #ff0;\n  color: #000;\n}\n\n//\n// Address inconsistent and variable font size in all browsers.\n//\n\nsmall {\n  font-size: 80%;\n}\n\n//\n// Prevent `sub` and `sup` affecting `line-height` in all browsers.\n//\n\nsub,\nsup {\n  font-size: 75%;\n  line-height: 0;\n  position: relative;\n  vertical-align: baseline;\n}\n\nsup {\n  top: -0.5em;\n}\n\nsub {\n  bottom: -0.25em;\n}\n\n// Embedded content\n// ==========================================================================\n\n//\n// Remove border when inside `a` element in IE 8/9/10.\n//\n\nimg {\n  border: 0;\n}\n\n//\n// Correct overflow not hidden in IE 9/10/11.\n//\n\nsvg:not(:root) {\n  overflow: hidden;\n}\n\n// Grouping content\n// ==========================================================================\n\n//\n// Address margin not present in IE 8/9 and Safari.\n//\n\nfigure {\n  margin: 1em 40px;\n}\n\n//\n// Address differences between Firefox and other browsers.\n//\n\nhr {\n  box-sizing: content-box;\n  height: 0;\n}\n\n//\n// Contain overflow in all browsers.\n//\n\npre {\n  overflow: auto;\n}\n\n//\n// Address odd `em`-unit font size rendering in all browsers.\n//\n\ncode,\nkbd,\npre,\nsamp {\n  font-family: monospace, monospace;\n  font-size: 1em;\n}\n\n// Forms\n// ==========================================================================\n\n//\n// Known limitation: by default, Chrome and Safari on OS X allow very limited\n// styling of `select`, unless a `border` property is set.\n//\n\n//\n// 1. Correct color not being inherited.\n//    Known issue: affects color of disabled elements.\n// 2. Correct font properties not being inherited.\n// 3. Address margins set differently in Firefox 4+, Safari, and Chrome.\n//\n\nbutton,\ninput,\noptgroup,\nselect,\ntextarea {\n  color: inherit; // 1\n  font: inherit; // 2\n  margin: 0; // 3\n}\n\n//\n// Address `overflow` set to `hidden` in IE 8/9/10/11.\n//\n\nbutton {\n  overflow: visible;\n}\n\n//\n// Address inconsistent `text-transform` inheritance for `button` and `select`.\n// All other form control elements do not inherit `text-transform` values.\n// Correct `button` style inheritance in Firefox, IE 8/9/10/11, and Opera.\n// Correct `select` style inheritance in Firefox.\n//\n\nbutton,\nselect {\n  text-transform: none;\n}\n\n//\n// 1. Avoid the WebKit bug in Android 4.0.* where (2) destroys native `audio`\n//    and `video` controls.\n// 2. Correct inability to style clickable `input` types in iOS.\n// 3. Improve usability and consistency of cursor style between image-type\n//    `input` and others.\n//\n\nbutton,\nhtml input[type=\"button\"], // 1\ninput[type=\"reset\"],\ninput[type=\"submit\"] {\n  -webkit-appearance: button; // 2\n  cursor: pointer; // 3\n}\n\n//\n// Re-set default cursor for disabled elements.\n//\n\nbutton[disabled],\nhtml input[disabled] {\n  cursor: default;\n}\n\n//\n// Remove inner padding and border in Firefox 4+.\n//\n\nbutton::-moz-focus-inner,\ninput::-moz-focus-inner {\n  border: 0;\n  padding: 0;\n}\n\n//\n// Address Firefox 4+ setting `line-height` on `input` using `!important` in\n// the UA stylesheet.\n//\n\ninput {\n  line-height: normal;\n}\n\n//\n// It's recommended that you don't attempt to style these elements.\n// Firefox's implementation doesn't respect box-sizing, padding, or width.\n//\n// 1. Address box sizing set to `content-box` in IE 8/9/10.\n// 2. Remove excess padding in IE 8/9/10.\n//\n\ninput[type=\"checkbox\"],\ninput[type=\"radio\"] {\n  box-sizing: border-box; // 1\n  padding: 0; // 2\n}\n\n//\n// Fix the cursor style for Chrome's increment/decrement buttons. For certain\n// `font-size` values of the `input`, it causes the cursor style of the\n// decrement button to change from `default` to `text`.\n//\n\ninput[type=\"number\"]::-webkit-inner-spin-button,\ninput[type=\"number\"]::-webkit-outer-spin-button {\n  height: auto;\n}\n\n//\n// 1. Address `appearance` set to `searchfield` in Safari and Chrome.\n// 2. Address `box-sizing` set to `border-box` in Safari and Chrome.\n//\n\ninput[type=\"search\"] {\n  -webkit-appearance: textfield; // 1\n  box-sizing: content-box; //2\n}\n\n//\n// Remove inner padding and search cancel button in Safari and Chrome on OS X.\n// Safari (but not Chrome) clips the cancel button when the search input has\n// padding (and `textfield` appearance).\n//\n\ninput[type=\"search\"]::-webkit-search-cancel-button,\ninput[type=\"search\"]::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n//\n// Define consistent border, margin, and padding.\n//\n\nfieldset {\n  border: 1px solid #c0c0c0;\n  margin: 0 2px;\n  padding: 0.35em 0.625em 0.75em;\n}\n\n//\n// 1. Correct `color` not being inherited in IE 8/9/10/11.\n// 2. Remove padding so people aren't caught out if they zero out fieldsets.\n//\n\nlegend {\n  border: 0; // 1\n  padding: 0; // 2\n}\n\n//\n// Remove default vertical scrollbar in IE 8/9/10/11.\n//\n\ntextarea {\n  overflow: auto;\n}\n\n//\n// Don't inherit the `font-weight` (applied by a rule above).\n// NOTE: the default cannot safely be changed in Chrome and Safari on OS X.\n//\n\noptgroup {\n  font-weight: bold;\n}\n\n// Tables\n// ==========================================================================\n\n//\n// Remove most spacing between table cells.\n//\n\ntable {\n  border-collapse: collapse;\n  border-spacing: 0;\n}\n\ntd,\nth {\n  padding: 0;\n}\n","// stylelint-disable declaration-no-important, selector-no-qualifying-type\n\n/*! Source: https://github.com/h5bp/html5-boilerplate/blob/master/src/css/main.css */\n\n// ==========================================================================\n// Print styles.\n// Inlined to avoid the additional HTTP request: h5bp.com/r\n// ==========================================================================\n\n@media print {\n  *,\n  *:before,\n  *:after {\n    color: #000 !important; // Black prints faster: h5bp.com/s\n    text-shadow: none !important;\n    background: transparent !important;\n    box-shadow: none !important;\n  }\n\n  a,\n  a:visited {\n    text-decoration: underline;\n  }\n\n  a[href]:after {\n    content: \" (\" attr(href) \")\";\n  }\n\n  abbr[title]:after {\n    content: \" (\" attr(title) \")\";\n  }\n\n  // Don't show links that are fragment identifiers,\n  // or use the `javascript:` pseudo protocol\n  a[href^=\"#\"]:after,\n  a[href^=\"javascript:\"]:after {\n    content: \"\";\n  }\n\n  pre,\n  blockquote {\n    border: 1px solid #999;\n    page-break-inside: avoid;\n  }\n\n  thead {\n    display: table-header-group; // h5bp.com/t\n  }\n\n  tr,\n  img {\n    page-break-inside: avoid;\n  }\n\n  img {\n    max-width: 100% !important;\n  }\n\n  p,\n  h2,\n  h3 {\n    orphans: 3;\n    widows: 3;\n  }\n\n  h2,\n  h3 {\n    page-break-after: avoid;\n  }\n\n  // Bootstrap specific changes start\n\n  // Bootstrap components\n  .navbar {\n    display: none;\n  }\n  .btn,\n  .dropup > .btn {\n    > .caret {\n      border-top-color: #000 !important;\n    }\n  }\n  .label {\n    border: 1px solid #000;\n  }\n\n  .table {\n    border-collapse: collapse !important;\n\n    td,\n    th {\n      background-color: #fff !important;\n    }\n  }\n  .table-bordered {\n    th,\n    td {\n      border: 1px solid #ddd !important;\n    }\n  }\n}\n","// stylelint-disable value-list-comma-newline-after, value-list-comma-space-after, indentation, declaration-colon-newline-after, font-family-no-missing-generic-family-keyword\n\n//\n// Glyphicons for Bootstrap\n//\n// Since icons are fonts, they can be placed anywhere text is placed and are\n// thus automatically sized to match the surrounding child. To use, create an\n// inline element with the appropriate classes, like so:\n//\n// <a href=\"#\"><span class=\"glyphicon glyphicon-star\"></span> Star</a>\n\n// Import the fonts\n@font-face {\n  font-family: \"Glyphicons Halflings\";\n  src: url(\"@{icon-font-path}@{icon-font-name}.eot\");\n  src: url(\"@{icon-font-path}@{icon-font-name}.eot?#iefix\") format(\"embedded-opentype\"),\n       url(\"@{icon-font-path}@{icon-font-name}.woff2\") format(\"woff2\"),\n       url(\"@{icon-font-path}@{icon-font-name}.woff\") format(\"woff\"),\n       url(\"@{icon-font-path}@{icon-font-name}.ttf\") format(\"truetype\"),\n       url(\"@{icon-font-path}@{icon-font-name}.svg#@{icon-font-svg-id}\") format(\"svg\");\n}\n\n// Catchall baseclass\n.glyphicon {\n  position: relative;\n  top: 1px;\n  display: inline-block;\n  font-family: \"Glyphicons Halflings\";\n  font-style: normal;\n  font-weight: 400;\n  line-height: 1;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n// Individual icons\n.glyphicon-asterisk               { &:before { content: \"\\002a\"; } }\n.glyphicon-plus                   { &:before { content: \"\\002b\"; } }\n.glyphicon-euro,\n.glyphicon-eur                    { &:before { content: \"\\20ac\"; } }\n.glyphicon-minus                  { &:before { content: \"\\2212\"; } }\n.glyphicon-cloud                  { &:before { content: \"\\2601\"; } }\n.glyphicon-envelope               { &:before { content: \"\\2709\"; } }\n.glyphicon-pencil                 { &:before { content: \"\\270f\"; } }\n.glyphicon-glass                  { &:before { content: \"\\e001\"; } }\n.glyphicon-music                  { &:before { content: \"\\e002\"; } }\n.glyphicon-search                 { &:before { content: \"\\e003\"; } }\n.glyphicon-heart                  { &:before { content: \"\\e005\"; } }\n.glyphicon-star                   { &:before { content: \"\\e006\"; } }\n.glyphicon-star-empty             { &:before { content: \"\\e007\"; } }\n.glyphicon-user                   { &:before { content: \"\\e008\"; } }\n.glyphicon-film                   { &:before { content: \"\\e009\"; } }\n.glyphicon-th-large               { &:before { content: \"\\e010\"; } }\n.glyphicon-th                     { &:before { content: \"\\e011\"; } }\n.glyphicon-th-list                { &:before { content: \"\\e012\"; } }\n.glyphicon-ok                     { &:before { content: \"\\e013\"; } }\n.glyphicon-remove                 { &:before { content: \"\\e014\"; } }\n.glyphicon-zoom-in                { &:before { content: \"\\e015\"; } }\n.glyphicon-zoom-out               { &:before { content: \"\\e016\"; } }\n.glyphicon-off                    { &:before { content: \"\\e017\"; } }\n.glyphicon-signal                 { &:before { content: \"\\e018\"; } }\n.glyphicon-cog                    { &:before { content: \"\\e019\"; } }\n.glyphicon-trash                  { &:before { content: \"\\e020\"; } }\n.glyphicon-home                   { &:before { content: \"\\e021\"; } }\n.glyphicon-file                   { &:before { content: \"\\e022\"; } }\n.glyphicon-time                   { &:before { content: \"\\e023\"; } }\n.glyphicon-road                   { &:before { content: \"\\e024\"; } }\n.glyphicon-download-alt           { &:before { content: \"\\e025\"; } }\n.glyphicon-download               { &:before { content: \"\\e026\"; } }\n.glyphicon-upload                 { &:before { content: \"\\e027\"; } }\n.glyphicon-inbox                  { &:before { content: \"\\e028\"; } }\n.glyphicon-play-circle            { &:before { content: \"\\e029\"; } }\n.glyphicon-repeat                 { &:before { content: \"\\e030\"; } }\n.glyphicon-refresh                { &:before { content: \"\\e031\"; } }\n.glyphicon-list-alt               { &:before { content: \"\\e032\"; } }\n.glyphicon-lock                   { &:before { content: \"\\e033\"; } }\n.glyphicon-flag                   { &:before { content: \"\\e034\"; } }\n.glyphicon-headphones             { &:before { content: \"\\e035\"; } }\n.glyphicon-volume-off             { &:before { content: \"\\e036\"; } }\n.glyphicon-volume-down            { &:before { content: \"\\e037\"; } }\n.glyphicon-volume-up              { &:before { content: \"\\e038\"; } }\n.glyphicon-qrcode                 { &:before { content: \"\\e039\"; } }\n.glyphicon-barcode                { &:before { content: \"\\e040\"; } }\n.glyphicon-tag                    { &:before { content: \"\\e041\"; } }\n.glyphicon-tags                   { &:before { content: \"\\e042\"; } }\n.glyphicon-book                   { &:before { content: \"\\e043\"; } }\n.glyphicon-bookmark               { &:before { content: \"\\e044\"; } }\n.glyphicon-print                  { &:before { content: \"\\e045\"; } }\n.glyphicon-camera                 { &:before { content: \"\\e046\"; } }\n.glyphicon-font                   { &:before { content: \"\\e047\"; } }\n.glyphicon-bold                   { &:before { content: \"\\e048\"; } }\n.glyphicon-italic                 { &:before { content: \"\\e049\"; } }\n.glyphicon-text-height            { &:before { content: \"\\e050\"; } }\n.glyphicon-text-width             { &:before { content: \"\\e051\"; } }\n.glyphicon-align-left             { &:before { content: \"\\e052\"; } }\n.glyphicon-align-center           { &:before { content: \"\\e053\"; } }\n.glyphicon-align-right            { &:before { content: \"\\e054\"; } }\n.glyphicon-align-justify          { &:before { content: \"\\e055\"; } }\n.glyphicon-list                   { &:before { content: \"\\e056\"; } }\n.glyphicon-indent-left            { &:before { content: \"\\e057\"; } }\n.glyphicon-indent-right           { &:before { content: \"\\e058\"; } }\n.glyphicon-facetime-video         { &:before { content: \"\\e059\"; } }\n.glyphicon-picture                { &:before { content: \"\\e060\"; } }\n.glyphicon-map-marker             { &:before { content: \"\\e062\"; } }\n.glyphicon-adjust                 { &:before { content: \"\\e063\"; } }\n.glyphicon-tint                   { &:before { content: \"\\e064\"; } }\n.glyphicon-edit                   { &:before { content: \"\\e065\"; } }\n.glyphicon-share                  { &:before { content: \"\\e066\"; } }\n.glyphicon-check                  { &:before { content: \"\\e067\"; } }\n.glyphicon-move                   { &:before { content: \"\\e068\"; } }\n.glyphicon-step-backward          { &:before { content: \"\\e069\"; } }\n.glyphicon-fast-backward          { &:before { content: \"\\e070\"; } }\n.glyphicon-backward               { &:before { content: \"\\e071\"; } }\n.glyphicon-play                   { &:before { content: \"\\e072\"; } }\n.glyphicon-pause                  { &:before { content: \"\\e073\"; } }\n.glyphicon-stop                   { &:before { content: \"\\e074\"; } }\n.glyphicon-forward                { &:before { content: \"\\e075\"; } }\n.glyphicon-fast-forward           { &:before { content: \"\\e076\"; } }\n.glyphicon-step-forward           { &:before { content: \"\\e077\"; } }\n.glyphicon-eject                  { &:before { content: \"\\e078\"; } }\n.glyphicon-chevron-left           { &:before { content: \"\\e079\"; } }\n.glyphicon-chevron-right          { &:before { content: \"\\e080\"; } }\n.glyphicon-plus-sign              { &:before { content: \"\\e081\"; } }\n.glyphicon-minus-sign             { &:before { content: \"\\e082\"; } }\n.glyphicon-remove-sign            { &:before { content: \"\\e083\"; } }\n.glyphicon-ok-sign                { &:before { content: \"\\e084\"; } }\n.glyphicon-question-sign          { &:before { content: \"\\e085\"; } }\n.glyphicon-info-sign              { &:before { content: \"\\e086\"; } }\n.glyphicon-screenshot             { &:before { content: \"\\e087\"; } }\n.glyphicon-remove-circle          { &:before { content: \"\\e088\"; } }\n.glyphicon-ok-circle              { &:before { content: \"\\e089\"; } }\n.glyphicon-ban-circle             { &:before { content: \"\\e090\"; } }\n.glyphicon-arrow-left             { &:before { content: \"\\e091\"; } }\n.glyphicon-arrow-right            { &:before { content: \"\\e092\"; } }\n.glyphicon-arrow-up               { &:before { content: \"\\e093\"; } }\n.glyphicon-arrow-down             { &:before { content: \"\\e094\"; } }\n.glyphicon-share-alt              { &:before { content: \"\\e095\"; } }\n.glyphicon-resize-full            { &:before { content: \"\\e096\"; } }\n.glyphicon-resize-small           { &:before { content: \"\\e097\"; } }\n.glyphicon-exclamation-sign       { &:before { content: \"\\e101\"; } }\n.glyphicon-gift                   { &:before { content: \"\\e102\"; } }\n.glyphicon-leaf                   { &:before { content: \"\\e103\"; } }\n.glyphicon-fire                   { &:before { content: \"\\e104\"; } }\n.glyphicon-eye-open               { &:before { content: \"\\e105\"; } }\n.glyphicon-eye-close              { &:before { content: \"\\e106\"; } }\n.glyphicon-warning-sign           { &:before { content: \"\\e107\"; } }\n.glyphicon-plane                  { &:before { content: \"\\e108\"; } }\n.glyphicon-calendar               { &:before { content: \"\\e109\"; } }\n.glyphicon-random                 { &:before { content: \"\\e110\"; } }\n.glyphicon-comment                { &:before { content: \"\\e111\"; } }\n.glyphicon-magnet                 { &:before { content: \"\\e112\"; } }\n.glyphicon-chevron-up             { &:before { content: \"\\e113\"; } }\n.glyphicon-chevron-down           { &:before { content: \"\\e114\"; } }\n.glyphicon-retweet                { &:before { content: \"\\e115\"; } }\n.glyphicon-shopping-cart          { &:before { content: \"\\e116\"; } }\n.glyphicon-folder-close           { &:before { content: \"\\e117\"; } }\n.glyphicon-folder-open            { &:before { content: \"\\e118\"; } }\n.glyphicon-resize-vertical        { &:before { content: \"\\e119\"; } }\n.glyphicon-resize-horizontal      { &:before { content: \"\\e120\"; } }\n.glyphicon-hdd                    { &:before { content: \"\\e121\"; } }\n.glyphicon-bullhorn               { &:before { content: \"\\e122\"; } }\n.glyphicon-bell                   { &:before { content: \"\\e123\"; } }\n.glyphicon-certificate            { &:before { content: \"\\e124\"; } }\n.glyphicon-thumbs-up              { &:before { content: \"\\e125\"; } }\n.glyphicon-thumbs-down            { &:before { content: \"\\e126\"; } }\n.glyphicon-hand-right             { &:before { content: \"\\e127\"; } }\n.glyphicon-hand-left              { &:before { content: \"\\e128\"; } }\n.glyphicon-hand-up                { &:before { content: \"\\e129\"; } }\n.glyphicon-hand-down              { &:before { content: \"\\e130\"; } }\n.glyphicon-circle-arrow-right     { &:before { content: \"\\e131\"; } }\n.glyphicon-circle-arrow-left      { &:before { content: \"\\e132\"; } }\n.glyphicon-circle-arrow-up        { &:before { content: \"\\e133\"; } }\n.glyphicon-circle-arrow-down      { &:before { content: \"\\e134\"; } }\n.glyphicon-globe                  { &:before { content: \"\\e135\"; } }\n.glyphicon-wrench                 { &:before { content: \"\\e136\"; } }\n.glyphicon-tasks                  { &:before { content: \"\\e137\"; } }\n.glyphicon-filter                 { &:before { content: \"\\e138\"; } }\n.glyphicon-briefcase              { &:before { content: \"\\e139\"; } }\n.glyphicon-fullscreen             { &:before { content: \"\\e140\"; } }\n.glyphicon-dashboard              { &:before { content: \"\\e141\"; } }\n.glyphicon-paperclip              { &:before { content: \"\\e142\"; } }\n.glyphicon-heart-empty            { &:before { content: \"\\e143\"; } }\n.glyphicon-link                   { &:before { content: \"\\e144\"; } }\n.glyphicon-phone                  { &:before { content: \"\\e145\"; } }\n.glyphicon-pushpin                { &:before { content: \"\\e146\"; } }\n.glyphicon-usd                    { &:before { content: \"\\e148\"; } }\n.glyphicon-gbp                    { &:before { content: \"\\e149\"; } }\n.glyphicon-sort                   { &:before { content: \"\\e150\"; } }\n.glyphicon-sort-by-alphabet       { &:before { content: \"\\e151\"; } }\n.glyphicon-sort-by-alphabet-alt   { &:before { content: \"\\e152\"; } }\n.glyphicon-sort-by-order          { &:before { content: \"\\e153\"; } }\n.glyphicon-sort-by-order-alt      { &:before { content: \"\\e154\"; } }\n.glyphicon-sort-by-attributes     { &:before { content: \"\\e155\"; } }\n.glyphicon-sort-by-attributes-alt { &:before { content: \"\\e156\"; } }\n.glyphicon-unchecked              { &:before { content: \"\\e157\"; } }\n.glyphicon-expand                 { &:before { content: \"\\e158\"; } }\n.glyphicon-collapse-down          { &:before { content: \"\\e159\"; } }\n.glyphicon-collapse-up            { &:before { content: \"\\e160\"; } }\n.glyphicon-log-in                 { &:before { content: \"\\e161\"; } }\n.glyphicon-flash                  { &:before { content: \"\\e162\"; } }\n.glyphicon-log-out                { &:before { content: \"\\e163\"; } }\n.glyphicon-new-window             { &:before { content: \"\\e164\"; } }\n.glyphicon-record                 { &:before { content: \"\\e165\"; } }\n.glyphicon-save                   { &:before { content: \"\\e166\"; } }\n.glyphicon-open                   { &:before { content: \"\\e167\"; } }\n.glyphicon-saved                  { &:before { content: \"\\e168\"; } }\n.glyphicon-import                 { &:before { content: \"\\e169\"; } }\n.glyphicon-export                 { &:before { content: \"\\e170\"; } }\n.glyphicon-send                   { &:before { content: \"\\e171\"; } }\n.glyphicon-floppy-disk            { &:before { content: \"\\e172\"; } }\n.glyphicon-floppy-saved           { &:before { content: \"\\e173\"; } }\n.glyphicon-floppy-remove          { &:before { content: \"\\e174\"; } }\n.glyphicon-floppy-save            { &:before { content: \"\\e175\"; } }\n.glyphicon-floppy-open            { &:before { content: \"\\e176\"; } }\n.glyphicon-credit-card            { &:before { content: \"\\e177\"; } }\n.glyphicon-transfer               { &:before { content: \"\\e178\"; } }\n.glyphicon-cutlery                { &:before { content: \"\\e179\"; } }\n.glyphicon-header                 { &:before { content: \"\\e180\"; } }\n.glyphicon-compressed             { &:before { content: \"\\e181\"; } }\n.glyphicon-earphone               { &:before { content: \"\\e182\"; } }\n.glyphicon-phone-alt              { &:before { content: \"\\e183\"; } }\n.glyphicon-tower                  { &:before { content: \"\\e184\"; } }\n.glyphicon-stats                  { &:before { content: \"\\e185\"; } }\n.glyphicon-sd-video               { &:before { content: \"\\e186\"; } }\n.glyphicon-hd-video               { &:before { content: \"\\e187\"; } }\n.glyphicon-subtitles              { &:before { content: \"\\e188\"; } }\n.glyphicon-sound-stereo           { &:before { content: \"\\e189\"; } }\n.glyphicon-sound-dolby            { &:before { content: \"\\e190\"; } }\n.glyphicon-sound-5-1              { &:before { content: \"\\e191\"; } }\n.glyphicon-sound-6-1              { &:before { content: \"\\e192\"; } }\n.glyphicon-sound-7-1              { &:before { content: \"\\e193\"; } }\n.glyphicon-copyright-mark         { &:before { content: \"\\e194\"; } }\n.glyphicon-registration-mark      { &:before { content: \"\\e195\"; } }\n.glyphicon-cloud-download         { &:before { content: \"\\e197\"; } }\n.glyphicon-cloud-upload           { &:before { content: \"\\e198\"; } }\n.glyphicon-tree-conifer           { &:before { content: \"\\e199\"; } }\n.glyphicon-tree-deciduous         { &:before { content: \"\\e200\"; } }\n.glyphicon-cd                     { &:before { content: \"\\e201\"; } }\n.glyphicon-save-file              { &:before { content: \"\\e202\"; } }\n.glyphicon-open-file              { &:before { content: \"\\e203\"; } }\n.glyphicon-level-up               { &:before { content: \"\\e204\"; } }\n.glyphicon-copy                   { &:before { content: \"\\e205\"; } }\n.glyphicon-paste                  { &:before { content: \"\\e206\"; } }\n// The following 2 Glyphicons are omitted for the time being because\n// they currently use Unicode codepoints that are outside the\n// Basic Multilingual Plane (BMP). Older buggy versions of WebKit can't handle\n// non-BMP codepoints in CSS string escapes, and thus can't display these two icons.\n// Notably, the bug affects some older versions of the Android Browser.\n// More info: https://github.com/twbs/bootstrap/issues/10106\n// .glyphicon-door                   { &:before { content: \"\\1f6aa\"; } }\n// .glyphicon-key                    { &:before { content: \"\\1f511\"; } }\n.glyphicon-alert                  { &:before { content: \"\\e209\"; } }\n.glyphicon-equalizer              { &:before { content: \"\\e210\"; } }\n.glyphicon-king                   { &:before { content: \"\\e211\"; } }\n.glyphicon-queen                  { &:before { content: \"\\e212\"; } }\n.glyphicon-pawn                   { &:before { content: \"\\e213\"; } }\n.glyphicon-bishop                 { &:before { content: \"\\e214\"; } }\n.glyphicon-knight                 { &:before { content: \"\\e215\"; } }\n.glyphicon-baby-formula           { &:before { content: \"\\e216\"; } }\n.glyphicon-tent                   { &:before { content: \"\\26fa\"; } }\n.glyphicon-blackboard             { &:before { content: \"\\e218\"; } }\n.glyphicon-bed                    { &:before { content: \"\\e219\"; } }\n.glyphicon-apple                  { &:before { content: \"\\f8ff\"; } }\n.glyphicon-erase                  { &:before { content: \"\\e221\"; } }\n.glyphicon-hourglass              { &:before { content: \"\\231b\"; } }\n.glyphicon-lamp                   { &:before { content: \"\\e223\"; } }\n.glyphicon-duplicate              { &:before { content: \"\\e224\"; } }\n.glyphicon-piggy-bank             { &:before { content: \"\\e225\"; } }\n.glyphicon-scissors               { &:before { content: \"\\e226\"; } }\n.glyphicon-bitcoin                { &:before { content: \"\\e227\"; } }\n.glyphicon-btc                    { &:before { content: \"\\e227\"; } }\n.glyphicon-xbt                    { &:before { content: \"\\e227\"; } }\n.glyphicon-yen                    { &:before { content: \"\\00a5\"; } }\n.glyphicon-jpy                    { &:before { content: \"\\00a5\"; } }\n.glyphicon-ruble                  { &:before { content: \"\\20bd\"; } }\n.glyphicon-rub                    { &:before { content: \"\\20bd\"; } }\n.glyphicon-scale                  { &:before { content: \"\\e230\"; } }\n.glyphicon-ice-lolly              { &:before { content: \"\\e231\"; } }\n.glyphicon-ice-lolly-tasted       { &:before { content: \"\\e232\"; } }\n.glyphicon-education              { &:before { content: \"\\e233\"; } }\n.glyphicon-option-horizontal      { &:before { content: \"\\e234\"; } }\n.glyphicon-option-vertical        { &:before { content: \"\\e235\"; } }\n.glyphicon-menu-hamburger         { &:before { content: \"\\e236\"; } }\n.glyphicon-modal-window           { &:before { content: \"\\e237\"; } }\n.glyphicon-oil                    { &:before { content: \"\\e238\"; } }\n.glyphicon-grain                  { &:before { content: \"\\e239\"; } }\n.glyphicon-sunglasses             { &:before { content: \"\\e240\"; } }\n.glyphicon-text-size              { &:before { content: \"\\e241\"; } }\n.glyphicon-text-color             { &:before { content: \"\\e242\"; } }\n.glyphicon-text-background        { &:before { content: \"\\e243\"; } }\n.glyphicon-object-align-top       { &:before { content: \"\\e244\"; } }\n.glyphicon-object-align-bottom    { &:before { content: \"\\e245\"; } }\n.glyphicon-object-align-horizontal{ &:before { content: \"\\e246\"; } }\n.glyphicon-object-align-left      { &:before { content: \"\\e247\"; } }\n.glyphicon-object-align-vertical  { &:before { content: \"\\e248\"; } }\n.glyphicon-object-align-right     { &:before { content: \"\\e249\"; } }\n.glyphicon-triangle-right         { &:before { content: \"\\e250\"; } }\n.glyphicon-triangle-left          { &:before { content: \"\\e251\"; } }\n.glyphicon-triangle-bottom        { &:before { content: \"\\e252\"; } }\n.glyphicon-triangle-top           { &:before { content: \"\\e253\"; } }\n.glyphicon-console                { &:before { content: \"\\e254\"; } }\n.glyphicon-superscript            { &:before { content: \"\\e255\"; } }\n.glyphicon-subscript              { &:before { content: \"\\e256\"; } }\n.glyphicon-menu-left              { &:before { content: \"\\e257\"; } }\n.glyphicon-menu-right             { &:before { content: \"\\e258\"; } }\n.glyphicon-menu-down              { &:before { content: \"\\e259\"; } }\n.glyphicon-menu-up                { &:before { content: \"\\e260\"; } }\n","//\n// Scaffolding\n// --------------------------------------------------\n\n\n// Reset the box-sizing\n//\n// Heads up! This reset may cause conflicts with some third-party widgets.\n// For recommendations on resolving such conflicts, see\n// https://getbootstrap.com/docs/3.4/getting-started/#third-box-sizing\n* {\n  .box-sizing(border-box);\n}\n*:before,\n*:after {\n  .box-sizing(border-box);\n}\n\n\n// Body reset\n\nhtml {\n  font-size: 10px;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n\nbody {\n  font-family: @font-family-base;\n  font-size: @font-size-base;\n  line-height: @line-height-base;\n  color: @text-color;\n  background-color: @body-bg;\n}\n\n// Reset fonts for relevant elements\ninput,\nbutton,\nselect,\ntextarea {\n  font-family: inherit;\n  font-size: inherit;\n  line-height: inherit;\n}\n\n\n// Links\n\na {\n  color: @link-color;\n  text-decoration: none;\n\n  &:hover,\n  &:focus {\n    color: @link-hover-color;\n    text-decoration: @link-hover-decoration;\n  }\n\n  &:focus {\n    .tab-focus();\n  }\n}\n\n\n// Figures\n//\n// We reset this here because previously Normalize had no `figure` margins. This\n// ensures we don't break anyone's use of the element.\n\nfigure {\n  margin: 0;\n}\n\n\n// Images\n\nimg {\n  vertical-align: middle;\n}\n\n// Responsive images (ensure images don't scale beyond their parents)\n.img-responsive {\n  .img-responsive();\n}\n\n// Rounded corners\n.img-rounded {\n  border-radius: @border-radius-large;\n}\n\n// Image thumbnails\n//\n// Heads up! This is mixin-ed into thumbnails.less for `.thumbnail`.\n.img-thumbnail {\n  padding: @thumbnail-padding;\n  line-height: @line-height-base;\n  background-color: @thumbnail-bg;\n  border: 1px solid @thumbnail-border;\n  border-radius: @thumbnail-border-radius;\n  .transition(all .2s ease-in-out);\n\n  // Keep them at most 100% wide\n  .img-responsive(inline-block);\n}\n\n// Perfect circle\n.img-circle {\n  border-radius: 50%; // set radius in percents\n}\n\n\n// Horizontal rules\n\nhr {\n  margin-top: @line-height-computed;\n  margin-bottom: @line-height-computed;\n  border: 0;\n  border-top: 1px solid @hr-border;\n}\n\n\n// Only display content to screen readers\n//\n// See: https://a11yproject.com/posts/how-to-hide-content\n\n.sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  border: 0;\n}\n\n// Use in conjunction with .sr-only to only display content when it's focused.\n// Useful for \"Skip to main content\" links; see https://www.w3.org/TR/2013/NOTE-WCAG20-TECHS-20130905/G1\n// Credit: HTML5 Boilerplate\n\n.sr-only-focusable {\n  &:active,\n  &:focus {\n    position: static;\n    width: auto;\n    height: auto;\n    margin: 0;\n    overflow: visible;\n    clip: auto;\n  }\n}\n\n\n// iOS \"clickable elements\" fix for role=\"button\"\n//\n// Fixes \"clickability\" issue (and more generally, the firing of events such as focus as well)\n// for traditionally non-focusable elements with role=\"button\"\n// see https://developer.mozilla.org/en-US/docs/Web/Events/click#Safari_Mobile\n\n[role=\"button\"] {\n  cursor: pointer;\n}\n","// stylelint-disable indentation, property-no-vendor-prefix, selector-no-vendor-prefix\n\n// Vendor Prefixes\n//\n// All vendor mixins are deprecated as of v3.2.0 due to the introduction of\n// Autoprefixer in our Gruntfile. They have been removed in v4.\n\n// - Animations\n// - Backface visibility\n// - Box shadow\n// - Box sizing\n// - Content columns\n// - Hyphens\n// - Placeholder text\n// - Transformations\n// - Transitions\n// - User Select\n\n\n// Animations\n.animation(@animation) {\n  -webkit-animation: @animation;\n       -o-animation: @animation;\n          animation: @animation;\n}\n.animation-name(@name) {\n  -webkit-animation-name: @name;\n          animation-name: @name;\n}\n.animation-duration(@duration) {\n  -webkit-animation-duration: @duration;\n          animation-duration: @duration;\n}\n.animation-timing-function(@timing-function) {\n  -webkit-animation-timing-function: @timing-function;\n          animation-timing-function: @timing-function;\n}\n.animation-delay(@delay) {\n  -webkit-animation-delay: @delay;\n          animation-delay: @delay;\n}\n.animation-iteration-count(@iteration-count) {\n  -webkit-animation-iteration-count: @iteration-count;\n          animation-iteration-count: @iteration-count;\n}\n.animation-direction(@direction) {\n  -webkit-animation-direction: @direction;\n          animation-direction: @direction;\n}\n.animation-fill-mode(@fill-mode) {\n  -webkit-animation-fill-mode: @fill-mode;\n          animation-fill-mode: @fill-mode;\n}\n\n// Backface visibility\n// Prevent browsers from flickering when using CSS 3D transforms.\n// Default value is `visible`, but can be changed to `hidden`\n\n.backface-visibility(@visibility) {\n  -webkit-backface-visibility: @visibility;\n     -moz-backface-visibility: @visibility;\n          backface-visibility: @visibility;\n}\n\n// Drop shadows\n//\n// Note: Deprecated `.box-shadow()` as of v3.1.0 since all of Bootstrap's\n// supported browsers that have box shadow capabilities now support it.\n\n.box-shadow(@shadow) {\n  -webkit-box-shadow: @shadow; // iOS <4.3 & Android <4.1\n          box-shadow: @shadow;\n}\n\n// Box sizing\n.box-sizing(@boxmodel) {\n  -webkit-box-sizing: @boxmodel;\n     -moz-box-sizing: @boxmodel;\n          box-sizing: @boxmodel;\n}\n\n// CSS3 Content Columns\n.content-columns(@column-count; @column-gap: @grid-gutter-width) {\n  -webkit-column-count: @column-count;\n     -moz-column-count: @column-count;\n          column-count: @column-count;\n  -webkit-column-gap: @column-gap;\n     -moz-column-gap: @column-gap;\n          column-gap: @column-gap;\n}\n\n// Optional hyphenation\n.hyphens(@mode: auto) {\n  -webkit-hyphens: @mode;\n     -moz-hyphens: @mode;\n      -ms-hyphens: @mode; // IE10+\n       -o-hyphens: @mode;\n          hyphens: @mode;\n  word-wrap: break-word;\n}\n\n// Placeholder text\n.placeholder(@color: @input-color-placeholder) {\n  // Firefox\n  &::-moz-placeholder {\n    color: @color;\n    opacity: 1; // Override Firefox's unusual default opacity; see https://github.com/twbs/bootstrap/pull/11526\n  }\n  &:-ms-input-placeholder { color: @color; } // Internet Explorer 10+\n  &::-webkit-input-placeholder  { color: @color; } // Safari and Chrome\n}\n\n// Transformations\n.scale(@ratio) {\n  -webkit-transform: scale(@ratio);\n      -ms-transform: scale(@ratio); // IE9 only\n       -o-transform: scale(@ratio);\n          transform: scale(@ratio);\n}\n.scale(@ratioX; @ratioY) {\n  -webkit-transform: scale(@ratioX, @ratioY);\n      -ms-transform: scale(@ratioX, @ratioY); // IE9 only\n       -o-transform: scale(@ratioX, @ratioY);\n          transform: scale(@ratioX, @ratioY);\n}\n.scaleX(@ratio) {\n  -webkit-transform: scaleX(@ratio);\n      -ms-transform: scaleX(@ratio); // IE9 only\n       -o-transform: scaleX(@ratio);\n          transform: scaleX(@ratio);\n}\n.scaleY(@ratio) {\n  -webkit-transform: scaleY(@ratio);\n      -ms-transform: scaleY(@ratio); // IE9 only\n       -o-transform: scaleY(@ratio);\n          transform: scaleY(@ratio);\n}\n.skew(@x; @y) {\n  -webkit-transform: skewX(@x) skewY(@y);\n      -ms-transform: skewX(@x) skewY(@y); // See https://github.com/twbs/bootstrap/issues/4885; IE9+\n       -o-transform: skewX(@x) skewY(@y);\n          transform: skewX(@x) skewY(@y);\n}\n.translate(@x; @y) {\n  -webkit-transform: translate(@x, @y);\n      -ms-transform: translate(@x, @y); // IE9 only\n       -o-transform: translate(@x, @y);\n          transform: translate(@x, @y);\n}\n.translate3d(@x; @y; @z) {\n  -webkit-transform: translate3d(@x, @y, @z);\n          transform: translate3d(@x, @y, @z);\n}\n.rotate(@degrees) {\n  -webkit-transform: rotate(@degrees);\n      -ms-transform: rotate(@degrees); // IE9 only\n       -o-transform: rotate(@degrees);\n          transform: rotate(@degrees);\n}\n.rotateX(@degrees) {\n  -webkit-transform: rotateX(@degrees);\n      -ms-transform: rotateX(@degrees); // IE9 only\n       -o-transform: rotateX(@degrees);\n          transform: rotateX(@degrees);\n}\n.rotateY(@degrees) {\n  -webkit-transform: rotateY(@degrees);\n      -ms-transform: rotateY(@degrees); // IE9 only\n       -o-transform: rotateY(@degrees);\n          transform: rotateY(@degrees);\n}\n.perspective(@perspective) {\n  -webkit-perspective: @perspective;\n     -moz-perspective: @perspective;\n          perspective: @perspective;\n}\n.perspective-origin(@perspective) {\n  -webkit-perspective-origin: @perspective;\n     -moz-perspective-origin: @perspective;\n          perspective-origin: @perspective;\n}\n.transform-origin(@origin) {\n  -webkit-transform-origin: @origin;\n     -moz-transform-origin: @origin;\n      -ms-transform-origin: @origin; // IE9 only\n          transform-origin: @origin;\n}\n\n\n// Transitions\n\n.transition(@transition) {\n  -webkit-transition: @transition;\n       -o-transition: @transition;\n          transition: @transition;\n}\n.transition-property(@transition-property) {\n  -webkit-transition-property: @transition-property;\n          transition-property: @transition-property;\n}\n.transition-delay(@transition-delay) {\n  -webkit-transition-delay: @transition-delay;\n          transition-delay: @transition-delay;\n}\n.transition-duration(@transition-duration) {\n  -webkit-transition-duration: @transition-duration;\n          transition-duration: @transition-duration;\n}\n.transition-timing-function(@timing-function) {\n  -webkit-transition-timing-function: @timing-function;\n          transition-timing-function: @timing-function;\n}\n.transition-transform(@transition) {\n  -webkit-transition: -webkit-transform @transition;\n     -moz-transition: -moz-transform @transition;\n       -o-transition: -o-transform @transition;\n          transition: transform @transition;\n}\n\n\n// User select\n// For selecting text on the page\n\n.user-select(@select) {\n  -webkit-user-select: @select;\n     -moz-user-select: @select;\n      -ms-user-select: @select; // IE10+\n          user-select: @select;\n}\n","// WebKit-style focus\n\n.tab-focus() {\n  // WebKit-specific. Other browsers will keep their default outline style.\n  // (Initially tried to also force default via `outline: initial`,\n  // but that seems to erroneously remove the outline in Firefox altogether.)\n  outline: 5px auto -webkit-focus-ring-color;\n  outline-offset: -2px;\n}\n","// stylelint-disable media-feature-name-no-vendor-prefix, media-feature-parentheses-space-inside, media-feature-name-no-unknown, indentation, at-rule-name-space-after\n\n// Responsive image\n//\n// Keep images from scaling beyond the width of their parents.\n.img-responsive(@display: block) {\n  display: @display;\n  max-width: 100%; // Part 1: Set a maximum relative to the parent\n  height: auto; // Part 2: Scale the height according to the width, otherwise you get stretching\n}\n\n\n// Retina image\n//\n// Short retina mixin for setting background-image and -size. Note that the\n// spelling of `min--moz-device-pixel-ratio` is intentional.\n.img-retina(@file-1x; @file-2x; @width-1x; @height-1x) {\n  background-image: url(\"@{file-1x}\");\n\n  @media\n  only screen and (-webkit-min-device-pixel-ratio: 2),\n  only screen and ( min--moz-device-pixel-ratio: 2),\n  only screen and ( -o-min-device-pixel-ratio: 2/1),\n  only screen and ( min-device-pixel-ratio: 2),\n  only screen and ( min-resolution: 192dpi),\n  only screen and ( min-resolution: 2dppx) {\n    background-image: url(\"@{file-2x}\");\n    background-size: @width-1x @height-1x;\n  }\n}\n","// stylelint-disable selector-list-comma-newline-after, selector-no-qualifying-type\n\n//\n// Typography\n// --------------------------------------------------\n\n\n// Headings\n// -------------------------\n\nh1, h2, h3, h4, h5, h6,\n.h1, .h2, .h3, .h4, .h5, .h6 {\n  font-family: @headings-font-family;\n  font-weight: @headings-font-weight;\n  line-height: @headings-line-height;\n  color: @headings-color;\n\n  small,\n  .small {\n    font-weight: 400;\n    line-height: 1;\n    color: @headings-small-color;\n  }\n}\n\nh1, .h1,\nh2, .h2,\nh3, .h3 {\n  margin-top: @line-height-computed;\n  margin-bottom: (@line-height-computed / 2);\n\n  small,\n  .small {\n    font-size: 65%;\n  }\n}\nh4, .h4,\nh5, .h5,\nh6, .h6 {\n  margin-top: (@line-height-computed / 2);\n  margin-bottom: (@line-height-computed / 2);\n\n  small,\n  .small {\n    font-size: 75%;\n  }\n}\n\nh1, .h1 { font-size: @font-size-h1; }\nh2, .h2 { font-size: @font-size-h2; }\nh3, .h3 { font-size: @font-size-h3; }\nh4, .h4 { font-size: @font-size-h4; }\nh5, .h5 { font-size: @font-size-h5; }\nh6, .h6 { font-size: @font-size-h6; }\n\n\n// Body text\n// -------------------------\n\np {\n  margin: 0 0 (@line-height-computed / 2);\n}\n\n.lead {\n  margin-bottom: @line-height-computed;\n  font-size: floor((@font-size-base * 1.15));\n  font-weight: 300;\n  line-height: 1.4;\n\n  @media (min-width: @screen-sm-min) {\n    font-size: (@font-size-base * 1.5);\n  }\n}\n\n\n// Emphasis & misc\n// -------------------------\n\n// Ex: (12px small font / 14px base font) * 100% = about 85%\nsmall,\n.small {\n  font-size: floor((100% * @font-size-small / @font-size-base));\n}\n\nmark,\n.mark {\n  padding: .2em;\n  background-color: @state-warning-bg;\n}\n\n// Alignment\n.text-left           { text-align: left; }\n.text-right          { text-align: right; }\n.text-center         { text-align: center; }\n.text-justify        { text-align: justify; }\n.text-nowrap         { white-space: nowrap; }\n\n// Transformation\n.text-lowercase      { text-transform: lowercase; }\n.text-uppercase      { text-transform: uppercase; }\n.text-capitalize     { text-transform: capitalize; }\n\n// Contextual colors\n.text-muted {\n  color: @text-muted;\n}\n.text-primary {\n  .text-emphasis-variant(@brand-primary);\n}\n.text-success {\n  .text-emphasis-variant(@state-success-text);\n}\n.text-info {\n  .text-emphasis-variant(@state-info-text);\n}\n.text-warning {\n  .text-emphasis-variant(@state-warning-text);\n}\n.text-danger {\n  .text-emphasis-variant(@state-danger-text);\n}\n\n// Contextual backgrounds\n// For now we'll leave these alongside the text classes until v4 when we can\n// safely shift things around (per SemVer rules).\n.bg-primary {\n  // Given the contrast here, this is the only class to have its color inverted\n  // automatically.\n  color: #fff;\n  .bg-variant(@brand-primary);\n}\n.bg-success {\n  .bg-variant(@state-success-bg);\n}\n.bg-info {\n  .bg-variant(@state-info-bg);\n}\n.bg-warning {\n  .bg-variant(@state-warning-bg);\n}\n.bg-danger {\n  .bg-variant(@state-danger-bg);\n}\n\n\n// Page header\n// -------------------------\n\n.page-header {\n  padding-bottom: ((@line-height-computed / 2) - 1);\n  margin: (@line-height-computed * 2) 0 @line-height-computed;\n  border-bottom: 1px solid @page-header-border-color;\n}\n\n\n// Lists\n// -------------------------\n\n// Unordered and Ordered lists\nul,\nol {\n  margin-top: 0;\n  margin-bottom: (@line-height-computed / 2);\n  ul,\n  ol {\n    margin-bottom: 0;\n  }\n}\n\n// List options\n\n// Unstyled keeps list items block level, just removes default browser padding and list-style\n.list-unstyled {\n  padding-left: 0;\n  list-style: none;\n}\n\n// Inline turns list items into inline-block\n.list-inline {\n  .list-unstyled();\n  margin-left: -5px;\n\n  > li {\n    display: inline-block;\n    padding-right: 5px;\n    padding-left: 5px;\n  }\n}\n\n// Description Lists\ndl {\n  margin-top: 0; // Remove browser default\n  margin-bottom: @line-height-computed;\n}\ndt,\ndd {\n  line-height: @line-height-base;\n}\ndt {\n  font-weight: 700;\n}\ndd {\n  margin-left: 0; // Undo browser default\n}\n\n// Horizontal description lists\n//\n// Defaults to being stacked without any of the below styles applied, until the\n// grid breakpoint is reached (default of ~768px).\n\n.dl-horizontal {\n  dd {\n    &:extend(.clearfix all); // Clear the floated `dt` if an empty `dd` is present\n  }\n\n  @media (min-width: @dl-horizontal-breakpoint) {\n    dt {\n      float: left;\n      width: (@dl-horizontal-offset - 20);\n      clear: left;\n      text-align: right;\n      .text-overflow();\n    }\n    dd {\n      margin-left: @dl-horizontal-offset;\n    }\n  }\n}\n\n\n// Misc\n// -------------------------\n\n// Abbreviations and acronyms\n// Add data-* attribute to help out our tooltip plugin, per https://github.com/twbs/bootstrap/issues/5257\nabbr[title],\nabbr[data-original-title] {\n  cursor: help;\n}\n\n.initialism {\n  font-size: 90%;\n  .text-uppercase();\n}\n\n// Blockquotes\nblockquote {\n  padding: (@line-height-computed / 2) @line-height-computed;\n  margin: 0 0 @line-height-computed;\n  font-size: @blockquote-font-size;\n  border-left: 5px solid @blockquote-border-color;\n\n  p,\n  ul,\n  ol {\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n\n  // Note: Deprecated small and .small as of v3.1.0\n  // Context: https://github.com/twbs/bootstrap/issues/11660\n  footer,\n  small,\n  .small {\n    display: block;\n    font-size: 80%; // back to default font-size\n    line-height: @line-height-base;\n    color: @blockquote-small-color;\n\n    &:before {\n      content: \"\\2014 \\00A0\"; // em dash, nbsp\n    }\n  }\n}\n\n// Opposite alignment of blockquote\n//\n// Heads up: `blockquote.pull-right` has been deprecated as of v3.1.0.\n.blockquote-reverse,\nblockquote.pull-right {\n  padding-right: 15px;\n  padding-left: 0;\n  text-align: right;\n  border-right: 5px solid @blockquote-border-color;\n  border-left: 0;\n\n  // Account for citation\n  footer,\n  small,\n  .small {\n    &:before { content: \"\"; }\n    &:after {\n      content: \"\\00A0 \\2014\"; // nbsp, em dash\n    }\n  }\n}\n\n// Addresses\naddress {\n  margin-bottom: @line-height-computed;\n  font-style: normal;\n  line-height: @line-height-base;\n}\n","// Typography\n\n.text-emphasis-variant(@color) {\n  color: @color;\n  a&:hover,\n  a&:focus {\n    color: darken(@color, 10%);\n  }\n}\n","// Contextual backgrounds\n\n.bg-variant(@color) {\n  background-color: @color;\n  a&:hover,\n  a&:focus {\n    background-color: darken(@color, 10%);\n  }\n}\n","// Text overflow\n// Requires inline-block or block for proper styling\n\n.text-overflow() {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n","//\n// Code (inline and block)\n// --------------------------------------------------\n\n\n// Inline and block code styles\ncode,\nkbd,\npre,\nsamp {\n  font-family: @font-family-monospace;\n}\n\n// Inline code\ncode {\n  padding: 2px 4px;\n  font-size: 90%;\n  color: @code-color;\n  background-color: @code-bg;\n  border-radius: @border-radius-base;\n}\n\n// User input typically entered via keyboard\nkbd {\n  padding: 2px 4px;\n  font-size: 90%;\n  color: @kbd-color;\n  background-color: @kbd-bg;\n  border-radius: @border-radius-small;\n  box-shadow: inset 0 -1px 0 rgba(0, 0, 0, .25);\n\n  kbd {\n    padding: 0;\n    font-size: 100%;\n    font-weight: 700;\n    box-shadow: none;\n  }\n}\n\n// Blocks of code\npre {\n  display: block;\n  padding: ((@line-height-computed - 1) / 2);\n  margin: 0 0 (@line-height-computed / 2);\n  font-size: (@font-size-base - 1); // 14px to 13px\n  line-height: @line-height-base;\n  color: @pre-color;\n  word-break: break-all;\n  word-wrap: break-word;\n  background-color: @pre-bg;\n  border: 1px solid @pre-border-color;\n  border-radius: @border-radius-base;\n\n  // Account for some code outputs that place code tags in pre tags\n  code {\n    padding: 0;\n    font-size: inherit;\n    color: inherit;\n    white-space: pre-wrap;\n    background-color: transparent;\n    border-radius: 0;\n  }\n}\n\n// Enable scrollable blocks of code\n.pre-scrollable {\n  max-height: @pre-scrollable-max-height;\n  overflow-y: scroll;\n}\n","//\n// Grid system\n// --------------------------------------------------\n\n\n// Container widths\n//\n// Set the container width, and override it for fixed navbars in media queries.\n\n.container {\n  .container-fixed();\n\n  @media (min-width: @screen-sm-min) {\n    width: @container-sm;\n  }\n  @media (min-width: @screen-md-min) {\n    width: @container-md;\n  }\n  @media (min-width: @screen-lg-min) {\n    width: @container-lg;\n  }\n}\n\n\n// Fluid container\n//\n// Utilizes the mixin meant for fixed width containers, but without any defined\n// width for fluid, full width layouts.\n\n.container-fluid {\n  .container-fixed();\n}\n\n\n// Row\n//\n// Rows contain and clear the floats of your columns.\n\n.row {\n  .make-row();\n}\n\n.row-no-gutters {\n  margin-right: 0;\n  margin-left: 0;\n\n  [class*=\"col-\"] {\n    padding-right: 0;\n    padding-left: 0;\n  }\n}\n\n\n// Columns\n//\n// Common styles for small and large grid columns\n\n.make-grid-columns();\n\n\n// Extra small grid\n//\n// Columns, offsets, pushes, and pulls for extra small devices like\n// smartphones.\n\n.make-grid(xs);\n\n\n// Small grid\n//\n// Columns, offsets, pushes, and pulls for the small device range, from phones\n// to tablets.\n\n@media (min-width: @screen-sm-min) {\n  .make-grid(sm);\n}\n\n\n// Medium grid\n//\n// Columns, offsets, pushes, and pulls for the desktop device range.\n\n@media (min-width: @screen-md-min) {\n  .make-grid(md);\n}\n\n\n// Large grid\n//\n// Columns, offsets, pushes, and pulls for the large desktop device range.\n\n@media (min-width: @screen-lg-min) {\n  .make-grid(lg);\n}\n","// Grid system\n//\n// Generate semantic grid columns with these mixins.\n\n// Centered container element\n.container-fixed(@gutter: @grid-gutter-width) {\n  padding-right: ceil((@gutter / 2));\n  padding-left: floor((@gutter / 2));\n  margin-right: auto;\n  margin-left: auto;\n  &:extend(.clearfix all);\n}\n\n// Creates a wrapper for a series of columns\n.make-row(@gutter: @grid-gutter-width) {\n  margin-right: floor((@gutter / -2));\n  margin-left: ceil((@gutter / -2));\n  &:extend(.clearfix all);\n}\n\n// Generate the extra small columns\n.make-xs-column(@columns; @gutter: @grid-gutter-width) {\n  position: relative;\n  float: left;\n  width: percentage((@columns / @grid-columns));\n  min-height: 1px;\n  padding-right: (@gutter / 2);\n  padding-left: (@gutter / 2);\n}\n.make-xs-column-offset(@columns) {\n  margin-left: percentage((@columns / @grid-columns));\n}\n.make-xs-column-push(@columns) {\n  left: percentage((@columns / @grid-columns));\n}\n.make-xs-column-pull(@columns) {\n  right: percentage((@columns / @grid-columns));\n}\n\n// Generate the small columns\n.make-sm-column(@columns; @gutter: @grid-gutter-width) {\n  position: relative;\n  min-height: 1px;\n  padding-right: (@gutter / 2);\n  padding-left: (@gutter / 2);\n\n  @media (min-width: @screen-sm-min) {\n    float: left;\n    width: percentage((@columns / @grid-columns));\n  }\n}\n.make-sm-column-offset(@columns) {\n  @media (min-width: @screen-sm-min) {\n    margin-left: percentage((@columns / @grid-columns));\n  }\n}\n.make-sm-column-push(@columns) {\n  @media (min-width: @screen-sm-min) {\n    left: percentage((@columns / @grid-columns));\n  }\n}\n.make-sm-column-pull(@columns) {\n  @media (min-width: @screen-sm-min) {\n    right: percentage((@columns / @grid-columns));\n  }\n}\n\n// Generate the medium columns\n.make-md-column(@columns; @gutter: @grid-gutter-width) {\n  position: relative;\n  min-height: 1px;\n  padding-right: (@gutter / 2);\n  padding-left: (@gutter / 2);\n\n  @media (min-width: @screen-md-min) {\n    float: left;\n    width: percentage((@columns / @grid-columns));\n  }\n}\n.make-md-column-offset(@columns) {\n  @media (min-width: @screen-md-min) {\n    margin-left: percentage((@columns / @grid-columns));\n  }\n}\n.make-md-column-push(@columns) {\n  @media (min-width: @screen-md-min) {\n    left: percentage((@columns / @grid-columns));\n  }\n}\n.make-md-column-pull(@columns) {\n  @media (min-width: @screen-md-min) {\n    right: percentage((@columns / @grid-columns));\n  }\n}\n\n// Generate the large columns\n.make-lg-column(@columns; @gutter: @grid-gutter-width) {\n  position: relative;\n  min-height: 1px;\n  padding-right: (@gutter / 2);\n  padding-left: (@gutter / 2);\n\n  @media (min-width: @screen-lg-min) {\n    float: left;\n    width: percentage((@columns / @grid-columns));\n  }\n}\n.make-lg-column-offset(@columns) {\n  @media (min-width: @screen-lg-min) {\n    margin-left: percentage((@columns / @grid-columns));\n  }\n}\n.make-lg-column-push(@columns) {\n  @media (min-width: @screen-lg-min) {\n    left: percentage((@columns / @grid-columns));\n  }\n}\n.make-lg-column-pull(@columns) {\n  @media (min-width: @screen-lg-min) {\n    right: percentage((@columns / @grid-columns));\n  }\n}\n","// Framework grid generation\n//\n// Used only by Bootstrap to generate the correct number of grid classes given\n// any value of `@grid-columns`.\n\n.make-grid-columns() {\n  // Common styles for all sizes of grid columns, widths 1-12\n  .col(@index) { // initial\n    @item: ~\".col-xs-@{index}, .col-sm-@{index}, .col-md-@{index}, .col-lg-@{index}\";\n    .col((@index + 1), @item);\n  }\n  .col(@index, @list) when (@index =< @grid-columns) { // general; \"=<\" isn't a typo\n    @item: ~\".col-xs-@{index}, .col-sm-@{index}, .col-md-@{index}, .col-lg-@{index}\";\n    .col((@index + 1), ~\"@{list}, @{item}\");\n  }\n  .col(@index, @list) when (@index > @grid-columns) { // terminal\n    @{list} {\n      position: relative;\n      // Prevent columns from collapsing when empty\n      min-height: 1px;\n      // Inner gutter via padding\n      padding-right: floor((@grid-gutter-width / 2));\n      padding-left: ceil((@grid-gutter-width / 2));\n    }\n  }\n  .col(1); // kickstart it\n}\n\n.float-grid-columns(@class) {\n  .col(@index) { // initial\n    @item: ~\".col-@{class}-@{index}\";\n    .col((@index + 1), @item);\n  }\n  .col(@index, @list) when (@index =< @grid-columns) { // general\n    @item: ~\".col-@{class}-@{index}\";\n    .col((@index + 1), ~\"@{list}, @{item}\");\n  }\n  .col(@index, @list) when (@index > @grid-columns) { // terminal\n    @{list} {\n      float: left;\n    }\n  }\n  .col(1); // kickstart it\n}\n\n.calc-grid-column(@index, @class, @type) when (@type = width) and (@index > 0) {\n  .col-@{class}-@{index} {\n    width: percentage((@index / @grid-columns));\n  }\n}\n.calc-grid-column(@index, @class, @type) when (@type = push) and (@index > 0) {\n  .col-@{class}-push-@{index} {\n    left: percentage((@index / @grid-columns));\n  }\n}\n.calc-grid-column(@index, @class, @type) when (@type = push) and (@index = 0) {\n  .col-@{class}-push-0 {\n    left: auto;\n  }\n}\n.calc-grid-column(@index, @class, @type) when (@type = pull) and (@index > 0) {\n  .col-@{class}-pull-@{index} {\n    right: percentage((@index / @grid-columns));\n  }\n}\n.calc-grid-column(@index, @class, @type) when (@type = pull) and (@index = 0) {\n  .col-@{class}-pull-0 {\n    right: auto;\n  }\n}\n.calc-grid-column(@index, @class, @type) when (@type = offset) {\n  .col-@{class}-offset-@{index} {\n    margin-left: percentage((@index / @grid-columns));\n  }\n}\n\n// Basic looping in LESS\n.loop-grid-columns(@index, @class, @type) when (@index >= 0) {\n  .calc-grid-column(@index, @class, @type);\n  // next iteration\n  .loop-grid-columns((@index - 1), @class, @type);\n}\n\n// Create grid for specific class\n.make-grid(@class) {\n  .float-grid-columns(@class);\n  .loop-grid-columns(@grid-columns, @class, width);\n  .loop-grid-columns(@grid-columns, @class, pull);\n  .loop-grid-columns(@grid-columns, @class, push);\n  .loop-grid-columns(@grid-columns, @class, offset);\n}\n","// stylelint-disable selector-max-type, selector-max-compound-selectors, selector-no-qualifying-type\n\n//\n// Tables\n// --------------------------------------------------\n\n\ntable {\n  background-color: @table-bg;\n\n  // Table cell sizing\n  //\n  // Reset default table behavior\n\n  col[class*=\"col-\"] {\n    position: static; // Prevent border hiding in Firefox and IE9-11 (see https://github.com/twbs/bootstrap/issues/11623)\n    display: table-column;\n    float: none;\n  }\n\n  td,\n  th {\n    &[class*=\"col-\"] {\n      position: static; // Prevent border hiding in Firefox and IE9-11 (see https://github.com/twbs/bootstrap/issues/11623)\n      display: table-cell;\n      float: none;\n    }\n  }\n}\n\ncaption {\n  padding-top: @table-cell-padding;\n  padding-bottom: @table-cell-padding;\n  color: @text-muted;\n  text-align: left;\n}\n\nth {\n  text-align: left;\n}\n\n\n// Baseline styles\n\n.table {\n  width: 100%;\n  max-width: 100%;\n  margin-bottom: @line-height-computed;\n  // Cells\n  > thead,\n  > tbody,\n  > tfoot {\n    > tr {\n      > th,\n      > td {\n        padding: @table-cell-padding;\n        line-height: @line-height-base;\n        vertical-align: top;\n        border-top: 1px solid @table-border-color;\n      }\n    }\n  }\n  // Bottom align for column headings\n  > thead > tr > th {\n    vertical-align: bottom;\n    border-bottom: 2px solid @table-border-color;\n  }\n  // Remove top border from thead by default\n  > caption + thead,\n  > colgroup + thead,\n  > thead:first-child {\n    > tr:first-child {\n      > th,\n      > td {\n        border-top: 0;\n      }\n    }\n  }\n  // Account for multiple tbody instances\n  > tbody + tbody {\n    border-top: 2px solid @table-border-color;\n  }\n\n  // Nesting\n  .table {\n    background-color: @body-bg;\n  }\n}\n\n\n// Condensed table w/ half padding\n\n.table-condensed {\n  > thead,\n  > tbody,\n  > tfoot {\n    > tr {\n      > th,\n      > td {\n        padding: @table-condensed-cell-padding;\n      }\n    }\n  }\n}\n\n\n// Bordered version\n//\n// Add borders all around the table and between all the columns.\n\n.table-bordered {\n  border: 1px solid @table-border-color;\n  > thead,\n  > tbody,\n  > tfoot {\n    > tr {\n      > th,\n      > td {\n        border: 1px solid @table-border-color;\n      }\n    }\n  }\n  > thead > tr {\n    > th,\n    > td {\n      border-bottom-width: 2px;\n    }\n  }\n}\n\n\n// Zebra-striping\n//\n// Default zebra-stripe styles (alternating gray and transparent backgrounds)\n\n.table-striped {\n  > tbody > tr:nth-of-type(odd) {\n    background-color: @table-bg-accent;\n  }\n}\n\n\n// Hover effect\n//\n// Placed here since it has to come after the potential zebra striping\n\n.table-hover {\n  > tbody > tr:hover {\n    background-color: @table-bg-hover;\n  }\n}\n\n\n// Table backgrounds\n//\n// Exact selectors below required to override `.table-striped` and prevent\n// inheritance to nested tables.\n\n// Generate the contextual variants\n.table-row-variant(active; @table-bg-active);\n.table-row-variant(success; @state-success-bg);\n.table-row-variant(info; @state-info-bg);\n.table-row-variant(warning; @state-warning-bg);\n.table-row-variant(danger; @state-danger-bg);\n\n\n// Responsive tables\n//\n// Wrap your tables in `.table-responsive` and we'll make them mobile friendly\n// by enabling horizontal scrolling. Only applies <768px. Everything above that\n// will display normally.\n\n.table-responsive {\n  min-height: .01%; // Workaround for IE9 bug (see https://github.com/twbs/bootstrap/issues/14837)\n  overflow-x: auto;\n\n  @media screen and (max-width: @screen-xs-max) {\n    width: 100%;\n    margin-bottom: (@line-height-computed * .75);\n    overflow-y: hidden;\n    -ms-overflow-style: -ms-autohiding-scrollbar;\n    border: 1px solid @table-border-color;\n\n    // Tighten up spacing\n    > .table {\n      margin-bottom: 0;\n\n      // Ensure the content doesn't wrap\n      > thead,\n      > tbody,\n      > tfoot {\n        > tr {\n          > th,\n          > td {\n            white-space: nowrap;\n          }\n        }\n      }\n    }\n\n    // Special overrides for the bordered tables\n    > .table-bordered {\n      border: 0;\n\n      // Nuke the appropriate borders so that the parent can handle them\n      > thead,\n      > tbody,\n      > tfoot {\n        > tr {\n          > th:first-child,\n          > td:first-child {\n            border-left: 0;\n          }\n          > th:last-child,\n          > td:last-child {\n            border-right: 0;\n          }\n        }\n      }\n\n      // Only nuke the last row's bottom-border in `tbody` and `tfoot` since\n      // chances are there will be only one `tr` in a `thead` and that would\n      // remove the border altogether.\n      > tbody,\n      > tfoot {\n        > tr:last-child {\n          > th,\n          > td {\n            border-bottom: 0;\n          }\n        }\n      }\n\n    }\n  }\n}\n","// Tables\n\n.table-row-variant(@state; @background) {\n  // Exact selectors below required to override `.table-striped` and prevent\n  // inheritance to nested tables.\n  .table > thead > tr,\n  .table > tbody > tr,\n  .table > tfoot > tr {\n    > td.@{state},\n    > th.@{state},\n    &.@{state} > td,\n    &.@{state} > th {\n      background-color: @background;\n    }\n  }\n\n  // Hover states for `.table-hover`\n  // Note: this is not available for cells or rows within `thead` or `tfoot`.\n  .table-hover > tbody > tr {\n    > td.@{state}:hover,\n    > th.@{state}:hover,\n    &.@{state}:hover > td,\n    &:hover > .@{state},\n    &.@{state}:hover > th {\n      background-color: darken(@background, 5%);\n    }\n  }\n}\n","// stylelint-disable selector-no-qualifying-type, property-no-vendor-prefix, media-feature-name-no-vendor-prefix\n\n//\n// Forms\n// --------------------------------------------------\n\n\n// Normalize non-controls\n//\n// Restyle and baseline non-control form elements.\n\nfieldset {\n  // Chrome and Firefox set a `min-width: min-content;` on fieldsets,\n  // so we reset that to ensure it behaves more like a standard block element.\n  // See https://github.com/twbs/bootstrap/issues/12359.\n  min-width: 0;\n  padding: 0;\n  margin: 0;\n  border: 0;\n}\n\nlegend {\n  display: block;\n  width: 100%;\n  padding: 0;\n  margin-bottom: @line-height-computed;\n  font-size: (@font-size-base * 1.5);\n  line-height: inherit;\n  color: @legend-color;\n  border: 0;\n  border-bottom: 1px solid @legend-border-color;\n}\n\nlabel {\n  display: inline-block;\n  max-width: 100%; // Force IE8 to wrap long content (see https://github.com/twbs/bootstrap/issues/13141)\n  margin-bottom: 5px;\n  font-weight: 700;\n}\n\n\n// Normalize form controls\n//\n// While most of our form styles require extra classes, some basic normalization\n// is required to ensure optimum display with or without those classes to better\n// address browser inconsistencies.\n\ninput[type=\"search\"] {\n  // Override content-box in Normalize (* isn't specific enough)\n  .box-sizing(border-box);\n\n  // Search inputs in iOS\n  //\n  // This overrides the extra rounded corners on search inputs in iOS so that our\n  // `.form-control` class can properly style them. Note that this cannot simply\n  // be added to `.form-control` as it's not specific enough. For details, see\n  // https://github.com/twbs/bootstrap/issues/11586.\n  -webkit-appearance: none;\n  appearance: none;\n}\n\n// Position radios and checkboxes better\ninput[type=\"radio\"],\ninput[type=\"checkbox\"] {\n  margin: 4px 0 0;\n  margin-top: 1px \\9; // IE8-9\n  line-height: normal;\n\n  // Apply same disabled cursor tweak as for inputs\n  // Some special care is needed because <label>s don't inherit their parent's `cursor`.\n  //\n  // Note: Neither radios nor checkboxes can be readonly.\n  &[disabled],\n  &.disabled,\n  fieldset[disabled] & {\n    cursor: @cursor-disabled;\n  }\n}\n\ninput[type=\"file\"] {\n  display: block;\n}\n\n// Make range inputs behave like textual form controls\ninput[type=\"range\"] {\n  display: block;\n  width: 100%;\n}\n\n// Make multiple select elements height not fixed\nselect[multiple],\nselect[size] {\n  height: auto;\n}\n\n// Focus for file, radio, and checkbox\ninput[type=\"file\"]:focus,\ninput[type=\"radio\"]:focus,\ninput[type=\"checkbox\"]:focus {\n  .tab-focus();\n}\n\n// Adjust output element\noutput {\n  display: block;\n  padding-top: (@padding-base-vertical + 1);\n  font-size: @font-size-base;\n  line-height: @line-height-base;\n  color: @input-color;\n}\n\n\n// Common form controls\n//\n// Shared size and type resets for form controls. Apply `.form-control` to any\n// of the following form controls:\n//\n// select\n// textarea\n// input[type=\"text\"]\n// input[type=\"password\"]\n// input[type=\"datetime\"]\n// input[type=\"datetime-local\"]\n// input[type=\"date\"]\n// input[type=\"month\"]\n// input[type=\"time\"]\n// input[type=\"week\"]\n// input[type=\"number\"]\n// input[type=\"email\"]\n// input[type=\"url\"]\n// input[type=\"search\"]\n// input[type=\"tel\"]\n// input[type=\"color\"]\n\n.form-control {\n  display: block;\n  width: 100%;\n  height: @input-height-base; // Make inputs at least the height of their button counterpart (base line-height + padding + border)\n  padding: @padding-base-vertical @padding-base-horizontal;\n  font-size: @font-size-base;\n  line-height: @line-height-base;\n  color: @input-color;\n  background-color: @input-bg;\n  background-image: none; // Reset unusual Firefox-on-Android default style; see https://github.com/necolas/normalize.css/issues/214\n  border: 1px solid @input-border;\n  border-radius: @input-border-radius; // Note: This has no effect on <select>s in some browsers, due to the limited stylability of <select>s in CSS.\n  .box-shadow(inset 0 1px 1px rgba(0, 0, 0, .075));\n  .transition(~\"border-color ease-in-out .15s, box-shadow ease-in-out .15s\");\n\n  // Customize the `:focus` state to imitate native WebKit styles.\n  .form-control-focus();\n\n  // Placeholder\n  .placeholder();\n\n  // Unstyle the caret on `<select>`s in IE10+.\n  &::-ms-expand {\n    background-color: transparent;\n    border: 0;\n  }\n\n  // Disabled and read-only inputs\n  //\n  // HTML5 says that controls under a fieldset > legend:first-child won't be\n  // disabled if the fieldset is disabled. Due to implementation difficulty, we\n  // don't honor that edge case; we style them as disabled anyway.\n  &[disabled],\n  &[readonly],\n  fieldset[disabled] & {\n    background-color: @input-bg-disabled;\n    opacity: 1; // iOS fix for unreadable disabled content; see https://github.com/twbs/bootstrap/issues/11655\n  }\n\n  &[disabled],\n  fieldset[disabled] & {\n    cursor: @cursor-disabled;\n  }\n\n  // Reset height for `textarea`s\n  textarea& {\n    height: auto;\n  }\n}\n\n\n// Special styles for iOS temporal inputs\n//\n// In Mobile Safari, setting `display: block` on temporal inputs causes the\n// text within the input to become vertically misaligned. As a workaround, we\n// set a pixel line-height that matches the given height of the input, but only\n// for Safari. See https://bugs.webkit.org/show_bug.cgi?id=139848\n//\n// Note that as of 9.3, iOS doesn't support `week`.\n\n@media screen and (-webkit-min-device-pixel-ratio: 0) {\n  input[type=\"date\"],\n  input[type=\"time\"],\n  input[type=\"datetime-local\"],\n  input[type=\"month\"] {\n    &.form-control {\n      line-height: @input-height-base;\n    }\n\n    &.input-sm,\n    .input-group-sm & {\n      line-height: @input-height-small;\n    }\n\n    &.input-lg,\n    .input-group-lg & {\n      line-height: @input-height-large;\n    }\n  }\n}\n\n\n// Form groups\n//\n// Designed to help with the organization and spacing of vertical forms. For\n// horizontal forms, use the predefined grid classes.\n\n.form-group {\n  margin-bottom: @form-group-margin-bottom;\n}\n\n\n// Checkboxes and radios\n//\n// Indent the labels to position radios/checkboxes as hanging controls.\n\n.radio,\n.checkbox {\n  position: relative;\n  display: block;\n  margin-top: 10px;\n  margin-bottom: 10px;\n\n  // These are used on elements with <label> descendants\n  &.disabled,\n  fieldset[disabled] & {\n    label {\n      cursor: @cursor-disabled;\n    }\n  }\n\n  label {\n    min-height: @line-height-computed; // Ensure the input doesn't jump when there is no text\n    padding-left: 20px;\n    margin-bottom: 0;\n    font-weight: 400;\n    cursor: pointer;\n  }\n}\n.radio input[type=\"radio\"],\n.radio-inline input[type=\"radio\"],\n.checkbox input[type=\"checkbox\"],\n.checkbox-inline input[type=\"checkbox\"] {\n  position: absolute;\n  margin-top: 4px \\9;\n  margin-left: -20px;\n}\n\n.radio + .radio,\n.checkbox + .checkbox {\n  margin-top: -5px; // Move up sibling radios or checkboxes for tighter spacing\n}\n\n// Radios and checkboxes on same line\n.radio-inline,\n.checkbox-inline {\n  position: relative;\n  display: inline-block;\n  padding-left: 20px;\n  margin-bottom: 0;\n  font-weight: 400;\n  vertical-align: middle;\n  cursor: pointer;\n\n  // These are used directly on <label>s\n  &.disabled,\n  fieldset[disabled] & {\n    cursor: @cursor-disabled;\n  }\n}\n.radio-inline + .radio-inline,\n.checkbox-inline + .checkbox-inline {\n  margin-top: 0;\n  margin-left: 10px; // space out consecutive inline controls\n}\n\n\n// Static form control text\n//\n// Apply class to a `p` element to make any string of text align with labels in\n// a horizontal form layout.\n\n.form-control-static {\n  min-height: (@line-height-computed + @font-size-base);\n  // Size it appropriately next to real form controls\n  padding-top: (@padding-base-vertical + 1);\n  padding-bottom: (@padding-base-vertical + 1);\n  // Remove default margin from `p`\n  margin-bottom: 0;\n\n  &.input-lg,\n  &.input-sm {\n    padding-right: 0;\n    padding-left: 0;\n  }\n}\n\n\n// Form control sizing\n//\n// Build on `.form-control` with modifier classes to decrease or increase the\n// height and font-size of form controls.\n//\n// The `.form-group-* form-control` variations are sadly duplicated to avoid the\n// issue documented in https://github.com/twbs/bootstrap/issues/15074.\n\n.input-sm {\n  .input-size(@input-height-small; @padding-small-vertical; @padding-small-horizontal; @font-size-small; @line-height-small; @input-border-radius-small);\n}\n.form-group-sm {\n  .form-control {\n    height: @input-height-small;\n    padding: @padding-small-vertical @padding-small-horizontal;\n    font-size: @font-size-small;\n    line-height: @line-height-small;\n    border-radius: @input-border-radius-small;\n  }\n  select.form-control {\n    height: @input-height-small;\n    line-height: @input-height-small;\n  }\n  textarea.form-control,\n  select[multiple].form-control {\n    height: auto;\n  }\n  .form-control-static {\n    height: @input-height-small;\n    min-height: (@line-height-computed + @font-size-small);\n    padding: (@padding-small-vertical + 1) @padding-small-horizontal;\n    font-size: @font-size-small;\n    line-height: @line-height-small;\n  }\n}\n\n.input-lg {\n  .input-size(@input-height-large; @padding-large-vertical; @padding-large-horizontal; @font-size-large; @line-height-large; @input-border-radius-large);\n}\n.form-group-lg {\n  .form-control {\n    height: @input-height-large;\n    padding: @padding-large-vertical @padding-large-horizontal;\n    font-size: @font-size-large;\n    line-height: @line-height-large;\n    border-radius: @input-border-radius-large;\n  }\n  select.form-control {\n    height: @input-height-large;\n    line-height: @input-height-large;\n  }\n  textarea.form-control,\n  select[multiple].form-control {\n    height: auto;\n  }\n  .form-control-static {\n    height: @input-height-large;\n    min-height: (@line-height-computed + @font-size-large);\n    padding: (@padding-large-vertical + 1) @padding-large-horizontal;\n    font-size: @font-size-large;\n    line-height: @line-height-large;\n  }\n}\n\n\n// Form control feedback states\n//\n// Apply contextual and semantic states to individual form controls.\n\n.has-feedback {\n  // Enable absolute positioning\n  position: relative;\n\n  // Ensure icons don't overlap text\n  .form-control {\n    padding-right: (@input-height-base * 1.25);\n  }\n}\n// Feedback icon (requires .glyphicon classes)\n.form-control-feedback {\n  position: absolute;\n  top: 0;\n  right: 0;\n  z-index: 2; // Ensure icon is above input groups\n  display: block;\n  width: @input-height-base;\n  height: @input-height-base;\n  line-height: @input-height-base;\n  text-align: center;\n  pointer-events: none;\n}\n.input-lg + .form-control-feedback,\n.input-group-lg + .form-control-feedback,\n.form-group-lg .form-control + .form-control-feedback {\n  width: @input-height-large;\n  height: @input-height-large;\n  line-height: @input-height-large;\n}\n.input-sm + .form-control-feedback,\n.input-group-sm + .form-control-feedback,\n.form-group-sm .form-control + .form-control-feedback {\n  width: @input-height-small;\n  height: @input-height-small;\n  line-height: @input-height-small;\n}\n\n// Feedback states\n.has-success {\n  .form-control-validation(@state-success-text; @state-success-text; @state-success-bg);\n}\n.has-warning {\n  .form-control-validation(@state-warning-text; @state-warning-text; @state-warning-bg);\n}\n.has-error {\n  .form-control-validation(@state-danger-text; @state-danger-text; @state-danger-bg);\n}\n\n// Reposition feedback icon if input has visible label above\n.has-feedback label {\n\n  & ~ .form-control-feedback {\n    top: (@line-height-computed + 5); // Height of the `label` and its margin\n  }\n  &.sr-only ~ .form-control-feedback {\n    top: 0;\n  }\n}\n\n\n// Help text\n//\n// Apply to any element you wish to create light text for placement immediately\n// below a form control. Use for general help, formatting, or instructional text.\n\n.help-block {\n  display: block; // account for any element using help-block\n  margin-top: 5px;\n  margin-bottom: 10px;\n  color: lighten(@text-color, 25%); // lighten the text some for contrast\n}\n\n\n// Inline forms\n//\n// Make forms appear inline(-block) by adding the `.form-inline` class. Inline\n// forms begin stacked on extra small (mobile) devices and then go inline when\n// viewports reach <768px.\n//\n// Requires wrapping inputs and labels with `.form-group` for proper display of\n// default HTML form controls and our custom form controls (e.g., input groups).\n//\n// Heads up! This is mixin-ed into `.navbar-form` in navbars.less.\n\n.form-inline {\n\n  // Kick in the inline\n  @media (min-width: @screen-sm-min) {\n    // Inline-block all the things for \"inline\"\n    .form-group {\n      display: inline-block;\n      margin-bottom: 0;\n      vertical-align: middle;\n    }\n\n    // In navbar-form, allow folks to *not* use `.form-group`\n    .form-control {\n      display: inline-block;\n      width: auto; // Prevent labels from stacking above inputs in `.form-group`\n      vertical-align: middle;\n    }\n\n    // Make static controls behave like regular ones\n    .form-control-static {\n      display: inline-block;\n    }\n\n    .input-group {\n      display: inline-table;\n      vertical-align: middle;\n\n      .input-group-addon,\n      .input-group-btn,\n      .form-control {\n        width: auto;\n      }\n    }\n\n    // Input groups need that 100% width though\n    .input-group > .form-control {\n      width: 100%;\n    }\n\n    .control-label {\n      margin-bottom: 0;\n      vertical-align: middle;\n    }\n\n    // Remove default margin on radios/checkboxes that were used for stacking, and\n    // then undo the floating of radios and checkboxes to match.\n    .radio,\n    .checkbox {\n      display: inline-block;\n      margin-top: 0;\n      margin-bottom: 0;\n      vertical-align: middle;\n\n      label {\n        padding-left: 0;\n      }\n    }\n    .radio input[type=\"radio\"],\n    .checkbox input[type=\"checkbox\"] {\n      position: relative;\n      margin-left: 0;\n    }\n\n    // Re-override the feedback icon.\n    .has-feedback .form-control-feedback {\n      top: 0;\n    }\n  }\n}\n\n\n// Horizontal forms\n//\n// Horizontal forms are built on grid classes and allow you to create forms with\n// labels on the left and inputs on the right.\n\n.form-horizontal {\n\n  // Consistent vertical alignment of radios and checkboxes\n  //\n  // Labels also get some reset styles, but that is scoped to a media query below.\n  .radio,\n  .checkbox,\n  .radio-inline,\n  .checkbox-inline {\n    padding-top: (@padding-base-vertical + 1); // Default padding plus a border\n    margin-top: 0;\n    margin-bottom: 0;\n  }\n  // Account for padding we're adding to ensure the alignment and of help text\n  // and other content below items\n  .radio,\n  .checkbox {\n    min-height: (@line-height-computed + (@padding-base-vertical + 1));\n  }\n\n  // Make form groups behave like rows\n  .form-group {\n    .make-row();\n  }\n\n  // Reset spacing and right align labels, but scope to media queries so that\n  // labels on narrow viewports stack the same as a default form example.\n  @media (min-width: @screen-sm-min) {\n    .control-label {\n      padding-top: (@padding-base-vertical + 1); // Default padding plus a border\n      margin-bottom: 0;\n      text-align: right;\n    }\n  }\n\n  // Validation states\n  //\n  // Reposition the icon because it's now within a grid column and columns have\n  // `position: relative;` on them. Also accounts for the grid gutter padding.\n  .has-feedback .form-control-feedback {\n    right: floor((@grid-gutter-width / 2));\n  }\n\n  // Form group sizes\n  //\n  // Quick utility class for applying `.input-lg` and `.input-sm` styles to the\n  // inputs and labels within a `.form-group`.\n  .form-group-lg {\n    @media (min-width: @screen-sm-min) {\n      .control-label {\n        padding-top: (@padding-large-vertical + 1);\n        font-size: @font-size-large;\n      }\n    }\n  }\n  .form-group-sm {\n    @media (min-width: @screen-sm-min) {\n      .control-label {\n        padding-top: (@padding-small-vertical + 1);\n        font-size: @font-size-small;\n      }\n    }\n  }\n}\n","// Form validation states\n//\n// Used in forms.less to generate the form validation CSS for warnings, errors,\n// and successes.\n\n.form-control-validation(@text-color: #555; @border-color: #ccc; @background-color: #f5f5f5) {\n  // Color the label and help text\n  .help-block,\n  .control-label,\n  .radio,\n  .checkbox,\n  .radio-inline,\n  .checkbox-inline,\n  &.radio label,\n  &.checkbox label,\n  &.radio-inline label,\n  &.checkbox-inline label  {\n    color: @text-color;\n  }\n  // Set the border and box shadow on specific inputs to match\n  .form-control {\n    border-color: @border-color;\n    .box-shadow(inset 0 1px 1px rgba(0, 0, 0, .075)); // Redeclare so transitions work\n    &:focus {\n      border-color: darken(@border-color, 10%);\n      @shadow: inset 0 1px 1px rgba(0, 0, 0, .075), 0 0 6px lighten(@border-color, 20%);\n      .box-shadow(@shadow);\n    }\n  }\n  // Set validation states also for addons\n  .input-group-addon {\n    color: @text-color;\n    background-color: @background-color;\n    border-color: @border-color;\n  }\n  // Optional feedback icon\n  .form-control-feedback {\n    color: @text-color;\n  }\n}\n\n\n// Form control focus state\n//\n// Generate a customized focus state and for any input with the specified color,\n// which defaults to the `@input-border-focus` variable.\n//\n// We highly encourage you to not customize the default value, but instead use\n// this to tweak colors on an as-needed basis. This aesthetic change is based on\n// WebKit's default styles, but applicable to a wider range of browsers. Its\n// usability and accessibility should be taken into account with any change.\n//\n// Example usage: change the default blue border and shadow to white for better\n// contrast against a dark gray background.\n.form-control-focus(@color: @input-border-focus) {\n  @color-rgba: rgba(red(@color), green(@color), blue(@color), .6);\n  &:focus {\n    border-color: @color;\n    outline: 0;\n    .box-shadow(~\"inset 0 1px 1px rgba(0, 0, 0, .075), 0 0 8px @{color-rgba}\");\n  }\n}\n\n// Form control sizing\n//\n// Relative text size, padding, and border-radii changes for form controls. For\n// horizontal sizing, wrap controls in the predefined grid classes. `<select>`\n// element gets special love because it's special, and that's a fact!\n.input-size(@input-height; @padding-vertical; @padding-horizontal; @font-size; @line-height; @border-radius) {\n  height: @input-height;\n  padding: @padding-vertical @padding-horizontal;\n  font-size: @font-size;\n  line-height: @line-height;\n  border-radius: @border-radius;\n\n  select& {\n    height: @input-height;\n    line-height: @input-height;\n  }\n\n  textarea&,\n  select[multiple]& {\n    height: auto;\n  }\n}\n","// stylelint-disable selector-no-qualifying-type\n\n//\n// Buttons\n// --------------------------------------------------\n\n\n// Base styles\n// --------------------------------------------------\n\n.btn {\n  display: inline-block;\n  margin-bottom: 0; // For input.btn\n  font-weight: @btn-font-weight;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: middle;\n  touch-action: manipulation;\n  cursor: pointer;\n  background-image: none; // Reset unusual Firefox-on-Android default style; see https://github.com/necolas/normalize.css/issues/214\n  border: 1px solid transparent;\n  .button-size(@padding-base-vertical; @padding-base-horizontal; @font-size-base; @line-height-base; @btn-border-radius-base);\n  .user-select(none);\n\n  &,\n  &:active,\n  &.active {\n    &:focus,\n    &.focus {\n      .tab-focus();\n    }\n  }\n\n  &:hover,\n  &:focus,\n  &.focus {\n    color: @btn-default-color;\n    text-decoration: none;\n  }\n\n  &:active,\n  &.active {\n    background-image: none;\n    outline: 0;\n    .box-shadow(inset 0 3px 5px rgba(0, 0, 0, .125));\n  }\n\n  &.disabled,\n  &[disabled],\n  fieldset[disabled] & {\n    cursor: @cursor-disabled;\n    .opacity(.65);\n    .box-shadow(none);\n  }\n\n  a& {\n    &.disabled,\n    fieldset[disabled] & {\n      pointer-events: none; // Future-proof disabling of clicks on `<a>` elements\n    }\n  }\n}\n\n\n// Alternate buttons\n// --------------------------------------------------\n\n.btn-default {\n  .button-variant(@btn-default-color; @btn-default-bg; @btn-default-border);\n}\n.btn-primary {\n  .button-variant(@btn-primary-color; @btn-primary-bg; @btn-primary-border);\n}\n// Success appears as green\n.btn-success {\n  .button-variant(@btn-success-color; @btn-success-bg; @btn-success-border);\n}\n// Info appears as blue-green\n.btn-info {\n  .button-variant(@btn-info-color; @btn-info-bg; @btn-info-border);\n}\n// Warning appears as orange\n.btn-warning {\n  .button-variant(@btn-warning-color; @btn-warning-bg; @btn-warning-border);\n}\n// Danger and error appear as red\n.btn-danger {\n  .button-variant(@btn-danger-color; @btn-danger-bg; @btn-danger-border);\n}\n\n\n// Link buttons\n// -------------------------\n\n// Make a button look and behave like a link\n.btn-link {\n  font-weight: 400;\n  color: @link-color;\n  border-radius: 0;\n\n  &,\n  &:active,\n  &.active,\n  &[disabled],\n  fieldset[disabled] & {\n    background-color: transparent;\n    .box-shadow(none);\n  }\n  &,\n  &:hover,\n  &:focus,\n  &:active {\n    border-color: transparent;\n  }\n  &:hover,\n  &:focus {\n    color: @link-hover-color;\n    text-decoration: @link-hover-decoration;\n    background-color: transparent;\n  }\n  &[disabled],\n  fieldset[disabled] & {\n    &:hover,\n    &:focus {\n      color: @btn-link-disabled-color;\n      text-decoration: none;\n    }\n  }\n}\n\n\n// Button Sizes\n// --------------------------------------------------\n\n.btn-lg {\n  // line-height: ensure even-numbered height of button next to large input\n  .button-size(@padding-large-vertical; @padding-large-horizontal; @font-size-large; @line-height-large; @btn-border-radius-large);\n}\n.btn-sm {\n  // line-height: ensure proper height of button next to small input\n  .button-size(@padding-small-vertical; @padding-small-horizontal; @font-size-small; @line-height-small; @btn-border-radius-small);\n}\n.btn-xs {\n  .button-size(@padding-xs-vertical; @padding-xs-horizontal; @font-size-small; @line-height-small; @btn-border-radius-small);\n}\n\n\n// Block button\n// --------------------------------------------------\n\n.btn-block {\n  display: block;\n  width: 100%;\n}\n\n// Vertically space out multiple block buttons\n.btn-block + .btn-block {\n  margin-top: 5px;\n}\n\n// Specificity overrides\ninput[type=\"submit\"],\ninput[type=\"reset\"],\ninput[type=\"button\"] {\n  &.btn-block {\n    width: 100%;\n  }\n}\n","// Button variants\n//\n// Easily pump out default styles, as well as :hover, :focus, :active,\n// and disabled options for all buttons\n\n.button-variant(@color; @background; @border) {\n  color: @color;\n  background-color: @background;\n  border-color: @border;\n\n  &:focus,\n  &.focus {\n    color: @color;\n    background-color: darken(@background, 10%);\n    border-color: darken(@border, 25%);\n  }\n  &:hover {\n    color: @color;\n    background-color: darken(@background, 10%);\n    border-color: darken(@border, 12%);\n  }\n  &:active,\n  &.active,\n  .open > .dropdown-toggle& {\n    color: @color;\n    background-color: darken(@background, 10%);\n    background-image: none;\n    border-color: darken(@border, 12%);\n\n    &:hover,\n    &:focus,\n    &.focus {\n      color: @color;\n      background-color: darken(@background, 17%);\n      border-color: darken(@border, 25%);\n    }\n  }\n  &.disabled,\n  &[disabled],\n  fieldset[disabled] & {\n    &:hover,\n    &:focus,\n    &.focus {\n      background-color: @background;\n      border-color: @border;\n    }\n  }\n\n  .badge {\n    color: @background;\n    background-color: @color;\n  }\n}\n\n// Button sizes\n.button-size(@padding-vertical; @padding-horizontal; @font-size; @line-height; @border-radius) {\n  padding: @padding-vertical @padding-horizontal;\n  font-size: @font-size;\n  line-height: @line-height;\n  border-radius: @border-radius;\n}\n","// Opacity\n\n.opacity(@opacity) {\n  @opacity-ie: (@opacity * 100);  // IE8 filter\n  filter: ~\"alpha(opacity=@{opacity-ie})\";\n  opacity: @opacity;\n}\n","// stylelint-disable selector-no-qualifying-type\n\n//\n// Component animations\n// --------------------------------------------------\n\n// Heads up!\n//\n// We don't use the `.opacity()` mixin here since it causes a bug with text\n// fields in IE7-8. Source: https://github.com/twbs/bootstrap/pull/3552.\n\n.fade {\n  opacity: 0;\n  .transition(opacity .15s linear);\n\n  &.in {\n    opacity: 1;\n  }\n}\n\n.collapse {\n  display: none;\n\n  &.in      { display: block; }\n  tr&.in    { display: table-row; }\n  tbody&.in { display: table-row-group; }\n}\n\n.collapsing {\n  position: relative;\n  height: 0;\n  overflow: hidden;\n  .transition-property(~\"height, visibility\");\n  .transition-duration(.35s);\n  .transition-timing-function(ease);\n}\n","//\n// Dropdown menus\n// --------------------------------------------------\n\n\n// Dropdown arrow/caret\n.caret {\n  display: inline-block;\n  width: 0;\n  height: 0;\n  margin-left: 2px;\n  vertical-align: middle;\n  border-top: @caret-width-base dashed;\n  border-top: @caret-width-base solid ~\"\\9\"; // IE8\n  border-right: @caret-width-base solid transparent;\n  border-left: @caret-width-base solid transparent;\n}\n\n// The dropdown wrapper (div)\n.dropup,\n.dropdown {\n  position: relative;\n}\n\n// Prevent the focus on the dropdown toggle when closing dropdowns\n.dropdown-toggle:focus {\n  outline: 0;\n}\n\n// The dropdown menu (ul)\n.dropdown-menu {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  z-index: @zindex-dropdown;\n  display: none; // none by default, but block on \"open\" of the menu\n  float: left;\n  min-width: 160px;\n  padding: 5px 0;\n  margin: 2px 0 0; // override default ul\n  font-size: @font-size-base;\n  text-align: left; // Ensures proper alignment if parent has it changed (e.g., modal footer)\n  list-style: none;\n  background-color: @dropdown-bg;\n  background-clip: padding-box;\n  border: 1px solid @dropdown-fallback-border; // IE8 fallback\n  border: 1px solid @dropdown-border;\n  border-radius: @border-radius-base;\n  .box-shadow(0 6px 12px rgba(0, 0, 0, .175));\n\n  // Aligns the dropdown menu to right\n  //\n  // Deprecated as of 3.1.0 in favor of `.dropdown-menu-[dir]`\n  &.pull-right {\n    right: 0;\n    left: auto;\n  }\n\n  // Dividers (basically an hr) within the dropdown\n  .divider {\n    .nav-divider(@dropdown-divider-bg);\n  }\n\n  // Links within the dropdown menu\n  > li > a {\n    display: block;\n    padding: 3px 20px;\n    clear: both;\n    font-weight: 400;\n    line-height: @line-height-base;\n    color: @dropdown-link-color;\n    white-space: nowrap; // prevent links from randomly breaking onto new lines\n\n    &:hover,\n    &:focus {\n      color: @dropdown-link-hover-color;\n      text-decoration: none;\n      background-color: @dropdown-link-hover-bg;\n    }\n  }\n}\n\n// Active state\n.dropdown-menu > .active > a {\n  &,\n  &:hover,\n  &:focus {\n    color: @dropdown-link-active-color;\n    text-decoration: none;\n    background-color: @dropdown-link-active-bg;\n    outline: 0;\n  }\n}\n\n// Disabled state\n//\n// Gray out text and ensure the hover/focus state remains gray\n\n.dropdown-menu > .disabled > a {\n  &,\n  &:hover,\n  &:focus {\n    color: @dropdown-link-disabled-color;\n  }\n\n  // Nuke hover/focus effects\n  &:hover,\n  &:focus {\n    text-decoration: none;\n    cursor: @cursor-disabled;\n    background-color: transparent;\n    background-image: none; // Remove CSS gradient\n    .reset-filter();\n  }\n}\n\n// Open state for the dropdown\n.open {\n  // Show the menu\n  > .dropdown-menu {\n    display: block;\n  }\n\n  // Remove the outline when :focus is triggered\n  > a {\n    outline: 0;\n  }\n}\n\n// Menu positioning\n//\n// Add extra class to `.dropdown-menu` to flip the alignment of the dropdown\n// menu with the parent.\n.dropdown-menu-right {\n  right: 0;\n  left: auto; // Reset the default from `.dropdown-menu`\n}\n// With v3, we enabled auto-flipping if you have a dropdown within a right\n// aligned nav component. To enable the undoing of that, we provide an override\n// to restore the default dropdown menu alignment.\n//\n// This is only for left-aligning a dropdown menu within a `.navbar-right` or\n// `.pull-right` nav component.\n.dropdown-menu-left {\n  right: auto;\n  left: 0;\n}\n\n// Dropdown section headers\n.dropdown-header {\n  display: block;\n  padding: 3px 20px;\n  font-size: @font-size-small;\n  line-height: @line-height-base;\n  color: @dropdown-header-color;\n  white-space: nowrap; // as with > li > a\n}\n\n// Backdrop to catch body clicks on mobile, etc.\n.dropdown-backdrop {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: (@zindex-dropdown - 10);\n}\n\n// Right aligned dropdowns\n.pull-right > .dropdown-menu {\n  right: 0;\n  left: auto;\n}\n\n// Allow for dropdowns to go bottom up (aka, dropup-menu)\n//\n// Just add .dropup after the standard .dropdown class and you're set, bro.\n// TODO: abstract this so that the navbar fixed styles are not placed here?\n\n.dropup,\n.navbar-fixed-bottom .dropdown {\n  // Reverse the caret\n  .caret {\n    content: \"\";\n    border-top: 0;\n    border-bottom: @caret-width-base dashed;\n    border-bottom: @caret-width-base solid ~\"\\9\"; // IE8\n  }\n  // Different positioning for bottom up menu\n  .dropdown-menu {\n    top: auto;\n    bottom: 100%;\n    margin-bottom: 2px;\n  }\n}\n\n\n// Component alignment\n//\n// Reiterate per navbar.less and the modified component alignment there.\n\n@media (min-width: @grid-float-breakpoint) {\n  .navbar-right {\n    .dropdown-menu {\n      .dropdown-menu-right();\n    }\n    // Necessary for overrides of the default right aligned menu.\n    // Will remove come v4 in all likelihood.\n    .dropdown-menu-left {\n      .dropdown-menu-left();\n    }\n  }\n}\n","// Horizontal dividers\n//\n// Dividers (basically an hr) within dropdowns and nav lists\n\n.nav-divider(@color: #e5e5e5) {\n  height: 1px;\n  margin: ((@line-height-computed / 2) - 1) 0;\n  overflow: hidden;\n  background-color: @color;\n}\n","// Reset filters for IE\n//\n// When you need to remove a gradient background, do not forget to use this to reset\n// the IE filter for IE9 and below.\n\n.reset-filter() {\n  filter: e(%(\"progid:DXImageTransform.Microsoft.gradient(enabled = false)\"));\n}\n","// stylelint-disable selector-no-qualifying-type */\n\n//\n// Button groups\n// --------------------------------------------------\n\n// Make the div behave like a button\n.btn-group,\n.btn-group-vertical {\n  position: relative;\n  display: inline-block;\n  vertical-align: middle; // match .btn alignment given font-size hack above\n  > .btn {\n    position: relative;\n    float: left;\n    // Bring the \"active\" button to the front\n    &:hover,\n    &:focus,\n    &:active,\n    &.active {\n      z-index: 2;\n    }\n  }\n}\n\n// Prevent double borders when buttons are next to each other\n.btn-group {\n  .btn + .btn,\n  .btn + .btn-group,\n  .btn-group + .btn,\n  .btn-group + .btn-group {\n    margin-left: -1px;\n  }\n}\n\n// Optional: Group multiple button groups together for a toolbar\n.btn-toolbar {\n  margin-left: -5px; // Offset the first child's margin\n  &:extend(.clearfix all);\n\n  .btn,\n  .btn-group,\n  .input-group {\n    float: left;\n  }\n  > .btn,\n  > .btn-group,\n  > .input-group {\n    margin-left: 5px;\n  }\n}\n\n.btn-group > .btn:not(:first-child):not(:last-child):not(.dropdown-toggle) {\n  border-radius: 0;\n}\n\n// Set corners individual because sometimes a single button can be in a .btn-group and we need :first-child and :last-child to both match\n.btn-group > .btn:first-child {\n  margin-left: 0;\n  &:not(:last-child):not(.dropdown-toggle) {\n    .border-right-radius(0);\n  }\n}\n// Need .dropdown-toggle since :last-child doesn't apply, given that a .dropdown-menu is used immediately after it\n.btn-group > .btn:last-child:not(:first-child),\n.btn-group > .dropdown-toggle:not(:first-child) {\n  .border-left-radius(0);\n}\n\n// Custom edits for including btn-groups within btn-groups (useful for including dropdown buttons within a btn-group)\n.btn-group > .btn-group {\n  float: left;\n}\n.btn-group > .btn-group:not(:first-child):not(:last-child) > .btn {\n  border-radius: 0;\n}\n.btn-group > .btn-group:first-child:not(:last-child) {\n  > .btn:last-child,\n  > .dropdown-toggle {\n    .border-right-radius(0);\n  }\n}\n.btn-group > .btn-group:last-child:not(:first-child) > .btn:first-child {\n  .border-left-radius(0);\n}\n\n// On active and open, don't show outline\n.btn-group .dropdown-toggle:active,\n.btn-group.open .dropdown-toggle {\n  outline: 0;\n}\n\n\n// Sizing\n//\n// Remix the default button sizing classes into new ones for easier manipulation.\n\n.btn-group-xs > .btn { &:extend(.btn-xs); }\n.btn-group-sm > .btn { &:extend(.btn-sm); }\n.btn-group-lg > .btn { &:extend(.btn-lg); }\n\n\n// Split button dropdowns\n// ----------------------\n\n// Give the line between buttons some depth\n.btn-group > .btn + .dropdown-toggle {\n  padding-right: 8px;\n  padding-left: 8px;\n}\n.btn-group > .btn-lg + .dropdown-toggle {\n  padding-right: 12px;\n  padding-left: 12px;\n}\n\n// The clickable button for toggling the menu\n// Remove the gradient and set the same inset shadow as the :active state\n.btn-group.open .dropdown-toggle {\n  .box-shadow(inset 0 3px 5px rgba(0, 0, 0, .125));\n\n  // Show no shadow for `.btn-link` since it has no other button styles.\n  &.btn-link {\n    .box-shadow(none);\n  }\n}\n\n\n// Reposition the caret\n.btn .caret {\n  margin-left: 0;\n}\n// Carets in other button sizes\n.btn-lg .caret {\n  border-width: @caret-width-large @caret-width-large 0;\n  border-bottom-width: 0;\n}\n// Upside down carets for .dropup\n.dropup .btn-lg .caret {\n  border-width: 0 @caret-width-large @caret-width-large;\n}\n\n\n// Vertical button groups\n// ----------------------\n\n.btn-group-vertical {\n  > .btn,\n  > .btn-group,\n  > .btn-group > .btn {\n    display: block;\n    float: none;\n    width: 100%;\n    max-width: 100%;\n  }\n\n  // Clear floats so dropdown menus can be properly placed\n  > .btn-group {\n    &:extend(.clearfix all);\n    > .btn {\n      float: none;\n    }\n  }\n\n  > .btn + .btn,\n  > .btn + .btn-group,\n  > .btn-group + .btn,\n  > .btn-group + .btn-group {\n    margin-top: -1px;\n    margin-left: 0;\n  }\n}\n\n.btn-group-vertical > .btn {\n  &:not(:first-child):not(:last-child) {\n    border-radius: 0;\n  }\n  &:first-child:not(:last-child) {\n    .border-top-radius(@btn-border-radius-base);\n    .border-bottom-radius(0);\n  }\n  &:last-child:not(:first-child) {\n    .border-top-radius(0);\n    .border-bottom-radius(@btn-border-radius-base);\n  }\n}\n.btn-group-vertical > .btn-group:not(:first-child):not(:last-child) > .btn {\n  border-radius: 0;\n}\n.btn-group-vertical > .btn-group:first-child:not(:last-child) {\n  > .btn:last-child,\n  > .dropdown-toggle {\n    .border-bottom-radius(0);\n  }\n}\n.btn-group-vertical > .btn-group:last-child:not(:first-child) > .btn:first-child {\n  .border-top-radius(0);\n}\n\n\n// Justified button groups\n// ----------------------\n\n.btn-group-justified {\n  display: table;\n  width: 100%;\n  table-layout: fixed;\n  border-collapse: separate;\n  > .btn,\n  > .btn-group {\n    display: table-cell;\n    float: none;\n    width: 1%;\n  }\n  > .btn-group .btn {\n    width: 100%;\n  }\n\n  > .btn-group .dropdown-menu {\n    left: auto;\n  }\n}\n\n\n// Checkbox and radio options\n//\n// In order to support the browser's form validation feedback, powered by the\n// `required` attribute, we have to \"hide\" the inputs via `clip`. We cannot use\n// `display: none;` or `visibility: hidden;` as that also hides the popover.\n// Simply visually hiding the inputs via `opacity` would leave them clickable in\n// certain cases which is prevented by using `clip` and `pointer-events`.\n// This way, we ensure a DOM element is visible to position the popover from.\n//\n// See https://github.com/twbs/bootstrap/pull/12794 and\n// https://github.com/twbs/bootstrap/pull/14559 for more information.\n\n[data-toggle=\"buttons\"] {\n  > .btn,\n  > .btn-group > .btn {\n    input[type=\"radio\"],\n    input[type=\"checkbox\"] {\n      position: absolute;\n      clip: rect(0, 0, 0, 0);\n      pointer-events: none;\n    }\n  }\n}\n","// Single side border-radius\n\n.border-top-radius(@radius) {\n  border-top-left-radius: @radius;\n  border-top-right-radius: @radius;\n}\n.border-right-radius(@radius) {\n  border-top-right-radius: @radius;\n  border-bottom-right-radius: @radius;\n}\n.border-bottom-radius(@radius) {\n  border-bottom-right-radius: @radius;\n  border-bottom-left-radius: @radius;\n}\n.border-left-radius(@radius) {\n  border-top-left-radius: @radius;\n  border-bottom-left-radius: @radius;\n}\n","// stylelint-disable selector-no-qualifying-type\n\n//\n// Input groups\n// --------------------------------------------------\n\n// Base styles\n// -------------------------\n.input-group {\n  position: relative; // For dropdowns\n  display: table;\n  border-collapse: separate; // prevent input groups from inheriting border styles from table cells when placed within a table\n\n  // Undo padding and float of grid classes\n  &[class*=\"col-\"] {\n    float: none;\n    padding-right: 0;\n    padding-left: 0;\n  }\n\n  .form-control {\n    // Ensure that the input is always above the *appended* addon button for\n    // proper border colors.\n    position: relative;\n    z-index: 2;\n\n    // IE9 fubars the placeholder attribute in text inputs and the arrows on\n    // select elements in input groups. To fix it, we float the input. Details:\n    // https://github.com/twbs/bootstrap/issues/11561#issuecomment-28936855\n    float: left;\n\n    width: 100%;\n    margin-bottom: 0;\n\n    &:focus {\n      z-index: 3;\n    }\n  }\n}\n\n// Sizing options\n//\n// Remix the default form control sizing classes into new ones for easier\n// manipulation.\n\n.input-group-lg > .form-control,\n.input-group-lg > .input-group-addon,\n.input-group-lg > .input-group-btn > .btn {\n  .input-lg();\n}\n.input-group-sm > .form-control,\n.input-group-sm > .input-group-addon,\n.input-group-sm > .input-group-btn > .btn {\n  .input-sm();\n}\n\n\n// Display as table-cell\n// -------------------------\n.input-group-addon,\n.input-group-btn,\n.input-group .form-control {\n  display: table-cell;\n\n  &:not(:first-child):not(:last-child) {\n    border-radius: 0;\n  }\n}\n// Addon and addon wrapper for buttons\n.input-group-addon,\n.input-group-btn {\n  width: 1%;\n  white-space: nowrap;\n  vertical-align: middle; // Match the inputs\n}\n\n// Text input groups\n// -------------------------\n.input-group-addon {\n  padding: @padding-base-vertical @padding-base-horizontal;\n  font-size: @font-size-base;\n  font-weight: 400;\n  line-height: 1;\n  color: @input-color;\n  text-align: center;\n  background-color: @input-group-addon-bg;\n  border: 1px solid @input-group-addon-border-color;\n  border-radius: @input-border-radius;\n\n  // Sizing\n  &.input-sm {\n    padding: @padding-small-vertical @padding-small-horizontal;\n    font-size: @font-size-small;\n    border-radius: @input-border-radius-small;\n  }\n  &.input-lg {\n    padding: @padding-large-vertical @padding-large-horizontal;\n    font-size: @font-size-large;\n    border-radius: @input-border-radius-large;\n  }\n\n  // Nuke default margins from checkboxes and radios to vertically center within.\n  input[type=\"radio\"],\n  input[type=\"checkbox\"] {\n    margin-top: 0;\n  }\n}\n\n// Reset rounded corners\n.input-group .form-control:first-child,\n.input-group-addon:first-child,\n.input-group-btn:first-child > .btn,\n.input-group-btn:first-child > .btn-group > .btn,\n.input-group-btn:first-child > .dropdown-toggle,\n.input-group-btn:last-child > .btn:not(:last-child):not(.dropdown-toggle),\n.input-group-btn:last-child > .btn-group:not(:last-child) > .btn {\n  .border-right-radius(0);\n}\n.input-group-addon:first-child {\n  border-right: 0;\n}\n.input-group .form-control:last-child,\n.input-group-addon:last-child,\n.input-group-btn:last-child > .btn,\n.input-group-btn:last-child > .btn-group > .btn,\n.input-group-btn:last-child > .dropdown-toggle,\n.input-group-btn:first-child > .btn:not(:first-child),\n.input-group-btn:first-child > .btn-group:not(:first-child) > .btn {\n  .border-left-radius(0);\n}\n.input-group-addon:last-child {\n  border-left: 0;\n}\n\n// Button input groups\n// -------------------------\n.input-group-btn {\n  position: relative;\n  // Jankily prevent input button groups from wrapping with `white-space` and\n  // `font-size` in combination with `inline-block` on buttons.\n  font-size: 0;\n  white-space: nowrap;\n\n  // Negative margin for spacing, position for bringing hovered/focused/actived\n  // element above the siblings.\n  > .btn {\n    position: relative;\n    + .btn {\n      margin-left: -1px;\n    }\n    // Bring the \"active\" button to the front\n    &:hover,\n    &:focus,\n    &:active {\n      z-index: 2;\n    }\n  }\n\n  // Negative margin to only have a 1px border between the two\n  &:first-child {\n    > .btn,\n    > .btn-group {\n      margin-right: -1px;\n    }\n  }\n  &:last-child {\n    > .btn,\n    > .btn-group {\n      z-index: 2;\n      margin-left: -1px;\n    }\n  }\n}\n","// stylelint-disable selector-no-qualifying-type, selector-max-type\n\n//\n// Navs\n// --------------------------------------------------\n\n\n// Base class\n// --------------------------------------------------\n\n.nav {\n  padding-left: 0; // Override default ul/ol\n  margin-bottom: 0;\n  list-style: none;\n  &:extend(.clearfix all);\n\n  > li {\n    position: relative;\n    display: block;\n\n    > a {\n      position: relative;\n      display: block;\n      padding: @nav-link-padding;\n      &:hover,\n      &:focus {\n        text-decoration: none;\n        background-color: @nav-link-hover-bg;\n      }\n    }\n\n    // Disabled state sets text to gray and nukes hover/tab effects\n    &.disabled > a {\n      color: @nav-disabled-link-color;\n\n      &:hover,\n      &:focus {\n        color: @nav-disabled-link-hover-color;\n        text-decoration: none;\n        cursor: @cursor-disabled;\n        background-color: transparent;\n      }\n    }\n  }\n\n  // Open dropdowns\n  .open > a {\n    &,\n    &:hover,\n    &:focus {\n      background-color: @nav-link-hover-bg;\n      border-color: @link-color;\n    }\n  }\n\n  // Nav dividers (deprecated with v3.0.1)\n  //\n  // This should have been removed in v3 with the dropping of `.nav-list`, but\n  // we missed it. We don't currently support this anywhere, but in the interest\n  // of maintaining backward compatibility in case you use it, it's deprecated.\n  .nav-divider {\n    .nav-divider();\n  }\n\n  // Prevent IE8 from misplacing imgs\n  //\n  // See https://github.com/h5bp/html5-boilerplate/issues/984#issuecomment-3985989\n  > li > a > img {\n    max-width: none;\n  }\n}\n\n\n// Tabs\n// -------------------------\n\n// Give the tabs something to sit on\n.nav-tabs {\n  border-bottom: 1px solid @nav-tabs-border-color;\n  > li {\n    float: left;\n    // Make the list-items overlay the bottom border\n    margin-bottom: -1px;\n\n    // Actual tabs (as links)\n    > a {\n      margin-right: 2px;\n      line-height: @line-height-base;\n      border: 1px solid transparent;\n      border-radius: @border-radius-base @border-radius-base 0 0;\n      &:hover {\n        border-color: @nav-tabs-link-hover-border-color @nav-tabs-link-hover-border-color @nav-tabs-border-color;\n      }\n    }\n\n    // Active state, and its :hover to override normal :hover\n    &.active > a {\n      &,\n      &:hover,\n      &:focus {\n        color: @nav-tabs-active-link-hover-color;\n        cursor: default;\n        background-color: @nav-tabs-active-link-hover-bg;\n        border: 1px solid @nav-tabs-active-link-hover-border-color;\n        border-bottom-color: transparent;\n      }\n    }\n  }\n  // pulling this in mainly for less shorthand\n  &.nav-justified {\n    .nav-justified();\n    .nav-tabs-justified();\n  }\n}\n\n\n// Pills\n// -------------------------\n.nav-pills {\n  > li {\n    float: left;\n\n    // Links rendered as pills\n    > a {\n      border-radius: @nav-pills-border-radius;\n    }\n    + li {\n      margin-left: 2px;\n    }\n\n    // Active state\n    &.active > a {\n      &,\n      &:hover,\n      &:focus {\n        color: @nav-pills-active-link-hover-color;\n        background-color: @nav-pills-active-link-hover-bg;\n      }\n    }\n  }\n}\n\n\n// Stacked pills\n.nav-stacked {\n  > li {\n    float: none;\n    + li {\n      margin-top: 2px;\n      margin-left: 0; // no need for this gap between nav items\n    }\n  }\n}\n\n\n// Nav variations\n// --------------------------------------------------\n\n// Justified nav links\n// -------------------------\n\n.nav-justified {\n  width: 100%;\n\n  > li {\n    float: none;\n    > a {\n      margin-bottom: 5px;\n      text-align: center;\n    }\n  }\n\n  > .dropdown .dropdown-menu {\n    top: auto;\n    left: auto;\n  }\n\n  @media (min-width: @screen-sm-min) {\n    > li {\n      display: table-cell;\n      width: 1%;\n      > a {\n        margin-bottom: 0;\n      }\n    }\n  }\n}\n\n// Move borders to anchors instead of bottom of list\n//\n// Mixin for adding on top the shared `.nav-justified` styles for our tabs\n.nav-tabs-justified {\n  border-bottom: 0;\n\n  > li > a {\n    // Override margin from .nav-tabs\n    margin-right: 0;\n    border-radius: @border-radius-base;\n  }\n\n  > .active > a,\n  > .active > a:hover,\n  > .active > a:focus {\n    border: 1px solid @nav-tabs-justified-link-border-color;\n  }\n\n  @media (min-width: @screen-sm-min) {\n    > li > a {\n      border-bottom: 1px solid @nav-tabs-justified-link-border-color;\n      border-radius: @border-radius-base @border-radius-base 0 0;\n    }\n    > .active > a,\n    > .active > a:hover,\n    > .active > a:focus {\n      border-bottom-color: @nav-tabs-justified-active-link-border-color;\n    }\n  }\n}\n\n\n// Tabbable tabs\n// -------------------------\n\n// Hide tabbable panes to start, show them when `.active`\n.tab-content {\n  > .tab-pane {\n    display: none;\n  }\n  > .active {\n    display: block;\n  }\n}\n\n\n// Dropdowns\n// -------------------------\n\n// Specific dropdowns\n.nav-tabs .dropdown-menu {\n  // make dropdown border overlap tab border\n  margin-top: -1px;\n  // Remove the top rounded corners here since there is a hard edge above the menu\n  .border-top-radius(0);\n}\n","// stylelint-disable selector-max-type, selector-max-compound-selectors, selector-max-combinators, selector-max-class, declaration-no-important, selector-no-qualifying-type\n\n//\n// Navbars\n// --------------------------------------------------\n\n\n// Wrapper and base class\n//\n// Provide a static navbar from which we expand to create full-width, fixed, and\n// other navbar variations.\n\n.navbar {\n  position: relative;\n  min-height: @navbar-height; // Ensure a navbar always shows (e.g., without a .navbar-brand in collapsed mode)\n  margin-bottom: @navbar-margin-bottom;\n  border: 1px solid transparent;\n\n  // Prevent floats from breaking the navbar\n  &:extend(.clearfix all);\n\n  @media (min-width: @grid-float-breakpoint) {\n    border-radius: @navbar-border-radius;\n  }\n}\n\n\n// Navbar heading\n//\n// Groups `.navbar-brand` and `.navbar-toggle` into a single component for easy\n// styling of responsive aspects.\n\n.navbar-header {\n  &:extend(.clearfix all);\n\n  @media (min-width: @grid-float-breakpoint) {\n    float: left;\n  }\n}\n\n\n// Navbar collapse (body)\n//\n// Group your navbar content into this for easy collapsing and expanding across\n// various device sizes. By default, this content is collapsed when <768px, but\n// will expand past that for a horizontal display.\n//\n// To start (on mobile devices) the navbar links, forms, and buttons are stacked\n// vertically and include a `max-height` to overflow in case you have too much\n// content for the user's viewport.\n\n.navbar-collapse {\n  padding-right: @navbar-padding-horizontal;\n  padding-left: @navbar-padding-horizontal;\n  overflow-x: visible;\n  border-top: 1px solid transparent;\n  box-shadow: inset 0 1px 0 rgba(255, 255, 255, .1);\n  &:extend(.clearfix all);\n  -webkit-overflow-scrolling: touch;\n\n  &.in {\n    overflow-y: auto;\n  }\n\n  @media (min-width: @grid-float-breakpoint) {\n    width: auto;\n    border-top: 0;\n    box-shadow: none;\n\n    &.collapse {\n      display: block !important;\n      height: auto !important;\n      padding-bottom: 0; // Override default setting\n      overflow: visible !important;\n    }\n\n    &.in {\n      overflow-y: visible;\n    }\n\n    // Undo the collapse side padding for navbars with containers to ensure\n    // alignment of right-aligned contents.\n    .navbar-fixed-top &,\n    .navbar-static-top &,\n    .navbar-fixed-bottom & {\n      padding-right: 0;\n      padding-left: 0;\n    }\n  }\n}\n\n.navbar-fixed-top,\n.navbar-fixed-bottom {\n  .navbar-collapse {\n    max-height: @navbar-collapse-max-height;\n\n    @media (max-device-width: @screen-xs-min) and (orientation: landscape) {\n      max-height: 200px;\n    }\n  }\n\n  // Fix the top/bottom navbars when screen real estate supports it\n  position: fixed;\n  right: 0;\n  left: 0;\n  z-index: @zindex-navbar-fixed;\n\n  // Undo the rounded corners\n  @media (min-width: @grid-float-breakpoint) {\n    border-radius: 0;\n  }\n}\n\n.navbar-fixed-top {\n  top: 0;\n  border-width: 0 0 1px;\n}\n.navbar-fixed-bottom {\n  bottom: 0;\n  margin-bottom: 0; // override .navbar defaults\n  border-width: 1px 0 0;\n}\n\n\n// Both navbar header and collapse\n//\n// When a container is present, change the behavior of the header and collapse.\n\n.container,\n.container-fluid {\n  > .navbar-header,\n  > .navbar-collapse {\n    margin-right: -@navbar-padding-horizontal;\n    margin-left: -@navbar-padding-horizontal;\n\n    @media (min-width: @grid-float-breakpoint) {\n      margin-right: 0;\n      margin-left: 0;\n    }\n  }\n}\n\n\n//\n// Navbar alignment options\n//\n// Display the navbar across the entirety of the page or fixed it to the top or\n// bottom of the page.\n\n// Static top (unfixed, but 100% wide) navbar\n.navbar-static-top {\n  z-index: @zindex-navbar;\n  border-width: 0 0 1px;\n\n  @media (min-width: @grid-float-breakpoint) {\n    border-radius: 0;\n  }\n}\n\n\n// Brand/project name\n\n.navbar-brand {\n  float: left;\n  height: @navbar-height;\n  padding: @navbar-padding-vertical @navbar-padding-horizontal;\n  font-size: @font-size-large;\n  line-height: @line-height-computed;\n\n  &:hover,\n  &:focus {\n    text-decoration: none;\n  }\n\n  > img {\n    display: block;\n  }\n\n  @media (min-width: @grid-float-breakpoint) {\n    .navbar > .container &,\n    .navbar > .container-fluid & {\n      margin-left: -@navbar-padding-horizontal;\n    }\n  }\n}\n\n\n// Navbar toggle\n//\n// Custom button for toggling the `.navbar-collapse`, powered by the collapse\n// JavaScript plugin.\n\n.navbar-toggle {\n  position: relative;\n  float: right;\n  padding: 9px 10px;\n  margin-right: @navbar-padding-horizontal;\n  .navbar-vertical-align(34px);\n  background-color: transparent;\n  background-image: none; // Reset unusual Firefox-on-Android default style; see https://github.com/necolas/normalize.css/issues/214\n  border: 1px solid transparent;\n  border-radius: @border-radius-base;\n\n  // We remove the `outline` here, but later compensate by attaching `:hover`\n  // styles to `:focus`.\n  &:focus {\n    outline: 0;\n  }\n\n  // Bars\n  .icon-bar {\n    display: block;\n    width: 22px;\n    height: 2px;\n    border-radius: 1px;\n  }\n  .icon-bar + .icon-bar {\n    margin-top: 4px;\n  }\n\n  @media (min-width: @grid-float-breakpoint) {\n    display: none;\n  }\n}\n\n\n// Navbar nav links\n//\n// Builds on top of the `.nav` components with its own modifier class to make\n// the nav the full height of the horizontal nav (above 768px).\n\n.navbar-nav {\n  margin: (@navbar-padding-vertical / 2) -@navbar-padding-horizontal;\n\n  > li > a {\n    padding-top: 10px;\n    padding-bottom: 10px;\n    line-height: @line-height-computed;\n  }\n\n  @media (max-width: @grid-float-breakpoint-max) {\n    // Dropdowns get custom display when collapsed\n    .open .dropdown-menu {\n      position: static;\n      float: none;\n      width: auto;\n      margin-top: 0;\n      background-color: transparent;\n      border: 0;\n      box-shadow: none;\n      > li > a,\n      .dropdown-header {\n        padding: 5px 15px 5px 25px;\n      }\n      > li > a {\n        line-height: @line-height-computed;\n        &:hover,\n        &:focus {\n          background-image: none;\n        }\n      }\n    }\n  }\n\n  // Uncollapse the nav\n  @media (min-width: @grid-float-breakpoint) {\n    float: left;\n    margin: 0;\n\n    > li {\n      float: left;\n      > a {\n        padding-top: @navbar-padding-vertical;\n        padding-bottom: @navbar-padding-vertical;\n      }\n    }\n  }\n}\n\n\n// Navbar form\n//\n// Extension of the `.form-inline` with some extra flavor for optimum display in\n// our navbars.\n\n.navbar-form {\n  padding: 10px @navbar-padding-horizontal;\n  margin-right: -@navbar-padding-horizontal;\n  margin-left: -@navbar-padding-horizontal;\n  border-top: 1px solid transparent;\n  border-bottom: 1px solid transparent;\n  @shadow: inset 0 1px 0 rgba(255, 255, 255, .1), 0 1px 0 rgba(255, 255, 255, .1);\n  .box-shadow(@shadow);\n\n  // Mixin behavior for optimum display\n  .form-inline();\n\n  .form-group {\n    @media (max-width: @grid-float-breakpoint-max) {\n      margin-bottom: 5px;\n\n      &:last-child {\n        margin-bottom: 0;\n      }\n    }\n  }\n\n  // Vertically center in expanded, horizontal navbar\n  .navbar-vertical-align(@input-height-base);\n\n  // Undo 100% width for pull classes\n  @media (min-width: @grid-float-breakpoint) {\n    width: auto;\n    padding-top: 0;\n    padding-bottom: 0;\n    margin-right: 0;\n    margin-left: 0;\n    border: 0;\n    .box-shadow(none);\n  }\n}\n\n\n// Dropdown menus\n\n// Menu position and menu carets\n.navbar-nav > li > .dropdown-menu {\n  margin-top: 0;\n  .border-top-radius(0);\n}\n// Menu position and menu caret support for dropups via extra dropup class\n.navbar-fixed-bottom .navbar-nav > li > .dropdown-menu {\n  margin-bottom: 0;\n  .border-top-radius(@navbar-border-radius);\n  .border-bottom-radius(0);\n}\n\n\n// Buttons in navbars\n//\n// Vertically center a button within a navbar (when *not* in a form).\n\n.navbar-btn {\n  .navbar-vertical-align(@input-height-base);\n\n  &.btn-sm {\n    .navbar-vertical-align(@input-height-small);\n  }\n  &.btn-xs {\n    .navbar-vertical-align(22);\n  }\n}\n\n\n// Text in navbars\n//\n// Add a class to make any element properly align itself vertically within the navbars.\n\n.navbar-text {\n  .navbar-vertical-align(@line-height-computed);\n\n  @media (min-width: @grid-float-breakpoint) {\n    float: left;\n    margin-right: @navbar-padding-horizontal;\n    margin-left: @navbar-padding-horizontal;\n  }\n}\n\n\n// Component alignment\n//\n// Repurpose the pull utilities as their own navbar utilities to avoid specificity\n// issues with parents and chaining. Only do this when the navbar is uncollapsed\n// though so that navbar contents properly stack and align in mobile.\n//\n// Declared after the navbar components to ensure more specificity on the margins.\n\n@media (min-width: @grid-float-breakpoint) {\n  .navbar-left  { .pull-left(); }\n  .navbar-right {\n    .pull-right();\n    margin-right: -@navbar-padding-horizontal;\n\n    ~ .navbar-right {\n      margin-right: 0;\n    }\n  }\n}\n\n\n// Alternate navbars\n// --------------------------------------------------\n\n// Default navbar\n.navbar-default {\n  background-color: @navbar-default-bg;\n  border-color: @navbar-default-border;\n\n  .navbar-brand {\n    color: @navbar-default-brand-color;\n    &:hover,\n    &:focus {\n      color: @navbar-default-brand-hover-color;\n      background-color: @navbar-default-brand-hover-bg;\n    }\n  }\n\n  .navbar-text {\n    color: @navbar-default-color;\n  }\n\n  .navbar-nav {\n    > li > a {\n      color: @navbar-default-link-color;\n\n      &:hover,\n      &:focus {\n        color: @navbar-default-link-hover-color;\n        background-color: @navbar-default-link-hover-bg;\n      }\n    }\n    > .active > a {\n      &,\n      &:hover,\n      &:focus {\n        color: @navbar-default-link-active-color;\n        background-color: @navbar-default-link-active-bg;\n      }\n    }\n    > .disabled > a {\n      &,\n      &:hover,\n      &:focus {\n        color: @navbar-default-link-disabled-color;\n        background-color: @navbar-default-link-disabled-bg;\n      }\n    }\n\n    // Dropdown menu items\n    // Remove background color from open dropdown\n    > .open > a {\n      &,\n      &:hover,\n      &:focus {\n        color: @navbar-default-link-active-color;\n        background-color: @navbar-default-link-active-bg;\n      }\n    }\n\n    @media (max-width: @grid-float-breakpoint-max) {\n      // Dropdowns get custom display when collapsed\n      .open .dropdown-menu {\n        > li > a {\n          color: @navbar-default-link-color;\n          &:hover,\n          &:focus {\n            color: @navbar-default-link-hover-color;\n            background-color: @navbar-default-link-hover-bg;\n          }\n        }\n        > .active > a {\n          &,\n          &:hover,\n          &:focus {\n            color: @navbar-default-link-active-color;\n            background-color: @navbar-default-link-active-bg;\n          }\n        }\n        > .disabled > a {\n          &,\n          &:hover,\n          &:focus {\n            color: @navbar-default-link-disabled-color;\n            background-color: @navbar-default-link-disabled-bg;\n          }\n        }\n      }\n    }\n  }\n\n  .navbar-toggle {\n    border-color: @navbar-default-toggle-border-color;\n    &:hover,\n    &:focus {\n      background-color: @navbar-default-toggle-hover-bg;\n    }\n    .icon-bar {\n      background-color: @navbar-default-toggle-icon-bar-bg;\n    }\n  }\n\n  .navbar-collapse,\n  .navbar-form {\n    border-color: @navbar-default-border;\n  }\n\n\n  // Links in navbars\n  //\n  // Add a class to ensure links outside the navbar nav are colored correctly.\n\n  .navbar-link {\n    color: @navbar-default-link-color;\n    &:hover {\n      color: @navbar-default-link-hover-color;\n    }\n  }\n\n  .btn-link {\n    color: @navbar-default-link-color;\n    &:hover,\n    &:focus {\n      color: @navbar-default-link-hover-color;\n    }\n    &[disabled],\n    fieldset[disabled] & {\n      &:hover,\n      &:focus {\n        color: @navbar-default-link-disabled-color;\n      }\n    }\n  }\n}\n\n// Inverse navbar\n\n.navbar-inverse {\n  background-color: @navbar-inverse-bg;\n  border-color: @navbar-inverse-border;\n\n  .navbar-brand {\n    color: @navbar-inverse-brand-color;\n    &:hover,\n    &:focus {\n      color: @navbar-inverse-brand-hover-color;\n      background-color: @navbar-inverse-brand-hover-bg;\n    }\n  }\n\n  .navbar-text {\n    color: @navbar-inverse-color;\n  }\n\n  .navbar-nav {\n    > li > a {\n      color: @navbar-inverse-link-color;\n\n      &:hover,\n      &:focus {\n        color: @navbar-inverse-link-hover-color;\n        background-color: @navbar-inverse-link-hover-bg;\n      }\n    }\n    > .active > a {\n      &,\n      &:hover,\n      &:focus {\n        color: @navbar-inverse-link-active-color;\n        background-color: @navbar-inverse-link-active-bg;\n      }\n    }\n    > .disabled > a {\n      &,\n      &:hover,\n      &:focus {\n        color: @navbar-inverse-link-disabled-color;\n        background-color: @navbar-inverse-link-disabled-bg;\n      }\n    }\n\n    // Dropdowns\n    > .open > a {\n      &,\n      &:hover,\n      &:focus {\n        color: @navbar-inverse-link-active-color;\n        background-color: @navbar-inverse-link-active-bg;\n      }\n    }\n\n    @media (max-width: @grid-float-breakpoint-max) {\n      // Dropdowns get custom display\n      .open .dropdown-menu {\n        > .dropdown-header {\n          border-color: @navbar-inverse-border;\n        }\n        .divider {\n          background-color: @navbar-inverse-border;\n        }\n        > li > a {\n          color: @navbar-inverse-link-color;\n          &:hover,\n          &:focus {\n            color: @navbar-inverse-link-hover-color;\n            background-color: @navbar-inverse-link-hover-bg;\n          }\n        }\n        > .active > a {\n          &,\n          &:hover,\n          &:focus {\n            color: @navbar-inverse-link-active-color;\n            background-color: @navbar-inverse-link-active-bg;\n          }\n        }\n        > .disabled > a {\n          &,\n          &:hover,\n          &:focus {\n            color: @navbar-inverse-link-disabled-color;\n            background-color: @navbar-inverse-link-disabled-bg;\n          }\n        }\n      }\n    }\n  }\n\n  // Darken the responsive nav toggle\n  .navbar-toggle {\n    border-color: @navbar-inverse-toggle-border-color;\n    &:hover,\n    &:focus {\n      background-color: @navbar-inverse-toggle-hover-bg;\n    }\n    .icon-bar {\n      background-color: @navbar-inverse-toggle-icon-bar-bg;\n    }\n  }\n\n  .navbar-collapse,\n  .navbar-form {\n    border-color: darken(@navbar-inverse-bg, 7%);\n  }\n\n  .navbar-link {\n    color: @navbar-inverse-link-color;\n    &:hover {\n      color: @navbar-inverse-link-hover-color;\n    }\n  }\n\n  .btn-link {\n    color: @navbar-inverse-link-color;\n    &:hover,\n    &:focus {\n      color: @navbar-inverse-link-hover-color;\n    }\n    &[disabled],\n    fieldset[disabled] & {\n      &:hover,\n      &:focus {\n        color: @navbar-inverse-link-disabled-color;\n      }\n    }\n  }\n}\n","// Navbar vertical align\n//\n// Vertically center elements in the navbar.\n// Example: an element has a height of 30px, so write out `.navbar-vertical-align(30px);` to calculate the appropriate top margin.\n\n.navbar-vertical-align(@element-height) {\n  margin-top: ((@navbar-height - @element-height) / 2);\n  margin-bottom: ((@navbar-height - @element-height) / 2);\n}\n","// stylelint-disable declaration-no-important\n\n//\n// Utility classes\n// --------------------------------------------------\n\n\n// Floats\n// -------------------------\n\n.clearfix {\n  .clearfix();\n}\n.center-block {\n  .center-block();\n}\n.pull-right {\n  float: right !important;\n}\n.pull-left {\n  float: left !important;\n}\n\n\n// Toggling content\n// -------------------------\n\n// Note: Deprecated .hide in favor of .hidden or .sr-only (as appropriate) in v3.0.1\n.hide {\n  display: none !important;\n}\n.show {\n  display: block !important;\n}\n.invisible {\n  visibility: hidden;\n}\n.text-hide {\n  .text-hide();\n}\n\n\n// Hide from screenreaders and browsers\n//\n// Credit: HTML5 Boilerplate\n\n.hidden {\n  display: none !important;\n}\n\n\n// For Affix plugin\n// -------------------------\n\n.affix {\n  position: fixed;\n}\n","// Bordered & Pulled\n// -------------------------\n\n.@{fa-css-prefix}-border {\n  padding: .2em .25em .15em;\n  border: solid .08em @fa-border-color;\n  border-radius: .1em;\n}\n\n.@{fa-css-prefix}-pull-left { float: left; }\n.@{fa-css-prefix}-pull-right { float: right; }\n\n.@{fa-css-prefix} {\n  &.@{fa-css-prefix}-pull-left { margin-right: .3em; }\n  &.@{fa-css-prefix}-pull-right { margin-left: .3em; }\n}\n\n/* Deprecated as of 4.4.0 */\n.pull-right { float: right; }\n.pull-left { float: left; }\n\n.@{fa-css-prefix} {\n  &.pull-left { margin-right: .3em; }\n  &.pull-right { margin-left: .3em; }\n}\n","//\n// Breadcrumbs\n// --------------------------------------------------\n\n\n.breadcrumb {\n  padding: @breadcrumb-padding-vertical @breadcrumb-padding-horizontal;\n  margin-bottom: @line-height-computed;\n  list-style: none;\n  background-color: @breadcrumb-bg;\n  border-radius: @border-radius-base;\n\n  > li {\n    display: inline-block;\n\n    + li:before {\n      padding: 0 5px;\n      color: @breadcrumb-color;\n      content: \"@{breadcrumb-separator}\\00a0\"; // Unicode space added since inline-block means non-collapsing white-space\n    }\n  }\n\n  > .active {\n    color: @breadcrumb-active-color;\n  }\n}\n","//\n// Pagination (multiple pages)\n// --------------------------------------------------\n.pagination {\n  display: inline-block;\n  padding-left: 0;\n  margin: @line-height-computed 0;\n  border-radius: @border-radius-base;\n\n  > li {\n    display: inline; // Remove list-style and block-level defaults\n    > a,\n    > span {\n      position: relative;\n      float: left; // Collapse white-space\n      padding: @padding-base-vertical @padding-base-horizontal;\n      margin-left: -1px;\n      line-height: @line-height-base;\n      color: @pagination-color;\n      text-decoration: none;\n      background-color: @pagination-bg;\n      border: 1px solid @pagination-border;\n\n      &:hover,\n      &:focus {\n        z-index: 2;\n        color: @pagination-hover-color;\n        background-color: @pagination-hover-bg;\n        border-color: @pagination-hover-border;\n      }\n    }\n    &:first-child {\n      > a,\n      > span {\n        margin-left: 0;\n        .border-left-radius(@border-radius-base);\n      }\n    }\n    &:last-child {\n      > a,\n      > span {\n        .border-right-radius(@border-radius-base);\n      }\n    }\n  }\n\n  > .active > a,\n  > .active > span {\n    &,\n    &:hover,\n    &:focus {\n      z-index: 3;\n      color: @pagination-active-color;\n      cursor: default;\n      background-color: @pagination-active-bg;\n      border-color: @pagination-active-border;\n    }\n  }\n\n  > .disabled {\n    > span,\n    > span:hover,\n    > span:focus,\n    > a,\n    > a:hover,\n    > a:focus {\n      color: @pagination-disabled-color;\n      cursor: @cursor-disabled;\n      background-color: @pagination-disabled-bg;\n      border-color: @pagination-disabled-border;\n    }\n  }\n}\n\n// Sizing\n// --------------------------------------------------\n\n// Large\n.pagination-lg {\n  .pagination-size(@padding-large-vertical; @padding-large-horizontal; @font-size-large; @line-height-large; @border-radius-large);\n}\n\n// Small\n.pagination-sm {\n  .pagination-size(@padding-small-vertical; @padding-small-horizontal; @font-size-small; @line-height-small; @border-radius-small);\n}\n","// Pagination\n\n.pagination-size(@padding-vertical; @padding-horizontal; @font-size; @line-height; @border-radius) {\n  > li {\n    > a,\n    > span {\n      padding: @padding-vertical @padding-horizontal;\n      font-size: @font-size;\n      line-height: @line-height;\n    }\n    &:first-child {\n      > a,\n      > span {\n        .border-left-radius(@border-radius);\n      }\n    }\n    &:last-child {\n      > a,\n      > span {\n        .border-right-radius(@border-radius);\n      }\n    }\n  }\n}\n","//\n// Pager pagination\n// --------------------------------------------------\n\n\n.pager {\n  padding-left: 0;\n  margin: @line-height-computed 0;\n  text-align: center;\n  list-style: none;\n  &:extend(.clearfix all);\n  li {\n    display: inline;\n    > a,\n    > span {\n      display: inline-block;\n      padding: 5px 14px;\n      background-color: @pager-bg;\n      border: 1px solid @pager-border;\n      border-radius: @pager-border-radius;\n    }\n\n    > a:hover,\n    > a:focus {\n      text-decoration: none;\n      background-color: @pager-hover-bg;\n    }\n  }\n\n  .next {\n    > a,\n    > span {\n      float: right;\n    }\n  }\n\n  .previous {\n    > a,\n    > span {\n      float: left;\n    }\n  }\n\n  .disabled {\n    > a,\n    > a:hover,\n    > a:focus,\n    > span {\n      color: @pager-disabled-color;\n      cursor: @cursor-disabled;\n      background-color: @pager-bg;\n    }\n  }\n}\n","//\n// Labels\n// --------------------------------------------------\n\n.label {\n  display: inline;\n  padding: .2em .6em .3em;\n  font-size: 75%;\n  font-weight: 700;\n  line-height: 1;\n  color: @label-color;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: baseline;\n  border-radius: .25em;\n\n  // Add hover effects, but only for links\n  a& {\n    &:hover,\n    &:focus {\n      color: @label-link-hover-color;\n      text-decoration: none;\n      cursor: pointer;\n    }\n  }\n\n  // Empty labels collapse automatically (not available in IE8)\n  &:empty {\n    display: none;\n  }\n\n  // Quick fix for labels in buttons\n  .btn & {\n    position: relative;\n    top: -1px;\n  }\n}\n\n// Colors\n// Contextual variations (linked labels get darker on :hover)\n\n.label-default {\n  .label-variant(@label-default-bg);\n}\n\n.label-primary {\n  .label-variant(@label-primary-bg);\n}\n\n.label-success {\n  .label-variant(@label-success-bg);\n}\n\n.label-info {\n  .label-variant(@label-info-bg);\n}\n\n.label-warning {\n  .label-variant(@label-warning-bg);\n}\n\n.label-danger {\n  .label-variant(@label-danger-bg);\n}\n","// Labels\n\n.label-variant(@color) {\n  background-color: @color;\n\n  &[href] {\n    &:hover,\n    &:focus {\n      background-color: darken(@color, 10%);\n    }\n  }\n}\n","//\n// Badges\n// --------------------------------------------------\n\n\n// Base class\n.badge {\n  display: inline-block;\n  min-width: 10px;\n  padding: 3px 7px;\n  font-size: @font-size-small;\n  font-weight: @badge-font-weight;\n  line-height: @badge-line-height;\n  color: @badge-color;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: middle;\n  background-color: @badge-bg;\n  border-radius: @badge-border-radius;\n\n  // Empty badges collapse automatically (not available in IE8)\n  &:empty {\n    display: none;\n  }\n\n  // Quick fix for badges in buttons\n  .btn & {\n    position: relative;\n    top: -1px;\n  }\n\n  .btn-xs &,\n  .btn-group-xs > .btn & {\n    top: 0;\n    padding: 1px 5px;\n  }\n\n  // Hover state, but only for links\n  a& {\n    &:hover,\n    &:focus {\n      color: @badge-link-hover-color;\n      text-decoration: none;\n      cursor: pointer;\n    }\n  }\n\n  // Account for badges in navs\n  .list-group-item.active > &,\n  .nav-pills > .active > a > & {\n    color: @badge-active-color;\n    background-color: @badge-active-bg;\n  }\n\n  .list-group-item > & {\n    float: right;\n  }\n\n  .list-group-item > & + & {\n    margin-right: 5px;\n  }\n\n  .nav-pills > li > a > & {\n    margin-left: 3px;\n  }\n}\n","//\n// Jumbotron\n// --------------------------------------------------\n\n\n.jumbotron {\n  padding-top: @jumbotron-padding;\n  padding-bottom: @jumbotron-padding;\n  margin-bottom: @jumbotron-padding;\n  color: @jumbotron-color;\n  background-color: @jumbotron-bg;\n\n  h1,\n  .h1 {\n    color: @jumbotron-heading-color;\n  }\n\n  p {\n    margin-bottom: (@jumbotron-padding / 2);\n    font-size: @jumbotron-font-size;\n    font-weight: 200;\n  }\n\n  > hr {\n    border-top-color: darken(@jumbotron-bg, 10%);\n  }\n\n  .container &,\n  .container-fluid & {\n    padding-right: (@grid-gutter-width / 2);\n    padding-left: (@grid-gutter-width / 2);\n    border-radius: @border-radius-large; // Only round corners at higher resolutions if contained in a container\n  }\n\n  .container {\n    max-width: 100%;\n  }\n\n  @media screen and (min-width: @screen-sm-min) {\n    padding-top: (@jumbotron-padding * 1.6);\n    padding-bottom: (@jumbotron-padding * 1.6);\n\n    .container &,\n    .container-fluid & {\n      padding-right: (@jumbotron-padding * 2);\n      padding-left: (@jumbotron-padding * 2);\n    }\n\n    h1,\n    .h1 {\n      font-size: @jumbotron-heading-font-size;\n    }\n  }\n}\n","// stylelint-disable selector-no-qualifying-type\n\n//\n// Thumbnails\n// --------------------------------------------------\n\n\n// Mixin and adjust the regular image class\n.thumbnail {\n  display: block;\n  padding: @thumbnail-padding;\n  margin-bottom: @line-height-computed;\n  line-height: @line-height-base;\n  background-color: @thumbnail-bg;\n  border: 1px solid @thumbnail-border;\n  border-radius: @thumbnail-border-radius;\n  .transition(border .2s ease-in-out);\n\n  > img,\n  a > img {\n    &:extend(.img-responsive);\n    margin-right: auto;\n    margin-left: auto;\n  }\n\n  // Add a hover state for linked versions only\n  a&:hover,\n  a&:focus,\n  a&.active {\n    border-color: @link-color;\n  }\n\n  // Image captions\n  .caption {\n    padding: @thumbnail-caption-padding;\n    color: @thumbnail-caption-color;\n  }\n}\n","//\n// Alerts\n// --------------------------------------------------\n\n\n// Base styles\n// -------------------------\n\n.alert {\n  padding: @alert-padding;\n  margin-bottom: @line-height-computed;\n  border: 1px solid transparent;\n  border-radius: @alert-border-radius;\n\n  // Headings for larger alerts\n  h4 {\n    margin-top: 0;\n    color: inherit; // Specified for the h4 to prevent conflicts of changing @headings-color\n  }\n\n  // Provide class for links that match alerts\n  .alert-link {\n    font-weight: @alert-link-font-weight;\n  }\n\n  // Improve alignment and spacing of inner content\n  > p,\n  > ul {\n    margin-bottom: 0;\n  }\n\n  > p + p {\n    margin-top: 5px;\n  }\n}\n\n// Dismissible alerts\n//\n// Expand the right padding and account for the close button's positioning.\n\n// The misspelled .alert-dismissable was deprecated in 3.2.0.\n.alert-dismissable,\n.alert-dismissible {\n  padding-right: (@alert-padding + 20);\n\n  // Adjust close link position\n  .close {\n    position: relative;\n    top: -2px;\n    right: -21px;\n    color: inherit;\n  }\n}\n\n// Alternate styles\n//\n// Generate contextual modifier classes for colorizing the alert.\n\n.alert-success {\n  .alert-variant(@alert-success-bg; @alert-success-border; @alert-success-text);\n}\n\n.alert-info {\n  .alert-variant(@alert-info-bg; @alert-info-border; @alert-info-text);\n}\n\n.alert-warning {\n  .alert-variant(@alert-warning-bg; @alert-warning-border; @alert-warning-text);\n}\n\n.alert-danger {\n  .alert-variant(@alert-danger-bg; @alert-danger-border; @alert-danger-text);\n}\n","// Alerts\n\n.alert-variant(@background; @border; @text-color) {\n  color: @text-color;\n  background-color: @background;\n  border-color: @border;\n\n  hr {\n    border-top-color: darken(@border, 5%);\n  }\n\n  .alert-link {\n    color: darken(@text-color, 10%);\n  }\n}\n","// stylelint-disable at-rule-no-vendor-prefix\n\n//\n// Progress bars\n// --------------------------------------------------\n\n\n// Bar animations\n// -------------------------\n\n// WebKit\n@-webkit-keyframes progress-bar-stripes {\n  from  { background-position: 40px 0; }\n  to    { background-position: 0 0; }\n}\n\n// Spec and IE10+\n@keyframes progress-bar-stripes {\n  from  { background-position: 40px 0; }\n  to    { background-position: 0 0; }\n}\n\n\n// Bar itself\n// -------------------------\n\n// Outer container\n.progress {\n  height: @line-height-computed;\n  margin-bottom: @line-height-computed;\n  overflow: hidden;\n  background-color: @progress-bg;\n  border-radius: @progress-border-radius;\n  .box-shadow(inset 0 1px 2px rgba(0, 0, 0, .1));\n}\n\n// Bar of progress\n.progress-bar {\n  float: left;\n  width: 0%;\n  height: 100%;\n  font-size: @font-size-small;\n  line-height: @line-height-computed;\n  color: @progress-bar-color;\n  text-align: center;\n  background-color: @progress-bar-bg;\n  .box-shadow(inset 0 -1px 0 rgba(0, 0, 0, .15));\n  .transition(width .6s ease);\n}\n\n// Striped bars\n//\n// `.progress-striped .progress-bar` is deprecated as of v3.2.0 in favor of the\n// `.progress-bar-striped` class, which you just add to an existing\n// `.progress-bar`.\n.progress-striped .progress-bar,\n.progress-bar-striped {\n  #gradient > .striped();\n  background-size: 40px 40px;\n}\n\n// Call animation for the active one\n//\n// `.progress.active .progress-bar` is deprecated as of v3.2.0 in favor of the\n// `.progress-bar.active` approach.\n.progress.active .progress-bar,\n.progress-bar.active {\n  .animation(progress-bar-stripes 2s linear infinite);\n}\n\n\n// Variations\n// -------------------------\n\n.progress-bar-success {\n  .progress-bar-variant(@progress-bar-success-bg);\n}\n\n.progress-bar-info {\n  .progress-bar-variant(@progress-bar-info-bg);\n}\n\n.progress-bar-warning {\n  .progress-bar-variant(@progress-bar-warning-bg);\n}\n\n.progress-bar-danger {\n  .progress-bar-variant(@progress-bar-danger-bg);\n}\n","// stylelint-disable value-no-vendor-prefix, selector-max-id\n\n#gradient {\n\n  // Horizontal gradient, from left to right\n  //\n  // Creates two color stops, start and end, by specifying a color and position for each color stop.\n  // Color stops are not available in IE9 and below.\n  .horizontal(@start-color: #555; @end-color: #333; @start-percent: 0%; @end-percent: 100%) {\n    background-image: -webkit-linear-gradient(left, @start-color @start-percent, @end-color @end-percent); // Safari 5.1-6, Chrome 10+\n    background-image: -o-linear-gradient(left, @start-color @start-percent, @end-color @end-percent); // Opera 12\n    background-image: linear-gradient(to right, @start-color @start-percent, @end-color @end-percent); // Standard, IE10, Firefox 16+, Opera 12.10+, Safari 7+, Chrome 26+\n    filter: e(%(\"progid:DXImageTransform.Microsoft.gradient(startColorstr='%d', endColorstr='%d', GradientType=1)\", argb(@start-color), argb(@end-color))); // IE9 and down\n    background-repeat: repeat-x;\n  }\n\n  // Vertical gradient, from top to bottom\n  //\n  // Creates two color stops, start and end, by specifying a color and position for each color stop.\n  // Color stops are not available in IE9 and below.\n  .vertical(@start-color: #555; @end-color: #333; @start-percent: 0%; @end-percent: 100%) {\n    background-image: -webkit-linear-gradient(top, @start-color @start-percent, @end-color @end-percent);  // Safari 5.1-6, Chrome 10+\n    background-image: -o-linear-gradient(top, @start-color @start-percent, @end-color @end-percent);  // Opera 12\n    background-image: linear-gradient(to bottom, @start-color @start-percent, @end-color @end-percent); // Standard, IE10, Firefox 16+, Opera 12.10+, Safari 7+, Chrome 26+\n    filter: e(%(\"progid:DXImageTransform.Microsoft.gradient(startColorstr='%d', endColorstr='%d', GradientType=0)\", argb(@start-color), argb(@end-color))); // IE9 and down\n    background-repeat: repeat-x;\n  }\n\n  .directional(@start-color: #555; @end-color: #333; @deg: 45deg) {\n    background-image: -webkit-linear-gradient(@deg, @start-color, @end-color); // Safari 5.1-6, Chrome 10+\n    background-image: -o-linear-gradient(@deg, @start-color, @end-color); // Opera 12\n    background-image: linear-gradient(@deg, @start-color, @end-color); // Standard, IE10, Firefox 16+, Opera 12.10+, Safari 7+, Chrome 26+\n    background-repeat: repeat-x;\n  }\n  .horizontal-three-colors(@start-color: #00b3ee; @mid-color: #7a43b6; @color-stop: 50%; @end-color: #c3325f) {\n    background-image: -webkit-linear-gradient(left, @start-color, @mid-color @color-stop, @end-color);\n    background-image: -o-linear-gradient(left, @start-color, @mid-color @color-stop, @end-color);\n    background-image: linear-gradient(to right, @start-color, @mid-color @color-stop, @end-color);\n    filter: e(%(\"progid:DXImageTransform.Microsoft.gradient(startColorstr='%d', endColorstr='%d', GradientType=1)\", argb(@start-color), argb(@end-color))); // IE9 and down, gets no color-stop at all for proper fallback\n    background-repeat: no-repeat;\n  }\n  .vertical-three-colors(@start-color: #00b3ee; @mid-color: #7a43b6; @color-stop: 50%; @end-color: #c3325f) {\n    background-image: -webkit-linear-gradient(@start-color, @mid-color @color-stop, @end-color);\n    background-image: -o-linear-gradient(@start-color, @mid-color @color-stop, @end-color);\n    background-image: linear-gradient(@start-color, @mid-color @color-stop, @end-color);\n    filter: e(%(\"progid:DXImageTransform.Microsoft.gradient(startColorstr='%d', endColorstr='%d', GradientType=0)\", argb(@start-color), argb(@end-color))); // IE9 and down, gets no color-stop at all for proper fallback\n    background-repeat: no-repeat;\n  }\n  .radial(@inner-color: #555; @outer-color: #333) {\n    background-image: -webkit-radial-gradient(circle, @inner-color, @outer-color);\n    background-image: radial-gradient(circle, @inner-color, @outer-color);\n    background-repeat: no-repeat;\n  }\n  .striped(@color: rgba(255, 255, 255, .15); @angle: 45deg) {\n    background-image: -webkit-linear-gradient(@angle, @color 25%, transparent 25%, transparent 50%, @color 50%, @color 75%, transparent 75%, transparent);\n    background-image: -o-linear-gradient(@angle, @color 25%, transparent 25%, transparent 50%, @color 50%, @color 75%, transparent 75%, transparent);\n    background-image: linear-gradient(@angle, @color 25%, transparent 25%, transparent 50%, @color 50%, @color 75%, transparent 75%, transparent);\n  }\n}\n","// Progress bars\n\n.progress-bar-variant(@color) {\n  background-color: @color;\n\n  // Deprecated parent class requirement as of v3.2.0\n  .progress-striped & {\n    #gradient > .striped();\n  }\n}\n",".media {\n  // Proper spacing between instances of .media\n  margin-top: 15px;\n\n  &:first-child {\n    margin-top: 0;\n  }\n}\n\n.media,\n.media-body {\n  overflow: hidden;\n  zoom: 1;\n}\n\n.media-body {\n  width: 10000px;\n}\n\n.media-object {\n  display: block;\n\n  // Fix collapse in webkit from max-width: 100% and display: table-cell.\n  &.img-thumbnail {\n    max-width: none;\n  }\n}\n\n.media-right,\n.media > .pull-right {\n  padding-left: 10px;\n}\n\n.media-left,\n.media > .pull-left {\n  padding-right: 10px;\n}\n\n.media-left,\n.media-right,\n.media-body {\n  display: table-cell;\n  vertical-align: top;\n}\n\n.media-middle {\n  vertical-align: middle;\n}\n\n.media-bottom {\n  vertical-align: bottom;\n}\n\n// Reset margins on headings for tighter default spacing\n.media-heading {\n  margin-top: 0;\n  margin-bottom: 5px;\n}\n\n// Media list variation\n//\n// Undo default ul/ol styles\n.media-list {\n  padding-left: 0;\n  list-style: none;\n}\n","// stylelint-disable selector-no-qualifying-type\n\n//\n// List groups\n// --------------------------------------------------\n\n\n// Base class\n//\n// Easily usable on <ul>, <ol>, or <div>.\n\n.list-group {\n  // No need to set list-style: none; since .list-group-item is block level\n  padding-left: 0; // reset padding because ul and ol\n  margin-bottom: 20px;\n}\n\n\n// Individual list items\n//\n// Use on `li`s or `div`s within the `.list-group` parent.\n\n.list-group-item {\n  position: relative;\n  display: block;\n  padding: 10px 15px;\n  // Place the border on the list items and negative margin up for better styling\n  margin-bottom: -1px;\n  background-color: @list-group-bg;\n  border: 1px solid @list-group-border;\n\n  // Round the first and last items\n  &:first-child {\n    .border-top-radius(@list-group-border-radius);\n  }\n  &:last-child {\n    margin-bottom: 0;\n    .border-bottom-radius(@list-group-border-radius);\n  }\n\n  // Disabled state\n  &.disabled,\n  &.disabled:hover,\n  &.disabled:focus {\n    color: @list-group-disabled-color;\n    cursor: @cursor-disabled;\n    background-color: @list-group-disabled-bg;\n\n    // Force color to inherit for custom content\n    .list-group-item-heading {\n      color: inherit;\n    }\n    .list-group-item-text {\n      color: @list-group-disabled-text-color;\n    }\n  }\n\n  // Active class on item itself, not parent\n  &.active,\n  &.active:hover,\n  &.active:focus {\n    z-index: 2; // Place active items above their siblings for proper border styling\n    color: @list-group-active-color;\n    background-color: @list-group-active-bg;\n    border-color: @list-group-active-border;\n\n    // Force color to inherit for custom content\n    .list-group-item-heading,\n    .list-group-item-heading > small,\n    .list-group-item-heading > .small {\n      color: inherit;\n    }\n    .list-group-item-text {\n      color: @list-group-active-text-color;\n    }\n  }\n}\n\n\n// Interactive list items\n//\n// Use anchor or button elements instead of `li`s or `div`s to create interactive items.\n// Includes an extra `.active` modifier class for showing selected items.\n\na.list-group-item,\nbutton.list-group-item {\n  color: @list-group-link-color;\n\n  .list-group-item-heading {\n    color: @list-group-link-heading-color;\n  }\n\n  // Hover state\n  &:hover,\n  &:focus {\n    color: @list-group-link-hover-color;\n    text-decoration: none;\n    background-color: @list-group-hover-bg;\n  }\n}\n\nbutton.list-group-item {\n  width: 100%;\n  text-align: left;\n}\n\n\n// Contextual variants\n//\n// Add modifier classes to change text and background color on individual items.\n// Organizationally, this must come after the `:hover` states.\n\n.list-group-item-variant(success; @state-success-bg; @state-success-text);\n.list-group-item-variant(info; @state-info-bg; @state-info-text);\n.list-group-item-variant(warning; @state-warning-bg; @state-warning-text);\n.list-group-item-variant(danger; @state-danger-bg; @state-danger-text);\n\n\n// Custom content options\n//\n// Extra classes for creating well-formatted content within `.list-group-item`s.\n\n.list-group-item-heading {\n  margin-top: 0;\n  margin-bottom: 5px;\n}\n.list-group-item-text {\n  margin-bottom: 0;\n  line-height: 1.3;\n}\n","// List Groups\n\n.list-group-item-variant(@state; @background; @color) {\n  .list-group-item-@{state} {\n    color: @color;\n    background-color: @background;\n\n    a&,\n    button& {\n      color: @color;\n\n      .list-group-item-heading {\n        color: inherit;\n      }\n\n      &:hover,\n      &:focus {\n        color: @color;\n        background-color: darken(@background, 5%);\n      }\n      &.active,\n      &.active:hover,\n      &.active:focus {\n        color: #fff;\n        background-color: @color;\n        border-color: @color;\n      }\n    }\n  }\n}\n","// stylelint-disable selector-max-type, selector-max-compound-selectors, selector-max-combinators, no-duplicate-selectors\n\n//\n// Panels\n// --------------------------------------------------\n\n\n// Base class\n.panel {\n  margin-bottom: @line-height-computed;\n  background-color: @panel-bg;\n  border: 1px solid transparent;\n  border-radius: @panel-border-radius;\n  .box-shadow(0 1px 1px rgba(0, 0, 0, .05));\n}\n\n// Panel contents\n.panel-body {\n  padding: @panel-body-padding;\n  &:extend(.clearfix all);\n}\n\n// Optional heading\n.panel-heading {\n  padding: @panel-heading-padding;\n  border-bottom: 1px solid transparent;\n  .border-top-radius((@panel-border-radius - 1));\n\n  > .dropdown .dropdown-toggle {\n    color: inherit;\n  }\n}\n\n// Within heading, strip any `h*` tag of its default margins for spacing.\n.panel-title {\n  margin-top: 0;\n  margin-bottom: 0;\n  font-size: ceil((@font-size-base * 1.125));\n  color: inherit;\n\n  > a,\n  > small,\n  > .small,\n  > small > a,\n  > .small > a {\n    color: inherit;\n  }\n}\n\n// Optional footer (stays gray in every modifier class)\n.panel-footer {\n  padding: @panel-footer-padding;\n  background-color: @panel-footer-bg;\n  border-top: 1px solid @panel-inner-border;\n  .border-bottom-radius((@panel-border-radius - 1));\n}\n\n\n// List groups in panels\n//\n// By default, space out list group content from panel headings to account for\n// any kind of custom content between the two.\n\n.panel {\n  > .list-group,\n  > .panel-collapse > .list-group {\n    margin-bottom: 0;\n\n    .list-group-item {\n      border-width: 1px 0;\n      border-radius: 0;\n    }\n\n    // Add border top radius for first one\n    &:first-child {\n      .list-group-item:first-child {\n        border-top: 0;\n        .border-top-radius((@panel-border-radius - 1));\n      }\n    }\n\n    // Add border bottom radius for last one\n    &:last-child {\n      .list-group-item:last-child {\n        border-bottom: 0;\n        .border-bottom-radius((@panel-border-radius - 1));\n      }\n    }\n  }\n  > .panel-heading + .panel-collapse > .list-group {\n    .list-group-item:first-child {\n      .border-top-radius(0);\n    }\n  }\n}\n// Collapse space between when there's no additional content.\n.panel-heading + .list-group {\n  .list-group-item:first-child {\n    border-top-width: 0;\n  }\n}\n.list-group + .panel-footer {\n  border-top-width: 0;\n}\n\n// Tables in panels\n//\n// Place a non-bordered `.table` within a panel (not within a `.panel-body`) and\n// watch it go full width.\n\n.panel {\n  > .table,\n  > .table-responsive > .table,\n  > .panel-collapse > .table {\n    margin-bottom: 0;\n\n    caption {\n      padding-right: @panel-body-padding;\n      padding-left: @panel-body-padding;\n    }\n  }\n  // Add border top radius for first one\n  > .table:first-child,\n  > .table-responsive:first-child > .table:first-child {\n    .border-top-radius((@panel-border-radius - 1));\n\n    > thead:first-child,\n    > tbody:first-child {\n      > tr:first-child {\n        border-top-left-radius: (@panel-border-radius - 1);\n        border-top-right-radius: (@panel-border-radius - 1);\n\n        td:first-child,\n        th:first-child {\n          border-top-left-radius: (@panel-border-radius - 1);\n        }\n        td:last-child,\n        th:last-child {\n          border-top-right-radius: (@panel-border-radius - 1);\n        }\n      }\n    }\n  }\n  // Add border bottom radius for last one\n  > .table:last-child,\n  > .table-responsive:last-child > .table:last-child {\n    .border-bottom-radius((@panel-border-radius - 1));\n\n    > tbody:last-child,\n    > tfoot:last-child {\n      > tr:last-child {\n        border-bottom-right-radius: (@panel-border-radius - 1);\n        border-bottom-left-radius: (@panel-border-radius - 1);\n\n        td:first-child,\n        th:first-child {\n          border-bottom-left-radius: (@panel-border-radius - 1);\n        }\n        td:last-child,\n        th:last-child {\n          border-bottom-right-radius: (@panel-border-radius - 1);\n        }\n      }\n    }\n  }\n  > .panel-body + .table,\n  > .panel-body + .table-responsive,\n  > .table + .panel-body,\n  > .table-responsive + .panel-body {\n    border-top: 1px solid @table-border-color;\n  }\n  > .table > tbody:first-child > tr:first-child th,\n  > .table > tbody:first-child > tr:first-child td {\n    border-top: 0;\n  }\n  > .table-bordered,\n  > .table-responsive > .table-bordered {\n    border: 0;\n    > thead,\n    > tbody,\n    > tfoot {\n      > tr {\n        > th:first-child,\n        > td:first-child {\n          border-left: 0;\n        }\n        > th:last-child,\n        > td:last-child {\n          border-right: 0;\n        }\n      }\n    }\n    > thead,\n    > tbody {\n      > tr:first-child {\n        > td,\n        > th {\n          border-bottom: 0;\n        }\n      }\n    }\n    > tbody,\n    > tfoot {\n      > tr:last-child {\n        > td,\n        > th {\n          border-bottom: 0;\n        }\n      }\n    }\n  }\n  > .table-responsive {\n    margin-bottom: 0;\n    border: 0;\n  }\n}\n\n\n// Collapsible panels (aka, accordion)\n//\n// Wrap a series of panels in `.panel-group` to turn them into an accordion with\n// the help of our collapse JavaScript plugin.\n\n.panel-group {\n  margin-bottom: @line-height-computed;\n\n  // Tighten up margin so it's only between panels\n  .panel {\n    margin-bottom: 0;\n    border-radius: @panel-border-radius;\n\n    + .panel {\n      margin-top: 5px;\n    }\n  }\n\n  .panel-heading {\n    border-bottom: 0;\n\n    + .panel-collapse > .panel-body,\n    + .panel-collapse > .list-group {\n      border-top: 1px solid @panel-inner-border;\n    }\n  }\n\n  .panel-footer {\n    border-top: 0;\n    + .panel-collapse .panel-body {\n      border-bottom: 1px solid @panel-inner-border;\n    }\n  }\n}\n\n\n// Contextual variations\n.panel-default {\n  .panel-variant(@panel-default-border; @panel-default-text; @panel-default-heading-bg; @panel-default-border);\n}\n.panel-primary {\n  .panel-variant(@panel-primary-border; @panel-primary-text; @panel-primary-heading-bg; @panel-primary-border);\n}\n.panel-success {\n  .panel-variant(@panel-success-border; @panel-success-text; @panel-success-heading-bg; @panel-success-border);\n}\n.panel-info {\n  .panel-variant(@panel-info-border; @panel-info-text; @panel-info-heading-bg; @panel-info-border);\n}\n.panel-warning {\n  .panel-variant(@panel-warning-border; @panel-warning-text; @panel-warning-heading-bg; @panel-warning-border);\n}\n.panel-danger {\n  .panel-variant(@panel-danger-border; @panel-danger-text; @panel-danger-heading-bg; @panel-danger-border);\n}\n","// Panels\n\n.panel-variant(@border; @heading-text-color; @heading-bg-color; @heading-border) {\n  border-color: @border;\n\n  & > .panel-heading {\n    color: @heading-text-color;\n    background-color: @heading-bg-color;\n    border-color: @heading-border;\n\n    + .panel-collapse > .panel-body {\n      border-top-color: @border;\n    }\n    .badge {\n      color: @heading-bg-color;\n      background-color: @heading-text-color;\n    }\n  }\n  & > .panel-footer {\n    + .panel-collapse > .panel-body {\n      border-bottom-color: @border;\n    }\n  }\n}\n","// Embeds responsive\n//\n// Credit: Nicolas Gallagher and SUIT CSS.\n\n.embed-responsive {\n  position: relative;\n  display: block;\n  height: 0;\n  padding: 0;\n  overflow: hidden;\n\n  .embed-responsive-item,\n  iframe,\n  embed,\n  object,\n  video {\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    border: 0;\n  }\n}\n\n// Modifier class for 16:9 aspect ratio\n.embed-responsive-16by9 {\n  padding-bottom: 56.25%;\n}\n\n// Modifier class for 4:3 aspect ratio\n.embed-responsive-4by3 {\n  padding-bottom: 75%;\n}\n","//\n// Wells\n// --------------------------------------------------\n\n\n// Base class\n.well {\n  min-height: 20px;\n  padding: 19px;\n  margin-bottom: 20px;\n  background-color: @well-bg;\n  border: 1px solid @well-border;\n  border-radius: @border-radius-base;\n  .box-shadow(inset 0 1px 1px rgba(0, 0, 0, .05));\n  blockquote {\n    border-color: #ddd;\n    border-color: rgba(0, 0, 0, .15);\n  }\n}\n\n// Sizes\n.well-lg {\n  padding: 24px;\n  border-radius: @border-radius-large;\n}\n.well-sm {\n  padding: 9px;\n  border-radius: @border-radius-small;\n}\n","// stylelint-disable property-no-vendor-prefix\n\n//\n// Close icons\n// --------------------------------------------------\n\n\n.close {\n  float: right;\n  font-size: (@font-size-base * 1.5);\n  font-weight: @close-font-weight;\n  line-height: 1;\n  color: @close-color;\n  text-shadow: @close-text-shadow;\n  .opacity(.2);\n\n  &:hover,\n  &:focus {\n    color: @close-color;\n    text-decoration: none;\n    cursor: pointer;\n    .opacity(.5);\n  }\n\n  // Additional properties for button version\n  // iOS requires the button element instead of an anchor tag.\n  // If you want the anchor version, it requires `href=\"#\"`.\n  // See https://developer.mozilla.org/en-US/docs/Web/Events/click#Safari_Mobile\n  button& {\n    padding: 0;\n    cursor: pointer;\n    background: transparent;\n    border: 0;\n    -webkit-appearance: none;\n    appearance: none;\n  }\n}\n","//\n// Modals\n// --------------------------------------------------\n\n// .modal-open      - body class for killing the scroll\n// .modal           - container to scroll within\n// .modal-dialog    - positioning shell for the actual modal\n// .modal-content   - actual modal w/ bg and corners and shit\n\n// Kill the scroll on the body\n.modal-open {\n  overflow: hidden;\n}\n\n// Container that the modal scrolls within\n.modal {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: @zindex-modal;\n  display: none;\n  overflow: hidden;\n  -webkit-overflow-scrolling: touch;\n\n  // Prevent Chrome on Windows from adding a focus outline. For details, see\n  // https://github.com/twbs/bootstrap/pull/10951.\n  outline: 0;\n\n  // When fading in the modal, animate it to slide down\n  &.fade .modal-dialog {\n    .translate(0, -25%);\n    .transition-transform(~\"0.3s ease-out\");\n  }\n  &.in .modal-dialog { .translate(0, 0); }\n}\n.modal-open .modal {\n  overflow-x: hidden;\n  overflow-y: auto;\n}\n\n// Shell div to position the modal with bottom padding\n.modal-dialog {\n  position: relative;\n  width: auto;\n  margin: 10px;\n}\n\n// Actual modal\n.modal-content {\n  position: relative;\n  background-color: @modal-content-bg;\n  background-clip: padding-box;\n  border: 1px solid @modal-content-fallback-border-color; //old browsers fallback (ie8 etc)\n  border: 1px solid @modal-content-border-color;\n  border-radius: @border-radius-large;\n  .box-shadow(0 3px 9px rgba(0, 0, 0, .5));\n  // Remove focus outline from opened modal\n  outline: 0;\n}\n\n// Modal background\n.modal-backdrop {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: @zindex-modal-background;\n  background-color: @modal-backdrop-bg;\n  // Fade for backdrop\n  &.fade { .opacity(0); }\n  &.in { .opacity(@modal-backdrop-opacity); }\n}\n\n// Modal header\n// Top section of the modal w/ title and dismiss\n.modal-header {\n  padding: @modal-title-padding;\n  border-bottom: 1px solid @modal-header-border-color;\n  &:extend(.clearfix all);\n}\n// Close icon\n.modal-header .close {\n  margin-top: -2px;\n}\n\n// Title text within header\n.modal-title {\n  margin: 0;\n  line-height: @modal-title-line-height;\n}\n\n// Modal body\n// Where all modal content resides (sibling of .modal-header and .modal-footer)\n.modal-body {\n  position: relative;\n  padding: @modal-inner-padding;\n}\n\n// Footer (for actions)\n.modal-footer {\n  padding: @modal-inner-padding;\n  text-align: right; // right align buttons\n  border-top: 1px solid @modal-footer-border-color;\n  &:extend(.clearfix all); // clear it in case folks use .pull-* classes on buttons\n\n  // Properly space out buttons\n  .btn + .btn {\n    margin-bottom: 0; // account for input[type=\"submit\"] which gets the bottom margin like all other inputs\n    margin-left: 5px;\n  }\n  // but override that for button groups\n  .btn-group .btn + .btn {\n    margin-left: -1px;\n  }\n  // and override it for block buttons as well\n  .btn-block + .btn-block {\n    margin-left: 0;\n  }\n}\n\n// Measure scrollbar width for padding body during modal show/hide\n.modal-scrollbar-measure {\n  position: absolute;\n  top: -9999px;\n  width: 50px;\n  height: 50px;\n  overflow: scroll;\n}\n\n// Scale up the modal\n@media (min-width: @screen-sm-min) {\n  // Automatically set modal's width for larger viewports\n  .modal-dialog {\n    width: @modal-md;\n    margin: 30px auto;\n  }\n  .modal-content {\n    .box-shadow(0 5px 15px rgba(0, 0, 0, .5));\n  }\n\n  // Modal sizes\n  .modal-sm { width: @modal-sm; }\n}\n\n@media (min-width: @screen-md-min) {\n  .modal-lg { width: @modal-lg; }\n}\n","//\n// Tooltips\n// --------------------------------------------------\n\n\n// Base class\n.tooltip {\n  position: absolute;\n  z-index: @zindex-tooltip;\n  display: block;\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\n  // So reset our font and text properties to avoid inheriting weird values.\n  .reset-text();\n  font-size: @font-size-small;\n\n  .opacity(0);\n\n  &.in { .opacity(@tooltip-opacity); }\n  &.top {\n    padding: @tooltip-arrow-width 0;\n    margin-top: -3px;\n  }\n  &.right {\n    padding: 0 @tooltip-arrow-width;\n    margin-left: 3px;\n  }\n  &.bottom {\n    padding: @tooltip-arrow-width 0;\n    margin-top: 3px;\n  }\n  &.left {\n    padding: 0 @tooltip-arrow-width;\n    margin-left: -3px;\n  }\n\n  // Note: Deprecated .top-left, .top-right, .bottom-left, and .bottom-right as of v3.3.1\n  &.top .tooltip-arrow {\n    bottom: 0;\n    left: 50%;\n    margin-left: -@tooltip-arrow-width;\n    border-width: @tooltip-arrow-width @tooltip-arrow-width 0;\n    border-top-color: @tooltip-arrow-color;\n  }\n  &.top-left .tooltip-arrow {\n    right: @tooltip-arrow-width;\n    bottom: 0;\n    margin-bottom: -@tooltip-arrow-width;\n    border-width: @tooltip-arrow-width @tooltip-arrow-width 0;\n    border-top-color: @tooltip-arrow-color;\n  }\n  &.top-right .tooltip-arrow {\n    bottom: 0;\n    left: @tooltip-arrow-width;\n    margin-bottom: -@tooltip-arrow-width;\n    border-width: @tooltip-arrow-width @tooltip-arrow-width 0;\n    border-top-color: @tooltip-arrow-color;\n  }\n  &.right .tooltip-arrow {\n    top: 50%;\n    left: 0;\n    margin-top: -@tooltip-arrow-width;\n    border-width: @tooltip-arrow-width @tooltip-arrow-width @tooltip-arrow-width 0;\n    border-right-color: @tooltip-arrow-color;\n  }\n  &.left .tooltip-arrow {\n    top: 50%;\n    right: 0;\n    margin-top: -@tooltip-arrow-width;\n    border-width: @tooltip-arrow-width 0 @tooltip-arrow-width @tooltip-arrow-width;\n    border-left-color: @tooltip-arrow-color;\n  }\n  &.bottom .tooltip-arrow {\n    top: 0;\n    left: 50%;\n    margin-left: -@tooltip-arrow-width;\n    border-width: 0 @tooltip-arrow-width @tooltip-arrow-width;\n    border-bottom-color: @tooltip-arrow-color;\n  }\n  &.bottom-left .tooltip-arrow {\n    top: 0;\n    right: @tooltip-arrow-width;\n    margin-top: -@tooltip-arrow-width;\n    border-width: 0 @tooltip-arrow-width @tooltip-arrow-width;\n    border-bottom-color: @tooltip-arrow-color;\n  }\n  &.bottom-right .tooltip-arrow {\n    top: 0;\n    left: @tooltip-arrow-width;\n    margin-top: -@tooltip-arrow-width;\n    border-width: 0 @tooltip-arrow-width @tooltip-arrow-width;\n    border-bottom-color: @tooltip-arrow-color;\n  }\n}\n\n// Wrapper for the tooltip content\n.tooltip-inner {\n  max-width: @tooltip-max-width;\n  padding: 3px 8px;\n  color: @tooltip-color;\n  text-align: center;\n  background-color: @tooltip-bg;\n  border-radius: @border-radius-base;\n}\n\n// Arrows\n.tooltip-arrow {\n  position: absolute;\n  width: 0;\n  height: 0;\n  border-color: transparent;\n  border-style: solid;\n}\n",".reset-text() {\n  font-family: @font-family-base;\n  // We deliberately do NOT reset font-size.\n  font-style: normal;\n  font-weight: 400;\n  line-height: @line-height-base;\n  line-break: auto;\n  text-align: left; // Fallback for where `start` is not supported\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  word-spacing: normal;\n  word-wrap: normal;\n  white-space: normal;\n}\n","//\n// Popovers\n// --------------------------------------------------\n\n\n.popover {\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: @zindex-popover;\n  display: none;\n  max-width: @popover-max-width;\n  padding: 1px;\n  // Our parent element can be arbitrary since popovers are by default inserted as a sibling of their target element.\n  // So reset our font and text properties to avoid inheriting weird values.\n  .reset-text();\n  font-size: @font-size-base;\n  background-color: @popover-bg;\n  background-clip: padding-box;\n  border: 1px solid @popover-fallback-border-color;\n  border: 1px solid @popover-border-color;\n  border-radius: @border-radius-large;\n  .box-shadow(0 5px 10px rgba(0, 0, 0, .2));\n\n  // Offset the popover to account for the popover arrow\n  &.top { margin-top: -@popover-arrow-width; }\n  &.right { margin-left: @popover-arrow-width; }\n  &.bottom { margin-top: @popover-arrow-width; }\n  &.left { margin-left: -@popover-arrow-width; }\n\n  // Arrows\n  // .arrow is outer, .arrow:after is inner\n  > .arrow {\n    border-width: @popover-arrow-outer-width;\n\n    &,\n    &:after {\n      position: absolute;\n      display: block;\n      width: 0;\n      height: 0;\n      border-color: transparent;\n      border-style: solid;\n    }\n\n    &:after {\n      content: \"\";\n      border-width: @popover-arrow-width;\n    }\n  }\n\n  &.top > .arrow {\n    bottom: -@popover-arrow-outer-width;\n    left: 50%;\n    margin-left: -@popover-arrow-outer-width;\n    border-top-color: @popover-arrow-outer-fallback-color; // IE8 fallback\n    border-top-color: @popover-arrow-outer-color;\n    border-bottom-width: 0;\n    &:after {\n      bottom: 1px;\n      margin-left: -@popover-arrow-width;\n      content: \" \";\n      border-top-color: @popover-arrow-color;\n      border-bottom-width: 0;\n    }\n  }\n  &.right > .arrow {\n    top: 50%;\n    left: -@popover-arrow-outer-width;\n    margin-top: -@popover-arrow-outer-width;\n    border-right-color: @popover-arrow-outer-fallback-color; // IE8 fallback\n    border-right-color: @popover-arrow-outer-color;\n    border-left-width: 0;\n    &:after {\n      bottom: -@popover-arrow-width;\n      left: 1px;\n      content: \" \";\n      border-right-color: @popover-arrow-color;\n      border-left-width: 0;\n    }\n  }\n  &.bottom > .arrow {\n    top: -@popover-arrow-outer-width;\n    left: 50%;\n    margin-left: -@popover-arrow-outer-width;\n    border-top-width: 0;\n    border-bottom-color: @popover-arrow-outer-fallback-color; // IE8 fallback\n    border-bottom-color: @popover-arrow-outer-color;\n    &:after {\n      top: 1px;\n      margin-left: -@popover-arrow-width;\n      content: \" \";\n      border-top-width: 0;\n      border-bottom-color: @popover-arrow-color;\n    }\n  }\n\n  &.left > .arrow {\n    top: 50%;\n    right: -@popover-arrow-outer-width;\n    margin-top: -@popover-arrow-outer-width;\n    border-right-width: 0;\n    border-left-color: @popover-arrow-outer-fallback-color; // IE8 fallback\n    border-left-color: @popover-arrow-outer-color;\n    &:after {\n      right: 1px;\n      bottom: -@popover-arrow-width;\n      content: \" \";\n      border-right-width: 0;\n      border-left-color: @popover-arrow-color;\n    }\n  }\n}\n\n.popover-title {\n  padding: 8px 14px;\n  margin: 0; // reset heading margin\n  font-size: @font-size-base;\n  background-color: @popover-title-bg;\n  border-bottom: 1px solid darken(@popover-title-bg, 5%);\n  border-radius: (@border-radius-large - 1) (@border-radius-large - 1) 0 0;\n}\n\n.popover-content {\n  padding: 9px 14px;\n}\n","// stylelint-disable media-feature-name-no-unknown\n\n//\n// Carousel\n// --------------------------------------------------\n\n\n// Wrapper for the slide container and indicators\n.carousel {\n  position: relative;\n}\n\n.carousel-inner {\n  position: relative;\n  width: 100%;\n  overflow: hidden;\n\n  > .item {\n    position: relative;\n    display: none;\n    .transition(.6s ease-in-out left);\n\n    // Account for jankitude on images\n    > img,\n    > a > img {\n      &:extend(.img-responsive);\n      line-height: 1;\n    }\n\n    // WebKit CSS3 transforms for supported devices\n    @media all and (transform-3d), (-webkit-transform-3d) {\n      .transition-transform(~\"0.6s ease-in-out\");\n      .backface-visibility(~\"hidden\");\n      .perspective(1000px);\n\n      &.next,\n      &.active.right {\n        .translate3d(100%, 0, 0);\n        left: 0;\n      }\n      &.prev,\n      &.active.left {\n        .translate3d(-100%, 0, 0);\n        left: 0;\n      }\n      &.next.left,\n      &.prev.right,\n      &.active {\n        .translate3d(0, 0, 0);\n        left: 0;\n      }\n    }\n  }\n\n  > .active,\n  > .next,\n  > .prev {\n    display: block;\n  }\n\n  > .active {\n    left: 0;\n  }\n\n  > .next,\n  > .prev {\n    position: absolute;\n    top: 0;\n    width: 100%;\n  }\n\n  > .next {\n    left: 100%;\n  }\n  > .prev {\n    left: -100%;\n  }\n  > .next.left,\n  > .prev.right {\n    left: 0;\n  }\n\n  > .active.left {\n    left: -100%;\n  }\n  > .active.right {\n    left: 100%;\n  }\n\n}\n\n// Left/right controls for nav\n// ---------------------------\n\n.carousel-control {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  width: @carousel-control-width;\n  font-size: @carousel-control-font-size;\n  color: @carousel-control-color;\n  text-align: center;\n  text-shadow: @carousel-text-shadow;\n  background-color: rgba(0, 0, 0, 0); // Fix IE9 click-thru bug\n  .opacity(@carousel-control-opacity);\n  // We can't have this transition here because WebKit cancels the carousel\n  // animation if you trip this while in the middle of another animation.\n\n  // Set gradients for backgrounds\n  &.left {\n    #gradient > .horizontal(@start-color: rgba(0, 0, 0, .5); @end-color: rgba(0, 0, 0, .0001));\n  }\n  &.right {\n    right: 0;\n    left: auto;\n    #gradient > .horizontal(@start-color: rgba(0, 0, 0, .0001); @end-color: rgba(0, 0, 0, .5));\n  }\n\n  // Hover/focus state\n  &:hover,\n  &:focus {\n    color: @carousel-control-color;\n    text-decoration: none;\n    outline: 0;\n    .opacity(.9);\n  }\n\n  // Toggles\n  .icon-prev,\n  .icon-next,\n  .glyphicon-chevron-left,\n  .glyphicon-chevron-right {\n    position: absolute;\n    top: 50%;\n    z-index: 5;\n    display: inline-block;\n    margin-top: -10px;\n  }\n  .icon-prev,\n  .glyphicon-chevron-left {\n    left: 50%;\n    margin-left: -10px;\n  }\n  .icon-next,\n  .glyphicon-chevron-right {\n    right: 50%;\n    margin-right: -10px;\n  }\n  .icon-prev,\n  .icon-next {\n    width: 20px;\n    height: 20px;\n    font-family: serif;\n    line-height: 1;\n  }\n\n  .icon-prev {\n    &:before {\n      content: \"\\2039\";// SINGLE LEFT-POINTING ANGLE QUOTATION MARK (U+2039)\n    }\n  }\n  .icon-next {\n    &:before {\n      content: \"\\203a\";// SINGLE RIGHT-POINTING ANGLE QUOTATION MARK (U+203A)\n    }\n  }\n}\n\n// Optional indicator pips\n//\n// Add an unordered list with the following class and add a list item for each\n// slide your carousel holds.\n\n.carousel-indicators {\n  position: absolute;\n  bottom: 10px;\n  left: 50%;\n  z-index: 15;\n  width: 60%;\n  padding-left: 0;\n  margin-left: -30%;\n  text-align: center;\n  list-style: none;\n\n  li {\n    display: inline-block;\n    width: 10px;\n    height: 10px;\n    margin: 1px;\n    text-indent: -999px;\n    cursor: pointer;\n    // IE8-9 hack for event handling\n    //\n    // Internet Explorer 8-9 does not support clicks on elements without a set\n    // `background-color`. We cannot use `filter` since that's not viewed as a\n    // background color by the browser. Thus, a hack is needed.\n    // See https://developer.mozilla.org/en-US/docs/Web/Events/click#Internet_Explorer\n    //\n    // For IE8, we set solid black as it doesn't support `rgba()`. For IE9, we\n    // set alpha transparency for the best results possible.\n    background-color: #000 \\9; // IE8\n    background-color: rgba(0, 0, 0, 0); // IE9\n\n    border: 1px solid @carousel-indicator-border-color;\n    border-radius: 10px;\n  }\n\n  .active {\n    width: 12px;\n    height: 12px;\n    margin: 0;\n    background-color: @carousel-indicator-active-bg;\n  }\n}\n\n// Optional captions\n// -----------------------------\n// Hidden by default for smaller viewports\n.carousel-caption {\n  position: absolute;\n  right: 15%;\n  bottom: 20px;\n  left: 15%;\n  z-index: 10;\n  padding-top: 20px;\n  padding-bottom: 20px;\n  color: @carousel-caption-color;\n  text-align: center;\n  text-shadow: @carousel-text-shadow;\n\n  & .btn {\n    text-shadow: none; // No shadow for button elements in carousel-caption\n  }\n}\n\n\n// Scale up controls for tablets and up\n@media screen and (min-width: @screen-sm-min) {\n\n  // Scale up the controls a smidge\n  .carousel-control {\n    .glyphicon-chevron-left,\n    .glyphicon-chevron-right,\n    .icon-prev,\n    .icon-next {\n      width: (@carousel-control-font-size * 1.5);\n      height: (@carousel-control-font-size * 1.5);\n      margin-top: (@carousel-control-font-size / -2);\n      font-size: (@carousel-control-font-size * 1.5);\n    }\n    .glyphicon-chevron-left,\n    .icon-prev {\n      margin-left: (@carousel-control-font-size / -2);\n    }\n    .glyphicon-chevron-right,\n    .icon-next {\n      margin-right: (@carousel-control-font-size / -2);\n    }\n  }\n\n  // Show and left align the captions\n  .carousel-caption {\n    right: 20%;\n    left: 20%;\n    padding-bottom: 30px;\n  }\n\n  // Move up the indicators\n  .carousel-indicators {\n    bottom: 20px;\n  }\n}\n","// Clearfix\n//\n// For modern browsers\n// 1. The space content is one way to avoid an Opera bug when the\n//    contenteditable attribute is included anywhere else in the document.\n//    Otherwise it causes space to appear at the top and bottom of elements\n//    that are clearfixed.\n// 2. The use of `table` rather than `block` is only necessary if using\n//    `:before` to contain the top-margins of child elements.\n//\n// Source: http://nicolasgallagher.com/micro-clearfix-hack/\n\n.clearfix() {\n  &:before,\n  &:after {\n    display: table; // 2\n    content: \" \"; // 1\n  }\n  &:after {\n    clear: both;\n  }\n}\n","// Center-align a block level element\n\n.center-block() {\n  display: block;\n  margin-right: auto;\n  margin-left: auto;\n}\n","// stylelint-disable font-family-name-quotes, font-family-no-missing-generic-family-keyword\n\n// CSS image replacement\n//\n// Heads up! v3 launched with only `.hide-text()`, but per our pattern for\n// mixins being reused as classes with the same name, this doesn't hold up. As\n// of v3.0.1 we have added `.text-hide()` and deprecated `.hide-text()`.\n//\n// Source: https://github.com/h5bp/html5-boilerplate/commit/aa0396eae757\n\n// Deprecated as of v3.0.1 (has been removed in v4)\n.hide-text() {\n  font: ~\"0/0\" a;\n  color: transparent;\n  text-shadow: none;\n  background-color: transparent;\n  border: 0;\n}\n\n// New mixin to use as of v3.0.1\n.text-hide() {\n  .hide-text();\n}\n","// stylelint-disable declaration-no-important, at-rule-no-vendor-prefix\n\n//\n// Responsive: Utility classes\n// --------------------------------------------------\n\n\n// IE10 in Windows (Phone) 8\n//\n// Support for responsive views via media queries is kind of borked in IE10, for\n// Surface/desktop in split view and for Windows Phone 8. This particular fix\n// must be accompanied by a snippet of JavaScript to sniff the user agent and\n// apply some conditional CSS to *only* the Surface/desktop Windows 8. Look at\n// our Getting Started page for more information on this bug.\n//\n// For more information, see the following:\n//\n// Issue: https://github.com/twbs/bootstrap/issues/10497\n// Docs: https://getbootstrap.com/docs/3.4/getting-started/#support-ie10-width\n// Source: https://timkadlec.com/2013/01/windows-phone-8-and-device-width/\n// Source: https://timkadlec.com/2012/10/ie10-snap-mode-and-responsive-design/\n\n@-ms-viewport {\n  width: device-width;\n}\n\n\n// Visibility utilities\n// Note: Deprecated .visible-xs, .visible-sm, .visible-md, and .visible-lg as of v3.2.0\n.visible-xs,\n.visible-sm,\n.visible-md,\n.visible-lg {\n  .responsive-invisibility();\n}\n\n.visible-xs-block,\n.visible-xs-inline,\n.visible-xs-inline-block,\n.visible-sm-block,\n.visible-sm-inline,\n.visible-sm-inline-block,\n.visible-md-block,\n.visible-md-inline,\n.visible-md-inline-block,\n.visible-lg-block,\n.visible-lg-inline,\n.visible-lg-inline-block {\n  display: none !important;\n}\n\n.visible-xs {\n  @media (max-width: @screen-xs-max) {\n    .responsive-visibility();\n  }\n}\n.visible-xs-block {\n  @media (max-width: @screen-xs-max) {\n    display: block !important;\n  }\n}\n.visible-xs-inline {\n  @media (max-width: @screen-xs-max) {\n    display: inline !important;\n  }\n}\n.visible-xs-inline-block {\n  @media (max-width: @screen-xs-max) {\n    display: inline-block !important;\n  }\n}\n\n.visible-sm {\n  @media (min-width: @screen-sm-min) and (max-width: @screen-sm-max) {\n    .responsive-visibility();\n  }\n}\n.visible-sm-block {\n  @media (min-width: @screen-sm-min) and (max-width: @screen-sm-max) {\n    display: block !important;\n  }\n}\n.visible-sm-inline {\n  @media (min-width: @screen-sm-min) and (max-width: @screen-sm-max) {\n    display: inline !important;\n  }\n}\n.visible-sm-inline-block {\n  @media (min-width: @screen-sm-min) and (max-width: @screen-sm-max) {\n    display: inline-block !important;\n  }\n}\n\n.visible-md {\n  @media (min-width: @screen-md-min) and (max-width: @screen-md-max) {\n    .responsive-visibility();\n  }\n}\n.visible-md-block {\n  @media (min-width: @screen-md-min) and (max-width: @screen-md-max) {\n    display: block !important;\n  }\n}\n.visible-md-inline {\n  @media (min-width: @screen-md-min) and (max-width: @screen-md-max) {\n    display: inline !important;\n  }\n}\n.visible-md-inline-block {\n  @media (min-width: @screen-md-min) and (max-width: @screen-md-max) {\n    display: inline-block !important;\n  }\n}\n\n.visible-lg {\n  @media (min-width: @screen-lg-min) {\n    .responsive-visibility();\n  }\n}\n.visible-lg-block {\n  @media (min-width: @screen-lg-min) {\n    display: block !important;\n  }\n}\n.visible-lg-inline {\n  @media (min-width: @screen-lg-min) {\n    display: inline !important;\n  }\n}\n.visible-lg-inline-block {\n  @media (min-width: @screen-lg-min) {\n    display: inline-block !important;\n  }\n}\n\n.hidden-xs {\n  @media (max-width: @screen-xs-max) {\n    .responsive-invisibility();\n  }\n}\n.hidden-sm {\n  @media (min-width: @screen-sm-min) and (max-width: @screen-sm-max) {\n    .responsive-invisibility();\n  }\n}\n.hidden-md {\n  @media (min-width: @screen-md-min) and (max-width: @screen-md-max) {\n    .responsive-invisibility();\n  }\n}\n.hidden-lg {\n  @media (min-width: @screen-lg-min) {\n    .responsive-invisibility();\n  }\n}\n\n\n// Print utilities\n//\n// Media queries are placed on the inside to be mixin-friendly.\n\n// Note: Deprecated .visible-print as of v3.2.0\n.visible-print {\n  .responsive-invisibility();\n\n  @media print {\n    .responsive-visibility();\n  }\n}\n.visible-print-block {\n  display: none !important;\n\n  @media print {\n    display: block !important;\n  }\n}\n.visible-print-inline {\n  display: none !important;\n\n  @media print {\n    display: inline !important;\n  }\n}\n.visible-print-inline-block {\n  display: none !important;\n\n  @media print {\n    display: inline-block !important;\n  }\n}\n\n.hidden-print {\n  @media print {\n    .responsive-invisibility();\n  }\n}\n","// stylelint-disable declaration-no-important\n\n.responsive-visibility() {\n  display: block !important;\n  table&  { display: table !important; }\n  tr&     { display: table-row !important; }\n  th&,\n  td&     { display: table-cell !important; }\n}\n\n.responsive-invisibility() {\n  display: none !important;\n}\n","/* FONT PATH\n * -------------------------- */\n\n@font-face {\n  font-family: 'FontAwesome';\n  src: url('@{fa-font-path}/fontawesome-webfont.eot?v=@{fa-version}');\n  src: url('@{fa-font-path}/fontawesome-webfont.eot?#iefix&v=@{fa-version}') format('embedded-opentype'),\n    url('@{fa-font-path}/fontawesome-webfont.woff2?v=@{fa-version}') format('woff2'),\n    url('@{fa-font-path}/fontawesome-webfont.woff?v=@{fa-version}') format('woff'),\n    url('@{fa-font-path}/fontawesome-webfont.ttf?v=@{fa-version}') format('truetype'),\n    url('@{fa-font-path}/fontawesome-webfont.svg?v=@{fa-version}#fontawesomeregular') format('svg');\n  // src: url('@{fa-font-path}/FontAwesome.otf') format('opentype'); // used when developing fonts\n  font-weight: normal;\n  font-style: normal;\n}\n","// Base Class Definition\n// -------------------------\n\n.@{fa-css-prefix} {\n  display: inline-block;\n  font: normal normal normal @fa-font-size-base/@fa-line-height-base FontAwesome; // shortening font declaration\n  font-size: inherit; // can't have font-size inherit on line above, so need to override\n  text-rendering: auto; // optimizelegibility throws things off #1094\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n\n}\n","// Icon Sizes\n// -------------------------\n\n/* makes the font 33% larger relative to the icon container */\n.@{fa-css-prefix}-lg {\n  font-size: (4em / 3);\n  line-height: (3em / 4);\n  vertical-align: -15%;\n}\n.@{fa-css-prefix}-2x { font-size: 2em; }\n.@{fa-css-prefix}-3x { font-size: 3em; }\n.@{fa-css-prefix}-4x { font-size: 4em; }\n.@{fa-css-prefix}-5x { font-size: 5em; }\n","// Fixed Width Icons\n// -------------------------\n.@{fa-css-prefix}-fw {\n  width: (18em / 14);\n  text-align: center;\n}\n","// List Icons\n// -------------------------\n\n.@{fa-css-prefix}-ul {\n  padding-left: 0;\n  margin-left: @fa-li-width;\n  list-style-type: none;\n  > li { position: relative; }\n}\n.@{fa-css-prefix}-li {\n  position: absolute;\n  left: -@fa-li-width;\n  width: @fa-li-width;\n  top: (2em / 14);\n  text-align: center;\n  &.@{fa-css-prefix}-lg {\n    left: (-@fa-li-width + (4em / 14));\n  }\n}\n","// Animated Icons\n// --------------------------\n\n.@{fa-css-prefix}-spin {\n  -webkit-animation: fa-spin 2s infinite linear;\n          animation: fa-spin 2s infinite linear;\n}\n\n.@{fa-css-prefix}-pulse {\n  -webkit-animation: fa-spin 1s infinite steps(8);\n          animation: fa-spin 1s infinite steps(8);\n}\n\n@-webkit-keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(359deg);\n            transform: rotate(359deg);\n  }\n}\n\n@keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(359deg);\n            transform: rotate(359deg);\n  }\n}\n","// Rotated & Flipped Icons\n// -------------------------\n\n.@{fa-css-prefix}-rotate-90  { .fa-icon-rotate(90deg, 1);  }\n.@{fa-css-prefix}-rotate-180 { .fa-icon-rotate(180deg, 2); }\n.@{fa-css-prefix}-rotate-270 { .fa-icon-rotate(270deg, 3); }\n\n.@{fa-css-prefix}-flip-horizontal { .fa-icon-flip(-1, 1, 0); }\n.@{fa-css-prefix}-flip-vertical   { .fa-icon-flip(1, -1, 2); }\n\n// Hook for IE8-9\n// -------------------------\n\n:root .@{fa-css-prefix}-rotate-90,\n:root .@{fa-css-prefix}-rotate-180,\n:root .@{fa-css-prefix}-rotate-270,\n:root .@{fa-css-prefix}-flip-horizontal,\n:root .@{fa-css-prefix}-flip-vertical {\n  filter: none;\n}\n","// Mixins\n// --------------------------\n\n.fa-icon() {\n  display: inline-block;\n  font: normal normal normal @fa-font-size-base/@fa-line-height-base FontAwesome; // shortening font declaration\n  font-size: inherit; // can't have font-size inherit on line above, so need to override\n  text-rendering: auto; // optimizelegibility throws things off #1094\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n\n}\n\n.fa-icon-rotate(@degrees, @rotation) {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=@{rotation})\";\n  -webkit-transform: rotate(@degrees);\n      -ms-transform: rotate(@degrees);\n          transform: rotate(@degrees);\n}\n\n.fa-icon-flip(@horiz, @vert, @rotation) {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=@{rotation}, mirror=1)\";\n  -webkit-transform: scale(@horiz, @vert);\n      -ms-transform: scale(@horiz, @vert);\n          transform: scale(@horiz, @vert);\n}\n\n\n// Only display content to screen readers. A la Bootstrap 4.\n//\n// See: http://a11yproject.com/posts/how-to-hide-content/\n\n.sr-only() {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0,0,0,0);\n  border: 0;\n}\n\n// Use in conjunction with .sr-only to only display content when it's focused.\n//\n// Useful for \"Skip to main content\" links; see http://www.w3.org/TR/2013/NOTE-WCAG20-TECHS-20130905/G1\n//\n// Credit: HTML5 Boilerplate\n\n.sr-only-focusable() {\n  &:active,\n  &:focus {\n    position: static;\n    width: auto;\n    height: auto;\n    margin: 0;\n    overflow: visible;\n    clip: auto;\n  }\n}\n","// Stacked Icons\n// -------------------------\n\n.@{fa-css-prefix}-stack {\n  position: relative;\n  display: inline-block;\n  width: 2em;\n  height: 2em;\n  line-height: 2em;\n  vertical-align: middle;\n}\n.@{fa-css-prefix}-stack-1x, .@{fa-css-prefix}-stack-2x {\n  position: absolute;\n  left: 0;\n  width: 100%;\n  text-align: center;\n}\n.@{fa-css-prefix}-stack-1x { line-height: inherit; }\n.@{fa-css-prefix}-stack-2x { font-size: 2em; }\n.@{fa-css-prefix}-inverse { color: @fa-inverse; }\n","/* Font Awesome uses the Unicode Private Use Area (PUA) to ensure screen\n   readers do not read off random characters that represent icons */\n\n.@{fa-css-prefix}-glass:before { content: @fa-var-glass; }\n.@{fa-css-prefix}-music:before { content: @fa-var-music; }\n.@{fa-css-prefix}-search:before { content: @fa-var-search; }\n.@{fa-css-prefix}-envelope-o:before { content: @fa-var-envelope-o; }\n.@{fa-css-prefix}-heart:before { content: @fa-var-heart; }\n.@{fa-css-prefix}-star:before { content: @fa-var-star; }\n.@{fa-css-prefix}-star-o:before { content: @fa-var-star-o; }\n.@{fa-css-prefix}-user:before { content: @fa-var-user; }\n.@{fa-css-prefix}-film:before { content: @fa-var-film; }\n.@{fa-css-prefix}-th-large:before { content: @fa-var-th-large; }\n.@{fa-css-prefix}-th:before { content: @fa-var-th; }\n.@{fa-css-prefix}-th-list:before { content: @fa-var-th-list; }\n.@{fa-css-prefix}-check:before { content: @fa-var-check; }\n.@{fa-css-prefix}-remove:before,\n.@{fa-css-prefix}-close:before,\n.@{fa-css-prefix}-times:before { content: @fa-var-times; }\n.@{fa-css-prefix}-search-plus:before { content: @fa-var-search-plus; }\n.@{fa-css-prefix}-search-minus:before { content: @fa-var-search-minus; }\n.@{fa-css-prefix}-power-off:before { content: @fa-var-power-off; }\n.@{fa-css-prefix}-signal:before { content: @fa-var-signal; }\n.@{fa-css-prefix}-gear:before,\n.@{fa-css-prefix}-cog:before { content: @fa-var-cog; }\n.@{fa-css-prefix}-trash-o:before { content: @fa-var-trash-o; }\n.@{fa-css-prefix}-home:before { content: @fa-var-home; }\n.@{fa-css-prefix}-file-o:before { content: @fa-var-file-o; }\n.@{fa-css-prefix}-clock-o:before { content: @fa-var-clock-o; }\n.@{fa-css-prefix}-road:before { content: @fa-var-road; }\n.@{fa-css-prefix}-download:before { content: @fa-var-download; }\n.@{fa-css-prefix}-arrow-circle-o-down:before { content: @fa-var-arrow-circle-o-down; }\n.@{fa-css-prefix}-arrow-circle-o-up:before { content: @fa-var-arrow-circle-o-up; }\n.@{fa-css-prefix}-inbox:before { content: @fa-var-inbox; }\n.@{fa-css-prefix}-play-circle-o:before { content: @fa-var-play-circle-o; }\n.@{fa-css-prefix}-rotate-right:before,\n.@{fa-css-prefix}-repeat:before { content: @fa-var-repeat; }\n.@{fa-css-prefix}-refresh:before { content: @fa-var-refresh; }\n.@{fa-css-prefix}-list-alt:before { content: @fa-var-list-alt; }\n.@{fa-css-prefix}-lock:before { content: @fa-var-lock; }\n.@{fa-css-prefix}-flag:before { content: @fa-var-flag; }\n.@{fa-css-prefix}-headphones:before { content: @fa-var-headphones; }\n.@{fa-css-prefix}-volume-off:before { content: @fa-var-volume-off; }\n.@{fa-css-prefix}-volume-down:before { content: @fa-var-volume-down; }\n.@{fa-css-prefix}-volume-up:before { content: @fa-var-volume-up; }\n.@{fa-css-prefix}-qrcode:before { content: @fa-var-qrcode; }\n.@{fa-css-prefix}-barcode:before { content: @fa-var-barcode; }\n.@{fa-css-prefix}-tag:before { content: @fa-var-tag; }\n.@{fa-css-prefix}-tags:before { content: @fa-var-tags; }\n.@{fa-css-prefix}-book:before { content: @fa-var-book; }\n.@{fa-css-prefix}-bookmark:before { content: @fa-var-bookmark; }\n.@{fa-css-prefix}-print:before { content: @fa-var-print; }\n.@{fa-css-prefix}-camera:before { content: @fa-var-camera; }\n.@{fa-css-prefix}-font:before { content: @fa-var-font; }\n.@{fa-css-prefix}-bold:before { content: @fa-var-bold; }\n.@{fa-css-prefix}-italic:before { content: @fa-var-italic; }\n.@{fa-css-prefix}-text-height:before { content: @fa-var-text-height; }\n.@{fa-css-prefix}-text-width:before { content: @fa-var-text-width; }\n.@{fa-css-prefix}-align-left:before { content: @fa-var-align-left; }\n.@{fa-css-prefix}-align-center:before { content: @fa-var-align-center; }\n.@{fa-css-prefix}-align-right:before { content: @fa-var-align-right; }\n.@{fa-css-prefix}-align-justify:before { content: @fa-var-align-justify; }\n.@{fa-css-prefix}-list:before { content: @fa-var-list; }\n.@{fa-css-prefix}-dedent:before,\n.@{fa-css-prefix}-outdent:before { content: @fa-var-outdent; }\n.@{fa-css-prefix}-indent:before { content: @fa-var-indent; }\n.@{fa-css-prefix}-video-camera:before { content: @fa-var-video-camera; }\n.@{fa-css-prefix}-photo:before,\n.@{fa-css-prefix}-image:before,\n.@{fa-css-prefix}-picture-o:before { content: @fa-var-picture-o; }\n.@{fa-css-prefix}-pencil:before { content: @fa-var-pencil; }\n.@{fa-css-prefix}-map-marker:before { content: @fa-var-map-marker; }\n.@{fa-css-prefix}-adjust:before { content: @fa-var-adjust; }\n.@{fa-css-prefix}-tint:before { content: @fa-var-tint; }\n.@{fa-css-prefix}-edit:before,\n.@{fa-css-prefix}-pencil-square-o:before { content: @fa-var-pencil-square-o; }\n.@{fa-css-prefix}-share-square-o:before { content: @fa-var-share-square-o; }\n.@{fa-css-prefix}-check-square-o:before { content: @fa-var-check-square-o; }\n.@{fa-css-prefix}-arrows:before { content: @fa-var-arrows; }\n.@{fa-css-prefix}-step-backward:before { content: @fa-var-step-backward; }\n.@{fa-css-prefix}-fast-backward:before { content: @fa-var-fast-backward; }\n.@{fa-css-prefix}-backward:before { content: @fa-var-backward; }\n.@{fa-css-prefix}-play:before { content: @fa-var-play; }\n.@{fa-css-prefix}-pause:before { content: @fa-var-pause; }\n.@{fa-css-prefix}-stop:before { content: @fa-var-stop; }\n.@{fa-css-prefix}-forward:before { content: @fa-var-forward; }\n.@{fa-css-prefix}-fast-forward:before { content: @fa-var-fast-forward; }\n.@{fa-css-prefix}-step-forward:before { content: @fa-var-step-forward; }\n.@{fa-css-prefix}-eject:before { content: @fa-var-eject; }\n.@{fa-css-prefix}-chevron-left:before { content: @fa-var-chevron-left; }\n.@{fa-css-prefix}-chevron-right:before { content: @fa-var-chevron-right; }\n.@{fa-css-prefix}-plus-circle:before { content: @fa-var-plus-circle; }\n.@{fa-css-prefix}-minus-circle:before { content: @fa-var-minus-circle; }\n.@{fa-css-prefix}-times-circle:before { content: @fa-var-times-circle; }\n.@{fa-css-prefix}-check-circle:before { content: @fa-var-check-circle; }\n.@{fa-css-prefix}-question-circle:before { content: @fa-var-question-circle; }\n.@{fa-css-prefix}-info-circle:before { content: @fa-var-info-circle; }\n.@{fa-css-prefix}-crosshairs:before { content: @fa-var-crosshairs; }\n.@{fa-css-prefix}-times-circle-o:before { content: @fa-var-times-circle-o; }\n.@{fa-css-prefix}-check-circle-o:before { content: @fa-var-check-circle-o; }\n.@{fa-css-prefix}-ban:before { content: @fa-var-ban; }\n.@{fa-css-prefix}-arrow-left:before { content: @fa-var-arrow-left; }\n.@{fa-css-prefix}-arrow-right:before { content: @fa-var-arrow-right; }\n.@{fa-css-prefix}-arrow-up:before { content: @fa-var-arrow-up; }\n.@{fa-css-prefix}-arrow-down:before { content: @fa-var-arrow-down; }\n.@{fa-css-prefix}-mail-forward:before,\n.@{fa-css-prefix}-share:before { content: @fa-var-share; }\n.@{fa-css-prefix}-expand:before { content: @fa-var-expand; }\n.@{fa-css-prefix}-compress:before { content: @fa-var-compress; }\n.@{fa-css-prefix}-plus:before { content: @fa-var-plus; }\n.@{fa-css-prefix}-minus:before { content: @fa-var-minus; }\n.@{fa-css-prefix}-asterisk:before { content: @fa-var-asterisk; }\n.@{fa-css-prefix}-exclamation-circle:before { content: @fa-var-exclamation-circle; }\n.@{fa-css-prefix}-gift:before { content: @fa-var-gift; }\n.@{fa-css-prefix}-leaf:before { content: @fa-var-leaf; }\n.@{fa-css-prefix}-fire:before { content: @fa-var-fire; }\n.@{fa-css-prefix}-eye:before { content: @fa-var-eye; }\n.@{fa-css-prefix}-eye-slash:before { content: @fa-var-eye-slash; }\n.@{fa-css-prefix}-warning:before,\n.@{fa-css-prefix}-exclamation-triangle:before { content: @fa-var-exclamation-triangle; }\n.@{fa-css-prefix}-plane:before { content: @fa-var-plane; }\n.@{fa-css-prefix}-calendar:before { content: @fa-var-calendar; }\n.@{fa-css-prefix}-random:before { content: @fa-var-random; }\n.@{fa-css-prefix}-comment:before { content: @fa-var-comment; }\n.@{fa-css-prefix}-magnet:before { content: @fa-var-magnet; }\n.@{fa-css-prefix}-chevron-up:before { content: @fa-var-chevron-up; }\n.@{fa-css-prefix}-chevron-down:before { content: @fa-var-chevron-down; }\n.@{fa-css-prefix}-retweet:before { content: @fa-var-retweet; }\n.@{fa-css-prefix}-shopping-cart:before { content: @fa-var-shopping-cart; }\n.@{fa-css-prefix}-folder:before { content: @fa-var-folder; }\n.@{fa-css-prefix}-folder-open:before { content: @fa-var-folder-open; }\n.@{fa-css-prefix}-arrows-v:before { content: @fa-var-arrows-v; }\n.@{fa-css-prefix}-arrows-h:before { content: @fa-var-arrows-h; }\n.@{fa-css-prefix}-bar-chart-o:before,\n.@{fa-css-prefix}-bar-chart:before { content: @fa-var-bar-chart; }\n.@{fa-css-prefix}-twitter-square:before { content: @fa-var-twitter-square; }\n.@{fa-css-prefix}-facebook-square:before { content: @fa-var-facebook-square; }\n.@{fa-css-prefix}-camera-retro:before { content: @fa-var-camera-retro; }\n.@{fa-css-prefix}-key:before { content: @fa-var-key; }\n.@{fa-css-prefix}-gears:before,\n.@{fa-css-prefix}-cogs:before { content: @fa-var-cogs; }\n.@{fa-css-prefix}-comments:before { content: @fa-var-comments; }\n.@{fa-css-prefix}-thumbs-o-up:before { content: @fa-var-thumbs-o-up; }\n.@{fa-css-prefix}-thumbs-o-down:before { content: @fa-var-thumbs-o-down; }\n.@{fa-css-prefix}-star-half:before { content: @fa-var-star-half; }\n.@{fa-css-prefix}-heart-o:before { content: @fa-var-heart-o; }\n.@{fa-css-prefix}-sign-out:before { content: @fa-var-sign-out; }\n.@{fa-css-prefix}-linkedin-square:before { content: @fa-var-linkedin-square; }\n.@{fa-css-prefix}-thumb-tack:before { content: @fa-var-thumb-tack; }\n.@{fa-css-prefix}-external-link:before { content: @fa-var-external-link; }\n.@{fa-css-prefix}-sign-in:before { content: @fa-var-sign-in; }\n.@{fa-css-prefix}-trophy:before { content: @fa-var-trophy; }\n.@{fa-css-prefix}-github-square:before { content: @fa-var-github-square; }\n.@{fa-css-prefix}-upload:before { content: @fa-var-upload; }\n.@{fa-css-prefix}-lemon-o:before { content: @fa-var-lemon-o; }\n.@{fa-css-prefix}-phone:before { content: @fa-var-phone; }\n.@{fa-css-prefix}-square-o:before { content: @fa-var-square-o; }\n.@{fa-css-prefix}-bookmark-o:before { content: @fa-var-bookmark-o; }\n.@{fa-css-prefix}-phone-square:before { content: @fa-var-phone-square; }\n.@{fa-css-prefix}-twitter:before { content: @fa-var-twitter; }\n.@{fa-css-prefix}-facebook-f:before,\n.@{fa-css-prefix}-facebook:before { content: @fa-var-facebook; }\n.@{fa-css-prefix}-github:before { content: @fa-var-github; }\n.@{fa-css-prefix}-unlock:before { content: @fa-var-unlock; }\n.@{fa-css-prefix}-credit-card:before { content: @fa-var-credit-card; }\n.@{fa-css-prefix}-feed:before,\n.@{fa-css-prefix}-rss:before { content: @fa-var-rss; }\n.@{fa-css-prefix}-hdd-o:before { content: @fa-var-hdd-o; }\n.@{fa-css-prefix}-bullhorn:before { content: @fa-var-bullhorn; }\n.@{fa-css-prefix}-bell:before { content: @fa-var-bell; }\n.@{fa-css-prefix}-certificate:before { content: @fa-var-certificate; }\n.@{fa-css-prefix}-hand-o-right:before { content: @fa-var-hand-o-right; }\n.@{fa-css-prefix}-hand-o-left:before { content: @fa-var-hand-o-left; }\n.@{fa-css-prefix}-hand-o-up:before { content: @fa-var-hand-o-up; }\n.@{fa-css-prefix}-hand-o-down:before { content: @fa-var-hand-o-down; }\n.@{fa-css-prefix}-arrow-circle-left:before { content: @fa-var-arrow-circle-left; }\n.@{fa-css-prefix}-arrow-circle-right:before { content: @fa-var-arrow-circle-right; }\n.@{fa-css-prefix}-arrow-circle-up:before { content: @fa-var-arrow-circle-up; }\n.@{fa-css-prefix}-arrow-circle-down:before { content: @fa-var-arrow-circle-down; }\n.@{fa-css-prefix}-globe:before { content: @fa-var-globe; }\n.@{fa-css-prefix}-wrench:before { content: @fa-var-wrench; }\n.@{fa-css-prefix}-tasks:before { content: @fa-var-tasks; }\n.@{fa-css-prefix}-filter:before { content: @fa-var-filter; }\n.@{fa-css-prefix}-briefcase:before { content: @fa-var-briefcase; }\n.@{fa-css-prefix}-arrows-alt:before { content: @fa-var-arrows-alt; }\n.@{fa-css-prefix}-group:before,\n.@{fa-css-prefix}-users:before { content: @fa-var-users; }\n.@{fa-css-prefix}-chain:before,\n.@{fa-css-prefix}-link:before { content: @fa-var-link; }\n.@{fa-css-prefix}-cloud:before { content: @fa-var-cloud; }\n.@{fa-css-prefix}-flask:before { content: @fa-var-flask; }\n.@{fa-css-prefix}-cut:before,\n.@{fa-css-prefix}-scissors:before { content: @fa-var-scissors; }\n.@{fa-css-prefix}-copy:before,\n.@{fa-css-prefix}-files-o:before { content: @fa-var-files-o; }\n.@{fa-css-prefix}-paperclip:before { content: @fa-var-paperclip; }\n.@{fa-css-prefix}-save:before,\n.@{fa-css-prefix}-floppy-o:before { content: @fa-var-floppy-o; }\n.@{fa-css-prefix}-square:before { content: @fa-var-square; }\n.@{fa-css-prefix}-navicon:before,\n.@{fa-css-prefix}-reorder:before,\n.@{fa-css-prefix}-bars:before { content: @fa-var-bars; }\n.@{fa-css-prefix}-list-ul:before { content: @fa-var-list-ul; }\n.@{fa-css-prefix}-list-ol:before { content: @fa-var-list-ol; }\n.@{fa-css-prefix}-strikethrough:before { content: @fa-var-strikethrough; }\n.@{fa-css-prefix}-underline:before { content: @fa-var-underline; }\n.@{fa-css-prefix}-table:before { content: @fa-var-table; }\n.@{fa-css-prefix}-magic:before { content: @fa-var-magic; }\n.@{fa-css-prefix}-truck:before { content: @fa-var-truck; }\n.@{fa-css-prefix}-pinterest:before { content: @fa-var-pinterest; }\n.@{fa-css-prefix}-pinterest-square:before { content: @fa-var-pinterest-square; }\n.@{fa-css-prefix}-google-plus-square:before { content: @fa-var-google-plus-square; }\n.@{fa-css-prefix}-google-plus:before { content: @fa-var-google-plus; }\n.@{fa-css-prefix}-money:before { content: @fa-var-money; }\n.@{fa-css-prefix}-caret-down:before { content: @fa-var-caret-down; }\n.@{fa-css-prefix}-caret-up:before { content: @fa-var-caret-up; }\n.@{fa-css-prefix}-caret-left:before { content: @fa-var-caret-left; }\n.@{fa-css-prefix}-caret-right:before { content: @fa-var-caret-right; }\n.@{fa-css-prefix}-columns:before { content: @fa-var-columns; }\n.@{fa-css-prefix}-unsorted:before,\n.@{fa-css-prefix}-sort:before { content: @fa-var-sort; }\n.@{fa-css-prefix}-sort-down:before,\n.@{fa-css-prefix}-sort-desc:before { content: @fa-var-sort-desc; }\n.@{fa-css-prefix}-sort-up:before,\n.@{fa-css-prefix}-sort-asc:before { content: @fa-var-sort-asc; }\n.@{fa-css-prefix}-envelope:before { content: @fa-var-envelope; }\n.@{fa-css-prefix}-linkedin:before { content: @fa-var-linkedin; }\n.@{fa-css-prefix}-rotate-left:before,\n.@{fa-css-prefix}-undo:before { content: @fa-var-undo; }\n.@{fa-css-prefix}-legal:before,\n.@{fa-css-prefix}-gavel:before { content: @fa-var-gavel; }\n.@{fa-css-prefix}-dashboard:before,\n.@{fa-css-prefix}-tachometer:before { content: @fa-var-tachometer; }\n.@{fa-css-prefix}-comment-o:before { content: @fa-var-comment-o; }\n.@{fa-css-prefix}-comments-o:before { content: @fa-var-comments-o; }\n.@{fa-css-prefix}-flash:before,\n.@{fa-css-prefix}-bolt:before { content: @fa-var-bolt; }\n.@{fa-css-prefix}-sitemap:before { content: @fa-var-sitemap; }\n.@{fa-css-prefix}-umbrella:before { content: @fa-var-umbrella; }\n.@{fa-css-prefix}-paste:before,\n.@{fa-css-prefix}-clipboard:before { content: @fa-var-clipboard; }\n.@{fa-css-prefix}-lightbulb-o:before { content: @fa-var-lightbulb-o; }\n.@{fa-css-prefix}-exchange:before { content: @fa-var-exchange; }\n.@{fa-css-prefix}-cloud-download:before { content: @fa-var-cloud-download; }\n.@{fa-css-prefix}-cloud-upload:before { content: @fa-var-cloud-upload; }\n.@{fa-css-prefix}-user-md:before { content: @fa-var-user-md; }\n.@{fa-css-prefix}-stethoscope:before { content: @fa-var-stethoscope; }\n.@{fa-css-prefix}-suitcase:before { content: @fa-var-suitcase; }\n.@{fa-css-prefix}-bell-o:before { content: @fa-var-bell-o; }\n.@{fa-css-prefix}-coffee:before { content: @fa-var-coffee; }\n.@{fa-css-prefix}-cutlery:before { content: @fa-var-cutlery; }\n.@{fa-css-prefix}-file-text-o:before { content: @fa-var-file-text-o; }\n.@{fa-css-prefix}-building-o:before { content: @fa-var-building-o; }\n.@{fa-css-prefix}-hospital-o:before { content: @fa-var-hospital-o; }\n.@{fa-css-prefix}-ambulance:before { content: @fa-var-ambulance; }\n.@{fa-css-prefix}-medkit:before { content: @fa-var-medkit; }\n.@{fa-css-prefix}-fighter-jet:before { content: @fa-var-fighter-jet; }\n.@{fa-css-prefix}-beer:before { content: @fa-var-beer; }\n.@{fa-css-prefix}-h-square:before { content: @fa-var-h-square; }\n.@{fa-css-prefix}-plus-square:before { content: @fa-var-plus-square; }\n.@{fa-css-prefix}-angle-double-left:before { content: @fa-var-angle-double-left; }\n.@{fa-css-prefix}-angle-double-right:before { content: @fa-var-angle-double-right; }\n.@{fa-css-prefix}-angle-double-up:before { content: @fa-var-angle-double-up; }\n.@{fa-css-prefix}-angle-double-down:before { content: @fa-var-angle-double-down; }\n.@{fa-css-prefix}-angle-left:before { content: @fa-var-angle-left; }\n.@{fa-css-prefix}-angle-right:before { content: @fa-var-angle-right; }\n.@{fa-css-prefix}-angle-up:before { content: @fa-var-angle-up; }\n.@{fa-css-prefix}-angle-down:before { content: @fa-var-angle-down; }\n.@{fa-css-prefix}-desktop:before { content: @fa-var-desktop; }\n.@{fa-css-prefix}-laptop:before { content: @fa-var-laptop; }\n.@{fa-css-prefix}-tablet:before { content: @fa-var-tablet; }\n.@{fa-css-prefix}-mobile-phone:before,\n.@{fa-css-prefix}-mobile:before { content: @fa-var-mobile; }\n.@{fa-css-prefix}-circle-o:before { content: @fa-var-circle-o; }\n.@{fa-css-prefix}-quote-left:before { content: @fa-var-quote-left; }\n.@{fa-css-prefix}-quote-right:before { content: @fa-var-quote-right; }\n.@{fa-css-prefix}-spinner:before { content: @fa-var-spinner; }\n.@{fa-css-prefix}-circle:before { content: @fa-var-circle; }\n.@{fa-css-prefix}-mail-reply:before,\n.@{fa-css-prefix}-reply:before { content: @fa-var-reply; }\n.@{fa-css-prefix}-github-alt:before { content: @fa-var-github-alt; }\n.@{fa-css-prefix}-folder-o:before { content: @fa-var-folder-o; }\n.@{fa-css-prefix}-folder-open-o:before { content: @fa-var-folder-open-o; }\n.@{fa-css-prefix}-smile-o:before { content: @fa-var-smile-o; }\n.@{fa-css-prefix}-frown-o:before { content: @fa-var-frown-o; }\n.@{fa-css-prefix}-meh-o:before { content: @fa-var-meh-o; }\n.@{fa-css-prefix}-gamepad:before { content: @fa-var-gamepad; }\n.@{fa-css-prefix}-keyboard-o:before { content: @fa-var-keyboard-o; }\n.@{fa-css-prefix}-flag-o:before { content: @fa-var-flag-o; }\n.@{fa-css-prefix}-flag-checkered:before { content: @fa-var-flag-checkered; }\n.@{fa-css-prefix}-terminal:before { content: @fa-var-terminal; }\n.@{fa-css-prefix}-code:before { content: @fa-var-code; }\n.@{fa-css-prefix}-mail-reply-all:before,\n.@{fa-css-prefix}-reply-all:before { content: @fa-var-reply-all; }\n.@{fa-css-prefix}-star-half-empty:before,\n.@{fa-css-prefix}-star-half-full:before,\n.@{fa-css-prefix}-star-half-o:before { content: @fa-var-star-half-o; }\n.@{fa-css-prefix}-location-arrow:before { content: @fa-var-location-arrow; }\n.@{fa-css-prefix}-crop:before { content: @fa-var-crop; }\n.@{fa-css-prefix}-code-fork:before { content: @fa-var-code-fork; }\n.@{fa-css-prefix}-unlink:before,\n.@{fa-css-prefix}-chain-broken:before { content: @fa-var-chain-broken; }\n.@{fa-css-prefix}-question:before { content: @fa-var-question; }\n.@{fa-css-prefix}-info:before { content: @fa-var-info; }\n.@{fa-css-prefix}-exclamation:before { content: @fa-var-exclamation; }\n.@{fa-css-prefix}-superscript:before { content: @fa-var-superscript; }\n.@{fa-css-prefix}-subscript:before { content: @fa-var-subscript; }\n.@{fa-css-prefix}-eraser:before { content: @fa-var-eraser; }\n.@{fa-css-prefix}-puzzle-piece:before { content: @fa-var-puzzle-piece; }\n.@{fa-css-prefix}-microphone:before { content: @fa-var-microphone; }\n.@{fa-css-prefix}-microphone-slash:before { content: @fa-var-microphone-slash; }\n.@{fa-css-prefix}-shield:before { content: @fa-var-shield; }\n.@{fa-css-prefix}-calendar-o:before { content: @fa-var-calendar-o; }\n.@{fa-css-prefix}-fire-extinguisher:before { content: @fa-var-fire-extinguisher; }\n.@{fa-css-prefix}-rocket:before { content: @fa-var-rocket; }\n.@{fa-css-prefix}-maxcdn:before { content: @fa-var-maxcdn; }\n.@{fa-css-prefix}-chevron-circle-left:before { content: @fa-var-chevron-circle-left; }\n.@{fa-css-prefix}-chevron-circle-right:before { content: @fa-var-chevron-circle-right; }\n.@{fa-css-prefix}-chevron-circle-up:before { content: @fa-var-chevron-circle-up; }\n.@{fa-css-prefix}-chevron-circle-down:before { content: @fa-var-chevron-circle-down; }\n.@{fa-css-prefix}-html5:before { content: @fa-var-html5; }\n.@{fa-css-prefix}-css3:before { content: @fa-var-css3; }\n.@{fa-css-prefix}-anchor:before { content: @fa-var-anchor; }\n.@{fa-css-prefix}-unlock-alt:before { content: @fa-var-unlock-alt; }\n.@{fa-css-prefix}-bullseye:before { content: @fa-var-bullseye; }\n.@{fa-css-prefix}-ellipsis-h:before { content: @fa-var-ellipsis-h; }\n.@{fa-css-prefix}-ellipsis-v:before { content: @fa-var-ellipsis-v; }\n.@{fa-css-prefix}-rss-square:before { content: @fa-var-rss-square; }\n.@{fa-css-prefix}-play-circle:before { content: @fa-var-play-circle; }\n.@{fa-css-prefix}-ticket:before { content: @fa-var-ticket; }\n.@{fa-css-prefix}-minus-square:before { content: @fa-var-minus-square; }\n.@{fa-css-prefix}-minus-square-o:before { content: @fa-var-minus-square-o; }\n.@{fa-css-prefix}-level-up:before { content: @fa-var-level-up; }\n.@{fa-css-prefix}-level-down:before { content: @fa-var-level-down; }\n.@{fa-css-prefix}-check-square:before { content: @fa-var-check-square; }\n.@{fa-css-prefix}-pencil-square:before { content: @fa-var-pencil-square; }\n.@{fa-css-prefix}-external-link-square:before { content: @fa-var-external-link-square; }\n.@{fa-css-prefix}-share-square:before { content: @fa-var-share-square; }\n.@{fa-css-prefix}-compass:before { content: @fa-var-compass; }\n.@{fa-css-prefix}-toggle-down:before,\n.@{fa-css-prefix}-caret-square-o-down:before { content: @fa-var-caret-square-o-down; }\n.@{fa-css-prefix}-toggle-up:before,\n.@{fa-css-prefix}-caret-square-o-up:before { content: @fa-var-caret-square-o-up; }\n.@{fa-css-prefix}-toggle-right:before,\n.@{fa-css-prefix}-caret-square-o-right:before { content: @fa-var-caret-square-o-right; }\n.@{fa-css-prefix}-euro:before,\n.@{fa-css-prefix}-eur:before { content: @fa-var-eur; }\n.@{fa-css-prefix}-gbp:before { content: @fa-var-gbp; }\n.@{fa-css-prefix}-dollar:before,\n.@{fa-css-prefix}-usd:before { content: @fa-var-usd; }\n.@{fa-css-prefix}-rupee:before,\n.@{fa-css-prefix}-inr:before { content: @fa-var-inr; }\n.@{fa-css-prefix}-cny:before,\n.@{fa-css-prefix}-rmb:before,\n.@{fa-css-prefix}-yen:before,\n.@{fa-css-prefix}-jpy:before { content: @fa-var-jpy; }\n.@{fa-css-prefix}-ruble:before,\n.@{fa-css-prefix}-rouble:before,\n.@{fa-css-prefix}-rub:before { content: @fa-var-rub; }\n.@{fa-css-prefix}-won:before,\n.@{fa-css-prefix}-krw:before { content: @fa-var-krw; }\n.@{fa-css-prefix}-bitcoin:before,\n.@{fa-css-prefix}-btc:before { content: @fa-var-btc; }\n.@{fa-css-prefix}-file:before { content: @fa-var-file; }\n.@{fa-css-prefix}-file-text:before { content: @fa-var-file-text; }\n.@{fa-css-prefix}-sort-alpha-asc:before { content: @fa-var-sort-alpha-asc; }\n.@{fa-css-prefix}-sort-alpha-desc:before { content: @fa-var-sort-alpha-desc; }\n.@{fa-css-prefix}-sort-amount-asc:before { content: @fa-var-sort-amount-asc; }\n.@{fa-css-prefix}-sort-amount-desc:before { content: @fa-var-sort-amount-desc; }\n.@{fa-css-prefix}-sort-numeric-asc:before { content: @fa-var-sort-numeric-asc; }\n.@{fa-css-prefix}-sort-numeric-desc:before { content: @fa-var-sort-numeric-desc; }\n.@{fa-css-prefix}-thumbs-up:before { content: @fa-var-thumbs-up; }\n.@{fa-css-prefix}-thumbs-down:before { content: @fa-var-thumbs-down; }\n.@{fa-css-prefix}-youtube-square:before { content: @fa-var-youtube-square; }\n.@{fa-css-prefix}-youtube:before { content: @fa-var-youtube; }\n.@{fa-css-prefix}-xing:before { content: @fa-var-xing; }\n.@{fa-css-prefix}-xing-square:before { content: @fa-var-xing-square; }\n.@{fa-css-prefix}-youtube-play:before { content: @fa-var-youtube-play; }\n.@{fa-css-prefix}-dropbox:before { content: @fa-var-dropbox; }\n.@{fa-css-prefix}-stack-overflow:before { content: @fa-var-stack-overflow; }\n.@{fa-css-prefix}-instagram:before { content: @fa-var-instagram; }\n.@{fa-css-prefix}-flickr:before { content: @fa-var-flickr; }\n.@{fa-css-prefix}-adn:before { content: @fa-var-adn; }\n.@{fa-css-prefix}-bitbucket:before { content: @fa-var-bitbucket; }\n.@{fa-css-prefix}-bitbucket-square:before { content: @fa-var-bitbucket-square; }\n.@{fa-css-prefix}-tumblr:before { content: @fa-var-tumblr; }\n.@{fa-css-prefix}-tumblr-square:before { content: @fa-var-tumblr-square; }\n.@{fa-css-prefix}-long-arrow-down:before { content: @fa-var-long-arrow-down; }\n.@{fa-css-prefix}-long-arrow-up:before { content: @fa-var-long-arrow-up; }\n.@{fa-css-prefix}-long-arrow-left:before { content: @fa-var-long-arrow-left; }\n.@{fa-css-prefix}-long-arrow-right:before { content: @fa-var-long-arrow-right; }\n.@{fa-css-prefix}-apple:before { content: @fa-var-apple; }\n.@{fa-css-prefix}-windows:before { content: @fa-var-windows; }\n.@{fa-css-prefix}-android:before { content: @fa-var-android; }\n.@{fa-css-prefix}-linux:before { content: @fa-var-linux; }\n.@{fa-css-prefix}-dribbble:before { content: @fa-var-dribbble; }\n.@{fa-css-prefix}-skype:before { content: @fa-var-skype; }\n.@{fa-css-prefix}-foursquare:before { content: @fa-var-foursquare; }\n.@{fa-css-prefix}-trello:before { content: @fa-var-trello; }\n.@{fa-css-prefix}-female:before { content: @fa-var-female; }\n.@{fa-css-prefix}-male:before { content: @fa-var-male; }\n.@{fa-css-prefix}-gittip:before,\n.@{fa-css-prefix}-gratipay:before { content: @fa-var-gratipay; }\n.@{fa-css-prefix}-sun-o:before { content: @fa-var-sun-o; }\n.@{fa-css-prefix}-moon-o:before { content: @fa-var-moon-o; }\n.@{fa-css-prefix}-archive:before { content: @fa-var-archive; }\n.@{fa-css-prefix}-bug:before { content: @fa-var-bug; }\n.@{fa-css-prefix}-vk:before { content: @fa-var-vk; }\n.@{fa-css-prefix}-weibo:before { content: @fa-var-weibo; }\n.@{fa-css-prefix}-renren:before { content: @fa-var-renren; }\n.@{fa-css-prefix}-pagelines:before { content: @fa-var-pagelines; }\n.@{fa-css-prefix}-stack-exchange:before { content: @fa-var-stack-exchange; }\n.@{fa-css-prefix}-arrow-circle-o-right:before { content: @fa-var-arrow-circle-o-right; }\n.@{fa-css-prefix}-arrow-circle-o-left:before { content: @fa-var-arrow-circle-o-left; }\n.@{fa-css-prefix}-toggle-left:before,\n.@{fa-css-prefix}-caret-square-o-left:before { content: @fa-var-caret-square-o-left; }\n.@{fa-css-prefix}-dot-circle-o:before { content: @fa-var-dot-circle-o; }\n.@{fa-css-prefix}-wheelchair:before { content: @fa-var-wheelchair; }\n.@{fa-css-prefix}-vimeo-square:before { content: @fa-var-vimeo-square; }\n.@{fa-css-prefix}-turkish-lira:before,\n.@{fa-css-prefix}-try:before { content: @fa-var-try; }\n.@{fa-css-prefix}-plus-square-o:before { content: @fa-var-plus-square-o; }\n.@{fa-css-prefix}-space-shuttle:before { content: @fa-var-space-shuttle; }\n.@{fa-css-prefix}-slack:before { content: @fa-var-slack; }\n.@{fa-css-prefix}-envelope-square:before { content: @fa-var-envelope-square; }\n.@{fa-css-prefix}-wordpress:before { content: @fa-var-wordpress; }\n.@{fa-css-prefix}-openid:before { content: @fa-var-openid; }\n.@{fa-css-prefix}-institution:before,\n.@{fa-css-prefix}-bank:before,\n.@{fa-css-prefix}-university:before { content: @fa-var-university; }\n.@{fa-css-prefix}-mortar-board:before,\n.@{fa-css-prefix}-graduation-cap:before { content: @fa-var-graduation-cap; }\n.@{fa-css-prefix}-yahoo:before { content: @fa-var-yahoo; }\n.@{fa-css-prefix}-google:before { content: @fa-var-google; }\n.@{fa-css-prefix}-reddit:before { content: @fa-var-reddit; }\n.@{fa-css-prefix}-reddit-square:before { content: @fa-var-reddit-square; }\n.@{fa-css-prefix}-stumbleupon-circle:before { content: @fa-var-stumbleupon-circle; }\n.@{fa-css-prefix}-stumbleupon:before { content: @fa-var-stumbleupon; }\n.@{fa-css-prefix}-delicious:before { content: @fa-var-delicious; }\n.@{fa-css-prefix}-digg:before { content: @fa-var-digg; }\n.@{fa-css-prefix}-pied-piper-pp:before { content: @fa-var-pied-piper-pp; }\n.@{fa-css-prefix}-pied-piper-alt:before { content: @fa-var-pied-piper-alt; }\n.@{fa-css-prefix}-drupal:before { content: @fa-var-drupal; }\n.@{fa-css-prefix}-joomla:before { content: @fa-var-joomla; }\n.@{fa-css-prefix}-language:before { content: @fa-var-language; }\n.@{fa-css-prefix}-fax:before { content: @fa-var-fax; }\n.@{fa-css-prefix}-building:before { content: @fa-var-building; }\n.@{fa-css-prefix}-child:before { content: @fa-var-child; }\n.@{fa-css-prefix}-paw:before { content: @fa-var-paw; }\n.@{fa-css-prefix}-spoon:before { content: @fa-var-spoon; }\n.@{fa-css-prefix}-cube:before { content: @fa-var-cube; }\n.@{fa-css-prefix}-cubes:before { content: @fa-var-cubes; }\n.@{fa-css-prefix}-behance:before { content: @fa-var-behance; }\n.@{fa-css-prefix}-behance-square:before { content: @fa-var-behance-square; }\n.@{fa-css-prefix}-steam:before { content: @fa-var-steam; }\n.@{fa-css-prefix}-steam-square:before { content: @fa-var-steam-square; }\n.@{fa-css-prefix}-recycle:before { content: @fa-var-recycle; }\n.@{fa-css-prefix}-automobile:before,\n.@{fa-css-prefix}-car:before { content: @fa-var-car; }\n.@{fa-css-prefix}-cab:before,\n.@{fa-css-prefix}-taxi:before { content: @fa-var-taxi; }\n.@{fa-css-prefix}-tree:before { content: @fa-var-tree; }\n.@{fa-css-prefix}-spotify:before { content: @fa-var-spotify; }\n.@{fa-css-prefix}-deviantart:before { content: @fa-var-deviantart; }\n.@{fa-css-prefix}-soundcloud:before { content: @fa-var-soundcloud; }\n.@{fa-css-prefix}-database:before { content: @fa-var-database; }\n.@{fa-css-prefix}-file-pdf-o:before { content: @fa-var-file-pdf-o; }\n.@{fa-css-prefix}-file-word-o:before { content: @fa-var-file-word-o; }\n.@{fa-css-prefix}-file-excel-o:before { content: @fa-var-file-excel-o; }\n.@{fa-css-prefix}-file-powerpoint-o:before { content: @fa-var-file-powerpoint-o; }\n.@{fa-css-prefix}-file-photo-o:before,\n.@{fa-css-prefix}-file-picture-o:before,\n.@{fa-css-prefix}-file-image-o:before { content: @fa-var-file-image-o; }\n.@{fa-css-prefix}-file-zip-o:before,\n.@{fa-css-prefix}-file-archive-o:before { content: @fa-var-file-archive-o; }\n.@{fa-css-prefix}-file-sound-o:before,\n.@{fa-css-prefix}-file-audio-o:before { content: @fa-var-file-audio-o; }\n.@{fa-css-prefix}-file-movie-o:before,\n.@{fa-css-prefix}-file-video-o:before { content: @fa-var-file-video-o; }\n.@{fa-css-prefix}-file-code-o:before { content: @fa-var-file-code-o; }\n.@{fa-css-prefix}-vine:before { content: @fa-var-vine; }\n.@{fa-css-prefix}-codepen:before { content: @fa-var-codepen; }\n.@{fa-css-prefix}-jsfiddle:before { content: @fa-var-jsfiddle; }\n.@{fa-css-prefix}-life-bouy:before,\n.@{fa-css-prefix}-life-buoy:before,\n.@{fa-css-prefix}-life-saver:before,\n.@{fa-css-prefix}-support:before,\n.@{fa-css-prefix}-life-ring:before { content: @fa-var-life-ring; }\n.@{fa-css-prefix}-circle-o-notch:before { content: @fa-var-circle-o-notch; }\n.@{fa-css-prefix}-ra:before,\n.@{fa-css-prefix}-resistance:before,\n.@{fa-css-prefix}-rebel:before { content: @fa-var-rebel; }\n.@{fa-css-prefix}-ge:before,\n.@{fa-css-prefix}-empire:before { content: @fa-var-empire; }\n.@{fa-css-prefix}-git-square:before { content: @fa-var-git-square; }\n.@{fa-css-prefix}-git:before { content: @fa-var-git; }\n.@{fa-css-prefix}-y-combinator-square:before,\n.@{fa-css-prefix}-yc-square:before,\n.@{fa-css-prefix}-hacker-news:before { content: @fa-var-hacker-news; }\n.@{fa-css-prefix}-tencent-weibo:before { content: @fa-var-tencent-weibo; }\n.@{fa-css-prefix}-qq:before { content: @fa-var-qq; }\n.@{fa-css-prefix}-wechat:before,\n.@{fa-css-prefix}-weixin:before { content: @fa-var-weixin; }\n.@{fa-css-prefix}-send:before,\n.@{fa-css-prefix}-paper-plane:before { content: @fa-var-paper-plane; }\n.@{fa-css-prefix}-send-o:before,\n.@{fa-css-prefix}-paper-plane-o:before { content: @fa-var-paper-plane-o; }\n.@{fa-css-prefix}-history:before { content: @fa-var-history; }\n.@{fa-css-prefix}-circle-thin:before { content: @fa-var-circle-thin; }\n.@{fa-css-prefix}-header:before { content: @fa-var-header; }\n.@{fa-css-prefix}-paragraph:before { content: @fa-var-paragraph; }\n.@{fa-css-prefix}-sliders:before { content: @fa-var-sliders; }\n.@{fa-css-prefix}-share-alt:before { content: @fa-var-share-alt; }\n.@{fa-css-prefix}-share-alt-square:before { content: @fa-var-share-alt-square; }\n.@{fa-css-prefix}-bomb:before { content: @fa-var-bomb; }\n.@{fa-css-prefix}-soccer-ball-o:before,\n.@{fa-css-prefix}-futbol-o:before { content: @fa-var-futbol-o; }\n.@{fa-css-prefix}-tty:before { content: @fa-var-tty; }\n.@{fa-css-prefix}-binoculars:before { content: @fa-var-binoculars; }\n.@{fa-css-prefix}-plug:before { content: @fa-var-plug; }\n.@{fa-css-prefix}-slideshare:before { content: @fa-var-slideshare; }\n.@{fa-css-prefix}-twitch:before { content: @fa-var-twitch; }\n.@{fa-css-prefix}-yelp:before { content: @fa-var-yelp; }\n.@{fa-css-prefix}-newspaper-o:before { content: @fa-var-newspaper-o; }\n.@{fa-css-prefix}-wifi:before { content: @fa-var-wifi; }\n.@{fa-css-prefix}-calculator:before { content: @fa-var-calculator; }\n.@{fa-css-prefix}-paypal:before { content: @fa-var-paypal; }\n.@{fa-css-prefix}-google-wallet:before { content: @fa-var-google-wallet; }\n.@{fa-css-prefix}-cc-visa:before { content: @fa-var-cc-visa; }\n.@{fa-css-prefix}-cc-mastercard:before { content: @fa-var-cc-mastercard; }\n.@{fa-css-prefix}-cc-discover:before { content: @fa-var-cc-discover; }\n.@{fa-css-prefix}-cc-amex:before { content: @fa-var-cc-amex; }\n.@{fa-css-prefix}-cc-paypal:before { content: @fa-var-cc-paypal; }\n.@{fa-css-prefix}-cc-stripe:before { content: @fa-var-cc-stripe; }\n.@{fa-css-prefix}-bell-slash:before { content: @fa-var-bell-slash; }\n.@{fa-css-prefix}-bell-slash-o:before { content: @fa-var-bell-slash-o; }\n.@{fa-css-prefix}-trash:before { content: @fa-var-trash; }\n.@{fa-css-prefix}-copyright:before { content: @fa-var-copyright; }\n.@{fa-css-prefix}-at:before { content: @fa-var-at; }\n.@{fa-css-prefix}-eyedropper:before { content: @fa-var-eyedropper; }\n.@{fa-css-prefix}-paint-brush:before { content: @fa-var-paint-brush; }\n.@{fa-css-prefix}-birthday-cake:before { content: @fa-var-birthday-cake; }\n.@{fa-css-prefix}-area-chart:before { content: @fa-var-area-chart; }\n.@{fa-css-prefix}-pie-chart:before { content: @fa-var-pie-chart; }\n.@{fa-css-prefix}-line-chart:before { content: @fa-var-line-chart; }\n.@{fa-css-prefix}-lastfm:before { content: @fa-var-lastfm; }\n.@{fa-css-prefix}-lastfm-square:before { content: @fa-var-lastfm-square; }\n.@{fa-css-prefix}-toggle-off:before { content: @fa-var-toggle-off; }\n.@{fa-css-prefix}-toggle-on:before { content: @fa-var-toggle-on; }\n.@{fa-css-prefix}-bicycle:before { content: @fa-var-bicycle; }\n.@{fa-css-prefix}-bus:before { content: @fa-var-bus; }\n.@{fa-css-prefix}-ioxhost:before { content: @fa-var-ioxhost; }\n.@{fa-css-prefix}-angellist:before { content: @fa-var-angellist; }\n.@{fa-css-prefix}-cc:before { content: @fa-var-cc; }\n.@{fa-css-prefix}-shekel:before,\n.@{fa-css-prefix}-sheqel:before,\n.@{fa-css-prefix}-ils:before { content: @fa-var-ils; }\n.@{fa-css-prefix}-meanpath:before { content: @fa-var-meanpath; }\n.@{fa-css-prefix}-buysellads:before { content: @fa-var-buysellads; }\n.@{fa-css-prefix}-connectdevelop:before { content: @fa-var-connectdevelop; }\n.@{fa-css-prefix}-dashcube:before { content: @fa-var-dashcube; }\n.@{fa-css-prefix}-forumbee:before { content: @fa-var-forumbee; }\n.@{fa-css-prefix}-leanpub:before { content: @fa-var-leanpub; }\n.@{fa-css-prefix}-sellsy:before { content: @fa-var-sellsy; }\n.@{fa-css-prefix}-shirtsinbulk:before { content: @fa-var-shirtsinbulk; }\n.@{fa-css-prefix}-simplybuilt:before { content: @fa-var-simplybuilt; }\n.@{fa-css-prefix}-skyatlas:before { content: @fa-var-skyatlas; }\n.@{fa-css-prefix}-cart-plus:before { content: @fa-var-cart-plus; }\n.@{fa-css-prefix}-cart-arrow-down:before { content: @fa-var-cart-arrow-down; }\n.@{fa-css-prefix}-diamond:before { content: @fa-var-diamond; }\n.@{fa-css-prefix}-ship:before { content: @fa-var-ship; }\n.@{fa-css-prefix}-user-secret:before { content: @fa-var-user-secret; }\n.@{fa-css-prefix}-motorcycle:before { content: @fa-var-motorcycle; }\n.@{fa-css-prefix}-street-view:before { content: @fa-var-street-view; }\n.@{fa-css-prefix}-heartbeat:before { content: @fa-var-heartbeat; }\n.@{fa-css-prefix}-venus:before { content: @fa-var-venus; }\n.@{fa-css-prefix}-mars:before { content: @fa-var-mars; }\n.@{fa-css-prefix}-mercury:before { content: @fa-var-mercury; }\n.@{fa-css-prefix}-intersex:before,\n.@{fa-css-prefix}-transgender:before { content: @fa-var-transgender; }\n.@{fa-css-prefix}-transgender-alt:before { content: @fa-var-transgender-alt; }\n.@{fa-css-prefix}-venus-double:before { content: @fa-var-venus-double; }\n.@{fa-css-prefix}-mars-double:before { content: @fa-var-mars-double; }\n.@{fa-css-prefix}-venus-mars:before { content: @fa-var-venus-mars; }\n.@{fa-css-prefix}-mars-stroke:before { content: @fa-var-mars-stroke; }\n.@{fa-css-prefix}-mars-stroke-v:before { content: @fa-var-mars-stroke-v; }\n.@{fa-css-prefix}-mars-stroke-h:before { content: @fa-var-mars-stroke-h; }\n.@{fa-css-prefix}-neuter:before { content: @fa-var-neuter; }\n.@{fa-css-prefix}-genderless:before { content: @fa-var-genderless; }\n.@{fa-css-prefix}-facebook-official:before { content: @fa-var-facebook-official; }\n.@{fa-css-prefix}-pinterest-p:before { content: @fa-var-pinterest-p; }\n.@{fa-css-prefix}-whatsapp:before { content: @fa-var-whatsapp; }\n.@{fa-css-prefix}-server:before { content: @fa-var-server; }\n.@{fa-css-prefix}-user-plus:before { content: @fa-var-user-plus; }\n.@{fa-css-prefix}-user-times:before { content: @fa-var-user-times; }\n.@{fa-css-prefix}-hotel:before,\n.@{fa-css-prefix}-bed:before { content: @fa-var-bed; }\n.@{fa-css-prefix}-viacoin:before { content: @fa-var-viacoin; }\n.@{fa-css-prefix}-train:before { content: @fa-var-train; }\n.@{fa-css-prefix}-subway:before { content: @fa-var-subway; }\n.@{fa-css-prefix}-medium:before { content: @fa-var-medium; }\n.@{fa-css-prefix}-yc:before,\n.@{fa-css-prefix}-y-combinator:before { content: @fa-var-y-combinator; }\n.@{fa-css-prefix}-optin-monster:before { content: @fa-var-optin-monster; }\n.@{fa-css-prefix}-opencart:before { content: @fa-var-opencart; }\n.@{fa-css-prefix}-expeditedssl:before { content: @fa-var-expeditedssl; }\n.@{fa-css-prefix}-battery-4:before,\n.@{fa-css-prefix}-battery:before,\n.@{fa-css-prefix}-battery-full:before { content: @fa-var-battery-full; }\n.@{fa-css-prefix}-battery-3:before,\n.@{fa-css-prefix}-battery-three-quarters:before { content: @fa-var-battery-three-quarters; }\n.@{fa-css-prefix}-battery-2:before,\n.@{fa-css-prefix}-battery-half:before { content: @fa-var-battery-half; }\n.@{fa-css-prefix}-battery-1:before,\n.@{fa-css-prefix}-battery-quarter:before { content: @fa-var-battery-quarter; }\n.@{fa-css-prefix}-battery-0:before,\n.@{fa-css-prefix}-battery-empty:before { content: @fa-var-battery-empty; }\n.@{fa-css-prefix}-mouse-pointer:before { content: @fa-var-mouse-pointer; }\n.@{fa-css-prefix}-i-cursor:before { content: @fa-var-i-cursor; }\n.@{fa-css-prefix}-object-group:before { content: @fa-var-object-group; }\n.@{fa-css-prefix}-object-ungroup:before { content: @fa-var-object-ungroup; }\n.@{fa-css-prefix}-sticky-note:before { content: @fa-var-sticky-note; }\n.@{fa-css-prefix}-sticky-note-o:before { content: @fa-var-sticky-note-o; }\n.@{fa-css-prefix}-cc-jcb:before { content: @fa-var-cc-jcb; }\n.@{fa-css-prefix}-cc-diners-club:before { content: @fa-var-cc-diners-club; }\n.@{fa-css-prefix}-clone:before { content: @fa-var-clone; }\n.@{fa-css-prefix}-balance-scale:before { content: @fa-var-balance-scale; }\n.@{fa-css-prefix}-hourglass-o:before { content: @fa-var-hourglass-o; }\n.@{fa-css-prefix}-hourglass-1:before,\n.@{fa-css-prefix}-hourglass-start:before { content: @fa-var-hourglass-start; }\n.@{fa-css-prefix}-hourglass-2:before,\n.@{fa-css-prefix}-hourglass-half:before { content: @fa-var-hourglass-half; }\n.@{fa-css-prefix}-hourglass-3:before,\n.@{fa-css-prefix}-hourglass-end:before { content: @fa-var-hourglass-end; }\n.@{fa-css-prefix}-hourglass:before { content: @fa-var-hourglass; }\n.@{fa-css-prefix}-hand-grab-o:before,\n.@{fa-css-prefix}-hand-rock-o:before { content: @fa-var-hand-rock-o; }\n.@{fa-css-prefix}-hand-stop-o:before,\n.@{fa-css-prefix}-hand-paper-o:before { content: @fa-var-hand-paper-o; }\n.@{fa-css-prefix}-hand-scissors-o:before { content: @fa-var-hand-scissors-o; }\n.@{fa-css-prefix}-hand-lizard-o:before { content: @fa-var-hand-lizard-o; }\n.@{fa-css-prefix}-hand-spock-o:before { content: @fa-var-hand-spock-o; }\n.@{fa-css-prefix}-hand-pointer-o:before { content: @fa-var-hand-pointer-o; }\n.@{fa-css-prefix}-hand-peace-o:before { content: @fa-var-hand-peace-o; }\n.@{fa-css-prefix}-trademark:before { content: @fa-var-trademark; }\n.@{fa-css-prefix}-registered:before { content: @fa-var-registered; }\n.@{fa-css-prefix}-creative-commons:before { content: @fa-var-creative-commons; }\n.@{fa-css-prefix}-gg:before { content: @fa-var-gg; }\n.@{fa-css-prefix}-gg-circle:before { content: @fa-var-gg-circle; }\n.@{fa-css-prefix}-tripadvisor:before { content: @fa-var-tripadvisor; }\n.@{fa-css-prefix}-odnoklassniki:before { content: @fa-var-odnoklassniki; }\n.@{fa-css-prefix}-odnoklassniki-square:before { content: @fa-var-odnoklassniki-square; }\n.@{fa-css-prefix}-get-pocket:before { content: @fa-var-get-pocket; }\n.@{fa-css-prefix}-wikipedia-w:before { content: @fa-var-wikipedia-w; }\n.@{fa-css-prefix}-safari:before { content: @fa-var-safari; }\n.@{fa-css-prefix}-chrome:before { content: @fa-var-chrome; }\n.@{fa-css-prefix}-firefox:before { content: @fa-var-firefox; }\n.@{fa-css-prefix}-opera:before { content: @fa-var-opera; }\n.@{fa-css-prefix}-internet-explorer:before { content: @fa-var-internet-explorer; }\n.@{fa-css-prefix}-tv:before,\n.@{fa-css-prefix}-television:before { content: @fa-var-television; }\n.@{fa-css-prefix}-contao:before { content: @fa-var-contao; }\n.@{fa-css-prefix}-500px:before { content: @fa-var-500px; }\n.@{fa-css-prefix}-amazon:before { content: @fa-var-amazon; }\n.@{fa-css-prefix}-calendar-plus-o:before { content: @fa-var-calendar-plus-o; }\n.@{fa-css-prefix}-calendar-minus-o:before { content: @fa-var-calendar-minus-o; }\n.@{fa-css-prefix}-calendar-times-o:before { content: @fa-var-calendar-times-o; }\n.@{fa-css-prefix}-calendar-check-o:before { content: @fa-var-calendar-check-o; }\n.@{fa-css-prefix}-industry:before { content: @fa-var-industry; }\n.@{fa-css-prefix}-map-pin:before { content: @fa-var-map-pin; }\n.@{fa-css-prefix}-map-signs:before { content: @fa-var-map-signs; }\n.@{fa-css-prefix}-map-o:before { content: @fa-var-map-o; }\n.@{fa-css-prefix}-map:before { content: @fa-var-map; }\n.@{fa-css-prefix}-commenting:before { content: @fa-var-commenting; }\n.@{fa-css-prefix}-commenting-o:before { content: @fa-var-commenting-o; }\n.@{fa-css-prefix}-houzz:before { content: @fa-var-houzz; }\n.@{fa-css-prefix}-vimeo:before { content: @fa-var-vimeo; }\n.@{fa-css-prefix}-black-tie:before { content: @fa-var-black-tie; }\n.@{fa-css-prefix}-fonticons:before { content: @fa-var-fonticons; }\n.@{fa-css-prefix}-reddit-alien:before { content: @fa-var-reddit-alien; }\n.@{fa-css-prefix}-edge:before { content: @fa-var-edge; }\n.@{fa-css-prefix}-credit-card-alt:before { content: @fa-var-credit-card-alt; }\n.@{fa-css-prefix}-codiepie:before { content: @fa-var-codiepie; }\n.@{fa-css-prefix}-modx:before { content: @fa-var-modx; }\n.@{fa-css-prefix}-fort-awesome:before { content: @fa-var-fort-awesome; }\n.@{fa-css-prefix}-usb:before { content: @fa-var-usb; }\n.@{fa-css-prefix}-product-hunt:before { content: @fa-var-product-hunt; }\n.@{fa-css-prefix}-mixcloud:before { content: @fa-var-mixcloud; }\n.@{fa-css-prefix}-scribd:before { content: @fa-var-scribd; }\n.@{fa-css-prefix}-pause-circle:before { content: @fa-var-pause-circle; }\n.@{fa-css-prefix}-pause-circle-o:before { content: @fa-var-pause-circle-o; }\n.@{fa-css-prefix}-stop-circle:before { content: @fa-var-stop-circle; }\n.@{fa-css-prefix}-stop-circle-o:before { content: @fa-var-stop-circle-o; }\n.@{fa-css-prefix}-shopping-bag:before { content: @fa-var-shopping-bag; }\n.@{fa-css-prefix}-shopping-basket:before { content: @fa-var-shopping-basket; }\n.@{fa-css-prefix}-hashtag:before { content: @fa-var-hashtag; }\n.@{fa-css-prefix}-bluetooth:before { content: @fa-var-bluetooth; }\n.@{fa-css-prefix}-bluetooth-b:before { content: @fa-var-bluetooth-b; }\n.@{fa-css-prefix}-percent:before { content: @fa-var-percent; }\n.@{fa-css-prefix}-gitlab:before { content: @fa-var-gitlab; }\n.@{fa-css-prefix}-wpbeginner:before { content: @fa-var-wpbeginner; }\n.@{fa-css-prefix}-wpforms:before { content: @fa-var-wpforms; }\n.@{fa-css-prefix}-envira:before { content: @fa-var-envira; }\n.@{fa-css-prefix}-universal-access:before { content: @fa-var-universal-access; }\n.@{fa-css-prefix}-wheelchair-alt:before { content: @fa-var-wheelchair-alt; }\n.@{fa-css-prefix}-question-circle-o:before { content: @fa-var-question-circle-o; }\n.@{fa-css-prefix}-blind:before { content: @fa-var-blind; }\n.@{fa-css-prefix}-audio-description:before { content: @fa-var-audio-description; }\n.@{fa-css-prefix}-volume-control-phone:before { content: @fa-var-volume-control-phone; }\n.@{fa-css-prefix}-braille:before { content: @fa-var-braille; }\n.@{fa-css-prefix}-assistive-listening-systems:before { content: @fa-var-assistive-listening-systems; }\n.@{fa-css-prefix}-asl-interpreting:before,\n.@{fa-css-prefix}-american-sign-language-interpreting:before { content: @fa-var-american-sign-language-interpreting; }\n.@{fa-css-prefix}-deafness:before,\n.@{fa-css-prefix}-hard-of-hearing:before,\n.@{fa-css-prefix}-deaf:before { content: @fa-var-deaf; }\n.@{fa-css-prefix}-glide:before { content: @fa-var-glide; }\n.@{fa-css-prefix}-glide-g:before { content: @fa-var-glide-g; }\n.@{fa-css-prefix}-signing:before,\n.@{fa-css-prefix}-sign-language:before { content: @fa-var-sign-language; }\n.@{fa-css-prefix}-low-vision:before { content: @fa-var-low-vision; }\n.@{fa-css-prefix}-viadeo:before { content: @fa-var-viadeo; }\n.@{fa-css-prefix}-viadeo-square:before { content: @fa-var-viadeo-square; }\n.@{fa-css-prefix}-snapchat:before { content: @fa-var-snapchat; }\n.@{fa-css-prefix}-snapchat-ghost:before { content: @fa-var-snapchat-ghost; }\n.@{fa-css-prefix}-snapchat-square:before { content: @fa-var-snapchat-square; }\n.@{fa-css-prefix}-pied-piper:before { content: @fa-var-pied-piper; }\n.@{fa-css-prefix}-first-order:before { content: @fa-var-first-order; }\n.@{fa-css-prefix}-yoast:before { content: @fa-var-yoast; }\n.@{fa-css-prefix}-themeisle:before { content: @fa-var-themeisle; }\n.@{fa-css-prefix}-google-plus-circle:before,\n.@{fa-css-prefix}-google-plus-official:before { content: @fa-var-google-plus-official; }\n.@{fa-css-prefix}-fa:before,\n.@{fa-css-prefix}-font-awesome:before { content: @fa-var-font-awesome; }\n.@{fa-css-prefix}-handshake-o:before { content: @fa-var-handshake-o; }\n.@{fa-css-prefix}-envelope-open:before { content: @fa-var-envelope-open; }\n.@{fa-css-prefix}-envelope-open-o:before { content: @fa-var-envelope-open-o; }\n.@{fa-css-prefix}-linode:before { content: @fa-var-linode; }\n.@{fa-css-prefix}-address-book:before { content: @fa-var-address-book; }\n.@{fa-css-prefix}-address-book-o:before { content: @fa-var-address-book-o; }\n.@{fa-css-prefix}-vcard:before,\n.@{fa-css-prefix}-address-card:before { content: @fa-var-address-card; }\n.@{fa-css-prefix}-vcard-o:before,\n.@{fa-css-prefix}-address-card-o:before { content: @fa-var-address-card-o; }\n.@{fa-css-prefix}-user-circle:before { content: @fa-var-user-circle; }\n.@{fa-css-prefix}-user-circle-o:before { content: @fa-var-user-circle-o; }\n.@{fa-css-prefix}-user-o:before { content: @fa-var-user-o; }\n.@{fa-css-prefix}-id-badge:before { content: @fa-var-id-badge; }\n.@{fa-css-prefix}-drivers-license:before,\n.@{fa-css-prefix}-id-card:before { content: @fa-var-id-card; }\n.@{fa-css-prefix}-drivers-license-o:before,\n.@{fa-css-prefix}-id-card-o:before { content: @fa-var-id-card-o; }\n.@{fa-css-prefix}-quora:before { content: @fa-var-quora; }\n.@{fa-css-prefix}-free-code-camp:before { content: @fa-var-free-code-camp; }\n.@{fa-css-prefix}-telegram:before { content: @fa-var-telegram; }\n.@{fa-css-prefix}-thermometer-4:before,\n.@{fa-css-prefix}-thermometer:before,\n.@{fa-css-prefix}-thermometer-full:before { content: @fa-var-thermometer-full; }\n.@{fa-css-prefix}-thermometer-3:before,\n.@{fa-css-prefix}-thermometer-three-quarters:before { content: @fa-var-thermometer-three-quarters; }\n.@{fa-css-prefix}-thermometer-2:before,\n.@{fa-css-prefix}-thermometer-half:before { content: @fa-var-thermometer-half; }\n.@{fa-css-prefix}-thermometer-1:before,\n.@{fa-css-prefix}-thermometer-quarter:before { content: @fa-var-thermometer-quarter; }\n.@{fa-css-prefix}-thermometer-0:before,\n.@{fa-css-prefix}-thermometer-empty:before { content: @fa-var-thermometer-empty; }\n.@{fa-css-prefix}-shower:before { content: @fa-var-shower; }\n.@{fa-css-prefix}-bathtub:before,\n.@{fa-css-prefix}-s15:before,\n.@{fa-css-prefix}-bath:before { content: @fa-var-bath; }\n.@{fa-css-prefix}-podcast:before { content: @fa-var-podcast; }\n.@{fa-css-prefix}-window-maximize:before { content: @fa-var-window-maximize; }\n.@{fa-css-prefix}-window-minimize:before { content: @fa-var-window-minimize; }\n.@{fa-css-prefix}-window-restore:before { content: @fa-var-window-restore; }\n.@{fa-css-prefix}-times-rectangle:before,\n.@{fa-css-prefix}-window-close:before { content: @fa-var-window-close; }\n.@{fa-css-prefix}-times-rectangle-o:before,\n.@{fa-css-prefix}-window-close-o:before { content: @fa-var-window-close-o; }\n.@{fa-css-prefix}-bandcamp:before { content: @fa-var-bandcamp; }\n.@{fa-css-prefix}-grav:before { content: @fa-var-grav; }\n.@{fa-css-prefix}-etsy:before { content: @fa-var-etsy; }\n.@{fa-css-prefix}-imdb:before { content: @fa-var-imdb; }\n.@{fa-css-prefix}-ravelry:before { content: @fa-var-ravelry; }\n.@{fa-css-prefix}-eercast:before { content: @fa-var-eercast; }\n.@{fa-css-prefix}-microchip:before { content: @fa-var-microchip; }\n.@{fa-css-prefix}-snowflake-o:before { content: @fa-var-snowflake-o; }\n.@{fa-css-prefix}-superpowers:before { content: @fa-var-superpowers; }\n.@{fa-css-prefix}-wpexplorer:before { content: @fa-var-wpexplorer; }\n.@{fa-css-prefix}-meetup:before { content: @fa-var-meetup; }\n","// Screen Readers\n// -------------------------\n\n.sr-only { .sr-only(); }\n.sr-only-focusable { .sr-only-focusable(); }\n","// Our customizations to bootstrap go here.\n\n:root {\n  --page-backdrop-color: #eee;\n  --body-bg-hue: 0;\n  --body-bg-saturation: 0%;\n  --body-bg-light: 100%;\n  --body-bg: hsl(\n    var(--body-bg-hue),\n    var(--body-bg-saturation),\n    var(--body-bg-light)\n  );\n  --body-bg-darken2pc: hsl(\n    var(--body-bg-hue),\n    var(--body-bg-saturation),\n    calc(var(--body-bg-light) - 2%)\n  );\n  --body-bg-darken3pc: hsl(\n    var(--body-bg-hue),\n    var(--body-bg-saturation),\n    calc(var(--body-bg-light) - 3.2%)\n  );\n  --body-bg-darken5pc: hsl(\n    var(--body-bg-hue),\n    var(--body-bg-saturation),\n    calc(var(--body-bg-light) - 5%)\n  );\n  --body-bg-darken10pc: hsl(\n    var(--body-bg-hue),\n    var(--body-bg-saturation),\n    calc(var(--body-bg-light) - 10%)\n  );\n  --body-bg-darken20pc: hsl(\n    var(--body-bg-hue),\n    var(--body-bg-saturation),\n    calc(var(--body-bg-light) - 20%)\n  );\n  --body-bg-darken30pc: hsl(\n    var(--body-bg-hue),\n    var(--body-bg-saturation),\n    calc(var(--body-bg-light) - 30%)\n  );\n  --header-bg: var(--body-bg);\n  --rendered-html-border-color: black;\n  --input-prompt-color: #303f9f;\n  --output-prompt-color: #d84315;\n  --output-stderr-bg-color: #fdd;\n  --output-pre-color: black;\n  --black: #000;\n  --text-color: var(--black);\n  --border-color: var(--body-bg-darken30pc);\n  --light-border-color: var(--body-bg-darken20pc);\n  --navbar-default-border: #e7e7e7;\n  --navbar-default-bg: #f5f5f5;\n  --navbar-default-link-color: #565656;\n  --navbar-default-link-hover-color: #333;\n  --btn-default-color: var(--navbar-default-link-hover-color);\n  --btn-default-hover-color: var(--btn-default-color);\n  --btn-default-bg-color: var(--header-bg);\n  --btn-default-bg-hover-color: #e6e6e6;\n  --btn-default-border-color: #ccc;\n  --btn-default-border-hover-color: #adadad;\n  --btn-default-active-hover-bg-color: #d4d4d4;\n  --btn-default-active-hover-border-color: #8c8c8c;\n  --menu-bg: var(--body-bg);\n  --menu-bg-hover: #e7e7e7;\n  --menu-fg: var(--btn-default-color);\n  --menu-fg-hover: var(--navbar-default-link-hover-color);\n  --code-bg-color: var(--menu-bg-hover);\n  --edit-hover-color: var(--body-bg-darken10pc);\n  --self-color: #05a;\n  --table-bg-good: rgba(0, 255, 0, 0.23);\n  --table-bg-bad: rgba(255, 0, 0, 0.23);\n}\n\n[data-theme=\"darcula\"] {\n  --page-backdrop-color: #3c3f41;\n  --body-bg-light: 17%;\n  --header-bg: #313335;\n  --input-prompt-color: #307fc1;\n  --output-prompt-color: #bf5b3d;\n  --output-stderr-bg-color: rgba(244, 67, 54, 0.28);\n  --output-pre-color: #bbbbbb;\n  --black: #bbbbbb;\n  --border-color: #616161;\n  --light-border-color: #505050;\n  --navbar-default-border: var(--border-color);\n  --navbar-default-bg: var(--header-bg);\n  --navbar-default-link-color: #a5a5a5;\n  --navbar-default-link-hover-color: #cbcbcb;\n  --btn-default-color: var(--navbar-default-link-color);\n  --btn-default-border-color: var(--navbar-default-border);\n  --menu-bg-hover: var(--page-backdrop-color);\n  --btn-default-bg-hover-color: var(--page-backdrop-color);\n  --btn-default-border-hover-color: var(--btn-default-border-color);\n  --btn-default-active-hover-bg-color: var(--btn-default-bg-hover-color);\n  --btn-default-active-hover-border-color: var(\n    --btn-default-border-hover-color\n  );\n  --edit-hover-color: #555758;\n  --rendered-html-border-color: var(--text-color);\n  --self-color: #307fc1;\n}\n\n@black: var(--black);\n@text-color: black;\n@font-size-base: 13px;\n@font-family-monospace: monospace; // to allow user to customize their fonts\n@navbar-height: 30px;\n@breadcrumb-color: hsl(\n  var(--body-bg-hue),\n  var(--body-bg-saturation),\n  calc(var(--body-bg-light) - 63%)\n);\n@blockquote-font-size: inherit;\n@modal-inner-padding: 15px;\n@grid-float-breakpoint: 541px;\n@screen-xs: 540px;\n@logo_height: 28px;\n@border-radius-small: 1px;\n@border-radius-base: 2px;\n@border-radius-large: 3px;\n@grid-gutter-width: 0px;\n@kbd-color: #888;\n@kbd-bg: transparent;\n\n@icon-font-path: \"~bootstrap/fonts/\";\n\n// Disable modal slide-in from top animation.\n.modal {\n  &.fade .modal-dialog {\n    .translate(0, 0);\n  }\n}\n\n// Set the default code color.\ncode {\n  color: @black; // default code color in bootstrap is #d14 (crimson / amaranth)\n}\n\n// Override bootstrap pre element styling.\npre {\n  // bootstrap has pre defaults that we don't want to inherit.\n  // start pre tag defaults based on the surrounding context instead.\n  font-size: inherit;\n  line-height: inherit;\n}\n\n// Disable bold labels in BS3\nlabel {\n  font-weight: normal;\n}\n\n// Our own global variables for all pages go here\n@global-shadow: 0px 0px 12px 1px rgba(87, 87, 87, 0.2);\n@global-shadow-dark: 0px 0px 12px 1px rgba(87, 87, 87, 0.4);\n@page-header-padding: 20px;\n/* Make the page background atleast 100% the height of the view port */\n@page-backdrop-height: 100vh;\n/* Make the page itself atleast 70% the height of the view port */\n@page-min-height: 0;\n@page-backdrop-color: var(--page-backdrop-color);\n@body-bg: var(--body-bg);\n@page-color: @body-bg;\n@page-padding: 15px;\n\n// preven container size to jump from 768px to 720px\n// when window width go from 768 to 769+\n@container-sm: @screen-sm-min;\n","// Mixin CSS classes\n\n.border-box-sizing {\n    box-sizing: border-box;\n    -moz-box-sizing: border-box;\n    -webkit-box-sizing: border-box;\n}\n\n.corner-all {\n    border-radius: @border-radius-base;\n}\n\n.border-radius(@radius) {\n  border-radius: @radius;\n}\n\n.no-padding {\n    padding: 0px;\n}\n","\n/* Flexible box model classes */\n/* Taken from Alex Russell http://infrequently.org/2009/08/css-3-progress/ */\n\n/* This file is a compatibility layer.  It allows the usage of flexible box \nmodel layouts accross multiple browsers, including older browsers.  The newest,\nuniversal implementation of the flexible box model is used when available (see\n`Modern browsers` comments below).  Browsers that are known to implement this \nnew spec completely include:\n\n    Firefox 28.0+\n    Chrome 29.0+\n    Internet Explorer 11+ \n    Opera 17.0+\n\nBrowsers not listed, including Safari, are supported via the styling under the\n`Old browsers` comments below.\n*/\n\n\n.hbox {\n    /* Old browsers */\n    display: -webkit-box;\n    -webkit-box-orient: horizontal;\n    -webkit-box-align: stretch;\n\n    display: -moz-box;\n    -moz-box-orient: horizontal;\n    -moz-box-align: stretch;\n\n    display: box;\n    box-orient: horizontal;\n    box-align: stretch;\n\n    /* Modern browsers */\n    display: flex;\n    flex-direction: row;\n    align-items: stretch;\n}\n\n.hbox > * {\n    /* Old browsers */\n    -webkit-box-flex: 0;\n    -moz-box-flex: 0;\n    box-flex: 0;\n\n    /* Modern browsers */\n    flex: none;\n}\n\n.vbox {\n    /* Old browsers */\n    display: -webkit-box;\n    -webkit-box-orient: vertical;\n    -webkit-box-align: stretch;\n\n    display: -moz-box;\n    -moz-box-orient: vertical;\n    -moz-box-align: stretch;\n\n    display: box;\n    box-orient: vertical;\n    box-align: stretch;\n\n    /* Modern browsers */\n    display: flex;\n    flex-direction: column;\n    align-items: stretch;\n}\n\n.vbox > * {\n    /* Old browsers */\n    -webkit-box-flex: 0;\n    -moz-box-flex: 0;\n    box-flex: 0;\n    \n    /* Modern browsers */\n    flex: none;\n}\n\n.hbox.reverse,\n.vbox.reverse,\n.reverse {\n    /* Old browsers */\n    -webkit-box-direction: reverse;\n    -moz-box-direction: reverse;\n    box-direction: reverse;\n    \n    /* Modern browsers */\n    flex-direction: row-reverse;\n}\n\n.hbox.box-flex0,\n.vbox.box-flex0,\n.box-flex0 {\n    /* Old browsers */\n    -webkit-box-flex: 0;\n    -moz-box-flex: 0;\n    box-flex: 0;\n    \n    /* Modern browsers */\n    flex: none;\n    width: auto;\n}\n\n.hbox.box-flex1,\n.vbox.box-flex1,\n.box-flex1 {\n    /* Old browsers */\n    -webkit-box-flex: 1;\n    -moz-box-flex: 1;\n    box-flex: 1;\n\n    /* Modern browsers */\n    flex: 1;\n}\n\n.hbox.box-flex,\n.vbox.box-flex,\n.box-flex {\n    /* Old browsers */\n    .box-flex1();\n}\n\n.hbox.box-flex2,\n.vbox.box-flex2,\n.box-flex2 {\n    /* Old browsers */\n    -webkit-box-flex: 2;\n    -moz-box-flex: 2;\n    box-flex: 2;\n\n    /* Modern browsers */\n    flex: 2;\n}\n\n.box-group1 {\n    /*  Deprecated */\n    -webkit-box-flex-group: 1;\n    -moz-box-flex-group: 1;\n    box-flex-group: 1;\n}\n\n.box-group2 {\n    /* Deprecated */\n    -webkit-box-flex-group: 2;\n    -moz-box-flex-group: 2;\n    box-flex-group: 2;\n}\n\n.hbox.start, \n.vbox.start,\n.start {\n    /* Old browsers */\n    -webkit-box-pack: start;\n    -moz-box-pack: start;\n    box-pack: start;\n    \n    /* Modern browsers */\n    justify-content: flex-start;\n}\n\n.hbox.end, \n.vbox.end,\n.end {\n    /* Old browsers */\n    -webkit-box-pack: end;\n    -moz-box-pack: end;\n    box-pack: end;\n    \n    /* Modern browsers */\n    justify-content: flex-end;\n}\n\n.hbox.center, \n.vbox.center,\n.center {\n    /* Old browsers */\n    -webkit-box-pack: center;\n    -moz-box-pack: center;\n    box-pack: center;\n    \n    /* Modern browsers */\n    justify-content: center;\n}\n\n.hbox.baseline, \n.vbox.baseline,\n.baseline {\n    /* Old browsers */\n    -webkit-box-pack: baseline;\n    -moz-box-pack: baseline;\n    box-pack: baseline;\n    \n    /* Modern browsers */\n    justify-content: baseline;\n}\n\n.hbox.stretch, \n.vbox.stretch,\n.stretch {\n    /* Old browsers */\n    -webkit-box-pack: stretch;\n    -moz-box-pack: stretch;\n    box-pack: stretch;\n    \n    /* Modern browsers */\n    justify-content: stretch;\n}\n\n.hbox.align-start, \n.vbox.align-start,\n.align-start {\n    /* Old browsers */\n    -webkit-box-align: start;\n    -moz-box-align: start;\n    box-align: start;\n    \n    /* Modern browsers */\n    align-items: flex-start;\n}\n\n.hbox.align-end, \n.vbox.align-end,\n.align-end {\n    /* Old browsers */\n    -webkit-box-align: end;\n    -moz-box-align: end;\n    box-align: end;\n    \n    /* Modern browsers */\n    align-items: flex-end;\n}\n\n.hbox.align-center, \n.vbox.align-center,\n.align-center {\n    /* Old browsers */\n    -webkit-box-align: center;\n    -moz-box-align: center;\n    box-align: center;\n    \n    /* Modern browsers */\n    align-items: center;\n}\n\n.hbox.align-baseline, \n.vbox.align-baseline,\n.align-baseline {\n    /* Old browsers */\n    -webkit-box-align: baseline;\n    -moz-box-align: baseline;\n    box-align: baseline;\n    \n    /* Modern browsers */\n    align-items: baseline;\n}\n\n.hbox.align-stretch, \n.vbox.align-stretch,\n.align-stretch {\n    /* Old browsers */\n    -webkit-box-align: stretch;\n    -moz-box-align: stretch;\n    box-align: stretch;\n    \n    /* Modern browsers */\n    align-items: stretch;\n}\n","div.error {\n  margin: 2em;\n  text-align: center;\n}\n\ndiv.error > h1 {\n    font-size: 500%;\n    line-height: normal;\n}\n\ndiv.error > p {\n    font-size: 200%;\n    line-height: normal;\n}\n\ndiv.traceback-wrapper {\n    text-align: left;\n    max-width: 800px;\n    margin: auto;\n    pre.traceback {\n      max-height: 600px;\n      overflow: auto;\n    }\n}\n","/**\n * Primary styles\n *\n * Author: Jupyter Development Team\n */\n\n.body {\n  background-color: @body-bg;\n  /* This makes sure that the body covers the entire window and needs to\n       be in a different element than the display: box in wrapper below */\n  position: absolute;\n  left: 0px;\n  right: 0px;\n  top: 0px;\n  bottom: 0px;\n  overflow: visible;\n  color: var(--text-color);\n}\n\n.body > #header {\n  /* Initially hidden to prevent FLOUC */\n  display: none;\n  background-color: @header-bg;\n\n  /* Display over codemirror */\n  position: relative;\n  z-index: 100;\n\n  #header-container {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    padding: 5px;\n    padding-bottom: 5px;\n    padding-top: 5px;\n    .border-box-sizing();\n  }\n\n  .header-bar {\n    width: 100%;\n    height: 1px;\n    background: @navbar-default-border;\n    margin-bottom: -1px;\n  }\n\n  @media print {\n    display: none !important;\n  }\n}\n\n#header-spacer {\n  width: 100%;\n  visibility: hidden;\n\n  @media print {\n    display: none;\n  }\n}\n\n#ipython_notebook {\n  padding-left: 0px;\n  padding-top: (@navbar-height - @logo_height) / 2;\n  padding-bottom: (@navbar-height - @logo_height) / 2;\n  margin-right: auto;\n}\n\n[dir=\"rtl\"] #ipython_notebook {\n  margin-right: 10px;\n  margin-left: 0;\n}\n\n[dir=\"rtl\"] #ipython_notebook.pull-left {\n  .pull-right();\n}\n\n.flex-spacer {\n  flex: 1;\n}\n\n#ipython_notebook img {\n  height: @logo_height;\n}\n\n#site {\n  width: 100%;\n  display: none;\n  .border-box-sizing();\n  overflow: auto;\n  @media print {\n    // force auto-height on print (overrides manual resizing in live view)\n    height: auto !important;\n  }\n}\n\n/* Smaller buttons */\n.ui-button .ui-button-text {\n  padding: 0.2em 0.8em;\n  font-size: 77%;\n}\n\ninput.ui-button {\n  padding: 0.3em 0.9em;\n}\n\nspan#kernel_logo_widget {\n  margin: 0 10px;\n  margin-left: auto;\n}\n\nspan#login_widget {\n  float: right;\n}\n\n[dir=\"rtl\"] span#login_widget {\n  float: left;\n}\n\nspan#login_widget > .button,\n#logout,\n#shutdown {\n  .btn-default();\n  margin-left: 10px;\n}\n\n.nav-header {\n  text-transform: none;\n}\n\n#header > span {\n  margin-top: 10px;\n}\n\n// class for stretching dialogs to fill the screen\n.modal_stretch .modal-dialog {\n  .vbox();\n  min-height: 80vh;\n  .modal-body {\n    // ~\"foo\" is to avoid less turning this into a weird value\n    max-height: calc(~\"100vh - 200px\");\n    overflow: auto;\n    flex: 1;\n  }\n}\n\n.modal-header {\n  cursor: move;\n}\n\n@media (min-width: @screen-sm-min) {\n  .modal .modal-dialog {\n    width: 700px;\n  }\n}\n\n// less mixin to be sure to add the right class to get icons with font awesome.\n.icon(@ico) {\n  .fa();\n  content: @ico;\n}\n\n@media (min-width: @screen-sm-min) {\n  select.form-control {\n    margin-left: @padding-base-horizontal;\n    margin-right: @padding-base-horizontal;\n  }\n}\n\n/* rtl fixes for the error, connecting, and renaming window */\n\n[dir=\"rtl\"] .modal-footer {\n  text-align: left !important;\n}\n\n[dir=\"rtl\"] .close {\n  float: left;\n}\n\n[dir=\"rtl\"] .fa-step-forward::before {\n  content: \"\\f048\";\n}\n","/* CSS font colors for translated ANSI escape sequences */\n\n.ansicolors(@name, @normal, @intense) {\n  .ansi-@{name}-fg { color: @normal; }\n  .ansi-@{name}-bg { background-color: @normal; }\n  .ansi-@{name}-intense-fg { color: @intense; }\n  .ansi-@{name}-intense-bg { background-color: @intense; }\n}\n\n/* The color values are a mix of\n   http://www.xcolors.net/dl/baskerville-ivorylight and\n   http://www.xcolors.net/dl/euphrasia */\n\n.ansicolors(black, #3E424D, #282C36);\n.ansicolors(red, #E75C58, #B22B31);\n.ansicolors(green, #00A250, #007427);\n.ansicolors(yellow, #DDB62B, #B27D12);\n.ansicolors(blue, #208FFB, #0065CA);\n.ansicolors(magenta, #D160C4, #A03196);\n.ansicolors(cyan, #60C6C8, #258F8F);\n.ansicolors(white, #C5C1B4, #A1A6B2);\n\n.ansi-default-inverse-fg { color: #FFFFFF; }\n.ansi-default-inverse-bg { background-color: #000000; }\n\n.ansi-bold { font-weight: bold; }\n.ansi-underline { text-decoration: underline; }\n","@_cell_padding_minus_border: @cell_padding - @cell_border_width;\n\n._selected_style(@border_color) {\n    position: absolute;\n    display: block;\n    top: -1 * @cell_border_width;\n    left: -1 * @cell_border_width;\n    width: @cell_left_border_width;\n    // height: 100% + (2 * @cell_border_width);\n    height: calc(~\"100% + \"(2 * @cell_border_width));\n    content: '';\n    background: @border_color;\n}\n\n\ndiv.cell {\n    .vbox();\n    .corner-all();\n    .border-box-sizing();\n    \n    border-width: @cell_border_width;\n    border-style: solid;\n    border-color: transparent;\n\n    width: 100%;\n    padding: @_cell_padding_minus_border;\n    /* This acts as a spacer between cells, that is outside the border */\n    margin: 0px;\n    outline: none;\n    \n    position: relative;\n    overflow: visible;\n\n    &:before {\n        ._selected_style(transparent);\n    }\n\n    &.jupyter-soft-selected {\n        border-left-color: @soft_select_color;\n        border-left-width: @cell_border_width;\n        padding-left: @cell_padding - @cell_border_width;\n        border-right-color: @soft_select_color;\n        border-right-width: @cell_border_width;\n        background: @soft_select_color;\n    \n        @media print {\n            border-color: transparent;\n        }\n    }\n\n    &.selected, &.selected.jupyter-soft-selected {\n        border-color: @border_color;\n        \n        &:before {\n            ._selected_style(@selected_border_color);\n        }\n\n        @media print {\n            border-color: transparent;\n        }\n    }\n\n    .edit_mode &.selected {\n        border-color: @edit_mode_border_color;\n        \n        &:before {\n            ._selected_style(@edit_mode_border_color);\n        }\n\n        @media print {\n            border-color: transparent;\n        }\n    }\n\n}\n\n\n.prompt {\n    /* This needs to be wide enough for 3 digit prompt numbers: In[100]: */\n    min-width: 14ex;\n\n    /* This padding is tuned to match the padding on the CodeMirror editor. */\n    padding: @code_padding;\n    margin: 0px;\n    font-family: @font-family-monospace;\n    text-align: right;\n\n    /* This has to match that of the the CodeMirror class line-height below */\n    line-height: @code_line_height;\n\n    /* Don't highlight prompt number selection */\n    -webkit-touch-callout: none;\n    -webkit-user-select: none;\n    -khtml-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n\n    /* Use default cursor */\n    cursor: default;\n}\n\n@media (max-width: @screen-xs-min) {\n    // prompts are in the main column on small screens,\n    // so text should be left-aligned\n    .prompt {\n        text-align: left;\n    }\n}\n\ndiv.inner_cell {\n    min-width: 0;\n    .vbox();\n    .box-flex1();\n}\n\n/* input_area and input_prompt must match in top border and margin for alignment */\ndiv.input_area {\n    border: 1px solid @light_border_color;\n    .corner-all;\n    background: @cell_background;\n    line-height: @code_line_height;\n}\n\n/* This is needed so that empty prompt areas can collapse to zero height when there\n   is no content in the output_subarea and the prompt. The main purpose of this is\n   to make sure that empty JavaScript output_subareas have no height. */\ndiv.prompt:empty {\n    padding-top: 0;\n    padding-bottom: 0;\n}\n\ndiv.unrecognized_cell {\n    // from text_cell\n    padding: 5px @_cell_padding_minus_border 5px 0px;\n    .hbox();\n\n    .inner_cell {\n        .border-radius(@border-radius-base);\n        padding: @_cell_padding_minus_border;\n        font-weight: bold;\n        color: red;\n        border: @cell_border_width solid @light_border_color;\n        background: hsl(var(--body-bg-hue), var(--body-bg-saturation), calc(var(--body-bg-light) - 8.2%));\n        // remove decoration from link\n        a {\n            color: inherit;\n            text-decoration: none;\n\n            &:hover {\n                color: inherit;\n                text-decoration: none;\n            }\n        }\n    }\n}\n@media (max-width: @screen-xs-min) {\n    // remove prompt indentation on small screens\n    div.unrecognized_cell > div.prompt {\n        display: none;\n    }\n}\n","div.code_cell {\n    /* avoid page breaking on code cells when printing */\n    @media print {\n        page-break-inside: avoid;\n    }\n}\n\n/* any special styling for code cells that are currently running goes here */\ndiv.code_cell.running {\n}\n\ndiv.input {\n    page-break-inside: avoid;\n    .hbox();\n}\n\n@media (max-width: @screen-xs-min) {\n    // move prompts above code on small screens\n    div.input {\n        .vbox();\n    }\n}\n\ndiv.prompt_container {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: flex-start;\n    text-align: right;\n}\n\n/* input_area and input_prompt must match in top border and margin for alignment */\ndiv.input_prompt {\n    color: @input_prompt_color;\n    border-top: 1px solid transparent;\n}\n\ndiv.run_this_cell {\n    display: none;\n    cursor: pointer;\n    color: #333;\n    padding-top: 5px;\n    padding-bottom: 5px;\n    padding-left: 2ex;\n    padding-right: 2ex;\n    width: 1ex;\n}\n\n// set the prompt width\ndiv.prompt {\n    min-width: 15ex;\n}\n\n@media (-moz-touch-enabled: 1), (any-pointer: coarse) {\n    div.run_this_cell {\n        display: block;\n    }\n}\n\n// The styles related to div.highlight are for nbconvert HTML output only. This works\n// because the .highlight div isn't present in the live notebook. We could put this into\n// nbconvert, but it easily falls out of sync, can't use our less variables and doesn't\n// help the basic template when paired with our CSS.\n\ndiv.input_area > div.highlight {\n    margin: @code_padding;\n    border: none;\n    padding: 0px;\n    background-color: transparent;\n}\n\ndiv.input_area > div.highlight > pre {\n    margin: 0px;\n    border: none;\n    padding: 0px;\n    background-color: transparent;\n}\n","/* The following gets added to the <head> if it is detected that the user has a\n * monospace font with inconsistent normal/bold/italic height.  See\n * notebookmain.js.  Such fonts will have keywords vertically offset with\n * respect to the rest of the text.  The user should select a better font.\n * See: https://github.com/ipython/ipython/issues/1503\n *\n * .CodeMirror span {\n *      vertical-align: bottom;\n * }\n */\n\n.CodeMirror {\n    line-height: @code_line_height;  /* Changed from 1em to our global default */\n    font-size: @notebook_font_size;\n    height: auto;     /* Changed to auto to autogrow */\n    background: none;  /* Changed from white to allow our bg to show through */\n}\n\n.CodeMirror-scroll {\n    /*  The CodeMirror docs are a bit fuzzy on if overflow-y should be hidden or visible.*/\n    /*  We have found that if it is visible, vertical scrollbars appear with font size changes.*/\n    overflow-y: hidden;\n    overflow-x: auto;\n}\n\n.CodeMirror-lines {\n    /* In CM2, this used to be 0.4em, but in CM3 it went to 4px. We need the em value because */\n    /* we have set a different line-height and want this to scale with that. */\n    /* Note that this should set vertical padding only, since CodeMirror assumes\n       that horizontal padding will be set on CodeMirror pre */\n    padding: @code_padding 0;\n}\n\n.CodeMirror-linenumber {\n    // This is needed to fine tune the position of the line numbers because we use the 0.4em in @code_padding\n    // spacing in various places. Fine tuned to look right.\n    padding: 0 8px 0 4px;\n}\n\n.CodeMirror-gutters {\n    // This is needed because our cell has rounded corners, otherwise the gutter area square\n    // corner cuts into the rounded cell border.\n    border-bottom-left-radius: @border-radius-base;\n    border-top-left-radius: @border-radius-base;\n}\n\n.CodeMirror pre {\n    /* In CM3 this went to 4px from 0 in CM2. This sets horizontal padding only,\n    use .CodeMirror-lines for vertical */\n    padding: 0 @code_padding;\n    border: 0;\n    .border-radius(0)\n}\n\n.CodeMirror-cursor {\n    border-left: 1.4px solid black;\n}\n\n// When zoomed out 67% and 33% on a screen of 1440 width x 900 height\n@media screen and (min-width: 2138px) and (max-width: 4319px)  {\n    .CodeMirror-cursor {\n        border-left: 2px solid black;\n    }\n}\n\n// When zoomed out less than 33%\n@media screen and (min-width: 4320px)  {\n    .CodeMirror-cursor {\n        border-left: 4px solid black;\n    }\n}\n","/*\n\nOriginal style from softwaremaniacs.org (c) Ivan Sagalaev <Maniac@SoftwareManiacs.Org>\nAdapted from GitHub theme\n\n*/\n\n@import (reference) \"highlight-refs.less\";\n\n@highlight-base: #000;\n\n.highlight-base {\n  color: @highlight-base;\n}\n\n.highlight-variable {\n  .highlight-base();\n}\n\n.highlight-variable-2 {\n  // color: lighten(@highlight-base, 10%);\n  // [basthon] self is a variable-2 and must be visible\n  color: var(--self-color);\n}\n\n.highlight-variable-3 {\n  color: lighten(@highlight-base, 20%);\n}\n\n.highlight-string {\n  color: #ba2121;\n}\n\n//fix issue #4206, overwrite .highlight-comment class, from #408080 to #007979\n.highlight-comment {\n  color: #007979;\n  font-style: italic;\n}\n\n.highlight-number {\n  color: #080;\n}\n\n.highlight-atom {\n  color: #88f;\n}\n\n.highlight-keyword {\n  color: #008000;\n  font-weight: bold;\n}\n\n.highlight-builtin {\n  color: #008000;\n}\n\n.highlight-error {\n  color: #f00;\n}\n\n.highlight-operator {\n  color: #aa22ff;\n  font-weight: bold;\n}\n\n.highlight-meta {\n  color: #aa22ff;\n}\n\n/* previously not defined, copying from default codemirror */\n.highlight-def {\n  .cm-s-default.cm-def();\n}\n.highlight-punctuation {\n  .cm-s-default.cm-punctuation();\n}\n.highlight-property {\n  .cm-s-default.cm-property();\n}\n.highlight-string-2 {\n  .cm-s-default.cm-string-2();\n}\n.highlight-qualifier {\n  .cm-s-default.cm-qualifier();\n}\n.highlight-bracket {\n  .cm-s-default.cm-bracket();\n}\n.highlight-tag {\n  .cm-s-default.cm-tag();\n}\n.highlight-attribute {\n  .cm-s-default.cm-attribute();\n}\n.highlight-header {\n  .cm-s-default.cm-header();\n}\n.highlight-quote {\n  .cm-s-default.cm-quote();\n}\n.highlight-link {\n  .cm-s-default.cm-link();\n}\n\n/* apply the same style to codemirror */\n.cm-s-ipython span {\n  &.cm-keyword {\n    .highlight-keyword();\n  }\n  &.cm-atom {\n    .highlight-atom();\n  }\n  &.cm-number {\n    .highlight-number();\n  }\n  &.cm-def {\n    .highlight-def();\n  }\n  &.cm-variable {\n    .highlight-variable();\n  }\n  &.cm-punctuation {\n    .highlight-punctuation();\n  }\n  &.cm-property {\n    .highlight-property();\n  }\n  &.cm-operator {\n    .highlight-operator();\n  }\n  &.cm-variable-2 {\n    .highlight-variable-2();\n  }\n  &.cm-variable-3 {\n    .highlight-variable-3();\n  }\n  &.cm-comment {\n    .highlight-comment();\n  }\n  &.cm-string {\n    .highlight-string();\n  }\n  &.cm-string-2 {\n    .highlight-string-2();\n  }\n  &.cm-meta {\n    .highlight-meta();\n  }\n  &.cm-qualifier {\n    .highlight-qualifier();\n  }\n  &.cm-builtin {\n    .highlight-builtin();\n  }\n  &.cm-bracket {\n    .highlight-bracket();\n  }\n  &.cm-tag {\n    .highlight-tag();\n  }\n  &.cm-attribute {\n    .highlight-attribute();\n  }\n  &.cm-header {\n    .highlight-header();\n  }\n  &.cm-quote {\n    .highlight-quote();\n  }\n  &.cm-link {\n    .highlight-link();\n  }\n  &.cm-error {\n    .highlight-error();\n  }\n\n  &.cm-tab {\n    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAMCAYAAAAkuj5RAAAAAXNSR0IArs4c6QAAAGFJREFUSMft1LsRQFAQheHPowAKoACx3IgEKtaEHujDjORSgWTH/ZOdnZOcM/sgk/kFFWY0qV8foQwS4MKBCS3qR6ixBJvElOobYAtivseIE120FaowJPN75GMu8j/LfMwNjh4HUpwg4LUAAAAASUVORK5CYII=);\n    background-position: right;\n    background-repeat: no-repeat;\n  }\n}\n","/* BASICS */\n\n.CodeMirror {\n  /* Set height, width, borders, and global font properties here */\n  font-family: monospace;\n  height: 300px;\n  color: black;\n  direction: ltr;\n}\n\n/* PADDING */\n\n.CodeMirror-lines {\n  padding: 4px 0; /* Vertical padding around content */\n}\n.CodeMirror pre.CodeMirror-line,\n.CodeMirror pre.CodeMirror-line-like {\n  padding: 0 4px; /* Horizontal padding of content */\n}\n\n.CodeMirror-scrollbar-filler, .CodeMirror-gutter-filler {\n  background-color: white; /* The little square between H and V scrollbars */\n}\n\n/* GUTTER */\n\n.CodeMirror-gutters {\n  border-right: 1px solid #ddd;\n  background-color: #f7f7f7;\n  white-space: nowrap;\n}\n.CodeMirror-linenumbers {}\n.CodeMirror-linenumber {\n  padding: 0 3px 0 5px;\n  min-width: 20px;\n  text-align: right;\n  color: #999;\n  white-space: nowrap;\n}\n\n.CodeMirror-guttermarker { color: black; }\n.CodeMirror-guttermarker-subtle { color: #999; }\n\n/* CURSOR */\n\n.CodeMirror-cursor {\n  border-left: 1px solid black;\n  border-right: none;\n  width: 0;\n}\n/* Shown when moving in bi-directional text */\n.CodeMirror div.CodeMirror-secondarycursor {\n  border-left: 1px solid silver;\n}\n.cm-fat-cursor .CodeMirror-cursor {\n  width: auto;\n  border: 0 !important;\n  background: #7e7;\n}\n.cm-fat-cursor div.CodeMirror-cursors {\n  z-index: 1;\n}\n.cm-fat-cursor .CodeMirror-line::selection,\n.cm-fat-cursor .CodeMirror-line > span::selection, \n.cm-fat-cursor .CodeMirror-line > span > span::selection { background: transparent; }\n.cm-fat-cursor .CodeMirror-line::-moz-selection,\n.cm-fat-cursor .CodeMirror-line > span::-moz-selection,\n.cm-fat-cursor .CodeMirror-line > span > span::-moz-selection { background: transparent; }\n.cm-fat-cursor { caret-color: transparent; }\n@-moz-keyframes blink {\n  0% {}\n  50% { background-color: transparent; }\n  100% {}\n}\n@-webkit-keyframes blink {\n  0% {}\n  50% { background-color: transparent; }\n  100% {}\n}\n@keyframes blink {\n  0% {}\n  50% { background-color: transparent; }\n  100% {}\n}\n\n/* Can style cursor different in overwrite (non-insert) mode */\n.CodeMirror-overwrite .CodeMirror-cursor {}\n\n.cm-tab { display: inline-block; text-decoration: inherit; }\n\n.CodeMirror-rulers {\n  position: absolute;\n  left: 0; right: 0; top: -50px; bottom: 0;\n  overflow: hidden;\n}\n.CodeMirror-ruler {\n  border-left: 1px solid #ccc;\n  top: 0; bottom: 0;\n  position: absolute;\n}\n\n/* DEFAULT THEME */\n\n.cm-s-default .cm-header {color: blue;}\n.cm-s-default .cm-quote {color: #090;}\n.cm-negative {color: #d44;}\n.cm-positive {color: #292;}\n.cm-header, .cm-strong {font-weight: bold;}\n.cm-em {font-style: italic;}\n.cm-link {text-decoration: underline;}\n.cm-strikethrough {text-decoration: line-through;}\n\n.cm-s-default .cm-keyword {color: #708;}\n.cm-s-default .cm-atom {color: #219;}\n.cm-s-default .cm-number {color: #164;}\n.cm-s-default .cm-def {color: #00f;}\n.cm-s-default .cm-variable,\n.cm-s-default .cm-punctuation,\n.cm-s-default .cm-property,\n.cm-s-default .cm-operator {}\n.cm-s-default .cm-variable-2 {color: #05a;}\n.cm-s-default .cm-variable-3, .cm-s-default .cm-type {color: #085;}\n.cm-s-default .cm-comment {color: #a50;}\n.cm-s-default .cm-string {color: #a11;}\n.cm-s-default .cm-string-2 {color: #f50;}\n.cm-s-default .cm-meta {color: #555;}\n.cm-s-default .cm-qualifier {color: #555;}\n.cm-s-default .cm-builtin {color: #30a;}\n.cm-s-default .cm-bracket {color: #997;}\n.cm-s-default .cm-tag {color: #170;}\n.cm-s-default .cm-attribute {color: #00c;}\n.cm-s-default .cm-hr {color: #999;}\n.cm-s-default .cm-link {color: #00c;}\n\n.cm-s-default .cm-error {color: #f00;}\n.cm-invalidchar {color: #f00;}\n\n.CodeMirror-composing { border-bottom: 2px solid; }\n\n/* Default styles for common addons */\n\ndiv.CodeMirror span.CodeMirror-matchingbracket {color: #0b0;}\ndiv.CodeMirror span.CodeMirror-nonmatchingbracket {color: #a22;}\n.CodeMirror-matchingtag { background: rgba(255, 150, 0, .3); }\n.CodeMirror-activeline-background {background: #e8f2ff;}\n\n/* STOP */\n\n/* The rest of this file contains styles related to the mechanics of\n   the editor. You probably shouldn't touch them. */\n\n.CodeMirror {\n  position: relative;\n  overflow: hidden;\n  background: white;\n}\n\n.CodeMirror-scroll {\n  overflow: scroll !important; /* Things will break if this is overridden */\n  /* 50px is the magic margin used to hide the element's real scrollbars */\n  /* See overflow: hidden in .CodeMirror */\n  margin-bottom: -50px; margin-right: -50px;\n  padding-bottom: 50px;\n  height: 100%;\n  outline: none; /* Prevent dragging from highlighting the element */\n  position: relative;\n  z-index: 0;\n}\n.CodeMirror-sizer {\n  position: relative;\n  border-right: 50px solid transparent;\n}\n\n/* The fake, visible scrollbars. Used to force redraw during scrolling\n   before actual scrolling happens, thus preventing shaking and\n   flickering artifacts. */\n.CodeMirror-vscrollbar, .CodeMirror-hscrollbar, .CodeMirror-scrollbar-filler, .CodeMirror-gutter-filler {\n  position: absolute;\n  z-index: 6;\n  display: none;\n  outline: none;\n}\n.CodeMirror-vscrollbar {\n  right: 0; top: 0;\n  overflow-x: hidden;\n  overflow-y: scroll;\n}\n.CodeMirror-hscrollbar {\n  bottom: 0; left: 0;\n  overflow-y: hidden;\n  overflow-x: scroll;\n}\n.CodeMirror-scrollbar-filler {\n  right: 0; bottom: 0;\n}\n.CodeMirror-gutter-filler {\n  left: 0; bottom: 0;\n}\n\n.CodeMirror-gutters {\n  position: absolute; left: 0; top: 0;\n  min-height: 100%;\n  z-index: 3;\n}\n.CodeMirror-gutter {\n  white-space: normal;\n  height: 100%;\n  display: inline-block;\n  vertical-align: top;\n  margin-bottom: -50px;\n}\n.CodeMirror-gutter-wrapper {\n  position: absolute;\n  z-index: 4;\n  background: none !important;\n  border: none !important;\n}\n.CodeMirror-gutter-background {\n  position: absolute;\n  top: 0; bottom: 0;\n  z-index: 4;\n}\n.CodeMirror-gutter-elt {\n  position: absolute;\n  cursor: default;\n  z-index: 4;\n}\n.CodeMirror-gutter-wrapper ::selection { background-color: transparent }\n.CodeMirror-gutter-wrapper ::-moz-selection { background-color: transparent }\n\n.CodeMirror-lines {\n  cursor: text;\n  min-height: 1px; /* prevents collapsing before first draw */\n}\n.CodeMirror pre.CodeMirror-line,\n.CodeMirror pre.CodeMirror-line-like {\n  /* Reset some styles that the rest of the page might have set */\n  -moz-border-radius: 0; -webkit-border-radius: 0; border-radius: 0;\n  border-width: 0;\n  background: transparent;\n  font-family: inherit;\n  font-size: inherit;\n  margin: 0;\n  white-space: pre;\n  word-wrap: normal;\n  line-height: inherit;\n  color: inherit;\n  z-index: 2;\n  position: relative;\n  overflow: visible;\n  -webkit-tap-highlight-color: transparent;\n  -webkit-font-variant-ligatures: contextual;\n  font-variant-ligatures: contextual;\n}\n.CodeMirror-wrap pre.CodeMirror-line,\n.CodeMirror-wrap pre.CodeMirror-line-like {\n  word-wrap: break-word;\n  white-space: pre-wrap;\n  word-break: normal;\n}\n\n.CodeMirror-linebackground {\n  position: absolute;\n  left: 0; right: 0; top: 0; bottom: 0;\n  z-index: 0;\n}\n\n.CodeMirror-linewidget {\n  position: relative;\n  z-index: 2;\n  padding: 0.1px; /* Force widget margins to stay inside of the container */\n}\n\n.CodeMirror-widget {}\n\n.CodeMirror-rtl pre { direction: rtl; }\n\n.CodeMirror-code {\n  outline: none;\n}\n\n/* Force content-box sizing for the elements where we expect it */\n.CodeMirror-scroll,\n.CodeMirror-sizer,\n.CodeMirror-gutter,\n.CodeMirror-gutters,\n.CodeMirror-linenumber {\n  -moz-box-sizing: content-box;\n  box-sizing: content-box;\n}\n\n.CodeMirror-measure {\n  position: absolute;\n  width: 100%;\n  height: 0;\n  overflow: hidden;\n  visibility: hidden;\n}\n\n.CodeMirror-cursor {\n  position: absolute;\n  pointer-events: none;\n}\n.CodeMirror-measure pre { position: static; }\n\ndiv.CodeMirror-cursors {\n  visibility: hidden;\n  position: relative;\n  z-index: 3;\n}\ndiv.CodeMirror-dragcursors {\n  visibility: visible;\n}\n\n.CodeMirror-focused div.CodeMirror-cursors {\n  visibility: visible;\n}\n\n.CodeMirror-selected { background: #d9d9d9; }\n.CodeMirror-focused .CodeMirror-selected { background: #d7d4f0; }\n.CodeMirror-crosshair { cursor: crosshair; }\n.CodeMirror-line::selection, .CodeMirror-line > span::selection, .CodeMirror-line > span > span::selection { background: #d7d4f0; }\n.CodeMirror-line::-moz-selection, .CodeMirror-line > span::-moz-selection, .CodeMirror-line > span > span::-moz-selection { background: #d7d4f0; }\n\n.cm-searching {\n  background-color: #ffa;\n  background-color: rgba(255, 255, 0, .4);\n}\n\n/* Used to force a border model for a node */\n.cm-force-border { padding-right: .1px; }\n\n@media print {\n  /* Hide the cursor when printing */\n  .CodeMirror div.CodeMirror-cursors {\n    visibility: hidden;\n  }\n}\n\n/* See issue #2901 */\n.cm-tab-wrap-hack:after { content: ''; }\n\n/* Help users use markselection to safely style text background */\nspan.CodeMirror-selectedtext { background: none; }\n","div.output_wrapper {\n    /* this position must be relative to enable descendents to be absolute within it */\n    position: relative;\n    .vbox();\n    // avoid scrolled output overlaying input in some strange circumstances\n    z-index: 1;\n}\n\n/* class for the output area when it should be height-limited */\ndiv.output_scroll {\n    /* ideally, this would be max-height, but FF barfs all over that */\n    height: 24em;\n    /* FF needs this *and the wrapper* to specify full width, or it will shrinkwrap */\n    width: 100%;\n\n    overflow: auto;\n    .corner-all;\n    .box-shadow(inset 0 2px 8px rgba(0, 0, 0, .8));\n    display: block;\n}\n\n/* output div while it is collapsed */\ndiv.output_collapsed {\n    margin: 0px;\n    padding: 0px;\n    .vbox();\n}\n\ndiv.out_prompt_overlay {\n    height: 100%;\n    padding: 0px @code_padding;\n    position: absolute;\n    .corner-all;\n}\n\ndiv.out_prompt_overlay:hover {\n    /* use inner shadow to get border that is computed the same on WebKit/FF */\n    .box-shadow(inset 0 0 1px #000);\n    background: rgba(240, 240, 240, 0.5);\n}\n\ndiv.output_prompt {\n    color: @output_prompt_color;\n}\n\n/* This class is the outer container of all output sections. */\ndiv.output_area {\n    padding: 0px;\n    page-break-inside: avoid;\n    .hbox();\n\n    .MathJax_Display {\n        // Inside a CodeCell, elements are left justified\n        text-align: center !important;\n    }\n\n    .rendered_html {\n        // Inside a CodeCell, elements are left justified\n        table {\n            margin-left: 0;\n            margin-right: 0;\n        }\n    \n        img {\n            margin-left: 0;\n            margin-right: 0;\n        }\n    }\n    \n    img, svg {\n        max-width: 100%;\n        height: auto;\n        &.unconfined {\n            max-width: none;\n        }\n    }\n\n    .mglyph>img {\n        max-width: none;\n    }\n\n    /* Basthon: better rendering for animation controls in FuncAnimation.to_jshtml */\n    .output_subarea {\n        .animation {\n            .anim-controls {\n                .anim-buttons {\n                    button {\n                        padding: 5px 10px;\n                        width: unset;\n                    }\n                }\n            }\n        }\n    }\n}\n\n/* This is needed to protect the pre formating from global settings such\n   as that of bootstrap */\n.output {\n    .vbox();\n}\n\n@media (max-width: @screen-xs-min) {\n    // move prompts above output on small screens\n    div.output_area {\n        .vbox();\n    }\n}\n\ndiv.output_area pre {\n    margin: 0;\n    padding: 1px 0 1px 0;\n    border: 0;\n    vertical-align: baseline;\n    color: @output_pre_color;\n    background-color: transparent;\n    .border-radius(0);\n}\n\n/* This class is for the output subarea inside the output_area and after\n   the prompt div. */\ndiv.output_subarea {\n    // Don't let contents overflow page area.\n    overflow-x: auto;\n    padding: @code_padding;\n    .box-flex1();\n    // appears to be needed for max-width in children to mean anything on Firefox:\n    max-width: calc(~\"100% - 14ex\");\n}\n\ndiv.output_scroll div.output_subarea {\n    // if the output area is scrolling, we don't need scrollbars on the subarea\n    overflow-x: visible;\n}\n\n/* The rest of the output_* classes are for special styling of the different\n   output types */\n\n/* all text output has this class: */\ndiv.output_text {\n    text-align: left;\n    color: @text-color;\n    /* This has to match that of the the CodeMirror class line-height below */  \n    line-height: @code_line_height;\n}\n\n/* stdout/stderr are 'text' as well as 'stream', but execute_result/error are *not* streams */\ndiv.output_stream {\n}\n\ndiv.output_stdout {\n}\n\ndiv.output_stderr {\n    background: var(--output-stderr-bg-color); /* very light red background for stderr */\n}\n\ndiv.output_latex {\n    text-align: left;\n}\n\ndiv.output_html {\n}\n\ndiv.output_png {\n}\n\ndiv.output_jpeg {\n}\n\n/* Empty output_javascript divs should have no height */\ndiv.output_javascript:empty {\n    padding: 0;\n}\n\n.js-error {\n    color: darkred;\n}\n\n/* raw_input styles */\n\ndiv.raw_input_container {\n    line-height: @code_line_height;\n    // for some reason, em padding doesn't compute the same for raw_input\n    // that is not the first input, but px does\n    padding-top: 5px;\n}\n\npre.raw_input_prompt {\n    /* nothing needed here. */\n}\n\ninput.raw_input {\n    font-family: @font-family-monospace;\n    font-size: inherit;\n    color: inherit;\n    width: auto;\n    /* make sure input baseline aligns with prompt */\n    vertical-align: baseline;\n    /* padding + margin = 0.5em between prompt and cursor */\n    padding: 0em 0.25em;\n    margin: 0em 0.25em;\n}\n\ninput.raw_input:focus {\n    box-shadow: none;\n}\n\np.p-space {\n    margin-bottom: 10px;\n}\n\ndiv.output_unrecognized {\n  padding: 5px;\n  font-weight: bold;\n  color: red;\n  // remove decoration from link\n  a {\n      color: inherit;\n      text-decoration: none;\n\n      &:hover {\n          color: inherit;\n          text-decoration: none;\n      }\n  }\n}\n",".rendered_html {\n\n    color: @text-color;\n    em {font-style: italic;}\n    strong {font-weight: bold;}\n    u {text-decoration: underline;}\n    :link {text-decoration: underline;}\n    :visited {text-decoration: underline;}\n\n    // For a 14px base font size this goes as:\n    // font-size = 26, 22, 18, 14, 12, 12\n    // margin-top = 14, 14, 14, 14, 8, 8\n    h1 {font-size: 185.7%; margin: 1.08em 0 0 0; font-weight: bold; line-height: 1.0;}\n    h2 {font-size: 157.1%; margin: 1.27em 0 0 0; font-weight: bold; line-height: 1.0;}\n    h3 {font-size: 128.6%; margin: 1.55em 0 0 0; font-weight: bold; line-height: 1.0;}\n    h4 {font-size: 100%; margin: 2em 0 0 0; font-weight: bold; line-height: 1.0;}\n    h5 {font-size: 100%; margin: 2em 0 0 0; font-weight: bold; line-height: 1.0; font-style: italic;}\n    h6 {font-size: 100%; margin: 2em 0 0 0; font-weight: bold; line-height: 1.0; font-style: italic;}\n\n    // Reduce the top margins by 14px compared to above\n    h1:first-child {margin-top: 0.538em;}\n    h2:first-child {margin-top: 0.636em;}\n    h3:first-child {margin-top: 0.777em;}\n    h4:first-child {margin-top: 1em;}\n    h5:first-child {margin-top: 1em;}\n    h6:first-child {margin-top: 1em;}\n\n    ul:not(.list-inline),\n    ol:not(.list-inline) {padding-left: 2em;}\n    ul {list-style:disc;}\n    ul ul {\n      list-style:square;\n      margin-top: 0;\n    }\n    ul ul ul {list-style:circle;}\n    ol {list-style:decimal;}\n    ol ol {\n      list-style:upper-alpha; \n      margin-top: 0;\n    }\n    ol ol ol {list-style:lower-alpha; }\n    ol ol ol ol {list-style:lower-roman; }\n    /* any extras will just be numbers: */\n    ol ol ol ol ol {list-style:decimal;}\n    * + ul {margin-top: 1em;}\n    * + ol {margin-top: 1em;}\n\n    hr {\n        color: @rendered_html_border_color;\n        background-color: @rendered_html_border_color;\n    }\n\n    pre {\n        margin: 1em 2em;\n        padding: 0px;\n        background-color: @body-bg;\n    }\n\n    code {\n        background-color: #eff0f1;\n    }\n\n    p code {\n        padding: 1px 5px;\n    }\n\n    pre code {background-color: @body-bg;}\n\n    pre, code {\n        border: 0;\n        color: @text-color;\n        font-size: 100%;\n    }\n\n    blockquote {margin: 1em 2em;}\n\n    table {\n        margin-left: auto;\n        margin-right: auto;\n        border: none;\n        border-collapse: collapse;\n        border-spacing: 0;\n        color: @rendered_html_border_color;\n        font-size: 12px;\n        table-layout: fixed;\n    }\n    thead {\n        border-bottom: 1px solid @rendered_html_border_color;\n        vertical-align: bottom;\n    }\n    tr, th, td {\n        text-align: right;\n        vertical-align: middle;\n        padding: 0.5em 0.5em;\n        line-height: normal;\n        white-space: normal;\n        max-width: none;\n        border: none;\n    }\n    td[align=\"left\"] {\n        text-align: left;\n    }\n    td[align=\"center\"] {\n        text-align: center;\n    }\n    td[align=\"right\"] {\n        text-align: right;\n    }\n    th {\n        font-weight: bold;\n    }\n    tbody tr:nth-child(odd) {\n        background: #f5f5f5;\n    }\n    tbody tr:hover {\n        background: rgba(66, 165, 245, 0.2);\n    }\n    * + table {margin-top: 1em;}\n\n    p {text-align: left;}\n    * + p {margin-top: 1em;}\n\n    img {\n        display: block;\n        margin-left: auto;\n        margin-right: auto;\n    }\n    * + img {margin-top: 1em;}\n    \n    img, svg {\n        max-width: 100%;\n        height: auto;\n        &.unconfined {\n            max-width: none;\n        }\n    }\n\n    // Override bootstrap settings, see #1390\n    .alert {margin-bottom: initial;}\n    * + .alert {margin-top: 1em;}\n}\n\n[dir=\"rtl\"] .rendered_html {\n    p {\n        text-align : right;\n    }\n}\n\n","div.text_cell {\n    .hbox();\n}\n@media (max-width: @screen-xs-min) {\n    // remove prompt indentation on small screens\n    div.text_cell > div.prompt {\n        display: none;\n    }\n}\n\ndiv.text_cell_render {\n    /*font-family: \"Helvetica Neue\", Arial, Helvetica, Geneva, sans-serif;*/\n    outline: none;\n    resize: none;\n    width:  inherit;\n    border-style: none;\n    padding: 0.5em 0.5em 0.5em @code_padding;\n    color: @text-color;\n    .border-box-sizing();\n}\n\na.anchor-link:link {\n  text-decoration: none;\n  padding: 0px 20px;\n  visibility: hidden;\n}\n\nh1,h2,h3,h4,h5,h6 {\n    &:hover .anchor-link {\n        visibility: visible;\n    }\n}\n\n.text_cell.rendered .input_area {\n    display: none;\n}\n\n.text_cell.rendered .rendered_html {\n    overflow-x: auto;\n    \n    // Content in the y direction should cause the rendered content to grow,\n    // the overflow-x: auto causes chrome to assume the same of y, so we need\n    // to tell it explicitly otherwise.\n    overflow-y: hidden;\n}\n\n.text_cell.rendered .rendered_html {\n\ttr, th, td {\n\t\tmax-width: none;\n\t}\n}\n\n.text_cell.unrendered .text_cell_render {\n    display:none;\n}\n\n.text_cell .dropzone .input_area {\n  border: 2px dashed #bababa;\n  margin: -1px;\n}\n\n.cm-header-1,\n.cm-header-2,\n.cm-header-3,\n.cm-header-4,\n.cm-header-5,\n.cm-header-6 {\n    font-weight: bold;\n    font-family: @font-family-sans-serif;\n}\n\n.cm-header-1 { font-size: 185.7%; }\n.cm-header-2 { font-size: 157.1%; }\n.cm-header-3 { font-size: 128.6%; }\n.cm-header-4 { font-size: 110%; }\n.cm-header-5 {\n    font-size: 100%;\n    font-style: italic;\n}\n.cm-header-6 {\n    font-size: 100%;\n    font-style: italic;\n}\n","@media (max-width: @screen-xs-max) {\n  // remove bootstrap-responsive's body padding on small screens\n  .notebook_app {\n    padding-left: 0px;\n    padding-right: 0px;\n  }\n}\n\n#ipython-main-app {\n  .border-box-sizing();\n  height: 100%;\n}\n\ndiv#notebook_panel {\n  margin: 0px;\n  padding: 0px;\n  .border-box-sizing();\n  height: 100%;\n}\n\ndiv#notebook {\n  font-size: @notebook_font_size;\n  line-height: @notebook_line_height;\n  overflow-y: hidden;\n  overflow-x: auto;\n  width: 100%;\n  /* This spaces the page away from the edge of the notebook area */\n  padding-top: @page-header-padding;\n  padding-bottom: @page-header-padding;\n  margin: 0px;\n  outline: none;\n  .border-box-sizing();\n  min-height: 100%;\n}\n\n#notebook-container {\n  @media not print {\n    padding: @page-padding;\n    background-color: @page-color;\n    min-height: @page-min-height;\n    .box-shadow(@global-shadow);\n  }\n  @media print {\n    width: 100%;\n  }\n}\n\ndiv.ui-widget-content {\n  border: 1px solid @border_color;\n  outline: none;\n}\n\npre.dialog {\n  background-color: @cell_background;\n  border: 1px solid #ddd;\n  .corner-all;\n  padding: 0.4em;\n  padding-left: 2em;\n}\n\np.dialog {\n  padding: 0.2em;\n}\n\n/* Word-wrap output correctly.  This is the CSS3 spelling, though Firefox seems\n   to not honor it correctly.  Webkit browsers (Chrome, rekonq, Safari) do.\n */\npre,\ncode,\nkbd,\nsamp {\n  white-space: pre-wrap;\n}\n\n#fonttest {\n  font-family: @font-family-monospace;\n}\n\np {\n  margin-bottom: 0;\n}\n\n.end_space {\n  min-height: 100px;\n  // [Basthon] temporarily disabling this since it seems\n  // to disturb the rendering by hidding notebook parts\n  // when scrolling...\n  // transition: height 0.2s ease;\n}\n\n.notebook_app > #header {\n  .box-shadow(@global-shadow);\n}\n\n.notebook_app {\n  @media not print {\n    background-color: @page-backdrop-color;\n  }\n}\n\nkbd {\n  border-style: solid;\n  border-width: 1px;\n  box-shadow: none;\n  margin: 2px;\n  padding-left: 2px;\n  padding-right: 2px;\n  padding-top: 1px;\n  padding-bottom: 1px;\n}\n\n.jupyter-keybindings {\n  padding: 1px;\n  line-height: 24px;\n  border-bottom: 1px solid gray;\n}\n\n.jupyter-keybindings input {\n  margin: 0;\n  padding: 0;\n  border: none;\n}\n\n.jupyter-keybindings i {\n  padding: 6px;\n}\n\n.well code {\n  background-color: hsl(\n    var(--body-bg-hue),\n    var(--body-bg-saturation),\n    calc(var(--body-bg-light) + 1.8%)\n  );\n  border-color: @border_color;\n  border-width: @border_width;\n  border-style: solid;\n  padding: 2px;\n  padding-top: 1px;\n  padding-bottom: 1px;\n}\n","/* CSS for the cell toolbar */\n@celltoolbar-height: 29px;\n\n.celltoolbar {\n    border: thin solid var(--btn-default-border-color);\n    border-bottom: none;\n    background : var(--page-backdrop-color);\n    border-radius : @border-radius-base @border-radius-base 0px 0px;\n    width:100%;\n    -webkit-box-pack: end;\n    height: @celltoolbar-height;\n    padding-right: 4px;\n    .hbox();\n    .end();\n    // safari fix, we cannot use -webkit-flex on hbox\n    // and vbox either or all css get borked\n    // cf https://github.com/jupyter/nbgrader/issues/394\n    display: -webkit-flex;\n    @media print{\n        display: none;\n    }\n}\n\n\n.ctb_hideshow {\n    display:none;\n    vertical-align:bottom;\n}\n\n/* ctb_show is added to the ctb_hideshow div to show the cell toolbar.\n   Cell toolbars are only shown when the ctb_global_show class is also set.\n*/\n.ctb_global_show .ctb_show.ctb_hideshow {\n    display: block;\n}\n\n.ctb_global_show .ctb_show + .input_area,\n.ctb_global_show .ctb_show + div.text_cell_input,\n.ctb_global_show .ctb_show ~ div.text_cell_render {\n    border-top-right-radius: 0px;\n    border-top-left-radius: 0px;\n}\n\n.ctb_global_show .ctb_show ~ div.text_cell_render {\n    // add border to rendered markdown cells\n    border: @border_width solid @light_border_color;\n}\n\n.celltoolbar {\n    font-size: 87%;\n    padding-top: 3px;\n}\n\n.celltoolbar select {\n    .form-control();\n    .input-sm();\n    // undo some of the sizing caused by the above mixins\n    width: inherit;\n    font-size: inherit;\n    height: 22px;\n    padding: 0px;\n    \n    display: inline-block;\n\n}\n\n.celltoolbar label {\n    margin-left: 5px;\n    margin-right: 5px;\n}\n","\n\n.tags_button_container {\n    width: 100%;\n    display: flex;\n}\n\n.tag-container {\n    display: flex;\n    flex-direction: row;\n    flex-grow: 1;\n    overflow: hidden;\n    position: relative;\n}\n\n.tag-container > * {\n    margin: 0 4px;\n}\n\n.remove-tag-btn {\n    margin-left: 4px;\n}\n\n.tags-input {\n    display: flex;\n}\n\n.cell-tag:last-child:after {\n    content: \"\";\n    position: absolute;\n    right: 0;\n    width: 40px;\n    height: 100%;\n    /* Fade to background color of cell toolbar */\n    background: linear-gradient(to right, rgba(0,0,0,0), #EEE);\n}\n\n.tags-input > * {\n    margin-left: 4px;\n}\n\n.cell-tag,\n.tags-input input,\n.tags-input button {\n    .form-control();\n    .input-sm();\n    // undo some of the sizing caused by the above mixins\n    box-shadow: none;\n    width: inherit;\n    font-size: inherit;\n    height: 22px;\n    line-height: 22px;\n    padding: 0px 4px;\n\n    display: inline-block;\n}\n\n.cell-tag,\n.tags-input button {\n    padding: 0px 4px;\n}\n\n.cell-tag {\n    background-color: #fff;\n    white-space: nowrap;\n}\n\n.tags-input input[type=text]:focus {\n    outline: none;\n    box-shadow: none;\n    border-color: #ccc;\n}\n",".completions {\n    position: absolute;\n    z-index: 110;\n    overflow: hidden;\n    border: 1px solid @border_color;\n    .corner-all;\n    .box-shadow(0px 6px 10px -1px #adadad);\n    line-height: 1;\n}\n\n.completions select {\n    background: white;\n    outline: none;\n    border: none;\n    padding: 0px;\n    margin: 0px;\n    overflow: auto;\n    font-family: @font-family-monospace;\n    font-size: 110%;\n    color: @text-color;\n    width: auto;\n}\n\n.completions select option.context {\n    color: darken(@brand-primary, 10%);\n}\n","#kernel_logo_widget {\n    .current_kernel_logo {\n        display: none;\n        .navbar-vertical-align(32px);\n        width: 32px;\n        height: 32px;\n    }\n}\n\n[dir=\"rtl\"] #kernel_logo_widget {\n    .pull-left();\n}\n",".modal .modal-body {\n  \n  .rename-message {\n    \n  }\n  .move-path {\n    display: flex;\n    flex-direction: row;\n    justify-content: space;\n    align-items: center;\n    \n    .server-root {\n      padding-right: 20px;\n    }\n    .path-input {\n      flex: 1;\n    }\n  }\n}\n","#menubar {\n  .border-box-sizing();\n  margin-top: 1px;\n\n  .navbar {\n    border-top: 1px;\n    border-radius: 0px 0px @border-radius-base @border-radius-base;\n    margin-bottom: 0px;\n  }\n  \n  .navbar-toggle {\n    float: left;\n    padding-top:7px;\n    padding-bottom:7px;\n    border:none;\n  }\n  .navbar-collapse {\n    clear: left;\n  }\n  \n}\n\n[dir=\"rtl\"] #menubar {\n    .navbar-toggle {\n        float: right;\n  }\n}\n\n[dir=\"rtl\"] #menubar {\n    .navbar-collapse {\n        clear: right;\n   }\n    .navbar-nav {\n        float : right;\n    }\n    .nav {\n        padding-right : 0px;\n    }\n     .navbar-nav > li {\n        float: right;\n    }\n    .navbar-right {\n        float : left !important;\n    }\n}\n\n[dir=\"rtl\"] ul.dropdown-menu {\n    text-align: right;\n    left : auto;\n}\n\n[dir=\"rtl\"] ul#new-menu.dropdown-menu {\n    right : auto;\n    left: 0;\n}\n.nav-wrapper {\n  border-bottom: 1px solid @navbar-default-border;\n}\n\ni.menu-icon {\n  // add padding to account for float-right\n  padding-top: 4px;\n}\n\n[dir=\"rtl\"] i.menu-icon.pull-right {\n    .pull-left();\n}\n\nul#help_menu li a{\n    overflow: hidden;\n    padding-right: 2.2em;\n    i {\n        margin-right: -1.2em;\n    }\n}\n\n[dir=\"rtl\"] ul#help_menu li a{\n    padding-left : 2.2em;\n    i {\n        margin-right: 0;\n        margin-left : -1.2em;\n    }\n    \n    i.pull-right {\n        .pull-left();\n    }\n}\n\n// Make sub menus work in BS3.\n// Credit: http://www.bootply.com/86684\n.dropdown-submenu {\n    position: relative;\n}\n\n.dropdown-submenu>.dropdown-menu {\n    top: 0;\n    left: 100%;\n    margin-top: -6px;\n    margin-left: -1px;\n}\n\n[dir=\"rtl\"] .dropdown-submenu>.dropdown-menu {\n    right:100%;\n    margin-right: -1px; \n}\n\n// arrow that indicate presence of submenu\n.dropdown-submenu:hover>.dropdown-menu {\n    display: block;\n}\n\n.dropdown-submenu>a:after {\n    .fa();\n    display: block;\n    content: @fa-var-caret-right;\n    float: right;\n    color: @dropdown-link-color;\n    margin-top: 2px;\n    margin-right: -10px;\n}\n\n[dir=\"rtl\"] .dropdown-submenu>a:after {\n    float: left;\n    content: @fa-var-caret-left;\n    margin-right : 0;\n    margin-left : -10px;\n}\n\n.dropdown-submenu:hover>a:after {\n    color: @dropdown-link-hover-color;\n}\n\n.dropdown-submenu.pull-left {\n    float: none;\n}\n\n.dropdown-submenu.pull-left>.dropdown-menu {\n    left: -100%;\n    margin-left: 10px;\n}\n\n//end submenu\n","#notification_area {\n    .pull-right();\n    z-index: 10;\n}\n\n[dir=\"rtl\"] #notification_area {\n    .pull-left();\n}\n\n.indicator_area {\n    .pull-right();\n    color: var(--navbar-default-link-color);\n    margin-left: 5px;\n    margin-right: 5px;\n    width: 11px;\n    z-index: 10;\n    text-align: center;\n    width: auto;\n}\n\n[dir=\"rtl\"] .indicator_area {\n    .pull-left();\n}\n\n#kernel_indicator {\n    .indicator_area();\n    \n    border-left: 1px solid;\n    \n    .kernel_indicator_name {\n        padding-left: 5px;\n        padding-right: 5px;\n    }\n}\n\n[dir=\"rtl\"] #kernel_indicator {\n    .pull-left();\n    border-left: 0;\n    border-right : 1px solid;\n}\n\n#modal_indicator {\n    .pull-right();\n    .indicator_area();\n}\n\n[dir=\"rtl\"] #modal_indicator {\n    .pull-left();\n} \n\n#readonly-indicator {\n    .pull-right();\n    .indicator_area();\n\n    margin-top: 2px;\n    margin-bottom: 0px;\n    margin-left: 0px;\n    margin-right: 0px;\n\n    // Start out hidden.\n    display: none;\n}\n\n.modal_indicator:before {\n    .fa-fw();\n}\n\n.edit_mode .modal_indicator:before {\n    .icon(@fa-var-pencil);\n}\n\n.command_mode .modal_indicator:before {\n    .icon(' ');\n}\n\n.kernel_idle_icon:before {\n    .icon(@fa-var-circle-o);\n}\n\n.kernel_busy_icon:before {\n    .icon(@fa-var-circle);\n}\n\n.kernel_dead_icon:before {\n    .icon(@fa-var-bomb);\n}\n\n.kernel_disconnected_icon:before {\n    .icon(@fa-var-chain-broken);\n}\n\n\n",".notification_widget {\n    color: @navbar-default-link-color;\n    z-index: 10;\n    background: @notification_widget_bg;\n    margin-right: 4px;\n    .btn-default();\n}\n\n.notification_widget.warning {\n    .btn-warning();\n}\n.notification_widget.success {\n    .btn-success();\n}\n.notification_widget.info {\n    .btn-info();\n}\n.notification_widget.danger {\n    .btn-danger();\n}\n\n","//This is file created for overwriting some of bootstrap element color in order to satisfiy the color contrast greater than 4.5:1.\n\n.btn-danger{\n    color: #ffffff;\n    background-color: #df0404;\n    border-color: #df0404;\n}\n\n.btn-warning{\n    color: #ffffff;\n    background-color:#b46102;\n    border-color: #b46102;\n}\n\n@link-color: #296eaa;\n\n.close {\n    float: right;\n    font-size: (@font-size-base * 1.5);\n    font-weight: @close-font-weight;\n    line-height: 1;\n    color: @close-color;\n    text-shadow: @close-text-shadow;\n    .opacity(.6);\n  \n    &:hover,\n    &:focus {\n      color: @close-color;\n      text-decoration: none;\n      cursor: pointer;\n      .opacity(1.0);\n}  button& {\n    padding: 0;\n    cursor: pointer;\n    background: transparent;\n    border: 0;\n    -webkit-appearance: none;\n    appearance: none;\n  }\n}\n\n.navbar-nav {\n    > li > a {\n      color: @navbar-default-link-color;\n      // To make keyboard focus clearly visible on the Controls(File,Edit,View,Insert,Cell...etc)present on the menubar.\n      //&:hover, //To use browser's hover default value \n      &:focus {\n      /* -webkit-focus-ring-color = '#5B9DD9' */\n      outline: -webkit-focus-ring-color auto 5px;\n     // color: @navbar-default-link-hover-color;\n     // background-color: @navbar-default-link-hover-bg;\n      }\n    }\n    }\n","div#pager {\n    background-color:   @body-bg;\n    font-size: @notebook_font_size;\n    line-height: @notebook_line_height;\n    overflow: hidden;\n    display: none;\n    position: fixed;\n    bottom: 0px;\n    width: 100%;\n    max-height: 50%;\n    padding-top: 8px;\n\n    .box-shadow(@global-shadow);\n\n    /* Display over codemirror */\n    z-index: 100;\n\n    /* Hack which prevents jquery ui resizable from changing top. */\n    top: auto !important;\n\n    pre {\n        line-height: @code_line_height;\n        color: @text-color;\n        background-color: @cell_background;\n        padding: @code_padding;\n    }\n\n    #pager-button-area {\n        position: absolute;\n        top: 8px;\n        right: 20px; \n    }\n\n    #pager-button-area .ui-button{\n        padding-top:0px;\n        padding-bottom:0px;\n        padding-right:10px;\n        padding-left:10px;\n    }\n\n    #pager-contents {\n        position: relative;\n        overflow: auto;\n        width: 100%;\n        height: 100%;\n\n        #pager-container {\n            position: relative;\n            padding: 15px 0px;\n            .border-box-sizing();\n        }\n    }\n\n    .ui-resizable-handle {\n        top: 0px;\n        height: 8px;\n        background: @cell_background;\n        border-top: 1px solid @light_border_color;\n        border-bottom: 1px solid @light_border_color;\n\n        /* This injects handle bars (a short, wide = symbol) for \n        the resize handle. */\n        &::after {\n            content: '';\n            \n            top: 2px;\n            left: 50%;\n            height: 3px;\n            width: 30px;\n            margin-left: -15px;\n            position: absolute;\n\n            border-top: 1px solid @light_border_color;\n        }\n    }\n}\n",".quickhelp {\n    .hbox();\n    line-height: 1.8em;\n}\n.shortcut_key {\n    display: inline-block;\n    width: 21ex;\n    text-align: right;\n    font-family: @font-family-monospace;\n}\n\n.shortcut_descr {\n    display: inline-block;\n    .box-flex1();\n}\n","span.save_widget {\n    height: 30px;\n    margin-top: 4px;\n    display: flex;\n    justify-content: center;\n    align-items: baseline;\n    width: 50%;\n    flex: 1;\n    max-width: 50%;\n    \n    span.filename {\n        height: 100%;\n        line-height: 1em;\n        margin-left: @padding-large-horizontal;\n        border: none;\n        font-size: 146.5%;\n        text-overflow: ellipsis;\n        overflow: hidden;\n        white-space: nowrap;\n        &:hover{\n            // ensure body is lighter on dark palette, \n            // and vice versa\n            background-color: var(--edit-hover-color);\n        }\n        .corner-all;\n    }\n}\n\n[dir=\"rtl\"] span.save_widget.pull-left {\n    .pull-right();\n}\n\n[dir=\"rtl\"] span.save_widget {\n    span.filename {\n        margin-left : 0;\n        margin-right : @padding-large-horizontal;\n    }\n}\n\nspan.checkpoint_status, span.autosave_status {\n    font-size: small;\n    white-space: nowrap;\n    padding: 0 5px;\n}\n\n@media (max-width: @screen-xs-max) {\n    span.save_widget {\n        font-size: small;\n        padding: 0 0 0 5px;\n    }\n    span.checkpoint_status, span.autosave_status {\n        display: none;\n    }\n}\n\n@media (min-width: @screen-sm-min) and (max-width: @screen-sm-max) {\n    span.checkpoint_status {\n        display: none;\n    }\n    span.autosave_status {\n        font-size: x-small;\n    }\n}\n","@btn_small_height: 24px;\n\n.toolbar {\n    padding: 0px;\n    margin-left: -5px;\n    margin-top: 2px;\n    margin-bottom: 5px;\n\n    select, label {\n        width: auto;\n        vertical-align:middle;\n        margin-right:2px;\n        margin-bottom:0px;\n        display: inline;\n        font-size: 92%;\n        margin-left:0.3em;\n        margin-right:0.3em;\n        padding: 0px;\n        padding-top: 3px;\n    }\n    .btn {\n        padding: 2px 8px;\n    }\n\n    .border-box-sizing();\n}\n\n.toolbar .btn-group {\n  margin-top: 0px;\n  margin-left: 5px;\n}\n\n.toolbar-btn-label {\n  margin-left: 6px;\n}\n\n#maintoolbar {\n  margin-bottom: -3px;\n  margin-top: -8px;\n  border: 0px;\n  min-height: 27px;\n  margin-left: 0px;\n  padding-top: 11px;\n  padding-bottom: 3px;\n\n  .navbar-text {\n    float: none;\n    vertical-align: middle;\n    text-align: right;\n    margin-left: 5px;\n    margin-right: 0px;\n    margin-top: 0px;\n  }\n}\n\n.select-xs {\n  height: @btn_small_height;\n}\n\n[dir=\"rtl\"] .btn-group > .btn, .btn-group-vertical > .btn {\n    float: right;\n}\n\n// highlight the new menu where celltoolbar is\n.pulse, .dropdown-menu > li > a.pulse,  li.pulse > a.dropdown-toggle, li.pulse.open > a.dropdown-toggle {\n    background-color: #F37626;\n    color: white;\n}\n","/**\n * Primary styles\n *\n * Author: Jupyter Development Team\n */\n\n/** WARNING IF YOU ARE EDITTING THIS FILE, if this is a .css file, It has a lot\n * of chance of beeing generated from the ../less/[samename].less file, you can\n * try to get back the less file by reverting somme commit in history\n **/\n\n/*\n * We'll try to get something pretty, so we\n * have some strange css to have the scroll bar on\n * the left with fix button on the top right of the tooltip\n */\n\n// double slash comment are remove by less compilation\n// **\n// * Less mixins\n// **/\n\n// Four color of the background\n@import \"variables\";\n\n.dropshadow() {\n  -moz-box-shadow: 0px 6px 10px -1px #adadad;\n  -webkit-box-shadow: 0px 6px 10px -1px #adadad;\n  box-shadow: 0px 6px 10px -1px #adadad;\n}\n\n// smoth height adaptation\n.smoothheight(@t:500ms) {\n  // [Basthon] temporarily disabling this since it seems\n  // to disturb the rendering by hidding notebook parts\n  // when scrolling...\n  // -webkit-transition-property: height;\n  // -webkit-transition-duration: @t;\n  // -moz-transition-property: height;\n  // -moz-transition-duration: @t;\n  // transition-property: height;\n  // transition-duration: @t;\n}\n\n@-moz-keyframes fadeOut {\n  from {\n    opacity: 1;\n  }\n  to {\n    opacity: 0;\n  }\n}\n\n@-webkit-keyframes fadeOut {\n  from {\n    opacity: 1;\n  }\n  to {\n    opacity: 0;\n  }\n}\n\n@-moz-keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n@-webkit-keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n/*properties of tooltip after \"expand\"*/\n.bigtooltip {\n  overflow: auto;\n  height: 200px;\n  .smoothheight();\n}\n\n/*properties of tooltip before \"expand\"*/\n.smalltooltip {\n  .smoothheight();\n  text-overflow: ellipsis;\n  overflow: hidden;\n  height: 85px;\n}\n\n.tooltipbuttons {\n  position: absolute;\n  padding-right: 15px;\n  top: 0px;\n  right: 0px;\n}\n\n.tooltipbuttons .ui-button {\n  padding-top: 0px;\n  padding-bottom: 0px;\n  padding-right: 10px;\n  padding-left: 10px;\n}\n\n.tooltiptext {\n  /*avoid the button to overlap on some docstring*/\n  padding-right: 30px;\n  /*avoid the ui-icon(s) from overlapping the tooltip*/\n  padding-top: 5px;\n}\n\n.ipython_tooltip {\n  max-width: 700px;\n  /*fade-in animation when inserted*/\n  -webkit-animation: fadeOut 400ms;\n  -moz-animation: fadeOut 400ms;\n  animation: fadeOut 400ms;\n  -webkit-animation: fadeIn 400ms;\n  -moz-animation: fadeIn 400ms;\n  animation: fadeIn 400ms;\n  vertical-align: middle;\n  background-color: @cell_background;\n\n  overflow: visible;\n  border: @border_color @border_width solid;\n  outline: none;\n  padding: 3px;\n  margin: 0px;\n  padding-left: 7px;\n  font-family: @font-family-monospace;\n  min-height: 50px;\n\n  .dropshadow;\n  .corner-all;\n\n  a {\n    float: right;\n  }\n  position: absolute;\n\n  z-index: 1000;\n\n  .tooltiptext {\n    pre {\n      border: 0;\n      .border-radius(0);\n      font-size: 100%;\n      background-color: @cell_background;\n    }\n  }\n}\n\n.pretooltiparrow {\n  left: 0px;\n  margin: 0px;\n  top: -16px;\n  width: 40px;\n  height: 16px;\n  overflow: hidden;\n  position: absolute;\n}\n\n.pretooltiparrow:before {\n  background-color: @cell_background;\n  border: @border_width @border_color solid;\n  z-index: 11;\n  content: \"\";\n  position: absolute;\n  left: 15px;\n  top: 10px;\n  width: 25px;\n  height: 25px;\n  @theta: 45deg;\n  -webkit-transform: rotate(@theta);\n  -moz-transform: rotate(@theta);\n  -ms-transform: rotate(@theta);\n  -o-transform: rotate(@theta);\n}\n","div.typeahead__container {\n  font: revert;\n}\n\nul.typeahead__list i {\n    width: 18px;\n}\n\nul.typeahead__list {\n  max-height: 80vh;\n  overflow:auto;\n\n    & > li > a {\n        /** Firefox bug **/\n        /* see https://github.com/jupyter/notebook/issues/559 */\n        white-space: normal;\n    }\n}\n\nul.typeahead__list & > li > a.pull-right {\n    .pull-left();\n}\n\n[dir=\"rtl\"] .typeahead__list {\n    text-align : right;\n}\n\n.cmd-palette {\n  & .modal-body{\n    padding: 7px;\n  }\n  \n  & form {\n    background: white;\n  }\n  \n  & input {\n    outline:none;\n  }\n}\n\n.no-shortcut{\n    min-width: 20px;\n    color: transparent;\n}\n\n[dir=\"rtl\"] .no-shortcut.pull-right{\n    .pull-left();\n}\n\n[dir=\"rtl\"] .command-shortcut.pull-right{\n    .pull-left();\n}\n\n.command-shortcut:before{\n    content:\"(command mode)\";\n    padding-right:3px;\n    color:@gray-light;\n}\n\n.edit-shortcut:before{\n    content:\"(edit)\";\n    padding-right:3px;\n    color:@gray-light;\n}\n\n[dir=\"rtl\"] .edit-shortcut.pull-right {\n    .pull-left();\n}\n","\n#find-and-replace {\n\n  #replace-preview .match, #replace-preview .insert {\n    background-color: #BBDEFB; // MD Blue 100\n    border-color: #90CAF9; // MD Blue 200\n    border-style: solid;\n    border-width: 1px;\n    border-radius: 0px;\n  }\n\n\n  [dir=\"ltr\"] & .input-group-btn + .form-control {\n    border-left: none;\n  }\n\n  [dir=\"rtl\"] & .input-group-btn + .form-control {\n     border-right: none;\n  }\n\n  #replace-preview .replace {\n    \n    & .match {\n     // text-decoration: line-through;\n      background-color: #FFCDD2; // MD Red 100\n      border-color: #EF9A9A; // MD Red 200\n      border-radius: 0px;\n      \n    }\n    \n    & .insert {\n      background-color: #C8E6C9; // MD Green 100\n      border-color: #A5D6A7; // MD Green 200\n      border-radius: 0px;\n      \n    }\n  }\n\n  #replace-preview {\n    max-height: 60vh;\n    overflow: auto;\n    pre {\n        padding: 5px 10px;\n    }\n  }\n}\n",".basthon-loader-root {\n  background-color: var(--header-bg);\n  box-shadow: 0px 0px 12px 1px rgba(87, 87, 87, 0.2);\n}\n\n.basthon-loader-spinner.basthon-loader-foot {\n  box-sizing: unset;\n}\n\n.basthon-loader-text.basthon-loader-foot {\n  font-size: 14px;\n  color: var(--text-color);\n}\n\n.basthon-dynamic-iframe {\n  max-width: 100%;\n  display: block;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
